(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[43],{

/***/ 70829:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...pageName]",
      function () {
        return __webpack_require__(12038);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _pageName_; }
});

// NAMESPACE OBJECT: ./src/store/shared-store/actions/publicPageActions.ts
var publicPageActions_namespaceObject = {};
__webpack_require__.r(publicPageActions_namespaceObject);
__webpack_require__.d(publicPageActions_namespaceObject, {
  "changeDataSet": function() { return changeDataSet; },
  "changeResponsiveTab": function() { return changeResponsiveTab; },
  "clearSelectFinder": function() { return clearSelectFinder; },
  "clearSelectedFinder": function() { return clearSelectedFinder; },
  "errorFetchDataSet": function() { return errorFetchDataSet; },
  "errorFetchLoadMoreDataSet": function() { return errorFetchLoadMoreDataSet; },
  "fetchingDataSet": function() { return fetchingDataSet; },
  "fetchingLoadMoreDataSet": function() { return fetchingLoadMoreDataSet; },
  "getDataSet": function() { return getDataSet; },
  "hubHandlerSelected": function() { return hubHandlerSelected; },
  "loadMoreDataSet": function() { return loadMoreDataSet; },
  "objectSelectionHover": function() { return objectSelectionHover; },
  "objectSelectorHover": function() { return objectSelectorHover; },
  "receiveDataSet": function() { return receiveDataSet; },
  "receiveLoadMoreDataSet": function() { return receiveLoadMoreDataSet; },
  "responsiveTab": function() { return responsiveTab; },
  "selectFinder": function() { return selectFinder; },
  "selectFinderType": function() { return selectFinderType; },
  "selectedFinder": function() { return selectedFinder; },
  "selectedFinderType": function() { return selectedFinderType; },
  "selectedHubHandlerToEdit": function() { return selectedHubHandlerToEdit; },
  "viewPortSizeExperienceManager": function() { return viewPortSizeExperienceManager; },
  "viewPortSizeStateExperienceManager": function() { return viewPortSizeStateExperienceManager; },
  "warningStateEM": function() { return warningStateEM; },
  "warningSystemEM": function() { return warningSystemEM; },
  "writeDataSet": function() { return writeDataSet; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
;// CONCATENATED MODULE: ./src/areas/public-page/Metadata/InjectMetaData/InjectMetaData.tsx





var metaIcons = [
    {
        iconId: "android-icon-192x192",
        rel: "icon",
        size: "192x192"
    },
    {
        iconId: "apple-icon-57x57",
        rel: "apple-touch-icon",
        size: "57x57"
    },
    {
        iconId: "apple-icon-60x60",
        rel: "apple-touch-icon",
        size: "60x60"
    },
    {
        iconId: "apple-icon-72x72",
        rel: "apple-touch-icon",
        size: "72x72"
    },
    {
        iconId: "apple-icon-76x76",
        rel: "apple-touch-icon",
        size: "76x76"
    },
    {
        iconId: "apple-icon-114x114",
        rel: "apple-touch-icon",
        size: "114x114"
    },
    {
        iconId: "apple-icon-120x120",
        rel: "apple-touch-icon",
        size: "120x120"
    },
    {
        iconId: "apple-icon-144x144",
        rel: "apple-touch-icon",
        size: "144x144"
    },
    {
        iconId: "favicon-16x16",
        rel: "icon",
        size: "16x16"
    },
    {
        iconId: "favicon-32x32",
        rel: "icon",
        size: "32x32"
    },
    {
        iconId: "favicon-96x96",
        rel: "icon",
        size: "96x96"
    },
    {
        iconId: "android-icon-192x192",
        rel: "icon",
        size: "192x192"
    },
    {
        iconId: "ms-icon-144x144",
        rel: "icon",
        size: "144x144"
    }, 
];
var InjectMetadata = function(param) {
    var site = param.site, fonts = param.fonts;
    var ref, ref1, ref2;
    var isAnalyticsUnlocked = (site === null || site === void 0 ? void 0 : (ref = site.cookieBar) === null || ref === void 0 ? void 0 : ref.analyticsConsent) === true ? false : true;
    var isHeadUnlocked = (site === null || site === void 0 ? void 0 : (ref1 = site.cookieBar) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.headConsent) === null || ref2 === void 0 ? void 0 : ref2.enable) === true ? false : true;
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState({
        analytics: isAnalyticsUnlocked,
        head: isHeadUnlocked
    }), 2), cookieState = ref3[0], setCookieState = ref3[1];
    var injectHead = site.injectHead, keywords = site.keywords, analyticsInjectHead = site.analyticsInjectHead, google_analytics = site.google_analytics, facebook_pixel = site.facebook_pixel, hotjar_id = site.hotjar_id, mixpanel_id = site.mixpanel_id;
    (0,react.useEffect)(function() {
        var handleCookieChange = function() {
            var analyticsCookie = "".concat("cookie-analytics-" + window.location.hostname);
            var headCookie = "".concat("cookie-head-" + window.location.hostname);
            var cookieString = document.cookie;
            var isAnalyticsAccepted = cookieString.includes(analyticsCookie);
            var isHeadAccepted = cookieString.includes(headCookie);
            if (isAnalyticsAccepted || isHeadAccepted) {
                setCookieState({
                    analytics: isAnalyticsAccepted,
                    head: isHeadAccepted
                });
            }
        };
        handleCookieChange() //initial load check
        ;
        //@ts-ignore
        if (typeof cookieStore !== "undefined") {
            //@ts-ignore
            cookieStore.addEventListener("change", function(param) {
                var changed = param.changed;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = changed[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _value = _step.value, name = _value.name, value = _value.value;
                        handleCookieChange();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
            return function() {
                //@ts-ignore
                cookieStore.removeEventListener("change", handleCookieChange);
            };
        }
    }, []);
    var title = site["og:title"];
    var description = site["og:description"];
    var image = site["og:image"];
    metaIcons.map(function(icon) {
        var iconId = icon.iconId;
        var key = Object.keys(site).find(function(k) {
            return k === iconId;
        });
        var item = key ? site[key] : undefined;
        icon.href = item;
    });
    var mergeScripts = function() {
        var mergedString = "";
        if (injectHead) {
            mergedString += injectHead + "\n";
        }
        return mergedString;
    };
    var mergeAnalytics = function() {
        var mergedString = "";
        if (analyticsInjectHead && cookieState.head) {
            mergedString += analyticsInjectHead + "\n";
        }
        if (google_analytics && cookieState.analytics) {
            mergedString += "<script async src='https://www.googletagmanager.com/gtag/js?id=".concat(google_analytics, "' />\n      <script defer>\n          window.dataLayer = window.dataLayer || [];\n\n          function gtag() {\n              dataLayer.push(arguments);\n          }\n\n          gtag('js', new Date());\n          gtag('config', ").concat(google_analytics, ");\n      </script>");
        }
        if (facebook_pixel) {
            mergedString += "<script defer>\n      !function (f, b, e, v, n, t, s) {\n          if (f.fbq)\n              return;\n          n = f.fbq = function () {\n              n.callMethod\n                  ? n\n                      .callMethod\n                      .apply(n, arguments)\n                  : n\n                      .queue\n                      .push(arguments)\n          };\n          if (!f._fbq)\n              f._fbq = n;\n          n.push = n;\n          n.loaded = !0;\n          n.version = '3.1';\n          n.queue = [];\n          t = b.createElement(e);\n          t.async = !0;\n          t.src = v;\n          s = b.getElementsByTagName(e)[0];\n          s\n              .parentNode\n              .insertBefore(t, s)\n      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');\n      fbq('init', '".concat(facebook_pixel, '\');\n      fbq(\'track\', \'PageView\');\n  </script>\n  <noscript><img height="1" width="1" style="display:none"\n          src="https://www.facebook.com/tr?id=').concat(facebook_pixel, '&ev=PageView&noscript=1" /></noscript>');
        }
        if (hotjar_id) {
            mergedString += "<script defer>\n      (function (h, o, t, j, a, r) {\n          h.hj = h.hj || function () {\n              (h.hj.q = h.hj.q || []).push(arguments)\n          };\n          h._hjSettings = {\n              hjid: ".concat(hotjar_id, ", hjsv: 6\n          };\n          a = o.getElementsByTagName('head')[0];\n          r = o.createElement('script'); r.async = 1;\n          r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;\n          a.appendChild(r);\n      })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');\n  </script>");
        }
        if (mixpanel_id) {
            mergedString += '<script type="text/javascript" defer>\n      (function (c, a) {\n          if (!a.__SV) {\n              var b = window;\n              try {\n                  var d,\n                      m,\n                      j,\n                      k = b.location,\n                      f = k.hash;\n                  d = function (a, b) {\n                      return (m = a.match(RegExp(b + "=([^&]*)")))\n                          ? m[1]\n                          : null\n                  };\n                  f && d(f, "state") && (j = JSON.parse(decodeURIComponent(d(f, "state"))), "mpeditor" === j.action && (b.sessionStorage.setItem("_mpcehash", f), history.replaceState(j.desiredHash || "", c.title, k.pathname + k.search)))\n              } catch (n) { }\n              var l,\n                  h;\n              window.mixpanel = a;\n              a._i = [];\n              a.init = function (b, d, g) {\n                  function c(b, i) {\n                      var a = i.split(".");\n                      2 == a.length && (b = b[a[0]], i = a[1]);\n                      b[i] = function () {\n                          b.push([i].concat(Array.prototype.slice.call(arguments, 0)))\n                      }\n                  }\n                  var e = a;\n                  "undefined" !== typeof g\n                      ? e = a[g] = []\n                      : g = "mixpanel";\n                  e.people = e.people || [];\n                  e.toString = function (b) {\n                      var a = "mixpanel";\n                      "mixpanel" !== g && (a += "." + g);\n                      b || (a += " (stub)");\n                      return a\n                  };\n                  e.people.toString = function () {\n                      return e.toString(1) + ".people (stub)"\n                  };\n                  l = "disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" ");\n                  for (h = 0; h < l.length; h++)\n                      c(e, l[h]);\n                  var f = "set set_once union unset remove delete".split(" ");\n                  e.get_group = function () {\n                      function a(c) {\n                          b[c] = function () {\n                              call2_args = arguments;\n                              call2 = [c].concat(Array.prototype.slice.call(call2_args, 0));\n                              e.push([d, call2])\n                          }\n                      }\n                      for (var b = {}, d = ["get_group"].concat(Array.prototype.slice.call(arguments, 0)), c = 0; c < f.length; c++)\n                          a(f[c]);\n                      return b\n                  };\n                  a\n                      ._i\n                      .push([b, d, g])\n              };\n              a.__SV = 1.2;\n              b = c.createElement("script");\n              b.type = "text/javascript";\n              b.async = !0;\n              b.src = "undefined" !== typeof MIXPANEL_CUSTOM_LIB_URL\n                  ? MIXPANEL_CUSTOM_LIB_URL\n                  : "file:" === c.location.protocol && "//cdn4.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^///)\n                      ? "https://cdn4.mxpnl.com/libs/mixpanel-2-latest.min.js"\n                      : "//cdn4.mxpnl.com/libs/mixpanel-2-latest.min.js";\n              d = c.getElementsByTagName("script")[0];\n              d\n                  .parentNode\n                  .insertBefore(b, d)\n          }\n      })(document, window.mixpanel || []);\n      mixpanel.init("<?= '.concat(mixpanel_id, ' ?>");\n  </script>');
        }
        return mergedString;
    };
    var mergedAll = function() {
        var mergedAllString = "";
        if (fonts) mergedAllString += fonts + "\n";
        mergedAllString += mergeAnalytics() + "\n" + mergeScripts();
        return mergedAllString;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "width=device-width,initial-scale=1,shrink-to-fit=no"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                httpEquiv: "X-UA-Compatible",
                content: "IE=edge,chrome=1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "generator",
                content: "Fluxio"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "author",
                content: "Fluxio"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title !== null && title !== void 0 ? title : "Fluxio powered website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description !== null && description !== void 0 ? description : "Created with Fluxio"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description !== null && description !== void 0 ? description : "Created with Fluxio"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "keywords",
                content: keywords !== null && keywords !== void 0 ? keywords : "fluxio, website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "keywords",
                content: keywords !== null && keywords !== void 0 ? keywords : "fluxio, website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: image
            }),
            metaIcons.map(function(icon) {
                return icon.href !== undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    href: icon.href,
                    rel: icon.rel,
                    sizes: icon.size
                }, icon.iconId) : null;
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "dns-prefetch",
                href: "https://apis.google.com"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "dns-prefetch",
                href: "https://www.gstatic.com"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "dns-prefetch",
                href: "https://accounts.google.com"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "dns-prefetch",
                href: "https://connect.facebook.net"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "dns-prefetch",
                href: "https://cdnjs.cloudflare.com"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "stylesheet",
                href: "https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.3.1/css/bootstrap.min.css",
                integrity: "sha256-YLGeXaapI0/5IgZopewRJcFXomhRMlYYjugPLSyNjTY=",
                crossOrigin: "anonymous"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "stylesheet",
                href: "https://cdnjs.cloudflare.com/ajax/libs/quill/1.3.6/quill.core.min.css",
                integrity: "sha256-w1xA5IxJPjR5nxXpZP0vneJCf62zDzyF6AlXlK7rYdk=",
                crossOrigin: "anonymous",
                media: "all"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "stylesheet",
                href: "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.1/css/all.min.css"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                async: true,
                id: "Typewriter",
                src: "https://unpkg.com/typewriter-effect@latest/dist/core.js",
                crossOrigin: "anonymous"
            }),
            (0,html_react_parser/* default */.ZP)(mergedAll())
        ]
    });
};
/* harmony default export */ var InjectMetaData = (InjectMetadata);

;// CONCATENATED MODULE: ./src/areas/public-page/Metadata/InjectMetaData/index.ts

/* harmony default export */ var Metadata_InjectMetaData = (InjectMetaData);

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(29430);
;// CONCATENATED MODULE: ./src/modules/shared-modules/utilities/browserHacks.ts
function handleSafariOldVersion(isOldVersion) {
    if (isOldVersion === "true") {
        return "safari-old-version";
    }
    return "";
}
/**
 * fixes images width/height: auto,
 * safari makes images overflowing they'r container.
 * forcing them to 100% seems to fix the problem
 */ function safariImageDimensions(objTemplate, classPrefix) {
    if (!objTemplate.width.enable && !objTemplate.height.enable) {
        /*
      Define here the CSS styles applied only to Safari browsers
      (any version and any device)
    */ return "\n      @media not all and (min-resolution:.001dpcm){ \n        @supports (-webkit-appearance:none) {\n          .".concat(classPrefix, "-bob-media .bob-image img,\n          .").concat(classPrefix, "-bob-media .bob-image{          \n            width: 100% !important;\n            height: 100% !important;\n          }\n        }\n      }\n    ");
    }
    return "";
}

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/stylesheets/modules/components/cookieBar.module.sass
var cookieBar_module = __webpack_require__(39295);
var cookieBar_module_default = /*#__PURE__*/__webpack_require__.n(cookieBar_module);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/cookieBanner/cookieBanner.tsx






var CookieBanner = function(param) {
    var cookieRules = param.cookieRules;
    var ref = (0,react.useState)(false), showBar = ref[0], setShowBar = ref[1];
    var ref1 = (0,react.useState)(false), showModal = ref1[0], setModal = ref1[1];
    var ref2 = (0,react.useState)(false), showPolicyModal = ref2[0], setPolicyModal = ref2[1];
    var ref3 = (0,react.useState)({
        analytics: false,
        cookieHead: false,
        cookieBody1: false,
        cookieBody2: false
    }), cookieOptions = ref3[0], setCookieOptions = ref3[1];
    var ref4 = (0,react.useState)({
        acceptString: "Accept Cookies",
        cookieMsg: "This website uses cookies to provide you with the best browsing experience. By accepting our cookies you are deemed to have read and accepted our Cookies Policy.",
        customizeString: "Customize",
        rejectString: "Reject All",
        cookiePolicyString: "View Cookie Policy",
        saveString: "Save",
        closeString: "Close"
    }), cookieStrings = ref4[0], setCookieStrings = ref4[1];
    (0,react.useEffect)(function() {
        var ref;
        var cookieToCheck = "".concat("cookie-bar-" + window.location.hostname);
        var cookieString = document.cookie;
        if ((cookieRules === null || cookieRules === void 0 ? void 0 : (ref = cookieRules.cookieBar) === null || ref === void 0 ? void 0 : ref.enable) && !cookieString.includes(cookieToCheck)) {
            setShowBar(true);
            var browserLanguage = navigator.language;
            if (browserLanguage === "pt-PT") {
                setCookieStrings({
                    acceptString: "Aceitar Cookies",
                    cookieMsg: "Este website utiliza Cookies para oferecer a melhor experi\xeancia. Ao aceitar as cookies considera-se que leu e aceitou a nossa Pol\xedtica de Cookies.",
                    customizeString: "Personalizar",
                    rejectString: "Rejeitar Tudo",
                    cookiePolicyString: "Ver Pol\xedtica de Cookies",
                    saveString: "Guardar",
                    closeString: "Fechar"
                });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var setCookie = function() {
        var expires = new Date();
        expires.setFullYear(expires.getFullYear() + 1);
        document.cookie = "".concat("cookie-bar-" + window.location.hostname, "=accepted; expires=").concat(expires);
        if (cookieOptions.analytics) {
            document.cookie = "".concat("cookie-analytics-" + window.location.hostname, "=accepted; expires=").concat(expires);
        }
        if (cookieOptions.cookieHead) {
            document.cookie = "".concat("cookie-head-" + window.location.hostname, "=accepted; expires=").concat(expires);
        }
        if (cookieOptions.cookieBody1) {
            document.cookie = "".concat("cookie-body1-" + window.location.hostname, "=accepted; expires=").concat(expires);
        }
        if (cookieOptions.cookieBody2) {
            document.cookie = "".concat("cookie-body2-" + window.location.hostname, "=accepted; expires=").concat(expires);
        }
        setShowBar(false);
        setModal(false);
    };
    var rejectCookie = function() {
        var expires = new Date();
        expires.setFullYear(expires.getFullYear() + 1);
        document.cookie = "".concat("cookie-bar-" + window.location.hostname, "=accepted; expires=").concat(expires);
        setShowBar(false);
        setModal(false);
    };
    var acceptAllCookie = function() {
        var expires = new Date();
        expires.setFullYear(expires.getFullYear() + 1);
        document.cookie = "".concat("cookie-bar-" + window.location.hostname, "=accepted; expires=").concat(expires);
        document.cookie = "".concat("cookie-analytics-" + window.location.hostname, "=accepted; expires=").concat(expires);
        document.cookie = "".concat("cookie-head-" + window.location.hostname, "=accepted; expires=").concat(expires);
        document.cookie = "".concat("cookie-body1-" + window.location.hostname, "=accepted; expires=").concat(expires);
        document.cookie = "".concat("cookie-body2-" + window.location.hostname, "=accepted; expires=").concat(expires);
        setShowBar(false);
        setModal(false);
    };
    var renderCookieOption = function(id, cookieTitle, cookieDescription) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (cookieBar_module_default())["cookie-option"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        value: cookieOptions["cookieHead"] === true ? "true" : "false",
                        onChange: function(e) {
                            return setCookieOptions((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cookieOptions), (0,src_define_property/* default */.Z)({}, id, e.target.checked)));
                        },
                        id: id,
                        className: (cookieBar_module_default())["cookie-checkbox"],
                        type: "checkbox"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        cookieTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: id,
                            className: (cookieBar_module_default())["cookie-title"],
                            children: cookieTitle
                        }),
                        cookieDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (cookieBar_module_default())["cookie-description"],
                            children: cookieDescription
                        })
                    ]
                })
            ]
        });
    };
    if (showBar) {
        var ref5, ref6, ref7, ref8;
        var ref9, ref10, ref11;
        var hasRules = (ref11 = (ref10 = (ref9 = cookieRules === null || cookieRules === void 0 ? void 0 : (ref5 = cookieRules.cookieBar) === null || ref5 === void 0 ? void 0 : ref5.body1Consent) !== null && ref9 !== void 0 ? ref9 : cookieRules === null || cookieRules === void 0 ? void 0 : (ref6 = cookieRules.cookieBar) === null || ref6 === void 0 ? void 0 : ref6.body2Consent) !== null && ref10 !== void 0 ? ref10 : cookieRules === null || cookieRules === void 0 ? void 0 : (ref7 = cookieRules.cookieBar) === null || ref7 === void 0 ? void 0 : ref7.headConsent) !== null && ref11 !== void 0 ? ref11 : cookieRules === null || cookieRules === void 0 ? void 0 : (ref8 = cookieRules.cookieBar) === null || ref8 === void 0 ? void 0 : ref8.analyticsConsent;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (cookieBar_module_default())["cookie-banner"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-4",
                    children: cookieStrings.cookieMsg
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (cookieBar_module_default())["cookie-actions"],
                    children: [
                        hasRules && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: function() {
                                        setShowBar(false);
                                        setModal(true);
                                    },
                                    className: "btn btn-fluxio btn-outline",
                                    children: cookieStrings.customizeString
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: rejectCookie,
                                    className: "btn btn-fluxio btn-outline",
                                    children: cookieStrings.rejectString
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: acceptAllCookie,
                            className: "btn btn-fluxio btn-primary",
                            children: cookieStrings.acceptString
                        })
                    ]
                })
            ]
        });
    }
    var renderCookiePolicy = function() {
        var ref, ref1, ref2, ref3;
        if ((ref = cookieRules.cookieBar) === null || ref === void 0 ? void 0 : (ref1 = ref.policy) === null || ref1 === void 0 ? void 0 : ref1.policyText) {
            //render Modal
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: function() {
                    return setPolicyModal(true);
                },
                className: "btn btn-fluxio btn-outline",
                children: cookieStrings.cookiePolicyString
            });
        }
        if ((ref2 = cookieRules.cookieBar) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.policy) === null || ref3 === void 0 ? void 0 : ref3.policyLink) {
            //render Link
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: cookieRules.cookieBar.policy.policyLink,
                target: "_blank",
                rel: "noreferrer",
                className: "btn btn-fluxio btn-outline",
                children: cookieStrings.cookiePolicyString
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    };
    var renderPolicyMsg = function() {
        var ref, ref1;
        var policyMsg = (ref = cookieRules.cookieBar) === null || ref === void 0 ? void 0 : (ref1 = ref.policy) === null || ref1 === void 0 ? void 0 : ref1.policyText;
        if (policyMsg) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (cookieBar_module_default())["cookie-policy-wrap"],
                children: [
                    policyMsg,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function() {
                            return setPolicyModal(false);
                        },
                        className: "btn btn-fluxio btn-outline mt-2 btn-block",
                        children: cookieStrings.closeString
                    })
                ]
            });
        }
    };
    if (showModal) {
        var ref12, ref13, ref14, ref15, ref16, ref17;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (cookieBar_module_default())["cookie-banner-modal-drop"],
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (cookieBar_module_default())["cookie-banner-modal"],
                children: [
                    showPolicyModal && renderPolicyMsg(),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (cookieBar_module_default())["cookie-options"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (cookieBar_module_default())["cookie-option"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            value: cookieOptions.analytics === true ? "true" : "false",
                                            onChange: function(e) {
                                                return setCookieOptions((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cookieOptions), {
                                                    analytics: e.target.checked
                                                }));
                                            },
                                            id: "cookie-1",
                                            className: (cookieBar_module_default())["cookie-checkbox"],
                                            type: "checkbox"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "cookie-1",
                                                className: (cookieBar_module_default())["cookie-title"],
                                                children: "Performance & Analytics"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (cookieBar_module_default())["cookie-description"],
                                                children: "Performance and analytics cookies collect anonymous data about website usage, which is used to improve the website and provide a better user experience."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            ((ref12 = cookieRules.cookieBar) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.headConsent) === null || ref13 === void 0 ? void 0 : ref13.enable) && renderCookieOption("cookieHead", cookieRules.cookieBar.headConsent.title, cookieRules.cookieBar.headConsent.description),
                            ((ref14 = cookieRules.cookieBar) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.body1Consent) === null || ref15 === void 0 ? void 0 : ref15.enable) && renderCookieOption("cookieBody1", cookieRules.cookieBar.body1Consent.title, cookieRules.cookieBar.body1Consent.description),
                            ((ref16 = cookieRules.cookieBar) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.body2Consent) === null || ref17 === void 0 ? void 0 : ref17.enable) && renderCookieOption("cookieBody2", cookieRules.cookieBar.body2Consent.title, cookieRules.cookieBar.body2Consent.description)
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex justify-content-between",
                        children: [
                            renderCookiePolicy(),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: setCookie,
                                className: "btn btn-fluxio btn-primary",
                                children: cookieStrings.saveString
                            })
                        ]
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var cookieBanner = (CookieBanner);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/cookieBanner/index.tsx

/* harmony default export */ var shared_public_page_cookieBanner = (cookieBanner);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var src_class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(5950);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/componentTypes.ts
var BUTTON = "button";
var BUTTON_RIGHT = "button_right";
var CARD_EXPAND_CONTAINER = "card_expand_container";
var CARD_LEFT = "card_left";
var CARD_LEFT_V2 = "card_left_v2";
var CARD_MODAL = "card_modal" // deprecated ?
;
var CARD_RIGHT = "card_right";
var CARD_RIGHT_V2 = "card_right_v2";
var CARD_TOP = "card_top";
var DROPDOWN = "dropdown";
var DROPDOWN_V2 = "dropdown_v2";
var EMBED_CONTAINER = "embed_container";
var EMBED_CONTAINER_V2 = "embed_container_v2";
var EXPAND_CONTENT = "expand_content";
var EXPAND_CONTENT_V2 = "expand_content_v2";
var GRID_CONTAINER = "grid_container";
var GRID_CONTAINER_V2 = "grid_container_v2";
var CONTAINER = "container";
var MEDIA = "media";
var MENUCOMPONENT = "menu";
var MENUCOMPONENT_V2 = "menu_v2";
var MENUTOGGLECOMPONENT = "menu_toggle";
var MENUTOGGLECOMPONENTV2 = "menu_toggle_v2";
var MODAL = "modal";
var MODAL_V2 = "modal_v2";
var MODAL_V3 = "modal_v3";
var MODAL_V4 = "modal_v4";
var NAVBARCOMPONENTV2 = "navbar_v2";
var NAVBARCOMPONENT = "navbar";
var NAVBARTOP = "navbar_top";
var SHOWCASE = "showcase";
var SLIDER_CONTAINER = "slider_container";
var SLIDER_CONTAINER_V2 = "slider_container_2";
var SLIDER_CONTAINER_V3 = "slider_container_v3";
var SOCIAL_CARD_EMBED = "social_card_embed";
var SOCIAL_MEDIA_EMBED = "social_media_embed";
var SOCIAL_CARD_SHARE = "social_card_share";
var TABS_CONTAINER = "tabs_container";
var TABS_CONTAINER_V2 = "tabs_container_v2";
var TABS_CONTAINER_DROPDOWN = "tabs_container_dropdown_v2";
var TABS_CONTENT = "tabs_content";
var TABS_CONTENT_VERTICAL = "tabs_content_vertical";
var TABS_CONTENT_V2 = "tabs_content_v2";
var TABS_CONTENT_VERTICAL_V2 = "tabs_content_vertical_v2";
var TEXT_BLOCK = "text_block";
var IMAGE_COMPARATION_SLIDER = "image_comparison_slider";
var FORM_CONTAINER = "simple_form_container";
var FORM = "form";
var INPUT = "input";
var SUBMIT = "submit";
var RESULTS_MAP = "results_map";
var DATASET_CONTAINER = "dataset_container";
var RESULTS_LIST_CONTAINER = "results_list_container";
var FILTERS = "filters";
var GRID = "grid";
var TEXT = "text";
var MEDIAV2 = "media_v2";

;// CONCATENATED MODULE: ./src/components/shared-components/error/ErrorBoundary/ErrorBoundary.tsx
/* provided dependency */ var process = __webpack_require__(83454);





var ErrorBoundary = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ErrorBoundary, _Component);
    var _super = (0,_create_super/* default */.Z)(ErrorBoundary);
    function ErrorBoundary(props) {
        (0,src_class_call_check/* default */.Z)(this, ErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: null,
            errorInfo: null
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        /**
     * don't show errors for public pages on production environment
     */ if (!process.env.REACT_APP_STAGING && "production" === "production" && this.props.expManager && !this.props.expManager.enable) return;
        // show error
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    };
    _proto.renderMsg = function renderMsg() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("details", {
            style: {
                whiteSpace: "pre-wrap"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: this.state.error && this.state.error.toString()
                }),
                this.state.errorInfo.componentStack
            ]
        });
    };
    _proto.render = function render() {
        if (this.state.errorInfo) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "component-error",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Component Crashed"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "An error ocurred!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Show the below details to Fluxio support."
                    }),
                    this.renderMsg()
                ]
            });
        }
        // Normally, just render children
        return this.props.children;
    };
    return ErrorBoundary;
}(react.Component);
/* harmony default export */ var ErrorBoundary_ErrorBoundary = (ErrorBoundary);

;// CONCATENATED MODULE: ./src/components/shared-components/error/ErrorBoundary/index.ts

/* harmony default export */ var error_ErrorBoundary = (ErrorBoundary_ErrorBoundary);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var src_to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js + 2 modules
var redux = __webpack_require__(89569);
;// CONCATENATED MODULE: ./src/api/shared-api/apiEnv.ts
var apiEnv_apiEnv = function() {
    var prefix = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "ipa";
    return "https://".concat(prefix, ".fluxio.cloud/");
};
/* harmony default export */ var shared_api_apiEnv = (apiEnv_apiEnv);

// EXTERNAL MODULE: ./src/store/shared-store/actions/actionTypes.ts
var actionTypes = __webpack_require__(28838);
;// CONCATENATED MODULE: ./src/store/shared-store/actions/contentActions.ts


function invalidHubId(hubId) {
    return {
        type: INVALID_HUB_ID,
        hubId: hubId
    };
}
function requestHubContent(hubId, local) {
    return {
        type: REQUEST_HUB_CONTENT,
        hubId: hubId,
        local: local
    };
}
function receiveHubContent(hubId, json) {
    return {
        type: RECEIVE_HUB_CONTENT,
        hubId: hubId,
        hubContent: json
    };
}
function fetchExpHubContent(hubId, uuid, userToken) {
    return function(dispatch) {
        dispatch(requestHubContent(hubId, uuid));
        return expHub(hubId, uuid, userToken).then(function(response) {
            dispatch(receiveHubContent(hubId, response));
        }).catch(function(error) {
            dispatch(invalidHubId(hubId));
            throw error;
        });
    };
}
function invalidFormulaId(formulaId) {
    return {
        type: INVALID_FORMULA_ID,
        formulaId: formulaId
    };
}
function requestFormulaContent(formulaId, until) {
    return {
        type: REQUEST_FORMULA_CONTENT,
        formulaId: formulaId,
        until: until
    };
}
function receiveFormulaContent(formulaId, json) {
    return {
        type: RECEIVE_FORMULA_CONTENT,
        formulaId: formulaId,
        formulaContent: json
    };
}
function fetchFormulaContent(localId, formulaId, until, userToken) {
    return function(dispatch) {
        dispatch(requestFormulaContent(formulaId, until));
        return formula(localId, formulaId, until, userToken).then(function(response) {
            dispatch(receiveFormulaContent(formulaId, response));
        }).catch(function(error) {
            dispatch(invalidFormulaId(formulaId));
            throw error;
        });
    };
}
/* -- * -- * -- * -- * -- * -- * -- * -- */ function invalidExperience(error) {
    return {
        type: INVALID_EXPERIENCE,
        error: error
    };
}
function requestExperience() {
    return {
        type: REQUEST_EXPERIENCE
    };
}
function receiveExperience(response) {
    var webpSupport = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "false";
    return {
        type: RECEIVE_EXPERIENCE,
        response: response,
        webpSupport: webpSupport
    };
}
function fetchExperience(wall, slug) {
    var language = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, defaultRoute = arguments.length > 3 ? arguments[3] : void 0, pageName = arguments.length > 4 ? arguments[4] : void 0, webpSupport = arguments.length > 5 ? arguments[5] : void 0;
    return function(dispatch) {
        return experience(wall, slug, language, defaultRoute, pageName).then(function(response) {
            dispatch(receiveExperience(response, webpSupport));
        }).catch(function(error) {
            dispatch(invalidExperience(error));
        });
    };
}
function fetchDemoExperience(demoId) {
    return function(dispatch) {
        dispatch(requestExperience());
        return demoExperience(demoId).then(function(response) {
            dispatch(receiveExperience(response));
        }).catch(function(error) {
            dispatch(invalidExperience(error));
        });
    };
}
function fetchRestrictedExperience(pageObjectRootId, token) {
    return function(dispatch) {
        dispatch(requestExperience());
        return restrictedExperience(pageObjectRootId, token).then(function(response) {
            dispatch(receiveExperience(response));
        }).catch(function(error) {
            dispatch(invalidExperience(error));
        });
    };
}
/* -- * -- * -- * -- * -- * -- * -- * -- */ function contentFetched(objectUuid, response) {
    return {
        type: actionTypes/* CONTENT_FETCHED */.cOZ,
        objectUuid: objectUuid,
        response: response
    };
}
function contentActions_contentFetch(objectUuid, response) {
    return function(dispatch) {
        dispatch(contentFetched(objectUuid, response));
    };
}
function fetchingContent(objectUuid) {
    return {
        type: actionTypes/* FETCHING_CONTENT */.K1K,
        objectUuid: objectUuid
    };
}
function loadingContentFetch(objectUuid) {
    return function(dispatch) {
        dispatch(fetchingContent(objectUuid));
    };
}
/* -- * -- * -- * -- * -- * -- * -- * -- */ function cleanHubContent() {
    return {
        type: CLEAN_HUB_CONTENT
    };
}
function clearHubContent() {
    return function(dispatch) {
        dispatch(cleanHubContent());
    };
}
/* -- * -- * -- * -- * -- * -- * -- * -- */ function errorFetchObjectTemplateById(error) {
    return {
        type: ERROR_FETCH_OBJECT_TEMPLATE_BY_ID,
        error: error
    };
}
function requestObjectTemplateById() {
    return {
        type: REQUEST_OBJECT_TEMPLATE_BY_ID
    };
}
function successFetchObjectTemplateById(response) {
    return {
        type: SUCCESS_FETCH_OBJECT_TEMPLATE_BY_ID,
        response: response
    };
}
function fetchObjectTemplateById(templateId, profile, token) {
    return function(dispatch) {
        dispatch(requestObjectTemplateById());
        return getObjectTemplateById(templateId, profile, token).then(function(response) {
            dispatch(successFetchObjectTemplateById(response));
        }).catch(function(error) {
            dispatch(errorFetchObjectTemplateById(error));
        });
    };
}
/* -- * -- * -- * -- * -- * -- * -- * -- */ function errorObjectTemplateToClone(error) {
    return {
        type: ERROR_OBJECT_TEMPLATE_TO_CLONE,
        error: error
    };
}
function requestObjectTemplateToClone() {
    return {
        type: REQUEST_OBJECT_TEMPLATE_TO_CLONE
    };
}
function successObjectTemplateToClone(response, groupId) {
    return {
        type: SUCCESS_OBJECT_TEMPLATE_TO_CLONE,
        response: response,
        groupId: groupId
    };
}
function objectTemplateToClone(profile, templateUuid, groupId, token) {
    return function(dispatch) {
        dispatch(requestObjectTemplateToClone());
        return getObjectTemplateById(templateUuid, profile, token).then(function(response) {
            dispatch(successObjectTemplateToClone(response, groupId));
        }).catch(function(error) {
            dispatch(errorObjectTemplateToClone(error));
            throw error;
        });
    };
}
function clearObjectTemplateToClone() {
    return {
        type: CLEAR_OBJECT_TEMPLATE_TO_CLONE
    };
}
function cleanObjectTemplateToClone() {
    return function(dispatch) {
        dispatch(clearObjectTemplateToClone());
    };
}
/* -- * -- * -- * -- * -- * -- * -- * -- */ function errorFetchExperiencePreview(error) {
    return {
        type: ERROR_FETCH_EXPERIENCE_PREVIEW,
        error: error
    };
}
function requestFetchExperiencePreview() {
    return {
        type: REQUEST_FETCH_EXPERIENCE_PREVIEW
    };
}
function successFetchExperiencePreview(response) {
    return {
        type: SUCCESS_FETCH_EXPERIENCE_PREVIEW,
        response: response
    };
}
function fetchExperiencePreview(hostUuid, pageUri, token, pageObjectRootId) {
    return function(dispatch) {
        dispatch(requestFetchExperiencePreview());
        return experiencePreview(hostUuid, pageUri, token, pageObjectRootId).then(function(response) {
            dispatch(successFetchExperiencePreview(response));
        }).catch(function(error) {
            dispatch(errorFetchExperiencePreview(error));
            throw error;
        });
    };
}
function fetchExperienceRestrictedPreview(pageObjectRootId, token) {
    return function(dispatch) {
        dispatch(requestFetchExperiencePreview());
        return experienceRestrictedPreview(pageObjectRootId, token).then(function(response) {
            dispatch(successFetchExperiencePreview(response));
        }).catch(function(error) {
            dispatch(errorFetchExperiencePreview(error));
            throw error;
        });
    };
}
function clearFetchExperiencePreview() {
    return {
        type: CLEAR_FETCH_EXPERIENCE_PREVIEW
    };
}
function cleanFetchExperiencePreview() {
    return function(dispatch) {
        dispatch(clearFetchExperiencePreview());
    };
}
/* -- * -- * -- * -- * -- * -- * -- * -- */ function errorFetchExperienceSymbol(error) {
    return {
        type: ERROR_FETCH_EXPERIENCE_SYMBOL,
        error: error
    };
}
function requestFetchExperienceSymbol() {
    return {
        type: REQUEST_FETCH_EXPERIENCE_SYMBOL
    };
}
function successFetchExperienceSymbol(response) {
    return {
        type: SUCCESS_FETCH_EXPERIENCE_SYMBOL,
        response: response
    };
}
function fetchExperienceSymbol(symbolId, profile, token) {
    return function(dispatch) {
        dispatch(requestFetchExperienceSymbol());
        return experienceSymbol(symbolId, profile, token).then(function(response) {
            dispatch(successFetchExperienceSymbol(response));
        }).catch(function(error) {
            dispatch(errorFetchExperienceSymbol(error));
            throw error;
        });
    };
}
function clearFetchExperienceSymbol() {
    return {
        type: CLEAR_FETCH_EXPERIENCE_SYMBOL
    };
}
function cleanFetchExperienceSymbol() {
    return function(dispatch) {
        dispatch(clearFetchExperienceSymbol());
    };
}

// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var lodash_cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(lodash_cloneDeep);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
;// CONCATENATED MODULE: ./src/areas/public-page/ContentFetch/ContentFetch.tsx












var ContentFetch = function(props) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var contentFetch = (0,es/* useSelector */.v9)(function(state) {
        return state.contentHubReducer;
    });
    var actions = (0,redux/* bindActionCreators */.DE)({
        contentFetchAction: contentActions_contentFetch,
        loadingContentFetch: loadingContentFetch
    }, dispatch);
    var getComposedUuid = function(obj) {
        if (obj.selectedInstanceId) {
            return "".concat(obj.uuid, "-").concat(obj.selectedInstanceId);
        }
        return obj.uuid;
    };
    var checkForItems = function(formulaToFetch) {
        if (formulaToFetch.posts.length > 0 && !contentFetch["content".concat(getComposedUuid(props.obj))]) {
            return true;
        }
        return false;
    };
    var fetchContent = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(id) {
            var config, content;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        config = {
                            headers: {
                                "Content-Type": "application/json",
                                Accept: "application/json",
                                "MeshApp-host": "meshapp"
                            }
                        };
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return axios_default().get("".concat(shared_api_apiEnv(), "v1/formulas/").concat(id, "/content2"), config);
                    case 4:
                        content = _ctx.sent;
                        actions.contentFetchAction(getComposedUuid(props.obj), content.data);
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        console.warn(_ctx.t0);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8
                ]
            ]);
        }));
        return function fetchContent(id) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!props.expManager.enable || props.expManager.content) {
            if (!contentFetch["content".concat(getComposedUuid(props.obj), "loading")] && !contentFetch["content".concat(getComposedUuid(props.obj), "content")]) {
                var ref;
                var ref1;
                var formulaToFetch = (ref1 = (ref = props.overrides) === null || ref === void 0 ? void 0 : ref.formula) !== null && ref1 !== void 0 ? ref1 : props.obj.content.formula;
                if (formulaToFetch && !checkForItems(formulaToFetch)) {
                    actions.loadingContentFetch(getComposedUuid(props.obj));
                    fetchContent(formulaToFetch.uuid);
                }
            }
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (props.expManager.enable && !props.expManager.content) {
        return props.children(props.obj);
    }
    if (contentFetch["content".concat(getComposedUuid(props.obj))]) {
        var newObj = cloneDeep_default()(props.obj);
        if (newObj.content.formula) {
            newObj.content.formula.posts = (0,src_to_consumable_array/* default */.Z)(contentFetch["content".concat(getComposedUuid(props.obj), "content")]);
            //Write media to formula
            if (contentFetch["content".concat(getComposedUuid(props.obj), "contentMedia")]) {
                newObj.content.formula = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, newObj.content.formula), {
                    media: (0,src_object_spread/* default */.Z)({}, contentFetch["content".concat(getComposedUuid(props.obj), "contentMedia")])
                });
            }
        } else {
            console.warn("Missing formula to add fetched content");
        }
        return props.children(newObj);
    }
    return props.children(props.obj);
};
/* harmony default export */ var ContentFetch_ContentFetch = (ContentFetch);

;// CONCATENATED MODULE: ./src/areas/public-page/ContentFetch/index.ts

/* harmony default export */ var public_page_ContentFetch = (ContentFetch_ContentFetch);

;// CONCATENATED MODULE: ./src/api/shared-api/publicPageApi.ts


var PublicPageApi = /*#__PURE__*/ function() {
    "use strict";
    function PublicPageApi() {
        (0,src_class_call_check/* default */.Z)(this, PublicPageApi);
    }
    PublicPageApi.getDataSet = function getDataSet(datasetId, filters, nextCursor) {
        // when filters are not present, body must not exist
        var bodyObj = JSON.stringify(filters) !== "{}" ? {
            filters: filters
        } : undefined;
        var endpoint = "".concat(shared_api_apiEnv(), "v1/datasets/").concat(datasetId, "/content");
        if (nextCursor) endpoint = "".concat(shared_api_apiEnv(), "v1/datasets/").concat(datasetId, "/content?cursor=").concat(nextCursor);
        var request = new Request(endpoint, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            }),
            body: JSON.stringify(bodyObj)
        });
        return fetch(request).then(function(response) {
            if (response.status === 200) {
                return response.json();
            }
            throw response;
        }).catch(function(error) {
            throw error;
        });
    };
    PublicPageApi.getDataSetList = function getDataSetList(profileId, token) {
        var request = new Request("".concat(shared_api_apiEnv(), "v1/profiles/").concat(profileId, "/datasetsEM"), {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json",
                "MeshApp-host": "".concat(profileId),
                "Authorization": "Bearer ".concat(token.access_token)
            })
        });
        return fetch(request).then(function(response) {
            if (response.status === 200) {
                return response.json();
            }
            throw response;
        }).catch(function(error) {
            throw error;
        });
    };
    PublicPageApi.getDataSetFiltersList = function getDataSetFiltersList(objectId) {
        var request = new Request("".concat(shared_api_apiEnv(), "v1/"), {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        });
        return fetch(request).then(function(response) {
            if (response.status === 200) {
                return response.json();
            }
            throw response;
        }).catch(function(error) {
            throw error;
        });
    };
    return PublicPageApi;
}();
/* harmony default export */ var publicPageApi = (PublicPageApi);

;// CONCATENATED MODULE: ./src/store/shared-store/actions/publicPageActions.ts


function changeDataSet(dataset) {
    return {
        type: actionTypes/* CHANGE_DATA_SET */.Bak,
        dataset: dataset
    };
}
function writeDataSet(dataset) {
    return function(dispatch) {
        dispatch(changeDataSet(dataset));
    };
}
/*************************************** */ function receiveDataSet(datasetId, filters, response) {
    return {
        type: actionTypes/* RECEIVE_DATASET */.C6S,
        response: response,
        datasetId: datasetId,
        filters: filters
    };
}
function errorFetchDataSet(datasetId, error) {
    return {
        type: actionTypes/* ERROR_FETCH_DATASET */.HhL,
        error: error,
        datasetId: datasetId
    };
}
function fetchingDataSet(datasetId) {
    return {
        type: actionTypes/* FETCHING_DATASET */.u7g,
        datasetId: datasetId
    };
}
/**
 *
 * @param objectId? This id should be send by the first dataSet Component
 * Since we wont implement this logic yet, there is going to exist only
 * one dataset at each moment.
 * TODO make it possible to have multiple datasets in the same page
 * @param datasetId: string
 */ function getDataSet(datasetId, filters) {
    return function(dispatch) {
        dispatch(fetchingDataSet(datasetId));
        publicPageApi.getDataSet(datasetId, filters).then(function(response) {
            dispatch(receiveDataSet(datasetId, filters, response));
        }).catch(function(error) {
            dispatch(errorFetchDataSet(datasetId, error));
        });
    };
}
/*************************************** */ function receiveLoadMoreDataSet(datasetId, filters, response, nextCursor) {
    return {
        type: actionTypes/* RECEIVE_LOADMORE_DATASET */.Lj2,
        response: response,
        datasetId: datasetId,
        filters: filters,
        nextCursor: nextCursor
    };
}
function errorFetchLoadMoreDataSet(datasetId, error) {
    return {
        type: actionTypes/* ERROR_FETCH_LOADMORE_DATASET */.hiD,
        error: error,
        datasetId: datasetId
    };
}
function fetchingLoadMoreDataSet(datasetId, nextCursor) {
    return {
        type: actionTypes/* FETCHING_LOADMORE_DATASET */.G2O,
        datasetId: datasetId,
        nextCursor: nextCursor
    };
}
/**
 *
 * @param objectId? This id should be send by the first dataSet Component
 * Since we wont implement this logic yet, there is going to exist only
 * one dataset at each moment.
 * TODO make it possible to have multiple datasets in the same page
 * @param datasetId: string
 */ function loadMoreDataSet(datasetId, filters, nextCursor) {
    return function(dispatch) {
        dispatch(fetchingLoadMoreDataSet(datasetId, nextCursor));
        publicPageApi.getDataSet(datasetId, filters, nextCursor).then(function(response) {
            dispatch(receiveLoadMoreDataSet(datasetId, filters, response, nextCursor));
        }).catch(function(error) {
            dispatch(errorFetchLoadMoreDataSet(datasetId, error));
        });
    };
}
/* -- * -- * -- * -- * -- * -- * -- * -- */ function warningStateEM(value) {
    return {
        type: actionTypes/* WARNING_STATE_EM */.WOt,
        value: value
    };
}
function warningSystemEM(value) {
    return function(dispatch) {
        dispatch(warningStateEM(value));
    };
}
/* -- * -- * -- * -- * -- * -- * -- * -- */ function selectedHubHandlerToEdit(id, parentId, object) {
    return {
        type: actionTypes/* SELECTED_HUB_HANDLER_TO_EDIT */.eSx,
        id: id,
        parentId: parentId,
        object: object
    };
}
function hubHandlerSelected(id, parentId, object) {
    return function(dispatch) {
        dispatch(selectedHubHandlerToEdit(id, parentId, object));
    };
}
/* -- * -- * -- * -- * -- * -- * -- * -- */ function selectedFinder(typeSelected, selectedObject) {
    return {
        type: actionTypes/* SELECTED_FINDER */.dQR,
        typeSelected: typeSelected,
        selectedObject: selectedObject
    };
}
function selectFinder(type, selectedObject) {
    return function(dispatch) {
        dispatch(selectedFinder(type, selectedObject));
    };
}
/* -- * -- * -- * -- * -- * -- * -- * -- */ function clearSelectedFinder() {
    return {
        type: actionTypes/* CLEAR_SELECTED_FINDER */.Ef1
    };
}
function clearSelectFinder() {
    return function(dispatch) {
        dispatch(clearSelectedFinder());
    };
}
/* -- * -- * -- * -- * -- * -- * -- * -- */ function objectSelectorHover(value) {
    return {
        type: actionTypes/* OBJECT_SELECTOR_HOVER */.OpV,
        value: value
    };
}
function objectSelectionHover(value) {
    return function(dispatch) {
        dispatch(objectSelectorHover(value));
    };
}
// Viewport State
function viewPortSizeExperienceManager(viewPortSize, viewPortScale) {
    return {
        type: actionTypes/* VIEW_PORT_SIZE_STATE_EXPERIENCE_MANAGER */.$s4,
        viewPortSize: viewPortSize,
        viewPortScale: viewPortScale
    };
}
function viewPortSizeStateExperienceManager(viewPortSize, viewPortScale) {
    return function(dispatch) {
        dispatch(viewPortSizeExperienceManager(viewPortSize, viewPortScale));
    };
}
/* -- * -- * -- * -- * -- * -- * -- * -- */ function responsiveTab(tab) {
    return {
        type: actionTypes/* RESPONSIVE_TAB */.ffN,
        tab: tab
    };
}
function changeResponsiveTab(tab) {
    return function(dispatch) {
        dispatch(responsiveTab(tab));
    };
}
/* -- * -- * -- * -- * -- * -- * -- * -- */ function selectedFinderType(typeSelected) {
    return {
        type: actionTypes/* SELECTED_FINDER_TYPE */.VlC,
        typeSelected: typeSelected
    };
}
function selectFinderType(typeSelected) {
    return function(dispatch) {
        dispatch(selectedFinderType(typeSelected));
    };
}

;// CONCATENATED MODULE: ./src/store/shared-store/actions/symbolsActions.ts


function requestSymbolsList() {
    return {
        type: REQUEST_SYMBOLS_LIST
    };
}
function receiveSymbolsList(response) {
    return {
        type: RECEIVE_SYMBOLS_LIST,
        response: response
    };
}
function errorSymbolsList(error) {
    return {
        type: ERROR_SYMBOLS_LIST,
        error: error
    };
}
function fetchSymbolsList(profile, token, orderby, limit, order, search, page, gsType) {
    return function(dispatch) {
        dispatch(requestSymbolsList());
        return getSymbolsList(profile, token, orderby, limit, order, search, page).then(function(response) {
            dispatch(receiveSymbolsList(response));
        }).catch(function(error) {
            dispatch(errorSymbolsList(error));
            throw error;
        });
    };
}
/************************************************* */ function addSymbolObject(object, addBehaviourType) {
    return {
        type: ADD_SYMBOL_OBJECT,
        object: object,
        addBehaviourType: addBehaviourType
    };
}
function clearAddSymbolObject() {
    return {
        type: CLEAR_ADD_SYMBOL_OBJECT
    };
}
function addSymbol(object, addBehaviourType) {
    return function(dispatch) {
        return dispatch(addSymbolObject(object, addBehaviourType));
    };
}
function clearAddSymbol() {
    return function(dispatch) {
        dispatch(clearAddSymbolObject());
    };
}
/************************************************* */ function symbolContentType(contentType) {
    return {
        type: actionTypes/* SYMBOL_CONTENT_TYPE */.j9d,
        contentType: contentType
    };
}
function setSymbolContentType(contentType) {
    return function(dispatch) {
        return dispatch(symbolContentType(contentType));
    };
}
/* -- * -- * -- * -- * -- * -- * -- * -- */ function selectSymbolInstanceToEdit(id, object) {
    return {
        type: actionTypes/* SELECTED_SYMBOL_INSTANCE */.yTC,
        id: id,
        object: object
    };
}
function selectSymbolInstance(id, object) {
    return function(dispatch) {
        dispatch(selectSymbolInstanceToEdit(id, object));
    };
}
/************************************************* */ function handleNewSymbolTree(symbol, symbolInstance) {
    return {
        type: HANDLE_SYMBOL_TREE,
        symbol: symbol,
        symbolInstance: symbolInstance
    };
}
function clearHandleNewSymbolTree() {
    return {
        type: CLEAR_HANDLE_SYMBOL_TREE
    };
}
function handleSymbolTree(symbol, symbolInstance) {
    return function(dispatch) {
        return dispatch(handleNewSymbolTree(symbol, symbolInstance));
    };
}
function clearHandleSymbolTree() {
    return function(dispatch) {
        dispatch(clearHandleNewSymbolTree());
    };
}
/************************************************* */ function requestDeleteSymbol(symbol) {
    return {
        type: REQUEST_DELETE_SYMBOL,
        symbol: symbol
    };
}
function successDeleteSymbol(response) {
    return {
        type: RECEIVE_DELETE_SYMBOL,
        response: response
    };
}
function errorDeleteSymbol(error) {
    return {
        type: ERROR_DELETE_SYMBOL,
        error: error
    };
}
function removeSymbol(symbol, profile, token) {
    return function(dispatch) {
        dispatch(requestDeleteSymbol(symbol));
        return deleteSymbol(symbol, profile, token).then(function(response) {
            dispatch(successDeleteSymbol(response));
        }).catch(function(error) {
            dispatch(errorDeleteSymbol(error));
            throw error;
        });
    };
}
function clearDeleteSymbol() {
    return {
        type: CLEAR_DELETE_SYMBOL
    };
}
function cleanDeleteSymbol() {
    return function(dispatch) {
        return dispatch(clearDeleteSymbol());
    };
}
/************************************************* */ function requestChangeSymbolLabel(objectId) {
    return {
        type: REQUEST_CHANGE_SYMBOL_LABEL,
        objectId: objectId
    };
}
function successChangeSymbolLabel(response) {
    return {
        type: RECEIVE_CHANGE_SYMBOL_LABEL,
        response: response
    };
}
function errorChangeSymbolLabel(error) {
    return {
        type: ERROR_CHANGE_SYMBOL_LABEL,
        error: error
    };
}
function changeSymbolLabel(symbolLabel, symbolId, objectId, profile, token) {
    return function(dispatch) {
        dispatch(requestChangeSymbolLabel(objectId));
        return changeSymbolLabelApi(symbolLabel, symbolId, profile, token).then(function(response) {
            dispatch(successChangeSymbolLabel({
                response: response,
                symbolLabel: symbolLabel,
                symbolId: symbolId
            }));
        }).catch(function(error) {
            dispatch(errorChangeSymbolLabel(error));
            throw error;
        });
    };
}
function clearChangeSymbolLabel() {
    return {
        type: CLEAR_CHANGE_SYMBOL_LABEL
    };
}
function cleanChangeSymbolLabel() {
    return function(dispatch) {
        return dispatch(clearChangeSymbolLabel());
    };
}
/************************************************* */ function requestSymbolScreenshot() {
    return {
        type: REQUEST_SYMBOL_SCREENSHOT
    };
}
function successSymbolScreenshot(response) {
    return {
        type: RECEIVE_SYMBOL_SCREENSHOT,
        response: response
    };
}
function errorSymbolScreenshot(error) {
    return {
        type: ERROR_SYMBOL_SCREENSHOT,
        error: error
    };
}
function symbolScreenshot(symbolId, profile, token) {
    return function(dispatch) {
        dispatch(requestSymbolScreenshot());
        return symbolScreenshotApi(symbolId, profile, token).then(function(response) {
            dispatch(successSymbolScreenshot(response));
        }).catch(function(error) {
            dispatch(errorSymbolScreenshot(error));
            throw error;
        });
    };
}
function clearSymbolScreenshot() {
    return {
        type: CLEAR_SYMBOL_SCREENSHOT
    };
}
function cleanSymbolScreenshot() {
    return function(dispatch) {
        return dispatch(clearSymbolScreenshot());
    };
} /************************************************* */ 

;// CONCATENATED MODULE: ./src/store/shared-store/actions/pageTreeActions.ts

function pageTreeFinderController(finderState) {
    return {
        type: PAGE_TREE_FINDER_CONTROLLER,
        finderState: finderState
    };
}
function controlPageTreeFinder(finderState) {
    return function(dispatch) {
        dispatch(pageTreeFinderController(finderState));
    };
}
/************************************************* */ function pageTreeEditSymbolState(symbolObj, tabToOpen) {
    return {
        type: actionTypes/* PAGE_TREE_EDIT_SYMBOL_STATE */.TVq,
        symbolObj: symbolObj,
        tabToOpen: tabToOpen
    };
}
function editSymbolState(symbolObj) {
    var tabToOpen = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "template";
    return function(dispatch) {
        dispatch(pageTreeEditSymbolState(symbolObj, tabToOpen));
    };
}
/************************************************* */ function pageTreeFinderExpanded(isExpanded) {
    return {
        type: PAGE_TREE_FINDER_EXPANDED,
        isExpanded: isExpanded
    };
}
function pageTreeFinderExpand(isExpanded) {
    return function(dispatch) {
        dispatch(pageTreeFinderExpanded(isExpanded));
    };
}

;// CONCATENATED MODULE: ./src/modules/shared-modules/utilities/symbols.tsx



function handleObjectTreeUuids(objectTree, instanceUuid, pageObjects, shouldReturn) {
    if (objectTree.children.length > 0) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = objectTree.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var childObject = _step.value;
                pageObjects[childObject].objectUuid = instanceUuid + "_" + pageObjects[childObject].objectUuid;
                if (pageObjects[childObject].children.length > 0) {
                    handleObjectTreeUuids(pageObjects[childObject], instanceUuid, pageObjects, false);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    if (shouldReturn) return objectTree;
}
function getSymbolObject(instance, pageResponse) {
    var instanceObject = pageResponse.objects[instance.uuid];
    if (instanceObject.isInstanceOf) {
        var symbolObject = pageResponse.symbols[instanceObject.isInstanceOf];
        return _object_spread_props(_object_spread({}, symbolObject.objects[symbolObject.rootId]), {
            selectedInstanceId: instance.uuid,
            isContentBlockChild: instance.isContentBlockChild
        });
    }
    console.warn("No symbol found!");
    return instance;
}
function symbols_handleFilterSymbolObject(instance, symbolsList, symbolEditMode) {
    //we failed as a society
    if (!symbolsList) {
        var clonedItem = cloneDeep_default()(instance);
        clonedItem.styles.component.name = "NO_SYMBOL";
        return clonedItem;
    }
    if (!symbolEditMode) {
        var SymbolToUse = symbolsList[instance.isInstanceOf];
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, SymbolToUse.objects[SymbolToUse.rootId]), {
            hidden: instance.hidden,
            selectedInstanceId: instance.objectUuid,
            isContentBlockChild: instance.isContentBlockChild
        });
    }
    var symbolToUse = symbolsList[instance.isInstanceOf];
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, symbolToUse.objects[symbolToUse.rootId]), {
        selectedInstanceId: instance.objectUuid,
        isContentBlockChild: instance.isContentBlockChild
    });
}
function getObjectFromSymbolObject(pageResponse, singleObject) {
    if (singleObject.fromSymbolTree) {
        var mainSymbol = pageResponse.symbols[singleObject.fromSymbolTree];
        var originalObject = mainSymbol.objects[singleObject.uuid];
        return originalObject !== null && originalObject !== void 0 ? originalObject : singleObject;
    }
    return singleObject;
}
function handleWriteInstanceIdToChilds(symbolObj, instance, symbolEditMode, shouldReturn) {
    if (symbolObj.objects) {
        for(var childObj in symbolObj.objects){
            symbolObj.objects[childObj] = _object_spread_props(_object_spread({}, symbolObj.objects[childObj]), {
                selectedInstanceId: instance.objectUuid
            });
        }
    }
    if (shouldReturn) return symbolObj.objects[symbolObj.rootId];
}
function handleFilterInstanceObj(pageObj, instanceId) {
    return pageObj.objects[instanceId];
}
function handleDOMid(field, id, instanceId, post) {
    var postId = (post === null || post === void 0 ? void 0 : post.id) ? "-".concat(post.id) : "";
    return instanceId ? "".concat(field, "-").concat(id, "-").concat(instanceId).concat(postId) : "".concat(field, "-").concat(id).concat(postId);
}
/**
 * handle unique ids for symbol/instance objects
 * objId + symbolObjId + instanceId
 * @param object
 * @param symbolsList
 */ function handleUniqueid(object, symbolsList) {
    // is instance
    if (object.isInstanceOf) {
        var symbol = symbolsList[object.isInstanceOf];
        /**
     * TODO: quickfix. Paste object should inject objects and symbols to the contentHub,
     * because thos objects could come from another page
     */ if (!symbol) return object.uuid // temporary
        ;
        var symbolObj = symbol.objects[symbol.rootId];
        return "".concat(symbolObj.uuid, "_").concat(object.isInstanceOf, "_").concat(object.uuid);
    }
    // is symbol obj
    if (object.fromSymbolTree && object.selectedInstanceId) return "".concat(object.uuid, "_").concat(object.fromSymbolTree, "_").concat(object.selectedInstanceId);
    // is normal obj
    return object.uuid;
}
/**
 * handle instance content overrides
 * when instance has overrides symbol(being rendered/used) must use those
 * can handle all symbol objects, or a single symbol object
 * @param instance
 * @param symbolObjects Use an objectsList to be returned
 * @param singleObject Or a singleObject to be returned
 */ function handleInstanceOverrides(instance, objectList, singleObject) {
    var ref;
    // instance has overrides
    if (instance === null || instance === void 0 ? void 0 : (ref = instance.content) === null || ref === void 0 ? void 0 : ref.overrides) {
        // loop throught each object overrides
        for(var objectKey in instance.content.overrides){
            var ref1, ref2, ref3;
            // handle object inlineContent overrides
            if ((ref1 = instance === null || instance === void 0 ? void 0 : instance.content.overrides[objectKey]) === null || ref1 === void 0 ? void 0 : ref1.inlineContent) {
                if (singleObject && singleObject.uuid === objectKey) singleObject.content.inlineContent = (0,src_object_spread/* default */.Z)({}, singleObject.content.inlineContent, instance.content.overrides[objectKey].inlineContent);
                if (objectList && objectList[objectKey]) objectList[objectKey].content.inlineContent = (0,src_object_spread/* default */.Z)({}, objectList[objectKey].content.inlineContent, instance.content.overrides[objectKey].inlineContent);
            }
            // handle object formula overrides
            if ((ref2 = instance === null || instance === void 0 ? void 0 : instance.content.overrides[objectKey]) === null || ref2 === void 0 ? void 0 : ref2.formula) {
                if (singleObject && singleObject.uuid === objectKey) singleObject.content.formula = (0,src_object_spread/* default */.Z)({}, singleObject.content.formula, instance.content.overrides[objectKey].formula);
                if (objectList && objectList[objectKey]) objectList[objectKey].content.formula = (0,src_object_spread/* default */.Z)({}, objectList[objectKey].content.formula, instance.content.overrides[objectKey].formula);
            }
            // handle other overrides
            if ((ref3 = instance === null || instance === void 0 ? void 0 : instance.content.overrides[objectKey]) === null || ref3 === void 0 ? void 0 : ref3.hasOwnProperty("isContentBlock")) {
                if (singleObject && singleObject.uuid === objectKey) singleObject.isContentBlock = instance.content.overrides[objectKey].isContentBlock;
                if (objectList && objectList[objectKey]) objectList[objectKey].isContentBlock = instance.content.overrides[objectKey].isContentBlock;
            }
        }
    }
    return singleObject || objectList;
}
/**
 * When in symbol edit mode and content type is symbol we must manipulate the instance object,
 * so it doens have written overrides,
 * this way the render of the symbol will not use the instance overrides contents
 * @param instance
 * @param contentType
 */ function handleContentType(instance, contentType) {
    var ref;
    if (contentType === "symbol") {
        if ((ref = instance.content) === null || ref === void 0 ? void 0 : ref.overrides) {
            // loop throught each object overrides
            for(var objectKey in instance.content.overrides){
                // handle object overrides
                if (instance === null || instance === void 0 ? void 0 : instance.content.overrides[objectKey]) {
                    delete instance.content.overrides[objectKey];
                }
            }
        }
    }
    return instance;
}

;// CONCATENATED MODULE: ./src/modules/shared-modules/experienceManager/defaultObj/defaultObj.ts
var main = {
    label: null,
    parentId: null,
    objectLabel: "New Object",
    objectFormula: null,
    uri: null,
    uuid: "",
    objectUuid: null,
    picture: null,
    picture_cover: null,
    picture_icon: null,
    type: "object",
    uniqueUuid: null,
    content: [],
    order: 0,
    hasMore: null,
    totalItems: null,
    nextCursor: null,
    createNow: false,
    insertEM: true,
    parentObjectUuid: null,
    firstObjectUuid: "",
    changedOrder: false,
    mql: null,
    description: null,
    styles: {
        uuid: null,
        component: {
            name: "grid_container",
            uuid: "f9d3a6a1-aea6-4455-9022-c6e5342e8126",
            preview: "https://meshapp-cdn.s3-eu-west-1.amazonaws.com/fluxio/components/grid_container.png",
            label: "Grid Container",
            bob_map: [
                "code1",
                "background1"
            ],
            bob: {
                code1: {
                    controls: true,
                    type: "bobCode"
                },
                background1: {
                    shadow: true,
                    name: "container",
                    border: true,
                    label: "Main Background",
                    scrollBehaviour: true,
                    radius: true,
                    linkMappedValues: [
                        "custom",
                        "page",
                        "anchor",
                        "$.originUrl",
                        '$["contacts.from"].link'
                    ],
                    grid: true,
                    filter: true,
                    wrap: true,
                    alignment: true,
                    mappedValues: [
                        "imageSrc"
                    ],
                    lean: true,
                    type: "bobBackground",
                    spacing: true,
                    controls: true
                }
            },
            content: {
                formulas: false,
                posts: false,
                embedCode: false,
                embed: false
            }
        },
        bobs: {
            background1: {
                enable: true,
                shadow: {
                    enable: false,
                    spread: 0,
                    offsetV: 0,
                    color: "rgba(0, 0, 0, 0.5)",
                    offsetH: 0,
                    inset: false,
                    blur: 0
                },
                scroll: {
                    enable: false,
                    value: "static"
                },
                size: "cover",
                border: {
                    enable: false,
                    bottomStyle: "solid",
                    leftWidth: 1,
                    topColor: "#ffffff",
                    rightColor: "#ffffff",
                    rightEnable: false,
                    topWidth: 1,
                    bottomEnable: false,
                    leftStyle: "solid",
                    leftEnable: false,
                    bottomColor: "#ffffff",
                    rightWidth: 1,
                    topEnable: false,
                    rightStyle: "solid",
                    bottomWidth: 1,
                    leftColor: "#ffffff",
                    topStyle: "solid"
                },
                image: {
                    enable: false,
                    size: "cover",
                    mappedValue: "imageSrc",
                    src: "",
                    position: "center center",
                    repeat: "no-repeat"
                },
                height: {
                    value: 100,
                    enable: false,
                    unit: "auto"
                },
                radius: {
                    enable: false,
                    bottomRight: 0,
                    topRight: 0,
                    bottomLeft: 0,
                    topLeft: 0
                },
                grid: {
                    rows: 1,
                    enable: true,
                    columns: [
                        "12"
                    ]
                },
                filter: {
                    enable: false,
                    shadow: 0,
                    sepia: 0,
                    hueRotation: 0,
                    overlay: "#ffffff",
                    blur: 0,
                    grayscale: 0,
                    brightness: 50,
                    contrast: 50,
                    opacity: 0,
                    invert: 0,
                    saturate: 50
                },
                colors: {
                    enable: false,
                    isGradient: false,
                    gradientAngle: 0,
                    colorSecond: "#fff",
                    colorFirst: "#fff",
                    gradientDirection: "left-right"
                },
                wrap: "container",
                fill: "color",
                alignment: {
                    enable: false,
                    horizontal: "left",
                    vertical: "top"
                },
                attachment: "scroll",
                lean: {
                    enable: false,
                    bottomLefty: 0,
                    topLeftx: 0,
                    bottomLeftx: 0,
                    direction: "left",
                    bottomRighty: 0,
                    topRightx: 0,
                    bottomRightx: 0,
                    topRighty: 0,
                    position: "both",
                    topLefty: 0
                },
                spacing: {
                    enable: true,
                    margin: {
                        left: 0,
                        right: 0,
                        bottom: 60,
                        top: 60
                    },
                    padding: {
                        left: 0,
                        top: 0,
                        bottom: 0,
                        right: 0
                    }
                },
                behaviour: {
                    hover: {
                        enable: false
                    },
                    link: {
                        enable: false,
                        mappedValue: "custom",
                        label: "",
                        customUrl: "",
                        linkedObject: ""
                    },
                    active: {
                        enable: false
                    }
                }
            },
            code1: {
                code: "",
                enable: true
            }
        }
    },
    staticPost: {
        title: "",
        description: "",
        description_preview: "",
        picture_orig: "https://cdn.fluxio.cloud/fluxio/fluxio_placeholder.png",
        network: "",
        "contacts.from": {
            ID: "",
            iname: "",
            source_id: "",
            name_full: ""
        },
        "indexed.unix": 0,
        source: [],
        content_type: "",
        message: "",
        originUrl: "",
        slug: "",
        "created.unix": 0,
        url: "",
        picture_medium: "",
        sourceId: "",
        experience_order: 0,
        picture_large: "",
        id: "",
        type: "",
        contacts: {
            from: {
                ID: "",
                iname: "",
                source_id: "",
                name_full: ""
            }
        }
    }
};

// EXTERNAL MODULE: ./node_modules/jsonpath/jsonpath.js
var jsonpath = __webpack_require__(39832);
var jsonpath_default = /*#__PURE__*/__webpack_require__.n(jsonpath);
// EXTERNAL MODULE: ./node_modules/lodash/set.js
var lodash_set = __webpack_require__(36968);
;// CONCATENATED MODULE: ./src/modules/shared-modules/experienceManager/finder/content/inlineContent/inlineContentTypes.ts
/**
 * Link Controller Fields
 */ var LINK_ENABLE = "behaviour-link-enable";
var LINK_LABEL = "behaviour-link-label";
var LINK_MAPPED_VALUE = "behaviour-link-mappedValue";
var LINK_CUSTOM_URL = "behaviour-link-customUrl";
var LINK_LINKED_OBJECT = "behaviour-link-linkedObject";
var LINK_TARGET = "behaviour-link-target";
/**
 * Background Fields
 */ var IMAGE_SRC = "image-src";
var IMAGE_SRC_ACTIVE = "behaviour-active-image-src";
var IMAGE_SRC_HOVER = "behaviour-hover-image-src";
var IMAGE_ALT = "image-alt";
var IMAGE_ALT_ACTIVE = "behaviour-active-image-alt";
var IMAGE_ALT_HOVER = "behaviour-hover-image-alt";
/**
 * Text Fields
 */ var CUSTOM_TEXT = "customText";
var CONTENT_SRC_TEXT = "contentSrc";
var MAPPED_VALUE = "mappedValue";
var FORM_FIELD = "formField";
var EXTRA_WEIGHTS = "extraWeights";
var TAG = "tag";
var SAFE_CUSTOM_TEXT_TAG = "safeCustomTextTag";
/**
 * Media Fields
 */ var SRC = "src";
var TABLET_SRC = "tablet-src";
var MOBILE_SRC = "mobile-src";
var LINK_TYPE = "linkType";
var CONTROLS = "controls";
var THUMBNAIL = "thumbnail";
var PLAY_PAUSE_ASSET = "playPauseAsset";
var EMBED_ENABLE = "embedEnable";
var EMBED = "embed";
var SRC_ACTIVE = "behaviour-active-src";
var SRC_HOVER = "behaviour-hover-src";
var IMAGE_ENABLE = "image-enable";
var IMAGE_ENABLE_ACTIVE = "behaviour-active-image-enable";
var IMAGE_ENABLE_HOVER = "behaviour-hover-image-enable";
var VIDEO_ENABLE = "video-enable";
var VIDEO_ENABLE_ACTIVE = "behaviour-active-video-enable";
var VIDEO_ENABLE_HOVER = "behaviour-hover-video-enable";
var CONTENT_SRC_MEDIA = "contentSrc";
var CONTENT_SRC_ACTIVE = "behaviour-active-contentSrc";
var CONTENT_SRC_HOVER = "behaviour-hover-contentSrc";
var IMAGE_MAPPED_VALUE = "image-mappedValue";
var IMAGE_MAPPED_VALUE_ACTIVE = "behaviour-active-image-mappedValue";
var IMAGE_MAPPED_VALUE_HOVER = "behaviour-hover-image-mappedValue";
var VIDEO_MAPPED_VALUE = "video-mappedValue";
var VIDEO_MAPPED_VALUE_ACTIVE = "behaviour-active-video-mappedValue";
var VIDEO_MAPPED_VALUE_HOVER = "behaviour-hover-video-mappedValue";
/**
 * Others
 */ var CUSTOM_ID = "id";
var CUSTOM_CLASS = "class";
/**
 * Custom Attributes Fields
 */ var CUSTOM_ATTRIBUTES_ENABLE = "custom-attributes";
var CUSTOM_ATTRIBUTES_MAPPED_FIELD = "custom-attribute-mappedField";
var CUSTOM_ATTRIBUTES_VALUE = "custom-attribute-value";
var CUSTOM_ATTRIBUTES_CONTENTSRC = "custom-attribute-contentSrc";

;// CONCATENATED MODULE: ./src/modules/shared-modules/experienceManager/finder/inputs/textController/textContentHelper.ts
function stateWrite(textControllerObject) {
    return {
        mappedValue: textControllerObject.mappedValue.value,
        contentSrc: textControllerObject.contentSrc.value
    };
}
var textContentHelper_CMS = "post";
var textContentHelper_WRITE = "custom";
var textContentHelper_CONTENT_PAGE = "content-page";
var textContentHelper_FORM = "form";
var mvPage = [
    {
        label: "Insert",
        value: textContentHelper_WRITE
    },
    {
        label: "CMS",
        value: textContentHelper_CMS
    }, 
];
var mvContentPage = [
    {
        label: "Insert",
        value: textContentHelper_WRITE
    },
    {
        label: "CMS",
        value: textContentHelper_CMS
    },
    {
        label: "Content Page",
        value: textContentHelper_CONTENT_PAGE
    }, 
];
var TEXTMAPPEDVALUES = [
    {
        label: "Title",
        value: "$.title"
    },
    {
        label: "Description",
        value: "$.description"
    },
    {
        label: "Description Preview",
        value: "$.description_preview"
    },
    {
        label: "Message",
        value: "$.message"
    },
    {
        label: "Object Label",
        value: "$.objectLabel"
    },
    {
        label: "Formula Label",
        value: "$.label"
    },
    {
        label: "Social Network",
        value: "$.network"
    },
    {
        label: "Entity Name",
        value: "$['contacts.from'].name_full"
    },
    {
        label: "Created Time",
        value: "$['created.unix']"
    },
    {
        label: "Entity Description",
        value: "$['contacts.from'].description"
    }, 
];

;// CONCATENATED MODULE: ./src/modules/shared-modules/experienceManager/finder/content/contentPageHelper.ts
var contentPageHelper_DummyPost = {
    title: "Lorem Ipsum",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    description_preview: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    message: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium,",
    picture_orig: "https://static-media.fluxio.cloud/ricardo/ayS2ABJu.jpg",
    content_type: "post",
    "created.unix": 0,
    "indexed.unix": 0,
    id: "",
    network: "",
    source: [
        ""
    ],
    sourceId: "",
    type: "item",
    url: "",
    originUrl: "",
    slug: "",
    picture_medium: "",
    experience_order: 0,
    picture_large: "",
    "contacts.from": {
        ID: "",
        iname: "",
        source_id: "",
        name_full: ""
    },
    contacts: {
        from: {
            ID: "",
            iname: "",
            source_id: "",
            name_full: ""
        }
    }
};

;// CONCATENATED MODULE: ./src/lib/typecheck/typeschek.ts
function stringOrUndefined(x) {
    if (typeof x === "string") return x;
    return undefined;
}

;// CONCATENATED MODULE: ./src/modules/shared-modules/utilities/components.tsx

















/**
 * Build path from string recurvely
 * : denotes an object ex:'from.contacts:picture.large'
 * @param {*} obj
 * @param {*} path
 */ function cleanPath(obj, path) {
    return multiIndex(obj, path.split(":"));
}
function multiIndex(obj, path) {
    return path.length ? multiIndex(obj[path[0]], path.slice(1)) : obj;
}
//Probably temp just to get the $.message field
function getPostStringByMappedValue(post, mappedField) {
    var value = jsonpath_default().query(post, mappedField);
    return value && value.length > 0 ? value[0] : undefined;
}
function datasetRender(post, customAttributesEnable, customAttributesMappedField, customAttributesValue, customAttributesContentSrc) {
    if (customAttributesEnable) {
        if (post && customAttributesContentSrc === "post" && customAttributesMappedField) {
            var postFieldValue = getPostStringByMappedValue(post, customAttributesMappedField);
            if (postFieldValue && postFieldValue !== "") {
                return {
                    "data-trackinfo": postFieldValue
                };
            }
        }
        if (post && customAttributesContentSrc === "custom" && customAttributesValue) {
            return {
                "data-trackinfo": customAttributesValue
            };
        }
    }
    return {};
}
/**
 * get post string value from text mapped value
 * @param {*} post
 * @param {*} obj
 * @param {*} field
 */ function getStringField(post, obj, pageResponse, field, overrides) {
    var ref;
    if (((ref = obj.content) === null || ref === void 0 ? void 0 : ref.inlineContent) && obj.content.inlineContent.safeInlineContent) {
        /**
     * Check first the contentSrc
     * If its customText we know we need to use the inlineContent
     * If its post we use the post content
     */ var contentSrc = components_getOverrideInlineContentValues("".concat(field, ".").concat(CONTENT_SRC_TEXT), {
            inlineContent: obj.content.inlineContent,
            overrides: overrides
        });
        if (contentSrc === textContentHelper_WRITE) {
            return components_getOverrideInlineContentValues("".concat(field, ".").concat(CUSTOM_TEXT), {
                inlineContent: obj.content.inlineContent,
                overrides: overrides
            });
        } else if (contentSrc === textContentHelper_CMS) {
            var mappedValue = components_getOverrideInlineContentValues("".concat(field, ".").concat(MAPPED_VALUE), {
                inlineContent: obj.content.inlineContent,
                overrides: overrides
            });
            if (mappedValue === null || mappedValue === void 0 ? void 0 : mappedValue.startsWith("$")) {
                var value = jsonpath_default().query(post, mappedValue);
                return value && value.length > 0 ? value[0] : "";
            }
            return mappedValue && cleanPath(post, mappedValue) || "";
        } else {
            var ref1;
            //contentSrc === CONTENT_PAGE
            var mappedValue1 = components_getOverrideInlineContentValues("".concat(field, ".").concat(MAPPED_VALUE), {
                inlineContent: obj.content.inlineContent,
                overrides: overrides
            });
            var postObj = ((ref1 = pageResponse.contentPage) === null || ref1 === void 0 ? void 0 : ref1.content) || contentPageHelper_DummyPost;
            if ((mappedValue1 === null || mappedValue1 === void 0 ? void 0 : mappedValue1.startsWith("$")) && postObj) {
                var value1 = jsonpath_default().query(postObj, mappedValue1);
                return value1 && value1.length > 0 ? value1[0] : "";
            }
            return mappedValue1 && cleanPath(postObj, mappedValue1) || "";
        }
    } else {
        var styles = obj.styles ? obj.styles : obj;
        // @ts-ignore TODO: styles should allways be of type Styles, using the obj gives the SingleObject type
        var template = styles.bobs && styles.bobs[field] ? styles.bobs[field] : styles;
        if (template.mappedValue === "customText") return template.customText;
        var mappedValueCheck = "mappedValue";
        if (!template.mappedValue && template.mappedvalue) {
            mappedValueCheck = "mappedvalue";
        }
        if (template && template[mappedValueCheck]) {
            if (template[mappedValueCheck].startsWith("$")) {
                var value2 = jsonpath_default().query(post, template[mappedValueCheck]);
                return value2 && value2.length > 0 ? value2[0] : "";
            }
            return cleanPath(post, template[mappedValueCheck]) || "";
        }
        return "Missing Bob Text";
    }
}
/**
 * get post string value from text mapped value
 * @param {*} post
 * @param {*} obj
 * @param {*} field
 */ function getStringFieldV2(post, obj, pageResponse, field, overrides) {
    /**
   * Check first the contentSrc
   * If its customText we know we need to use the inlineContent
   * If its post we use the post content
   */ var contentSrc = components_getOverrideInlineContentValues("".concat(field, ".").concat(CONTENT_SRC_TEXT), {
        inlineContent: obj.content.inlineContent,
        overrides: overrides
    });
    if (contentSrc === textContentHelper_WRITE) {
        return components_getOverrideInlineContentValues("".concat(field, ".").concat(CUSTOM_TEXT), {
            inlineContent: obj.content.inlineContent,
            overrides: overrides
        });
    } else if (contentSrc === textContentHelper_CMS) {
        var mappedValue = components_getOverrideInlineContentValues("".concat(field, ".").concat(MAPPED_VALUE), {
            inlineContent: obj.content.inlineContent,
            overrides: overrides
        });
        if (mappedValue === null || mappedValue === void 0 ? void 0 : mappedValue.startsWith("$")) {
            var value = jsonpath_default().query(post, mappedValue);
            return value && value.length > 0 ? value[0] : "";
        }
        return mappedValue && cleanPath(post, mappedValue) || "";
    } else {
        var ref;
        //contentSrc === CONTENT_PAGE
        var mappedValue1 = components_getOverrideInlineContentValues("".concat(field, ".").concat(MAPPED_VALUE), {
            inlineContent: obj.content.inlineContent,
            overrides: overrides
        });
        var postObj = ((ref = pageResponse.contentPage) === null || ref === void 0 ? void 0 : ref.content) || contentPageHelper_DummyPost;
        if ((mappedValue1 === null || mappedValue1 === void 0 ? void 0 : mappedValue1.startsWith("$")) && postObj) {
            var value1 = jsonpath_default().query(postObj, mappedValue1);
            return value1 && value1.length > 0 ? value1[0] : "";
        }
        return mappedValue1 && cleanPath(postObj, mappedValue1) || "";
    }
}
/**
 *
 * @param formFieldProp
 * @param form
 * @param field
 * @param content
 * @returns
 */ function getFormField(form, formFieldProp, content, bobProp) {
    var formField = content.inlineContent["".concat(bobProp, ".formField")];
    var fieldValue = formField && (form === null || form === void 0 ? void 0 : form.fields[formField][formFieldProp]);
    return fieldValue ? fieldValue : "";
// TODO: backend is not handling contentSrc for now
// let placeholder = content.inlineContent[`${bobProp}.${formFieldProp}`]
// if (
//   getOverrideInlineContentValues(`${bobProp}.contentSrc`, {
//     inlineContent: content.inlineContent,
//     overrides: content.overrides,
//   }) === FORM
// ) {
//   const formField: string = content.inlineContent[`${bobProp}.formField`]
//   placeholder = form?.fields[formField][formFieldProp]
// }
// return placeholder
}
function getFormProp(form, formFieldProp, content, bobProp) {
    return (form === null || form === void 0 ? void 0 : form[formFieldProp]) || "";
// TODO: backend is not handling contentSrc for now
// let placeholder = content.inlineContent[`${bobProp}.${formFieldProp}`]
// if (
//   getOverrideInlineContentValues(`${bobProp}.contentSrc`, {
//     inlineContent: content.inlineContent,
//     overrides: content.overrides,
//   }) === FORM
// ) {
//   placeholder = form?.[formFieldProp]
// }
// return placeholder
}
/**
 * get post string value from media mapped value
 * @param {*} post
 * @param {*} obj
 * @param {*} field
 */ function components_getMediaStringField(post, content, field, overrides) {
    var bobContent = getOverrideInlineContentString("".concat(field, ".image-mappedValue"), {
        inlineContent: content,
        overrides: overrides
    });
    var contentSrc = getOverrideInlineContentString("".concat(field, ".contentSrc"), {
        inlineContent: content,
        overrides: overrides
    });
    if (contentSrc === "custom") {
        return getOverrideInlineContentString("".concat(field, ".src"), {
            inlineContent: content,
            overrides: overrides
        });
    }
    if (bobContent) {
        if (bobContent.startsWith("$")) {
            var value = jsonpath_default().query(post, bobContent);
            return stringOrUndefined(value && value.length > 0 ? value[0] : undefined);
        }
        return stringOrUndefined(cleanPath(post, bobContent));
    }
    return "Missing Bob Text";
}
/**
 * Check if an object is the root of the objects tree
 *
 * @param {*} objectType
 */ function isRootObject(objectType) {
    return objectType === "pageRoot" || objectType === "objectTemplate" || objectType === "symbol";
}
/**
 * get object from different list based on object type
 *
 * @param {*} parentObject
 * @param {*} objectId
 * @param {*} pageResponse
 */ // TODO: seperate functions for singleObject/instance
function handleObjectType(parentObject, objectId, pageResponse, emEditorType) {
    if (emEditorType === "symbol") {
        return pageResponse.objects[objectId];
    }
    if (parentObject.fromSymbolTree || parentObject.isInstanceOf) {
        var symbol = cloneDeep_default()(pageResponse.symbols[parentObject.fromSymbolTree || parentObject.isInstanceOf]);
        var instance = pageResponse.objects[parentObject.selectedInstanceId || parentObject.uuid];
        symbol.objects = handleInstanceOverrides(instance, symbol.objects);
        return symbol.objects[objectId];
    }
    return pageResponse.objects[objectId];
}
/**
 * use instance coorresponding symbol object
 * used in componentHandler main rende, TODO: review
 *
 * @param {*} obj
 * @param {*} pageResponse
 */ // TODO: seperate functions for singleObject/instance
function handleInstanceObject(obj, pageResponse) {
    if (obj.type === "instance") {
        var symbol = cloneDeep_default()(pageResponse.symbols[obj.isInstanceOf]);
        var symbolObj = symbols_handleFilterSymbolObject(obj, pageResponse.symbols, symbol);
        obj = handleInstanceOverrides(obj, undefined, symbolObj);
    }
    return obj;
}
/**
 * for symbol objects use complex uri
 * @param {*} obj
 */ function handleObjectUri(obj) {
    if (obj.fromSymbolTree && obj.selectedInstanceId) {
        return "".concat(obj.uri, "_").concat(obj.selectedInstanceId);
    }
    var _uri;
    return (_uri = obj.uri) !== null && _uri !== void 0 ? _uri : "";
}
/**
 * Check wich objects list to use
 * If we'r dealing with normal objects use the objects list
 * If we'r dealing we symbol objects use the symbols list
 * @param {*} pageObj
 * @param {*} object
 */ function components_handleObjectsListType(pageObj, object, emEditorType) {
    if (emEditorType === "symbol") return pageObj.objects;
    return object.fromSymbolTree ? pageObj.symbols[object.fromSymbolTree].objects : pageObj.objects;
}
function handlePostLink(mappedValue, post) {
    if (post && mappedValue && mappedValue.startsWith("$")) {
        var value = jsonpath_default().query(post, mappedValue);
        return value && value.length > 0 ? value[0] : "";
    }
    return undefined;
}
function getCPMappedValue(mappedValue, post) {
    var cuttedMappedValue = mappedValue.slice(0, -3);
    //TODO get content from post or content page
    if (post && cuttedMappedValue && cuttedMappedValue.startsWith("$")) {
        var value = jsonpath_default().query(post, cuttedMappedValue);
        return value && value.length > 0 ? value[0] : "";
    }
    return undefined;
}
/**
 * Returns true if obj has componentX as a child
 * @param {*} childName
 * @param {*} childsList
 * @param {*} obj
 * @param {*} pageResponse
 */ function hasChildOfType(childName, childsList, obj, pageResponse, emEditorType) {
    var childsOfType = childsList.filter(function(componentId) {
        //First we get all the object childrens
        var objectById = handleObjectType(obj, componentId, pageResponse, emEditorType);
        var objectStyleComponentId;
        //We then need to check if its an instance or not, to properly get its style component Id
        if (objectById.isInstanceOf) {
            //Go to symbols
            var symbolTree = pageResponse.symbols[objectById.isInstanceOf];
            //Return the style Id
            objectStyleComponentId = symbolTree.objects[symbolTree.rootId].styles.component;
        } else {
            //Return the style Id
            objectStyleComponentId = objectById.styles.component;
        }
        return pageResponse.components[objectStyleComponentId].name === childName;
    });
    return childsOfType.length > 0;
}
/**
 * forceWrite is used to write the css rules even
 * if there are no css props to write inside the rule,
 * used in the controller for example
 * @param bobTemplate
 * @param bobType
 * @param objectId
 * @param forceWrite
 * @returns
 */ // TODO: Styles bob type should be completed
function writeCustomCssSelectors(bobTemplate, bobType, objectId, forceWrite) {
    var ref, ref1, ref2, ref3;
    var defaultCss = bobTemplate === null || bobTemplate === void 0 ? void 0 : (ref = bobTemplate.customCss) === null || ref === void 0 ? void 0 : ref.default;
    var mobileCss = bobTemplate === null || bobTemplate === void 0 ? void 0 : (ref1 = bobTemplate.customCss) === null || ref1 === void 0 ? void 0 : ref1.mobile;
    var tabletCss = bobTemplate === null || bobTemplate === void 0 ? void 0 : (ref2 = bobTemplate.customCss) === null || ref2 === void 0 ? void 0 : ref2.tablet;
    var desktopCss = bobTemplate === null || bobTemplate === void 0 ? void 0 : (ref3 = bobTemplate.customCss) === null || ref3 === void 0 ? void 0 : ref3.desktop;
    var mobileMediaQuery = "@media all and (max-width: 768px)";
    var tabletMediaQuery = "@media all and (max-width: 992px) and (min-width: 767px)";
    var desktopMediaQuery = "@media all and (min-width: 992px)";
    if (bobType.startsWith("background")) {
        var backgroundCssProperties = {
            default: {
                container: forceWrite || (defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.container) ? "#".concat(objectId, "{\n").concat((defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.container) || "", "\n}") : "",
                innerContainer: forceWrite || (defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.innerContainer) ? "#".concat(objectId, " > .").concat(bobTemplate.wrap, "{\n").concat((defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.innerContainer) || "", "\n}") : ""
            },
            mobile: {
                container: forceWrite || (mobileCss === null || mobileCss === void 0 ? void 0 : mobileCss.container) ? "".concat(mobileMediaQuery, "{\n  #").concat(objectId, "{\n").concat((mobileCss === null || mobileCss === void 0 ? void 0 : mobileCss.container) || "", "\n  }\n}") : "",
                innerContainer: forceWrite || (mobileCss === null || mobileCss === void 0 ? void 0 : mobileCss.innerContainer) ? "".concat(mobileMediaQuery, "{\n  #").concat(objectId, " > .").concat(bobTemplate.wrap, "{\n").concat((mobileCss === null || mobileCss === void 0 ? void 0 : mobileCss.innerContainer) || "", "\n  }\n}") : ""
            },
            tablet: {
                container: forceWrite || (tabletCss === null || tabletCss === void 0 ? void 0 : tabletCss.container) ? "".concat(tabletMediaQuery, "{\n  #").concat(objectId, "{\n").concat((tabletCss === null || tabletCss === void 0 ? void 0 : tabletCss.container) || "", "\n  }\n}") : "",
                innerContainer: forceWrite || (tabletCss === null || tabletCss === void 0 ? void 0 : tabletCss.innerContainer) ? "".concat(tabletMediaQuery, "{\n  #").concat(objectId, " > .").concat(bobTemplate.wrap, "{\n").concat((tabletCss === null || tabletCss === void 0 ? void 0 : tabletCss.innerContainer) || "", "\n  }\n}") : ""
            },
            desktop: {
                container: forceWrite || (desktopCss === null || desktopCss === void 0 ? void 0 : desktopCss.container) ? "".concat(desktopMediaQuery, "{\n  #").concat(objectId, "{\n").concat((desktopCss === null || desktopCss === void 0 ? void 0 : desktopCss.container) || "", "\n  }\n}") : "",
                innerContainer: forceWrite || (desktopCss === null || desktopCss === void 0 ? void 0 : desktopCss.innerContainer) ? "".concat(desktopMediaQuery, "{\n  #").concat(objectId, " > .").concat(bobTemplate.wrap, "{\n").concat((desktopCss === null || desktopCss === void 0 ? void 0 : desktopCss.innerContainer) || "", "\n  }\n}") : ""
            }
        };
        return backgroundCssProperties;
    }
    if (bobType.startsWith("media")) {
        var mediaCssProperties = {
            default: {
                container: forceWrite || (defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.container) ? "#".concat(objectId, "{\n").concat((defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.container) || "", "\n}") : "",
                image: forceWrite || (defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.image) ? "#".concat(objectId, " > img{\n").concat((defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.image) || "", "\n}") : ""
            },
            mobile: {
                container: forceWrite || (mobileCss === null || mobileCss === void 0 ? void 0 : mobileCss.container) ? "".concat(mobileMediaQuery, "{\n  #").concat(objectId, "{\n").concat((mobileCss === null || mobileCss === void 0 ? void 0 : mobileCss.container) || "", "\n  }\n}") : "",
                image: forceWrite || (mobileCss === null || mobileCss === void 0 ? void 0 : mobileCss.image) ? "".concat(mobileMediaQuery, "{\n  #").concat(objectId, " > img{\n").concat((mobileCss === null || mobileCss === void 0 ? void 0 : mobileCss.image) || "", "\n  }\n}") : ""
            },
            tablet: {
                container: forceWrite || (tabletCss === null || tabletCss === void 0 ? void 0 : tabletCss.container) ? "".concat(tabletMediaQuery, "{\n  #").concat(objectId, "{\n").concat((tabletCss === null || tabletCss === void 0 ? void 0 : tabletCss.container) || "", "\n  }\n}") : "",
                image: forceWrite || (tabletCss === null || tabletCss === void 0 ? void 0 : tabletCss.image) ? "".concat(tabletMediaQuery, "{\n  #").concat(objectId, " > img{\n").concat((tabletCss === null || tabletCss === void 0 ? void 0 : tabletCss.image) || "", "\n  }\n}") : ""
            },
            desktop: {
                container: forceWrite || (desktopCss === null || desktopCss === void 0 ? void 0 : desktopCss.container) ? "".concat(desktopMediaQuery, "{\n  #").concat(objectId, "{\n").concat((desktopCss === null || desktopCss === void 0 ? void 0 : desktopCss.container) || "", "\n  }\n}") : "",
                image: forceWrite || (desktopCss === null || desktopCss === void 0 ? void 0 : desktopCss.image) ? "".concat(desktopMediaQuery, "{\n  #").concat(objectId, " > img{\n").concat((desktopCss === null || desktopCss === void 0 ? void 0 : desktopCss.image) || "", "\n  }\n}") : ""
            }
        };
        return mediaCssProperties;
    }
    if (bobType.startsWith("text")) {
        var textCssProperties = {
            default: {
                text: forceWrite || (defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.text) ? "#".concat(objectId, "{\n").concat((defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.text) || "", "\n}") : ""
            },
            mobile: {
                text: forceWrite || (mobileCss === null || mobileCss === void 0 ? void 0 : mobileCss.text) ? "".concat(mobileMediaQuery, "{\n  #").concat(objectId, "{\n").concat((mobileCss === null || mobileCss === void 0 ? void 0 : mobileCss.text) || "", "\n  }\n}") : ""
            },
            tablet: {
                text: forceWrite || (tabletCss === null || tabletCss === void 0 ? void 0 : tabletCss.text) ? "".concat(tabletMediaQuery, "{\n  #").concat(objectId, "{\n").concat((tabletCss === null || tabletCss === void 0 ? void 0 : tabletCss.text) || "", "\n  }\n}") : ""
            },
            desktop: {
                text: forceWrite || (desktopCss === null || desktopCss === void 0 ? void 0 : desktopCss.text) ? "".concat(desktopMediaQuery, "{\n  #").concat(objectId, "{\n").concat((desktopCss === null || desktopCss === void 0 ? void 0 : desktopCss.text) || "", "\n  }\n}") : ""
            }
        };
        return textCssProperties;
    }
    if (bobType.startsWith("icon")) {
        var iconCssProperties = {
            default: {
                container: forceWrite || (defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.container) ? "#".concat(objectId, "{\n").concat((defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.container) || "", "\n}") : "",
                icon: forceWrite || (defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.icon) ? "#".concat(objectId, " > .bob-icon{\n").concat((defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.icon) || "", "\n}") : ""
            },
            mobile: {
                container: forceWrite || (mobileCss === null || mobileCss === void 0 ? void 0 : mobileCss.container) ? "".concat(mobileMediaQuery, "{\n  #").concat(objectId, "{\n").concat((mobileCss === null || mobileCss === void 0 ? void 0 : mobileCss.container) || "", "\n  }\n}") : "",
                icon: forceWrite || (mobileCss === null || mobileCss === void 0 ? void 0 : mobileCss.icon) ? "".concat(mobileMediaQuery, "{\n  #").concat(objectId, " > .bob-icon{\n").concat((mobileCss === null || mobileCss === void 0 ? void 0 : mobileCss.icon) || "", "\n  }\n}") : ""
            },
            tablet: {
                container: forceWrite || (tabletCss === null || tabletCss === void 0 ? void 0 : tabletCss.container) ? "".concat(tabletMediaQuery, "{\n  #").concat(objectId, "{\n").concat((tabletCss === null || tabletCss === void 0 ? void 0 : tabletCss.container) || "", "\n  }\n}") : "",
                icon: forceWrite || (tabletCss === null || tabletCss === void 0 ? void 0 : tabletCss.icon) ? "".concat(tabletMediaQuery, "{\n  #").concat(objectId, " > .bob-icon{\n").concat((tabletCss === null || tabletCss === void 0 ? void 0 : tabletCss.icon) || "", "\n  }\n}") : ""
            },
            desktop: {
                container: forceWrite || (desktopCss === null || desktopCss === void 0 ? void 0 : desktopCss.container) ? "".concat(desktopMediaQuery, "{\n  #").concat(objectId, "{\n").concat((desktopCss === null || desktopCss === void 0 ? void 0 : desktopCss.container) || "", "\n  }\n}") : "",
                icon: forceWrite || (desktopCss === null || desktopCss === void 0 ? void 0 : desktopCss.icon) ? "".concat(desktopMediaQuery, "{\n  #").concat(objectId, " > .bob-icon{\n").concat((desktopCss === null || desktopCss === void 0 ? void 0 : desktopCss.icon) || "", "\n  }\n}") : ""
            }
        };
        return iconCssProperties;
    }
    return "";
}
function handleVerticalAlign(verticalAlign) {
    var verticalStyle = {
        display: "flex !important",
        justifyContent: "center !important",
        flexDirection: "column !important",
        alignSelf: "center !important"
    };
    if (!verticalAlign) return verticalStyle;
    if (verticalAlign === "middle") {
        return verticalStyle;
    }
    if (verticalAlign === "top") {
        verticalStyle.justifyContent = "flex-start !important";
        verticalStyle.alignSelf = "flex-start !important";
        return verticalStyle;
    }
    if (verticalAlign === "bottom") {
        verticalStyle.justifyContent = "flex-end !important";
        verticalStyle.alignSelf = "flex-end !important";
        return verticalStyle;
    }
}
function components_getOverrideInlineContentValues(inlineField, content) {
    var ref, ref1;
    var ref2;
    return (ref2 = (ref = content.overrides) === null || ref === void 0 ? void 0 : (ref1 = ref.inlineContent) === null || ref1 === void 0 ? void 0 : ref1[inlineField]) !== null && ref2 !== void 0 ? ref2 : content.inlineContent[inlineField];
}
function getOverrideInlineContentString(inlineField, content) {
    var ref, ref1;
    var ref2;
    return stringOrUndefined((ref2 = (ref = content.overrides) === null || ref === void 0 ? void 0 : (ref1 = ref.inlineContent) === null || ref1 === void 0 ? void 0 : ref1[inlineField]) !== null && ref2 !== void 0 ? ref2 : content.inlineContent[inlineField]);
}
function components_getResponsiveOverrideInlineContentValues(inlineField, content) {
    var ref, ref1;
    var ref2;
    return (ref2 = (ref = content.overrides) === null || ref === void 0 ? void 0 : (ref1 = ref.inlineContent) === null || ref1 === void 0 ? void 0 : ref1[inlineField]) !== null && ref2 !== void 0 ? ref2 : content.inlineContent[inlineField];
}
function handleComponentLinks(inlineContent, bobKey, pageResponse, overrides, post) {
    var url = components_getOverrideInlineContentValues("".concat(bobKey, ".behaviour-link-customUrl"), {
        inlineContent: inlineContent,
        overrides: overrides
    });
    var action = components_getOverrideInlineContentValues("".concat(bobKey, ".behaviour-link-mappedValue"), {
        inlineContent: inlineContent,
        overrides: overrides
    });
    if (action) {
        var ref;
        /**
     * If it ends with -cp it means we have to use info related to the content page
     */ var postLink = action.endsWith("-cp") ? getCPMappedValue(action, (ref = pageResponse.contentPage) === null || ref === void 0 ? void 0 : ref.content) : handlePostLink(action, post);
        if (url || postLink) {
            if (action === "page") {
                return "/".concat(url);
            }
            if (action === "custom") {
                if (url && (url.startsWith("//") || url.startsWith("/") || url.startsWith("http") || url.startsWith("mailto"))) return "".concat(url);
                return "//".concat(url);
            }
            return postLink ? postLink : url;
        }
    }
    return undefined;
}
function handleLeanSettings(template) {
    var lean = template.lean;
    if (!lean.enable) return "none";
    var leanClipPath = "polygon(".concat(lean.topleftx, "% ").concat(lean.toplefty, "%, ").concat(lean.toprightx, "% ").concat(lean.toprighty, "%, ").concat(lean.bottomrightx, "% ").concat(lean.bottomrighty, "%, ").concat(lean.bottomleftx, "% ").concat(lean.bottomlefty, "%) !important");
    return leanClipPath;
}
function handleAlignment(template, flexDirection) {
    var self = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!template.alignment) return {};
    var horizontalValue = template.alignment.horizontal === "left" ? "flex-start" : template.alignment.horizontal === "right" ? "flex-end" : template.alignment.horizontal;
    var verticalValue = template.alignment.vertical === "top" ? "flex-start" : template.alignment.vertical === "bottom" ? "flex-end" : template.alignment.vertical;
    return {
        justifyContent: flexDirection === "column" ? verticalValue : horizontalValue,
        alignItems: flexDirection === "column" ? horizontalValue : verticalValue,
        alignSelf: self && flexDirection === "column" ? horizontalValue : verticalValue,
        display: "flex",
        flexDirection: flexDirection
    };
}
function handleTemplateNulls(template, defaultTemplate, prop) {
    if (defaultTemplate && prop) {
        for(var key in defaultTemplate[prop]){
            if (!template.hasOwnProperty(key) || template[key] === null) {
                template[key] = defaultTemplate[prop][key];
            }
        }
    }
    return template;
}
function handleHeight(template, defaultTemplate) {
    // no height prop
    if (!template.height) return {
        height: ""
    };
    var heightTemplate = (0,src_object_spread/* default */.Z)({}, template.height);
    // when nulls exist they must fallback to default template value
    heightTemplate = handleTemplateNulls(heightTemplate, defaultTemplate, "height");
    // enable is off
    if (!heightTemplate.enable) {
        return {
            height: "auto !important"
        };
    }
    var height = "".concat(heightTemplate.value).concat(heightTemplate.unit, " !important");
    return {
        height: height
    };
}
function handleWidth(template, defaultTemplate) {
    // no height prop
    if (!template.width) return {
        width: ""
    };
    var widthTemplate = _object_spread({}, template.width);
    // when nulls exist they must fallback to default template value
    widthTemplate = handleTemplateNulls(widthTemplate, defaultTemplate, "width");
    // enable is off
    if (!widthTemplate.enable) {
        return {
            width: "auto !important"
        };
    }
    var width = "".concat(widthTemplate.value).concat(widthTemplate.unit, " !important");
    return {
        width: width
    };
}
/**
 *
 * @param {*} template Object
 *
 */ function handleBondaries(template) {
    if (template && template.spacing && !template.spacing.enable) return {
        "margin-top": "0 !important",
        "margin-bottom": "0 !important",
        "margin-right": "0 !important",
        "margin-left": "0 !important",
        "padding-top": "0 !important",
        "padding-bottom": "0 !important",
        "padding-right": "0 !important",
        "padding-left": "0 !important"
    };
    var boundaryObj = template.spacing || template;
    var boundaryStyle = {};
    if (boundaryObj.margin) {
        for(var side in boundaryObj.margin){
            boundaryStyle = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, boundaryStyle), (0,src_define_property/* default */.Z)({}, "margin-".concat(side), boundaryObj.margin[side] + "px !important"));
        }
    }
    if (boundaryObj.padding) {
        for(var side1 in boundaryObj.padding){
            boundaryStyle = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, boundaryStyle), (0,src_define_property/* default */.Z)({}, "padding-".concat(side1), boundaryObj.padding[side1] + "px !important"));
        }
    }
    return boundaryStyle;
}
function capitalize(stringToUper) {
    if (typeof stringToUper !== "string") return "";
    return stringToUper.charAt(0).toUpperCase() + stringToUper.slice(1);
}
function handleBondaries_DEPRECATED(template) {
    if (template && template.spacing && !template.spacing.enable || template && !template.enable) return {
        marginTop: "0 !important",
        marginBottom: "0 !important",
        marginRright: "0 !important",
        marginLeft: "0 !important",
        paddingTop: "0 !important",
        paddingBottom: "0 !important",
        paddingRight: "0 !important",
        paddingLeft: "0 !important"
    };
    var boundaryObj = template.spacing || template;
    var boundaryStyle = {};
    if (boundaryObj.margin) {
        for(var side in boundaryObj.margin){
            boundaryStyle = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, boundaryStyle), (0,src_define_property/* default */.Z)({}, "margin".concat(capitalize(side)), boundaryObj.margin[side] + "px !important"));
        }
    }
    if (boundaryObj.padding) {
        for(var side1 in boundaryObj.padding){
            boundaryStyle = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, boundaryStyle), (0,src_define_property/* default */.Z)({}, "padding".concat(capitalize(side1)), boundaryObj.padding[side1] + "px !important"));
        }
    }
    return boundaryStyle;
}
function handleRadius(template, defaultTemplate) {
    if (!template.radius) return {
        borderRadius: ""
    };
    var radiusTemplate = (0,src_object_spread/* default */.Z)({}, template.radius);
    // when nulls exist they must fallback to default template value
    radiusTemplate = handleTemplateNulls(radiusTemplate, defaultTemplate, "radius");
    if (!radiusTemplate.enable) return {
        borderTopLeftRadius: "0 !important",
        borderTopRightRadius: "0 !important",
        borderBottomLeftRadius: "0 !important",
        borderBottomRightRadius: "0 !important"
    };
    var borderTopLeftRadius = "".concat(radiusTemplate.topLeft, "px !important");
    var borderTopRightRadius = "".concat(radiusTemplate.topRight, "px !important");
    var borderBottomLeftRadius = "".concat(radiusTemplate.bottomLeft, "px !important");
    var borderBottomRightRadius = "".concat(radiusTemplate.bottomRight, "px !important");
    return {
        borderTopLeftRadius: borderTopLeftRadius,
        borderTopRightRadius: borderTopRightRadius,
        borderBottomRightRadius: borderBottomRightRadius,
        borderBottomLeftRadius: borderBottomLeftRadius
    };
}
function handleBorder(template, defaultTemplate) {
    if (!template.border) return {
        borderTop: "",
        borderBottom: "",
        borderLeft: "",
        borderRight: ""
    };
    var borderTemplate = (0,src_object_spread/* default */.Z)({}, template.border);
    // when nulls exist they must fallback to default template value
    borderTemplate = handleTemplateNulls(borderTemplate, defaultTemplate, "border");
    if (!borderTemplate.enable) {
        /**
     * When the border is changed and the component is rerendered, if the property that
     * reads has the shortand "border: value", the next render must have the same value,
     * if the rendered value is now separated between top, bottom, left, right, react throws
     * a silent error, to prevent it, we send every border side separated.
     */ return {
            borderTop: "none !important",
            borderBottom: "none !important",
            borderLeft: "none !important",
            borderRight: "none !important"
        };
    }
    var borderTop = borderTemplate.topEnable ? "".concat(borderTemplate.topWidth, "px ").concat(borderTemplate.topStyle, " ").concat(borderTemplate.topColor, " !important") : "none !important";
    var borderRight = borderTemplate.rightEnable ? "".concat(borderTemplate.rightWidth, "px ").concat(borderTemplate.rightStyle, " ").concat(borderTemplate.rightColor, " !important") : "none !important";
    var borderBottom = borderTemplate.bottomEnable ? "".concat(borderTemplate.bottomWidth, "px ").concat(borderTemplate.bottomStyle, " ").concat(borderTemplate.bottomColor, " !important") : "none !important";
    var borderLeft = borderTemplate.leftEnable ? "".concat(borderTemplate.leftWidth, "px ").concat(borderTemplate.leftStyle, " ").concat(borderTemplate.leftColor, " !important") : "none !important";
    return {
        borderTop: borderTop,
        borderRight: borderRight,
        borderBottom: borderBottom,
        borderLeft: borderLeft
    };
}
function handleShadow(template, order, defaultTemplate) {
    if (!template.shadow) return {
        boxShadow: ""
    };
    var boxShadowTemplate = (0,src_object_spread/* default */.Z)({}, template.shadow);
    // when nulls exist they must fallback to default template value
    boxShadowTemplate = handleTemplateNulls(boxShadowTemplate, defaultTemplate, "shadow");
    if (template.hasOwnProperty("enable") && (!template.boxShadow || !template.boxShadow.enable) && !boxShadowTemplate.enable) return {
        boxShadow: "none !important"
    };
    var boxShadow;
    // LEGACY
    if (template.boxShadow) boxShadow = "".concat(template.boxShadow.inset ? "inset " : "").concat(template.boxShadow.offsetH, "px ").concat(template.boxShadow.offsetV, "px ").concat(template.boxShadow.blur, "px ").concat(template.boxShadow.spread, "px ").concat(template.boxShadow.color, " !important");
    if (boxShadowTemplate) boxShadow = "".concat(boxShadowTemplate.inset ? "inset " : "").concat(boxShadowTemplate.offsetH, "px ").concat(boxShadowTemplate.offsetV, "px ").concat(boxShadowTemplate.blur, "px ").concat(boxShadowTemplate.spread, "px ").concat(boxShadowTemplate.color, " !important");
    /**
   * Workaround for when the sibling is right under this object
   * and the shadow doesnt render hover it.
   */ if (order || order === 0) {
        var ref;
        var zIndex = 20 - order;
        if (zIndex <= 0) {
            zIndex = 1;
        }
        /**
     * When the scroll is enable we cant force position relative.
     * For this we must use the value for the scroll, since
     * its the selected option by the user
     */ return {
            boxShadow: boxShadow,
            position: ((ref = template.scroll) === null || ref === void 0 ? void 0 : ref.enable) ? template.scroll.value + " !important" : "relative !important",
            zIndex: zIndex + " !important"
        };
    }
    return {
        boxShadow: boxShadow
    };
}
function handleTextShadow(template, defaultTemplate) {
    // no shadow prop
    if (!template.shadow) return {
        textShadow: ""
    };
    var shadowTemplate = (0,src_object_spread/* default */.Z)({}, template.shadow);
    // when nulls exist they must fallback to default template value
    shadowTemplate = handleTemplateNulls(shadowTemplate, defaultTemplate, "shadow");
    // enable is off
    if (shadowTemplate.hasOwnProperty("enable") && !shadowTemplate.enable) {
        return {
            textShadow: "none !important"
        };
    }
    var textShadow = "".concat(shadowTemplate.offsetH, "px ").concat(shadowTemplate.offsetV, "px ").concat(shadowTemplate.blur, "px ").concat(shadowTemplate.color, " !important");
    return {
        textShadow: textShadow
    };
}
/**
 * Returns filter and overlay objects
 * Filter object should be aplied directly to an image/backgroundImage element
 * Overlay object should be aplied to an element that overlays the image
 */ function handleImageFilter(template, defaultTemplate) {
    // when filter is not present we must not write css
    // so that the default css is used instead and not overriten
    if (!template.filter) return {
        filter: {
            WebkitFilter: "",
            filter: ""
        },
        overlay: {
            backgroundColor: ""
        }
    };
    var filterTemplate = (0,src_object_spread/* default */.Z)({}, template.filter);
    // when nulls exist they must fallback to default template value
    filterTemplate = handleTemplateNulls(filterTemplate, defaultTemplate, "filter");
    // filter is disabled
    if ((!template.image || !template.image.filterEnable) && !filterTemplate.enable) return {
        filter: {
            WebkitFilter: "none !important",
            filter: "none !important"
        },
        overlay: {
            backgroundColor: "transparent !important"
        }
    };
    // filter is enabled
    var imageFilter = "";
    var colorOverlay;
    // LEGACY
    if (template.image) {
        var blur = "".concat(template.image.filterBlur && template.image.filterBlur !== 0 ? "blur(".concat(template.image.filterBlur, "px)") : "");
        var opacity = "".concat(template.image.filterOpacity && template.image.filterOpacity !== 0 ? "opacity(".concat(template.image.filterOpacity, "%)") : "");
        var brightness = "".concat(template.image.filterBrightness ? "brightness(".concat(template.image.filterBrightness, "%)") : "");
        var contrast = "".concat(template.image.filterContrast ? "contrast(".concat(template.image.filterContrast, "%)") : "");
        var grayscale = "".concat(template.image.filterGrayscale && template.image.filterGrayscale !== 0 ? "grayscale(".concat(template.image.filterGrayscale, "%)") : "");
        var hueRotate = "".concat(template.image.filterHueRotate && template.image.filterHueRotate !== 0 ? "hue-rotate(".concat(template.image.filterHueRotate, "deg)") : "");
        var invert = "".concat(template.image.filterInvert && template.image.filterInvert !== 0 ? "invert(".concat(template.image.filterInvert, "%)") : "");
        var saturate = "".concat(template.image.filterSaturate && template.image.filterSaturate !== 0 ? "saturate(".concat(template.image.filterSaturate, "%)") : "");
        var sepia = "".concat(template.image.filterSepia && template.image.filterSepia !== 0 ? "sepia(".concat(template.image.filterSepia, "%)") : "");
        var shadow = "".concat(template.image.filterShadow && template.image.filterShadow !== 0 ? "box-shadow(".concat(template.image.filterShadow, "%)") : "");
        if (blur && blur !== "" || brightness && brightness !== "" || opacity && opacity !== "" || contrast && contrast !== "" || grayscale && grayscale !== "" || hueRotate && hueRotate !== "" || invert && invert !== "" || saturate && saturate !== "" || sepia && sepia !== "" || shadow && shadow !== "") imageFilter = "".concat(blur, " ").concat(opacity, " ").concat(brightness, " ").concat(contrast, " ").concat(grayscale, " ").concat(hueRotate, " ").concat(invert, " ").concat(saturate, " ").concat(sepia, " ").concat(shadow, " !important");
        colorOverlay = "".concat(template.image.filterOverlay && template.image.filterOverlay !== "" ? template.image.filterOverlay + " !important" : "");
    }
    // NEW VERSION
    if (filterTemplate) {
        var blur1 = "".concat(filterTemplate.blur || filterTemplate.blur === 0 ? "blur(".concat(filterTemplate.blur, "px)") : "");
        // let opacity = `${filterTemplate.opacity || filterTemplate.opacity === 0 ? `opacity(${filterTemplate.opacity}%)` : ``}`
        var brightness1 = "".concat(filterTemplate.brightness ? "brightness(".concat(filterTemplate.brightness, "%)") : "");
        var contrast1 = "".concat(filterTemplate.contrast ? "contrast(".concat(filterTemplate.contrast, "%)") : "");
        var grayscale1 = "".concat(filterTemplate.grayscale || filterTemplate.grayscale === 0 ? "grayscale(".concat(filterTemplate.grayscale, "%)") : "");
        var hueRotate1 = "".concat(filterTemplate.hueRotate || filterTemplate.hueRotate === 0 ? "hue-rotate(".concat(filterTemplate.hueRotate, "deg)") : "");
        var invert1 = "".concat(filterTemplate.invert || filterTemplate.invert === 0 ? "invert(".concat(filterTemplate.invert, "%)") : "");
        var saturate1 = "".concat(filterTemplate.saturate || filterTemplate.saturate === 0 ? "saturate(".concat(filterTemplate.saturate, "%)") : "");
        var sepia1 = "".concat(filterTemplate.sepia || filterTemplate.sepia === 0 ? "sepia(".concat(filterTemplate.sepia, "%)") : "");
        // let shadow = `${filterTemplate.shadow && filterTemplate.shadow !== 0 ? `box-shadow(${filterTemplate.shadow}%)` : ``}`
        if (blur1 && blur1 !== "" || brightness1 && brightness1 !== "" || contrast1 && contrast1 !== "" || grayscale1 && grayscale1 !== "" || hueRotate1 && hueRotate1 !== "" || invert1 && invert1 !== "" || saturate1 && saturate1 !== "" || sepia1 && sepia1 !== "") imageFilter = "".concat(blur1, " ").concat(brightness1, " ").concat(contrast1, " ").concat(grayscale1, " ").concat(hueRotate1, " ").concat(invert1, " ").concat(saturate1, " ").concat(sepia1, "  !important");
        colorOverlay = "".concat(template.filter.overlay && template.filter.overlay !== "" ? template.filter.overlay + " !important" : "");
    }
    return {
        filter: {
            WebkitFilter: imageFilter,
            filter: imageFilter
        },
        overlay: {
            backgroundColor: colorOverlay
        }
    };
}
function handleBackgroundColor(template, foundationStyle, defaultTemplate) {
    // TODO: handle foundationStyle type when added to other bobs
    // no color prop
    // gradient must be false
    if (!template.colors || template.colors && template.colors.isGradient) return {
        backgroundColor: ""
    };
    var backgroundColorTemplate = (0,src_object_spread/* default */.Z)({}, template.colors);
    // when nulls exist they must fallback to default template value
    backgroundColorTemplate = handleTemplateNulls(backgroundColorTemplate, defaultTemplate, "colors");
    // enable is off
    if (!backgroundColorTemplate.enable) {
        return {
            backgroundColor: "transparent !important"
        };
    }
    // const color = foundationStyle ? foundationStyle.color : backgroundColorTemplate.colorFirst
    var color = backgroundColorTemplate.colorFirst;
    var backgroundColor = "".concat(color, " !important");
    return {
        backgroundColor: backgroundColor
    };
}
function handleBackgroundImage(template, defaultTemplate, imageSrc, foundationStyle // TODO: fix when aplyint to other bobs
) {
    var backgroundImage;
    var backgroundImageTemplate = template.image || {};
    var backgroundColorsTemplate = template.colors || {};
    // no image prop
    if (!template.image) backgroundImage = "";
    // image styles
    if (template.image && imageSrc && imageSrc !== "") {
        backgroundImageTemplate = (0,src_object_spread/* default */.Z)({}, template.image);
        // when nulls exist they must fallback to default template value
        backgroundImageTemplate = handleTemplateNulls(backgroundImageTemplate, defaultTemplate, "image");
        backgroundImage = "url(".concat(imageSrc, ") !important");
    }
    // gradient styles, may combine gradient and image style together
    if (template.colors) {
        backgroundColorsTemplate = (0,src_object_spread/* default */.Z)({}, template.colors);
        // when nulls exist they must fallback to default template value
        backgroundColorsTemplate = handleTemplateNulls(backgroundColorsTemplate, defaultTemplate, "colors");
        if (backgroundColorsTemplate.isGradient) // ${foundationStyle?.[0] ? foundationStyle[0].color : backgroundColorsTemplate.colorFirst},
        //     ${foundationStyle?.[1] ? foundationStyle[1].color : backgroundColorsTemplate.colorSecond})
        backgroundImage = "linear-gradient(\n        ".concat(backgroundColorsTemplate.gradientAngle ? backgroundColorsTemplate.gradientAngle : 0, "deg,           \n        ").concat(backgroundColorsTemplate.colorFirst, ", \n        ").concat(backgroundColorsTemplate.colorSecond, ")\n        ").concat(backgroundImageTemplate.enable ? ", url(".concat(imageSrc, ")") : "", " !important");
    }
    // enable is off
    if (!backgroundImageTemplate.enable && !backgroundColorsTemplate.isGradient) {
        return {
            backgroundImage: "none !important"
        };
    }
    return {
        backgroundImage: backgroundImage
    };
}
function handleBackground(template) {
    var backgroundRepeat = template.background.repeat;
    var backgroundSize = template.background.size;
    var backgroundPosition = template.background.position;
    var minHeight = template.background.height + "vh";
    var objectFit = template.background.size;
    var objectPosition = template.background.position;
    var backgroundImage = {
        minHeight: minHeight,
        backgroundRepeat: backgroundRepeat,
        backgroundPosition: backgroundPosition,
        backgroundSize: backgroundSize
    };
    var img = {
        minHeight: minHeight,
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    return {
        backgroundImage: backgroundImage,
        img: img
    };
}
function handleFlow(template, expManager) {
    var ref, ref1, ref2, ref3;
    //When inside EM we dont fix the navbar
    // fixed, magnetic, static
    // LEGACY
    if (expManager || !((ref = template.scroll) === null || ref === void 0 ? void 0 : ref.enable)) {
        return {
            position: "static !important"
        };
    } else if (template.flow === "fixed" || ((ref1 = template.scroll) === null || ref1 === void 0 ? void 0 : ref1.value) === "fixed") {
        var ref4;
        return {
            position: "fixed !important",
            zIndex: "999 !important",
            width: "100% !important",
            top: ((ref4 = template.scroll) === null || ref4 === void 0 ? void 0 : ref4.value) ? "0 !important" : undefined
        };
    } else if (template.flow === "magnetic" || ((ref2 = template.scroll) === null || ref2 === void 0 ? void 0 : ref2.value) === "magnetic") {
        return {
            position: "sticky !important",
            top: "0 !important",
            zIndex: "999 !important"
        };
    } else if (template.flow === "static" || ((ref3 = template.scroll) === null || ref3 === void 0 ? void 0 : ref3.value) === "static") {
        return {
            position: "static !important"
        };
    }
    return {
        position: "static !important"
    };
}
/**
 * handle column gutters
 * @param {*} template bob template
 * @param {*} noGuttersDefault tells if the bob html element has no-gutters by default
 */ function handleGutts(template, noGuttersDefault) {
    /**
   * when gutters prop doenst exist
   * we want to use the FE defaults
   */ if (!template.grid.hasOwnProperty("gutters")) return !noGuttersDefault ? "" : "no-gutters";
    // else use the gutters value
    return "".concat(template.grid.gutters ? "" : "no-gutters");
}
/**
 * Builds import statement for google fonts
 * @param {*} template
 * @param {*} fontWeight
 * @param {*} isPublic
 */ function dynamicFontLoader(template, fontWeight, label) {
    var isPublic = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, isStateTemplate = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    /**
   * Legacy check due to old components, fontType may not exist
   */ if (template.hasOwnProperty("fontType") && template.fontType !== "google-fonts" && !isStateTemplate) return "";
    if (!template.fontFamily) return "";
    var weightsString, fontWeightString = isPublic ? "wght@300,400,700,900" : "wght@100,200,300,400,500,600,700,800,900";
    var italWght = "";
    var nonItalWght = "";
    if (fontWeight && isPublic) {
        weightsString = "ital,wght@";
        fontWeight.forEach(function(element) {
            if (element.italic) {
                italWght += "".concat(italWght === "" ? "" : ",", "1,") + element.weight;
            } else {
                nonItalWght += "".concat(nonItalWght === "" ? "" : ",", "0,") + element.weight;
            }
        });
        weightsString += nonItalWght + "".concat(nonItalWght && italWght ? "," : "") + italWght;
    }
    return "@import url('https://fonts.bunny.net/css?family=".concat((label === null || label === void 0 ? void 0 : label.fontFamily) || template.fontFamily, ":").concat(weightsString ? weightsString : fontWeightString, "&display=swap');");
}
function clearFont(font) {
    if (font) {
        var noPlus = font.replace("+", " ");
        return noPlus.split(":")[0];
    }
    return "Roboto";
}
/**
 * build an object with the google fonts families as keys
 * so that it's lighter when searching for a specific font object
 * @param {*} fontList google api response list
 */ function googleFontsListForFilter(fontList) {
    var fontsForFilter = {};
    for(var font in fontList){
        var fontForFilter = fontList[font];
        fontsForFilter = _object_spread_props(_object_spread({}, fontsForFilter), _define_property({}, fontForFilter.family, {
            value: fontForFilter.family,
            label: fontForFilter.family,
            variants: fontForFilter.variants
        }));
    }
    return fontsForFilter;
}
function customFontsListForFilter(fontList) {
    var fontsForFilter = {};
    // loop through fonts list
    for(var font in fontList){
        var fontForFilter = fontList[font];
        var fontFamily = fontForFilter.fontFamily;
        var variants = [];
        // loop through each font weight
        for(var weight in fontForFilter.weights){
            var fontWeight = fontForFilter.weights[weight];
            variants = _to_consumable_array(variants).concat([
                fontWeight.weight
            ]);
            fontsForFilter = _object_spread_props(_object_spread({}, fontsForFilter), _define_property({}, fontFamily, _object_spread_props(_object_spread({}, fontWeight), {
                value: fontFamily,
                label: fontWeight.originalFontFamily,
                variants: variants
            })));
        }
    }
    return fontsForFilter;
}
/**
 * This function will evaluate what content must be returned
 * by the toReturn string, it can return only posts or objects or everything
 * keeping in check if static is being used
 * When fallbackPost is true a dummy post is return when content is empty
 * @param {object} obj
 * @param {string} toReturn
 * @param {object} objects
 * @param {boolean} fallbackPost
 */ function getContent(obj, toReturn, overrides, objects) {
    var fallbackPost = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
    var ref;
    //Workaround for new post location
    //TODO send posts inside formula object
    var Items = (ref = (overrides === null || overrides === void 0 ? void 0 : overrides.formula) && overrides.formula.posts) !== null && ref !== void 0 ? ref : obj.content.formula && obj.content.formula.posts ? obj.content.formula.posts : obj.content ? obj.content : [];
    if (toReturn === "posts") {
        //Return dummy post
        return Items.length > 0 ? Items : fallbackPost && [
            main.staticPost
        ];
    }
    if (toReturn === "all") {
        var Objects = filterBy(obj.children, objects);
        return Items.length > 0 ? (0,src_to_consumable_array/* default */.Z)(Objects).concat((0,src_to_consumable_array/* default */.Z)(Items)) : fallbackPost ? (0,src_to_consumable_array/* default */.Z)(Objects).concat([
            main.staticPost
        ]) : (0,src_to_consumable_array/* default */.Z)(Objects);
    }
    if (toReturn === "objects") {
        return filterBy(obj.children, objects);
    }
}
function filterBy(arrObjectUuid, objects) {
    if (arrObjectUuid && arrObjectUuid.constructor === Array) return arrObjectUuid.map(function(objectUuid) {
        return objects[objectUuid];
    });
    return [];
}
function templateIdsReplace(originalTemplate, newTemplate) {
    var cloneTemplate = cloneDeep(originalTemplate);
    // replace styles props
    cloneTemplate.uuid = newTemplate.uuid;
    // replace bob's ids
    for(var key in cloneTemplate.bobs){
        if (newTemplate.bobs[key]) cloneTemplate.bobs[key].uuid = newTemplate.bobs[key].uuid;
    }
    return cloneTemplate;
}
function replaceCustomContent(arrCC, originalTemplate) {
    if (arrCC.length === 0) return originalTemplate;
    var clonedOriginalTemplate = cloneDeep(originalTemplate);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = arrCC[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var customOption = _step.value;
            set(clonedOriginalTemplate.bobs, customOption.objPath, customOption.value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return clonedOriginalTemplate;
}
// map contents based on number of columns
// maintain the same pattern of columns if there are multiple lines
function handleColumns(idx, counter, backgroundTemplate) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var columns = "12";
    var columnsTablet;
    var columnsMobile;
    var nthCol = backgroundTemplate.grid.columns && backgroundTemplate.grid.columns.length;
    var nthColTablet = handleDeprecatedCols("tablet", backgroundTemplate, nthCol);
    var nthColMobile = handleDeprecatedCols("mobile", backgroundTemplate, nthCol);
    counter.desktop = idx % nthCol !== 0 ? counter.desktop + 1 : 0;
    counter.tablet = idx % nthColTablet !== 0 ? counter.tablet + 1 : 0;
    counter.mobile = idx % nthColMobile !== 0 ? counter.mobile + 1 : 0;
    columns = backgroundTemplate.grid.columns ? backgroundTemplate.grid.columns[counter.desktop] : backgroundTemplate.grid.cols;
    /**
   * write desktop as a default value on other breakpoints
   *
   * DEPRECATED:
   * Due to the mobile/tablet columns being defaulted to 12 on the past,
   * we need to handle the bobs that were using this behaviour as if the behaviour still exists,
   * instead of defaulting to the desktop styles.
   * The objects that are edited and republished will have the 'newBehaviour' prop so that the fallback stops working for this ones.
   *
   * This should only be true to objects that were never written with the colsMobile and colTablet props on the grid object.
   * This ones were migrated so that the mobile.grid.columns values is equal to the mobileCols value.
   * So no need to fallback to 12
   */ if (!backgroundTemplate.grid.newBehaviour && JSON.stringify(backgroundTemplate.grid.columns) !== '["12"]' && !backgroundTemplate.grid.columnsTablet && !backgroundTemplate.grid.columnsMobile && !((ref = backgroundTemplate.tablet) === null || ref === void 0 ? void 0 : (ref1 = ref.grid) === null || ref1 === void 0 ? void 0 : ref1.columns) && !((ref2 = backgroundTemplate.mobile) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.grid) === null || ref3 === void 0 ? void 0 : ref3.columns)) {
        columnsTablet = "12";
        columnsMobile = "12";
    } else {
        columnsTablet = columns;
        columnsMobile = columns;
    }
    /**
   * Check for legacy data and render that, if new structure is not present
   * Write breakpoint value if it exists
   */ //Mobile
    if (backgroundTemplate.mobile && ((ref4 = backgroundTemplate.mobile.grid) === null || ref4 === void 0 ? void 0 : ref4.columns)) {
        columnsMobile = backgroundTemplate.mobile.grid.columns[counter.mobile];
    } else if (backgroundTemplate.grid.columnsMobile) {
        columnsMobile = backgroundTemplate.grid.columnsMobile[counter.mobile];
    }
    //Tablet
    if (backgroundTemplate.tablet && ((ref5 = backgroundTemplate.tablet.grid) === null || ref5 === void 0 ? void 0 : ref5.columns)) {
        columnsTablet = backgroundTemplate.tablet.grid.columns[counter.tablet];
    } else if (backgroundTemplate.grid.columnsTablet) {
        columnsTablet = backgroundTemplate.grid.columnsTablet[counter.tablet];
    }
    return {
        columns: columns,
        columnsTablet: columnsTablet,
        columnsMobile: columnsMobile,
        counter: counter
    };
}
function handleDeprecatedCols(type, template, nthCol) {
    var ref, ref1, ref2, ref3;
    if (type === "tablet") return ((ref = template.tablet) === null || ref === void 0 ? void 0 : (ref1 = ref.grid) === null || ref1 === void 0 ? void 0 : ref1.columns) ? template.tablet.grid.columns.length : template.grid.columnsTablet ? template.grid.columnsTablet.length : nthCol;
    if (type === "mobile") return ((ref2 = template.mobile) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.grid) === null || ref3 === void 0 ? void 0 : ref3.columns) ? template.mobile.grid.columns.length : template.grid.columnsMobile ? template.grid.columnsMobile.length : nthCol;
    return undefined;
}
function newComponentIcons(componentName, color) {
    if (componentName === "container") {
        return /*#__PURE__*/ _jsx("i", {
            style: {
                color: color
            },
            className: "fas fa-border-all"
        });
    }
    if (componentName === "text") {
        return /*#__PURE__*/ _jsx("i", {
            style: {
                color: color
            },
            className: "fas fa-shapes"
        });
    }
    if (componentName === "media_v2") {
        return /*#__PURE__*/ _jsx("i", {
            style: {
                color: color
            },
            className: "fas fa-shapes"
        });
    }
    if (componentName === "grid") {
        return /*#__PURE__*/ _jsx("i", {
            style: {
                color: color
            },
            className: "fas fa-border-all"
        });
    }
    if (componentName === "form") {
        return /*#__PURE__*/ _jsx("i", {
            style: {
                color: color
            },
            className: "fas fa-border-none"
        });
    }
    if (componentName === "input") {
        return /*#__PURE__*/ _jsx("i", {
            style: {
                color: color
            },
            className: "fas fa-border-none"
        });
    }
    if (componentName === "submit") {
        return /*#__PURE__*/ _jsx("i", {
            style: {
                color: color
            },
            className: "fas fa-border-none"
        });
    }
    return /*#__PURE__*/ _jsx("i", {
        style: {
            color: color
        },
        className: "fa fa-question-circle"
    });
}
function handleComponentCategoryIcon(category, isFromSymbol, replaceColor) {
    if (category === componentIconTypes.STRUCTURE) return /*#__PURE__*/ _jsx("i", {
        style: {
            color: "".concat(replaceColor ? replaceColor : isFromSymbol ? "#FD7900" : "#000")
        },
        className: "fas fa-border-all"
    });
    if (category === componentIconTypes.ELEMENTS) return /*#__PURE__*/ _jsx("i", {
        style: {
            color: "".concat(replaceColor ? replaceColor : isFromSymbol ? "#FD7900" : "#000")
        },
        className: "fas fa-shapes"
    });
    if (category === componentIconTypes.NAVIGATION) return /*#__PURE__*/ _jsx("i", {
        style: {
            color: "".concat(replaceColor ? replaceColor : isFromSymbol ? "#FD7900" : "#000")
        },
        className: "fas fa-compass"
    });
    if (category === componentIconTypes.CONTENT) return /*#__PURE__*/ _jsx("i", {
        style: {
            color: "".concat(replaceColor ? replaceColor : isFromSymbol ? "#FD7900" : "#000")
        },
        className: "fas fa-boxes"
    });
    // default value
    return /*#__PURE__*/ _jsx("i", {
        style: {
            color: "".concat(replaceColor ? replaceColor : isFromSymbol ? "#FD7900" : "#000")
        },
        className: "fas fa-question"
    });
}
function overridesHasFormulas(clonedSingleObject, pageResponse) {
    var ref, ref1;
    if (!((ref = clonedSingleObject.content) === null || ref === void 0 ? void 0 : ref.overrides) || ((ref1 = clonedSingleObject.content) === null || ref1 === void 0 ? void 0 : ref1.overrides) && Object.keys(clonedSingleObject.content.overrides).length === 0) {
        return false;
    }
    var hasRootSymbolObjFormula = false;
    if (clonedSingleObject.isInstanceOf) {
        var ref2;
        var instanceSymbolRootId = (ref2 = pageResponse.symbols[clonedSingleObject.isInstanceOf]) === null || ref2 === void 0 ? void 0 : ref2.rootId;
        //eslint-disable-next-line
        Object.keys(clonedSingleObject.content.overrides).map(function(objectKey) {
            var ref;
            if (instanceSymbolRootId === objectKey && ((ref = clonedSingleObject.content.overrides) === null || ref === void 0 ? void 0 : ref[objectKey].formula)) hasRootSymbolObjFormula = true;
        });
    }
    return hasRootSymbolObjFormula;
}
function isParentContentBlock(parentObj, overrides) {
    var ref;
    return (ref = overrides === null || overrides === void 0 ? void 0 : overrides.isContentBlock) !== null && ref !== void 0 ? ref : parentObj.isContentBlock;
}
function handleContentBlock(singleObject, post, parentObj, pageResponse, overrides) {
    /**
   * Send content to child, and grandchild, etc
   *
   * if post already exists on child we shouldn't inject it again.
   * if isContentBlockChild still doenst exist it's because the post is being injected for the first time to the child,
   * so allways inject it, this way we dont run the filter on page start
   */ if (!isParentContentBlock(parentObj, overrides) && !parentObj.isContentBlockChild || !post) return singleObject;
    var clonedSingleObject = cloneDeep_default()(singleObject);
    // const FormComponents =
    //   parentObj.label.toLocaleLowerCase() === componentType.FORM ||
    //   clonedSingleObject.label.toLocaleLowerCase() === componentType.FORM_INPUT ||
    //   clonedSingleObject.label.toLocaleLowerCase() === componentType.FORM_SUBMIT
    // if (FormComponents) {
    //   clonedSingleObject.content.form = parentObj.content.form
    // } else
    if (clonedSingleObject.type === "instance") {
        clonedSingleObject.isContentBlockChild = true;
        //write override if it doesnt exist
        if (!overridesHasFormulas(clonedSingleObject, pageResponse) && clonedSingleObject.isInstanceOf) {
            var ref;
            //get uuid for object to write the override
            var instanceSymbolRootId = (ref = pageResponse.symbols[clonedSingleObject.isInstanceOf]) === null || ref === void 0 ? void 0 : ref.rootId;
            if (instanceSymbolRootId) {
                var ref1;
                var ref2;
                var parentObjFormula = (ref2 = overrides === null || overrides === void 0 ? void 0 : overrides.formula) !== null && ref2 !== void 0 ? ref2 : parentObj.content.formula;
                var ref3;
                var existingOverrides = (ref3 = (ref1 = clonedSingleObject.content.overrides) === null || ref1 === void 0 ? void 0 : ref1[instanceSymbolRootId]) !== null && ref3 !== void 0 ? ref3 : {};
                var ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
                clonedSingleObject.content.overrides = (0,src_define_property/* default */.Z)({}, instanceSymbolRootId, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, existingOverrides), {
                    formula: {
                        uuid: (ref4 = parentObjFormula === null || parentObjFormula === void 0 ? void 0 : parentObjFormula.uuid) !== null && ref4 !== void 0 ? ref4 : "",
                        label: (ref5 = parentObjFormula === null || parentObjFormula === void 0 ? void 0 : parentObjFormula.label) !== null && ref5 !== void 0 ? ref5 : "",
                        name: (ref6 = parentObjFormula === null || parentObjFormula === void 0 ? void 0 : parentObjFormula.name) !== null && ref6 !== void 0 ? ref6 : "",
                        mql: (ref7 = parentObjFormula === null || parentObjFormula === void 0 ? void 0 : parentObjFormula.mql) !== null && ref7 !== void 0 ? ref7 : "",
                        objectFormula: (ref8 = parentObjFormula === null || parentObjFormula === void 0 ? void 0 : parentObjFormula.objectFormula) !== null && ref8 !== void 0 ? ref8 : false,
                        hasMore: (ref9 = parentObjFormula === null || parentObjFormula === void 0 ? void 0 : parentObjFormula.hasMore) !== null && ref9 !== void 0 ? ref9 : false,
                        totalItems: (ref10 = parentObjFormula === null || parentObjFormula === void 0 ? void 0 : parentObjFormula.totalItems) !== null && ref10 !== void 0 ? ref10 : 1,
                        nextCursor: (ref11 = parentObjFormula === null || parentObjFormula === void 0 ? void 0 : parentObjFormula.nextCursor) !== null && ref11 !== void 0 ? ref11 : "",
                        posts: [
                            post
                        ],
                        postIds: (ref12 = parentObjFormula === null || parentObjFormula === void 0 ? void 0 : parentObjFormula.postIds) !== null && ref12 !== void 0 ? ref12 : [],
                        type: (ref13 = parentObjFormula === null || parentObjFormula === void 0 ? void 0 : parentObjFormula.type) !== null && ref13 !== void 0 ? ref13 : "expression",
                        media: parentObjFormula === null || parentObjFormula === void 0 ? void 0 : parentObjFormula.media
                    }
                }));
            }
        } else {
            //check if the overrride has formula
            var hasFormula = false;
            var localOverrides = clonedSingleObject.content.overrides;
            if (localOverrides) {
                //eslint-disable-next-line
                Object.keys(localOverrides).map(function(objectKey) {
                    var ref;
                    if (localOverrides === null || localOverrides === void 0 ? void 0 : (ref = localOverrides[objectKey]) === null || ref === void 0 ? void 0 : ref.formula) hasFormula = objectKey;
                });
                var overrideFormula = localOverrides[hasFormula].formula;
                if (hasFormula && overrideFormula) {
                    overrideFormula.posts = (0,src_to_consumable_array/* default */.Z)(overrideFormula.posts).concat([
                        post
                    ]);
                }
            } else if (clonedSingleObject.isInstanceOf) {
                var ref14;
                //get uuid for object to write the override
                var instanceSymbolRootId1 = (ref14 = pageResponse.symbols[clonedSingleObject.isInstanceOf]) === null || ref14 === void 0 ? void 0 : ref14.rootId;
                if (instanceSymbolRootId1) {
                    var ref15;
                    var ref16;
                    var parentObjFormula1 = (ref16 = overrides === null || overrides === void 0 ? void 0 : overrides.formula) !== null && ref16 !== void 0 ? ref16 : parentObj.content.formula;
                    var ref17;
                    var existingOverrides1 = (ref17 = (ref15 = clonedSingleObject.content.overrides) === null || ref15 === void 0 ? void 0 : ref15[instanceSymbolRootId1]) !== null && ref17 !== void 0 ? ref17 : {};
                    var ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27;
                    clonedSingleObject.content.overrides = (0,src_define_property/* default */.Z)({}, instanceSymbolRootId1, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, existingOverrides1), {
                        formula: {
                            uuid: (ref18 = parentObjFormula1 === null || parentObjFormula1 === void 0 ? void 0 : parentObjFormula1.uuid) !== null && ref18 !== void 0 ? ref18 : "",
                            label: (ref19 = parentObjFormula1 === null || parentObjFormula1 === void 0 ? void 0 : parentObjFormula1.label) !== null && ref19 !== void 0 ? ref19 : "",
                            name: (ref20 = parentObjFormula1 === null || parentObjFormula1 === void 0 ? void 0 : parentObjFormula1.name) !== null && ref20 !== void 0 ? ref20 : "",
                            mql: (ref21 = parentObjFormula1 === null || parentObjFormula1 === void 0 ? void 0 : parentObjFormula1.mql) !== null && ref21 !== void 0 ? ref21 : "",
                            objectFormula: (ref22 = parentObjFormula1 === null || parentObjFormula1 === void 0 ? void 0 : parentObjFormula1.objectFormula) !== null && ref22 !== void 0 ? ref22 : false,
                            hasMore: (ref23 = parentObjFormula1 === null || parentObjFormula1 === void 0 ? void 0 : parentObjFormula1.hasMore) !== null && ref23 !== void 0 ? ref23 : false,
                            totalItems: (ref24 = parentObjFormula1 === null || parentObjFormula1 === void 0 ? void 0 : parentObjFormula1.totalItems) !== null && ref24 !== void 0 ? ref24 : 1,
                            nextCursor: (ref25 = parentObjFormula1 === null || parentObjFormula1 === void 0 ? void 0 : parentObjFormula1.nextCursor) !== null && ref25 !== void 0 ? ref25 : "",
                            posts: [
                                post
                            ],
                            postIds: (ref26 = parentObjFormula1 === null || parentObjFormula1 === void 0 ? void 0 : parentObjFormula1.postIds) !== null && ref26 !== void 0 ? ref26 : [],
                            type: (ref27 = parentObjFormula1 === null || parentObjFormula1 === void 0 ? void 0 : parentObjFormula1.type) !== null && ref27 !== void 0 ? ref27 : "expression",
                            media: parentObjFormula1 === null || parentObjFormula1 === void 0 ? void 0 : parentObjFormula1.media
                        }
                    }));
                }
            }
        }
    } else {
        var ref28, ref29;
        //Check if object has posts
        var objectPosts = (ref28 = clonedSingleObject.content) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.formula) === null || ref29 === void 0 ? void 0 : ref29.posts;
        if (post) {
            var isPostInjected = !objectPosts || objectPosts && objectPosts.filter(function(obj) {
                return obj.id === post.id;
            }).length > 0;
            if (!clonedSingleObject.isContentBlockChild || !isPostInjected) {
                /**
         * check for content.formula existance
         * if it doenst create it so we can add posts inside it
         */ if (clonedSingleObject.content.formula) clonedSingleObject.content.formula.posts = clonedSingleObject.content.formula.posts ? (0,src_to_consumable_array/* default */.Z)(clonedSingleObject.content.formula.posts).concat([
                    post
                ]) : [
                    post
                ];
                else {
                    var ref30;
                    var parentObjFormula2 = (ref30 = overrides === null || overrides === void 0 ? void 0 : overrides.formula) !== null && ref30 !== void 0 ? ref30 : parentObj.content.formula;
                    var ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40;
                    clonedSingleObject.content.formula = {
                        uuid: (ref31 = parentObjFormula2 === null || parentObjFormula2 === void 0 ? void 0 : parentObjFormula2.uuid) !== null && ref31 !== void 0 ? ref31 : "",
                        label: (ref32 = parentObjFormula2 === null || parentObjFormula2 === void 0 ? void 0 : parentObjFormula2.label) !== null && ref32 !== void 0 ? ref32 : "",
                        name: (ref33 = parentObjFormula2 === null || parentObjFormula2 === void 0 ? void 0 : parentObjFormula2.name) !== null && ref33 !== void 0 ? ref33 : "",
                        mql: (ref34 = parentObjFormula2 === null || parentObjFormula2 === void 0 ? void 0 : parentObjFormula2.mql) !== null && ref34 !== void 0 ? ref34 : "",
                        objectFormula: (ref35 = parentObjFormula2 === null || parentObjFormula2 === void 0 ? void 0 : parentObjFormula2.objectFormula) !== null && ref35 !== void 0 ? ref35 : false,
                        hasMore: (ref36 = parentObjFormula2 === null || parentObjFormula2 === void 0 ? void 0 : parentObjFormula2.hasMore) !== null && ref36 !== void 0 ? ref36 : false,
                        totalItems: (ref37 = parentObjFormula2 === null || parentObjFormula2 === void 0 ? void 0 : parentObjFormula2.totalItems) !== null && ref37 !== void 0 ? ref37 : 1,
                        nextCursor: (ref38 = parentObjFormula2 === null || parentObjFormula2 === void 0 ? void 0 : parentObjFormula2.nextCursor) !== null && ref38 !== void 0 ? ref38 : "",
                        posts: [
                            post
                        ],
                        postIds: (ref39 = parentObjFormula2 === null || parentObjFormula2 === void 0 ? void 0 : parentObjFormula2.postIds) !== null && ref39 !== void 0 ? ref39 : [],
                        type: (ref40 = parentObjFormula2 === null || parentObjFormula2 === void 0 ? void 0 : parentObjFormula2.type) !== null && ref40 !== void 0 ? ref40 : "expression",
                        media: parentObjFormula2 === null || parentObjFormula2 === void 0 ? void 0 : parentObjFormula2.media
                    };
                }
                // write isContentBlockChild for every child of a content block
                clonedSingleObject.isContentBlockChild = true;
                // handle postList field
                clonedSingleObject.content.formula = handlePostListField(singleObject.content, clonedSingleObject.content.formula, post, pageResponse);
            }
        }
    }
    return clonedSingleObject;
}
/**
 * handle postList field
 * use a postList from a post
 *
 * @param content
 * @param formula
 * @param post
 * @param pageResponse
 * @returns
 */ function handlePostListField(content, formula, post, pageResponse) {
    if (content.mappedField || content.contentSrc === "field") {
        // post and postList metadata must exist
        if (post && post._meta_post_ids_at && content.mappedField) {
            // Check for mappedField in _meta_post_ids_at
            if (!post._meta_post_ids_at.includes(content.mappedField)) {
                console.warn("PostList mappedField doens't exist in _meta_post_ids_at");
                return undefined;
            }
            // Use post postList when it exists
            // Post postList exists
            var postListIdsLocation = content.mappedField;
            if (postListIdsLocation) {
                var postsList = pageResponse.linkedPosts;
                var postIds = post[postListIdsLocation];
                // Get postList
                if (postsList && postIds && postIds.length > 0) {
                    var posts = postIds.map(function(postId) {
                        return postsList[postId];
                    });
                    formula.posts = posts;
                }
            } else return undefined;
        } else return undefined;
    }
    return formula;
}
function handleDataSetAsContentBlock(singleObject, posts, parentObj) {
    var clonedSingleObject = cloneDeep_default()(singleObject);
    /**
   * Send content to child, and grandchild, etc
   *
   * if post already exists on child we shouldn't inject it again.
   * if isContentBlockChild still doenst exist it's because the post is being injected for the first time to the child,
   * so allways inject it, this way we dont run the filter on page start
   */ var postsExist = clonedSingleObject.content && clonedSingleObject.content.formula && clonedSingleObject.content.formula.posts;
    var postExists = !postsExist || postsExist && clonedSingleObject.content.formula && clonedSingleObject.content.formula.posts.filter(function(obj) {
        return obj.id === posts[0].id;
    }).length > 0;
    if (posts) {
        if (!clonedSingleObject.isContentBlockChild || !postExists) {
            /**
       * check for content.formula existance
       * if it doenst create it so we can add posts inside it
       */ if (clonedSingleObject.content.formula) clonedSingleObject.content.formula.posts = clonedSingleObject.content.formula.posts ? (0,src_to_consumable_array/* default */.Z)(clonedSingleObject.content.formula.posts).concat((0,src_to_consumable_array/* default */.Z)(posts)) : (0,src_to_consumable_array/* default */.Z)(posts);
            else clonedSingleObject.content.formula = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, clonedSingleObject.content.formula), {
                posts: (0,src_to_consumable_array/* default */.Z)(posts)
            });
            clonedSingleObject.isContentBlockChild = true;
        }
    }
    return clonedSingleObject;
}
function isSubDomainPreview(domain) {
    /**
   * Since checking for the subdomain can be quiet heavy, we just
   * use includes() to see if its the fluxio.cloud domain and with a "-preview" string
   */ if (domain.includes("fluxio.cloud") && domain.includes("-preview")) return true;
    return false;
}
function handleObjectName(label, singleObject, contentHub) {
    if (isDefaultLabel(label)) {
        if (singleObject.type === "instance" || singleObject.type === "symbol") {
            return "Symbol";
        }
        if (singleObject.type === "object") {
            var ref;
            return ComponentNames.types((ref = contentHub.components[singleObject.styles.component]) === null || ref === void 0 ? void 0 : ref.name);
        }
    }
    return label;
}
function getInstanceName(singleObject) {
    if (singleObject.type === "instance") return singleObject.label;
    return "!!!Wrong object provided!!!";
}
function isDefaultLabel(label) {
    return label.toLowerCase() === "new object";
}
/**
 * block set as symbol if object has template events
 */ function checkTemplateEvents(eventPile, obj, contentHub) {
    // when dealing with an instance, if events exist,
    // those events id's are refering to the symbol object that made style changes
    var newObj = obj;
    if (obj.isInstanceOf) newObj = handleFilterSymbolObject(obj, contentHub.symbols, false);
    if (eventPile && eventPile.length > 0) {
        for(var index in eventPile){
            if (eventPile[index].type === "template" && eventPile[index].content.objectUuid === newObj.objectUuid) return true;
        }
    }
    return false;
}
function isInSymbolEditMode(symbolObj, symbolContentType, emType) {
    if (symbolObj && symbolContentType === CONTENT_TYPE_SYMBOL) return true;
    if (emType === "symbol") return true;
    return false;
}
function isInInstanceEditMode(symbolObj, symbolContentType) {
    if (symbolObj && symbolContentType === CONTENT_TYPE_INSTANCE) return true;
    return false;
}
function disableBodyScroll(expManager, disableScroll) {
    // disabled body scroll when modal is open
    if (expManager.enable) {
        var boardPreview = document.getElementById("board-preview-frame");
        if (boardPreview) {
            var ref;
            var iframeBody = (ref = boardPreview.contentWindow) === null || ref === void 0 ? void 0 : ref.document.body;
            if (disableScroll) {
                if (iframeBody) iframeBody.style.overflowY = "hidden";
            } else {
                if (iframeBody) iframeBody.style.overflowY = "auto";
            }
        }
    } else {
        if (disableScroll) document.body.style.overflowY = "hidden";
        else document.body.style.overflowY = "auto";
    }
}

;// CONCATENATED MODULE: ./src/modules/shared-modules/experienceManager/types/pageTreeTypes.ts
var CONTENT_TAB = "formula";
var STYLES_TAB = "template";
var DEFAULT_FINDER_TAB = "formula";
var PROPERTIES_STYLES_TAB = "mainHub-style";
var PROPERTIES_TAB = "mainHub";

// EXTERNAL MODULE: ./src/modules/shared-modules/experienceManager/finder/symbols/symbolTypes.ts
var symbolTypes = __webpack_require__(14673);
;// CONCATENATED MODULE: ./src/modules/shared-modules/experienceManager/types/stylesTypes.ts
function isBobForm(bob) {
    if ("formId" in bob) return bob;
    throw new Error("type is not bobForm");
}
function isBobFlex(bob) {
    if ("flex" in bob) return bob;
    throw new Error("type is not bobBackground");
}
function isBobGrid(bob) {
    if ("grid" in bob && "selfFlex" in bob) return bob;
    throw new Error("type is not bobGrid");
}
function isNbobText(bob) {
    if ("fontFamily" in bob && "width" in bob) return bob;
    throw new Error("type is not nBobText");
}
function isNbobNmedia(bob) {
    if ("video" in bob && "selfFlex" in bob) return bob;
    throw new Error("type is not nBobText");
}
function isBobFormV2(bob) {
    if ("flex" in bob) return bob;
    throw new Error("type is not bobForm");
}
function isBobInput(bob) {
    if ("flex" in bob && "fontFamily" in bob) return bob;
    throw new Error("type is not bobForm");
}
/**
 * old bobs
 *
 */ function isBobBackground(bob) {
    if ("lean" in bob && "grid" in bob) return bob;
    throw new Error("type is not bobBackground");
}
function isBobText(bob) {
    if ("fontFamily" in bob && !("maxWidth" in bob)) return bob;
    throw new Error("type is not bobText");
}
function isBobMedia(bob) {
    if ("filter" in bob && !("maxWidth" in bob)) return bob;
    throw new Error("type is not bobMedia");
}
function isBobIcon(bob) {
    if ("icon" in bob) return bob;
    throw new Error("type is not bobIcon");
}
function isBobCode(bob) {
    if ("code" in bob && typeof bob.code === "string") return bob;
    throw new Error("type is not BobCode");
}
function isBobCodeV2(bob) {
    if ("code" in bob && typeof bob.code !== "string") return bob;
    throw new Error("type is not BobCodeV2");
}

// EXTERNAL MODULE: ./src/modules/shared-modules/experienceManager/viewPortTypes/viewPortTypes.ts
var viewPortTypes = __webpack_require__(82031);
;// CONCATENATED MODULE: ./src/modules/shared-modules/utilities/utils.tsx

/**
 * check for prop value existance
 * @param obj
 * @param prop
 */ function utils_objValueExists(obj, prop) {
    return obj.hasOwnProperty(prop) && obj[prop] !== null && obj[prop] !== undefined;
}
/**
 * Check if value exists
 * @param value
 */ function valueExists(value) {
    return value || value === false || value === 0 || value === "";
}
function isNullUndefined(value) {
    return typeof value === "undefined" || value === null;
}
function isDesktop(breakpoint, ifDesktop, orElse) {
    return getDeviceSize(breakpoint) === "desktop" ? ifDesktop : orElse;
}
function isTablet(breakpoint, isTablet, orElse) {
    return getDeviceSize(breakpoint) === "tablet" ? isTablet : orElse;
}
function isMobile(breakpoint, isMobile, orElse) {
    return getDeviceSize(breakpoint) === "mobile" ? isMobile : orElse;
}
function getDeviceSize(viewPortSizeState) {
    if (viewPortSizeState >= viewPortTypes/* DESKTOP */.q5) {
        return "desktop";
    }
    if (viewPortSizeState > viewPortTypes/* MOBILE */.Jq) {
        return "tablet";
    }
    if (viewPortSizeState === "100%_NO_BARS") return "fullscreen";
    return "mobile";
}
function getComposedUuid(obj) {
    if (!obj) return "";
    if (obj.selectedInstanceId) {
        return "".concat(obj.uuid, "-").concat(obj.selectedInstanceId);
    }
    return obj.uuid;
}
function clamp(min, max, x) {
    if (x < min) return min;
    else if (x > max) return max;
    else return x;
}
function loadThreshold(imgBytes) {
    var min = 250;
    var max = 1000;
    if (!imgBytes) {
        return min;
    }
    return clamp(min, max, imgBytes / 400 * 100 + 250);
}
function shouldBeNull(obj) {
    var shouldParseInt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, shouldToString = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (obj.breakpoint !== "desktop" || obj.state !== "default") {
        if (!obj.isDiferent) {
            return null;
        } else return shouldParseInt ? parseFloat(obj.value) : shouldToString ? obj.value.toString() : obj.value;
    }
    return obj.value && shouldParseInt ? parseFloat(obj.value) : obj.value && shouldToString ? obj.value.toString() : obj.value;
}

;// CONCATENATED MODULE: ./src/areas/skynet/experienceManager/utils/devices.ts



var Devices = /*#__PURE__*/ function() {
    "use strict";
    function Devices() {
        (0,src_class_call_check/* default */.Z)(this, Devices);
    }
    /**
   * Scale viewport when size is bigger than the viewport itself
   * @param {*} size
   * @param {*} scale
   */ Devices.handleViewPortMaxSize = function handleViewPortMaxSize(size, scale, max) {
        if (size >= max) {
            scale = max * 100 / size;
            return {
                size: size,
                scale: scale
            };
        }
        if (size <= max && size === viewPortTypes/* DESKTOP */.q5) size = max;
        return {
            size: size,
            scale: scale
        };
    };
    Devices.handleSelectedBreakpoint = function handleSelectedBreakpoint(viewPortSizeState) {
        if (getDeviceSize(viewPortSizeState) === "mobile") return "mobile";
        if (getDeviceSize(viewPortSizeState) === "tablet") return "tablet";
        if (getDeviceSize(viewPortSizeState) === "desktop") return "desktop";
    };
    Devices.handleResponsiveBreakpoint = function handleResponsiveBreakpoint(responsiveTab, viewPortSizeState) {
        return {
            type: responsiveTab,
            breakpoint: this.handleSelectedBreakpoint(viewPortSizeState)
        };
    };
    return Devices;
}();
/* harmony default export */ var devices = (Devices);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/componentSelectorEM/ComponentSelectorEM.tsx
















var ComponentSelectorEM = function(props) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var actions = (0,redux/* bindActionCreators */.DE)({
        hubHandlerSelected: hubHandlerSelected,
        selectFinder: selectFinder,
        objectSelectionHover: objectSelectionHover,
        selectSymbolInstance: selectSymbolInstance,
        setSymbolContentType: setSymbolContentType,
        editSymbolState: editSymbolState,
        viewPortSizeStateExperienceManager: viewPortSizeStateExperienceManager,
        changeResponsiveTab: changeResponsiveTab
    }, dispatch);
    var selectedSingleObject = (0,es/* useSelector */.v9)(function(state) {
        return state.publicPageReducer.hubHandlerObject;
    });
    var contentHub = (0,es/* useSelector */.v9)(function(state) {
        return state.contentHubReducer.hubContent;
    });
    var symbolObj = (0,es/* useSelector */.v9)(function(state) {
        return state.pageTreeReducer;
    }).symbolObj;
    var viewPortSizeState = (0,es/* useSelector */.v9)(function(state) {
        return state.publicPageReducer.viewPortSizeState;
    });
    var viewPortOriginalSizeState = (0,es/* useSelector */.v9)(function(state) {
        return state.experienceManagerReducer.viewPortOriginalSizeState;
    });
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return state.experienceManagerReducer;
    }), objectSelectorModeEM = ref.objectSelectorModeEM, objectSelectorStateEM = ref.objectSelectorStateEM, finderType = ref.finderType, emEditorType = ref.emEditorType;
    var objectSelectorHover = (0,es/* useSelector */.v9)(function(state) {
        return state.publicPageReducer;
    }).objectSelectorHover;
    var handleObjectClick = function(e) {
        /**
     * Only trigger if in object selection Mode
     * @param objectSelectorModeEM (boolean)
     */ if (objectSelectorModeEM) {
            e.stopPropagation();
            e.preventDefault();
            // symbol root object clicked
            if (props.obj.fromSymbolTree && props.obj.type === "root" && props.obj.selectedInstanceId) {
                var symbolInstanceObj = handleFilterInstanceObj(contentHub, props.obj.selectedInstanceId);
                var symbolToUse = symbols_handleFilterSymbolObject(symbolInstanceObj, contentHub.symbols, false);
                actions.hubHandlerSelected(symbolToUse.uuid, undefined, symbolToUse);
                actions.selectSymbolInstance(symbolInstanceObj.uuid, symbolInstanceObj);
                actions.selectFinder(handleOpenTab(), symbolToUse);
                //directly open styles for symbol
                actions.editSymbolState({
                    symbolObj: symbolToUse
                }, CONTENT_TAB);
                // if fromSymbolTree is different set instance edit mode
                if (props.obj.fromSymbolTree !== selectedSingleObject.fromSymbolTree) {
                    actions.setSymbolContentType(symbolTypes/* CONTENT_TYPE_INSTANCE */.h);
                }
            } else if (props.obj.fromSymbolTree && props.obj.type === "object" && props.obj.selectedInstanceId) {
                //Gets original object without the overrides
                var objToUse = getObjectFromSymbolObject(contentHub, props.obj);
                var symbolInstanceObj1 = handleFilterInstanceObj(contentHub, props.obj.selectedInstanceId);
                var symbolToUse1 = symbols_handleFilterSymbolObject(symbolInstanceObj1, contentHub.symbols, false);
                actions.hubHandlerSelected(props.obj.uuid, undefined, objToUse);
                actions.selectSymbolInstance(symbolInstanceObj1.uuid, symbolInstanceObj1);
                actions.selectFinder(handleOpenTab(), objToUse);
                //directly open styles for symbol
                actions.editSymbolState({
                    symbolObj: symbolToUse1
                }, CONTENT_TAB);
                // if fromSymbolTree is different set instance edit mode
                if (props.obj.fromSymbolTree !== selectedSingleObject.fromSymbolTree) {
                    actions.setSymbolContentType(symbolTypes/* CONTENT_TYPE_INSTANCE */.h);
                }
            } else {
                if (!props.obj.selectedInstanceId) {
                    actions.editSymbolState(false);
                    actions.setSymbolContentType(symbolTypes/* CONTENT_TYPE_INSTANCE */.h);
                }
                //clear selected instance
                if (!props.obj.fromSymbolTree) actions.selectSymbolInstance(undefined);
                var SingleObjectToUse = components_handleObjectsListType(contentHub, props.obj, emEditorType)[props.obj.uuid];
                actions.hubHandlerSelected(SingleObjectToUse.objectUuid, SingleObjectToUse.parentId, SingleObjectToUse);
                actions.selectFinder(handleOpenTab(), SingleObjectToUse);
            }
            //Return to desktop mode when in Fullscreen
            if (viewPortSizeState === "100%_NO_BARS") {
                var viewport = devices.handleViewPortMaxSize(viewPortTypes/* DESKTOP */.q5, 100, viewPortOriginalSizeState);
                actions.viewPortSizeStateExperienceManager(viewport.size, viewport.scale);
                actions.changeResponsiveTab("responsive");
            }
        }
    };
    var handleOpenTab = function() {
        if (finderType === "template" || finderType === CONTENT_TAB) {
            return finderType;
        }
        return DEFAULT_FINDER_TAB;
    };
    /**
   * handle validate visiblity
   * based on objt uuid or instance uuid
   */ var handleVisibilityOnHover = function() {
        if (objectSelectorHover) {
            var id = handleUniqueid(props.obj, contentHub.symbols);
            if (objectSelectorHover === id) return true;
            return false;
        }
        return false;
    };
    var handleElementEnter = function(e) {
        e.stopPropagation();
        /**
     * element hover logic
     * when hover is on a symbol obj, use the selectedInstanceId
     */ if (objectSelectorModeEM) {
            var obj = props.obj;
            // when hovering a symbol object that inst the root object,
            // we must use the root object himself so that the instance on the tree matches the objectSelectorModeEM id
            if (props.obj.fromSymbolTree && props.obj.type !== "root" && props.expManager.emEditorType !== "symbol" && !symbolObj) {
                var symbol = contentHub.symbols[props.obj.fromSymbolTree];
                obj = symbol.objects[symbol.rootId];
            }
            var id = handleUniqueid((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, obj), {
                selectedInstanceId: props.obj.selectedInstanceId
            }), contentHub.symbols);
            actions.objectSelectionHover(id);
        }
    };
    var handleElementLeave = function(e) {
        e.stopPropagation();
        /**
     * element hover logic
     */ if (objectSelectorModeEM) {
            actions.objectSelectionHover(false);
        }
    };
    var outerDivStyle = {
        position: "relative"
    };
    if (props.expManager.enable && !props.expManager.content) {
        var ref1;
        var isSelected = false;
        var classes = "";
        if (objectSelectorStateEM) {
            isSelected = true;
            classes += "editing ";
        }
        var displayBoundaries = objectSelectorModeEM ? "block" : "none";
        // TODO: should every component have a background1?
        var background1Obj = ((ref1 = props.obj.styles.bobs) === null || ref1 === void 0 ? void 0 : ref1.background1) ? isBobBackground(props.obj.styles.bobs.background1) : undefined;
        var Template = background1Obj && background1Obj.spacing && background1Obj.spacing.enable ? background1Obj.spacing : {
            margin: {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
            },
            padding: {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
            }
        };
        /**
     *
     * Border/Padding/Content layout
     *
     * To emulate visually the borders, paddings and content with the charro feature
     * we need to create a frame around the content with the two options avaiable
     *
     * MARGIN TOP */ var MarginTop = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "margin top",
            style: {
                width: "100%",
                height: "".concat(Template.margin.top, "px"),
                left: "0",
                top: "-".concat(Template.margin.top, "px")
            }
        });
        /* Margin top will go from left to right using 100%
     * The height will equal the margin top selected in the interface
     * To visually apply it over the real margin he we need to give it a negative top equal to its height
     *
     * MARGIN BOTTOM */ var MarginBottom = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "margin bottom",
            style: {
                width: "100%",
                height: "".concat(Template.margin.bottom, "px"),
                right: "0",
                bottom: "-".concat(Template.margin.bottom, "px")
            }
        });
        /* Margin bottom applies the same principles from margin top but with inverted sides
    * In this case it uses the right and bottom side to align it and the negative value is applied at the bottom

    * MARGIN LEFT */ var MarginLeft = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "margin left",
            style: {
                width: "".concat(Template.margin.left, "px"),
                height: "100%"
            }
        });
        /* Margin left uses the full height avaiable
     * The width equals the margin left applied in the interface
     * The position is forced to the left side with top and left at 0
     *
     * MARGIN RIGHT */ var MarginRight = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "margin right",
            style: {
                width: "".concat(Template.margin.right, "px"),
                height: "100%"
            }
        });
        /* Margin right uses the same logic for the margin left
     * With the proper use of the margin right for the width
     * And starting at the right and bottom side (0)
     *
     *       ---------------------------------------------------------------------------------------------
     *       |       margin-top: width:100%; height:${margin.top}px; left:0; top: -${margin.top};        |
     *       ---------------------------------------------------------------------------------------------
     *       |        margin-left:     |                                      |        margin-right:     |
     *       | width: ${margin-left}px |                                      | width: ${margin-right}px |
     *       |        height: 100%     |                                      |        height: 100%      |
     *       |         left: 0         |                                      |         right: 0         |
     *       |         top: 0          |                                      |         bottom: 0        |
     *       ---------------------------------------------------------------------------------------------
     *       | margin-bottom: width:100%; height:${margin-bottom}px; right:0; bottom: -${margin.bottom}; |
     *       ---------------------------------------------------------------------------------------------
     *
     * PADDING TOP */ var PaddingTop = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "padding top",
            style: {
                width: "calc(100% - ".concat(Template.padding.left + Template.padding.right, "px)"),
                height: "".concat(Template.padding.top, "px"),
                left: "".concat(Template.padding.left, "px")
            }
        });
        /* Padding top will use the total width minus both padding side values for the left & right
     * The height will equal to the padding top and will start at where the left padding ends
     *
     * PADDING BOTTOM */ var PaddingBottom = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "padding bottom",
            style: {
                width: "calc(100% - ".concat(Template.padding.left + Template.padding.right, "px)"),
                height: "".concat(Template.padding.bottom, "px"),
                right: "".concat(Template.padding.right, "px")
            }
        });
        /* Padding bottom will have the same logic applied at the padding top, with the small change to start at the right side where the right padding ends
     * The height will equal the padding bottom
     *
     * PADDING LEFT */ var PaddingLeft = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "padding left",
            style: {
                width: "".concat(Template.padding.left, "px"),
                height: "100%"
            }
        });
        /* Padding left will just use the padding left for the width and 100% for the height
     * Since we leave the heavy logic for the top and bottom padding
     *
     *
     *
     *
     *       --------------------------------------------------------------------------------------------------------------------
     *       | padding-top: width:calc(100%-[${padding.left}+${padding.right}]px); height:${padding.top}; left:${padding.left}; |
     *       --------------------------------------------------------------------------------------------------------------------
     */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes,
            onClick: function(e) {
                return handleObjectClick(e);
            },
            style: outerDivStyle,
            onMouseOver: function(e) {
                return handleElementEnter(e);
            },
            onMouseLeave: function(e) {
                return handleElementLeave(e);
            },
            children: [
                isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "object-selected",
                    className: "".concat(symbolObj ? "isSymbol" : "", " ").concat(props.obj.uuid === (selectedSingleObject === null || selectedSingleObject === void 0 ? void 0 : selectedSingleObject.uuid) ? "isSelected" : "")
                }),
                handleVisibilityOnHover() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "element-hover",
                    style: {
                        display: displayBoundaries
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "property",
                        children: [
                            MarginTop,
                            MarginBottom,
                            MarginLeft,
                            MarginRight,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "block",
                                style: {
                                    top: "0",
                                    right: "".concat(Template.margin.right, "px"),
                                    bottom: "0",
                                    left: "".concat(Template.margin.left, "px"),
                                    width: "calc(100% - ".concat(Template.margin.left + Template.margin.right, ")"),
                                    height: "100%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "property",
                                    children: [
                                        PaddingTop,
                                        PaddingBottom,
                                        PaddingLeft,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "padding right",
                                            style: {
                                                width: "".concat(Template.padding.right, "px"),
                                                height: "100%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "block",
                                            style: {
                                                top: "".concat(Template.padding.top, "px"),
                                                right: "".concat(Template.padding.right, "px"),
                                                bottom: "".concat(Template.padding.bottom, "px"),
                                                left: "".concat(Template.padding.left, "px"),
                                                width: "calc(100% - ".concat(Template.padding.right + Template.padding.left, "px)"),
                                                height: "calc(100% - ".concat(Template.padding.bottom + Template.padding.top, "px)")
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "property",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "content",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "object-label",
                                                        children: [
                                                            props.obj.isContentBlockChild ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "fa fa-th-list",
                                                                        "aria-hidden": "true"
                                                                    }),
                                                                    " "
                                                                ]
                                                            }) : "",
                                                            props.obj.label
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                props.children
            ]
        });
    }
    return(/**
     * Div must be rendered because if we remove it now it will have implications on the components render.
     * At least the tabs component, when in position: sticky has a diferent behaviour.
     */ /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: outerDivStyle,
        children: props.children
    }));
};
/* harmony default export */ var componentSelectorEM_ComponentSelectorEM = (ComponentSelectorEM);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/componentSelectorEM/index.ts

/* harmony default export */ var componentSelectorEM = (componentSelectorEM_ComponentSelectorEM);

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/invalid/Invalid.tsx


var Invalid = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "alert alert-danger",
        children: [
            "Missing component render for ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: props.componentRule.name
            })
        ]
    });
};
/* harmony default export */ var invalid_Invalid = (Invalid);

;// CONCATENATED MODULE: ./src/modules/shared-modules/constants/bobDefaultNode.tsx
var bobDefaultNode_styles = {
    "fontFamily": "Roboto",
    "fontWeight": "normal",
    "fontSize": "16",
    "letterSpacing": "1",
    "lineHeight": "1",
    "textAlign": "left",
    "verticalAlign": "bottom",
    "textTransform": "none",
    "color": "rgba(0,0,0,1)"
};
var stylesOverride = {
    "fontFamily": "Roboto:300,400,600,700 !important",
    "fontWeight": "normal !important",
    "fontSize": "16 !important",
    "letterSpacing": "1 !important",
    "lineHeight": "1 !important",
    "textAlign": "left !important",
    "verticalAlign": "bottom !important",
    "textTransform": "none !important",
    "color": "rgba(0,0,0,1) !important"
};

// EXTERNAL MODULE: ./node_modules/style-it/dist/style-it.js
var style_it = __webpack_require__(42374);
var style_it_default = /*#__PURE__*/__webpack_require__.n(style_it);
;// CONCATENATED MODULE: ./src/modules/shared-modules/utilities/validation.ts
function validHtml(value) {
    return /<(br|basefont|hr|input|source|frame|param|area|meta|!--|col|link|option|base|img|wbr|!DOCTYPE).*?>|<(a|abbr|acronym|address|applet|article|aside|audio|b|bdi|bdo|big|blockquote|body|button|canvas|caption|center|cite|code|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frameset|head|header|hgroup|h1|h2|h3|h4|h5|h6|html|i|iframe|ins|kbd|keygen|label|legend|li|map|mark|menu|meter|nav|noframes|noscript|object|ol|optgroup|output|p|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video).*?<\/\2>/i.test(value);
}
function validateNumber(value) {
    var v = parseFloat(value);
    return isNaN(v) ? {
        msg: "Invalid Number ".concat(value)
    } : v;
}
function orElse(a, onError) {
    return isError(a) ? onError() : a;
}
function isError(a) {
    return a != null && typeof a === "object" && "msg" in a;
}
function validateFontType(value) {
    if (value === "google-fonts") return "google-fonts";
    else if (value === "custom") return "custom";
    else return {
        msg: "Invalid font type ".concat(value)
    };
}

// EXTERNAL MODULE: ./node_modules/lodash/mergeWith.js
var mergeWith = __webpack_require__(30236);
var mergeWith_default = /*#__PURE__*/__webpack_require__.n(mergeWith);
// EXTERNAL MODULE: ./node_modules/lodash/isArray.js
var isArray = __webpack_require__(1469);
var isArray_default = /*#__PURE__*/__webpack_require__.n(isArray);
// EXTERNAL MODULE: ./node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(32521);
// EXTERNAL MODULE: ./node_modules/fp-ts/es6/Either.js + 2 modules
var Either = __webpack_require__(48973);
// EXTERNAL MODULE: ./node_modules/fp-ts/es6/function.js
var es6_function = __webpack_require__(3735);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/codec/codecUtils.ts


var codecUtils_decoderErrors = function(v) {
    return (0,es6_function/* pipe */.zG)(v, (0,Either/* fold */.g_)(function(errors) {
        return errors.map(function(error) {
            var last = error.context[error.context.length - 1];
            var expecting = last.type.name;
            var got = last.actual;
            var path = error.context.map(function(param) {
                var key = param.key;
                return key;
            }).join(".");
            var message = "".concat(path, ": expecting ").concat(expecting, ", got ").concat(got);
            return message;
        });
    }, function() {
        return [];
    }));
};


;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/analytics/analytics.ts
function clickEvent(eventLabel) {
    var eventCat = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "CTA";
    //Google Event
    if (window.gtag) {
        GoogleEvent("click", eventLabel, eventCat);
    }
    if (window.fbq) {
        FacebookEvent("click", eventLabel);
    }
    //MixPanel
    if (window.mixpanel) {
        MixPanelEvent("click", eventLabel);
    }
}
function pageView(eventType, route) {
    //Google Event
    if (window.gtag) {
        GoogleEvent(eventType, route, eventType);
    }
    //MixPanel
    if (window.mixpanel) {
        MixPanelEvent(eventType, route);
    }
}
function pageScroll(percentage) {
    if (window.gtag) {
        GoogleEvent("scroll", "Page scroll", "Page scroll", percentage);
    }
}
function elementInViewport(el) {
    if (window.gtag) {
        GoogleEvent("element_in_viewport", "Viewport: ".concat(el.id), "Element in Viewport", el.id);
    }
}
function elementLoaded(el) {
    if (window.gtag) {
        GoogleEvent("element_loaded", "Loaded: ".concat(el.id), "Element Loaded", el.id);
    }
}
function formInput(el, formId) {
    if (window.gtag) {
        GoogleEvent("form_input", "Input: ".concat(el.target.placeholder), "Form ".concat(formId), el.target.placeholder);
    }
}
function GoogleEvent(eventType, eventLabel, eventCat) {
    var value = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
    window.gtag("event", eventType, {
        event_label: removeHTMLTags(eventLabel),
        event_category: eventCat,
        value: value,
        nonInteraction: false
    });
}
function removeHTMLTags(possibleHtml) {
    return possibleHtml.replace(/<\/?[^>]+(>|$)/g, "");
}
function MixPanelEvent(eventType, eventLabel) {
    window.mixpanel.track(eventType, {
        where: eventLabel
    });
}
function FacebookEvent(eventType, eventLabel) {
    window.fbq("track", eventType, {
        content_name: eventLabel,
        content_category: "CTA"
    });
}
//utils
function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobUtils.ts


// Returns the values ready to be added to the <a>
function getLinkAttributes(inlineField, content, pageResponse, post) {
    var ref;
    var isPostPath = (ref = components_getOverrideInlineContentValues("".concat(inlineField, ".behaviour-link-mappedValue"), content)) === null || ref === void 0 ? void 0 : ref.startsWith("$");
    var linkAttrs = {};
    //(templateStyles.behaviour && (templateStyles.behaviour.link.enable && ((templateStyles.behaviour.link.customUrl && templateStyles.behaviour.link.customUrl !== '') || isPostPath)))
    if (components_getOverrideInlineContentValues("".concat(inlineField, ".behaviour-link-enable"), content) && (components_getOverrideInlineContentValues("".concat(inlineField, ".behaviour-link-customUrl"), content) && components_getOverrideInlineContentValues("".concat(inlineField, ".behaviour-link-customUrl"), content) !== "" || isPostPath)) {
        linkAttrs["href"] = handleComponentLinks(content.inlineContent, inlineField, pageResponse, content.overrides, post);
        linkAttrs["target"] = components_getOverrideInlineContentValues("".concat(inlineField, ".behaviour-link-target"), content);
        linkAttrs["rel"] = linkAttrs["href"] && linkAttrs["href"].startsWith("http") ? "noopener" : "";
    }
    return linkAttrs;
}
// Returns the label to classify the event in google analytics
// According to this doc: https://fluxio.atlassian.net/wiki/spaces/DEV/pages/329449473/Analytics
function analyticsLinkLabel(inlineField, content, pageResponse, post) {
    var mappedValue = components_getOverrideInlineContentValues("".concat(inlineField, ".behaviour-link-mappedValue"), content);
    var url = handleComponentLinks(content.inlineContent, inlineField, pageResponse, content.overrides, post);
    var linkAnalyticsLabel = "";
    if (mappedValue === null || mappedValue === void 0 ? void 0 : mappedValue.startsWith("$")) linkAnalyticsLabel === "cms:".concat(url);
    if (mappedValue === "custom") linkAnalyticsLabel = "url:".concat(url);
    if (mappedValue === "page") linkAnalyticsLabel = "page:".concat(url);
    if (mappedValue === "anchor") linkAnalyticsLabel = "anchor:".concat(url);
    return linkAnalyticsLabel;
}
function bobUtils_clickEvent(e, tag, field, inlineContent, overrides, pageResponse, post) {
    if (tag === "a") {
        var ref;
        var linkLabel = analyticsLinkLabel(field, {
            inlineContent: inlineContent,
            overrides: overrides
        }, pageResponse, post);
        //get parent id to properly know who has the link configured
        var parentId = (ref = e.target.parentElement) === null || ref === void 0 ? void 0 : ref.id;
        if (parentId) {
            GoogleEvent("link_click", linkLabel, "Link Clicked", 1);
        }
    }
}
function emPreviewClass(isExperienceManage, styleId) {
    return isExperienceManage ? "spacing-preview-".concat(styleId) : "";
}
function emScrollId(isExperienceManager, objectUuid) {
    return isExperienceManager ? {
        "data-id": "object-".concat(objectUuid)
    } : {};
}
function bobUtils_showIfWritten(object, key) {
    return key in object ? "".concat(key, ": ").concat(object[key], ";") : "";
}
function get2(x, y) {
    return typeof x === "undefined" ? y : x;
}
function bobUtils_get2WithNull(x, y) {
    return typeof x === "undefined" || x === null ? y : x;
}
function get2WithNull4Enable(x, y) {
    return typeof x === "undefined" || x === null ? y === true ? y : x : x;
}
function get3WithNull(x, y, k, z) {
    var ref;
    return typeof x === "undefined" || x === null ? (ref = y !== null && y !== void 0 ? y : k) !== null && ref !== void 0 ? ref : z : x;
}
function get3WithNull4Enable(x, y, k, z) {
    var ref;
    return typeof x === "undefined" || x === null ? (ref = y !== null && y !== void 0 ? y : k) !== null && ref !== void 0 ? ref : z === true ? z : k : x;
}
/**
 * Deals with default value if condition is true
 *
 * @param x state/breakpoint value
 * @param y default value
 * @param c condition
 * @returns x | y
 */ function bobUtils_get2WithNullConditional(x, y, c) {
    if (c) return bobUtils_get2WithNull(x, y);
    return x;
}
/**
 * Deals with default value if condition is true
 *
 * @param x state/breakpoint value
 * @param y default value
 * @param c condition
 * @returns x | y
 */ function get3WithNullConditional(x, y, k, z, c) {
    if (c) get3WithNull(x, y, k, z);
    return x;
}
function renderImportant(shouldRenderImportant) {
    return shouldRenderImportant ? " !important" : "";
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/shadowStyle.ts






//Temp to handle nulls
var nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
/**
 * We should only check for property and undefined
 * this solution is only until we fix the null being send around the page object
 */ // props only, no enable
var ShadowPropsCodec = (0,es6/* type */.dt)({
    inset: es6/* boolean */.O7,
    offsetH: es6/* number */.pk,
    offsetV: es6/* number */.pk,
    spread: es6/* number */.pk,
    blur: es6/* number */.pk,
    color: es6/* string */.Z_
});
var ShadowCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    ShadowPropsCodec
]);
// props only, no enable
var ShadowPropsOptCodec = (0,es6/* partial */.r$)({
    inset: nullable(es6/* boolean */.O7),
    offsetH: nullable(es6/* number */.pk),
    offsetV: nullable(es6/* number */.pk),
    spread: nullable(es6/* number */.pk),
    blur: nullable(es6/* number */.pk),
    color: nullable(es6/* string */.Z_)
});
var ShadowOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: nullable(es6/* boolean */.O7)
    }),
    ShadowPropsOptCodec
]);
var StylesShadowCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        shadow: ShadowCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                shadow: ShadowOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                shadow: ShadowOptCodec
            })
        }),
        mobile: (0,es6/* partial */.r$)({
            shadow: ShadowOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    shadow: ShadowOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    shadow: ShadowOptCodec
                })
            })
        }),
        tablet: (0,es6/* partial */.r$)({
            shadow: ShadowOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    shadow: ShadowOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    shadow: ShadowOptCodec
                })
            })
        })
    }), 
]);
var GSShadowCodec = (0,es6/* intersection */.jV)([
    ShadowPropsCodec,
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: ShadowPropsOptCodec,
            hover: ShadowPropsOptCodec
        }),
        mobile: (0,es6/* intersection */.jV)([
            ShadowPropsOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: ShadowPropsOptCodec,
                    hover: ShadowPropsOptCodec
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            ShadowPropsOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: ShadowPropsOptCodec,
                    hover: ShadowPropsOptCodec
                })
            }), 
        ])
    }), 
]);
function boxShadowCss(css) {
    if (css.hasOwnProperty("box-shadow")) return "box-shadow: ".concat(css["box-shadow"], ";");
    return "";
}
function textShadowCss(css) {
    if (css.hasOwnProperty("text-shadow")) return "text-shadow: ".concat(css["text-shadow"], ";");
    return "";
}
function responsiveStyle(shadowObj, optionalProperties, desktopDefaultValues, breakpointDefaultValues) {
    var hasEnable = shadowObj.hasOwnProperty("enable");
    if (hasEnable && !utils_objValueExists(shadowObj, "enable")) return "";
    /**
   * Check if property is available, and fallback to breakpointDefault or the desktopDefault
   */ var inset = (shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.inset) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.inset) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.inset);
    var offsetH = (shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetH) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.offsetH) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.offsetH);
    var offsetV = (shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetV) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.offsetV) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.offsetV);
    var blur = (shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.blur) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.blur) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.blur);
    var color = (shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.color) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.color) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.color);
    var spread = (shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.spread) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.spread) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.spread);
    // other props like text-shadow
    if (optionalProperties && optionalProperties.shadowType) {
        if (hasEnable && !shadowObj.enable) return (0,src_define_property/* default */.Z)({}, "".concat(optionalProperties.shadowType, "-shadow"), "none !important");
        return (0,src_define_property/* default */.Z)({}, "".concat(optionalProperties.shadowType, "-shadow"), "".concat(inset ? "inset " : "").concat(offsetH, "px ").concat(offsetV, "px ").concat(blur, "px ").concat(color, " !important"));
    }
    // box shadow prop
    if (hasEnable && !shadowObj.enable) return {
        "box-shadow": "none !important"
    };
    return {
        "box-shadow": "".concat(inset ? "inset " : "").concat(offsetH, "px ").concat(offsetV, "px ").concat(blur, "px ").concat(spread, "px ").concat(color, " !important")
    };
}
function cssRenderUnsafe(stylesObj, breakpoint, behaviourState, shadowType) {
    var foundationStyle = arguments.length > 4 && arguments[4] !== void 0 // TODO: fix when working on other bobs
     ? arguments[4] : undefined;
    var styles = StylesShadowCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return cssRender(styles.right, breakpoint, behaviourState, shadowType, foundationStyle);
    console.warn(codecUtils_decoderErrors(styles));
    return {};
}
function globalStyleCssRenderUnsafe(gsObj, breakpoint, behaviourState, shadowType) {
    var foundationStyle = arguments.length > 4 && arguments[4] !== void 0 // TODO: Work on when foundation is added to global styles
     ? arguments[4] : undefined;
    var gs = GSShadowCodec.decode(gsObj);
    if ((0,Either/* isRight */.tO)(gs)) return globalStyleCssRender(gs.right, breakpoint, behaviourState, shadowType, foundationStyle);
    console.warn(codecUtils_decoderErrors(gs));
    return {};
}
function zIndexFix(desktopDefaultShadowEnable, desktopDefaultScroll, objPosition) {
    if (desktopDefaultShadowEnable === false) {
        return "";
    }
    if (typeof objPosition === "number") {
        var defaultZIndex = 20;
        var computedZIndex = defaultZIndex - objPosition;
        var cssPosition = desktopDefaultScroll.enable && desktopDefaultScroll.value === "static" || !desktopDefaultScroll.enable ? "relative" : desktopDefaultScroll.value;
        if (computedZIndex <= 0) {
            return {
                "z-index": "1 !important",
                position: "".concat(cssPosition, " !important")
            };
        }
        return {
            "z-index": "".concat(computedZIndex, " !important"),
            position: "".concat(cssPosition, " !important")
        };
    }
    return "";
}
function cssRender(stylesObj, breakpoint, behaviourState, shadowType, foundationStyle) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return renderBob(stylesObj.shadow, shadowType, foundationStyle);
        } else {
            var ref, ref1;
            return renderBobOpt(mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.shadow, stylesObj.shadow), shadowType, foundationStyle);
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return renderBobOpt(mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.shadow, stylesObj.shadow), shadowType, foundationStyle);
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return renderBobOpt(mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.shadow, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.shadow, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.shadow, stylesObj.shadow), shadowType, foundationStyle);
        }
    }
}
function globalStyleCssRender(stylesObj, breakpoint, behaviourState, shadowType, foundationStyle) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return render(stylesObj, shadowType, foundationStyle);
        } else {
            var ref;
            return renderOpt(merge2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : ref[behaviourState], stylesObj), shadowType, foundationStyle);
        }
    } else {
        if (behaviourState === "default") {
            return renderOpt(merge2(stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj), shadowType, foundationStyle);
        } else {
            var ref1, ref2, ref3;
            return renderOpt(merge3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref1 = stylesObj[breakpoint]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : ref2[behaviourState], (ref3 = stylesObj.behaviour) === null || ref3 === void 0 ? void 0 : ref3[behaviourState], stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj), shadowType, foundationStyle);
        }
    }
}
function renderBob(shadowObj, shadowType, foundationStyle) {
    if (!shadowObj.enable) return cssProperty("none !important", shadowType);
    return render(shadowObj, shadowType, foundationStyle);
}
function renderBobOpt(shadowObj, shadowType, foundationStyle) {
    if ((shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.enable) === false) return cssProperty("none !important", shadowType);
    if (shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.enable) return renderOpt(shadowObj, shadowType, foundationStyle);
    return {};
}
function render(shadowObj, shadowType, foundationStyle) {
    var isBox = shadowType === "box" ? " ".concat(shadowObj.spread, "px") : "";
    var cssValue = "".concat(shadowObj.inset ? "inset " : "").concat(shadowObj.offsetH, "px ").concat(shadowObj.offsetV, "px ").concat(shadowObj.blur, "px").concat(isBox, " ").concat(shadowObj.color, " !important");
    // TODO: foundation color reverted
    // }px${isBox} ${foundationStyle ? foundationStyle.color : shadowObj.color} !important`
    return cssProperty(cssValue, shadowType);
}
function renderOpt(shadowObj, shadowType, foundationStyle) {
    if (utils_objValueExists(shadowObj, "inset") || utils_objValueExists(shadowObj, "offsetH") || utils_objValueExists(shadowObj, "offsetV") || utils_objValueExists(shadowObj, "blur") || utils_objValueExists(shadowObj, "color") || utils_objValueExists(shadowObj, "spread")) {
        var isBox = shadowType === "box" ? " ".concat(shadowObj.spread, "px") : "";
        var cssValue = "".concat(shadowObj.inset ? "inset " : "").concat(shadowObj.offsetH, "px ").concat(shadowObj.offsetV, "px ").concat(shadowObj.blur, "px").concat(isBox, " ").concat(shadowObj.color, " !important");
        // TODO: foundation color reverted
        // }px${isBox} ${foundationStyle ? foundationStyle.color : shadowObj.color} !important`
        return cssProperty(cssValue, shadowType);
    }
    return {};
}
function cssProperty(cssValue, shadowType) {
    return shadowType === "box" ? {
        "box-shadow": cssValue
    } : {
        "text-shadow": cssValue
    };
}
/**
 *
 * @param shadowObj
 * @param defaultShadowObj
 * @returns Shadow
 *
 */ function mergeBob2(shadowObj, defaultShadowObj) {
    if (!shadowObj) {
        return {
            enable: undefined,
            inset: undefined,
            offsetH: undefined,
            offsetV: undefined,
            blur: undefined,
            color: undefined,
            spread: undefined
        };
    }
    var enable = get2WithNull4Enable(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.enable, defaultShadowObj.enable);
    //if one of the values is set in the breakpoint we render the entire shadow property
    if (utils_objValueExists(shadowObj, "inset") || utils_objValueExists(shadowObj, "offsetH") || utils_objValueExists(shadowObj, "offsetV") || utils_objValueExists(shadowObj, "blur") || utils_objValueExists(shadowObj, "color") || utils_objValueExists(shadowObj, "spread")) {
        var inset = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.inset, defaultShadowObj.inset);
        var offsetH = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetH, defaultShadowObj.offsetH);
        var offsetV = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetV, defaultShadowObj.offsetV);
        var blur = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.blur, defaultShadowObj.blur);
        var color = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.color, defaultShadowObj.color);
        var spread = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.spread, defaultShadowObj.spread);
        return {
            enable: enable,
            inset: inset,
            offsetH: offsetH,
            offsetV: offsetV,
            blur: blur,
            color: color,
            spread: spread
        };
    }
    return {
        enable: shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.enable,
        inset: undefined,
        offsetH: undefined,
        offsetV: undefined,
        blur: undefined,
        color: undefined,
        spread: undefined
    };
}
/**
 *
 * @param shadowObj
 * @param defaultShadowObj
 * @returns ShadowProps
 *
 */ function merge2(shadowObj, defaultShadowObj) {
    if (!shadowObj) {
        return {
            inset: undefined,
            offsetH: undefined,
            offsetV: undefined,
            blur: undefined,
            color: undefined,
            spread: undefined
        };
    }
    if (utils_objValueExists(shadowObj, "inset") || utils_objValueExists(shadowObj, "offsetH") || utils_objValueExists(shadowObj, "offsetV") || utils_objValueExists(shadowObj, "blur") || utils_objValueExists(shadowObj, "color") || utils_objValueExists(shadowObj, "spread")) {
        var inset = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.inset, defaultShadowObj.inset);
        var offsetH = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetH, defaultShadowObj.offsetH);
        var offsetV = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetV, defaultShadowObj.offsetV);
        var blur = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.blur, defaultShadowObj.blur);
        var color = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.color, defaultShadowObj.color);
        var spread = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.spread, defaultShadowObj.spread);
        return {
            inset: inset,
            offsetH: offsetH,
            offsetV: offsetV,
            blur: blur,
            color: color,
            spread: spread
        };
    }
    return {
        inset: undefined,
        offsetH: undefined,
        offsetV: undefined,
        blur: undefined,
        color: undefined,
        spread: undefined
    };
}
/**
 *
 * @param shadowObj
 * @param shadowDefaultBreakpoint
 * @param defaultShadowObj
 * @returns Shadow
 */ function mergeBob3(shadowObj, shadowDesktopBehaviour, shadowDefaultBreakpoint, defaultShadowObj) {
    if (!shadowObj) {
        return {
            enable: undefined,
            inset: undefined,
            offsetH: undefined,
            offsetV: undefined,
            blur: undefined,
            color: undefined,
            spread: undefined
        };
    }
    var enable = get3WithNull4Enable(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.enable, shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.enable, shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.enable, defaultShadowObj.enable);
    if (utils_objValueExists(shadowObj, "inset") || utils_objValueExists(shadowObj, "offsetH") || utils_objValueExists(shadowObj, "offsetV") || utils_objValueExists(shadowObj, "blur") || utils_objValueExists(shadowObj, "color") || utils_objValueExists(shadowObj, "spread")) {
        var ref, ref1, ref2;
        var inset = (ref2 = (ref1 = (ref = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.inset) !== null && ref !== void 0 ? ref : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.inset) !== null && ref1 !== void 0 ? ref1 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.inset) !== null && ref2 !== void 0 ? ref2 : defaultShadowObj.inset;
        var ref3, ref4, ref5;
        var offsetH = (ref5 = (ref4 = (ref3 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetH) !== null && ref3 !== void 0 ? ref3 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.offsetH) !== null && ref4 !== void 0 ? ref4 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.offsetH) !== null && ref5 !== void 0 ? ref5 : defaultShadowObj.offsetH;
        var ref6, ref7, ref8;
        var offsetV = (ref8 = (ref7 = (ref6 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetV) !== null && ref6 !== void 0 ? ref6 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.offsetV) !== null && ref7 !== void 0 ? ref7 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.offsetV) !== null && ref8 !== void 0 ? ref8 : defaultShadowObj.offsetV;
        var ref9, ref10, ref11;
        var blur = (ref11 = (ref10 = (ref9 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.blur) !== null && ref9 !== void 0 ? ref9 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.blur) !== null && ref10 !== void 0 ? ref10 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.blur) !== null && ref11 !== void 0 ? ref11 : defaultShadowObj.blur;
        var ref12, ref13, ref14;
        var color = (ref14 = (ref13 = (ref12 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.color) !== null && ref12 !== void 0 ? ref12 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.color) !== null && ref13 !== void 0 ? ref13 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.color) !== null && ref14 !== void 0 ? ref14 : defaultShadowObj.color;
        var ref15, ref16, ref17;
        var spread = (ref17 = (ref16 = (ref15 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.spread) !== null && ref15 !== void 0 ? ref15 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.spread) !== null && ref16 !== void 0 ? ref16 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.spread) !== null && ref17 !== void 0 ? ref17 : defaultShadowObj.spread;
        return {
            enable: enable,
            inset: inset,
            offsetH: offsetH,
            offsetV: offsetV,
            blur: blur,
            color: color,
            spread: spread
        };
    }
    return {
        enable: shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.enable,
        inset: undefined,
        offsetH: undefined,
        offsetV: undefined,
        blur: undefined,
        color: undefined,
        spread: undefined
    };
}
/**
 *
 * @param shadowObj
 * @param shadowDefaultBreakpoint
 * @param defaultShadowObj
 * @returns Shadow
 */ function merge3(shadowObj, shadowDesktopBehaviour, shadowDefaultBreakpoint, defaultShadowObj) {
    if (!shadowObj) {
        return {
            inset: undefined,
            offsetH: undefined,
            offsetV: undefined,
            blur: undefined,
            color: undefined,
            spread: undefined
        };
    }
    if (utils_objValueExists(shadowObj, "inset") || utils_objValueExists(shadowObj, "offsetH") || utils_objValueExists(shadowObj, "offsetV") || utils_objValueExists(shadowObj, "blur") || utils_objValueExists(shadowObj, "color") || utils_objValueExists(shadowObj, "spread")) {
        var ref, ref1, ref2;
        var inset = (ref2 = (ref1 = (ref = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.inset) !== null && ref !== void 0 ? ref : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.inset) !== null && ref1 !== void 0 ? ref1 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.inset) !== null && ref2 !== void 0 ? ref2 : defaultShadowObj.inset;
        var ref3, ref4, ref5;
        var offsetH = (ref5 = (ref4 = (ref3 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetH) !== null && ref3 !== void 0 ? ref3 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.offsetH) !== null && ref4 !== void 0 ? ref4 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.offsetH) !== null && ref5 !== void 0 ? ref5 : defaultShadowObj.offsetH;
        var ref6, ref7, ref8;
        var offsetV = (ref8 = (ref7 = (ref6 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetV) !== null && ref6 !== void 0 ? ref6 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.offsetV) !== null && ref7 !== void 0 ? ref7 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.offsetV) !== null && ref8 !== void 0 ? ref8 : defaultShadowObj.offsetV;
        var ref9, ref10, ref11;
        var blur = (ref11 = (ref10 = (ref9 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.blur) !== null && ref9 !== void 0 ? ref9 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.blur) !== null && ref10 !== void 0 ? ref10 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.blur) !== null && ref11 !== void 0 ? ref11 : defaultShadowObj.blur;
        var ref12, ref13, ref14;
        var color = (ref14 = (ref13 = (ref12 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.color) !== null && ref12 !== void 0 ? ref12 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.color) !== null && ref13 !== void 0 ? ref13 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.color) !== null && ref14 !== void 0 ? ref14 : defaultShadowObj.color;
        var ref15, ref16, ref17;
        var spread = (ref17 = (ref16 = (ref15 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.spread) !== null && ref15 !== void 0 ? ref15 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.spread) !== null && ref16 !== void 0 ? ref16 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.spread) !== null && ref17 !== void 0 ? ref17 : defaultShadowObj.spread;
        return {
            inset: inset,
            offsetH: offsetH,
            offsetV: offsetV,
            blur: blur,
            color: color,
            spread: spread
        };
    }
    return {
        inset: undefined,
        offsetH: undefined,
        offsetV: undefined,
        blur: undefined,
        color: undefined,
        spread: undefined
    };
}


// EXTERNAL MODULE: ./node_modules/fp-ts/lib/Either.js
var lib_Either = __webpack_require__(45974);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/boundaryStyle.ts








//Temp to handle nulls
var boundaryStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
var BMarginPropsCodec = (0,es6/* type */.dt)({
    top: (0,es6/* union */.G0)([
        es6/* number */.pk,
        (0,es6/* literal */.i0)("auto")
    ]),
    bottom: (0,es6/* union */.G0)([
        es6/* number */.pk,
        (0,es6/* literal */.i0)("auto")
    ]),
    left: (0,es6/* union */.G0)([
        es6/* number */.pk,
        (0,es6/* literal */.i0)("auto")
    ]),
    right: (0,es6/* union */.G0)([
        es6/* number */.pk,
        (0,es6/* literal */.i0)("auto")
    ])
});
var BPaddingPropsCodec = (0,es6/* type */.dt)({
    top: es6/* number */.pk,
    bottom: es6/* number */.pk,
    left: es6/* number */.pk,
    right: es6/* number */.pk
});
var BoundaryPropsCodec = (0,es6/* type */.dt)({
    margin: BMarginPropsCodec,
    padding: BPaddingPropsCodec
});
var BoundaryCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    BoundaryPropsCodec
]);
var BMarginPropsOptCodec = (0,es6/* partial */.r$)({
    top: boundaryStyle_nullable((0,es6/* union */.G0)([
        es6/* number */.pk,
        (0,es6/* literal */.i0)("auto")
    ])),
    bottom: boundaryStyle_nullable((0,es6/* union */.G0)([
        es6/* number */.pk,
        (0,es6/* literal */.i0)("auto")
    ])),
    left: boundaryStyle_nullable((0,es6/* union */.G0)([
        es6/* number */.pk,
        (0,es6/* literal */.i0)("auto")
    ])),
    right: boundaryStyle_nullable((0,es6/* union */.G0)([
        es6/* number */.pk,
        (0,es6/* literal */.i0)("auto")
    ]))
});
var BPaddingPropsOptCodec = (0,es6/* partial */.r$)({
    top: boundaryStyle_nullable(es6/* number */.pk),
    bottom: boundaryStyle_nullable(es6/* number */.pk),
    left: boundaryStyle_nullable(es6/* number */.pk),
    right: boundaryStyle_nullable(es6/* number */.pk)
});
var BoundaryPropsOptCodec = (0,es6/* partial */.r$)({
    margin: BMarginPropsOptCodec,
    padding: BPaddingPropsOptCodec
});
var BoundaryOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: boundaryStyle_nullable(es6/* boolean */.O7)
    }),
    BoundaryPropsOptCodec
]);
var StylesBoundaryCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        spacing: BoundaryCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                spacing: BoundaryOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                spacing: BoundaryOptCodec
            })
        }),
        mobile: (0,es6/* partial */.r$)({
            spacing: BoundaryOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    spacing: BoundaryOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    spacing: BoundaryOptCodec
                })
            })
        }),
        tablet: (0,es6/* partial */.r$)({
            spacing: BoundaryOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    spacing: BoundaryOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    spacing: BoundaryOptCodec
                })
            })
        })
    }), 
]);
var GSBoundaryCodec = (0,es6/* intersection */.jV)([
    BoundaryPropsCodec,
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: BoundaryPropsOptCodec,
            hover: BoundaryPropsOptCodec
        }),
        mobile: (0,es6/* intersection */.jV)([
            BoundaryPropsOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: BoundaryPropsOptCodec,
                    hover: BoundaryPropsOptCodec
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            BoundaryPropsOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: BoundaryPropsOptCodec,
                    hover: BoundaryPropsOptCodec
                })
            }), 
        ])
    }), 
]);
function boundaryStyle_responsiveStyle(boundaryObj) {
    if (boundaryObj.hasOwnProperty("enable") && !boundaryObj.enable) return {
        "margin-top": "0 !important",
        "margin-right": "0 !important",
        "margin-bottom": "0 !important",
        "margin-left": "0 !important",
        "padding-top": "0 !important",
        "padding-right": "0 !important",
        "padding-bottom": "0 !important",
        "padding-left": "0 !important"
    };
    var boundaryStyle = {};
    if (boundaryObj.margin) {
        for(var side in boundaryObj.margin){
            boundaryStyle = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, boundaryStyle), (0,src_define_property/* default */.Z)({}, "margin-".concat(side), boundaryObj.margin[side] + "px !important"));
        }
    }
    if (boundaryObj.padding) {
        for(var side1 in boundaryObj.padding){
            boundaryStyle = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, boundaryStyle), (0,src_define_property/* default */.Z)({}, "padding-".concat(side1), boundaryObj.padding[side1] + "px !important"));
        }
    }
    return boundaryStyle;
}
function renderCSSString(boundaryStyle) {
    return "\n    ".concat(bobUtils_showIfWritten(boundaryStyle, "margin-bottom"), " \n    ").concat(bobUtils_showIfWritten(boundaryStyle, "margin-top"), " \n    ").concat(bobUtils_showIfWritten(boundaryStyle, "margin-left"), " \n    ").concat(bobUtils_showIfWritten(boundaryStyle, "margin-right"), " \n    ").concat(bobUtils_showIfWritten(boundaryStyle, "padding-bottom"), " \n    ").concat(bobUtils_showIfWritten(boundaryStyle, "padding-top"), " \n    ").concat(bobUtils_showIfWritten(boundaryStyle, "padding-left"), " \n    ").concat(bobUtils_showIfWritten(boundaryStyle, "padding-right"), " \n    ");
}
function boundaryStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var styles = StylesBoundaryCodec.decode(stylesObj);
    if ((0,lib_Either.isRight)(styles)) return boundaryStyle_cssRender(styles.right, breakpoint, behaviourState);
    console.warn("BoundaryStyle ".concat(breakpoint, " ").concat(behaviourState, " ").concat(codecUtils_decoderErrors(styles)));
    return {};
}
function boundaryStyle_globalStyleCssRenderUnsafe(gsObj, breakpoint, behaviourState) {
    var gs = GSBoundaryCodec.decode(gsObj);
    if ((0,lib_Either.isRight)(gs)) return boundaryStyle_globalStyleCssRender(gs.right, breakpoint, behaviourState);
    console.warn("BoundaryGSStyle ".concat(breakpoint, " ").concat(behaviourState, " ").concat(codecUtils_decoderErrors(gs)));
    return {};
}
function boundaryStyle_globalStyleCssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return boundaryStyle_render(stylesObj);
        } else {
            var ref;
            return boundaryStyle_renderOpt(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : ref[behaviourState]);
        }
    } else {
        if (behaviourState === "default") {
            return boundaryStyle_renderOpt(stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint]);
        } else {
            var ref1, ref2;
            return boundaryStyle_renderOpt(stylesObj === null || stylesObj === void 0 ? void 0 : (ref1 = stylesObj[breakpoint]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : ref2[behaviourState]);
        }
    }
}
function boundaryStyle_cssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return boundaryStyle_renderBob(stylesObj.spacing);
        } else {
            var ref, ref1;
            return boundaryStyle_renderBobOpt(boundaryStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.spacing, stylesObj.spacing));
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return boundaryStyle_renderBobOpt(boundaryStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.spacing, stylesObj.spacing));
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return boundaryStyle_renderBobOpt(boundaryStyle_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.spacing, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.spacing, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.spacing, stylesObj.spacing));
        }
    }
}
function boundaryStyle_mergeBob3(boundaryObj, boundaryDesktopBehaviour, boundaryDefaultBreakpoint, defaultBoundaryObj) {
    var enable = get3WithNull4Enable(boundaryObj === null || boundaryObj === void 0 ? void 0 : boundaryObj.enable, boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : boundaryDesktopBehaviour.enable, boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : boundaryDefaultBreakpoint.enable, defaultBoundaryObj.enable);
    return {
        enable: enable,
        margin: boundaryObj === null || boundaryObj === void 0 ? void 0 : boundaryObj.margin,
        padding: boundaryObj === null || boundaryObj === void 0 ? void 0 : boundaryObj.padding
    };
}
function boundaryStyle_merge3(boundaryObj, boundaryDesktopBehaviour, boundaryDefaultBreakpoint, defaultBoundaryObj) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
    var ref24, ref25, ref26;
    var mTop = (ref26 = (ref25 = (ref24 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref = boundaryObj.margin) === null || ref === void 0 ? void 0 : ref.top) !== null && ref24 !== void 0 ? ref24 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref1 = boundaryDesktopBehaviour.margin) === null || ref1 === void 0 ? void 0 : ref1.top) !== null && ref25 !== void 0 ? ref25 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref2 = boundaryDefaultBreakpoint.margin) === null || ref2 === void 0 ? void 0 : ref2.top) !== null && ref26 !== void 0 ? ref26 : defaultBoundaryObj.margin.top;
    var ref27, ref28, ref29;
    var mBottom = (ref29 = (ref28 = (ref27 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref3 = boundaryObj.margin) === null || ref3 === void 0 ? void 0 : ref3.bottom) !== null && ref27 !== void 0 ? ref27 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref4 = boundaryDesktopBehaviour.margin) === null || ref4 === void 0 ? void 0 : ref4.bottom) !== null && ref28 !== void 0 ? ref28 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref5 = boundaryDefaultBreakpoint.margin) === null || ref5 === void 0 ? void 0 : ref5.bottom) !== null && ref29 !== void 0 ? ref29 : defaultBoundaryObj.margin.bottom;
    var ref30, ref31, ref32;
    var mLeft = (ref32 = (ref31 = (ref30 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref6 = boundaryObj.margin) === null || ref6 === void 0 ? void 0 : ref6.left) !== null && ref30 !== void 0 ? ref30 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref7 = boundaryDesktopBehaviour.margin) === null || ref7 === void 0 ? void 0 : ref7.left) !== null && ref31 !== void 0 ? ref31 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref8 = boundaryDefaultBreakpoint.margin) === null || ref8 === void 0 ? void 0 : ref8.left) !== null && ref32 !== void 0 ? ref32 : defaultBoundaryObj.margin.left;
    var ref33, ref34, ref35;
    var mRight = (ref35 = (ref34 = (ref33 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref9 = boundaryObj.margin) === null || ref9 === void 0 ? void 0 : ref9.right) !== null && ref33 !== void 0 ? ref33 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref10 = boundaryDesktopBehaviour.margin) === null || ref10 === void 0 ? void 0 : ref10.right) !== null && ref34 !== void 0 ? ref34 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref11 = boundaryDefaultBreakpoint.margin) === null || ref11 === void 0 ? void 0 : ref11.right) !== null && ref35 !== void 0 ? ref35 : defaultBoundaryObj.margin.right;
    var ref36, ref37, ref38;
    var pTop = (ref38 = (ref37 = (ref36 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref12 = boundaryObj.padding) === null || ref12 === void 0 ? void 0 : ref12.top) !== null && ref36 !== void 0 ? ref36 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref13 = boundaryDesktopBehaviour.padding) === null || ref13 === void 0 ? void 0 : ref13.top) !== null && ref37 !== void 0 ? ref37 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref14 = boundaryDefaultBreakpoint.padding) === null || ref14 === void 0 ? void 0 : ref14.top) !== null && ref38 !== void 0 ? ref38 : defaultBoundaryObj.padding.top;
    var ref39, ref40, ref41;
    var pBottom = (ref41 = (ref40 = (ref39 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref15 = boundaryObj.padding) === null || ref15 === void 0 ? void 0 : ref15.bottom) !== null && ref39 !== void 0 ? ref39 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref16 = boundaryDesktopBehaviour.padding) === null || ref16 === void 0 ? void 0 : ref16.bottom) !== null && ref40 !== void 0 ? ref40 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref17 = boundaryDefaultBreakpoint.padding) === null || ref17 === void 0 ? void 0 : ref17.bottom) !== null && ref41 !== void 0 ? ref41 : defaultBoundaryObj.padding.bottom;
    var ref42, ref43, ref44;
    var pLeft = (ref44 = (ref43 = (ref42 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref18 = boundaryObj.padding) === null || ref18 === void 0 ? void 0 : ref18.left) !== null && ref42 !== void 0 ? ref42 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref19 = boundaryDesktopBehaviour.padding) === null || ref19 === void 0 ? void 0 : ref19.left) !== null && ref43 !== void 0 ? ref43 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref20 = boundaryDefaultBreakpoint.padding) === null || ref20 === void 0 ? void 0 : ref20.left) !== null && ref44 !== void 0 ? ref44 : defaultBoundaryObj.padding.left;
    var ref45, ref46, ref47;
    var pRight = (ref47 = (ref46 = (ref45 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref21 = boundaryObj.padding) === null || ref21 === void 0 ? void 0 : ref21.right) !== null && ref45 !== void 0 ? ref45 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref22 = boundaryDesktopBehaviour.padding) === null || ref22 === void 0 ? void 0 : ref22.right) !== null && ref46 !== void 0 ? ref46 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref23 = boundaryDefaultBreakpoint.padding) === null || ref23 === void 0 ? void 0 : ref23.right) !== null && ref47 !== void 0 ? ref47 : defaultBoundaryObj.padding.right;
    return {
        margin: {
            top: mTop,
            bottom: mBottom,
            left: mLeft,
            right: mRight
        },
        padding: {
            top: pTop,
            bottom: pBottom,
            left: pLeft,
            right: pRight
        }
    };
}
function boundaryStyle_mergeBob2(boundaryObj, defaultBoundaryObj) {
    var enable = get2WithNull4Enable(boundaryObj === null || boundaryObj === void 0 ? void 0 : boundaryObj.enable, defaultBoundaryObj.enable);
    return {
        enable: enable,
        margin: boundaryObj === null || boundaryObj === void 0 ? void 0 : boundaryObj.margin,
        padding: boundaryObj === null || boundaryObj === void 0 ? void 0 : boundaryObj.padding
    };
}
function boundaryStyle_merge2(boundaryObj, defaultBoundaryObj) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var mTop = get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref = boundaryObj.margin) === null || ref === void 0 ? void 0 : ref.top, defaultBoundaryObj.margin.top);
    var mBottom = get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref1 = boundaryObj.margin) === null || ref1 === void 0 ? void 0 : ref1.bottom, defaultBoundaryObj.margin.bottom);
    var mRight = get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref2 = boundaryObj.margin) === null || ref2 === void 0 ? void 0 : ref2.right, defaultBoundaryObj.margin.right);
    var mLeft = get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref3 = boundaryObj.margin) === null || ref3 === void 0 ? void 0 : ref3.left, defaultBoundaryObj.margin.left);
    var pTop = get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref4 = boundaryObj.padding) === null || ref4 === void 0 ? void 0 : ref4.top, defaultBoundaryObj.padding.top);
    var pBottom = get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref5 = boundaryObj.padding) === null || ref5 === void 0 ? void 0 : ref5.bottom, defaultBoundaryObj.padding.bottom);
    var pRight = get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref6 = boundaryObj.padding) === null || ref6 === void 0 ? void 0 : ref6.right, defaultBoundaryObj.padding.right);
    var pLeft = get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref7 = boundaryObj.padding) === null || ref7 === void 0 ? void 0 : ref7.left, defaultBoundaryObj.padding.left);
    return {
        margin: {
            top: mTop,
            bottom: mBottom,
            left: mLeft,
            right: mRight
        },
        padding: {
            top: pTop,
            bottom: pBottom,
            left: pLeft,
            right: pRight
        }
    };
}
function boundaryStyle_renderBob(boundaryObj) {
    if (boundaryObj.enable === false) return {
        "margin-top": "0px !important",
        "margin-right": "0px !important",
        "margin-bottom": "0px !important",
        "margin-left": "0px !important",
        "padding-top": "0px !important",
        "padding-right": "0px !important",
        "padding-bottom": "0px !important",
        "padding-left": "0px !important"
    };
    return boundaryStyle_render(boundaryObj);
}
/**
 * Renders ColorsOpt css for breakpoints/state templates
 * or empty for non written style props
 *
 * @param colorsObj
 * @param foundationStyle
 * @returns
 */ function boundaryStyle_renderBobOpt(boundaryObj) {
    if ((boundaryObj === null || boundaryObj === void 0 ? void 0 : boundaryObj.enable) === false) return {
        "margin-top": "0px !important",
        "margin-right": "0px !important",
        "margin-bottom": "0px !important",
        "margin-left": "0px !important",
        "padding-top": "0px !important",
        "padding-right": "0px !important",
        "padding-bottom": "0px !important",
        "padding-left": "0px !important"
    };
    if ((boundaryObj === null || boundaryObj === void 0 ? void 0 : boundaryObj.enable) === true) {
        return boundaryStyle_renderOpt(boundaryObj);
    }
    return {};
}
function boundaryStyle_render(boundaryObj) {
    return {
        "margin-top": "".concat(boundaryObj.margin.top, "px !important"),
        "margin-right": "".concat(boundaryObj.margin.right, "px !important"),
        "margin-bottom": "".concat(boundaryObj.margin.bottom, "px !important"),
        "margin-left": "".concat(boundaryObj.margin.left, "px !important"),
        "padding-top": "".concat(boundaryObj.padding.top, "px !important"),
        "padding-right": "".concat(boundaryObj.padding.right, "px !important"),
        "padding-bottom": "".concat(boundaryObj.padding.bottom, "px !important"),
        "padding-left": "".concat(boundaryObj.padding.left, "px !important")
    };
}
/**
 * Renders ColorOpt css for breakpoints/state templates
 * Returns color
 * or empty for non written style props
 *
 * @param colorValue
 * @param foundationStyle
 * @returns
 */ function boundaryStyle_renderOpt(boundaryObj) {
    var margin = boundaryObj === null || boundaryObj === void 0 ? void 0 : boundaryObj.margin;
    var padding = boundaryObj === null || boundaryObj === void 0 ? void 0 : boundaryObj.padding;
    var css = {};
    if (valueExists(margin === null || margin === void 0 ? void 0 : margin.top)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "margin-top": "".concat(margin === null || margin === void 0 ? void 0 : margin.top, "px !important")
    });
    if (valueExists(margin === null || margin === void 0 ? void 0 : margin.bottom)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "margin-bottom": "".concat(margin === null || margin === void 0 ? void 0 : margin.bottom, "px !important")
    });
    if (valueExists(margin === null || margin === void 0 ? void 0 : margin.left)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "margin-left": "".concat(margin === null || margin === void 0 ? void 0 : margin.left, "px !important")
    });
    if (valueExists(margin === null || margin === void 0 ? void 0 : margin.right)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "margin-right": "".concat(margin === null || margin === void 0 ? void 0 : margin.right, "px !important")
    });
    if (valueExists(padding === null || padding === void 0 ? void 0 : padding.top)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "padding-top": "".concat(padding === null || padding === void 0 ? void 0 : padding.top, "px !important")
    });
    if (valueExists(padding === null || padding === void 0 ? void 0 : padding.bottom)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "padding-bottom": "".concat(padding === null || padding === void 0 ? void 0 : padding.bottom, "px !important")
    });
    if (valueExists(padding === null || padding === void 0 ? void 0 : padding.left)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "padding-left": "".concat(padding === null || padding === void 0 ? void 0 : padding.left, "px !important")
    });
    if (valueExists(padding === null || padding === void 0 ? void 0 : padding.right)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "padding-right": "".concat(padding === null || padding === void 0 ? void 0 : padding.right, "px !important")
    });
    return css;
}


;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/borderStyle.ts







var borderStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
var borderStyleCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("none"),
    (0,es6/* literal */.i0)("solid"),
    (0,es6/* literal */.i0)("dashed"),
    (0,es6/* literal */.i0)("dotted")
]);
var BorderPropsCodec = (0,es6/* type */.dt)({
    bottomColor: es6/* string */.Z_,
    bottomEnable: es6/* boolean */.O7,
    bottomStyle: borderStyleCodec,
    bottomWidth: es6/* number */.pk,
    topColor: es6/* string */.Z_,
    topEnable: es6/* boolean */.O7,
    topStyle: borderStyleCodec,
    topWidth: es6/* number */.pk,
    leftColor: es6/* string */.Z_,
    leftEnable: es6/* boolean */.O7,
    leftStyle: borderStyleCodec,
    leftWidth: es6/* number */.pk,
    rightColor: es6/* string */.Z_,
    rightEnable: es6/* boolean */.O7,
    rightStyle: borderStyleCodec,
    rightWidth: es6/* number */.pk
});
var BorderCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    BorderPropsCodec
]);
var BorderPropsOptCodec = (0,es6/* partial */.r$)({
    bottomColor: borderStyle_nullable(es6/* string */.Z_),
    bottomEnable: borderStyle_nullable(es6/* boolean */.O7),
    bottomStyle: borderStyle_nullable(borderStyleCodec),
    bottomWidth: borderStyle_nullable(es6/* number */.pk),
    topColor: borderStyle_nullable(es6/* string */.Z_),
    topEnable: borderStyle_nullable(es6/* boolean */.O7),
    topStyle: borderStyle_nullable(borderStyleCodec),
    topWidth: borderStyle_nullable(es6/* number */.pk),
    leftColor: borderStyle_nullable(es6/* string */.Z_),
    leftEnable: borderStyle_nullable(es6/* boolean */.O7),
    leftStyle: borderStyle_nullable(borderStyleCodec),
    leftWidth: borderStyle_nullable(es6/* number */.pk),
    rightColor: borderStyle_nullable(es6/* string */.Z_),
    rightEnable: borderStyle_nullable(es6/* boolean */.O7),
    rightStyle: borderStyle_nullable(borderStyleCodec),
    rightWidth: borderStyle_nullable(es6/* number */.pk)
});
var BorderOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: borderStyle_nullable(es6/* boolean */.O7)
    }),
    BorderPropsOptCodec
]);
var StylesBorderCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        border: BorderCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                border: BorderOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                border: BorderOptCodec
            })
        }),
        mobile: (0,es6/* partial */.r$)({
            border: BorderOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    border: BorderOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    border: BorderOptCodec
                })
            })
        }),
        tablet: (0,es6/* partial */.r$)({
            border: BorderOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    border: BorderOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    border: BorderOptCodec
                })
            })
        })
    }), 
]);
var GSBorderCodec = (0,es6/* intersection */.jV)([
    BorderPropsCodec,
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: BorderPropsOptCodec,
            hover: BorderPropsOptCodec
        }),
        mobile: (0,es6/* intersection */.jV)([
            BorderPropsOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: BorderPropsOptCodec,
                    hover: BorderPropsOptCodec
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            BorderPropsOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: BorderPropsOptCodec,
                    hover: BorderPropsOptCodec
                })
            }), 
        ])
    }), 
]);
function borderStyle_responsiveStyle(borderObj) {
    if (borderObj.hasOwnProperty("enable") && !utils_objValueExists(borderObj, "enable")) return "";
    if (borderObj.hasOwnProperty("enable") && !borderObj.enable) return {
        "border-top": "none !important",
        "border-right": "none !important",
        "border-bottom": "none !important",
        "border-left": "none !important"
    };
    var borderTop = borderObj.topEnable ? "".concat(borderObj.topWidth, "px ").concat(borderObj.topStyle, " ").concat(borderObj.topColor, " !important") : "none !important";
    var borderRight = borderObj.rightEnable ? "".concat(borderObj.rightWidth, "px ").concat(borderObj.rightStyle, " ").concat(borderObj.rightColor, " !important") : "none !important";
    var borderBottom = borderObj.bottomEnable ? "".concat(borderObj.bottomWidth, "px ").concat(borderObj.bottomStyle, " ").concat(borderObj.bottomColor, " !important") : "none !important";
    var borderLeft = borderObj.leftEnable ? "".concat(borderObj.leftWidth, "px ").concat(borderObj.leftStyle, " ").concat(borderObj.leftColor, " !important") : "none !important";
    return {
        "border-top": borderTop,
        "border-right": borderRight,
        "border-bottom": borderBottom,
        "border-left": borderLeft
    };
}
function borderStyle_renderCSSString(borderStyle) {
    return "\n    ".concat(bobUtils_showIfWritten(borderStyle, "border-bottom-style"), " \n    ").concat(bobUtils_showIfWritten(borderStyle, "border-bottom-width"), " \n    ").concat(bobUtils_showIfWritten(borderStyle, "border-bottom-color"), "  \n    ").concat(bobUtils_showIfWritten(borderStyle, "border-top-style"), " \n    ").concat(bobUtils_showIfWritten(borderStyle, "border-top-width"), " \n    ").concat(bobUtils_showIfWritten(borderStyle, "border-top-color"), "  \n    ").concat(bobUtils_showIfWritten(borderStyle, "border-left-style"), " \n    ").concat(bobUtils_showIfWritten(borderStyle, "border-left-width"), " \n    ").concat(bobUtils_showIfWritten(borderStyle, "border-left-color"), "  \n    ").concat(bobUtils_showIfWritten(borderStyle, "border-right-style"), " \n    ").concat(bobUtils_showIfWritten(borderStyle, "border-right-width"), " \n    ").concat(bobUtils_showIfWritten(borderStyle, "border-right-color"), "\n    ");
}
function borderStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var styles = StylesBorderCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return borderStyle_cssRender(styles.right, breakpoint, behaviourState);
    console.warn(breakpoint, behaviourState, codecUtils_decoderErrors(styles));
    return {
        "border-bottom-style": "none !important",
        "border-bottom-width": "0 !important",
        "border-bottom-color": "#fff !important",
        "border-top-style": "none !important",
        "border-top-width": "0 !important",
        "border-top-color": "#fff !important",
        "border-left-style": "none !important",
        "border-left-width": "0 !important",
        "border-left-color": "#fff !important",
        "border-right-style": "none !important",
        "border-right-width": "0 !important",
        "border-right-color": "#fff !important"
    };
}
function borderStyle_globalStyleCssRenderUnsafe(gsObj, breakpoint, behaviourState) {
    var gs = GSBorderCodec.decode(gsObj);
    if (isRight(gs)) return borderStyle_globalStyleCssRender(gs.right, breakpoint, behaviourState);
    console.warn(decoderErrors(gs));
    return {
        "border-bottom-style": "none !important",
        "border-bottom-width": "0 !important",
        "border-bottom-color": "#fff !important",
        "border-top-style": "none !important",
        "border-top-width": "0 !important",
        "border-top-color": "#fff !important",
        "border-left-style": "none !important",
        "border-left-width": "0 !important",
        "border-left-color": "#fff !important",
        "border-right-style": "none !important",
        "border-right-width": "0 !important",
        "border-right-color": "#fff !important"
    };
}
function borderStyle_cssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return borderStyle_renderBob(stylesObj.border);
        } else {
            var ref, ref1;
            return borderStyle_renderBobOpt(borderStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.border, stylesObj.border));
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return borderStyle_renderBobOpt(borderStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.border, stylesObj.border));
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return borderStyle_renderBobOpt(borderStyle_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.border, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.border, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.border, stylesObj.border));
        }
    }
}
function borderStyle_globalStyleCssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return borderStyle_render(stylesObj);
        } else {
            var ref;
            return borderStyle_render(borderStyle_merge2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : ref[behaviourState], stylesObj));
        }
    } else {
        if (behaviourState === "default") {
            return borderStyle_render(borderStyle_merge2(stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj));
        } else {
            var ref1, ref2, ref3;
            return borderStyle_render(borderStyle_merge3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref1 = stylesObj[breakpoint]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : ref2[behaviourState], (ref3 = stylesObj.behaviour) === null || ref3 === void 0 ? void 0 : ref3[behaviourState], stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj));
        }
    }
}
function borderStyle_renderBob(borderObj) {
    if (borderObj.enable === false) return {
        "border-bottom-style": "none !important",
        "border-bottom-width": "0 !important",
        "border-bottom-color": "#fff !important",
        "border-top-style": "none !important",
        "border-top-width": "0 !important",
        "border-top-color": "#fff !important",
        "border-left-style": "none !important",
        "border-left-width": "0 !important",
        "border-left-color": "#fff !important",
        "border-right-style": "none !important",
        "border-right-width": "0 !important",
        "border-right-color": "#fff !important"
    };
    return borderStyle_render(borderObj);
}
function borderStyle_renderBobOpt(borderObj) {
    if (borderObj.enable === false) return {
        "border-bottom-style": "none !important",
        "border-bottom-width": "0 !important",
        "border-bottom-color": "#fff !important",
        "border-top-style": "none !important",
        "border-top-width": "0 !important",
        "border-top-color": "#fff !important",
        "border-left-style": "none !important",
        "border-left-width": "0 !important",
        "border-left-color": "#fff !important",
        "border-right-style": "none !important",
        "border-right-width": "0 !important",
        "border-right-color": "#fff !important"
    };
    if (borderObj.enable === true) return borderStyle_renderOpt(borderObj);
    return {};
}
function borderStyle_render(borderObj) {
    return {
        "border-bottom-style": "".concat(borderObj.bottomEnable ? borderObj.bottomStyle : "none", " !important"),
        "border-bottom-width": "".concat(borderObj.bottomEnable ? borderObj.bottomWidth : "0", "px !important"),
        "border-bottom-color": "".concat(borderObj.bottomEnable ? borderObj.bottomColor : "#fff", " !important"),
        "border-top-style": "".concat(borderObj.topEnable ? borderObj.topStyle : "none", " !important"),
        "border-top-width": "".concat(borderObj.topEnable ? borderObj.topWidth : "0", "px !important"),
        "border-top-color": "".concat(borderObj.topEnable ? borderObj.topColor : "#fff", " !important"),
        "border-left-style": "".concat(borderObj.leftEnable ? borderObj.leftStyle : "none", " !important"),
        "border-left-width": "".concat(borderObj.leftEnable ? borderObj.leftWidth : "0", "px !important"),
        "border-left-color": "".concat(borderObj.leftEnable ? borderObj.leftColor : "#fff", " !important"),
        "border-right-style": "".concat(borderObj.rightEnable ? borderObj.rightStyle : "none", " !important"),
        "border-right-width": "".concat(borderObj.rightEnable ? borderObj.rightWidth : "0", "px !important"),
        "border-right-color": "".concat(borderObj.rightEnable ? borderObj.rightColor : "#fff", " !important")
    };
}
function borderStyle_renderOpt(borderObj) {
    var cssProperties = {};
    if (valueExists(borderObj.bottomEnable) && borderObj.bottomEnable) {
        if (valueExists(borderObj.bottomWidth)) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-bottom-width": "".concat(borderObj.bottomWidth, "px !important")
        });
        if (valueExists(borderObj.bottomStyle)) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-bottom-style": "".concat(borderObj.bottomStyle, " !important")
        });
        if (valueExists(borderObj.bottomColor)) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-bottom-color": "".concat(borderObj.bottomColor, " !important")
        });
    }
    if (valueExists(borderObj.topEnable) && borderObj.topEnable) {
        if (valueExists(borderObj.topWidth)) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-top-width": "".concat(borderObj.topWidth, "px !important")
        });
        if (valueExists(borderObj.topStyle)) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-top-style": "".concat(borderObj.topStyle, " !important")
        });
        if (valueExists(borderObj.topColor)) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-top-color": "".concat(borderObj.topColor, " !important")
        });
    }
    if (valueExists(borderObj.leftEnable) && borderObj.leftEnable) {
        if (valueExists(borderObj.leftWidth)) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-left-width": "".concat(borderObj.leftWidth, "px !important")
        });
        if (valueExists(borderObj.leftStyle)) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-left-style": "".concat(borderObj.leftStyle, " !important")
        });
        if (valueExists(borderObj.leftColor)) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-left-color": "".concat(borderObj.leftColor, " !important")
        });
    }
    if (valueExists(borderObj.rightEnable) && borderObj.rightEnable) {
        if (valueExists(borderObj.rightWidth)) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-right-width": "".concat(borderObj.rightWidth, "px !important")
        });
        if (valueExists(borderObj.rightStyle)) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-right-style": "".concat(borderObj.rightStyle, " !important")
        });
        if (valueExists(borderObj.rightColor)) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-right-color": "".concat(borderObj.rightColor, " !important")
        });
    }
    return cssProperties;
}
function borderStyle_mergeBob2(borderObj, defaultBorderObj) {
    var enable = get2WithNull4Enable(borderObj === null || borderObj === void 0 ? void 0 : borderObj.enable, defaultBorderObj.enable);
    var bottomEnable = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomEnable, defaultBorderObj.bottomEnable);
    var topEnable = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.topEnable, defaultBorderObj.topEnable);
    var leftEnable = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftEnable, defaultBorderObj.leftEnable);
    var rightEnable = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightEnable, defaultBorderObj.rightEnable);
    return {
        enable: enable,
        bottomColor: borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomColor,
        bottomStyle: borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomStyle,
        bottomWidth: borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomWidth,
        bottomEnable: bottomEnable,
        topColor: borderObj === null || borderObj === void 0 ? void 0 : borderObj.topColor,
        topStyle: borderObj === null || borderObj === void 0 ? void 0 : borderObj.topStyle,
        topWidth: borderObj === null || borderObj === void 0 ? void 0 : borderObj.topWidth,
        topEnable: topEnable,
        leftColor: borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftColor,
        leftStyle: borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftStyle,
        leftWidth: borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftWidth,
        leftEnable: leftEnable,
        rightColor: borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightColor,
        rightStyle: borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightStyle,
        rightWidth: borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightWidth,
        rightEnable: rightEnable
    };
}
function borderStyle_merge2(borderObj, defaultBorderObj) {
    var bottomColor = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomColor, defaultBorderObj.bottomColor);
    var bottomStyle = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomStyle, defaultBorderObj.bottomStyle);
    var bottomWidth = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomWidth, defaultBorderObj.bottomWidth);
    var bottomEnable = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomEnable, defaultBorderObj.bottomEnable);
    var topColor = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.topColor, defaultBorderObj.topColor);
    var topStyle = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.topStyle, defaultBorderObj.topStyle);
    var topWidth = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.topWidth, defaultBorderObj.topWidth);
    var topEnable = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.topEnable, defaultBorderObj.topEnable);
    var leftColor = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftColor, defaultBorderObj.leftColor);
    var leftStyle = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftStyle, defaultBorderObj.leftStyle);
    var leftWidth = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftWidth, defaultBorderObj.leftWidth);
    var leftEnable = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftEnable, defaultBorderObj.leftEnable);
    var rightColor = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightColor, defaultBorderObj.rightColor);
    var rightStyle = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightStyle, defaultBorderObj.rightStyle);
    var rightWidth = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightWidth, defaultBorderObj.rightWidth);
    var rightEnable = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightEnable, defaultBorderObj.rightEnable);
    return {
        bottomColor: bottomColor,
        bottomStyle: bottomStyle,
        bottomWidth: bottomWidth,
        bottomEnable: bottomEnable,
        topColor: topColor,
        topStyle: topStyle,
        topWidth: topWidth,
        topEnable: topEnable,
        leftColor: leftColor,
        leftStyle: leftStyle,
        leftWidth: leftWidth,
        leftEnable: leftEnable,
        rightColor: rightColor,
        rightStyle: rightStyle,
        rightWidth: rightWidth,
        rightEnable: rightEnable
    };
}
function borderStyle_mergeBob3(borderObj, borderDesktopBehaviour, borderDefaultBreakpoint, defaultBorderObj) {
    var enable = get3WithNull4Enable(borderObj === null || borderObj === void 0 ? void 0 : borderObj.enable, borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.enable, borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.enable, defaultBorderObj.enable);
    var ref, ref1, ref2;
    var bottomEnable = (ref2 = (ref1 = (ref = borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomEnable) !== null && ref !== void 0 ? ref : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.bottomEnable) !== null && ref1 !== void 0 ? ref1 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.bottomEnable) !== null && ref2 !== void 0 ? ref2 : defaultBorderObj.bottomEnable;
    var ref3, ref4, ref5;
    var topEnable = (ref5 = (ref4 = (ref3 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.topEnable) !== null && ref3 !== void 0 ? ref3 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.topEnable) !== null && ref4 !== void 0 ? ref4 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.topEnable) !== null && ref5 !== void 0 ? ref5 : defaultBorderObj.topEnable;
    var ref6, ref7, ref8;
    var leftEnable = (ref8 = (ref7 = (ref6 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftEnable) !== null && ref6 !== void 0 ? ref6 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.leftEnable) !== null && ref7 !== void 0 ? ref7 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.leftEnable) !== null && ref8 !== void 0 ? ref8 : defaultBorderObj.leftEnable;
    var ref9, ref10, ref11;
    var rightEnable = (ref11 = (ref10 = (ref9 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightEnable) !== null && ref9 !== void 0 ? ref9 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.rightEnable) !== null && ref10 !== void 0 ? ref10 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.rightEnable) !== null && ref11 !== void 0 ? ref11 : defaultBorderObj.rightEnable;
    return {
        enable: enable,
        bottomColor: borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomColor,
        bottomStyle: borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomStyle,
        bottomWidth: borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomWidth,
        bottomEnable: bottomEnable,
        topColor: borderObj === null || borderObj === void 0 ? void 0 : borderObj.topColor,
        topStyle: borderObj === null || borderObj === void 0 ? void 0 : borderObj.topStyle,
        topWidth: borderObj === null || borderObj === void 0 ? void 0 : borderObj.topWidth,
        topEnable: topEnable,
        leftColor: borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftColor,
        leftStyle: borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftStyle,
        leftWidth: borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftWidth,
        leftEnable: leftEnable,
        rightColor: borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightColor,
        rightStyle: borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightStyle,
        rightWidth: borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightWidth,
        rightEnable: rightEnable
    };
}
function borderStyle_merge3(borderObj, borderDesktopBehaviour, borderDefaultBreakpoint, defaultBorderObj) {
    var ref, ref1, ref2;
    var bottomColor = (ref2 = (ref1 = (ref = borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomColor) !== null && ref !== void 0 ? ref : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.bottomColor) !== null && ref1 !== void 0 ? ref1 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.bottomColor) !== null && ref2 !== void 0 ? ref2 : defaultBorderObj.bottomColor;
    var ref3, ref4, ref5;
    var bottomStyle = (ref5 = (ref4 = (ref3 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomStyle) !== null && ref3 !== void 0 ? ref3 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.bottomStyle) !== null && ref4 !== void 0 ? ref4 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.bottomStyle) !== null && ref5 !== void 0 ? ref5 : defaultBorderObj.bottomStyle;
    var ref6, ref7, ref8;
    var bottomWidth = (ref8 = (ref7 = (ref6 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomWidth) !== null && ref6 !== void 0 ? ref6 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.bottomWidth) !== null && ref7 !== void 0 ? ref7 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.bottomWidth) !== null && ref8 !== void 0 ? ref8 : defaultBorderObj.bottomWidth;
    var ref9, ref10, ref11;
    var bottomEnable = (ref11 = (ref10 = (ref9 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomEnable) !== null && ref9 !== void 0 ? ref9 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.bottomEnable) !== null && ref10 !== void 0 ? ref10 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.bottomEnable) !== null && ref11 !== void 0 ? ref11 : defaultBorderObj.bottomEnable;
    var ref12, ref13, ref14;
    var topColor = (ref14 = (ref13 = (ref12 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.topColor) !== null && ref12 !== void 0 ? ref12 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.topColor) !== null && ref13 !== void 0 ? ref13 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.topColor) !== null && ref14 !== void 0 ? ref14 : defaultBorderObj.topColor;
    var ref15, ref16, ref17;
    var topStyle = (ref17 = (ref16 = (ref15 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.topStyle) !== null && ref15 !== void 0 ? ref15 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.topStyle) !== null && ref16 !== void 0 ? ref16 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.topStyle) !== null && ref17 !== void 0 ? ref17 : defaultBorderObj.topStyle;
    var ref18, ref19, ref20;
    var topWidth = (ref20 = (ref19 = (ref18 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.topWidth) !== null && ref18 !== void 0 ? ref18 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.topWidth) !== null && ref19 !== void 0 ? ref19 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.topWidth) !== null && ref20 !== void 0 ? ref20 : defaultBorderObj.topWidth;
    var ref21, ref22, ref23;
    var topEnable = (ref23 = (ref22 = (ref21 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.topEnable) !== null && ref21 !== void 0 ? ref21 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.topEnable) !== null && ref22 !== void 0 ? ref22 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.topEnable) !== null && ref23 !== void 0 ? ref23 : defaultBorderObj.topEnable;
    var ref24, ref25, ref26;
    var leftColor = (ref26 = (ref25 = (ref24 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftColor) !== null && ref24 !== void 0 ? ref24 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.leftColor) !== null && ref25 !== void 0 ? ref25 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.leftColor) !== null && ref26 !== void 0 ? ref26 : defaultBorderObj.leftColor;
    var ref27, ref28, ref29;
    var leftStyle = (ref29 = (ref28 = (ref27 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftStyle) !== null && ref27 !== void 0 ? ref27 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.leftStyle) !== null && ref28 !== void 0 ? ref28 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.leftStyle) !== null && ref29 !== void 0 ? ref29 : defaultBorderObj.leftStyle;
    var ref30, ref31, ref32;
    var leftWidth = (ref32 = (ref31 = (ref30 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftWidth) !== null && ref30 !== void 0 ? ref30 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.leftWidth) !== null && ref31 !== void 0 ? ref31 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.leftWidth) !== null && ref32 !== void 0 ? ref32 : defaultBorderObj.leftWidth;
    var ref33, ref34, ref35;
    var leftEnable = (ref35 = (ref34 = (ref33 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftEnable) !== null && ref33 !== void 0 ? ref33 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.leftEnable) !== null && ref34 !== void 0 ? ref34 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.leftEnable) !== null && ref35 !== void 0 ? ref35 : defaultBorderObj.leftEnable;
    var ref36, ref37, ref38;
    var rightColor = (ref38 = (ref37 = (ref36 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightColor) !== null && ref36 !== void 0 ? ref36 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.rightColor) !== null && ref37 !== void 0 ? ref37 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.rightColor) !== null && ref38 !== void 0 ? ref38 : defaultBorderObj.rightColor;
    var ref39, ref40, ref41;
    var rightStyle = (ref41 = (ref40 = (ref39 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightStyle) !== null && ref39 !== void 0 ? ref39 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.rightStyle) !== null && ref40 !== void 0 ? ref40 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.rightStyle) !== null && ref41 !== void 0 ? ref41 : defaultBorderObj.rightStyle;
    var ref42, ref43, ref44;
    var rightWidth = (ref44 = (ref43 = (ref42 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightWidth) !== null && ref42 !== void 0 ? ref42 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.rightWidth) !== null && ref43 !== void 0 ? ref43 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.rightWidth) !== null && ref44 !== void 0 ? ref44 : defaultBorderObj.rightWidth;
    var ref45, ref46, ref47;
    var rightEnable = (ref47 = (ref46 = (ref45 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightEnable) !== null && ref45 !== void 0 ? ref45 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.rightEnable) !== null && ref46 !== void 0 ? ref46 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.rightEnable) !== null && ref47 !== void 0 ? ref47 : defaultBorderObj.rightEnable;
    return {
        bottomColor: bottomColor,
        bottomStyle: bottomStyle,
        bottomWidth: bottomWidth,
        bottomEnable: bottomEnable,
        topColor: topColor,
        topStyle: topStyle,
        topWidth: topWidth,
        topEnable: topEnable,
        leftColor: leftColor,
        leftStyle: leftStyle,
        leftWidth: leftWidth,
        leftEnable: leftEnable,
        rightColor: rightColor,
        rightStyle: rightStyle,
        rightWidth: rightWidth,
        rightEnable: rightEnable
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/radiusStyle.ts







//Temp to handle nulls
var radiusStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
var RadiusCodec = (0,es6/* type */.dt)({
    bottomLeft: es6/* number */.pk,
    bottomRight: es6/* number */.pk,
    enable: es6/* boolean */.O7,
    topLeft: es6/* number */.pk,
    topRight: es6/* number */.pk
});
var RadiusOptCodec = (0,es6/* partial */.r$)({
    bottomLeft: radiusStyle_nullable(es6/* number */.pk),
    bottomRight: radiusStyle_nullable(es6/* number */.pk),
    enable: radiusStyle_nullable(es6/* boolean */.O7),
    topLeft: radiusStyle_nullable(es6/* number */.pk),
    topRight: radiusStyle_nullable(es6/* number */.pk)
});
var StylesRadiusCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        radius: RadiusCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                radius: RadiusOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                radius: RadiusOptCodec
            })
        }),
        mobile: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                radius: RadiusOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        radius: RadiusOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        radius: RadiusOptCodec
                    })
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                radius: RadiusOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        radius: RadiusOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        radius: RadiusOptCodec
                    })
                })
            }), 
        ])
    }), 
]);
function radiusStyle_responsiveStyle(radiusObj) {
    if (radiusObj.hasOwnProperty("enable") && !utils_objValueExists(radiusObj, "enable")) return "";
    if (radiusObj.hasOwnProperty("enable") && !radiusObj.enable) return {
        "border-radius": "0 !important"
    };
    return {
        "border-top-left-radius": "".concat(radiusObj.topLeft, "px !important"),
        "border-top-right-radius": "".concat(radiusObj.topRight, "px !important"),
        "border-bottom-left-radius": "".concat(radiusObj.bottomLeft, "px !important"),
        "border-bottom-right-radius": "".concat(radiusObj.bottomRight, "px !important")
    };
}
function radiusStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var styles = StylesRadiusCodec.decode(stylesObj);
    if ((0,lib_Either.isRight)(styles)) return radiusStyle_cssRender(styles.right, breakpoint, behaviourState);
    console.warn("RadiusStyle ".concat(breakpoint, " ").concat(behaviourState, " ").concat(codecUtils_decoderErrors(styles)));
    return {};
}
function radiusStyle_cssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return radiusStyle_renderBob(stylesObj.radius);
        } else {
            var ref, ref1;
            return radiusStyle_renderBobOpt(stylesObj.radius, radiusStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.radius, stylesObj.radius));
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return radiusStyle_renderBobOpt(stylesObj.radius, radiusStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.radius, stylesObj.radius));
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return radiusStyle_renderBobOpt(stylesObj.radius, radiusStyle_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.radius, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.radius, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.radius, stylesObj.radius));
        }
    }
}
function radiusStyle_renderBob(radiusObj) {
    if (!radiusObj.enable) return {};
    return radiusStyle_render(radiusObj);
}
/**
 * Renders ColorsOpt css for breakpoints/state templates
 * or empty for non written style props
 *
 * @param radiusObj
 * @param foundationStyle
 * @returns
 */ function radiusStyle_renderBobOpt(defaultRadiusObj, radiusObj) {
    if ((radiusObj === null || radiusObj === void 0 ? void 0 : radiusObj.enable) === false) {
        if (defaultRadiusObj.enable) return {
            "border-top-left-radius": "0px",
            "border-top-right-radius": "0px",
            "border-bottom-left-radius": "0px",
            "border-bottom-right-radius": "0px"
        };
        return {};
    }
    if (radiusObj === null || radiusObj === void 0 ? void 0 : radiusObj.enable) return radiusStyle_renderOpt(radiusObj);
    return {};
}
/**
 * Renders RadiusOpt css for breakpoints/state templates
 * Returns color
 * or empty for non written style props
 *
 * @param radiusObj
 * @param foundationStyle
 * @returns
 */ function radiusStyle_renderOpt(radiusObj) {
    var css = {};
    if (valueExists(radiusObj === null || radiusObj === void 0 ? void 0 : radiusObj.bottomLeft)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "border-bottom-left-radius": "".concat(radiusObj === null || radiusObj === void 0 ? void 0 : radiusObj.bottomLeft, "px")
    });
    if (valueExists(radiusObj === null || radiusObj === void 0 ? void 0 : radiusObj.bottomRight)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "border-bottom-right-radius": "".concat(radiusObj === null || radiusObj === void 0 ? void 0 : radiusObj.bottomRight, "px")
    });
    if (valueExists(radiusObj === null || radiusObj === void 0 ? void 0 : radiusObj.topLeft)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "border-top-left-radius": "".concat(radiusObj === null || radiusObj === void 0 ? void 0 : radiusObj.topLeft, "px")
    });
    if (valueExists(radiusObj === null || radiusObj === void 0 ? void 0 : radiusObj.topRight)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "border-top-right-radius": "".concat(radiusObj === null || radiusObj === void 0 ? void 0 : radiusObj.topRight, "px")
    });
    return css;
}
function radiusStyle_render(radiusObj) {
    return {
        "border-top-left-radius": "".concat(radiusObj.topLeft, "px"),
        "border-top-right-radius": "".concat(radiusObj.topRight, "px"),
        "border-bottom-left-radius": "".concat(radiusObj.bottomLeft, "px"),
        "border-bottom-right-radius": "".concat(radiusObj.bottomRight, "px")
    };
}
function radiusStyle_mergeBob2(radiusObj, defaultRadiusObj) {
    var enable = get2WithNull4Enable(radiusObj === null || radiusObj === void 0 ? void 0 : radiusObj.enable, defaultRadiusObj.enable);
    return {
        enable: enable,
        bottomLeft: radiusObj === null || radiusObj === void 0 ? void 0 : radiusObj.bottomLeft,
        bottomRight: radiusObj === null || radiusObj === void 0 ? void 0 : radiusObj.bottomRight,
        topLeft: radiusObj === null || radiusObj === void 0 ? void 0 : radiusObj.topLeft,
        topRight: radiusObj === null || radiusObj === void 0 ? void 0 : radiusObj.topRight
    };
}
function radiusStyle_mergeBob3(radiusObj, radiusDesktopBehaviour, radiusDefaultBreakpoint, defaultRadiusObj) {
    var enable = get3WithNull4Enable(radiusObj === null || radiusObj === void 0 ? void 0 : radiusObj.enable, radiusDesktopBehaviour === null || radiusDesktopBehaviour === void 0 ? void 0 : radiusDesktopBehaviour.enable, radiusDefaultBreakpoint === null || radiusDefaultBreakpoint === void 0 ? void 0 : radiusDefaultBreakpoint.enable, defaultRadiusObj.enable);
    return {
        enable: enable,
        bottomLeft: radiusObj === null || radiusObj === void 0 ? void 0 : radiusObj.bottomLeft,
        bottomRight: radiusObj === null || radiusObj === void 0 ? void 0 : radiusObj.bottomRight,
        topLeft: radiusObj === null || radiusObj === void 0 ? void 0 : radiusObj.topLeft,
        topRight: radiusObj === null || radiusObj === void 0 ? void 0 : radiusObj.topRight
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/alignmentStyle.ts




//Temp to handle nulls
var alignmentStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
// enable: true
// horizontal: "right"
// vertical: "center"
var VerticalCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("top"),
    (0,es6/* literal */.i0)("center"),
    (0,es6/* literal */.i0)("bottom")
]);
var HorizontalCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("left"),
    (0,es6/* literal */.i0)("center"),
    (0,es6/* literal */.i0)("right")
]);
var AlignmentPropsCodec = (0,es6/* type */.dt)({
    vertical: VerticalCodec,
    horizontal: HorizontalCodec
});
var AlignmentCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    AlignmentPropsCodec
]);
var AlignmentPropsOptCodec = (0,es6/* partial */.r$)({
    vertical: alignmentStyle_nullable(VerticalCodec),
    horizontal: alignmentStyle_nullable(HorizontalCodec)
});
var AlignmentOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: alignmentStyle_nullable(es6/* boolean */.O7)
    }),
    AlignmentPropsOptCodec
]);
var StylesAlignmentCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        alignment: AlignmentCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                alignment: AlignmentOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                alignment: AlignmentOptCodec
            })
        }),
        mobile: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                alignment: AlignmentOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        alignment: AlignmentOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        alignment: AlignmentOptCodec
                    })
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                alignment: AlignmentOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        alignment: AlignmentOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        alignment: AlignmentOptCodec
                    })
                })
            }), 
        ])
    }), 
]);
function AlignmentResponsiveStyle(alignmentObj, optionalProperties) {
    if (!alignmentObj.enable) return {};
    var horizontalValue = alignmentObj.horizontal === "left" ? "flex-start !important" : alignmentObj.horizontal === "right" ? "flex-end !important" : alignmentObj.horizontal + " !important";
    var verticalValue = alignmentObj.vertical === "top" ? "flex-start !important" : alignmentObj.vertical === "bottom" ? "flex-end !important" : alignmentObj.vertical + " !important";
    return {
        "justify-content": optionalProperties.flexDirection === "column" ? verticalValue : horizontalValue,
        "align-items": optionalProperties.flexDirection === "column" ? horizontalValue : verticalValue,
        "align-self": optionalProperties.self && optionalProperties.flexDirection === "column" ? horizontalValue : verticalValue,
        display: "flex !important",
        "flex-direction": optionalProperties.flexDirection && optionalProperties.flexDirection + " !important"
    };
}
function AlignmentCssRenderUnsafe(stylesObj, breakpoint, behaviourState, objectSpecific) {
    var styles = StylesAlignmentCodec.decode(stylesObj);
    if ((0,lib_Either.isRight)(styles)) return AlignmentCssRender(styles.right, breakpoint, behaviourState, objectSpecific);
    console.warn("breakpoint: ".concat(breakpoint, " / behaviourState: ").concat(behaviourState), codecUtils_decoderErrors(styles));
    return {
        "justify-content": "center !important",
        "align-items": "center !important",
        "align-self": "center !important",
        display: "flex !important",
        "flex-direction": "".concat(objectSpecific.flexDirection, " !important")
    };
}
function alignmentStyle_AlignmentCssClassRenderUnsafe(stylesObj, breakpoint, behaviourState, objectSpecific) {
    var styles = StylesAlignmentCodec.decode(stylesObj);
    if (isRight(styles)) return AlignmentCssClassRender(styles.right, breakpoint, behaviourState, objectSpecific);
    console.warn(decoderErrors(styles));
    return "d-flex justify-content-center align-items-center align-self-center flex-".concat(objectSpecific.flexDirection);
}
function AlignmentCssRender(stylesObj, breakpoint, behaviourState, objectSpecific) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return AlignmentRenderBob(stylesObj.alignment, objectSpecific);
        } else {
            var ref, ref1;
            return AlignmentRenderBob(AlignmentMergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.alignment, stylesObj.alignment), objectSpecific);
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return AlignmentRenderBob(AlignmentMergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.alignment, stylesObj.alignment), objectSpecific);
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return AlignmentRenderBob(AlignmentMergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.alignment, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.alignment, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.alignment, stylesObj.alignment), objectSpecific);
        }
    }
}
function AlignmentCssClassRender(stylesObj, breakpoint, behaviourState, objectSpecific) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return AlignmentRenderBobClass(stylesObj.alignment, objectSpecific, breakpoint);
        } else {
            var ref, ref1;
            return AlignmentRenderBobClass(AlignmentMergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.alignment, stylesObj.alignment), objectSpecific, breakpoint);
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return AlignmentRenderBobClass(AlignmentMergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.alignment, stylesObj.alignment), objectSpecific, breakpoint);
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return AlignmentRenderBobClass(AlignmentMergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.alignment, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.alignment, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.alignment, stylesObj.alignment), objectSpecific, breakpoint);
        }
    }
}
function AlignmentRenderBob(alignmentObj, objectSpecific) {
    if (!alignmentObj.enable) {
        //See https://fluxio.atlassian.net/wiki/spaces/DEV/pages/133464172/Alignment+changes
        //Browser defaults should be the ones being applied, instead of custom ones
        return {
            "justify-content": "center !important",
            "align-items": "center !important",
            "align-self": "center !important",
            display: "flex !important",
            "flex-direction": "".concat(objectSpecific.flexDirection, " !important")
        };
    }
    return AlignmentRender(alignmentObj, objectSpecific);
}
function AlignmentRenderBobClass(alignmentObj, objectSpecific, breakpoint) {
    if (!alignmentObj.enable) {
        //See https://fluxio.atlassian.net/wiki/spaces/DEV/pages/133464172/Alignment+changes
        //Browser defaults should be the ones being applied, instead of custom ones
        var breakpointClass = AlignmentRenderBreakpointClass(breakpoint);
        return "d".concat(breakpointClass, "-flex justify-content").concat(breakpointClass, "-center align-items").concat(breakpointClass, "-center align-self").concat(breakpointClass, "-center flex").concat(AlignmentRenderBreakpointClass(breakpoint), "-").concat(objectSpecific.flexDirection);
    }
    return AlignmentRenderClass(alignmentObj, objectSpecific, breakpoint);
}
function AlignmentRender(alignmentObj, objectSpecific) {
    var horizontalValue = alignmentObj.horizontal === "left" ? "flex-start !important" : alignmentObj.horizontal === "right" ? "flex-end !important" : alignmentObj.horizontal + " !important";
    var verticalValue = alignmentObj.vertical === "top" ? "flex-start !important" : alignmentObj.vertical === "bottom" ? "flex-end !important" : alignmentObj.vertical + " !important";
    return {
        "justify-content": objectSpecific.flexDirection === "column" ? verticalValue : horizontalValue,
        "align-items": objectSpecific.flexDirection === "column" ? horizontalValue : verticalValue,
        "align-self": objectSpecific.self ? objectSpecific.flexDirection === "column" ? horizontalValue : verticalValue : "auto !important",
        display: "flex !important",
        "flex-direction": "".concat(objectSpecific.flexDirection, " !important")
    };
}
function AlignmentRenderClass(alignmentObj, objectSpecific, breakpoint) {
    var breakpointClass = AlignmentRenderBreakpointClass(breakpoint);
    var horizontalValue = alignmentObj.horizontal === "left" ? "start" : alignmentObj.horizontal === "right" ? "end" : alignmentObj.horizontal;
    var verticalValue = alignmentObj.vertical === "top" ? "start" : alignmentObj.vertical === "bottom" ? "end" : alignmentObj.vertical;
    var justifyContent = "justify-content".concat(breakpointClass, "-").concat(objectSpecific.flexDirection === "column" ? verticalValue : horizontalValue);
    var alignItems = "align-items".concat(breakpointClass, "-").concat(objectSpecific.flexDirection === "column" ? horizontalValue : verticalValue);
    var alignSelf = "align-self".concat(breakpointClass, "-").concat(objectSpecific.self ? objectSpecific.flexDirection === "column" ? horizontalValue : verticalValue : "auto");
    var flexDirection = "flex".concat(breakpointClass, "-").concat(objectSpecific.flexDirection);
    return "d".concat(breakpointClass, "-flex ").concat(flexDirection, " ").concat(alignSelf, " ").concat(alignItems, " ").concat(justifyContent);
}
function AlignmentRenderBreakpointClass(breakpoint) {
    if (breakpoint === "desktop") return "";
    if (breakpoint === "tablet") return "-md";
    return "-sm";
}
function AlignmentMergeBob2(alignmentObj, defaultAlignmentObj) {
    var enable = bobUtils_get2WithNull(alignmentObj === null || alignmentObj === void 0 ? void 0 : alignmentObj.enable, defaultAlignmentObj.enable);
    var vertical = bobUtils_get2WithNull(alignmentObj === null || alignmentObj === void 0 ? void 0 : alignmentObj.vertical, defaultAlignmentObj.vertical);
    var horizontal = bobUtils_get2WithNull(alignmentObj === null || alignmentObj === void 0 ? void 0 : alignmentObj.horizontal, defaultAlignmentObj.horizontal);
    return {
        enable: enable,
        vertical: vertical,
        horizontal: horizontal
    };
}
function AlignmentMergeBob3(alignmentObj, alignmentDesktopBehaviour, alignmentDefaultBreakpoint, defaultAlignmentObj) {
    var ref, ref1, ref2;
    var enable = (ref2 = (ref1 = (ref = alignmentObj === null || alignmentObj === void 0 ? void 0 : alignmentObj.enable) !== null && ref !== void 0 ? ref : alignmentDesktopBehaviour === null || alignmentDesktopBehaviour === void 0 ? void 0 : alignmentDesktopBehaviour.enable) !== null && ref1 !== void 0 ? ref1 : alignmentDefaultBreakpoint === null || alignmentDefaultBreakpoint === void 0 ? void 0 : alignmentDefaultBreakpoint.enable) !== null && ref2 !== void 0 ? ref2 : defaultAlignmentObj.enable;
    var ref3, ref4, ref5;
    var vertical = (ref5 = (ref4 = (ref3 = alignmentObj === null || alignmentObj === void 0 ? void 0 : alignmentObj.vertical) !== null && ref3 !== void 0 ? ref3 : alignmentDesktopBehaviour === null || alignmentDesktopBehaviour === void 0 ? void 0 : alignmentDesktopBehaviour.vertical) !== null && ref4 !== void 0 ? ref4 : alignmentDefaultBreakpoint === null || alignmentDefaultBreakpoint === void 0 ? void 0 : alignmentDefaultBreakpoint.vertical) !== null && ref5 !== void 0 ? ref5 : defaultAlignmentObj.vertical;
    var ref6, ref7, ref8;
    var horizontal = (ref8 = (ref7 = (ref6 = alignmentObj === null || alignmentObj === void 0 ? void 0 : alignmentObj.horizontal) !== null && ref6 !== void 0 ? ref6 : alignmentDesktopBehaviour === null || alignmentDesktopBehaviour === void 0 ? void 0 : alignmentDesktopBehaviour.horizontal) !== null && ref7 !== void 0 ? ref7 : alignmentDefaultBreakpoint === null || alignmentDefaultBreakpoint === void 0 ? void 0 : alignmentDefaultBreakpoint.horizontal) !== null && ref8 !== void 0 ? ref8 : defaultAlignmentObj.horizontal;
    return {
        enable: enable,
        vertical: vertical,
        horizontal: horizontal
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/filterStyle.ts





//Temp to handle nulls
var filterStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
var FilterPropsCodec = (0,es6/* type */.dt)({
    blur: es6/* number */.pk,
    opacity: es6/* number */.pk,
    brightness: es6/* number */.pk,
    contrast: es6/* number */.pk,
    grayscale: es6/* number */.pk,
    hueRotation: es6/* number */.pk,
    invert: es6/* number */.pk,
    saturate: es6/* number */.pk,
    sepia: es6/* number */.pk,
    shadow: es6/* number */.pk,
    enable: es6/* boolean */.O7
});
var FilterCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    FilterPropsCodec
]);
var FilterPropsOptCodec = (0,es6/* partial */.r$)({
    blur: filterStyle_nullable(es6/* number */.pk),
    opacity: filterStyle_nullable(es6/* number */.pk),
    brightness: filterStyle_nullable(es6/* number */.pk),
    contrast: filterStyle_nullable(es6/* number */.pk),
    grayscale: filterStyle_nullable(es6/* number */.pk),
    hueRotation: filterStyle_nullable(es6/* number */.pk),
    invert: filterStyle_nullable(es6/* number */.pk),
    saturate: filterStyle_nullable(es6/* number */.pk),
    sepia: filterStyle_nullable(es6/* number */.pk),
    shadow: filterStyle_nullable(es6/* number */.pk),
    enable: filterStyle_nullable(es6/* boolean */.O7)
});
var FilterOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: filterStyle_nullable(es6/* boolean */.O7)
    }),
    FilterPropsOptCodec
]);
var StylesFilterCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        filter: FilterCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                filter: FilterOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                filter: FilterOptCodec
            })
        }),
        mobile: (0,es6/* partial */.r$)({
            filter: FilterOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    filter: FilterOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    filter: FilterOptCodec
                })
            })
        }),
        tablet: (0,es6/* partial */.r$)({
            filter: FilterOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    filter: FilterOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    filter: FilterOptCodec
                })
            })
        })
    }), 
]);
function filterStyle_responsiveStyle(filterObj, optionalProperties) {
    // filter is disabled
    if (filterObj.hasOwnProperty("enable") && !filterObj.enable) return {
        filter: "none !important",
        "background-color": "transparent !important"
    };
    // retrun color overlay only
    if (optionalProperties && optionalProperties.type === "overlay") {
        var colorOverlay = "".concat(filterObj.overlay && filterObj.overlay !== "" ? filterObj.overlay + "!important" : "none !important");
        return {
            "background-color": colorOverlay
        };
    }
    // return filter
    var blur = "".concat(filterObj.blur && filterObj.blur !== 0 ? "blur(".concat(filterObj.blur, "px)") : "");
    var opacity = "".concat(filterObj.opacity && filterObj.opacity !== 0 ? "opacity(".concat(filterObj.opacity, "%)") : "");
    var brightness = "".concat(filterObj.brightness ? "brightness(".concat(filterObj.brightness, "%)") : "");
    var contrast = "".concat(filterObj.contrast ? "contrast(".concat(filterObj.contrast, "%)") : "");
    var grayscale = "".concat(filterObj.grayscale && filterObj.grayscale !== 0 ? "grayscale(".concat(filterObj.grayscale, "%)") : "");
    var hueRotate = "".concat(filterObj.hueRotate && filterObj.hueRotate !== 0 ? "hue-rotate(".concat(filterObj.hueRotate, "deg)") : "");
    var invert = "".concat(filterObj.invert && filterObj.invert !== 0 ? "invert(".concat(filterObj.invert, "%)") : "");
    var saturate = "".concat(filterObj.saturate && filterObj.saturate !== 0 ? "saturate(".concat(filterObj.saturate, "%)") : "");
    var sepia = "".concat(filterObj.sepia && filterObj.sepia !== 0 ? "sepia(".concat(filterObj.sepia, "%)") : "");
    var shadow = "".concat(filterObj.shadow && filterObj.shadow !== 0 ? "box-shadow(".concat(filterObj.shadow, "%)") : "");
    var imageFilter = "".concat(blur, " ").concat(opacity, " ").concat(brightness, " ").concat(contrast, " ").concat(grayscale, " ").concat(hueRotate, " ").concat(invert, " ").concat(saturate, " ").concat(sepia, " ").concat(shadow, " !important");
    return {
        filter: imageFilter
    };
}
function filterStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var styles = StylesFilterCodec.decode(stylesObj);
    if ((0,lib_Either.isRight)(styles)) return filterStyle_cssRender(styles.right, breakpoint, behaviourState);
    console.warn("FilterStyle ".concat(breakpoint, " ").concat(behaviourState, " ").concat(codecUtils_decoderErrors(styles)));
    return {};
}
function filterStyle_cssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return filterStyle_renderBob(stylesObj.filter);
        } else {
            var ref, ref1;
            return filterStyle_renderBobOpt(stylesObj.filter, filterStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.filter, stylesObj.filter));
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return filterStyle_renderBobOpt(stylesObj.filter, filterStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.filter, stylesObj.filter));
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return filterStyle_renderBobOpt(stylesObj.filter, filterStyle_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.filter, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.filter, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.filter, stylesObj.filter));
        }
    }
}
function filterStyle_renderBob(filterObj) {
    if (!filterObj.enable) return {};
    return filterStyle_render(filterObj);
}
/**
 * Renders ColorsOpt css for breakpoints/state templates
 * or empty for non written style props
 *
 * @param filterObj
 * @param foundationStyle
 * @returns
 */ function filterStyle_renderBobOpt(defaultFilterObj, filterObj) {
    if ((filterObj === null || filterObj === void 0 ? void 0 : filterObj.enable) === false) {
        if (defaultFilterObj.enable) return {
            filter: "initial"
        };
        return {};
    }
    if (filterObj === null || filterObj === void 0 ? void 0 : filterObj.enable) return filterStyle_renderOpt(filterObj);
    return {};
}
/**
 * Renders FilterOpt css for breakpoints/state templates
 * Returns color
 * or empty for non written style props
 *
 * @param filterObj
 * @param foundationStyle
 * @returns
 */ function filterStyle_renderOpt(filterObj) {
    var css = {};
    if (utils_objValueExists(filterObj, "blur") || utils_objValueExists(filterObj, "brightness") || utils_objValueExists(filterObj, "contrast") || utils_objValueExists(filterObj, "grayscale") || utils_objValueExists(filterObj, "hueRotate") || utils_objValueExists(filterObj, "invert") || utils_objValueExists(filterObj, "saturate") || utils_objValueExists(filterObj, "sepia") || utils_objValueExists(filterObj, "shadow") || utils_objValueExists(filterObj, "enable")) {
        var blur = "blur(".concat(filterObj.blur, "px)");
        var brightness = "brightness(".concat(filterObj.brightness).concat(filterObj.brightness !== 0 ? "%" : "", ")");
        var contrast = "contrast(".concat(filterObj.contrast).concat(filterObj.contrast !== 0 ? "%" : "", ")");
        var grayscale = "grayscale(".concat(filterObj.grayscale).concat(filterObj.grayscale !== 0 ? "%" : "", ")");
        var hueRotation = "hue-rotate(".concat(filterObj.hueRotation, "deg)");
        var invert = "invert(".concat(filterObj.invert).concat(filterObj.invert !== 0 ? "%" : "", ")");
        var saturate = "saturate(".concat(filterObj.saturate).concat(filterObj.saturate !== 0 ? "%" : "", ")");
        var sepia = "sepia(".concat(filterObj.sepia).concat(filterObj.sepia !== 0 ? "%" : "", ")");
        css = {
            filter: "".concat(blur, " ").concat(brightness, " ").concat(contrast, " ").concat(grayscale, " ").concat(hueRotation, " ").concat(invert, " ").concat(saturate, " ").concat(sepia)
        };
    }
    return css;
}
function filterStyle_render(filterObj) {
    var blur = "blur(".concat(filterObj.blur, "px)");
    var brightness = "brightness(".concat(filterObj.brightness).concat(filterObj.brightness !== 0 ? "%" : "", ")");
    var contrast = "contrast(".concat(filterObj.contrast).concat(filterObj.contrast !== 0 ? "%" : "", ")");
    var grayscale = "grayscale(".concat(filterObj.grayscale).concat(filterObj.grayscale !== 0 ? "%" : "", ")");
    var hueRotation = "hue-rotate(".concat(filterObj.hueRotation, "deg)");
    var invert = "invert(".concat(filterObj.invert).concat(filterObj.invert !== 0 ? "%" : "", ")");
    var saturate = "saturate(".concat(filterObj.saturate).concat(filterObj.saturate !== 0 ? "%" : "", ")");
    var sepia = "sepia(".concat(filterObj.sepia).concat(filterObj.sepia !== 0 ? "%" : "", ")");
    return {
        filter: "".concat(blur, " ").concat(brightness, " ").concat(contrast, " ").concat(grayscale, " ").concat(hueRotation, " ").concat(invert, " ").concat(saturate, " ").concat(sepia)
    };
}
function filterStyle_mergeBob2(filterObj, defaultFilterObj) {
    // no filter object
    if (!filterObj) {
        return {
            enable: undefined,
            blur: undefined,
            brightness: undefined,
            contrast: undefined,
            grayscale: undefined,
            hueRotation: undefined,
            invert: undefined,
            saturate: undefined,
            sepia: undefined,
            shadow: undefined
        };
    }
    var enable = get2WithNull4Enable(filterObj === null || filterObj === void 0 ? void 0 : filterObj.enable, defaultFilterObj.enable);
    //if one of the values is set in the breakpoint we render the entire shadow property
    if (utils_objValueExists(filterObj, "blur") || utils_objValueExists(filterObj, "opacity") || utils_objValueExists(filterObj, "brightness") || utils_objValueExists(filterObj, "contrast") || utils_objValueExists(filterObj, "grayscale") || utils_objValueExists(filterObj, "hueRotation") || utils_objValueExists(filterObj, "invert") || utils_objValueExists(filterObj, "saturate") || utils_objValueExists(filterObj, "sepia") || utils_objValueExists(filterObj, "shadow") || utils_objValueExists(filterObj, "enable")) {
        var blur = bobUtils_get2WithNull(filterObj === null || filterObj === void 0 ? void 0 : filterObj.blur, defaultFilterObj.blur);
        var brightness = bobUtils_get2WithNull(filterObj === null || filterObj === void 0 ? void 0 : filterObj.brightness, defaultFilterObj.brightness);
        var contrast = bobUtils_get2WithNull(filterObj === null || filterObj === void 0 ? void 0 : filterObj.contrast, defaultFilterObj.contrast);
        var grayscale = bobUtils_get2WithNull(filterObj === null || filterObj === void 0 ? void 0 : filterObj.grayscale, defaultFilterObj.grayscale);
        var hueRotation = bobUtils_get2WithNull(filterObj === null || filterObj === void 0 ? void 0 : filterObj.hueRotation, defaultFilterObj.hueRotation);
        var invert = bobUtils_get2WithNull(filterObj === null || filterObj === void 0 ? void 0 : filterObj.invert, defaultFilterObj.invert);
        var saturate = bobUtils_get2WithNull(filterObj === null || filterObj === void 0 ? void 0 : filterObj.saturate, defaultFilterObj.saturate);
        var sepia = bobUtils_get2WithNull(filterObj === null || filterObj === void 0 ? void 0 : filterObj.sepia, defaultFilterObj.sepia);
        var shadow = bobUtils_get2WithNull(filterObj === null || filterObj === void 0 ? void 0 : filterObj.shadow, defaultFilterObj.shadow);
        return {
            enable: enable,
            blur: blur,
            brightness: brightness,
            contrast: contrast,
            grayscale: grayscale,
            hueRotation: hueRotation,
            invert: invert,
            saturate: saturate,
            sepia: sepia,
            shadow: shadow
        };
    }
    //only enable is written
    return {
        enable: enable,
        blur: undefined,
        brightness: undefined,
        contrast: undefined,
        grayscale: undefined,
        hueRotation: undefined,
        invert: undefined,
        saturate: undefined,
        sepia: undefined,
        shadow: undefined
    };
}
function filterStyle_mergeBob3(filterObj, filterDesktopBehaviour, filterDefaultBreakpoint, defaultFilterObj) {
    // no filter object
    if (!filterObj) {
        return {
            enable: undefined,
            blur: undefined,
            brightness: undefined,
            contrast: undefined,
            grayscale: undefined,
            hueRotation: undefined,
            invert: undefined,
            saturate: undefined,
            sepia: undefined,
            shadow: undefined
        };
    }
    var enable = get3WithNull4Enable(filterObj === null || filterObj === void 0 ? void 0 : filterObj.enable, filterDesktopBehaviour === null || filterDesktopBehaviour === void 0 ? void 0 : filterDesktopBehaviour.enable, filterDefaultBreakpoint === null || filterDefaultBreakpoint === void 0 ? void 0 : filterDefaultBreakpoint.enable, defaultFilterObj.enable);
    //if one of the values is set in the breakpoint we render the entire shadow property
    if (utils_objValueExists(filterObj, "blur") || utils_objValueExists(filterObj, "brightness") || utils_objValueExists(filterObj, "contrast") || utils_objValueExists(filterObj, "grayscale") || utils_objValueExists(filterObj, "hueRotation") || utils_objValueExists(filterObj, "invert") || utils_objValueExists(filterObj, "saturate") || utils_objValueExists(filterObj, "sepia") || utils_objValueExists(filterObj, "shadow") || utils_objValueExists(filterObj, "enable")) {
        var ref, ref1, ref2;
        var blur = (ref2 = (ref1 = (ref = filterObj === null || filterObj === void 0 ? void 0 : filterObj.blur) !== null && ref !== void 0 ? ref : filterDesktopBehaviour === null || filterDesktopBehaviour === void 0 ? void 0 : filterDesktopBehaviour.blur) !== null && ref1 !== void 0 ? ref1 : filterDefaultBreakpoint === null || filterDefaultBreakpoint === void 0 ? void 0 : filterDefaultBreakpoint.blur) !== null && ref2 !== void 0 ? ref2 : defaultFilterObj.blur;
        var ref3, ref4, ref5;
        var brightness = (ref5 = (ref4 = (ref3 = filterObj === null || filterObj === void 0 ? void 0 : filterObj.brightness) !== null && ref3 !== void 0 ? ref3 : filterDesktopBehaviour === null || filterDesktopBehaviour === void 0 ? void 0 : filterDesktopBehaviour.brightness) !== null && ref4 !== void 0 ? ref4 : filterDefaultBreakpoint === null || filterDefaultBreakpoint === void 0 ? void 0 : filterDefaultBreakpoint.brightness) !== null && ref5 !== void 0 ? ref5 : defaultFilterObj.brightness;
        var ref6, ref7, ref8;
        var contrast = (ref8 = (ref7 = (ref6 = filterObj === null || filterObj === void 0 ? void 0 : filterObj.contrast) !== null && ref6 !== void 0 ? ref6 : filterDesktopBehaviour === null || filterDesktopBehaviour === void 0 ? void 0 : filterDesktopBehaviour.contrast) !== null && ref7 !== void 0 ? ref7 : filterDefaultBreakpoint === null || filterDefaultBreakpoint === void 0 ? void 0 : filterDefaultBreakpoint.contrast) !== null && ref8 !== void 0 ? ref8 : defaultFilterObj.contrast;
        var ref9, ref10, ref11;
        var grayscale = (ref11 = (ref10 = (ref9 = filterObj === null || filterObj === void 0 ? void 0 : filterObj.grayscale) !== null && ref9 !== void 0 ? ref9 : filterDesktopBehaviour === null || filterDesktopBehaviour === void 0 ? void 0 : filterDesktopBehaviour.grayscale) !== null && ref10 !== void 0 ? ref10 : filterDefaultBreakpoint === null || filterDefaultBreakpoint === void 0 ? void 0 : filterDefaultBreakpoint.grayscale) !== null && ref11 !== void 0 ? ref11 : defaultFilterObj.grayscale;
        var ref12, ref13, ref14;
        var hueRotation = (ref14 = (ref13 = (ref12 = filterObj === null || filterObj === void 0 ? void 0 : filterObj.hueRotation) !== null && ref12 !== void 0 ? ref12 : filterDesktopBehaviour === null || filterDesktopBehaviour === void 0 ? void 0 : filterDesktopBehaviour.hueRotation) !== null && ref13 !== void 0 ? ref13 : filterDefaultBreakpoint === null || filterDefaultBreakpoint === void 0 ? void 0 : filterDefaultBreakpoint.hueRotation) !== null && ref14 !== void 0 ? ref14 : defaultFilterObj.hueRotation;
        var ref15, ref16, ref17;
        var invert = (ref17 = (ref16 = (ref15 = filterObj === null || filterObj === void 0 ? void 0 : filterObj.invert) !== null && ref15 !== void 0 ? ref15 : filterDesktopBehaviour === null || filterDesktopBehaviour === void 0 ? void 0 : filterDesktopBehaviour.invert) !== null && ref16 !== void 0 ? ref16 : filterDefaultBreakpoint === null || filterDefaultBreakpoint === void 0 ? void 0 : filterDefaultBreakpoint.invert) !== null && ref17 !== void 0 ? ref17 : defaultFilterObj.invert;
        var ref18, ref19, ref20;
        var saturate = (ref20 = (ref19 = (ref18 = filterObj === null || filterObj === void 0 ? void 0 : filterObj.saturate) !== null && ref18 !== void 0 ? ref18 : filterDesktopBehaviour === null || filterDesktopBehaviour === void 0 ? void 0 : filterDesktopBehaviour.saturate) !== null && ref19 !== void 0 ? ref19 : filterDefaultBreakpoint === null || filterDefaultBreakpoint === void 0 ? void 0 : filterDefaultBreakpoint.saturate) !== null && ref20 !== void 0 ? ref20 : defaultFilterObj.saturate;
        var ref21, ref22, ref23;
        var sepia = (ref23 = (ref22 = (ref21 = filterObj === null || filterObj === void 0 ? void 0 : filterObj.sepia) !== null && ref21 !== void 0 ? ref21 : filterDesktopBehaviour === null || filterDesktopBehaviour === void 0 ? void 0 : filterDesktopBehaviour.sepia) !== null && ref22 !== void 0 ? ref22 : filterDefaultBreakpoint === null || filterDefaultBreakpoint === void 0 ? void 0 : filterDefaultBreakpoint.sepia) !== null && ref23 !== void 0 ? ref23 : defaultFilterObj.sepia;
        var ref24, ref25, ref26;
        var shadow = (ref26 = (ref25 = (ref24 = filterObj === null || filterObj === void 0 ? void 0 : filterObj.shadow) !== null && ref24 !== void 0 ? ref24 : filterDesktopBehaviour === null || filterDesktopBehaviour === void 0 ? void 0 : filterDesktopBehaviour.shadow) !== null && ref25 !== void 0 ? ref25 : filterDefaultBreakpoint === null || filterDefaultBreakpoint === void 0 ? void 0 : filterDefaultBreakpoint.shadow) !== null && ref26 !== void 0 ? ref26 : defaultFilterObj.shadow;
        return {
            enable: enable,
            blur: blur,
            brightness: brightness,
            contrast: contrast,
            grayscale: grayscale,
            hueRotation: hueRotation,
            invert: invert,
            saturate: saturate,
            sepia: sepia,
            shadow: shadow
        };
    }
    //only enable is written
    return {
        enable: enable,
        blur: undefined,
        brightness: undefined,
        contrast: undefined,
        grayscale: undefined,
        hueRotation: undefined,
        invert: undefined,
        saturate: undefined,
        sepia: undefined,
        shadow: undefined
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/heightStyle.ts




//Temp to handle nulls
var heightStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
var UnitCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("px"),
    (0,es6/* literal */.i0)("%"),
    (0,es6/* literal */.i0)("vw"),
    (0,es6/* literal */.i0)("vh"),
    (0,es6/* literal */.i0)("auto")
]);
var HeightPropsCodec = (0,es6/* type */.dt)({
    value: es6/* number */.pk,
    unit: UnitCodec
});
var HeightCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    HeightPropsCodec
]);
var HeightPropsOptCodec = (0,es6/* partial */.r$)({
    unit: heightStyle_nullable(UnitCodec),
    value: heightStyle_nullable(es6/* number */.pk)
});
var HeightOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: heightStyle_nullable(es6/* boolean */.O7)
    }),
    HeightPropsOptCodec
]);
var StylesHeightCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        height: HeightCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                height: HeightPropsOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                height: HeightPropsOptCodec
            })
        }),
        mobile: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                height: HeightPropsOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        height: HeightPropsOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        height: HeightPropsOptCodec
                    })
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                height: HeightPropsOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        height: HeightPropsOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        height: HeightPropsOptCodec
                    })
                })
            }), 
        ])
    }), 
]);
function heightStyle_responsiveStyle(heightObj) {
    if (!utils_objValueExists(heightObj, "enable")) return "";
    if (!heightObj.enable) return {
        height: "auto !important"
    };
    return {
        height: heightObj.value + heightObj.unit + " !important"
    };
}
function heightStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var styles = StylesHeightCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return heightStyle_cssRender(styles.right, breakpoint, behaviourState);
    console.warn(codecUtils_decoderErrors(styles));
    return {
        height: "auto !important"
    };
}
function heightStyle_cssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return heightStyle_renderBob(stylesObj.height);
        } else {
            var ref, ref1;
            return heightStyle_renderBob(heightStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.height, stylesObj.height));
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return heightStyle_renderBob(heightStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.height, stylesObj.height));
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return heightStyle_renderBob(heightStyle_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.height, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.height, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.height, stylesObj.height));
        }
    }
}
function heightStyle_renderBob(heightObj) {
    if (!heightObj.enable) {
        return {
            height: "auto !important"
        };
    }
    return heightStyle_render(heightObj);
}
function heightStyle_render(heightObj) {
    var heightValue = heightObj.value;
    var heightUnit = heightObj.unit;
    return {
        height: "".concat(heightValue).concat(heightUnit, " !important")
    };
}
function heightStyle_mergeBob2(heightObj, defaultHeightObj) {
    var ref;
    var enable = (ref = heightObj === null || heightObj === void 0 ? void 0 : heightObj.enable) !== null && ref !== void 0 ? ref : defaultHeightObj.enable;
    var ref1;
    var value = (ref1 = heightObj === null || heightObj === void 0 ? void 0 : heightObj.value) !== null && ref1 !== void 0 ? ref1 : defaultHeightObj.value;
    var ref2;
    var unit = (ref2 = heightObj === null || heightObj === void 0 ? void 0 : heightObj.unit) !== null && ref2 !== void 0 ? ref2 : defaultHeightObj.unit;
    return {
        enable: enable,
        value: value,
        unit: unit
    };
}
function heightStyle_mergeBob3(heightObj, heightDesktopBehaviour, heightDefaultBreakpoint, defaultHeightObj) {
    var ref, ref1, ref2;
    var enable = (ref2 = (ref1 = (ref = heightObj === null || heightObj === void 0 ? void 0 : heightObj.enable) !== null && ref !== void 0 ? ref : heightDesktopBehaviour === null || heightDesktopBehaviour === void 0 ? void 0 : heightDesktopBehaviour.enable) !== null && ref1 !== void 0 ? ref1 : heightDefaultBreakpoint === null || heightDefaultBreakpoint === void 0 ? void 0 : heightDefaultBreakpoint.enable) !== null && ref2 !== void 0 ? ref2 : defaultHeightObj.enable;
    var ref3, ref4, ref5;
    var value = (ref5 = (ref4 = (ref3 = heightObj === null || heightObj === void 0 ? void 0 : heightObj.value) !== null && ref3 !== void 0 ? ref3 : heightDesktopBehaviour === null || heightDesktopBehaviour === void 0 ? void 0 : heightDesktopBehaviour.value) !== null && ref4 !== void 0 ? ref4 : heightDefaultBreakpoint === null || heightDefaultBreakpoint === void 0 ? void 0 : heightDefaultBreakpoint.value) !== null && ref5 !== void 0 ? ref5 : defaultHeightObj.value;
    var ref6, ref7, ref8;
    var unit = (ref8 = (ref7 = (ref6 = heightObj === null || heightObj === void 0 ? void 0 : heightObj.unit) !== null && ref6 !== void 0 ? ref6 : heightDesktopBehaviour === null || heightDesktopBehaviour === void 0 ? void 0 : heightDesktopBehaviour.unit) !== null && ref7 !== void 0 ? ref7 : heightDefaultBreakpoint === null || heightDefaultBreakpoint === void 0 ? void 0 : heightDefaultBreakpoint.unit) !== null && ref8 !== void 0 ? ref8 : defaultHeightObj.unit;
    return {
        enable: enable,
        value: value,
        unit: unit
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/sizeStyle.ts

var SizeStyle = /*#__PURE__*/ function() {
    "use strict";
    function SizeStyle() {
        (0,src_class_call_check/* default */.Z)(this, SizeStyle);
    }
    SizeStyle.responsiveStyle = function responsiveStyle(sizeObj) {
        return {
            "object-fit": "".concat(sizeObj, " !important")
        };
    };
    return SizeStyle;
}();
/* harmony default export */ var sizeStyle = (SizeStyle);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/widthStyle.ts




//Temp to handle nulls
var widthStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
var widthStyle_UnitCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("px"),
    (0,es6/* literal */.i0)("%"),
    (0,es6/* literal */.i0)("vw"),
    (0,es6/* literal */.i0)("vh"),
    (0,es6/* literal */.i0)("auto")
]);
var WidthPropsCodec = (0,es6/* type */.dt)({
    value: es6/* number */.pk,
    unit: widthStyle_UnitCodec
});
var WidthCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    WidthPropsCodec
]);
var WidthPropsOptCodec = (0,es6/* partial */.r$)({
    unit: widthStyle_nullable(widthStyle_UnitCodec),
    value: widthStyle_nullable(es6/* number */.pk)
});
var WidthOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: widthStyle_nullable(es6/* boolean */.O7)
    }),
    WidthPropsOptCodec
]);
var StylesWidthCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        width: WidthCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                width: WidthPropsOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                width: WidthPropsOptCodec
            })
        }),
        mobile: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                width: WidthPropsOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        width: WidthPropsOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        width: WidthPropsOptCodec
                    })
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                width: WidthPropsOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        width: WidthPropsOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        width: WidthPropsOptCodec
                    })
                })
            }), 
        ])
    }), 
]);
function widthStyle_responsiveStyle(widthObj) {
    if (!utils_objValueExists(widthObj, "enable")) return "";
    if (!widthObj.enable) return {
        width: "auto !important"
    };
    return {
        width: widthObj.value + widthObj.unit + " !important"
    };
}
function widthStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var styles = StylesWidthCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return widthStyle_cssRender(styles.right, breakpoint, behaviourState);
    console.warn(codecUtils_decoderErrors(styles));
    return {
        width: "auto !important"
    };
}
function widthStyle_cssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return widthStyle_renderBob(stylesObj.width);
        } else {
            var ref, ref1;
            return widthStyle_renderBob(widthStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.width, stylesObj.width));
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return widthStyle_renderBob(widthStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.width, stylesObj.width));
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return widthStyle_renderBob(widthStyle_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.width, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.width, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.width, stylesObj.width));
        }
    }
}
function widthStyle_renderBob(widthObj) {
    if (!widthObj.enable) {
        return {
            width: "auto !important"
        };
    }
    return widthStyle_render(widthObj);
}
function widthStyle_render(widthObj) {
    var widthValue = widthObj.value;
    var widthUnit = widthObj.unit;
    return {
        width: "".concat(widthValue).concat(widthUnit, " !important")
    };
}
function widthStyle_mergeBob2(widthObj, defaultWidthObj) {
    var ref;
    var enable = (ref = widthObj === null || widthObj === void 0 ? void 0 : widthObj.enable) !== null && ref !== void 0 ? ref : defaultWidthObj.enable;
    var ref1;
    var value = (ref1 = widthObj === null || widthObj === void 0 ? void 0 : widthObj.value) !== null && ref1 !== void 0 ? ref1 : defaultWidthObj.value;
    var ref2;
    var unit = (ref2 = widthObj === null || widthObj === void 0 ? void 0 : widthObj.unit) !== null && ref2 !== void 0 ? ref2 : defaultWidthObj.unit;
    return {
        enable: enable,
        value: value,
        unit: unit
    };
}
function widthStyle_mergeBob3(widthObj, widthDesktopBehaviour, widthDefaultBreakpoint, defaultWidthObj) {
    var ref, ref1, ref2;
    var enable = (ref2 = (ref1 = (ref = widthObj === null || widthObj === void 0 ? void 0 : widthObj.enable) !== null && ref !== void 0 ? ref : widthDesktopBehaviour === null || widthDesktopBehaviour === void 0 ? void 0 : widthDesktopBehaviour.enable) !== null && ref1 !== void 0 ? ref1 : widthDefaultBreakpoint === null || widthDefaultBreakpoint === void 0 ? void 0 : widthDefaultBreakpoint.enable) !== null && ref2 !== void 0 ? ref2 : defaultWidthObj.enable;
    var ref3, ref4, ref5;
    var value = (ref5 = (ref4 = (ref3 = widthObj === null || widthObj === void 0 ? void 0 : widthObj.value) !== null && ref3 !== void 0 ? ref3 : widthDesktopBehaviour === null || widthDesktopBehaviour === void 0 ? void 0 : widthDesktopBehaviour.value) !== null && ref4 !== void 0 ? ref4 : widthDefaultBreakpoint === null || widthDefaultBreakpoint === void 0 ? void 0 : widthDefaultBreakpoint.value) !== null && ref5 !== void 0 ? ref5 : defaultWidthObj.value;
    var ref6, ref7, ref8;
    var unit = (ref8 = (ref7 = (ref6 = widthObj === null || widthObj === void 0 ? void 0 : widthObj.unit) !== null && ref6 !== void 0 ? ref6 : widthDesktopBehaviour === null || widthDesktopBehaviour === void 0 ? void 0 : widthDesktopBehaviour.unit) !== null && ref7 !== void 0 ? ref7 : widthDefaultBreakpoint === null || widthDefaultBreakpoint === void 0 ? void 0 : widthDefaultBreakpoint.unit) !== null && ref8 !== void 0 ? ref8 : defaultWidthObj.unit;
    return {
        enable: enable,
        value: value,
        unit: unit
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/objectPositionStyle.ts

var PositionStyle = /*#__PURE__*/ function() {
    "use strict";
    function PositionStyle() {
        (0,src_class_call_check/* default */.Z)(this, PositionStyle);
    }
    PositionStyle.responsiveStyle = function responsiveStyle(positionObj) {
        return {
            "object-position": "".concat(positionObj, " !important")
        };
    };
    return PositionStyle;
}();
/* harmony default export */ var objectPositionStyle = (PositionStyle);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/gridStyle.ts

var GridStyle = /*#__PURE__*/ function() {
    "use strict";
    function GridStyle() {
        (0,src_class_call_check/* default */.Z)(this, GridStyle);
    }
    GridStyle.responsiveStyle = function responsiveStyle(gridObj) {
        return {};
    };
    return GridStyle;
}();
/* harmony default export */ var gridStyle = (GridStyle);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/wrapStyle.ts

var WrapStyle = /*#__PURE__*/ function() {
    "use strict";
    function WrapStyle() {
        (0,src_class_call_check/* default */.Z)(this, WrapStyle);
    }
    WrapStyle.responsiveStyle = function responsiveStyle(wrapObj) {
        return {};
    };
    return WrapStyle;
}();
/* harmony default export */ var wrapStyle = (WrapStyle);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/scrollStyle.ts


var ScrollStyle = /*#__PURE__*/ function() {
    "use strict";
    function ScrollStyle() {
        (0,src_class_call_check/* default */.Z)(this, ScrollStyle);
    }
    ScrollStyle.responsiveStyle = function responsiveStyle(scrollObj) {
        if (!utils_objValueExists(scrollObj, "enable")) return "";
        if (!scrollObj.enable) return {
            position: "static !important"
        };
        if (scrollObj.value === "magnetic") return {
            position: "sticky !important",
            top: "0 !important",
            "z-index": "999 !important"
        };
        if (scrollObj.value === "fixed") return {
            position: "fixed !important",
            zIndex: "999 !important",
            width: "100% !important"
        };
        if (scrollObj.value === "static") return {
            position: "static !important"
        };
    };
    return ScrollStyle;
}();
/* harmony default export */ var scrollStyle = (ScrollStyle);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/colorsStyle.ts





//Temp to handle nulls
var colorsStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
/**
 * We should only check for property and undefined
 * this solution is only until we fix the null being send around the page object
 */ // props only, no enable
var ColorsPropsCodec = (0,es6/* type */.dt)({
    colorFirst: es6/* string */.Z_,
    colorSecond: es6/* string */.Z_,
    gradientAngle: es6/* number */.pk,
    gradientDirection: es6/* string */.Z_,
    isGradient: es6/* boolean */.O7
});
var ColorsCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    ColorsPropsCodec
]);
// props only, no enable
var ColorsPropsOptCodec = (0,es6/* partial */.r$)({
    colorFirst: colorsStyle_nullable(es6/* string */.Z_),
    colorSecond: colorsStyle_nullable(es6/* string */.Z_),
    gradientAngle: colorsStyle_nullable(es6/* number */.pk),
    gradientDirection: colorsStyle_nullable(es6/* string */.Z_),
    isGradient: colorsStyle_nullable(es6/* boolean */.O7)
});
var ColorsOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: colorsStyle_nullable(es6/* boolean */.O7)
    }),
    ColorsPropsOptCodec
]);
var StylesColorsCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        colors: ColorsCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                colors: ColorsOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                colors: ColorsOptCodec
            })
        }),
        mobile: (0,es6/* partial */.r$)({
            colors: ColorsOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    colors: ColorsOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    colors: ColorsOptCodec
                })
            })
        }),
        tablet: (0,es6/* partial */.r$)({
            colors: ColorsOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    colors: ColorsOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    colors: ColorsOptCodec
                })
            })
        })
    }), 
]);
function colorsCss(css) {
    if (css.hasOwnProperty("background-color")) return css["background-color"];
    return "";
}
function colorsStyle_responsiveStyle(colorsObj, desktopDefaultValues, breakpointDefaultValues) {
    var hasEnable = colorsObj.hasOwnProperty("enable");
    if (hasEnable && !utils_objValueExists(colorsObj, "enable")) return "";
    /**
   * Check if property is available, and fallback to breakpointDefault or the desktopDefault
   */ var colorFirst = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.colorFirst) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.colorFirst);
    var colorSecond = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.colorSecond) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.colorSecond);
    var gradientAngle = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.gradientAngle) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.gradientAngle);
    // TODO: was not used in old method, why?
    // const gradientDirection =
    //   colorsObj?.gradientDirection ||
    //   breakpointDefaultValues?.gradientDirection ||
    //   desktopDefaultValues?.gradientDirection
    var isGradient = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.isGradient) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.isGradient);
    // colors prop
    // TODO: old method returned {} when isGradient was disabled, shouldn't it return background-image: none ?
    if (hasEnable && !colorsObj.enable) return !isGradient ? {
        "background-color": "transparent !important"
    } : {};
    if (!isGradient) return {
        "background-color": colorFirst + " !important"
    };
    else return {
        "background-image": "linear-gradient(".concat(gradientAngle, "deg, ").concat(colorFirst, ", ").concat(colorSecond, ") !important")
    };
}
function colorsStyle_renderCSSString(stylesObj) {
    return "\n    ".concat(bobUtils_showIfWritten(stylesObj, "background-color"), " \n    ");
}
function colorsStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var foundationStyle = arguments.length > 3 && arguments[3] !== void 0 // TODO: fix when working on other bobs
     ? arguments[3] : undefined;
    /**
   * Colors in bobMEdia was optional in the BE, so some bobmedias didn't have colors written on the template.
   * A migration was runed to writte the colors object in all bobMedias,
   * this migration won't affect public pages until they are published again.
   * So, the codec will still break in this cases, which can haven bad effects on future logic, beware.
   */ var styles = StylesColorsCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return colorsStyle_cssRender(styles.right, breakpoint, behaviourState, foundationStyle);
    console.warn(codecUtils_decoderErrors(styles));
    return {
        "background-color": "transparent"
    };
}
// export function globalStyleCssRenderUnsafe(
//   gsObj: any,
//   breakpoint: Breakpoint,
//   behaviourState: BehaviourState_,
//   foundationStyle: FColor | undefined = undefined // TODO: Work on when foundation is added to global styles
// ): ColorsCSS | "" {
//   const gs = GSColorsCodec.decode(gsObj)
//   if (isRight(gs)) return globalStyleCssRender(gs.right, breakpoint, behaviourState, foundationStyle)
//   console.warn(decoderErrors(gs))
//   return ""
// }
function colorsStyle_cssRender(stylesObj, breakpoint, behaviourState, foundationStyle) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return colorsStyle_renderBob(stylesObj.colors, foundationStyle);
        } else {
            var ref, ref1;
            return colorsStyle_renderBobOpt(colorsStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.colors, stylesObj.colors), foundationStyle);
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return colorsStyle_renderBobOpt(colorsStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.colors, stylesObj.colors), foundationStyle);
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return colorsStyle_renderBobOpt(colorsStyle_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.colors, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.colors, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.colors, stylesObj.colors), foundationStyle);
        }
    }
}
// export function globalStyleCssRender(
//   stylesObj: GSColors,
//   breakpoint: Breakpoint,
//   behaviourState: BehaviourState_,
//   foundationStyle: FColor | undefined
// ): ColorsCSS {
//   if (breakpoint === "desktop") {
//     if (behaviourState === "default") {
//       return render(stylesObj, foundationStyle)
//     }
//     //hover | active
//     else {
//       return render(merge2(stylesObj?.behaviour?.[behaviourState], stylesObj), foundationStyle)
//     }
//   }
//   //tablet | mobile
//   else {
//     if (behaviourState === "default") {
//       return render(merge2(stylesObj?.[breakpoint], stylesObj), foundationStyle)
//     }
//     //hover | active
//     else {
//       return render(
//         merge3(
//           stylesObj?.[breakpoint]?.behaviour?.[behaviourState],
//           stylesObj.behaviour?.[behaviourState],
//           stylesObj?.[breakpoint],
//           stylesObj
//         ),
//         foundationStyle
//       )
//     }
//   }
// }
/**
 * Renders Colors css for desktop template
 *
 * @param colorsObj
 * @param foundationStyle
 * @returns
 */ function colorsStyle_renderBob(colorsObj, foundationStyle) {
    if (colorsObj.enable === false) return {
        "background-color": "transparent !important"
    };
    return colorsStyle_render(colorsObj, foundationStyle);
}
/**
 * Renders ColorsOpt css for breakpoints/state templates
 * or empty for non written style props
 *
 * @param colorsObj
 * @param foundationStyle
 * @returns
 */ function colorsStyle_renderBobOpt(colorsObj, foundationStyle) {
    if (colorsObj.enable === false) return {
        "background-color": "transparent !important"
    };
    else if (colorsObj.enable === true) {
        return colorsStyle_renderOpt(colorsObj, foundationStyle);
    }
    return {};
}
/**
 * Renders Colors css for desktop template
 * Returns background color for nonGradient style
 * or background-image for gradient style
 *
 * @param colorsObj
 * @param foundationStyle
 * @returns
 */ function colorsStyle_render(colorsObj, foundationStyle) {
    // single color css
    if (!colorsObj.isGradient) {
        return {
            "background-color": colorsObj.colorFirst + " !important"
        };
    // gradient color css
    } else {
        return {
            "background-image": "linear-gradient(".concat(colorsObj.gradientAngle, "deg, ").concat(colorsObj.colorFirst, ", ").concat(colorsObj.colorSecond, ") !important")
        };
    }
}
/**
 * Renders ColorsOpt css for breakpoints/state templates
 * Returns background color for nonGradient style
 * or background-image for gradient style
 * or empty for non written style props
 *
 * @param colorsObj
 * @param foundationStyle
 * @returns
 */ function colorsStyle_renderOpt(colorsObj, foundationStyle) {
    // single color css
    if (!colorsObj.isGradient) {
        if (colorsObj.colorFirst) return {
            "background-color": colorsObj.colorFirst + " !important"
        };
    // gradient color css
    } else if (utils_objValueExists(colorsObj, "gradientAngle") && colorsObj.colorFirst && colorsObj.colorSecond) {
        return {
            "background-image": "linear-gradient(".concat(colorsObj.gradientAngle, "deg, ").concat(colorsObj.colorFirst, ", ").concat(colorsObj.colorSecond, ") !important")
        };
    }
    // no written style props
    return {};
}
/**
 * Fallback templateObj values to defaultObj value when needed
 * used for breakpoints/states(default) templates
 *
 * For values that are not written on the templateObj and are interpreted as css,
 * the fallback value shouldn't be used as the browser deals with the fallback by itself
 *
 * For values that are not interpreted as css, like isGradient, the fallback must be allways used when needed,
 * as this value will not be dealt by the browser
 *
 * For values that are needed together for a single css property,
 * if one of those values is written on the templateObj the other values must use the fallback value when needed
 *
 * @param colorsObj
 * @param defaultColorsObj
 * @returns Colors
 *
 */ function colorsStyle_mergeBob2(colorsObj, defaultColorsObj) {
    var isGradientValueWritten = handleGradientValueWritten(colorsObj);
    var enable = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.enable;
    var isGradient = bobUtils_get2WithNull(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient, defaultColorsObj.isGradient);
    var colorFirst = bobUtils_get2WithNullConditional(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst, defaultColorsObj.colorFirst, (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten);
    var colorSecond = bobUtils_get2WithNullConditional(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond, defaultColorsObj.colorSecond, (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten);
    var gradientAngle = bobUtils_get2WithNullConditional(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle, defaultColorsObj.gradientAngle, (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten);
    var gradientDirection = bobUtils_get2WithNullConditional(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientDirection, defaultColorsObj.gradientDirection, (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten);
    return {
        enable: enable,
        colorFirst: colorFirst,
        colorSecond: colorSecond,
        gradientAngle: gradientAngle,
        gradientDirection: gradientDirection,
        isGradient: isGradient
    };
}
/**
 * Fallback templateObj values to defaultObj value when needed
 * used for globalstyles breakpoints/states(default) templates
 *
 * For values that are not written on the templateObj and are interpreted as css,
 * the fallback value shouldn't be used as the browser deals with the fallback by itself
 *
 * For values that are not interpreted as css, like isGradient, the fallback must be allways used when needed,
 * as this value will not be dealt by the browser
 *
 * For values that are needed together for a single css property,
 * if one of those values is written on the templateObj the other values must use the fallback value when needed
 *
 * @param colorsObj
 * @param defaultColorsObj
 * @returns ColorsProps
 *
 */ function colorsStyle_merge2(colorsObj, defaultColorsObj) {
    var isGradientValueWritten = handleGradientValueWritten(colorsObj);
    var isGradient = get2WithNull(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient, defaultColorsObj.isGradient);
    var colorFirst = get2WithNullConditional(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst, defaultColorsObj.colorFirst, (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten);
    var colorSecond = get2WithNullConditional(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond, defaultColorsObj.colorSecond, (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten);
    var gradientAngle = get2WithNullConditional(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle, defaultColorsObj.gradientAngle, (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten);
    var gradientDirection = get2WithNullConditional(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientDirection, defaultColorsObj.gradientDirection, (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten);
    return {
        colorFirst: colorFirst,
        colorSecond: colorSecond,
        gradientAngle: gradientAngle,
        gradientDirection: gradientDirection,
        isGradient: isGradient
    };
}
/**
 * Fallback templateObj values to defaultObj value when needed
 * used for states inside breakpoints templates
 *
 * For values that are not written on the templateObj and are interpreted as css,
 * the fallback value shouldn't be used as the browser deals with the fallback by itself
 *
 * For values that are not interpreted as css, like isGradient, the fallback must be allways used when needed,
 * as this value will not be dealt by the browser
 *
 * For values that are needed together for a single css property,
 * if one of those values is written on the templateObj the other values must use the fallback value when needed
 *
 * @param colorsObj
 * @param colorsDefaultBreakpoint
 * @param defaultColorsObj
 * @returns Colors
 */ function colorsStyle_mergeBob3(colorsObj, colorsDesktopBehaviour, colorsDefaultBreakpoint, defaultColorsObj) {
    var isGradientValueWritten = handleGradientValueWritten(colorsObj);
    var enable = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.enable;
    var ref, ref1, ref2;
    var isGradient = (ref2 = (ref1 = (ref = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) !== null && ref !== void 0 ? ref : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.isGradient) !== null && ref1 !== void 0 ? ref1 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.isGradient) !== null && ref2 !== void 0 ? ref2 : defaultColorsObj.isGradient;
    var ref3, ref4, ref5;
    var colorFirst = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten ? (ref5 = (ref4 = (ref3 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst) !== null && ref3 !== void 0 ? ref3 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.colorFirst) !== null && ref4 !== void 0 ? ref4 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.colorFirst) !== null && ref5 !== void 0 ? ref5 : defaultColorsObj.colorFirst : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst;
    var ref6, ref7, ref8;
    var colorSecond = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten ? (ref8 = (ref7 = (ref6 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond) !== null && ref6 !== void 0 ? ref6 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.colorSecond) !== null && ref7 !== void 0 ? ref7 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.colorSecond) !== null && ref8 !== void 0 ? ref8 : defaultColorsObj.colorSecond : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond;
    var ref9, ref10, ref11;
    var gradientAngle = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten ? (ref11 = (ref10 = (ref9 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle) !== null && ref9 !== void 0 ? ref9 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.gradientAngle) !== null && ref10 !== void 0 ? ref10 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.gradientAngle) !== null && ref11 !== void 0 ? ref11 : defaultColorsObj.gradientAngle : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle;
    var ref12, ref13, ref14;
    var gradientDirection = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten ? (ref14 = (ref13 = (ref12 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientDirection) !== null && ref12 !== void 0 ? ref12 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.gradientDirection) !== null && ref13 !== void 0 ? ref13 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.gradientDirection) !== null && ref14 !== void 0 ? ref14 : defaultColorsObj.gradientDirection : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientDirection;
    return {
        enable: enable,
        colorFirst: colorFirst,
        colorSecond: colorSecond,
        gradientAngle: gradientAngle,
        gradientDirection: gradientDirection,
        isGradient: isGradient
    };
}
/**
 * Fallback templateObj values to defaultObj value when needed
 * used for globalstyles states inside breakpoints templates
 *
 * For values that are not written on the templateObj and are interpreted as css,
 * the fallback value shouldn't be used as the browser deals with the fallback by itself
 *
 * For values that are not interpreted as css, like isGradient, the fallback must be allways used when needed,
 * as this value will not be dealt by the browser
 *
 * @param colorsObj
 * @param colorsDefaultBreakpoint
 * @param defaultColorsObj
 * @returns Colors
 */ function colorsStyle_merge3(colorsObj, colorsDesktopBehaviour, colorsDefaultBreakpoint, defaultColorsObj) {
    var isGradientValueWritten = handleGradientValueWritten(colorsObj);
    var ref, ref1, ref2;
    var isGradient = (ref2 = (ref1 = (ref = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) !== null && ref !== void 0 ? ref : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.isGradient) !== null && ref1 !== void 0 ? ref1 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.isGradient) !== null && ref2 !== void 0 ? ref2 : defaultColorsObj.isGradient;
    var ref3, ref4, ref5;
    var colorFirst = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten ? (ref5 = (ref4 = (ref3 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst) !== null && ref3 !== void 0 ? ref3 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.colorFirst) !== null && ref4 !== void 0 ? ref4 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.colorFirst) !== null && ref5 !== void 0 ? ref5 : defaultColorsObj.colorFirst : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst;
    var ref6, ref7, ref8;
    var colorSecond = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten ? (ref8 = (ref7 = (ref6 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond) !== null && ref6 !== void 0 ? ref6 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.colorSecond) !== null && ref7 !== void 0 ? ref7 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.colorSecond) !== null && ref8 !== void 0 ? ref8 : defaultColorsObj.colorSecond : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond;
    var ref9, ref10, ref11;
    var gradientAngle = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten ? (ref11 = (ref10 = (ref9 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle) !== null && ref9 !== void 0 ? ref9 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.gradientAngle) !== null && ref10 !== void 0 ? ref10 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.gradientAngle) !== null && ref11 !== void 0 ? ref11 : defaultColorsObj.gradientAngle : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle;
    var ref12, ref13, ref14;
    var gradientDirection = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten ? (ref14 = (ref13 = (ref12 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientDirection) !== null && ref12 !== void 0 ? ref12 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.gradientDirection) !== null && ref13 !== void 0 ? ref13 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.gradientDirection) !== null && ref14 !== void 0 ? ref14 : defaultColorsObj.gradientDirection : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientDirection;
    return {
        colorFirst: colorFirst,
        colorSecond: colorSecond,
        gradientAngle: gradientAngle,
        gradientDirection: gradientDirection,
        isGradient: isGradient
    };
}
/**
 * Checks if at least one gradient needed value is written
 *
 * @param colorsObj
 * @returns
 */ function handleGradientValueWritten(colorsObj) {
    var ref, ref1, ref2;
    return ((ref2 = (ref1 = (ref = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst) !== null && ref !== void 0 ? ref : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond) !== null && ref1 !== void 0 ? ref1 : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle) !== null && ref2 !== void 0 ? ref2 : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientDirection) ? true : false;
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/backgroundImageStyle.ts






//Temp to handle nulls
var backgroundImageStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
/**
 * We should only check for property and undefined
 * this solution is only until we fix the null being send around the page object
 */ // props only, no enable
var BackgroundImagePropsCodec = (0,es6/* type */.dt)({
    position: es6/* string */.Z_,
    repeat: es6/* string */.Z_,
    size: es6/* string */.Z_,
    src: es6/* string */.Z_
});
var BackgroundImageCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    BackgroundImagePropsCodec
]);
// props only, no enable
var BackgroundImagePropsOptCodec = (0,es6/* partial */.r$)({
    position: backgroundImageStyle_nullable(es6/* string */.Z_),
    repeat: backgroundImageStyle_nullable(es6/* string */.Z_),
    size: backgroundImageStyle_nullable(es6/* string */.Z_),
    src: backgroundImageStyle_nullable(es6/* string */.Z_)
});
var BackgroundImageOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: backgroundImageStyle_nullable(es6/* boolean */.O7)
    }),
    BackgroundImagePropsOptCodec
]);
var StylesBackgroundImageCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        image: BackgroundImageCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                image: BackgroundImageOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                image: BackgroundImageOptCodec
            })
        }),
        mobile: (0,es6/* partial */.r$)({
            image: BackgroundImageOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    image: BackgroundImageOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    image: BackgroundImageOptCodec
                })
            })
        }),
        tablet: (0,es6/* partial */.r$)({
            image: BackgroundImageOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    image: BackgroundImageOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    image: BackgroundImageOptCodec
                })
            })
        })
    }), 
]);
function backgroundImageStyle_responsiveStyle(imageObj, desktopDefaultValues, breakpointDefaultValues) {
    var hasEnable = imageObj.hasOwnProperty("enable");
    if (hasEnable && !utils_objValueExists(imageObj, "enable")) return "";
    /**
   * Check if property is available, and fallback to breakpointDefault or the desktopDefault
   */ var position = (imageObj === null || imageObj === void 0 ? void 0 : imageObj.position) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.position) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.position);
    var repeat = (imageObj === null || imageObj === void 0 ? void 0 : imageObj.repeat) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.repeat) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.repeat);
    var size = (imageObj === null || imageObj === void 0 ? void 0 : imageObj.size) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.size) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.size);
    var src = (imageObj === null || imageObj === void 0 ? void 0 : imageObj.src) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.src) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.src);
    if (hasEnable && !imageObj.enable) return {
        "background-image": "none !important"
    };
    //TODO: handle gradient color
    return {
        "background-size": "".concat(position, " !important"),
        "background-repeat": "".concat(repeat, " !important"),
        "background-position": "".concat(size, " !important"),
        "background-image": "url(".concat(src, ") !important")
    };
}
function backgroundImageStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState, imageSrc) {
    var foundationStyle = arguments.length > 4 && arguments[4] !== void 0 // TODO: fix when working on other bobs
     ? arguments[4] : undefined;
    var styles = StylesBackgroundImageCodec.decode(stylesObj);
    // TODO: should use codec from colors?
    if ((0,Either/* isRight */.tO)(styles)) return backgroundImageStyle_cssRender(styles.right, stylesObj, breakpoint, behaviourState, imageSrc, foundationStyle);
    console.warn(codecUtils_decoderErrors(styles));
    return {
        "background-position": "0% 0%",
        "background-repeat": "repeat",
        "background-size": "contain",
        "background-image": "transparent"
    };
}
// export function globalStyleCssRenderUnsafe(
//   gsObj: any,
//   breakpoint: Breakpoint,
//   behaviourState: BehaviourState_,
//   foundationStyle: FColor | undefined = undefined // TODO: Work on when foundation is added to global styles
// ): BackgroundImageCSS | "" {
//   const gs = GSBackgroundImageCodec.decode(gsObj)
//   if (isRight(gs)) return globalStyleCssRender(gs.right, breakpoint, behaviourState, foundationStyle)
//   console.warn(decoderErrors(gs))
//   return ""
// }
function backgroundImageStyle_cssRender(stylesObj, colorsStyles, breakpoint, behaviourState, imageSrc, foundationStyle) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return backgroundImageStyle_renderBob(stylesObj.image, colorsStyles.colors, imageSrc, foundationStyle);
        } else {
            var ref, ref1, ref2, ref3;
            return backgroundImageStyle_renderBobOpt(backgroundImageStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.image, stylesObj.image), colorsStyle_mergeBob2(colorsStyles === null || colorsStyles === void 0 ? void 0 : (ref2 = colorsStyles.behaviour) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[behaviourState]) === null || ref3 === void 0 ? void 0 : ref3.colors, colorsStyles.colors), imageSrc, foundationStyle);
        }
    } else {
        if (behaviourState === "default") {
            var ref4, ref5;
            return backgroundImageStyle_renderBobOpt(backgroundImageStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref4 = stylesObj[breakpoint]) === null || ref4 === void 0 ? void 0 : ref4.image, stylesObj.image), colorsStyle_mergeBob2(colorsStyles === null || colorsStyles === void 0 ? void 0 : (ref5 = colorsStyles[breakpoint]) === null || ref5 === void 0 ? void 0 : ref5.colors, colorsStyles.colors), imageSrc, foundationStyle);
        } else {
            var ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
            return backgroundImageStyle_renderBobOpt(backgroundImageStyle_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj[breakpoint]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.behaviour) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[behaviourState]) === null || ref8 === void 0 ? void 0 : ref8.image, stylesObj === null || stylesObj === void 0 ? void 0 : (ref9 = stylesObj.behaviour) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[behaviourState]) === null || ref10 === void 0 ? void 0 : ref10.image, stylesObj === null || stylesObj === void 0 ? void 0 : (ref11 = stylesObj[breakpoint]) === null || ref11 === void 0 ? void 0 : ref11.image, stylesObj.image), colorsStyle_mergeBob3(colorsStyles === null || colorsStyles === void 0 ? void 0 : (ref12 = colorsStyles[breakpoint]) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.behaviour) === null || ref13 === void 0 ? void 0 : (ref14 = ref13[behaviourState]) === null || ref14 === void 0 ? void 0 : ref14.colors, colorsStyles === null || colorsStyles === void 0 ? void 0 : (ref15 = colorsStyles.behaviour) === null || ref15 === void 0 ? void 0 : (ref16 = ref15[behaviourState]) === null || ref16 === void 0 ? void 0 : ref16.colors, colorsStyles === null || colorsStyles === void 0 ? void 0 : (ref17 = colorsStyles[breakpoint]) === null || ref17 === void 0 ? void 0 : ref17.colors, colorsStyles.colors), imageSrc, foundationStyle);
        }
    }
}
// export function globalStyleCssRender(
//   stylesObj: GSBackgroundImage,
//   breakpoint: Breakpoint,
//   behaviourState: BehaviourState_,
//   foundationStyle: FColor | undefined
// ): BackgroundImageCSS {
//   if (breakpoint === "desktop") {
//     if (behaviourState === "default") {
//       return render(stylesObj, foundationStyle)
//     }
//     //hover | active
//     else {
//       return render(merge2(stylesObj?.behaviour?.[behaviourState], stylesObj), foundationStyle)
//     }
//   }
//   //tablet | mobile
//   else {
//     if (behaviourState === "default") {
//       return render(merge2(stylesObj?.[breakpoint], stylesObj), foundationStyle)
//     }
//     //hover | active
//     else {
//       return render(
//         merge3(
//           stylesObj?.[breakpoint]?.behaviour?.[behaviourState],
//           stylesObj.behaviour?.[behaviourState],
//           stylesObj?.[breakpoint],
//           stylesObj
//         ),
//         foundationStyle
//       )
//     }
//   }
// }
function backgroundImageStyle_renderBob(imageObj, colorsObj, imageSrc, foundationStyle) {
    if (!imageObj.enable && !colorsObj.isGradient) return {
        "background-image": "none !important"
    };
    return backgroundImageStyle_render(imageObj, colorsObj, imageSrc, foundationStyle);
}
function backgroundImageStyle_renderBobOpt(imageObj, colorsObj, imageSrc, foundationStyle) {
    if (!imageObj.enable && !colorsObj.isGradient) return {
        "background-image": "none !important"
    };
    return backgroundImageStyle_renderOpt(imageObj, colorsObj, imageSrc, foundationStyle);
}
function backgroundImageStyle_render(imageObj, colorsObj, imageSrc, foundationStyle) {
    return {
        "background-size": "".concat(imageObj.size, " !important"),
        "background-repeat": "".concat(imageObj.repeat, " !important"),
        "background-position": "".concat(imageObj.position, " !important"),
        "background-image": backgroundImageStyle_handleBackgroundImage(imageObj, colorsObj, imageSrc)
    };
}
function backgroundImageStyle_renderOpt(imageObj, colorsObj, imageSrc, foundationStyle) {
    return {
        "background-size": "".concat(imageObj.size, " !important"),
        "background-repeat": "".concat(imageObj.repeat, " !important"),
        "background-position": "".concat(imageObj.position, " !important"),
        "background-image": handleBackgroundImageOpt(imageObj, colorsObj, imageSrc)
    };
}
function backgroundImageStyle_handleBackgroundImage(imageObj, colorsObj, imageSrc) {
    // image and gradient are enabled
    if (imageObj.enable && imageSrc && imageSrc !== "" && colorsObj.isGradient) {
        return "\n        linear-gradient(\n        ".concat(colorsObj.gradientAngle ? colorsObj.gradientAngle : 0, "deg,           \n        ").concat(colorsObj.colorFirst, ", \n        ").concat(colorsObj.colorSecond, ")\n        ").concat(", url(".concat(imageSrc, ")"), " !important\n      ");
    } else if ((!imageObj.enable || !imageSrc && imageSrc === "") && colorsObj.isGradient) {
        return "\n        linear-gradient(\n        ".concat(colorsObj.gradientAngle ? colorsObj.gradientAngle : 0, "deg,           \n        ").concat(colorsObj.colorFirst, ", \n        ").concat(colorsObj.colorSecond, ") !important\n      ");
    }
    // only image is enabled
    return imageSrc && imageSrc !== "" ? "url(".concat(imageSrc, ") !important") : "url() !important";
}
function handleBackgroundImageOpt(imageObj, colorsObj, imageSrc) {
    // image and gradient are enabled
    if (imageObj.enable && imageSrc && imageSrc !== "" && colorsObj.isGradient) {
        return "\n        linear-gradient(\n        ".concat(colorsObj.gradientAngle ? colorsObj.gradientAngle : 0, "deg,           \n        ").concat(colorsObj.colorFirst, ", \n        ").concat(colorsObj.colorSecond, ")\n        ").concat(", url(".concat(imageSrc, ")"), " !important\n      ");
    } else if ((!imageObj.enable || !imageSrc && imageSrc === "") && colorsObj.isGradient) {
        return "\n        linear-gradient(\n        ".concat(colorsObj.gradientAngle ? colorsObj.gradientAngle : 0, "deg,           \n        ").concat(colorsObj.colorFirst, ", \n        ").concat(colorsObj.colorSecond, ") !important\n      ");
    }
    // only image is enabled
    return imageSrc && imageSrc !== "" ? "url(".concat(imageSrc, ") !important") : "url() !important";
}
/**
 *
 * @param imageObj
 * @param defaultBackgroundImageObj
 * @returns BackgroundImage
 *
 */ function backgroundImageStyle_mergeBob2(imageObj, defaultBackgroundImageObj) {
    var enable = bobUtils_get2WithNull(imageObj === null || imageObj === void 0 ? void 0 : imageObj.enable, defaultBackgroundImageObj.enable);
    var position = bobUtils_get2WithNull(imageObj === null || imageObj === void 0 ? void 0 : imageObj.position, defaultBackgroundImageObj.position);
    var repeat = bobUtils_get2WithNull(imageObj === null || imageObj === void 0 ? void 0 : imageObj.repeat, defaultBackgroundImageObj.repeat);
    var size = bobUtils_get2WithNull(imageObj === null || imageObj === void 0 ? void 0 : imageObj.size, defaultBackgroundImageObj.size);
    var src = bobUtils_get2WithNull(imageObj === null || imageObj === void 0 ? void 0 : imageObj.src, defaultBackgroundImageObj.src);
    return {
        enable: enable,
        position: position,
        repeat: repeat,
        size: size,
        src: src
    };
}
/**
 *
 * @param imageObj
 * @param defaultBackgroundImageObj
 * @returns BackgroundImageProps
 *
 */ function backgroundImageStyle_merge2(imageObj, defaultBackgroundImageObj) {
    var position = get2WithNull(imageObj === null || imageObj === void 0 ? void 0 : imageObj.position, defaultBackgroundImageObj.position);
    var repeat = get2WithNull(imageObj === null || imageObj === void 0 ? void 0 : imageObj.repeat, defaultBackgroundImageObj.repeat);
    var size = get2WithNull(imageObj === null || imageObj === void 0 ? void 0 : imageObj.size, defaultBackgroundImageObj.size);
    var src = get2WithNull(imageObj === null || imageObj === void 0 ? void 0 : imageObj.src, defaultBackgroundImageObj.src);
    return {
        position: position,
        repeat: repeat,
        size: size,
        src: src
    };
}
/**
 *
 * @param imageObj
 * @param imageDefaultBreakpoint
 * @param defaultBackgroundImageObj
 * @returns BackgroundImage
 */ function backgroundImageStyle_mergeBob3(imageObj, imageDesktopBehaviour, imageDefaultBreakpoint, defaultBackgroundImageObj) {
    var ref, ref1, ref2;
    var enable = (ref2 = (ref1 = (ref = imageObj === null || imageObj === void 0 ? void 0 : imageObj.enable) !== null && ref !== void 0 ? ref : imageDesktopBehaviour === null || imageDesktopBehaviour === void 0 ? void 0 : imageDesktopBehaviour.enable) !== null && ref1 !== void 0 ? ref1 : imageDefaultBreakpoint === null || imageDefaultBreakpoint === void 0 ? void 0 : imageDefaultBreakpoint.enable) !== null && ref2 !== void 0 ? ref2 : defaultBackgroundImageObj.enable;
    var ref3, ref4, ref5;
    var position = (ref5 = (ref4 = (ref3 = imageObj === null || imageObj === void 0 ? void 0 : imageObj.position) !== null && ref3 !== void 0 ? ref3 : imageDesktopBehaviour === null || imageDesktopBehaviour === void 0 ? void 0 : imageDesktopBehaviour.position) !== null && ref4 !== void 0 ? ref4 : imageDefaultBreakpoint === null || imageDefaultBreakpoint === void 0 ? void 0 : imageDefaultBreakpoint.position) !== null && ref5 !== void 0 ? ref5 : defaultBackgroundImageObj.position;
    var ref6, ref7, ref8;
    var repeat = (ref8 = (ref7 = (ref6 = imageObj === null || imageObj === void 0 ? void 0 : imageObj.repeat) !== null && ref6 !== void 0 ? ref6 : imageDesktopBehaviour === null || imageDesktopBehaviour === void 0 ? void 0 : imageDesktopBehaviour.repeat) !== null && ref7 !== void 0 ? ref7 : imageDefaultBreakpoint === null || imageDefaultBreakpoint === void 0 ? void 0 : imageDefaultBreakpoint.repeat) !== null && ref8 !== void 0 ? ref8 : defaultBackgroundImageObj.repeat;
    var ref9, ref10, ref11;
    var size = (ref11 = (ref10 = (ref9 = imageObj === null || imageObj === void 0 ? void 0 : imageObj.size) !== null && ref9 !== void 0 ? ref9 : imageDesktopBehaviour === null || imageDesktopBehaviour === void 0 ? void 0 : imageDesktopBehaviour.size) !== null && ref10 !== void 0 ? ref10 : imageDefaultBreakpoint === null || imageDefaultBreakpoint === void 0 ? void 0 : imageDefaultBreakpoint.size) !== null && ref11 !== void 0 ? ref11 : defaultBackgroundImageObj.size;
    var ref12, ref13, ref14;
    var src = (ref14 = (ref13 = (ref12 = imageObj === null || imageObj === void 0 ? void 0 : imageObj.src) !== null && ref12 !== void 0 ? ref12 : imageDesktopBehaviour === null || imageDesktopBehaviour === void 0 ? void 0 : imageDesktopBehaviour.src) !== null && ref13 !== void 0 ? ref13 : imageDefaultBreakpoint === null || imageDefaultBreakpoint === void 0 ? void 0 : imageDefaultBreakpoint.src) !== null && ref14 !== void 0 ? ref14 : defaultBackgroundImageObj.src;
    return {
        enable: enable,
        position: position,
        repeat: repeat,
        size: size,
        src: src
    };
}
/**
 *
 * @param imageObj
 * @param imageDefaultBreakpoint
 * @param defaultBackgroundImageObj
 * @returns BackgroundImage
 */ function backgroundImageStyle_merge3(imageObj, imageDesktopBehaviour, imageDefaultBreakpoint, defaultBackgroundImageObj) {
    var ref, ref1, ref2;
    var position = (ref2 = (ref1 = (ref = imageObj === null || imageObj === void 0 ? void 0 : imageObj.position) !== null && ref !== void 0 ? ref : imageDesktopBehaviour === null || imageDesktopBehaviour === void 0 ? void 0 : imageDesktopBehaviour.position) !== null && ref1 !== void 0 ? ref1 : imageDefaultBreakpoint === null || imageDefaultBreakpoint === void 0 ? void 0 : imageDefaultBreakpoint.position) !== null && ref2 !== void 0 ? ref2 : defaultBackgroundImageObj.position;
    var ref3, ref4, ref5;
    var repeat = (ref5 = (ref4 = (ref3 = imageObj === null || imageObj === void 0 ? void 0 : imageObj.repeat) !== null && ref3 !== void 0 ? ref3 : imageDesktopBehaviour === null || imageDesktopBehaviour === void 0 ? void 0 : imageDesktopBehaviour.repeat) !== null && ref4 !== void 0 ? ref4 : imageDefaultBreakpoint === null || imageDefaultBreakpoint === void 0 ? void 0 : imageDefaultBreakpoint.repeat) !== null && ref5 !== void 0 ? ref5 : defaultBackgroundImageObj.repeat;
    var ref6, ref7, ref8;
    var size = (ref8 = (ref7 = (ref6 = imageObj === null || imageObj === void 0 ? void 0 : imageObj.size) !== null && ref6 !== void 0 ? ref6 : imageDesktopBehaviour === null || imageDesktopBehaviour === void 0 ? void 0 : imageDesktopBehaviour.size) !== null && ref7 !== void 0 ? ref7 : imageDefaultBreakpoint === null || imageDefaultBreakpoint === void 0 ? void 0 : imageDefaultBreakpoint.size) !== null && ref8 !== void 0 ? ref8 : defaultBackgroundImageObj.size;
    var ref9, ref10, ref11;
    var src = (ref11 = (ref10 = (ref9 = imageObj === null || imageObj === void 0 ? void 0 : imageObj.src) !== null && ref9 !== void 0 ? ref9 : imageDesktopBehaviour === null || imageDesktopBehaviour === void 0 ? void 0 : imageDesktopBehaviour.src) !== null && ref10 !== void 0 ? ref10 : imageDefaultBreakpoint === null || imageDefaultBreakpoint === void 0 ? void 0 : imageDefaultBreakpoint.src) !== null && ref11 !== void 0 ? ref11 : defaultBackgroundImageObj.src;
    return {
        position: position,
        repeat: repeat,
        size: size,
        src: src
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/attachmentStyle.ts

var AttachmentStyle = /*#__PURE__*/ function() {
    "use strict";
    function AttachmentStyle() {
        (0,src_class_call_check/* default */.Z)(this, AttachmentStyle);
    }
    AttachmentStyle.responsiveStyle = function responsiveStyle(attachmentObj) {
        return {
            "background-attachment": "".concat(attachmentObj, " !important")
        };
    };
    return AttachmentStyle;
}();
/* harmony default export */ var attachmentStyle = (AttachmentStyle);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/behaviourStyle.ts

var BehaviourStyle = /*#__PURE__*/ function() {
    "use strict";
    function BehaviourStyle() {
        (0,src_class_call_check/* default */.Z)(this, BehaviourStyle);
    }
    BehaviourStyle.responsiveStyle = function responsiveStyle(behaviourObj) {
        return {};
    };
    return BehaviourStyle;
}();
/* harmony default export */ var behaviourStyle = (BehaviourStyle);

// EXTERNAL MODULE: ./node_modules/lodash/groupBy.js
var groupBy = __webpack_require__(7739);
var groupBy_default = /*#__PURE__*/__webpack_require__.n(groupBy);
// EXTERNAL MODULE: ./node_modules/lodash/flatMap.js
var flatMap = __webpack_require__(94654);
var flatMap_default = /*#__PURE__*/__webpack_require__.n(flatMap);
;// CONCATENATED MODULE: ./src/modules/shared-modules/globalStyles/globalStylesTypes.ts
var GS_BOUNDARY = "GSpacing";
var GS_SHADOW = "GShadow";
var GS_SCREEN_FLOW = "GExpansion";
var GS_HEIGHT = "GDimension";
var GS_BORDER_RADIUS = "GCorner";
var GS_BORDER = "GBorder";
var GS_BG_COLORS = "GBackgroundColor";
var GS_COLUMNS = "GColumns";
var GS_ALIGNMENT = "GAlignment";
var GS_FILTER = "GFilter";
var GS_TEXT = "GText";
var GS_TEXT_COLOR = "GColor";
var GS_ICON = "GIcon";
// NGS(new global styles)
var NGS_CLASS_SUFIX = "_ngs";

// EXTERNAL MODULE: ./node_modules/fp-ts/es6/Console.js
var Console = __webpack_require__(1718);
;// CONCATENATED MODULE: ./src/api/shared-api/types/cmsContentTypes.ts
function mkRawUrl(s) {
    return s; // no validation
}
function mkMediaItemId(s) {
    return s; // no validation
}

// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
;// CONCATENATED MODULE: ./src/lib/brand/StringType.ts

/*
    A string newtype without validation.
*/ function schema() {
    return lib.z.string().brand();
}
function wrap(schema, u) {
    return u;
}

;// CONCATENATED MODULE: ./src/modules/shared-modules/mediaLibrary/mediaLibraryUtils.ts





var ProfileNameSchema = schema();
var mkProfileName = function(s) {
    return wrap(ProfileNameSchema, s);
};
/**
 *
 * @param profile string
 * @param media any
 * This function manages to preview for the mediaLibrary
 */ function mediaLibraryUtils_handleLink(profile, media) {
    if ((media === null || media === void 0 ? void 0 : media.itemType) === "image") return "https://static-media.fluxio.cloud/".concat(media.profileName ? media.profileName : profile, "/").concat(media.id).concat(media.extension ? "".concat(hasVersion(media.version), ".").concat(media.extension) : "".concat(hasVersion(media.version)));
    if ((media === null || media === void 0 ? void 0 : media.itemType) === "video") return "https://static-media.fluxio.cloud/".concat(media.profileName ? media.profileName : profile, "/").concat(media.id).concat(media.extension ? "".concat(hasVersion(media.version), ".").concat(media.extension) : "".concat(hasVersion(media.version)));
    if ((media === null || media === void 0 ? void 0 : media.itemType) === "other") return "https://static-media.fluxio.cloud/".concat(media.profileName ? media.profileName : profile, "/").concat(media.id).concat(media.extension ? "".concat(hasVersion(media.version), ".").concat(media.extension) : "".concat(hasVersion(media.version)));
    console.warn("unhandled itemType");
    return "https://cdn.fluxio.cloud/fluxio/fluxio_placeholder.png";
}
/**
 *
 * @param pageResponse
 * @param mediaId
 * This function renders the final media in the bobX render
 */ function mediaLibraryUtils_handleSrcLink(pageResponse, mediaIdOrUrl // TODO: type
) {
    var placeholder = mkRawUrl("https://cdn.fluxio.cloud/fluxio/fluxio_placeholder.png");
    var placeholderAlt = "Fluxio";
    //Direct link
    if (!(mediaIdOrUrl === null || mediaIdOrUrl === void 0 ? void 0 : mediaIdOrUrl.startsWith("media"))) return {
        mediaSrc: mkRawUrl(mediaIdOrUrl !== null && mediaIdOrUrl !== void 0 ? mediaIdOrUrl : ""),
        mediaAlt: ""
    };
    //If the media object is not available we return a placeholder
    var cutMediaId = mkMediaItemId(mediaIdOrUrl.replace(/media-/g, ""));
    var mediaObject = pageResponse.media[cutMediaId];
    if (!mediaObject) {
        console.warn("Missing media object for ".concat(cutMediaId, " asset"));
        return {
            mediaSrc: placeholder,
            mediaAlt: placeholderAlt
        };
    }
    //With no profile available we stop and return a placeholder
    var profile = mkProfileName(mediaObject.profileName || pageResponse.profileName) // should be typed way before this
    ;
    if (!profile) {
        console.warn("Missing Profile Name for asset handler");
        return {
            mediaSrc: placeholder,
            mediaAlt: placeholderAlt
        };
    }
    //if the logic got here than we can return the proper url for the asset
    return {
        mediaSrc: makeMediaUrl(profile, cutMediaId, mediaObject.version, mediaObject.extension),
        mediaAlt: mediaObject.alt,
        fallbackExtension: mediaObject.fallbackExtension,
        mediaInfo: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, mediaObject), {
            id: cutMediaId,
            profileName: profile
        })
    };
}
function makeMediaUrl(profileName, mediaItemId, version, ext) {
    return mkRawUrl("https://static-media.fluxio.cloud/".concat(profileName, "/").concat(mediaItemId).concat(showVersion(version), ".").concat(ext));
}
/**
 *
 * @param pageResponse
 * @param mediaId
 * This function renders the final media in the bobX render
 */ function handleContentSrcLink(mediaList, profile, mediaId) {
    var placeholder = "https://cdn.fluxio.cloud/fluxio/fluxio_placeholder.png";
    var placeholderAlt = "Fluxio";
    //No media
    if (!mediaId) return {
        mediaSrc: placeholder,
        mediaAlt: placeholderAlt
    };
    //Direct link
    if (!(mediaId === null || mediaId === void 0 ? void 0 : mediaId.startsWith("media"))) return {
        mediaSrc: mediaId,
        mediaAlt: placeholderAlt
    };
    //no media present
    if (!mediaList) {
        console.warn("Missing medias for ".concat(mediaId, " asset"));
        return {
            mediaSrc: placeholder,
            mediaAlt: placeholderAlt
        };
    }
    //If the media object is not available we return a placeholder
    var cutMediaId = mediaId.replace(/media-/g, "");
    var mediaObject = mediaList[cutMediaId];
    if (!mediaObject) {
        console.warn("Missing media object for ".concat(cutMediaId, " asset"));
        return {
            mediaSrc: placeholder,
            mediaAlt: placeholderAlt
        };
    }
    //With no profile available we stop and return a placeholder
    if (!profile) {
        console.warn("Missing Profile Name for asset handler");
        return {
            mediaSrc: placeholder,
            mediaAlt: placeholderAlt
        };
    }
    //if the logic got here than we can return the proper url for the asset
    return {
        mediaSrc: "https://static-media.fluxio.cloud/".concat(profile, "/").concat(cutMediaId).concat(hasVersion(mediaObject.version), ".").concat(mediaObject.extension),
        mediaAlt: mediaObject.alt
    };
}
function cutMediaString(mediaStr) {
    return mediaStr.replace(/media-/g, "");
}
/**
 *
 * @param pageResponse
 * @param mediaId
 * @param field
 * IF the field param is not sent, this function returns the entire object
 */ function handleMediaFields(pageResponse, mediaId, field) {
    var defaultMsg = function(fieldMsg) {
        return "Missing field ".concat(fieldMsg);
    };
    if (!mediaId) {
        //console.warn(defaultMsg("mediaId"))
        return undefined;
    }
    //Direct link
    if (!(mediaId === null || mediaId === void 0 ? void 0 : mediaId.startsWith("media"))) return mediaId;
    var profile = pageResponse.profileName;
    if (!profile) return defaultMsg("profileName");
    //If the media object is not available we return a placeholder
    var cutMediaId = mediaId.replace(/media-/g, "");
    var mediaObject = pageResponse.media[cutMediaId];
    if (!mediaObject) return "Missing or Deleted Media";
    //if no field is defined, we send the entire object
    if (!field) return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, mediaObject), {
        id: cutMediaId,
        profile: profile
    });
    //No field available
    if (!mediaObject[field]) return defaultMsg(field);
    //Return field
    return mediaObject[field];
}
/**
 *
 * @param mediaList medialist that doesnt come from the pageResponse
 * @param profile
 * @param mediaId
 * @param field
 * IF the field param is not sent, this function returns the entire object
 */ function handleContentMediaFields(mediaList, mediaId, field) {
    var defaultMsg = function(fieldMsg) {
        return "Missing field ".concat(fieldMsg);
    };
    if (!mediaList) return defaultMsg("Medias");
    //Direct link
    if (!(mediaId === null || mediaId === void 0 ? void 0 : mediaId.startsWith("media"))) return mediaId;
    //If the media object is not available we return a placeholder
    var cutMediaId = mediaId.replace(/media-/g, "");
    var mediaObject = mediaList[cutMediaId];
    if (!mediaObject) return defaultMsg("Media Object");
    //if no field is defined, we send the entire object
    if (!field) return _object_spread_props(_object_spread({}, mediaObject), {
        id: cutMediaId,
        profile: mediaObject.profileName
    });
    //No field available
    if (!mediaObject[field]) return defaultMsg(field);
    //Return field
    return mediaObject[field];
}
function writeMediaToPage(pageObject, mediaObject) {
    var mediaObj = _define_property({}, mediaObject.id, _object_spread({}, mediaObject));
    pageObject.media = _object_spread({}, pageObject.media, mediaObj);
    return pageObject;
}
function getMediaId(mediaSrc) {
    if (mediaSrc.startsWith("media")) return mediaSrc.replace(/media-/g, "");
    return mediaSrc;
}
/**
 *
 * @param mediaObj
 * This method should only be used when the mediaObj comes from the handleMediaFields()
 */ function handleMediaSrc(mediaObj) {
    //When handleMediaFields() couldnt resolve the object
    if (typeof mediaObj === "string") return mediaObj;
    return "https://static-media.fluxio.cloud/".concat(mediaObj.profile || mediaObj.profileName, "/").concat(mediaObj.id).concat(hasVersion(mediaObj.version), ".").concat(mediaObj.extension);
}
function hasVersion(version) {
    if (version) return "_".concat(version);
    return "";
}
function showVersion(version) {
    return hasVersion(version);
}
function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","), //@ts-ignore
    mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([
        u8arr
    ], filename, {
        type: mime
    });
}
function formatBytes(bytes) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    if (bytes === 0) return "0 Bytes";
    var k = 1024;
    var dm = decimals < 0 ? 0 : decimals;
    var sizes = [
        "Bytes",
        "KB",
        "MB",
        "GB",
        "TB",
        "PB",
        "EB",
        "ZB",
        "YB"
    ];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

;// CONCATENATED MODULE: ./src/modules/shared-modules/stylesheet/stylesheetUtils.tsx








var writeStylesheetCssVariables = function(stylesheetLabels) {
    var cssVariables = "";
    if (stylesheetLabels) {
        for(var key in stylesheetLabels){
            var label = stylesheetLabels[key];
            if (label.type === "Color") cssVariables += "\n--".concat(writeStylesheetVariable(label), ": ").concat(label.value, ";");
            if (label.type === "Font") cssVariables += "\n--".concat(writeStylesheetVariable(label), ": ").concat(label.fontFamily, ";");
        }
    }
    return cssVariables;
};
var writeStylesheetVariable = function(stylesheetLabel) {
    return "".concat(stylesheetLabel.type, "-").concat(stylesheetLabel.name);
};
var handleBobStylesheetLabel = function(stylesheetLabel, bobValue) {
    if (stylesheetLabel) return "var(--".concat(writeStylesheetVariable(stylesheetLabel), ")");
    return bobValue || "";
};
var handleMediaStylesheetLabel = function(stylesheetLabel, mediaValue) {
    if (stylesheetLabel) return stylesheetLabel.value;
    return mediaValue || "";
};
var handleBobBorderLabel = function(styles, stylesheetLabels, breakpoint, state) {
    var stylesheetBorderTopColorLabel;
    var stylesheetBorderBottomColorLabel;
    var stylesheetBorderRightColorLabel;
    var stylesheetBorderLeftColorLabel;
    // DESKTOP
    if (breakpoint === "desktop") {
        // hover
        if (state !== "default") {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
            stylesheetBorderTopColorLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref = styles.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[state]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.border) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.labels) === null || ref3 === void 0 ? void 0 : ref3.topColor) || ""];
            stylesheetBorderBottomColorLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref4 = styles.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[state]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.border) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.labels) === null || ref7 === void 0 ? void 0 : ref7.bottomColor) || ""];
            stylesheetBorderRightColorLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref8 = styles.behaviour) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[state]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.border) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.labels) === null || ref11 === void 0 ? void 0 : ref11.rightColor) || ""];
            stylesheetBorderLeftColorLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref12 = styles.behaviour) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[state]) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.border) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.labels) === null || ref15 === void 0 ? void 0 : ref15.leftColor) || ""];
        } else {
            var ref16, ref17, ref18, ref19;
            stylesheetBorderTopColorLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref16 = styles.border.labels) === null || ref16 === void 0 ? void 0 : ref16.topColor) || ""];
            stylesheetBorderBottomColorLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref17 = styles.border.labels) === null || ref17 === void 0 ? void 0 : ref17.bottomColor) || ""];
            stylesheetBorderRightColorLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref18 = styles.border.labels) === null || ref18 === void 0 ? void 0 : ref18.rightColor) || ""];
            stylesheetBorderLeftColorLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref19 = styles.border.labels) === null || ref19 === void 0 ? void 0 : ref19.leftColor) || ""];
        }
    } else {
        // hover
        if (state !== "default") {
            var ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39;
            stylesheetBorderTopColorLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref20 = styles[breakpoint]) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.behaviour) === null || ref21 === void 0 ? void 0 : (ref22 = ref21[state]) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.border) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.labels) === null || ref24 === void 0 ? void 0 : ref24.topColor) || ""];
            stylesheetBorderBottomColorLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref25 = styles[breakpoint]) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.behaviour) === null || ref26 === void 0 ? void 0 : (ref27 = ref26[state]) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.border) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.labels) === null || ref29 === void 0 ? void 0 : ref29.bottomColor) || ""];
            stylesheetBorderRightColorLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref30 = styles[breakpoint]) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.behaviour) === null || ref31 === void 0 ? void 0 : (ref32 = ref31[state]) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.border) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.labels) === null || ref34 === void 0 ? void 0 : ref34.rightColor) || ""];
            stylesheetBorderLeftColorLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref35 = styles[breakpoint]) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.behaviour) === null || ref36 === void 0 ? void 0 : (ref37 = ref36[state]) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.border) === null || ref38 === void 0 ? void 0 : (ref39 = ref38.labels) === null || ref39 === void 0 ? void 0 : ref39.leftColor) || ""];
        } else {
            var ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51;
            stylesheetBorderTopColorLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref40 = styles[breakpoint]) === null || ref40 === void 0 ? void 0 : (ref41 = ref40.border) === null || ref41 === void 0 ? void 0 : (ref42 = ref41.labels) === null || ref42 === void 0 ? void 0 : ref42.topColor) || ""];
            stylesheetBorderBottomColorLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref43 = styles[breakpoint]) === null || ref43 === void 0 ? void 0 : (ref44 = ref43.border) === null || ref44 === void 0 ? void 0 : (ref45 = ref44.labels) === null || ref45 === void 0 ? void 0 : ref45.bottomColor) || ""];
            stylesheetBorderRightColorLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref46 = styles[breakpoint]) === null || ref46 === void 0 ? void 0 : (ref47 = ref46.border) === null || ref47 === void 0 ? void 0 : (ref48 = ref47.labels) === null || ref48 === void 0 ? void 0 : ref48.rightColor) || ""];
            stylesheetBorderLeftColorLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref49 = styles[breakpoint]) === null || ref49 === void 0 ? void 0 : (ref50 = ref49.border) === null || ref50 === void 0 ? void 0 : (ref51 = ref50.labels) === null || ref51 === void 0 ? void 0 : ref51.leftColor) || ""];
        }
    }
    return {
        "top-color": (stylesheetBorderTopColorLabel === null || stylesheetBorderTopColorLabel === void 0 ? void 0 : stylesheetBorderTopColorLabel.type) === "Color" ? stylesheetBorderTopColorLabel : undefined,
        "bottom-color": (stylesheetBorderBottomColorLabel === null || stylesheetBorderBottomColorLabel === void 0 ? void 0 : stylesheetBorderBottomColorLabel.type) === "Color" ? stylesheetBorderBottomColorLabel : undefined,
        "left-color": (stylesheetBorderLeftColorLabel === null || stylesheetBorderLeftColorLabel === void 0 ? void 0 : stylesheetBorderLeftColorLabel.type) === "Color" ? stylesheetBorderLeftColorLabel : undefined,
        "right-color": (stylesheetBorderRightColorLabel === null || stylesheetBorderRightColorLabel === void 0 ? void 0 : stylesheetBorderRightColorLabel.type) === "Color" ? stylesheetBorderRightColorLabel : undefined
    };
};
var handleBobColorsLabel = function(styles, stylesheetLabels, breakpoint, state) {
    var stylesheetColorFirstLabel;
    var stylesheetColorSecondLabel;
    // DESKTOP
    if (breakpoint === "desktop") {
        // hover
        if (state !== "default") {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
            stylesheetColorFirstLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref = styles.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[state]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.labels) === null || ref3 === void 0 ? void 0 : ref3.colorFirst) || ""];
            stylesheetColorSecondLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref4 = styles.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[state]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.colors) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.labels) === null || ref7 === void 0 ? void 0 : ref7.colorSecond) || ""];
        } else {
            var ref8, ref9;
            // default
            stylesheetColorFirstLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref8 = styles.colors.labels) === null || ref8 === void 0 ? void 0 : ref8.colorFirst) || ""];
            stylesheetColorSecondLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref9 = styles.colors.labels) === null || ref9 === void 0 ? void 0 : ref9.colorSecond) || ""];
        }
    } else {
        // hover
        if (state !== "default") {
            var ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
            stylesheetColorFirstLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref10 = styles[breakpoint]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.behaviour) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[state]) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.colors) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.labels) === null || ref14 === void 0 ? void 0 : ref14.colorFirst) || ""];
            stylesheetColorSecondLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref15 = styles[breakpoint]) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.behaviour) === null || ref16 === void 0 ? void 0 : (ref17 = ref16[state]) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.colors) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.labels) === null || ref19 === void 0 ? void 0 : ref19.colorSecond) || ""];
        } else {
            var ref20, ref21, ref22, ref23, ref24, ref25;
            // default
            stylesheetColorFirstLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref20 = styles[breakpoint]) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.colors) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.labels) === null || ref22 === void 0 ? void 0 : ref22.colorFirst) || ""];
            stylesheetColorSecondLabel = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref23 = styles[breakpoint]) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.colors) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.labels) === null || ref25 === void 0 ? void 0 : ref25.colorSecond) || ""];
        }
    }
    return {
        "color-first": (stylesheetColorFirstLabel === null || stylesheetColorFirstLabel === void 0 ? void 0 : stylesheetColorFirstLabel.type) === "Color" ? stylesheetColorFirstLabel : undefined,
        "color-second": (stylesheetColorSecondLabel === null || stylesheetColorSecondLabel === void 0 ? void 0 : stylesheetColorSecondLabel.type) === "Color" ? stylesheetColorSecondLabel : undefined
    };
};
var handleBobShadowLabel = function(styles, stylesheetLabels, breakpoint, state) {
    var ref, ref1, ref2;
    // DESKTOP
    if (breakpoint === "desktop") {
        var ref3, ref4;
        // hover
        if (state !== "default") {
            var ref5, ref6, ref7, ref8;
            var label = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref5 = styles.behaviour) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[state]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.shadow) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.labels) === null || ref8 === void 0 ? void 0 : ref8.color) || ""];
            if ((label === null || label === void 0 ? void 0 : label.type) === "Color") return label;
            return undefined;
        }
        // default
        var label1 = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[(styles === null || styles === void 0 ? void 0 : (ref3 = styles.shadow) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.labels) === null || ref4 === void 0 ? void 0 : ref4.color) || ""];
        if ((label1 === null || label1 === void 0 ? void 0 : label1.type) === "Color") return label1;
        return undefined;
    }
    // MOBILE/TABLET
    // hover
    if (state !== "default") {
        var ref9, ref10, ref11, ref12, ref13;
        var label2 = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[(styles === null || styles === void 0 ? void 0 : (ref9 = styles[breakpoint]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.behaviour) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[state]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.shadow) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.labels) === null || ref13 === void 0 ? void 0 : ref13.color) || ""];
        if ((label2 === null || label2 === void 0 ? void 0 : label2.type) === "Color") return label2;
        return undefined;
    }
    // default
    var label3 = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[(styles === null || styles === void 0 ? void 0 : (ref = styles[breakpoint]) === null || ref === void 0 ? void 0 : (ref1 = ref.shadow) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.labels) === null || ref2 === void 0 ? void 0 : ref2.color) || ""];
    if ((label3 === null || label3 === void 0 ? void 0 : label3.type) === "Color") return label3;
    return undefined;
};
var handleBobTextDecorationLabel = function(styles, stylesheetLabels, breakpoint, state) {
    var ref, ref1, ref2;
    // DESKTOP
    if (breakpoint === "desktop") {
        var ref3, ref4;
        // hover
        if (state !== "default") {
            var ref5, ref6, ref7, ref8;
            var label = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref5 = styles.behaviour) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[state]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.textDecorationV2) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.labels) === null || ref8 === void 0 ? void 0 : ref8.color) || ""];
            if ((label === null || label === void 0 ? void 0 : label.type) === "Color") return label;
            return undefined;
        }
        // default
        var label1 = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[(styles === null || styles === void 0 ? void 0 : (ref3 = styles.textDecorationV2) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.labels) === null || ref4 === void 0 ? void 0 : ref4.color) || ""];
        if ((label1 === null || label1 === void 0 ? void 0 : label1.type) === "Color") return label1;
        return undefined;
    }
    // MOBILE/TABLET
    // hover
    if (state !== "default") {
        var ref9, ref10, ref11, ref12, ref13;
        var label2 = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[(styles === null || styles === void 0 ? void 0 : (ref9 = styles[breakpoint]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.behaviour) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[state]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.textDecorationV2) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.labels) === null || ref13 === void 0 ? void 0 : ref13.color) || ""];
        if ((label2 === null || label2 === void 0 ? void 0 : label2.type) === "Color") return label2;
        return undefined;
    }
    // default
    var label3 = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[(styles === null || styles === void 0 ? void 0 : (ref = styles[breakpoint]) === null || ref === void 0 ? void 0 : (ref1 = ref.textDecorationV2) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.labels) === null || ref2 === void 0 ? void 0 : ref2.color) || ""];
    if ((label3 === null || label3 === void 0 ? void 0 : label3.type) === "Color") return label3;
    return undefined;
};
var handleBobTextShadowLabel = function(styles, stylesheetLabels, breakpoint, state) {
    var ref, ref1, ref2;
    // DESKTOP
    if (breakpoint === "desktop") {
        var ref3, ref4;
        // hover
        if (state !== "default") {
            var ref5, ref6, ref7, ref8;
            var label = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref5 = styles.behaviour) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[state]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.textShadow) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.labels) === null || ref8 === void 0 ? void 0 : ref8.color) || ""];
            if ((label === null || label === void 0 ? void 0 : label.type) === "Color") return label;
            return undefined;
        }
        // default
        var label1 = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[(styles === null || styles === void 0 ? void 0 : (ref3 = styles.textShadow) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.labels) === null || ref4 === void 0 ? void 0 : ref4.color) || ""];
        if ((label1 === null || label1 === void 0 ? void 0 : label1.type) === "Color") return label1;
        return undefined;
    }
    // MOBILE/TABLET
    // hover
    if (state !== "default") {
        var ref9, ref10, ref11, ref12, ref13;
        var label2 = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[(styles === null || styles === void 0 ? void 0 : (ref9 = styles[breakpoint]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.behaviour) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[state]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.textShadow) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.labels) === null || ref13 === void 0 ? void 0 : ref13.color) || ""];
        if ((label2 === null || label2 === void 0 ? void 0 : label2.type) === "Color") return label2;
        return undefined;
    }
    // default
    var label3 = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[(styles === null || styles === void 0 ? void 0 : (ref = styles[breakpoint]) === null || ref === void 0 ? void 0 : (ref1 = ref.textShadow) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.labels) === null || ref2 === void 0 ? void 0 : ref2.color) || ""];
    if ((label3 === null || label3 === void 0 ? void 0 : label3.type) === "Color") return label3;
    return undefined;
};
var handleBobLabel = function(styles, stylesheetLabels, breakpoint, state, type) {
    var ref, ref1;
    // DESKTOP
    if (breakpoint === "desktop") {
        var ref2;
        // hover
        if (state !== "default") {
            var ref3, ref4, ref5;
            return stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref3 = styles.behaviour) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[state]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.labels) === null || ref5 === void 0 ? void 0 : ref5[type]) || ""];
        }
        // default
        return stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref2 = styles.labels) === null || ref2 === void 0 ? void 0 : ref2[type]) || ""];
    }
    // MOBILE/TABLET
    // hover
    if (state !== "default") {
        var ref6, ref7, ref8, ref9;
        return stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref6 = styles[breakpoint]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.behaviour) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[state]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.labels) === null || ref9 === void 0 ? void 0 : ref9[type]) || ""];
    }
    // default
    return stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[((ref = styles[breakpoint]) === null || ref === void 0 ? void 0 : (ref1 = ref.labels) === null || ref1 === void 0 ? void 0 : ref1[type]) || ""];
};
var attachStylesheetLabel = function(hubContent, label, selectedObject, bobKey, controller, controllerProp, breakpoint, state, emEditorType) {
    var clonedHubContent = cloneDeep(hubContent);
    if (!clonedHubContent.stylesheet) {
        var objects = handleObjectsListType(clonedHubContent, selectedObject, emEditorType);
        console.warn("stylesheet doens't exist");
        return {
            hubContent: hubContent,
            objects: objects
        };
    }
    //trigger publish btn
    clonedHubContent.isOutdated = true;
    // attach to bob
    var objects1 = handleObjectsListType(clonedHubContent, selectedObject, emEditorType);
    var labelController = handleLabelController(controller, objects1[selectedObject.uuid].styles.bobs[bobKey], breakpoint, state);
    labelController.labels = _object_spread({}, labelController.labels, handleControllerProp(controllerProp, label));
    return {
        hubContent: clonedHubContent,
        objects: objects1
    };
};
var dettachStylesheetLabel = function(hubContent, label, selectedObject, bobKey, controller, controllerProp, breakpoint, state, emEditorType) {
    var ref;
    var clonedHubContent = cloneDeep(hubContent);
    //trigger publish btn
    clonedHubContent.isOutdated = true;
    // dettach from bob
    var objects = handleObjectsListType(clonedHubContent, selectedObject, emEditorType);
    var labelController = handleLabelController(controller, objects[selectedObject.uuid].styles.bobs[bobKey], breakpoint, state);
    if (controllerProp === "allColor") {
        var ref1, ref2, ref3, ref4;
        (ref1 = labelController.labels) === null || ref1 === void 0 ? void 0 : delete ref1["topColor"];
        (ref2 = labelController.labels) === null || ref2 === void 0 ? void 0 : delete ref2["bottomColor"];
        (ref3 = labelController.labels) === null || ref3 === void 0 ? void 0 : delete ref3["leftColor"];
        (ref4 = labelController.labels) === null || ref4 === void 0 ? void 0 : delete ref4["rightColor"];
    } else (ref = labelController.labels) === null || ref === void 0 ? void 0 : delete ref[controllerProp];
    return {
        hubContent: clonedHubContent,
        objects: objects
    };
};
var attachStylesheetLabelContent = function(hubContent, label, selectedObject, controller, emEditorType) {
    var clonedHubContent = cloneDeep(hubContent);
    if (!clonedHubContent.stylesheet) {
        var objects = handleObjectsListType(clonedHubContent, selectedObject, emEditorType);
        console.warn("stylesheet doens't exist");
        return {
            hubContent: hubContent,
            objects: objects
        };
    }
    //trigger publish btn
    clonedHubContent.isOutdated = true;
    // attach to page
    clonedHubContent.stylesheet = _object_spread_props(_object_spread({}, clonedHubContent.stylesheet), {
        labels: _object_spread_props(_object_spread({}, clonedHubContent.stylesheet.labels), _define_property({}, getLabelKey(label.name, label.type), label))
    });
    // attach to bob
    var objects1 = handleObjectsListType(clonedHubContent, selectedObject, emEditorType);
    objects1[selectedObject.uuid].content.inlineContent.labels = _object_spread_props(_object_spread({}, objects1[selectedObject.uuid].content.inlineContent.labels), _define_property({}, controller, getLabelKey(label.name, label.type)));
    return {
        hubContent: clonedHubContent,
        objects: objects1
    };
};
var dettachStylesheetLabelContent = function(hubContent, selectedObject, controller, emEditorType) {
    var clonedHubContent = cloneDeep(hubContent);
    //trigger publish btn
    clonedHubContent.isOutdated = true;
    // dettach from bob
    var objects = handleObjectsListType(clonedHubContent, selectedObject, emEditorType);
    delete objects[selectedObject.uuid].content.inlineContent.labels[controller];
    return {
        hubContent: clonedHubContent,
        objects: objects
    };
};
var handleControllerProp = function(controllerProp, label) {
    if (controllerProp === "allColor") {
        return {
            topColor: getLabelKey(label.name, label.type),
            leftColor: getLabelKey(label.name, label.type),
            rightColor: getLabelKey(label.name, label.type),
            bottomColor: getLabelKey(label.name, label.type)
        };
    } else {
        return _define_property({}, controllerProp, getLabelKey(label.name, label.type));
    }
};
var handleStyleHelper = function(a) {
    if (a !== undefined) return a;
    return {};
};
var handleStyleControllerHelper = function(a) {
    if (a !== undefined) return a;
    return {};
};
var handleLabelController = function(controller, styles, breakpoint, state) {
    /**
   * handle controller on root of template
   */ if (controller === "color" || controller === "") {
        // MOBILE/TABLET
        if (breakpoint !== "desktop") {
            // active/hover
            if (state !== "default") {
                var ref, ref1;
                return handleStyleHelper((ref = styles[breakpoint]) === null || ref === void 0 ? void 0 : (ref1 = ref.behaviour) === null || ref1 === void 0 ? void 0 : ref1[state]);
            }
            // normal
            return handleStyleHelper(styles[breakpoint]);
        }
        // DESKTOP
        // active/hover
        if (state !== "default") {
            return styles.behaviour[state];
        }
        // normal
        return styles;
    } else {
        /**
     * handle controller on controller prop of template
     */ // MOBILE/TABLET
        if (breakpoint !== "desktop") {
            var ref2;
            // active/hover
            if (state !== "default") {
                var ref3, ref4, ref5;
                return handleStyleControllerHelper((ref3 = styles[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[state]) === null || ref5 === void 0 ? void 0 : ref5[controller]);
            }
            // normal
            return handleStyleControllerHelper((ref2 = styles[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2[controller]);
        }
        // DESKTOP
        // active/hover
        if (state !== "default") {
            return handleStyleControllerHelper(styles.behaviour[state][controller]);
        }
        // normal
        return handleStyleControllerHelper(styles[controller]);
    }
};
var getAttachedStylesheetLabel = function(labelController, pageResponse, selectedProperty, globalStyle) {
    if (labelController || globalStyle) {
        var ref, ref1;
        // global style label
        if (globalStyle && globalStyle.labels) {
            var ref2, ref3;
            return (ref2 = pageResponse.stylesheet) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.labels) === null || ref3 === void 0 ? void 0 : ref3[globalStyle.labels[selectedProperty === "allColor" ? "topColor" : selectedProperty]];
        }
        // object label
        if (labelController.labels) return (ref = pageResponse.stylesheet) === null || ref === void 0 ? void 0 : (ref1 = ref.labels) === null || ref1 === void 0 ? void 0 : ref1[labelController.labels[selectedProperty === "allColor" ? "topColor" : selectedProperty] // TODO: fix allColor condition
        ];
    }
};
var getAttachedStylesheetLabelContent = function(inlineContent, stylesheet, prop) {
    var ref, ref1;
    return inlineContent && (stylesheet === null || stylesheet === void 0 ? void 0 : (ref1 = stylesheet.labels) === null || ref1 === void 0 ? void 0 : ref1[inlineContent === null || inlineContent === void 0 ? void 0 : (ref = inlineContent.labels) === null || ref === void 0 ? void 0 : ref[prop]]);
};
var getAttachedBobLabel = function(labels, labelName, labelType) {
    return labels === null || labels === void 0 ? void 0 : labels[getLabelKey(labelName, labelType)];
};
var getLabelKey = function(labelName, labelType) {
    return "".concat(labelName, "-").concat(labelType);
};
var getLabelValue = function(label, valueKey) {
    if (valueKey === "fontFamily" && valueKey in label) return label[valueKey];
    if (valueKey === "value" && valueKey in label) return label[valueKey];
    console.warn("missing valueKey");
    return "";
};
var getLabelsList = function(labels, type, valueKey) {
    var mediaLabelsList = [];
    if (labels) for(var key in labels){
        var label = labels[key];
        if (label.type === type && valueKey in label) {
            mediaLabelsList = _to_consumable_array(mediaLabelsList).concat([
                {
                    value: label.name,
                    label: getLabelValue(label, valueKey)
                }, 
            ]);
        }
    }
    return mediaLabelsList;
};
var getMediaLabelsList = function(labels, media, profile) {
    var mediaLabelsList = [];
    if (labels) for(var key in labels){
        var label = labels[key];
        if (label.type === "Media") {
            var labelMedia = media === null || media === void 0 ? void 0 : media[(label === null || label === void 0 ? void 0 : label.value.replace(/media-/g, "")) || ""];
            mediaLabelsList = _to_consumable_array(mediaLabelsList).concat([
                {
                    value: label.value,
                    label: label.name,
                    icon: /*#__PURE__*/ _jsx("img", {
                        style: {
                            height: "15px",
                            width: "35px",
                            objectFit: "contain",
                            backgroundColor: "rgba(0,0,0,0.3)",
                            objectPosition: "center center"
                        },
                        src: labelMedia ? handleLink(profile, labelMedia) : "",
                        alt: label.name
                    }, label.name)
                }, 
            ]);
        }
    }
    return mediaLabelsList;
};

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/textStyle.ts











//Temp to handle nulls
var textStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
var FontTypeCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("custom"),
    (0,es6/* literal */.i0)("google-fonts")
]);
var FontTypeOpt = (0,es6/* partial */.r$)({
    fontType: FontTypeCodec
});
var TextCodec = (0,es6/* intersection */.jV)([
    FontTypeOpt,
    (0,es6/* type */.dt)({
        fontFamily: es6/* string */.Z_,
        fontSize: es6/* number */.pk,
        fontWeight: es6/* number */.pk,
        letterSpacing: es6/* number */.pk,
        lineHeight: es6/* number */.pk
    }), 
]);
var TextOptCodec = (0,es6/* partial */.r$)({
    fontFamily: textStyle_nullable(es6/* string */.Z_),
    fontType: textStyle_nullable(FontTypeCodec),
    fontSize: textStyle_nullable(es6/* number */.pk),
    fontWeight: textStyle_nullable(es6/* number */.pk),
    letterSpacing: textStyle_nullable(es6/* number */.pk),
    lineHeight: textStyle_nullable(es6/* number */.pk)
});
var StylesTextCodec = (0,es6/* intersection */.jV)([
    TextCodec,
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: TextOptCodec,
            hover: TextOptCodec
        }),
        mobile: (0,es6/* intersection */.jV)([
            TextOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: TextOptCodec,
                    hover: TextOptCodec
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            TextOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: TextOptCodec,
                    hover: TextOptCodec
                })
            }), 
        ])
    }), 
]);
var GSTextCodec = (0,es6/* intersection */.jV)([
    TextCodec,
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: TextOptCodec,
            hover: TextOptCodec
        }),
        mobile: (0,es6/* intersection */.jV)([
            TextOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: TextOptCodec,
                    hover: TextOptCodec
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            TextOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: TextOptCodec,
                    hover: TextOptCodec
                })
            }), 
        ])
    }), 
]);
function textStyle_responsiveStyle(bobTextObj) {
    return (0,src_object_spread/* default */.Z)({
        "font-family": "".concat(utils_objValueExists(bobTextObj, "fontFamily") ? '"'.concat(bobTextObj.fontFamily, '" !important') : ""),
        "font-size": "".concat(utils_objValueExists(bobTextObj, "fontSize") ? bobTextObj.fontSize + "px !important" : ""),
        "font-weight": "".concat(utils_objValueExists(bobTextObj, "fontWeight") ? bobTextObj.fontWeight + " !important" : ""),
        "letter-spacing": "".concat(utils_objValueExists(bobTextObj, "letterSpacing") ? bobTextObj.letterSpacing + "px !important" : ""),
        "line-height": "".concat(utils_objValueExists(bobTextObj, "lineHeight") ? bobTextObj.lineHeight + " !important" : ""),
        "text-align": "".concat(utils_objValueExists(bobTextObj, "textAlign") ? bobTextObj.textAlign + " !important" : ""),
        "text-transform": "".concat(utils_objValueExists(bobTextObj, "textTransform") ? bobTextObj.textTransform + " !important" : "")
    }, textStyle_handleVerticalAlign(utils_objValueExists(bobTextObj, "verticalAlign") ? bobTextObj.verticalAlign + " !important" : ""));
}
function textStyle_handleVerticalAlign(verticalAlign) {
    var verticalStyle = {
        display: "flex",
        "justify-content": "center !important",
        "flex-direction": "column !important",
        "align-self": "center !important"
    };
    if (verticalAlign === "middle") {
        return verticalStyle;
    }
    if (verticalAlign === "top") {
        verticalStyle["justify-content"] = "flex-start !important";
        verticalStyle["align-self"] = "flex-start !important";
        return verticalStyle;
    }
    if (verticalAlign === "bottom") {
        verticalStyle["justify-content"] = "flex-end !important";
        verticalStyle["align-self"] = "flex-end !important";
        return verticalStyle;
    }
}
function textStyle_renderCSSString(textStyle) {
    if (!("font-family" in textStyle)) {
        return "";
    } else {
        return 'font-family: "'.concat(textStyle["font-family"], '" !important;\n    font-size: ').concat(textStyle["font-size"], "px !important;\n    font-weight: ").concat(textStyle["font-weight"], " !important;\n    letter-spacing: ").concat(textStyle["letter-spacing"], "px !important;\n    line-height: ").concat(textStyle["line-height"], " !important;");
    }
}
function getFontImports(gsObj, pageLabels, expManager) {
    if (!expManager.enable) return "";
    var importsString = "";
    Object.values(gsObj).forEach(function(nGs) {
        if (nGs.type === GS_TEXT) {
            var styles = StylesTextCodec.decode(nGs);
            if ((0,lib_Either.isRight)(styles)) {
                var label = handleBobLabel(nGs, pageLabels, "desktop", "default", "fontFamily");
                importsString += renderImportFont(getSetFonts([
                    textStyle_cssRender(styles.right, "desktop", "default"),
                    textStyle_cssRender(styles.right, "desktop", "hover"),
                    textStyle_cssRender(styles.right, "desktop", "active"),
                    textStyle_cssRender(styles.right, "mobile", "default"),
                    textStyle_cssRender(styles.right, "mobile", "hover"),
                    textStyle_cssRender(styles.right, "mobile", "active"),
                    textStyle_cssRender(styles.right, "tablet", "default"),
                    textStyle_cssRender(styles.right, "tablet", "hover"),
                    textStyle_cssRender(styles.right, "tablet", "active"), 
                ]), label);
            } else {
                Console/* warn */.ZK(codecUtils_decoderErrors(styles));
            }
        }
    });
    return importsString;
}
function textStyle_dynamicFontLoader(fontObj, label) {
    var nonItalWght = "";
    var weightsString = "wght@";
    fontObj.weights.forEach(function(element) {
        nonItalWght += "".concat(nonItalWght === "" ? "" : ",") + element;
    });
    weightsString += nonItalWght;
    return "@import url('https://fonts.bunny.net/css?family=".concat((label === null || label === void 0 ? void 0 : label.fontFamily) || fontObj.font, ":").concat(weightsString, "&display=swap');");
}
function getSetFonts(fonts) {
    var grouped = groupBy_default()(flatMap_default()(fonts, function(x) {
        return x === "" ? [] : [
            x
        ];
    }), function(x) {
        return x["font-family"];
    }) // { arial: [{font-family: arial,  weight: 300}] }
    ;
    return Object.entries(grouped).map(function(kv) {
        return {
            font: kv[0],
            weights: Array.from(new Set(kv[1].map(function(x) {
                return x["font-weight"];
            }))),
            type: kv[1][0]["font-type"]
        };
    });
}
function renderImportFont(fonts, label) {
    var stringImports = "";
    fonts.forEach(function(fontObj) {
        if (fontObj.type === "google-fonts") stringImports += "".concat(textStyle_dynamicFontLoader(fontObj, label), " ");
    });
    return stringImports;
}
function textStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var styles = StylesTextCodec.decode(stylesObj);
    if (isRight(styles)) return textStyle_cssRender(styles.right, breakpoint, behaviourState);
    console.warn("TextStyle ".concat(breakpoint, " ").concat(behaviourState, " ").concat(decoderErrors(styles)));
    return {};
}
function textStyle_globalStyleCssRenderUnsafe(gsObj, breakpoint, behaviourState) {
    var gs = GSTextCodec.decode(gsObj);
    if ((0,lib_Either.isRight)(gs)) return textStyle_globalStyleCssRender(gs.right, breakpoint, behaviourState);
    Console/* warn */.ZK("TextGSStyle ".concat(breakpoint, " ").concat(behaviourState, " ").concat(codecUtils_decoderErrors(gs)));
    return {};
}
function textStyle_cssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return textStyle_renderBob(stylesObj);
        } else {
            var ref;
            return textStyle_renderBob(textStyle_merge2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : ref[behaviourState], stylesObj));
        }
    } else {
        if (behaviourState === "default") {
            return textStyle_renderBob(textStyle_merge2(stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj));
        } else {
            var ref1, ref2, ref3;
            return textStyle_renderBob(textStyle_merge3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref1 = stylesObj[breakpoint]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : ref2[behaviourState], stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj.behaviour) === null || ref3 === void 0 ? void 0 : ref3[behaviourState], stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj));
        }
    }
}
function textStyle_globalStyleCssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return textStyle_render(stylesObj);
        } else {
            var ref;
            return textStyle_render(textStyle_merge2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : ref[behaviourState], stylesObj));
        }
    } else {
        if (behaviourState === "default") {
            return textStyle_render(textStyle_merge2(stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj));
        } else {
            var ref1, ref2, ref3;
            return textStyle_render(textStyle_merge3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref1 = stylesObj[breakpoint]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : ref2[behaviourState], (ref3 = stylesObj.behaviour) === null || ref3 === void 0 ? void 0 : ref3[behaviourState], stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj));
        }
    }
}
function textStyle_renderBob(textObj) {
    return textStyle_render(textObj);
}
function textStyle_render(textObj) {
    var _fontType;
    return {
        "font-family": textObj.fontFamily,
        "font-weight": textObj.fontWeight,
        "font-size": textObj.fontSize,
        "letter-spacing": textObj.letterSpacing,
        "line-height": textObj.lineHeight,
        "font-type": (_fontType = textObj.fontType) !== null && _fontType !== void 0 ? _fontType : "google-fonts"
    };
}
function textStyle_merge2(textObj, defaultTextObj) {
    var fontFamily = bobUtils_get2WithNull(textObj === null || textObj === void 0 ? void 0 : textObj.fontFamily, defaultTextObj.fontFamily);
    var fontType = bobUtils_get2WithNull(textObj === null || textObj === void 0 ? void 0 : textObj.fontType, defaultTextObj.fontType);
    var fontSize = bobUtils_get2WithNull(textObj === null || textObj === void 0 ? void 0 : textObj.fontSize, defaultTextObj.fontSize);
    var fontWeight = bobUtils_get2WithNull(textObj === null || textObj === void 0 ? void 0 : textObj.fontWeight, defaultTextObj.fontWeight);
    var letterSpacing = bobUtils_get2WithNull(textObj === null || textObj === void 0 ? void 0 : textObj.letterSpacing, defaultTextObj.letterSpacing);
    var lineHeight = bobUtils_get2WithNull(textObj === null || textObj === void 0 ? void 0 : textObj.lineHeight, defaultTextObj.lineHeight);
    return {
        fontFamily: fontFamily,
        fontType: fontType,
        fontSize: fontSize,
        fontWeight: fontWeight,
        letterSpacing: letterSpacing,
        lineHeight: lineHeight
    };
}
function textStyle_merge3(textObj, shadowDesktopBehaviour, shadowDefaultBreakpoint, defaultTextObj) {
    var ref, ref1, ref2;
    var fontFamily = (ref2 = (ref1 = (ref = textObj === null || textObj === void 0 ? void 0 : textObj.fontFamily) !== null && ref !== void 0 ? ref : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.fontFamily) !== null && ref1 !== void 0 ? ref1 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.fontFamily) !== null && ref2 !== void 0 ? ref2 : defaultTextObj.fontFamily;
    var ref3, ref4, ref5;
    var fontType = (ref5 = (ref4 = (ref3 = textObj === null || textObj === void 0 ? void 0 : textObj.fontType) !== null && ref3 !== void 0 ? ref3 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.fontType) !== null && ref4 !== void 0 ? ref4 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.fontType) !== null && ref5 !== void 0 ? ref5 : defaultTextObj.fontType;
    var ref6, ref7, ref8;
    var fontSize = (ref8 = (ref7 = (ref6 = textObj === null || textObj === void 0 ? void 0 : textObj.fontSize) !== null && ref6 !== void 0 ? ref6 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.fontSize) !== null && ref7 !== void 0 ? ref7 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.fontSize) !== null && ref8 !== void 0 ? ref8 : defaultTextObj.fontSize;
    var ref9, ref10, ref11;
    var fontWeight = (ref11 = (ref10 = (ref9 = textObj === null || textObj === void 0 ? void 0 : textObj.fontWeight) !== null && ref9 !== void 0 ? ref9 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.fontWeight) !== null && ref10 !== void 0 ? ref10 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.fontWeight) !== null && ref11 !== void 0 ? ref11 : defaultTextObj.fontWeight;
    var ref12, ref13, ref14;
    var letterSpacing = (ref14 = (ref13 = (ref12 = textObj === null || textObj === void 0 ? void 0 : textObj.letterSpacing) !== null && ref12 !== void 0 ? ref12 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.letterSpacing) !== null && ref13 !== void 0 ? ref13 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.letterSpacing) !== null && ref14 !== void 0 ? ref14 : defaultTextObj.letterSpacing;
    var ref15, ref16, ref17;
    var lineHeight = (ref17 = (ref16 = (ref15 = textObj === null || textObj === void 0 ? void 0 : textObj.lineHeight) !== null && ref15 !== void 0 ? ref15 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.lineHeight) !== null && ref16 !== void 0 ? ref16 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.lineHeight) !== null && ref17 !== void 0 ? ref17 : defaultTextObj.lineHeight;
    return {
        fontFamily: fontFamily,
        fontType: fontType,
        fontSize: fontSize,
        fontWeight: fontWeight,
        letterSpacing: letterSpacing,
        lineHeight: lineHeight
    };
}


;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/bobIconStyle.ts

var BobIconStyle = /*#__PURE__*/ function() {
    "use strict";
    function BobIconStyle() {
        (0,src_class_call_check/* default */.Z)(this, BobIconStyle);
    }
    BobIconStyle.responsiveStyle = function responsiveStyle(bobIconObj) {
        return {
            "font-size": "".concat(bobIconObj.size, "px !important")
        };
    };
    return BobIconStyle;
}();
/* harmony default export */ var bobIconStyle = (BobIconStyle);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/zindexStyle.ts







//Temp to handle nulls
var zindexStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
var ZIndexCodec = (0,es6/* type */.dt)({
    value: es6/* number */.pk,
    enable: es6/* boolean */.O7
});
var ZIndexOptCodec = (0,es6/* partial */.r$)({
    value: zindexStyle_nullable(es6/* number */.pk),
    enable: zindexStyle_nullable(es6/* boolean */.O7)
});
var StylesZIndexCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        zIndex: ZIndexCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                zIndex: ZIndexOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                zIndex: ZIndexOptCodec
            })
        }),
        mobile: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                zIndex: ZIndexOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        zIndex: ZIndexOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        zIndex: ZIndexOptCodec
                    })
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                zIndex: ZIndexOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        zIndex: ZIndexOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        zIndex: ZIndexOptCodec
                    })
                })
            }), 
        ])
    }), 
]);
function zindexStyle_responsiveStyle(zIndexObj) {
    if (!utils_objValueExists(zIndexObj, "enable")) return "";
    if (!zIndexObj.enable) return {
        "z-index": "auto !important"
    };
    var zIndexStyle = {};
    if (zIndexObj.value) {
        zIndexStyle = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, zIndexStyle), {
            "z-index": zIndexObj.value + "!important"
        });
    }
    return zIndexStyle;
}
function zindexStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var styles = StylesZIndexCodec.decode(stylesObj);
    if ((0,lib_Either.isRight)(styles)) return zindexStyle_cssRender(styles.right, breakpoint, behaviourState);
    console.warn("ZIndexStyle ".concat(breakpoint, " ").concat(behaviourState, " ").concat(codecUtils_decoderErrors(styles)));
    return {};
}
function zindexStyle_cssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return zindexStyle_renderBob(stylesObj.zIndex);
        } else {
            var ref, ref1;
            return zindexStyle_renderBobOpt(stylesObj.zIndex, zindexStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.zIndex, stylesObj.zIndex));
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return zindexStyle_renderBobOpt(stylesObj.zIndex, zindexStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.zIndex, stylesObj.zIndex));
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return zindexStyle_renderBobOpt(stylesObj.zIndex, zindexStyle_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.zIndex, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.zIndex, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.zIndex, stylesObj.zIndex));
        }
    }
}
function zindexStyle_renderBob(zIndexObj) {
    if (!zIndexObj.enable) return {};
    return zindexStyle_render(zIndexObj);
}
/**
 * Renders ColorsOpt css for breakpoints/state templates
 * or empty for non written style props
 *
 * @param zIndexObj
 * @param foundationStyle
 * @returns
 */ function zindexStyle_renderBobOpt(defaultZIndexObj, zIndexObj) {
    if ((zIndexObj === null || zIndexObj === void 0 ? void 0 : zIndexObj.enable) === false) {
        if (defaultZIndexObj.enable) return {
            "z-index": "0"
        };
        return {};
    }
    if (zIndexObj === null || zIndexObj === void 0 ? void 0 : zIndexObj.enable) return zindexStyle_renderOpt(zIndexObj);
    return {};
}
/**
 * Renders ZIndexOpt css for breakpoints/state templates
 * Returns color
 * or empty for non written style props
 *
 * @param zIndexObj
 * @param foundationStyle
 * @returns
 */ function zindexStyle_renderOpt(zIndexObj) {
    var css = {};
    if (valueExists(zIndexObj === null || zIndexObj === void 0 ? void 0 : zIndexObj.value)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "z-index": "".concat(zIndexObj === null || zIndexObj === void 0 ? void 0 : zIndexObj.value)
    });
    return css;
}
function zindexStyle_render(zIndexObj) {
    return {
        "z-index": "".concat(zIndexObj.value)
    };
}
function zindexStyle_mergeBob2(zIndexObj, defaultZIndexObj) {
    var enable = get2WithNull4Enable(zIndexObj === null || zIndexObj === void 0 ? void 0 : zIndexObj.enable, defaultZIndexObj.enable);
    return {
        enable: enable,
        value: zIndexObj === null || zIndexObj === void 0 ? void 0 : zIndexObj.value
    };
}
function zindexStyle_mergeBob3(zIndexObj, zIndexDesktopBehaviour, zIndexDefaultBreakpoint, defaultZIndexObj) {
    var enable = get3WithNull4Enable(zIndexObj === null || zIndexObj === void 0 ? void 0 : zIndexObj.enable, zIndexDesktopBehaviour === null || zIndexDesktopBehaviour === void 0 ? void 0 : zIndexDesktopBehaviour.enable, zIndexDefaultBreakpoint === null || zIndexDefaultBreakpoint === void 0 ? void 0 : zIndexDefaultBreakpoint.enable, defaultZIndexObj.enable);
    return {
        enable: enable,
        value: zIndexObj === null || zIndexObj === void 0 ? void 0 : zIndexObj.value
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobHandler.ts
























/**
 *
 * @param bobObj
 * @param breakpoint
 * @param optionalProperties
 * This param is used to send aditional values that are needed for a specific style
 * The object must be named with the correct property name and the values inside an object, like so:
 * [property]: { valueName: value, valueName: value, etc}
 * @param excluded
 * The excluded param is used to prevent the loop of styles from returning (?a) specific(s) properties,
 * with the following structure:
 * ['property', 'property', etc...]
 * @param exclusive
 * To prevent the loop from happening, and thos rendering only some properties, instead of exluding everything,
 * we just return some, that are presented in this param, like so:
 * ['property', 'property', etc...]
 */ function responsiveProperties(bobObj, breakpoint) {
    var optionalProperties = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, excluded = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], exclusive = arguments.length > 4 ? arguments[4] : void 0, foundationStyle = arguments.length > 5 ? arguments[5] : void 0;
    var cssStylesObj = {};
    //We have properties to render
    if (bobObj[breakpoint]) {
        /**
     * With exclusive present we only return this properties
     */ if (exclusive) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = exclusive[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var property = _step.value;
                    if (bobObj[breakpoint][property]) {
                        cssStylesObj = (0,src_object_spread/* default */.Z)({}, cssStylesObj, stylePropertyHandler(property, bobObj[breakpoint], optionalProperties, foundationStyle));
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return cssStylesObj;
        }
        /**
     * Without exclusive property we render all properties
     */ for(var property1 in bobObj[breakpoint]){
            if (!excluded.includes(property1)) {
                cssStylesObj = (0,src_object_spread/* default */.Z)({}, cssStylesObj, stylePropertyHandler(property1, bobObj[breakpoint], optionalProperties, foundationStyle));
            }
        }
    }
    return cssStylesObj;
}
function stylePropertyHandler(property, styleObj, optionalProperties, foundationStyle) {
    // TODO: handle foundationStyle type when added to other bobs
    switch(property){
        case "spacing":
            return boundaryStyle_responsiveStyle(styleObj[property]);
        case "shadow":
            return responsiveStyle(styleObj[property], optionalProperties[property]);
        case "border":
            return borderStyle_responsiveStyle(styleObj[property]);
        case "radius":
            return radiusStyle_responsiveStyle(styleObj[property]);
        case "alignment":
            return AlignmentResponsiveStyle(styleObj[property], optionalProperties[property]);
        case "filter":
            return filterStyle_responsiveStyle(styleObj[property], optionalProperties[property]);
        case "height":
            return heightStyle_responsiveStyle(styleObj[property]);
        case "size":
            return sizeStyle.responsiveStyle(styleObj[property]);
        case "width":
            return widthStyle_responsiveStyle(styleObj[property]);
        case "position":
            return objectPositionStyle.responsiveStyle(styleObj[property]);
        case "grid":
            return gridStyle.responsiveStyle(styleObj[property]);
        case "wrap":
            return wrapStyle.responsiveStyle(styleObj[property]);
        case "scroll":
            return scrollStyle.responsiveStyle(styleObj[property]);
        case "attachment":
            return attachmentStyle.responsiveStyle(styleObj[property]);
        case "behaviour":
            return behaviourStyle.responsiveStyle(styleObj[property]);
        case "colors":
            return colorsStyle_responsiveStyle(styleObj[property], foundationStyle);
        case "image":
            return backgroundImageStyle_responsiveStyle({
                image: styleObj[property],
                colors: styleObj.colors
            }, optionalProperties[property]);
        case "zIndex":
            return zindexStyle_responsiveStyle(styleObj[property]);
        default:
            return {};
    }
}
function responsiveGroupStylesProperties(bobObj, breakpoint, bobType) {
    if (bobType === "text" && bobObj[breakpoint]) {
        return textStyle_responsiveStyle(bobObj[breakpoint]);
    }
    if (bobType === "ntext" && bobObj[breakpoint]) {
        return textStyle_responsiveStyle(bobObj[breakpoint]);
    }
    if (bobType === "icon" && bobObj[breakpoint]) {
        return bobIconStyle.responsiveStyle(bobObj[breakpoint]);
    }
    //Define that bobType
    return {};
}
/**
 * builds container classe's for each breackpoint when it exists
 * @param bobObj
 */ function responsiveWrapClass(bobObj) {
    var className = "";
    if (bobObj.tablet && bobObj.tablet.wrap) className += "".concat(bobObj.tablet.wrap, "-md ");
    if (bobObj.mobile && bobObj.mobile.wrap) className += "".concat(bobObj.mobile.wrap, "-sm");
    return className;
}
/**
 * builds gutters classe's for each breackpoint when it exists
 * @param bobObj
 */ function bobHandler_responsiveGuttersClass(bobObj, globalStyleTemplate, noGuttersDefault) {
    // TODO: sould we copy only the prop that is edited instead of merging all of the template?
    var bobObjClone;
    if (globalStyleTemplate) bobObjClone = mergeWith_default()({}, bobObj, globalStyleTemplate, mergeCopyArrays);
    else bobObjClone = bobObj;
    // desktop gutters value
    var className = bobObjClone.grid.gutters ? "" : "no-gutters ";
    //Overwrite default
    if (!bobObjClone.grid.hasOwnProperty("gutters")) className = !noGuttersDefault ? "" : "no-gutters";
    if (bobObjClone.tablet && bobObjClone.tablet.grid && utils_objValueExists(bobObjClone.tablet.grid, "gutters")) className += bobObjClone.tablet.grid.gutters ? "gutters-md " : "no-gutters-md ";
    if (bobObjClone.mobile && bobObjClone.mobile.grid && utils_objValueExists(bobObjClone.mobile.grid, "gutters")) className += bobObjClone.mobile.grid.gutters ? "gutters-sm " : "no-gutters-sm ";
    return className;
}
/**
 * method exists on componets too
 * here it needs to reneder !important flag due to the css being used on a class
 * on the components side it cannot render !important because inline styles doens't accept it
 * @param template
 * @param flexDirection
 * @param self
 */ function bobHandler_handleAlignment(template, flexDirection) {
    var self = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!template.alignment) return {};
    var horizontalValue = template.alignment.horizontal === "left" ? "flex-start" : template.alignment.horizontal === "right" ? "flex-end" : template.alignment.horizontal;
    var verticalValue = template.alignment.vertical === "top" ? "flex-start" : template.alignment.vertical === "bottom" ? "flex-end" : template.alignment.vertical;
    return {
        justifyContent: flexDirection === "column" ? verticalValue + " !important" : horizontalValue + " !important",
        alignItems: flexDirection === "column" ? horizontalValue + " !important" : verticalValue + " !important",
        alignSelf: self && flexDirection === "column" ? horizontalValue + " !important" : verticalValue + " !important",
        display: "flex !important",
        flexDirection: flexDirection + " !important"
    };
}
// map contents based on number of columns
// maintain the same pattern of columns if there are multiple lines
function bobHandler_handleColumns(idx, counter, backgroundTemplate, globalStyleTemplate) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var backgroundTemplateClone = backgroundTemplate;
    var mergedTemplate;
    if (globalStyleTemplate) mergedTemplate = mergeWith_default()({}, backgroundTemplateClone, globalStyleTemplate, mergeCopyArrays);
    else mergedTemplate = backgroundTemplate;
    var columns = "12";
    var columnsTablet;
    var columnsMobile;
    var nthCol = mergedTemplate.grid.columns && mergedTemplate.grid.columns.length;
    var nthColTablet = bobHandler_handleDeprecatedCols("tablet", mergedTemplate, nthCol);
    var nthColMobile = bobHandler_handleDeprecatedCols("mobile", mergedTemplate, nthCol);
    counter.desktop = idx % nthCol !== 0 ? counter.desktop + 1 : 0;
    counter.tablet = idx % nthColTablet !== 0 ? counter.tablet + 1 : 0;
    counter.mobile = idx % nthColMobile !== 0 ? counter.mobile + 1 : 0;
    columns = mergedTemplate.grid.columns ? mergedTemplate.grid.columns[counter.desktop] : mergedTemplate.grid.cols;
    /**
   * write desktop as a default value on other breakpoints
   *
   * DEPRECATED:
   * Due to the mobile/tablet columns being defaulted to 12 on the past,
   * we need to handle the bobs that were using this behaviour as if the behaviour still exists,
   * instead of defaulting to the desktop styles.
   * The objects that are edited and republished will have the 'newBehaviour' prop so that the fallback stops working for this ones.
   *
   * This should only be true to objects that were never written with the colsMobile and colTablet props on the grid object.
   * This ones were migrated so that the mobile.grid.columns values is equal to the mobileCols value.
   * So no need to fallback to 12
   */ if (!mergedTemplate.grid.newBehaviour && JSON.stringify(mergedTemplate.grid.columns) !== '["12"]' && !mergedTemplate.grid.columnsTablet && !mergedTemplate.grid.columnsMobile && !((ref = backgroundTemplate.tablet) === null || ref === void 0 ? void 0 : (ref1 = ref.grid) === null || ref1 === void 0 ? void 0 : ref1.columns) && !((ref2 = backgroundTemplate.mobile) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.grid) === null || ref3 === void 0 ? void 0 : ref3.columns)) {
        columnsTablet = "12";
        columnsMobile = "12";
    } else {
        columnsTablet = columns;
        columnsMobile = columns;
    }
    /**
   * Check for legacy data and render that, if new structure is not present
   * Write breakpoint value if it exists
   */ //Mobile
    if (backgroundTemplateClone.mobile && ((ref4 = backgroundTemplateClone.mobile.grid) === null || ref4 === void 0 ? void 0 : ref4.columns)) {
        columnsMobile = backgroundTemplateClone.mobile.grid.columns[counter.mobile];
    } else if (backgroundTemplateClone.grid.columnsMobile) {
        columnsMobile = backgroundTemplateClone.grid.columnsMobile[counter.mobile];
    }
    //Tablet
    if (backgroundTemplateClone.tablet && ((ref5 = backgroundTemplateClone.tablet.grid) === null || ref5 === void 0 ? void 0 : ref5.columns)) {
        columnsTablet = backgroundTemplateClone.tablet.grid.columns[counter.tablet];
    } else if (backgroundTemplateClone.grid.columnsTablet) {
        columnsTablet = backgroundTemplateClone.grid.columnsTablet[counter.tablet];
    }
    return {
        columns: columns,
        columnsTablet: columnsTablet,
        columnsMobile: columnsMobile,
        counter: counter
    };
}
function bobHandler_handleDeprecatedCols(type, template, nthCol) {
    var ref, ref1, ref2, ref3;
    if (type === "tablet") return ((ref = template.tablet) === null || ref === void 0 ? void 0 : (ref1 = ref.grid) === null || ref1 === void 0 ? void 0 : ref1.columns) ? template.tablet.grid.columns.length : template.grid.columnsTablet ? template.grid.columnsTablet.length : nthCol;
    if (type === "mobile") return ((ref2 = template.mobile) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.grid) === null || ref3 === void 0 ? void 0 : ref3.columns) ? template.mobile.grid.columns.length : template.grid.columnsMobile ? template.grid.columnsMobile.length : nthCol;
    return undefined;
}
function mergeCopyArrays(objValue, srcValue) {
    if (isArray_default()(objValue)) return srcValue;
}
function mergeStyleWithGS(styleObject, globalStyleObject) {
    if (!globalStyleObject) return styleObject;
    var clonedStyleObject = styleObject;
    return mergeWith_default()({}, clonedStyleObject, globalStyleObject, mergeStylesOptions);
}
/**
 * force enable value true when it doenst exist on the template
 * @param styleObject
 */ function handleEnableValues(styleObject) {
    if (styleObject.behaviour.hover.enable) {
        for(var prop in styleObject.behaviour.hover){
            if (styleObject[prop] && !styleObject[prop].hasOwnProperty("enable") && styleObject[prop].enable) styleObject.behaviour.hover[prop].enable = styleObject[prop].enable;
        }
    }
    return styleObject;
}
/**
 * This function is used to merge the styles values,
 * keeping the key elements, that are needed.
 * 1. Arrays arent merged, we keep the object to merge.
 * 2. We create exceptions for the following properties:
 * - * uuid
 * - * name
 * @param objValue
 * @param srcValue
 * @param key
 */ function mergeStylesOptions(objValue, srcValue, key) {
    if (key === "uuid") return objValue;
    if (key === "name") return objValue;
    if (isArray_default()(objValue)) return srcValue;
}

;// CONCATENATED MODULE: ./src/modules/shared-modules/utilities/responsiveHandler.tsx




function handleStateValue(stateObj, breakpoint) {
    var state = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "default", field = arguments.length > 3 ? arguments[3] : void 0;
    var ref;
    var responsiveObj;
    // handle responsive or desktop obj
    var obj = breakpoint !== "desktop" ? stateObj[breakpoint] : stateObj;
    /**
   * handle the default value.
   * Should be the default breakpoint(desktop) state value,
   * or if it doenst exist should be the breakpoint value,
   * else the default(desktop) value
   */ var defaultValue = ((ref = stateObj[state]) === null || ref === void 0 ? void 0 : ref[field]) || obj[field] || stateObj[field];
    /**
   * We have the value for this state
   */ if (obj[state] && obj[state].hasOwnProperty(field) && obj[state][field] !== null && obj[state][field] !== undefined) {
        responsiveObj = {
            value: obj[state][field],
            isDiferent: true,
            isUnset: false,
            breakpoint: breakpoint,
            state: state,
            defaultValue: defaultValue
        };
    } else {
        /**
     * We dont have the value so we return the default value
     */ responsiveObj = {
            value: defaultValue,
            isDiferent: false,
            isUnset: true,
            breakpoint: breakpoint,
            state: state,
            defaultValue: defaultValue
        };
    }
    return responsiveObj;
}
function handleResponsiveValue(stateObj, breakpoint, field) {
    var responsiveObj;
    /**
   * We have the value for this breakpoint
   */ if (stateObj[breakpoint] && stateObj[breakpoint].hasOwnProperty(field) && stateObj[breakpoint][field] !== null && stateObj[breakpoint][field] !== undefined) {
        responsiveObj = {
            value: stateObj[breakpoint][field],
            isDiferent: true,
            isUnset: false,
            breakpoint: breakpoint,
            state: "default",
            defaultValue: stateObj[field]
        };
    } else {
        /**
     * We dont have the value so we return the default value
     */ responsiveObj = {
            value: stateObj[field],
            isDiferent: false,
            isUnset: true,
            breakpoint: breakpoint,
            state: "default",
            defaultValue: stateObj[field]
        };
    }
    return responsiveObj;
}
function getValue(selectedBreakpoint, stateObj, field, selectedState) {
    /**
   * handle state values
   */ if (selectedState && (selectedState === "hover" || selectedState === "active")) {
        return handleStateValue(stateObj, selectedBreakpoint.breakpoint, selectedState, field);
    }
    /**
   * handle responsive values
   */ if (selectedBreakpoint.type === "responsive") {
        if (selectedBreakpoint.breakpoint === "mobile" || selectedBreakpoint.breakpoint === "tablet") {
            return handleResponsiveValue(stateObj, selectedBreakpoint.breakpoint, field);
        }
    }
    /**
   * Object for Default Styles Option
   */ var responsiveObj;
    // value/prop exists/is written
    if (utils_objValueExists(stateObj, field)) responsiveObj = {
        value: stateObj[field],
        defaultValue: stateObj[field],
        isDiferent: false,
        isUnset: false,
        breakpoint: "desktop",
        state: "default"
    };
    else responsiveObj = {
        value: stateObj[field],
        defaultValue: stateObj[field],
        isDiferent: false,
        isUnset: true,
        breakpoint: "desktop",
        state: "default"
    };
    return responsiveObj;
}
/**
 * writes all values for a breakpoint(tablet/mobile) when one value is being written on that breakpoint and the others still don't exist
 * for this we write the isDiferent=true on every prop, so that bobs use the prop value in that breakpoint
 *
 * this is needed if, for example, we change shadow color in tablet, the other props must be written too with the desktop values,
 * else the css being rendered is not valid due to the other props being null
 *
 * TODO: check performance
 *
 * @param properties properties to handle
 * @param propToIgnore ignore prop value being changed, it's already being writen in state
 */ function handleBreakpointValues(properties, propToIgnore) {
    if (properties[propToIgnore].breakpoint !== "desktop") {
        var values = {};
        for(var prop in properties){
            // @ts-ignore
            if (prop !== propToIgnore && properties[prop].hasOwnProperty("isDiferent")) // @ts-ignore
            values = _object_spread_props(_object_spread({}, values), _define_property({}, prop, _object_spread_props(_object_spread({}, properties[prop]), {
                isDiferent: true,
                isUnset: false
            })));
        }
        return values;
    }
    return {};
}

;// CONCATENATED MODULE: ./src/modules/shared-modules/globalStyles/globalStylesResponsiveHandler.tsx












var GlobalStylesResponsiveHandler = /*#__PURE__*/ function() {
    "use strict";
    function GlobalStylesResponsiveHandler() {
        (0,src_class_call_check/* default */.Z)(this, GlobalStylesResponsiveHandler);
    }
    /**
   *
   * @param bobObj
   * @param breakpoint
   * @param optionalProperties
   * This param is used to send aditional values that are needed for a specific style
   * The object must be named with the correct property name and the values inside an object, like so:
   * [property]: { valueName: value, valueName: value, etc}
   */ GlobalStylesResponsiveHandler.responsiveProperties = function responsiveProperties(bobObj, objType, breakpoint) {
        var optionalProperties = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        var cssStylesObj = {};
        //We have properties to render
        if (bobObj[breakpoint]) {
            cssStylesObj = (0,src_object_spread/* default */.Z)({}, cssStylesObj, this.stylePropertyHandler(objType, bobObj[breakpoint], optionalProperties));
        }
        return cssStylesObj;
    };
    GlobalStylesResponsiveHandler.stylePropertyHandler = function stylePropertyHandler(objType, styleObj, optionalProperties) {
        switch(objType){
            case GS_BOUNDARY:
                return boundaryStyle_responsiveStyle(styleObj);
            case GS_SHADOW:
                return responsiveStyle(styleObj, optionalProperties);
            case GS_BORDER:
                return borderStyle_responsiveStyle(styleObj);
            case GS_BORDER_RADIUS:
                return radiusStyle_responsiveStyle(styleObj);
            case GS_FILTER:
                return filterStyle_responsiveStyle(styleObj, optionalProperties);
            default:
                return {};
        }
    };
    GlobalStylesResponsiveHandler.writeShadowControllerToGlobalStyle = function writeShadowControllerToGlobalStyle(shadowObj, shadowGS) {
        var clonedShadowGS = cloneDeep_default()(shadowGS);
        /**
     * TODO: Make universal object with this properties, and conditional properties, like enable
     */ var shadow = {
            blur: shouldBeNull(shadowObj.blur, true),
            color: shouldBeNull(shadowObj.color),
            inset: shouldBeNull(shadowObj.inset),
            offsetH: shouldBeNull(shadowObj.offsetH, true),
            offsetV: shouldBeNull(shadowObj.offsetV, true),
            spread: shouldBeNull(shadowObj.spread, true)
        };
        var state = shadowObj.blur.state;
        var breakpoint = shadowObj.blur.breakpoint;
        if (breakpoint === "desktop") {
            //state hover/active
            if (state === "hover" || state === "active") {
                var ref;
                clonedShadowGS = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, clonedShadowGS), {
                    behaviour: (0,src_define_property/* default */.Z)({}, state, (0,src_object_spread/* default */.Z)({}, (ref = clonedShadowGS.behaviour) === null || ref === void 0 ? void 0 : ref[state], shadow))
                });
            } else {
                clonedShadowGS = (0,src_object_spread/* default */.Z)({}, clonedShadowGS, shadow);
            }
        } else {
            //state hover/active
            if (state === "hover" || state === "active") {
                var ref1, ref2;
                clonedShadowGS = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, clonedShadowGS), (0,src_define_property/* default */.Z)({}, breakpoint, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, clonedShadowGS[breakpoint]), {
                    behaviour: (0,src_define_property/* default */.Z)({}, state, (0,src_object_spread/* default */.Z)({}, (ref1 = clonedShadowGS[breakpoint]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : ref2[state], shadow))
                })));
            } else {
                clonedShadowGS = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, clonedShadowGS), (0,src_define_property/* default */.Z)({}, breakpoint, (0,src_object_spread/* default */.Z)({}, clonedShadowGS[breakpoint], shadow)));
            }
        }
        return clonedShadowGS;
    };
    GlobalStylesResponsiveHandler.writeBoundaryControllerToGlobalStyle = function writeBoundaryControllerToGlobalStyle(boundaryObj, boundaryGS) {
        var clonedBoundaryGS = cloneDeep_default()(boundaryGS);
        /**
     * TODO: Make universal object with this properties, and conditional properties, like enable
     */ var boundary = {
            margin: {
                top: shouldBeNull(boundaryObj["margin-top"], typeof boundaryObj["margin-top"] === "number"),
                bottom: shouldBeNull(boundaryObj["margin-bottom"], typeof boundaryObj["margin-bottom"] === "number"),
                left: shouldBeNull(boundaryObj["margin-left"], typeof boundaryObj["margin-left"] === "number"),
                right: shouldBeNull(boundaryObj["margin-right"], typeof boundaryObj["margin-right"] === "number")
            },
            padding: {
                top: shouldBeNull(boundaryObj["padding-top"], true),
                bottom: shouldBeNull(boundaryObj["padding-bottom"], true),
                left: shouldBeNull(boundaryObj["padding-left"], true),
                right: shouldBeNull(boundaryObj["padding-right"], true)
            }
        };
        var state = boundaryObj["margin-top"].state;
        var breakpoint = boundaryObj["margin-top"].breakpoint;
        if (breakpoint === "desktop") {
            //state hover/active
            if (state === "hover" || state === "active") {
                var ref;
                clonedBoundaryGS = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, clonedBoundaryGS), {
                    behaviour: (0,src_define_property/* default */.Z)({}, state, (0,src_object_spread/* default */.Z)({}, (ref = clonedBoundaryGS.behaviour) === null || ref === void 0 ? void 0 : ref[state], boundary))
                });
            } else {
                clonedBoundaryGS = (0,src_object_spread/* default */.Z)({}, clonedBoundaryGS, boundary);
            }
        } else {
            //state hover/active
            if (state === "hover" || state === "active") {
                var ref1, ref2;
                clonedBoundaryGS = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, clonedBoundaryGS), (0,src_define_property/* default */.Z)({}, breakpoint, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, clonedBoundaryGS[breakpoint]), {
                    behaviour: (0,src_define_property/* default */.Z)({}, state, (0,src_object_spread/* default */.Z)({}, (ref1 = clonedBoundaryGS[breakpoint]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : ref2[state], boundary))
                })));
            } else {
                clonedBoundaryGS = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, clonedBoundaryGS), (0,src_define_property/* default */.Z)({}, breakpoint, (0,src_object_spread/* default */.Z)({}, clonedBoundaryGS[breakpoint], boundary)));
            }
        }
        return clonedBoundaryGS;
    };
    GlobalStylesResponsiveHandler.writeTextControllerToGlobalStyle = function writeTextControllerToGlobalStyle(textObj, textGS) {
        var clonedTextGS = JSON.parse(JSON.stringify(textGS));
        /**
     * TODO: Make universal object with this properties, and conditional properties, like enable
     */ var text = {
            fontType: shouldBeNull(textObj.fontType),
            fontFamily: shouldBeNull(textObj.family),
            fontSize: shouldBeNull(textObj.size, true),
            fontWeight: shouldBeNull(textObj.weight, true),
            letterSpacing: shouldBeNull(textObj.letterSpacing, true),
            lineHeight: shouldBeNull(textObj.lineHeight, true)
        };
        var state = textObj.family.state;
        var breakpoint = textObj.family.breakpoint;
        if (breakpoint === "desktop") {
            //state hover/active
            if (state === "hover" || state === "active") {
                var ref;
                clonedTextGS = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, clonedTextGS), {
                    behaviour: (0,src_define_property/* default */.Z)({}, state, (0,src_object_spread/* default */.Z)({}, (ref = clonedTextGS.behaviour) === null || ref === void 0 ? void 0 : ref[state], text))
                });
            } else {
                clonedTextGS = (0,src_object_spread/* default */.Z)({}, clonedTextGS, text);
            }
        } else {
            //state hover/active
            if (state === "hover" || state === "active") {
                var ref1, ref2;
                clonedTextGS = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, clonedTextGS), (0,src_define_property/* default */.Z)({}, breakpoint, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, clonedTextGS[breakpoint]), {
                    behaviour: (0,src_define_property/* default */.Z)({}, state, (0,src_object_spread/* default */.Z)({}, (ref1 = clonedTextGS[breakpoint]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : ref2[state], text))
                })));
            } else {
                clonedTextGS = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, clonedTextGS), (0,src_define_property/* default */.Z)({}, breakpoint, (0,src_object_spread/* default */.Z)({}, clonedTextGS[breakpoint], text)));
            }
        }
        return clonedTextGS;
    };
    return GlobalStylesResponsiveHandler;
}();
/* harmony default export */ var globalStylesResponsiveHandler = (GlobalStylesResponsiveHandler);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/shadowStyleV2.ts






function shadowStyleV2_boxShadowCss(css) {
    if (css.hasOwnProperty("box-shadow")) return "box-shadow: ".concat(css["box-shadow"], ";");
    return "";
}
function shadowStyleV2_textShadowCss(css) {
    if (css.hasOwnProperty("text-shadow")) return "text-shadow: ".concat(css["text-shadow"], ";");
    return "";
}
function shadowStyleV2_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var foundationStyle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : undefined, stylesheetLabel = arguments.length > 4 ? arguments[4] : void 0;
    var styles = StylesShadowCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return shadowStyleV2_cssRender(styles.right, breakpoint, behaviourState, foundationStyle, stylesheetLabel);
    console.warn(codecUtils_decoderErrors(styles));
    return {};
}
function shadowStyleV2_globalStyleCssRenderUnsafe(gsObj, breakpoint, behaviourState) {
    var foundationStyle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : undefined, stylesheetLabel = arguments.length > 4 ? arguments[4] : void 0;
    var gs = GSShadowCodec.decode(gsObj);
    if ((0,Either/* isRight */.tO)(gs)) return shadowStyleV2_globalStyleCssRender(gs.right, breakpoint, behaviourState, foundationStyle, stylesheetLabel);
    console.warn(codecUtils_decoderErrors(gs));
    return {};
}
function shadowStyleV2_cssRender(stylesObj, breakpoint, behaviourState, foundationStyle, stylesheetLabel) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return shadowStyleV2_renderBob(stylesObj.shadow, foundationStyle, stylesheetLabel);
        } else {
            var ref, ref1;
            return shadowStyleV2_renderBobOpt(stylesObj.shadow, shadowStyleV2_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.shadow, stylesObj.shadow, stylesheetLabel), foundationStyle, stylesheetLabel);
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return shadowStyleV2_renderBobOpt(stylesObj.shadow, shadowStyleV2_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.shadow, stylesObj.shadow, stylesheetLabel), foundationStyle, stylesheetLabel);
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return shadowStyleV2_renderBobOpt(stylesObj.shadow, shadowStyleV2_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.shadow, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.shadow, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.shadow, stylesObj.shadow, stylesheetLabel), foundationStyle, stylesheetLabel);
        }
    }
}
function shadowStyleV2_globalStyleCssRender(stylesObj, breakpoint, behaviourState, foundationStyle, stylesheetLabel) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return shadowStyleV2_render(stylesObj, foundationStyle, stylesheetLabel);
        } else {
            var ref;
            return shadowStyleV2_renderOpt(shadowStyleV2_merge2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : ref[behaviourState], stylesObj, stylesheetLabel), foundationStyle, stylesheetLabel);
        }
    } else {
        if (behaviourState === "default") {
            return shadowStyleV2_renderOpt(shadowStyleV2_merge2(stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj, stylesheetLabel), foundationStyle, stylesheetLabel);
        } else {
            var ref1, ref2, ref3;
            return shadowStyleV2_renderOpt(shadowStyleV2_merge3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref1 = stylesObj[breakpoint]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : ref2[behaviourState], (ref3 = stylesObj.behaviour) === null || ref3 === void 0 ? void 0 : ref3[behaviourState], stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj, stylesheetLabel), foundationStyle, stylesheetLabel);
        }
    }
}
function shadowStyleV2_renderBob(shadowObj, foundationStyle, stylesheetLabel) {
    if (!shadowObj.enable) return {};
    return shadowStyleV2_render(shadowObj, foundationStyle, stylesheetLabel);
}
function shadowStyleV2_renderBobOpt(defaultShadowObj, shadowObj, foundationStyle, stylesheetLabel) {
    if ((shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.enable) === false) {
        if (defaultShadowObj.enable) return shadowStyleV2_cssProperty("none", undefined);
        return {};
    }
    if (shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.enable) return shadowStyleV2_renderOpt(shadowObj, foundationStyle, stylesheetLabel);
    return {};
}
function shadowStyleV2_render(shadowObj, foundationStyle, stylesheetLabel) {
    var isBox = " ".concat(shadowObj.spread, "px");
    var cssValue = "".concat(shadowObj.inset ? "inset " : "").concat(shadowObj.offsetH, "px ").concat(shadowObj.offsetV, "px ").concat(shadowObj.blur, "px").concat(isBox, " ").concat(handleBobStylesheetLabel(stylesheetLabel, shadowObj.color));
    // TODO: foundation color reverted
    // }px${isBox} ${foundationStyle ? foundationStyle.color : shadowObj.color} !important`
    return shadowStyleV2_cssProperty(cssValue, stylesheetLabel);
}
function shadowStyleV2_renderOpt(shadowObj, foundationStyle, stylesheetLabel) {
    if (utils_objValueExists(shadowObj, "inset") || utils_objValueExists(shadowObj, "offsetH") || utils_objValueExists(shadowObj, "offsetV") || utils_objValueExists(shadowObj, "blur") || utils_objValueExists(shadowObj, "color") || utils_objValueExists(shadowObj, "spread") || stylesheetLabel) {
        var isBox = " ".concat(shadowObj.spread, "px");
        var cssValue = "".concat(shadowObj.inset ? "inset " : "").concat(shadowObj.offsetH, "px ").concat(shadowObj.offsetV, "px ").concat(shadowObj.blur, "px").concat(isBox, " ").concat(handleBobStylesheetLabel(stylesheetLabel, shadowObj.color));
        // TODO: foundation color reverted
        // }px${isBox} ${foundationStyle ? foundationStyle.color : shadowObj.color} !important`
        return shadowStyleV2_cssProperty(cssValue, stylesheetLabel);
    }
    return {};
}
function shadowStyleV2_cssProperty(cssValue, stylesheetLabel) {
    return {
        "box-shadow": cssValue
    };
}
/**
 *
 * @param shadowObj
 * @param defaultShadowObj
 * @returns Shadow
 *
 */ function shadowStyleV2_mergeBob2(shadowObj, defaultShadowObj, stylesheetLabel) {
    if (!shadowObj) {
        return {
            enable: undefined,
            inset: undefined,
            offsetH: undefined,
            offsetV: undefined,
            blur: undefined,
            color: undefined,
            spread: undefined
        };
    }
    var enable = get2WithNull4Enable(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.enable, defaultShadowObj.enable);
    //if one of the values is set in the breakpoint we render the entire shadow property
    if (utils_objValueExists(shadowObj, "inset") || utils_objValueExists(shadowObj, "offsetH") || utils_objValueExists(shadowObj, "offsetV") || utils_objValueExists(shadowObj, "blur") || utils_objValueExists(shadowObj, "color") || utils_objValueExists(shadowObj, "spread") || stylesheetLabel) {
        var inset = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.inset, defaultShadowObj.inset);
        var offsetH = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetH, defaultShadowObj.offsetH);
        var offsetV = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetV, defaultShadowObj.offsetV);
        var blur = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.blur, defaultShadowObj.blur);
        var color = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.color, defaultShadowObj.color);
        var spread = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.spread, defaultShadowObj.spread);
        return {
            enable: enable,
            inset: inset,
            offsetH: offsetH,
            offsetV: offsetV,
            blur: blur,
            color: color,
            spread: spread
        };
    }
    return {
        enable: shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.enable,
        inset: undefined,
        offsetH: undefined,
        offsetV: undefined,
        blur: undefined,
        color: undefined,
        spread: undefined
    };
}
/**
 *
 * @param shadowObj
 * @param defaultShadowObj
 * @returns ShadowProps
 *
 */ function shadowStyleV2_merge2(shadowObj, defaultShadowObj, stylesheetLabel) {
    if (!shadowObj) {
        return {
            inset: undefined,
            offsetH: undefined,
            offsetV: undefined,
            blur: undefined,
            color: undefined,
            spread: undefined
        };
    }
    if (utils_objValueExists(shadowObj, "inset") || utils_objValueExists(shadowObj, "offsetH") || utils_objValueExists(shadowObj, "offsetV") || utils_objValueExists(shadowObj, "blur") || utils_objValueExists(shadowObj, "color") || utils_objValueExists(shadowObj, "spread") || stylesheetLabel) {
        var inset = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.inset, defaultShadowObj.inset);
        var offsetH = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetH, defaultShadowObj.offsetH);
        var offsetV = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetV, defaultShadowObj.offsetV);
        var blur = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.blur, defaultShadowObj.blur);
        var color = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.color, defaultShadowObj.color);
        var spread = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.spread, defaultShadowObj.spread);
        return {
            inset: inset,
            offsetH: offsetH,
            offsetV: offsetV,
            blur: blur,
            color: color,
            spread: spread
        };
    }
    return {
        inset: undefined,
        offsetH: undefined,
        offsetV: undefined,
        blur: undefined,
        color: undefined,
        spread: undefined
    };
}
/**
 *
 * @param shadowObj
 * @param shadowDefaultBreakpoint
 * @param defaultShadowObj
 * @returns Shadow
 */ function shadowStyleV2_mergeBob3(shadowObj, shadowDesktopBehaviour, shadowDefaultBreakpoint, defaultShadowObj, stylesheetLabel) {
    if (!shadowObj) {
        return {
            enable: undefined,
            inset: undefined,
            offsetH: undefined,
            offsetV: undefined,
            blur: undefined,
            color: undefined,
            spread: undefined
        };
    }
    var enable = get3WithNull4Enable(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.enable, shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.enable, shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.enable, defaultShadowObj.enable);
    if (utils_objValueExists(shadowObj, "inset") || utils_objValueExists(shadowObj, "offsetH") || utils_objValueExists(shadowObj, "offsetV") || utils_objValueExists(shadowObj, "blur") || utils_objValueExists(shadowObj, "color") || utils_objValueExists(shadowObj, "spread") || stylesheetLabel) {
        var ref, ref1, ref2;
        var inset = (ref2 = (ref1 = (ref = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.inset) !== null && ref !== void 0 ? ref : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.inset) !== null && ref1 !== void 0 ? ref1 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.inset) !== null && ref2 !== void 0 ? ref2 : defaultShadowObj.inset;
        var ref3, ref4, ref5;
        var offsetH = (ref5 = (ref4 = (ref3 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetH) !== null && ref3 !== void 0 ? ref3 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.offsetH) !== null && ref4 !== void 0 ? ref4 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.offsetH) !== null && ref5 !== void 0 ? ref5 : defaultShadowObj.offsetH;
        var ref6, ref7, ref8;
        var offsetV = (ref8 = (ref7 = (ref6 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetV) !== null && ref6 !== void 0 ? ref6 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.offsetV) !== null && ref7 !== void 0 ? ref7 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.offsetV) !== null && ref8 !== void 0 ? ref8 : defaultShadowObj.offsetV;
        var ref9, ref10, ref11;
        var blur = (ref11 = (ref10 = (ref9 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.blur) !== null && ref9 !== void 0 ? ref9 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.blur) !== null && ref10 !== void 0 ? ref10 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.blur) !== null && ref11 !== void 0 ? ref11 : defaultShadowObj.blur;
        var ref12, ref13, ref14;
        var color = (ref14 = (ref13 = (ref12 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.color) !== null && ref12 !== void 0 ? ref12 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.color) !== null && ref13 !== void 0 ? ref13 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.color) !== null && ref14 !== void 0 ? ref14 : defaultShadowObj.color;
        var ref15, ref16, ref17;
        var spread = (ref17 = (ref16 = (ref15 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.spread) !== null && ref15 !== void 0 ? ref15 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.spread) !== null && ref16 !== void 0 ? ref16 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.spread) !== null && ref17 !== void 0 ? ref17 : defaultShadowObj.spread;
        return {
            enable: enable,
            inset: inset,
            offsetH: offsetH,
            offsetV: offsetV,
            blur: blur,
            color: color,
            spread: spread
        };
    }
    return {
        enable: shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.enable,
        inset: undefined,
        offsetH: undefined,
        offsetV: undefined,
        blur: undefined,
        color: undefined,
        spread: undefined
    };
}
/**
 *
 * @param shadowObj
 * @param shadowDefaultBreakpoint
 * @param defaultShadowObj
 * @returns Shadow
 */ function shadowStyleV2_merge3(shadowObj, shadowDesktopBehaviour, shadowDefaultBreakpoint, defaultShadowObj, stylesheetLabel) {
    if (!shadowObj) {
        return {
            inset: undefined,
            offsetH: undefined,
            offsetV: undefined,
            blur: undefined,
            color: undefined,
            spread: undefined
        };
    }
    if (utils_objValueExists(shadowObj, "inset") || utils_objValueExists(shadowObj, "offsetH") || utils_objValueExists(shadowObj, "offsetV") || utils_objValueExists(shadowObj, "blur") || utils_objValueExists(shadowObj, "color") || utils_objValueExists(shadowObj, "spread") || stylesheetLabel) {
        var ref, ref1, ref2;
        var inset = (ref2 = (ref1 = (ref = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.inset) !== null && ref !== void 0 ? ref : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.inset) !== null && ref1 !== void 0 ? ref1 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.inset) !== null && ref2 !== void 0 ? ref2 : defaultShadowObj.inset;
        var ref3, ref4, ref5;
        var offsetH = (ref5 = (ref4 = (ref3 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetH) !== null && ref3 !== void 0 ? ref3 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.offsetH) !== null && ref4 !== void 0 ? ref4 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.offsetH) !== null && ref5 !== void 0 ? ref5 : defaultShadowObj.offsetH;
        var ref6, ref7, ref8;
        var offsetV = (ref8 = (ref7 = (ref6 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetV) !== null && ref6 !== void 0 ? ref6 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.offsetV) !== null && ref7 !== void 0 ? ref7 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.offsetV) !== null && ref8 !== void 0 ? ref8 : defaultShadowObj.offsetV;
        var ref9, ref10, ref11;
        var blur = (ref11 = (ref10 = (ref9 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.blur) !== null && ref9 !== void 0 ? ref9 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.blur) !== null && ref10 !== void 0 ? ref10 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.blur) !== null && ref11 !== void 0 ? ref11 : defaultShadowObj.blur;
        var ref12, ref13, ref14;
        var color = (ref14 = (ref13 = (ref12 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.color) !== null && ref12 !== void 0 ? ref12 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.color) !== null && ref13 !== void 0 ? ref13 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.color) !== null && ref14 !== void 0 ? ref14 : defaultShadowObj.color;
        var ref15, ref16, ref17;
        var spread = (ref17 = (ref16 = (ref15 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.spread) !== null && ref15 !== void 0 ? ref15 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.spread) !== null && ref16 !== void 0 ? ref16 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.spread) !== null && ref17 !== void 0 ? ref17 : defaultShadowObj.spread;
        return {
            inset: inset,
            offsetH: offsetH,
            offsetV: offsetV,
            blur: blur,
            color: color,
            spread: spread
        };
    }
    return {
        inset: undefined,
        offsetH: undefined,
        offsetV: undefined,
        blur: undefined,
        color: undefined,
        spread: undefined
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/textShadowStyle.ts







//Temp to handle nulls
var textShadowStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
/**
 * We should only check for property and undefined
 * this solution is only until we fix the null being send around the page object
 */ // props only, no enable
var textShadowStyle_ShadowPropsCodec = (0,es6/* type */.dt)({
    offsetH: es6/* number */.pk,
    offsetV: es6/* number */.pk,
    blur: es6/* number */.pk,
    color: es6/* string */.Z_
});
var textShadowStyle_ShadowCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    textShadowStyle_ShadowPropsCodec
]);
// props only, no enable
var textShadowStyle_ShadowPropsOptCodec = (0,es6/* partial */.r$)({
    offsetH: textShadowStyle_nullable(es6/* number */.pk),
    offsetV: textShadowStyle_nullable(es6/* number */.pk),
    blur: textShadowStyle_nullable(es6/* number */.pk),
    color: textShadowStyle_nullable(es6/* string */.Z_)
});
var textShadowStyle_ShadowOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: textShadowStyle_nullable(es6/* boolean */.O7)
    }),
    textShadowStyle_ShadowPropsOptCodec
]);
var textShadowStyle_StylesShadowCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        textShadow: textShadowStyle_ShadowCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                textShadow: textShadowStyle_ShadowOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                textShadow: textShadowStyle_ShadowOptCodec
            })
        }),
        mobile: (0,es6/* partial */.r$)({
            textShadow: textShadowStyle_ShadowOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    textShadow: textShadowStyle_ShadowOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    textShadow: textShadowStyle_ShadowOptCodec
                })
            })
        }),
        tablet: (0,es6/* partial */.r$)({
            textShadow: textShadowStyle_ShadowOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    textShadow: textShadowStyle_ShadowOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    textShadow: textShadowStyle_ShadowOptCodec
                })
            })
        })
    }), 
]);
var textShadowStyle_GSShadowCodec = (0,es6/* intersection */.jV)([
    textShadowStyle_ShadowPropsCodec,
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: textShadowStyle_ShadowPropsOptCodec,
            hover: textShadowStyle_ShadowPropsOptCodec
        }),
        mobile: (0,es6/* intersection */.jV)([
            textShadowStyle_ShadowPropsOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: textShadowStyle_ShadowPropsOptCodec,
                    hover: textShadowStyle_ShadowPropsOptCodec
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            textShadowStyle_ShadowPropsOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: textShadowStyle_ShadowPropsOptCodec,
                    hover: textShadowStyle_ShadowPropsOptCodec
                })
            }), 
        ])
    }), 
]);
function textShadowStyle_textShadowCss(css) {
    return bobUtils_showIfWritten(css, "text-shadow");
}
function textShadowStyle_responsiveStyle(shadowObj, desktopDefaultValues, breakpointDefaultValues) {
    var hasEnable = shadowObj.hasOwnProperty("enable");
    if (hasEnable && !objValueExists(shadowObj, "enable")) return "";
    /**
   * Check if property is available, and fallback to breakpointDefault or the desktopDefault
   */ var offsetH = (shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetH) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.offsetH) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.offsetH);
    var offsetV = (shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetV) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.offsetV) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.offsetV);
    var blur = (shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.blur) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.blur) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.blur);
    var color = (shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.color) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.color) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.color);
    // other props like text-shadow
    if (hasEnable && !shadowObj.enable) return _define_property({}, "text-shadow", "none");
    return _define_property({}, "text-shadow", "".concat(offsetH, "px ").concat(offsetV, "px ").concat(blur, "px ").concat(color));
}
function textShadowStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var foundationStyle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : undefined, stylesheetLabel = arguments.length > 4 ? arguments[4] : void 0;
    var styles = textShadowStyle_StylesShadowCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return textShadowStyle_cssRender(styles.right, breakpoint, behaviourState, foundationStyle, stylesheetLabel);
    console.warn(codecUtils_decoderErrors(styles));
    return {};
}
function textShadowStyle_globalStyleCssRenderUnsafe(gsObj, breakpoint, behaviourState) {
    var foundationStyle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : undefined, stylesheetLabel = arguments.length > 4 ? arguments[4] : void 0;
    var gs = textShadowStyle_GSShadowCodec.decode(gsObj);
    if ((0,Either/* isRight */.tO)(gs)) return textShadowStyle_globalStyleCssRender(gs.right, breakpoint, behaviourState, foundationStyle, stylesheetLabel);
    console.warn(codecUtils_decoderErrors(gs));
    return {};
}
function textShadowStyle_cssRender(stylesObj, breakpoint, behaviourState, foundationStyle, stylesheetLabel) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return textShadowStyle_renderBob(stylesObj.textShadow, foundationStyle, stylesheetLabel);
        } else {
            var ref, ref1;
            return textShadowStyle_renderBobOpt(stylesObj.textShadow, textShadowStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.textShadow, stylesObj.textShadow, stylesheetLabel), foundationStyle, stylesheetLabel);
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return textShadowStyle_renderBobOpt(stylesObj.textShadow, textShadowStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.textShadow, stylesObj.textShadow, stylesheetLabel), foundationStyle, stylesheetLabel);
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return textShadowStyle_renderBobOpt(stylesObj.textShadow, textShadowStyle_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.textShadow, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.textShadow, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.textShadow, stylesObj.textShadow, stylesheetLabel), foundationStyle, stylesheetLabel);
        }
    }
}
function textShadowStyle_globalStyleCssRender(stylesObj, breakpoint, behaviourState, foundationStyle, stylesheetLabel) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return textShadowStyle_render(stylesObj, foundationStyle, stylesheetLabel);
        } else {
            var ref;
            return textShadowStyle_renderOpt(textShadowStyle_merge2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : ref[behaviourState], stylesObj, stylesheetLabel), foundationStyle, stylesheetLabel);
        }
    } else {
        if (behaviourState === "default") {
            return textShadowStyle_renderOpt(textShadowStyle_merge2(stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj, stylesheetLabel), foundationStyle, stylesheetLabel);
        } else {
            var ref1, ref2, ref3;
            return textShadowStyle_renderOpt(textShadowStyle_merge3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref1 = stylesObj[breakpoint]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : ref2[behaviourState], (ref3 = stylesObj.behaviour) === null || ref3 === void 0 ? void 0 : ref3[behaviourState], stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj, stylesheetLabel), foundationStyle, stylesheetLabel);
        }
    }
}
function textShadowStyle_renderBob(shadowObj, foundationStyle, stylesheetLabel) {
    if (!shadowObj.enable) return {};
    return textShadowStyle_render(shadowObj, foundationStyle, stylesheetLabel);
}
function textShadowStyle_renderBobOpt(defaultShadowObj, shadowObj, foundationStyle, stylesheetLabel) {
    if ((shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.enable) === false) {
        if (defaultShadowObj.enable) return textShadowStyle_cssProperty("none", undefined);
        return {};
    }
    if (shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.enable) return textShadowStyle_renderOpt(shadowObj, foundationStyle, stylesheetLabel);
    return {};
}
function textShadowStyle_render(shadowObj, foundationStyle, stylesheetLabel) {
    var cssValue = "".concat(shadowObj.offsetH, "px ").concat(shadowObj.offsetV, "px ").concat(shadowObj.blur, "px ").concat(handleBobStylesheetLabel(stylesheetLabel, shadowObj.color));
    return textShadowStyle_cssProperty(cssValue, stylesheetLabel);
}
function textShadowStyle_renderOpt(shadowObj, foundationStyle, stylesheetLabel) {
    if (utils_objValueExists(shadowObj, "offsetH") || utils_objValueExists(shadowObj, "offsetV") || utils_objValueExists(shadowObj, "blur") || utils_objValueExists(shadowObj, "color") || stylesheetLabel) {
        var cssValue = "".concat(shadowObj.offsetH, "px ").concat(shadowObj.offsetV, "px ").concat(shadowObj.blur, "px ").concat(handleBobStylesheetLabel(stylesheetLabel, shadowObj.color));
        return textShadowStyle_cssProperty(cssValue, stylesheetLabel);
    }
    return {};
}
function textShadowStyle_cssProperty(cssValue, stylesheetLabel) {
    return {
        "text-shadow": cssValue
    };
}
/**
 *
 * @param shadowObj
 * @param defaultShadowObj
 * @returns Shadow
 *
 */ function textShadowStyle_mergeBob2(shadowObj, defaultShadowObj, stylesheetLabel) {
    if (!shadowObj) {
        return {
            enable: undefined,
            offsetH: undefined,
            offsetV: undefined,
            blur: undefined,
            color: undefined
        };
    }
    var enable = get2WithNull4Enable(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.enable, defaultShadowObj.enable);
    //if one of the values is set in the breakpoint we render the entire shadow property
    if (utils_objValueExists(shadowObj, "offsetH") || utils_objValueExists(shadowObj, "offsetV") || utils_objValueExists(shadowObj, "blur") || utils_objValueExists(shadowObj, "color") || stylesheetLabel) {
        var offsetH = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetH, defaultShadowObj.offsetH);
        var offsetV = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetV, defaultShadowObj.offsetV);
        var blur = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.blur, defaultShadowObj.blur);
        var color = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.color, defaultShadowObj.color);
        return {
            enable: enable,
            offsetH: offsetH,
            offsetV: offsetV,
            blur: blur,
            color: color
        };
    }
    return {
        enable: shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.enable,
        offsetH: undefined,
        offsetV: undefined,
        blur: undefined,
        color: undefined
    };
}
/**
 *
 * @param shadowObj
 * @param defaultShadowObj
 * @returns ShadowProps
 *
 */ function textShadowStyle_merge2(shadowObj, defaultShadowObj, stylesheetLabel) {
    if (!shadowObj) {
        return {
            offsetH: undefined,
            offsetV: undefined,
            blur: undefined,
            color: undefined
        };
    }
    if (utils_objValueExists(shadowObj, "offsetH") || utils_objValueExists(shadowObj, "offsetV") || utils_objValueExists(shadowObj, "blur") || utils_objValueExists(shadowObj, "color") || stylesheetLabel) {
        var offsetH = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetH, defaultShadowObj.offsetH);
        var offsetV = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetV, defaultShadowObj.offsetV);
        var blur = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.blur, defaultShadowObj.blur);
        var color = bobUtils_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.color, defaultShadowObj.color);
        return {
            offsetH: offsetH,
            offsetV: offsetV,
            blur: blur,
            color: color
        };
    }
    return {
        offsetH: undefined,
        offsetV: undefined,
        blur: undefined,
        color: undefined
    };
}
/**
 *
 * @param shadowObj
 * @param shadowDefaultBreakpoint
 * @param defaultShadowObj
 * @returns Shadow
 */ function textShadowStyle_mergeBob3(shadowObj, shadowDesktopBehaviour, shadowDefaultBreakpoint, defaultShadowObj, stylesheetLabel) {
    if (!shadowObj) {
        return {
            enable: undefined,
            offsetH: undefined,
            offsetV: undefined,
            blur: undefined,
            color: undefined
        };
    }
    var enable = get3WithNull4Enable(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.enable, shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.enable, shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.enable, defaultShadowObj.enable);
    if (utils_objValueExists(shadowObj, "offsetH") || utils_objValueExists(shadowObj, "offsetV") || utils_objValueExists(shadowObj, "blur") || utils_objValueExists(shadowObj, "color") || stylesheetLabel) {
        var ref, ref1, ref2;
        var offsetH = (ref2 = (ref1 = (ref = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetH) !== null && ref !== void 0 ? ref : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.offsetH) !== null && ref1 !== void 0 ? ref1 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.offsetH) !== null && ref2 !== void 0 ? ref2 : defaultShadowObj.offsetH;
        var ref3, ref4, ref5;
        var offsetV = (ref5 = (ref4 = (ref3 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetV) !== null && ref3 !== void 0 ? ref3 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.offsetV) !== null && ref4 !== void 0 ? ref4 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.offsetV) !== null && ref5 !== void 0 ? ref5 : defaultShadowObj.offsetV;
        var ref6, ref7, ref8;
        var blur = (ref8 = (ref7 = (ref6 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.blur) !== null && ref6 !== void 0 ? ref6 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.blur) !== null && ref7 !== void 0 ? ref7 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.blur) !== null && ref8 !== void 0 ? ref8 : defaultShadowObj.blur;
        var ref9, ref10, ref11;
        var color = (ref11 = (ref10 = (ref9 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.color) !== null && ref9 !== void 0 ? ref9 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.color) !== null && ref10 !== void 0 ? ref10 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.color) !== null && ref11 !== void 0 ? ref11 : defaultShadowObj.color;
        return {
            enable: enable,
            offsetH: offsetH,
            offsetV: offsetV,
            blur: blur,
            color: color
        };
    }
    return {
        enable: shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.enable,
        offsetH: undefined,
        offsetV: undefined,
        blur: undefined,
        color: undefined
    };
}
/**
 *
 * @param shadowObj
 * @param shadowDefaultBreakpoint
 * @param defaultShadowObj
 * @returns Shadow
 */ function textShadowStyle_merge3(shadowObj, shadowDesktopBehaviour, shadowDefaultBreakpoint, defaultShadowObj, stylesheetLabel) {
    if (!shadowObj) {
        return {
            offsetH: undefined,
            offsetV: undefined,
            blur: undefined,
            color: undefined
        };
    }
    if (utils_objValueExists(shadowObj, "offsetH") || utils_objValueExists(shadowObj, "offsetV") || utils_objValueExists(shadowObj, "blur") || utils_objValueExists(shadowObj, "color") || stylesheetLabel) {
        var ref, ref1, ref2;
        var offsetH = (ref2 = (ref1 = (ref = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetH) !== null && ref !== void 0 ? ref : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.offsetH) !== null && ref1 !== void 0 ? ref1 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.offsetH) !== null && ref2 !== void 0 ? ref2 : defaultShadowObj.offsetH;
        var ref3, ref4, ref5;
        var offsetV = (ref5 = (ref4 = (ref3 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetV) !== null && ref3 !== void 0 ? ref3 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.offsetV) !== null && ref4 !== void 0 ? ref4 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.offsetV) !== null && ref5 !== void 0 ? ref5 : defaultShadowObj.offsetV;
        var ref6, ref7, ref8;
        var blur = (ref8 = (ref7 = (ref6 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.blur) !== null && ref6 !== void 0 ? ref6 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.blur) !== null && ref7 !== void 0 ? ref7 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.blur) !== null && ref8 !== void 0 ? ref8 : defaultShadowObj.blur;
        var ref9, ref10, ref11;
        var color = (ref11 = (ref10 = (ref9 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.color) !== null && ref9 !== void 0 ? ref9 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.color) !== null && ref10 !== void 0 ? ref10 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.color) !== null && ref11 !== void 0 ? ref11 : defaultShadowObj.color;
        return {
            offsetH: offsetH,
            offsetV: offsetV,
            blur: blur,
            color: color
        };
    }
    return {
        offsetH: undefined,
        offsetV: undefined,
        blur: undefined,
        color: undefined
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/boundaryStyleV2.ts







function boundaryStyleV2_renderCSSString(boundaryStyle) {
    return "\n    ".concat(bobUtils_showIfWritten(boundaryStyle, "margin-bottom"), " \n    ").concat(bobUtils_showIfWritten(boundaryStyle, "margin-top"), " \n    ").concat(bobUtils_showIfWritten(boundaryStyle, "margin-left"), " \n    ").concat(bobUtils_showIfWritten(boundaryStyle, "margin-right"), " \n    ").concat(bobUtils_showIfWritten(boundaryStyle, "padding-bottom"), " \n    ").concat(bobUtils_showIfWritten(boundaryStyle, "padding-top"), " \n    ").concat(bobUtils_showIfWritten(boundaryStyle, "padding-left"), " \n    ").concat(bobUtils_showIfWritten(boundaryStyle, "padding-right"), " \n    ");
}
function boundaryStyleV2_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var styles = StylesBoundaryCodec.decode(stylesObj);
    if ((0,lib_Either.isRight)(styles)) return boundaryStyleV2_cssRender(styles.right, breakpoint, behaviourState);
    console.warn("BoundaryStyle ".concat(breakpoint, " ").concat(behaviourState, " ").concat(codecUtils_decoderErrors(styles)));
    return {};
}
function boundaryStyleV2_globalStyleCssRenderUnsafe(gsObj, breakpoint, behaviourState) {
    var gs = GSBoundaryCodec.decode(gsObj);
    if ((0,lib_Either.isRight)(gs)) return boundaryStyleV2_globalStyleCssRender(gs.right, breakpoint, behaviourState);
    console.warn("BoundaryGSStyle ".concat(breakpoint, " ").concat(behaviourState, " ").concat(codecUtils_decoderErrors(gs)));
    return {};
}
function boundaryStyleV2_globalStyleCssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return boundaryStyleV2_render(stylesObj);
        } else {
            var ref;
            return boundaryStyleV2_renderOpt(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : ref[behaviourState]);
        }
    } else {
        if (behaviourState === "default") {
            return boundaryStyleV2_renderOpt(stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint]);
        } else {
            var ref1, ref2;
            return boundaryStyleV2_renderOpt(stylesObj === null || stylesObj === void 0 ? void 0 : (ref1 = stylesObj[breakpoint]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : ref2[behaviourState]);
        }
    }
}
function boundaryStyleV2_cssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return boundaryStyleV2_renderBob(stylesObj.spacing);
        } else {
            var ref, ref1;
            return boundaryStyleV2_renderBobOpt(stylesObj.spacing, boundaryStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.spacing, stylesObj.spacing));
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return boundaryStyleV2_renderBobOpt(stylesObj.spacing, boundaryStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.spacing, stylesObj.spacing));
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return boundaryStyleV2_renderBobOpt(stylesObj.spacing, boundaryStyle_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.spacing, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.spacing, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.spacing, stylesObj.spacing));
        }
    }
}
function boundaryStyleV2_renderBob(boundaryObj) {
    if (boundaryObj.enable === false) return {};
    return boundaryStyleV2_render(boundaryObj);
}
/**
 * Renders ColorsOpt css for breakpoints/state templates
 * or empty for non written style props
 *
 * @param colorsObj
 * @param foundationStyle
 * @returns
 */ function boundaryStyleV2_renderBobOpt(defaultBoundaryObj, boundaryObj) {
    if ((boundaryObj === null || boundaryObj === void 0 ? void 0 : boundaryObj.enable) === false) {
        if (defaultBoundaryObj.enable) {
            return {
                "margin-top": "0px",
                "margin-right": "0px",
                "margin-bottom": "0px",
                "margin-left": "0px",
                "padding-top": "0px",
                "padding-right": "0px",
                "padding-bottom": "0px",
                "padding-left": "0px"
            };
        }
        return {};
    }
    if ((boundaryObj === null || boundaryObj === void 0 ? void 0 : boundaryObj.enable) === true) return boundaryStyleV2_renderOpt(boundaryObj);
    return {};
}
function boundaryStyleV2_render(boundaryObj) {
    return {
        "margin-top": "".concat(isNumberOrAuto(boundaryObj.margin.top)),
        "margin-right": "".concat(isNumberOrAuto(boundaryObj.margin.right)),
        "margin-bottom": "".concat(isNumberOrAuto(boundaryObj.margin.bottom)),
        "margin-left": "".concat(isNumberOrAuto(boundaryObj.margin.left)),
        "padding-top": "".concat(boundaryObj.padding.top, "px"),
        "padding-right": "".concat(boundaryObj.padding.right, "px"),
        "padding-bottom": "".concat(boundaryObj.padding.bottom, "px"),
        "padding-left": "".concat(boundaryObj.padding.left, "px")
    };
}
/**
 * Renders ColorOpt css for breakpoints/state templates
 * Returns color
 * or empty for non written style props
 *
 * @param colorValue
 * @param foundationStyle
 * @returns
 */ function boundaryStyleV2_renderOpt(boundaryObj) {
    var margin = boundaryObj === null || boundaryObj === void 0 ? void 0 : boundaryObj.margin;
    var padding = boundaryObj === null || boundaryObj === void 0 ? void 0 : boundaryObj.padding;
    var css = {};
    if (valueExists(margin === null || margin === void 0 ? void 0 : margin.top)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "margin-top": "".concat(isNumberOrAuto(margin === null || margin === void 0 ? void 0 : margin.top))
    });
    if (valueExists(margin === null || margin === void 0 ? void 0 : margin.bottom)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "margin-bottom": "".concat(isNumberOrAuto(margin === null || margin === void 0 ? void 0 : margin.bottom))
    });
    if (valueExists(margin === null || margin === void 0 ? void 0 : margin.left)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "margin-left": "".concat(isNumberOrAuto(margin === null || margin === void 0 ? void 0 : margin.left))
    });
    if (valueExists(margin === null || margin === void 0 ? void 0 : margin.right)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "margin-right": "".concat(isNumberOrAuto(margin === null || margin === void 0 ? void 0 : margin.right))
    });
    if (valueExists(padding === null || padding === void 0 ? void 0 : padding.top)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "padding-top": "".concat(padding === null || padding === void 0 ? void 0 : padding.top, "px")
    });
    if (valueExists(padding === null || padding === void 0 ? void 0 : padding.bottom)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "padding-bottom": "".concat(padding === null || padding === void 0 ? void 0 : padding.bottom, "px")
    });
    if (valueExists(padding === null || padding === void 0 ? void 0 : padding.left)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "padding-left": "".concat(padding === null || padding === void 0 ? void 0 : padding.left, "px")
    });
    if (valueExists(padding === null || padding === void 0 ? void 0 : padding.right)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "padding-right": "".concat(padding === null || padding === void 0 ? void 0 : padding.right, "px")
    });
    return css;
}
/**
 *
 * @param x
 * returns with px if its number else just the string auto, or empty
 */ function isNumberOrAuto(x) {
    if (typeof x === "number") {
        return "".concat(x, "px");
    }
    return "".concat(x);
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/textStyleV2.ts







function textStyleV2_renderCSSString(textStyle) {
    if ("font-family" in textStyle || "font-size" in textStyle || "font-weight" in textStyle || "letter-spacing" in textStyle || "line-height" in textStyle) {
        var css = "";
        if (valueExists(textStyle === null || textStyle === void 0 ? void 0 : textStyle["font-family"])) {
            css += "font-family: ".concat(textStyle === null || textStyle === void 0 ? void 0 : textStyle["font-family"], ";");
        }
        if (valueExists(textStyle === null || textStyle === void 0 ? void 0 : textStyle["font-weight"])) {
            css += "font-weight: ".concat(textStyle === null || textStyle === void 0 ? void 0 : textStyle["font-weight"], ";");
        }
        if (valueExists(textStyle === null || textStyle === void 0 ? void 0 : textStyle["font-size"])) {
            css += "font-size: ".concat(textStyle === null || textStyle === void 0 ? void 0 : textStyle["font-size"], "px;");
        }
        if (valueExists(textStyle === null || textStyle === void 0 ? void 0 : textStyle["letter-spacing"])) {
            css += "letter-spacing: ".concat(textStyle === null || textStyle === void 0 ? void 0 : textStyle["letter-spacing"], "px;");
        }
        if (valueExists(textStyle === null || textStyle === void 0 ? void 0 : textStyle["line-height"])) {
            css += "line-height: ".concat(textStyle === null || textStyle === void 0 ? void 0 : textStyle["line-height"], ";");
        }
        return css;
    }
    return "";
}
function textStyleV2_cssRenderUnsafe(stylesObj, breakpoint, behaviourState, stylesheetLabel) {
    var styles = StylesTextCodec.decode(stylesObj);
    if ((0,lib_Either.isRight)(styles)) return textStyleV2_cssRender(styles.right, breakpoint, behaviourState, stylesheetLabel);
    console.warn("TextStyle ".concat(breakpoint, " ").concat(behaviourState, " ").concat(codecUtils_decoderErrors(styles)));
    return {};
}
function textStyleV2_cssRender(stylesObj, breakpoint, behaviourState, stylesheetLabel) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return textStyleV2_renderBob(stylesObj, stylesheetLabel);
        } else {
            var ref;
            return textStyleV2_renderBobOpt(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : ref[behaviourState], stylesheetLabel);
        }
    } else {
        if (behaviourState === "default") {
            return textStyleV2_renderBobOpt(stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesheetLabel);
        } else {
            var ref1, ref2;
            return textStyleV2_renderBobOpt(stylesObj === null || stylesObj === void 0 ? void 0 : (ref1 = stylesObj[breakpoint]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : ref2[behaviourState], stylesheetLabel);
        }
    }
}
function textStyleV2_globalStyleCssRenderUnsafe(gsObj, breakpoint, behaviourState, stylesheetLabel) {
    var gs = GSTextCodec.decode(gsObj);
    if ((0,lib_Either.isRight)(gs)) return textStyleV2_globalStyleCssRender(gs.right, breakpoint, behaviourState, stylesheetLabel);
    console.warn("TextGSStyle ".concat(breakpoint, " ").concat(behaviourState, " ").concat(codecUtils_decoderErrors(gs)));
    return {};
}
function textStyleV2_globalStyleCssRender(stylesObj, breakpoint, behaviourState, stylesheetLabel) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return textStyleV2_render(stylesObj, stylesheetLabel);
        } else {
            var ref;
            return textStyleV2_renderOpt(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : ref[behaviourState], stylesheetLabel);
        }
    } else {
        if (behaviourState === "default") {
            return textStyleV2_renderOpt(stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesheetLabel);
        } else {
            var ref1, ref2;
            return textStyleV2_renderOpt(stylesObj === null || stylesObj === void 0 ? void 0 : (ref1 = stylesObj[breakpoint]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : ref2[behaviourState], stylesheetLabel);
        }
    }
}
function textStyleV2_renderBob(textObj, stylesheetLabel) {
    return textStyleV2_render(textObj, stylesheetLabel);
}
/**
 * Renders ColorsOpt css for breakpoints/state templates
 * or empty for non written style props
 *
 * @param textObj
 * @param foundationStyle
 * @returns
 */ function textStyleV2_renderBobOpt(textObj, stylesheetLabel) {
    if (textObj) {
        return textStyleV2_renderOpt(textObj, stylesheetLabel);
    }
    return {};
}
/**
 * Renders TextOpt css for breakpoints/state templates
 * Returns color
 * or empty for non written style props
 *
 * @param textObj
 * @param foundationStyle
 * @returns
 */ function textStyleV2_renderOpt(textObj, stylesheetLabel) {
    var css = {};
    if (valueExists(textObj === null || textObj === void 0 ? void 0 : textObj.fontFamily)) {
        css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
            "font-family": handleBobStylesheetLabel(stylesheetLabel, '"'.concat(textObj === null || textObj === void 0 ? void 0 : textObj.fontFamily, '"'))
        });
    }
    if (valueExists(textObj === null || textObj === void 0 ? void 0 : textObj.fontWeight)) {
        css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
            "font-weight": "".concat(textObj === null || textObj === void 0 ? void 0 : textObj.fontWeight)
        });
    }
    if (valueExists(textObj === null || textObj === void 0 ? void 0 : textObj.fontSize)) {
        css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
            "font-size": textObj === null || textObj === void 0 ? void 0 : textObj.fontSize
        });
    }
    if (valueExists(textObj === null || textObj === void 0 ? void 0 : textObj.letterSpacing)) {
        css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
            "letter-spacing": textObj === null || textObj === void 0 ? void 0 : textObj.letterSpacing
        });
    }
    if (valueExists(textObj === null || textObj === void 0 ? void 0 : textObj.lineHeight)) {
        css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
            "line-height": "".concat(textObj === null || textObj === void 0 ? void 0 : textObj.lineHeight)
        });
    }
    return css;
}
function textStyleV2_render(textObj, stylesheetLabel) {
    return {
        "font-family": handleBobStylesheetLabel(stylesheetLabel, '"'.concat(textObj.fontFamily, '"')),
        "font-weight": "".concat(textObj.fontWeight),
        "font-size": textObj.fontSize,
        "letter-spacing": textObj.letterSpacing,
        "line-height": "".concat(textObj.lineHeight)
    };
}

;// CONCATENATED MODULE: ./src/modules/shared-modules/globalStyles/globalStylesHandler.tsx












/**
 * idEstilo-controllador-brk-behaviour
 *
 * @param globalStyle
 * @returns
 */ function handleStylesGroupCss(globalStyle, stylesheetLabels, expManager) {
    /**
   * format object for responsiveProperties methods
   */ /**
   * handle className
   */ var className = ".".concat(globalStyle.type, "-").concat(globalStyle.uuid);
    /**
   * handle styles to css
   */ var cssStyles = handleStylesToCss(globalStyle.type, globalStyle, stylesheetLabels, className, expManager);
    return cssStyles;
}
function handleGroupKey(type) {
    if (type === GS_BOUNDARY) return "spacing";
    if (type === GS_SHADOW) return "shadow";
    if (type === GS_SCREEN_FLOW) return "wrap";
    if (type === GS_HEIGHT) return "height";
    if (type === GS_BORDER_RADIUS) return "radius";
    if (type === GS_BORDER) return "border";
    if (type === GS_BG_COLORS) return "backgroundColor";
    if (type === GS_COLUMNS) return "grid";
    if (type === GS_ALIGNMENT) return "alignment";
    if (type === GS_FILTER) return "filter";
    if (type === GS_TEXT) return "text";
    if (type === GS_ICON) return "icon";
    return "unknownGroup";
}
// TODO: every controller should have 'enable' prop on it's own state
function handleEnableProp(type) {
    if (type === gsType.GS_BOUNDARY) return "enable";
    if (type === gsType.GS_SHADOW) return "enable";
    if (type === gsType.GS_SCREEN_FLOW) return "enable";
    if (type === gsType.GS_HEIGHT) return "enable";
    if (type === gsType.GS_BORDER_RADIUS) return "enable";
    if (type === gsType.GS_BORDER) return "enable";
    if (type === gsType.GS_BG_COLORS) return "enable";
    if (type === gsType.GS_COLUMNS) return "enable";
    if (type === gsType.GS_ALIGNMENT) return "enable";
    if (type === gsType.GS_FILTER) return "enable";
    if (type === gsType.GS_TEXT) return "enable";
    if (type === gsType.GS_ICON) return "enable";
    return "unknownGroup";
}
function writeCss(desktopCss, tabletCss, mobileCss, tabletStyles, mobileStyles) {
    /**
   * write css for box shadow
   */ var boxStyles = "\n      ".concat(desktopCss, "\n\n      ").concat(tabletStyles[0] || tabletStyles[1] || tabletStyles[2] ? "@media all and (max-width: 992px) and (min-width: 767px){\n            ".concat(tabletCss, "\n          }") : "", "\n\n      ").concat(mobileStyles[0] || mobileStyles[1] || mobileStyles[2] ? "@media all and (max-width: 766px){\n            ".concat(mobileCss, "\n          }") : "", "\n      ");
    return boxStyles;
}
function handleStylesToCss(type, groupStyle, stylesheetLabels, className, expManager) {
    if (type === GS_SHADOW) {
        var ref, ref1;
        /**
     * handle api values to css values for box shadow
     */ var boxDesktopStyles = globalStyleCssRenderUnsafe(groupStyle, "desktop", "default", "box", undefined);
        var boxHoverStyles = globalStyleCssRenderUnsafe(groupStyle, "desktop", "hover", "box", undefined);
        var boxActiveStyles = globalStyleCssRenderUnsafe(groupStyle, "desktop", "active", "box", undefined);
        // mobile
        var boxMobileStyles = globalStyleCssRenderUnsafe(groupStyle, "mobile", "default", "box", undefined);
        var boxMobileHoverStyles = globalStyleCssRenderUnsafe(groupStyle, "mobile", "hover", "box", undefined);
        var boxMobileActiveStyles = globalStyleCssRenderUnsafe(groupStyle, "mobile", "active", "box", undefined);
        // tablet
        var boxTabletStyles = globalStyleCssRenderUnsafe(groupStyle, "tablet", "default", "box", undefined);
        var boxTabletHoverStyles = globalStyleCssRenderUnsafe(groupStyle, "tablet", "hover", "box", undefined);
        var boxTabletActiveStyles = globalStyleCssRenderUnsafe(groupStyle, "tablet", "active", "box", undefined);
        /**
     * v2
     */ var shadowColorLabelDesktop = handleBobLabel(groupStyle, stylesheetLabels, "desktop", "default", "color");
        var shadowColorLabelHover = handleBobLabel(groupStyle, stylesheetLabels, "desktop", "hover", "color");
        var shadowColorLabelActive = handleBobLabel(groupStyle, stylesheetLabels, "desktop", "active", "color");
        var boxDesktopStylesV2 = shadowStyleV2_globalStyleCssRenderUnsafe(groupStyle, "desktop", "default", undefined, shadowColorLabelDesktop);
        var boxHoverStylesV2 = shadowStyleV2_globalStyleCssRenderUnsafe(groupStyle, "desktop", "hover", undefined, shadowColorLabelHover);
        var boxActiveStylesV2 = shadowStyleV2_globalStyleCssRenderUnsafe(groupStyle, "desktop", "active", undefined, shadowColorLabelActive);
        // mobile
        var shadowColorLabelMobile = handleBobLabel(groupStyle, stylesheetLabels, "mobile", "default", "color");
        var shadowColorLabelMobileHover = handleBobLabel(groupStyle, stylesheetLabels, "mobile", "hover", "color");
        var shadowColorLabelMobileActive = handleBobLabel(groupStyle, stylesheetLabels, "mobile", "active", "color");
        var boxMobileStylesV2 = shadowStyleV2_globalStyleCssRenderUnsafe(groupStyle, "mobile", "default", undefined, shadowColorLabelMobile);
        var boxMobileHoverStylesV2 = shadowStyleV2_globalStyleCssRenderUnsafe(groupStyle, "mobile", "hover", undefined, shadowColorLabelMobileHover);
        var boxMobileActiveStylesV2 = shadowStyleV2_globalStyleCssRenderUnsafe(groupStyle, "mobile", "active", undefined, shadowColorLabelMobileActive);
        // tablet
        var shadowColorLabelTablet = handleBobLabel(groupStyle, stylesheetLabels, "tablet", "default", "color");
        var shadowColorLabelTabletHover = handleBobLabel(groupStyle, stylesheetLabels, "tablet", "hover", "color");
        var shadowColorLabelTabletActive = handleBobLabel(groupStyle, stylesheetLabels, "tablet", "active", "color");
        var boxTabletStylesV2 = shadowStyleV2_globalStyleCssRenderUnsafe(groupStyle, "tablet", "default", undefined, shadowColorLabelTablet);
        var boxTabletHoverStylesV2 = shadowStyleV2_globalStyleCssRenderUnsafe(groupStyle, "tablet", "hover", undefined, shadowColorLabelTabletHover);
        var boxTabletActiveStylesV2 = shadowStyleV2_globalStyleCssRenderUnsafe(groupStyle, "tablet", "active", undefined, shadowColorLabelTabletActive);
        /**
     * write css for box shadow
     * desktop hover is writen n it's own breakpoint,
     * but on the bob side the diferent breakpoint classes use the desktop default value
     */ var boxStyles = "";
        /**
     * Render gs css for old bobs
     * support bobs in pages that still don't have compatibility in globalstyles
     */ if (!groupStyle.compatibility || groupStyle.compatibility && groupStyle.compatibility.oldBobs) boxStyles = "\n        ".concat("".concat(className, "-box"), "{\n          ").concat(boxShadowCss(boxDesktopStyles), "\n        }\n        @media all and (min-width: 993px){\n          ").concat(className, "-box.ngsHoverState:hover{\n            ").concat(boxShadowCss(boxHoverStyles), "\n          }\n          ").concat("".concat(className, "-box"), ".ngsActiveState.active{\n            ").concat(boxShadowCss(boxActiveStyles), "\n          }\n        }\n        @media all and (max-width: 992px) and (min-width: 767px){\n          ").concat(className, "-box{\n            ").concat(boxShadowCss(boxTabletStyles), "\n          }\n          ").concat(className, "-box.ngsTabletHoverState:hover{\n            ").concat(boxShadowCss(boxTabletHoverStyles), "\n          }\n          ").concat(className, "-box.ngsTabletActiveState.active{\n            ").concat(boxShadowCss(boxTabletActiveStyles), "\n          }\n        }\n        @media all and (max-width: 766px){\n          ").concat(className, "-box{\n            ").concat(boxShadowCss(boxMobileStyles), "\n          }\n          ").concat(className, "-box.ngsMobileHoverState:hover{\n            ").concat(boxShadowCss(boxMobileHoverStyles), "\n          }\n          ").concat(className, "-box.ngsMobileActiveState.active{\n            ").concat(boxShadowCss(boxMobileActiveStyles), "\n          }\n        }");
        /**
     * Render gs css for new bobs
     */ if ((ref = groupStyle.compatibility) === null || ref === void 0 ? void 0 : ref.newBobs) boxStyles += "\n        ".concat("".concat(className, "-box").concat(NGS_CLASS_SUFIX), "{\n          ").concat(shadowStyleV2_boxShadowCss(boxDesktopStylesV2), "\n        }\n        ").concat(className, "-box").concat(NGS_CLASS_SUFIX, ":hover{\n          ").concat(shadowStyleV2_boxShadowCss(boxHoverStylesV2), "\n        }\n        ").concat("".concat(className, "-box").concat(NGS_CLASS_SUFIX), ".active{\n          ").concat(shadowStyleV2_boxShadowCss(boxActiveStylesV2), "\n        }\n        @media all and (max-width: 992px) and (min-width: 767px){\n          ").concat(className, "-box").concat(NGS_CLASS_SUFIX, "{\n            ").concat(shadowStyleV2_boxShadowCss(boxTabletStylesV2), "\n          }\n          ").concat(className, "-box").concat(NGS_CLASS_SUFIX, ":hover{\n            ").concat(shadowStyleV2_boxShadowCss(boxTabletHoverStylesV2), "\n          }\n          ").concat(className, "-box").concat(NGS_CLASS_SUFIX, ".active{\n            ").concat(shadowStyleV2_boxShadowCss(boxTabletActiveStylesV2), "\n          }\n        }\n        @media all and (max-width: 766px){\n          ").concat(className, "-box").concat(NGS_CLASS_SUFIX, "{\n            ").concat(shadowStyleV2_boxShadowCss(boxMobileStylesV2), "\n          }\n          ").concat(className, "-box").concat(NGS_CLASS_SUFIX, ":hover{\n            ").concat(shadowStyleV2_boxShadowCss(boxMobileHoverStylesV2), "\n          }\n          ").concat(className, "-box").concat(NGS_CLASS_SUFIX, ".active{\n            ").concat(shadowStyleV2_boxShadowCss(boxMobileActiveStylesV2), "\n          }\n        }");
        /**
     * handle api values to css values for text shadow
     */ var textDesktopStyles = globalStyleCssRenderUnsafe(groupStyle, "desktop", "default", "text", undefined);
        var textHoverStyles = globalStyleCssRenderUnsafe(groupStyle, "desktop", "hover", "text", undefined);
        var textActiveStyles = globalStyleCssRenderUnsafe(groupStyle, "desktop", "active", "text", undefined);
        // mobile
        var textMobileStyles = globalStyleCssRenderUnsafe(groupStyle, "mobile", "active", "text", undefined);
        var textMobileHoverStyles = globalStyleCssRenderUnsafe(groupStyle, "mobile", "hover", "text", undefined);
        var textMobileActiveStyles = globalStyleCssRenderUnsafe(groupStyle, "mobile", "active", "text", undefined);
        // tablet
        var textTabletStyles = globalStyleCssRenderUnsafe(groupStyle, "tablet", "active", "text", undefined);
        var textTabletHoverStyles = globalStyleCssRenderUnsafe(groupStyle, "tablet", "hover", "text", undefined);
        var textTabletActiveStyles = globalStyleCssRenderUnsafe(groupStyle, "tablet", "active", "text", undefined);
        /**
     * v2
     */ var tShadowColorLabelDesktop = handleBobLabel(groupStyle, stylesheetLabels, "desktop", "default", "color");
        var tShadowColorLabelHover = handleBobLabel(groupStyle, stylesheetLabels, "desktop", "hover", "color");
        var tShadowColorLabelActive = handleBobLabel(groupStyle, stylesheetLabels, "desktop", "active", "color");
        var textDesktopStylesV2 = textShadowStyle_globalStyleCssRenderUnsafe(groupStyle, "desktop", "default", undefined, tShadowColorLabelDesktop);
        var textHoverStylesV2 = textShadowStyle_globalStyleCssRenderUnsafe(groupStyle, "desktop", "hover", undefined, tShadowColorLabelHover);
        var textActiveStylesV2 = textShadowStyle_globalStyleCssRenderUnsafe(groupStyle, "desktop", "active", undefined, tShadowColorLabelActive);
        // mobile
        var tShadowColorLabelMobile = handleBobLabel(groupStyle, stylesheetLabels, "mobile", "default", "color");
        var tShadowColorLabelMobileHover = handleBobLabel(groupStyle, stylesheetLabels, "mobile", "hover", "color");
        var tShadowColorLabelMobileActive = handleBobLabel(groupStyle, stylesheetLabels, "mobile", "active", "color");
        var textMobileStylesV2 = textShadowStyle_globalStyleCssRenderUnsafe(groupStyle, "mobile", "default", undefined, tShadowColorLabelMobile);
        var textMobileHoverStylesV2 = textShadowStyle_globalStyleCssRenderUnsafe(groupStyle, "mobile", "hover", undefined, tShadowColorLabelMobileHover);
        var textMobileActiveStylesV2 = textShadowStyle_globalStyleCssRenderUnsafe(groupStyle, "mobile", "active", undefined, tShadowColorLabelMobileActive);
        // tablet
        var tShadowColorLabelTablet = handleBobLabel(groupStyle, stylesheetLabels, "tablet", "default", "color");
        var tShadowColorLabelTabletHover = handleBobLabel(groupStyle, stylesheetLabels, "tablet", "hover", "color");
        var tShadowColorLabelTabletActive = handleBobLabel(groupStyle, stylesheetLabels, "tablet", "active", "color");
        var textTabletStylesV2 = textShadowStyle_globalStyleCssRenderUnsafe(groupStyle, "tablet", "default", undefined, tShadowColorLabelTablet);
        var textTabletHoverStylesV2 = textShadowStyle_globalStyleCssRenderUnsafe(groupStyle, "tablet", "hover", undefined, tShadowColorLabelTabletHover);
        var textTabletActiveStylesV2 = textShadowStyle_globalStyleCssRenderUnsafe(groupStyle, "tablet", "active", undefined, tShadowColorLabelTabletActive);
        /**
     * write css for text shadow
     */ var textStyles = "";
        /**
     * Render gs css for old bobs
     * support bobs in pages that still don't have compatibility in globalstyles
     */ if (!groupStyle.compatibility || groupStyle.compatibility && groupStyle.compatibility.oldBobs) textStyles = "\n      ".concat(className, "-text{\n        ").concat(textShadowCss(textDesktopStyles), ";\n      }\n      @media all and (min-width: 993px){\n        ").concat(className, "-text.ngsHoverState:hover{\n          ").concat(textShadowCss(textHoverStyles), ";\n        }\n        ").concat(className, "-text.ngsActiveState.active{\n          ").concat(textShadowCss(textActiveStyles), ";\n        }\n      }\n       @media all and (max-width: 992px) and (min-width: 767px){\n        ").concat(className, "-text{\n          ").concat(textShadowCss(textTabletStyles), ";\n        }\n        ").concat(className, "-text.ngsTabletHoverState:hover{\n          ").concat(textShadowCss(textTabletHoverStyles), ";\n        }\n        ").concat(className, "-text.ngsTabletActiveState.active{\n          ").concat(textShadowCss(textTabletActiveStyles), ";\n        }\n      }\n      @media all and (max-width: 766px){\n        ").concat(className, "-text{\n          ").concat(textShadowCss(textMobileStyles), ";\n        }\n        ").concat(className, "-text.ngsMobileHoverState:hover{\n          ").concat(textShadowCss(textMobileHoverStyles), ";\n        }\n        ").concat(className, "-text.ngsMobileActiveState.active{\n          ").concat(textShadowCss(textMobileActiveStyles), ";\n        }\n      }");
        /**
     * Render gs css for new bobs
     */ if ((ref1 = groupStyle.compatibility) === null || ref1 === void 0 ? void 0 : ref1.newBobs) textStyles += "\n      ".concat(className, "-text").concat(NGS_CLASS_SUFIX, "{\n        ").concat(textShadowStyle_textShadowCss(textDesktopStylesV2), ";\n      }\n      ").concat(className, "-text").concat(NGS_CLASS_SUFIX, ":hover{\n        ").concat(textShadowStyle_textShadowCss(textHoverStylesV2), ";\n      }\n      ").concat(className, "-text").concat(NGS_CLASS_SUFIX, ".active{\n        ").concat(textShadowStyle_textShadowCss(textActiveStylesV2), ";\n      }\n       @media all and (max-width: 992px) and (min-width: 767px){\n        ").concat(className, "-text").concat(NGS_CLASS_SUFIX, "{\n          ").concat(textShadowStyle_textShadowCss(textTabletStylesV2), ";\n        }\n        ").concat(className, "-text").concat(NGS_CLASS_SUFIX, ":hover{\n          ").concat(textShadowStyle_textShadowCss(textTabletHoverStylesV2), ";\n        }\n        ").concat(className, "-text").concat(NGS_CLASS_SUFIX, ".active{\n          ").concat(textShadowStyle_textShadowCss(textTabletActiveStylesV2), ";\n        }\n      }\n      @media all and (max-width: 766px){\n        ").concat(className, "-text").concat(NGS_CLASS_SUFIX, "{\n          ").concat(textShadowStyle_textShadowCss(textMobileStylesV2), ";\n        }\n        ").concat(className, "-text").concat(NGS_CLASS_SUFIX, ":hover{\n          ").concat(textShadowStyle_textShadowCss(textMobileHoverStylesV2), ";\n        }\n        ").concat(className, "-text").concat(NGS_CLASS_SUFIX, ".active{\n          ").concat(textShadowStyle_textShadowCss(textMobileActiveStylesV2), ";\n        }\n      }");
        return "\n        ".concat(boxStyles, "\n        ").concat(textStyles, "\n      ");
    }
    if (type === GS_BOUNDARY) {
        var ref2;
        /**
     * handle api values to css values
     */ var desktopStyles = boundaryStyle_globalStyleCssRenderUnsafe(groupStyle, "desktop", "default");
        var hoverStyles = boundaryStyle_globalStyleCssRenderUnsafe(groupStyle, "desktop", "hover");
        var activeStyles = boundaryStyle_globalStyleCssRenderUnsafe(groupStyle, "desktop", "active");
        // mobile
        var mobileStyles = boundaryStyle_globalStyleCssRenderUnsafe(groupStyle, "mobile", "default");
        var mobileHoverStyles = boundaryStyle_globalStyleCssRenderUnsafe(groupStyle, "mobile", "hover");
        var mobileActiveStyles = boundaryStyle_globalStyleCssRenderUnsafe(groupStyle, "mobile", "active");
        // tablet
        var tabletStyles = boundaryStyle_globalStyleCssRenderUnsafe(groupStyle, "tablet", "default");
        var tabletHoverStyles = boundaryStyle_globalStyleCssRenderUnsafe(groupStyle, "tablet", "hover");
        var tabletActiveStyles = boundaryStyle_globalStyleCssRenderUnsafe(groupStyle, "tablet", "active");
        /**
     * v2
     */ var desktopStylesV2 = boundaryStyleV2_globalStyleCssRenderUnsafe(groupStyle, "desktop", "default");
        var hoverStylesV2 = boundaryStyleV2_globalStyleCssRenderUnsafe(groupStyle, "desktop", "hover");
        var activeStylesV2 = boundaryStyleV2_globalStyleCssRenderUnsafe(groupStyle, "desktop", "active");
        // mobile
        var mobileStylesV2 = boundaryStyleV2_globalStyleCssRenderUnsafe(groupStyle, "mobile", "default");
        var mobileHoverStylesV2 = boundaryStyleV2_globalStyleCssRenderUnsafe(groupStyle, "mobile", "hover");
        var mobileActiveStylesV2 = boundaryStyleV2_globalStyleCssRenderUnsafe(groupStyle, "mobile", "active");
        // tablet
        var tabletStylesV2 = boundaryStyleV2_globalStyleCssRenderUnsafe(groupStyle, "tablet", "default");
        var tabletHoverStylesV2 = boundaryStyleV2_globalStyleCssRenderUnsafe(groupStyle, "tablet", "hover");
        var tabletActiveStylesV2 = boundaryStyleV2_globalStyleCssRenderUnsafe(groupStyle, "tablet", "active");
        /**
     * write css
     * desktop hover is writen n it's own breakpoint,
     * but on the bob side the diferent breakpoint classes use the desktop default value
     */ var styles = "";
        /**
     * Render gs css for old bobs
     * support bobs in pages that still don't have compatibility in globalstyles
     */ if (!groupStyle.compatibility || groupStyle.compatibility && groupStyle.compatibility.oldBobs) styles = "\n      ".concat(className, "{\n       ").concat(renderCSSString(desktopStyles), "\n      }\n      @media all and (min-width: 993px){\n        ").concat(className, ".ngsHoverState:hover{\n          ").concat(renderCSSString(hoverStyles), "\n        }\n        ").concat(className, ".ngsACtiveState.active{\n          ").concat(renderCSSString(activeStyles), "\n        }\n      }\n      @media all and (max-width: 992px) and (min-width: 767px){\n        ").concat(className, "{\n          ").concat(renderCSSString(tabletStyles), "\n        }\n        ").concat(className, ".ngsTabletHoverState:hover{\n          ").concat(renderCSSString(tabletHoverStyles), "\n        }\n        ").concat(className, ".ngsTabletActiveState.active{\n          ").concat(renderCSSString(tabletActiveStyles), "\n        }\n      }\n      @media all and (max-width: 766px){\n        ").concat(className, "{\n          ").concat(renderCSSString(mobileStyles), "\n        }\n        ").concat(className, ".ngsMobileHoverState:hover{\n          ").concat(renderCSSString(mobileHoverStyles), "\n        }\n        ").concat(className, ".ngsMobileActiveState.active{\n          ").concat(renderCSSString(mobileActiveStyles), "\n        }\n      }");
        /**
     * Render gs css for new bobs
     */ if ((ref2 = groupStyle.compatibility) === null || ref2 === void 0 ? void 0 : ref2.newBobs) styles += "\n      ".concat(className).concat(NGS_CLASS_SUFIX, "{\n        ").concat(boundaryStyleV2_renderCSSString(desktopStylesV2), "\n      }\n      ").concat(className).concat(NGS_CLASS_SUFIX, ":hover{\n        ").concat(boundaryStyleV2_renderCSSString(hoverStylesV2), "\n      }\n      ").concat(className).concat(NGS_CLASS_SUFIX, ".active{\n        ").concat(boundaryStyleV2_renderCSSString(activeStylesV2), "\n      }\n      @media all and (max-width: 992px) and (min-width: 767px){\n        ").concat(className).concat(NGS_CLASS_SUFIX, "{\n          ").concat(boundaryStyleV2_renderCSSString(tabletStylesV2), "\n        }\n        ").concat(className).concat(NGS_CLASS_SUFIX, ":hover{\n          ").concat(boundaryStyleV2_renderCSSString(tabletHoverStylesV2), "\n        }\n        ").concat(className).concat(NGS_CLASS_SUFIX, ".active{\n          ").concat(boundaryStyleV2_renderCSSString(tabletActiveStylesV2), "\n        }\n      }\n      @media all and (max-width: 766px){\n        ").concat(className).concat(NGS_CLASS_SUFIX, "{\n          ").concat(boundaryStyleV2_renderCSSString(mobileStylesV2), "\n        }\n        ").concat(className).concat(NGS_CLASS_SUFIX, ":hover{\n          ").concat(boundaryStyleV2_renderCSSString(mobileHoverStylesV2), "\n        }\n        ").concat(className).concat(NGS_CLASS_SUFIX, ".active{\n          ").concat(boundaryStyleV2_renderCSSString(mobileActiveStylesV2), "\n        }\n      }");
        return styles;
    }
    if (type === GS_TEXT) {
        var ref3;
        /**
     * handle api values to css values for text
     */ var textDesktopStyles1 = textStyle_globalStyleCssRenderUnsafe(groupStyle, "desktop", "default");
        var textHoverStyles1 = textStyle_globalStyleCssRenderUnsafe(groupStyle, "desktop", "hover");
        var textActiveStyles1 = textStyle_globalStyleCssRenderUnsafe(groupStyle, "desktop", "active");
        // mobile
        var textMobileStyles1 = textStyle_globalStyleCssRenderUnsafe(groupStyle, "mobile", "active");
        var textMobileHoverStyles1 = textStyle_globalStyleCssRenderUnsafe(groupStyle, "mobile", "hover");
        var textMobileActiveStyles1 = textStyle_globalStyleCssRenderUnsafe(groupStyle, "mobile", "active");
        // tablet
        var textTabletStyles1 = textStyle_globalStyleCssRenderUnsafe(groupStyle, "tablet", "active");
        var textTabletHoverStyles1 = textStyle_globalStyleCssRenderUnsafe(groupStyle, "tablet", "hover");
        var textTabletActiveStyles1 = textStyle_globalStyleCssRenderUnsafe(groupStyle, "tablet", "active");
        /**
     * v2
     */ var textLabelDesktop = handleBobLabel(groupStyle, stylesheetLabels, "desktop", "default", "fontFamily");
        var textLabelHover = handleBobLabel(groupStyle, stylesheetLabels, "desktop", "hover", "fontFamily");
        var textLabelActive = handleBobLabel(groupStyle, stylesheetLabels, "desktop", "active", "fontFamily");
        var textDesktopStylesV21 = textStyleV2_globalStyleCssRenderUnsafe(groupStyle, "desktop", "default", textLabelDesktop);
        var textHoverStylesV21 = textStyleV2_globalStyleCssRenderUnsafe(groupStyle, "desktop", "hover", textLabelHover);
        var textActiveStylesV21 = textStyleV2_globalStyleCssRenderUnsafe(groupStyle, "desktop", "active", textLabelActive);
        // mobile
        var textLabelMobile = handleBobLabel(groupStyle, stylesheetLabels, "mobile", "default", "fontFamily");
        var textLabelMobileHover = handleBobLabel(groupStyle, stylesheetLabels, "mobile", "hover", "fontFamily");
        var textLabelMobileActive = handleBobLabel(groupStyle, stylesheetLabels, "mobile", "active", "fontFamily");
        var textMobileStylesV21 = textStyleV2_globalStyleCssRenderUnsafe(groupStyle, "mobile", "default", textLabelMobile);
        var textMobileHoverStylesV21 = textStyleV2_globalStyleCssRenderUnsafe(groupStyle, "mobile", "hover", textLabelMobileHover);
        var textMobileActiveStylesV21 = textStyleV2_globalStyleCssRenderUnsafe(groupStyle, "mobile", "active", textLabelMobileActive);
        // tablet
        var textLabelTablet = handleBobLabel(groupStyle, stylesheetLabels, "tablet", "default", "fontFamily");
        var textLabelTabletHover = handleBobLabel(groupStyle, stylesheetLabels, "tablet", "hover", "fontFamily");
        var textLabelTabletActive = handleBobLabel(groupStyle, stylesheetLabels, "tablet", "active", "fontFamily");
        var textTabletStylesV21 = textStyleV2_globalStyleCssRenderUnsafe(groupStyle, "tablet", "default", textLabelTablet);
        var textTabletHoverStylesV21 = textStyleV2_globalStyleCssRenderUnsafe(groupStyle, "tablet", "hover", textLabelTabletHover);
        var textTabletActiveStylesV21 = textStyleV2_globalStyleCssRenderUnsafe(groupStyle, "tablet", "active", textLabelTabletActive);
        /**
     * write css for text shadow
     */ var textStyles1 = "";
        /**
     * Render gs css for old bobs
     * support bobs in pages that still don't have compatibility in globalstyles
     */ if (!groupStyle.compatibility || groupStyle.compatibility && groupStyle.compatibility.oldBobs) textStyles1 = "\n      ".concat(className, "{\n        ").concat(textStyle_renderCSSString(textDesktopStyles1), "\n      }\n      @media all and (min-width: 993px){\n        ").concat(className, ".ngsHoverState:hover{\n          ").concat(textStyle_renderCSSString(textHoverStyles1), "\n        }\n        ").concat(className, ".ngsActiveState.active{\n          ").concat(textStyle_renderCSSString(textActiveStyles1), "\n        }\n      }\n      @media all and (max-width: 992px) and (min-width: 767px){\n        ").concat(className, "{\n          ").concat(textStyle_renderCSSString(textTabletStyles1), "\n        }\n        ").concat(className, ".ngsTabletHoverState:hover{\n          ").concat(textStyle_renderCSSString(textTabletHoverStyles1), "\n        }\n        ").concat(className, ".ngsTabletActiveState.active{\n          ").concat(textStyle_renderCSSString(textTabletActiveStyles1), "\n        }\n      }\n      @media all and (max-width: 766px){\n        ").concat(className, "{\n          ").concat(textStyle_renderCSSString(textMobileStyles1), "\n        }\n        ").concat(className, ".ngsMobileHoverState:hover{\n          ").concat(textStyle_renderCSSString(textMobileHoverStyles1), "\n        }\n        ").concat(className, ".ngsMobileActiveState.active{\n          ").concat(textStyle_renderCSSString(textMobileActiveStyles1), "\n        }\n      }");
        /**
     * Render gs css for new bobs
     */ if ((ref3 = groupStyle.compatibility) === null || ref3 === void 0 ? void 0 : ref3.newBobs) textStyles1 += "\n      ".concat(className).concat(NGS_CLASS_SUFIX, "{\n        ").concat(textStyleV2_renderCSSString(textDesktopStylesV21), "\n      }\n      ").concat(className).concat(NGS_CLASS_SUFIX, ":hover{\n        ").concat(textStyleV2_renderCSSString(textHoverStylesV21), "\n      }\n      ").concat(className).concat(NGS_CLASS_SUFIX, ".active{\n        ").concat(textStyleV2_renderCSSString(textActiveStylesV21), "\n      }\n      @media all and (max-width: 992px) and (min-width: 767px){\n        ").concat(className).concat(NGS_CLASS_SUFIX, " {\n          ").concat(textStyleV2_renderCSSString(textTabletStylesV21), "}\n        }\n        ").concat(className).concat(NGS_CLASS_SUFIX, ":hover{\n          ").concat(textStyleV2_renderCSSString(textTabletHoverStylesV21), "\n        }\n        ").concat(className).concat(NGS_CLASS_SUFIX, ".active{\n          ").concat(textStyleV2_renderCSSString(textTabletActiveStylesV21), "\n        }\n      }\n      @media all and (max-width: 766px){\n        ").concat(className).concat(NGS_CLASS_SUFIX, " {\n          ").concat(textStyleV2_renderCSSString(textMobileStylesV21), "}\n        }\n        ").concat(className).concat(NGS_CLASS_SUFIX, ":hover{\n          ").concat(textStyleV2_renderCSSString(textMobileHoverStylesV21), "\n        }\n        ").concat(className).concat(NGS_CLASS_SUFIX, ".active{\n          ").concat(textStyleV2_renderCSSString(textMobileActiveStylesV21), "\n        }\n      }");
        return textStyles1;
    }
    /**
   * Still not used by bobs/controllers
   */ if (type === GS_SCREEN_FLOW) {
        /**
     * Handled in every component that writes the container Class
     * ComponentBoilerplate.js
     * BobBackgroundImage.tsx
     */ return "";
    }
    if (type === GS_COLUMNS) {
        /**
     * Handled in every component that writes the columns Class
     * handleColumns
     */ return "";
    }
    if (type === GS_BG_COLORS) {
        /**
     * Handled in every bobBackgroundImage with the following properties:
     * background color with gradients
     * background image position
     */ return "";
    }
    if (type === GS_ICON) {
        /**
     * Modify responsive handler to be used here and in the bobIcon with the following properties
     * size
     */ return "";
    }
    if (type === GS_HEIGHT) {
        var ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
        /**
     * handle api values to css values
     */ var desktopStyles1 = handleHeight(groupStyle);
        var hoverStyles1 = handleHeight(groupStyle.behaviour.hover);
        var activeStyles1 = handleHeight((ref4 = groupStyle.behaviour) === null || ref4 === void 0 ? void 0 : ref4.active);
        // mobile
        var mobileStyles1 = globalStylesResponsiveHandler.responsiveProperties(groupStyle, type, "mobile");
        var mobileHoverStyles1 = globalStylesResponsiveHandler.responsiveProperties({
            mobile: (ref5 = groupStyle.mobile) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.behaviour) === null || ref6 === void 0 ? void 0 : ref6.hover
        }, type, "mobile");
        var mobileActiveStyles1 = globalStylesResponsiveHandler.responsiveProperties({
            mobile: (ref7 = groupStyle.mobile) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.behaviour) === null || ref8 === void 0 ? void 0 : ref8.active
        }, type, "mobile");
        // tablet
        var tabletStyles1 = globalStylesResponsiveHandler.responsiveProperties(groupStyle, type, "tablet");
        var tabletHoverStyles1 = globalStylesResponsiveHandler.responsiveProperties({
            tablet: (ref9 = groupStyle.tablet) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.behaviour) === null || ref10 === void 0 ? void 0 : ref10.hover
        }, type, "tablet");
        var tabletActiveStyles1 = globalStylesResponsiveHandler.responsiveProperties({
            tablet: (ref11 = groupStyle.tablet) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.behaviour) === null || ref12 === void 0 ? void 0 : ref12.active
        }, type, "tablet");
        /**
     * write css
     */ var styles1 = "\n      ".concat(className, "{\n        height: ").concat(desktopStyles1.height, ";\n      }\n      ").concat(hoverStyles1 ? "".concat(className, ":hover{\n            height: ").concat(hoverStyles1.height, ";\n          }") : "", "\n      ").concat(activeStyles1 ? "".concat(className, ".active{\n            height: ").concat(activeStyles1.height, ";\n          }") : "", "\n\n      ").concat(tabletStyles1 || tabletHoverStyles1 || tabletActiveStyles1 ? "@media all and (max-width: 992px) and (min-width: 767px){\n            ".concat(className, "{\n              height: ").concat(tabletStyles1.height, ";\n            }\n            ").concat(tabletHoverStyles1 ? "".concat(className, ":hover{\n              height: ").concat(tabletHoverStyles1.height, ";\n                }") : "", "\n            ").concat(tabletActiveStyles1 ? "".concat(className, ".active{\n              height: ").concat(tabletActiveStyles1.height, ";\n                }") : "", "\n          }") : "", "\n\n      ").concat(mobileStyles1 || mobileHoverStyles1 || mobileActiveStyles1 ? "@media all and (max-width: 766px){\n            ".concat(className, "{\n              height: ").concat(mobileStyles1.height, ";\n            }\n            ").concat(mobileHoverStyles1 ? "".concat(className, ":hover{\n              height: ").concat(mobileHoverStyles1.height, ";\n                }") : "", "\n            ").concat(mobileActiveStyles1 ? "".concat(className, ".active{\n              height: ").concat(mobileActiveStyles1.height, ";\n                }") : "", "\n          }") : "", "\n      ");
        return styles1;
    }
    if (type === GS_BORDER_RADIUS) {
        var ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22;
        /**
     * handle api values to css values
     */ var desktopStyles2 = handleRadius({
            radius: groupStyle
        });
        var hoverStyles2 = handleRadius({
            radius: (ref13 = groupStyle.behaviour) === null || ref13 === void 0 ? void 0 : ref13.hover
        });
        var activeStyles2 = handleRadius({
            radius: (ref14 = groupStyle.behaviour) === null || ref14 === void 0 ? void 0 : ref14.active
        });
        // mobile
        var mobileStyles2 = globalStylesResponsiveHandler.responsiveProperties(groupStyle, type, "mobile");
        var mobileHoverStyles2 = globalStylesResponsiveHandler.responsiveProperties({
            mobile: (ref15 = groupStyle.mobile) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.behaviour) === null || ref16 === void 0 ? void 0 : ref16.hover
        }, type, "mobile");
        var mobileActiveStyles2 = globalStylesResponsiveHandler.responsiveProperties({
            mobile: (ref17 = groupStyle.mobile) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.behaviour) === null || ref18 === void 0 ? void 0 : ref18.active
        }, type, "mobile");
        // tablet
        var tabletStyles2 = globalStylesResponsiveHandler.responsiveProperties(groupStyle, type, "tablet");
        var tabletHoverStyles2 = globalStylesResponsiveHandler.responsiveProperties({
            tablet: (ref19 = groupStyle.tablet) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.behaviour) === null || ref20 === void 0 ? void 0 : ref20.hover
        }, type, "tablet");
        var tabletActiveStyles2 = globalStylesResponsiveHandler.responsiveProperties({
            tablet: (ref21 = groupStyle.tablet) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.behaviour) === null || ref22 === void 0 ? void 0 : ref22.active
        }, type, "tablet");
        /**
     * write css
     */ var styles2 = "\n      ".concat(className, "{\n        border-top-left-radius: ").concat(desktopStyles2.borderTopLeftRadius, ";\n        border-top-right-radius: ").concat(desktopStyles2.borderTopRightRadius, ";\n        border-bottom-left-radius: ").concat(desktopStyles2.borderBottomLeftRadius, ";\n        border-bottom-right-radius: ").concat(desktopStyles2.borderBottomRightRadius, ";\n      }\n      ").concat(hoverStyles2 ? "".concat(className, ":hover{\n            border-top-left-radius: ").concat(hoverStyles2.borderTopLeftRadius, ";\n            border-top-right-radius: ").concat(hoverStyles2.borderTopRightRadius, ";\n            border-bottom-left-radius: ").concat(hoverStyles2.borderBottomLeftRadius, ";\n            border-bottom-right-radius: ").concat(hoverStyles2.borderBottomRightRadius, ";\n          }") : "", "\n      ").concat(activeStyles2 ? "".concat(className, ".active{\n            border-top-left-radius: ").concat(activeStyles2.borderTopLeftRadius, ";\n            border-top-right-radius: ").concat(activeStyles2.borderTopRightRadius, ";\n            border-bottom-left-radius: ").concat(activeStyles2.borderBottomLeftRadius, ";\n            border-bottom-right-radius: ").concat(activeStyles2.borderBottomRightRadius, ";\n          }") : "", "\n\n      ").concat(tabletStyles2 || tabletHoverStyles2 || tabletActiveStyles2 ? "@media all and (max-width: 992px) and (min-width: 767px){\n            ".concat(className, "{\n              border-top-left-radius: ").concat(tabletStyles2["border-top-left-radius"], ";\n              border-top-right-radius: ").concat(tabletStyles2["border-top-right-radius"], ";\n              border-bottom-left-radius: ").concat(tabletStyles2["border-bottom-left-radius"], ";\n              border-bottom-right-radius: ").concat(tabletStyles2["border-bottom-right-radius"], ";\n            }\n            ").concat(tabletHoverStyles2 ? "".concat(className, ":hover{\n              border-top-left-radius: ").concat(tabletHoverStyles2["border-top-left-radius"], ";\n              border-top-right-radius: ").concat(tabletHoverStyles2["border-top-right-radius"], ";\n              border-bottom-left-radius: ").concat(tabletHoverStyles2["border-bottom-left-radius"], ";\n              border-bottom-right-radius: ").concat(tabletHoverStyles2["border-bottom-right-radius"], ";\n                }") : "", "\n            ").concat(tabletActiveStyles2 ? "".concat(className, ".active{\n              border-top-left-radius: ").concat(tabletActiveStyles2["border-top-left-radius"], ";\n              border-top-right-radius: ").concat(tabletActiveStyles2["border-top-right-radius"], ";\n              border-bottom-left-radius: ").concat(tabletActiveStyles2["border-bottom-left-radius"], ";\n              border-bottom-right-radius: ").concat(tabletActiveStyles2["border-bottom-right-radius"], ";\n                }") : "", "\n          }") : "", "\n\n      ").concat(mobileStyles2 || mobileHoverStyles2 || mobileActiveStyles2 ? "@media all and (max-width: 766px){\n            ".concat(className, "{\n              border-top-left-radius: ").concat(mobileStyles2["border-top-left-radius"], ";\n              border-top-right-radius: ").concat(mobileStyles2["border-top-right-radius"], ";\n              border-bottom-left-radius: ").concat(mobileStyles2["border-bottom-left-radius"], ";\n              border-bottom-right-radius: ").concat(mobileStyles2["border-bottom-right-radius"], ";\n            }\n            ").concat(mobileHoverStyles2 ? "".concat(className, ":hover{\n              border-top-left-radius: ").concat(mobileHoverStyles2["border-top-left-radius"], ";\n              border-top-right-radius: ").concat(mobileHoverStyles2["border-top-right-radius"], ";\n              border-bottom-left-radius: ").concat(mobileHoverStyles2["border-bottom-left-radius"], ";\n              border-bottom-right-radius: ").concat(mobileHoverStyles2["border-bottom-right-radius"], ";\n                }") : "", "\n            ").concat(mobileActiveStyles2 ? "".concat(className, ".active{\n              border-top-left-radius: ").concat(mobileActiveStyles2["border-top-left-radius"], ";\n              border-top-right-radius: ").concat(mobileActiveStyles2["border-top-right-radius"], ";\n              border-bottom-left-radius: ").concat(mobileActiveStyles2["border-bottom-left-radius"], ";\n              border-bottom-right-radius: ").concat(mobileActiveStyles2["border-bottom-right-radius"], ";\n                }") : "", "\n          }") : "", "\n      ");
        return styles2;
    }
    if (type === GS_BORDER) {
        var ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32;
        /**
     * handle api values to css values
     */ var desktopStyles3 = handleBorder({
            border: groupStyle
        });
        var hoverStyles3 = handleBorder({
            border: (ref23 = groupStyle.behaviour) === null || ref23 === void 0 ? void 0 : ref23.hover
        });
        var activeStyles3 = handleBorder({
            border: (ref24 = groupStyle.behaviour) === null || ref24 === void 0 ? void 0 : ref24.active
        });
        // mobile
        var mobileStyles3 = globalStylesResponsiveHandler.responsiveProperties(groupStyle, type, "mobile");
        var mobileHoverStyles3 = globalStylesResponsiveHandler.responsiveProperties({
            mobile: (ref25 = groupStyle.mobile) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.behaviour) === null || ref26 === void 0 ? void 0 : ref26.hover
        }, type, "mobile");
        var mobileActiveStyles3 = globalStylesResponsiveHandler.responsiveProperties({
            mobile: (ref27 = groupStyle.mobile) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.behaviour) === null || ref28 === void 0 ? void 0 : ref28.active
        }, type, "mobile");
        // tablet
        var tabletStyles3 = globalStylesResponsiveHandler.responsiveProperties(groupStyle, type, "tablet");
        var tabletHoverStyles3 = globalStylesResponsiveHandler.responsiveProperties({
            tablet: (ref29 = groupStyle.tablet) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.behaviour) === null || ref30 === void 0 ? void 0 : ref30.hover
        }, type, "tablet");
        var tabletActiveStyles3 = globalStylesResponsiveHandler.responsiveProperties({
            tablet: (ref31 = groupStyle.tablet) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.behaviour) === null || ref32 === void 0 ? void 0 : ref32.active
        }, type, "tablet");
        /**
     * write css
     */ var styles3 = "\n      ".concat(className, "{\n        border-top: ").concat(desktopStyles3.borderTop, ";\n        border-left: ").concat(desktopStyles3.borderLeft, ";\n        border-bottom: ").concat(desktopStyles3.borderBottom, ";\n        border-right: ").concat(desktopStyles3.borderRight, ";\n      }\n      ").concat(hoverStyles3 ? "".concat(className, ":hover{\n            border-top: ").concat(hoverStyles3.borderTop, ";\n            border-left: ").concat(hoverStyles3.borderLeft, ";\n            border-bottom: ").concat(hoverStyles3.borderBottom, ";\n            border-right: ").concat(hoverStyles3.borderRight, ";\n          }") : "", "\n      ").concat(activeStyles3 ? "".concat(className, ".active{\n            border-top: ").concat(activeStyles3.borderTop, ";\n            border-left: ").concat(activeStyles3.borderLeft, ";\n            border-bottom: ").concat(activeStyles3.borderBottom, ";\n            border-right: ").concat(activeStyles3.borderRight, ";\n          }") : "", "\n\n      ").concat(tabletStyles3 || tabletHoverStyles3 || tabletActiveStyles3 ? "@media all and (max-width: 992px) and (min-width: 767px){\n            ".concat(className, "{\n              border-top: ").concat(tabletStyles3["border-top"], ";\n              border-left: ").concat(tabletStyles3["border-left"], ";\n              border-bottom: ").concat(tabletStyles3["border-bottom"], ";\n              border-right: ").concat(tabletStyles3["border-right"], ";\n            }\n            ").concat(tabletHoverStyles3 ? "".concat(className, ":hover{\n              border-top: ").concat(tabletHoverStyles3["border-top"], ";\n              border-left: ").concat(tabletHoverStyles3["border-left"], ";\n              border-bottom: ").concat(tabletHoverStyles3["border-bottom"], ";\n              border-right: ").concat(tabletHoverStyles3["border-right"], ";\n                }") : "", "\n            ").concat(tabletActiveStyles3 ? "".concat(className, ".active{\n              border-top: ").concat(tabletActiveStyles3["border-top"], ";\n              border-left: ").concat(tabletActiveStyles3["border-left"], ";\n              border-bottom: ").concat(tabletActiveStyles3["border-bottom"], ";\n              border-right: ").concat(tabletActiveStyles3["border-right"], ";\n                }") : "", "\n          }") : "", "\n\n      ").concat(mobileStyles3 || mobileHoverStyles3 || mobileActiveStyles3 ? "@media all and (max-width: 766px){\n            ".concat(className, "{\n              border-top: ").concat(mobileStyles3["border-top"], ";\n              border-left: ").concat(mobileStyles3["border-left"], ";\n              border-bottom: ").concat(mobileStyles3["border-bottom"], ";\n              border-right: ").concat(mobileStyles3["border-right"], ";\n            }\n            ").concat(mobileHoverStyles3 ? "".concat(className, ":hover{\n              border-top: ").concat(mobileHoverStyles3["border-top"], ";\n              border-left: ").concat(mobileHoverStyles3["border-left"], ";\n              border-bottom: ").concat(mobileHoverStyles3["border-bottom"], ";\n              border-right: ").concat(mobileHoverStyles3["border-right"], ";\n                }") : "", "\n            ").concat(mobileActiveStyles3 ? "".concat(className, ".active{\n              border-top: ").concat(mobileActiveStyles3["border-top"], ";\n              border-left: ").concat(mobileActiveStyles3["border-left"], ";\n              border-bottom: ").concat(mobileActiveStyles3["border-bottom"], ";\n              border-right: ").concat(mobileActiveStyles3["border-right"], ";\n                }") : "", "\n          }") : "", "\n      ");
        return styles3;
    }
    if (type === GS_FILTER) {
        var ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42;
        /**
     * handle api values to css values
     */ var desktopStyles4 = handleImageFilter({
            filter: groupStyle
        });
        var hoverStyles4 = handleImageFilter({
            filter: (ref33 = groupStyle.behaviour) === null || ref33 === void 0 ? void 0 : ref33.hover
        });
        var activeStyles4 = handleImageFilter({
            filter: (ref34 = groupStyle.behaviour) === null || ref34 === void 0 ? void 0 : ref34.active
        });
        // mobile
        var mobileStyles4 = globalStylesResponsiveHandler.responsiveProperties(groupStyle, type, "mobile");
        var mobileHoverStyles4 = globalStylesResponsiveHandler.responsiveProperties({
            mobile: (ref35 = groupStyle.mobile) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.behaviour) === null || ref36 === void 0 ? void 0 : ref36.hover
        }, type, "mobile");
        var mobileActiveStyles4 = globalStylesResponsiveHandler.responsiveProperties({
            mobile: (ref37 = groupStyle.mobile) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.behaviour) === null || ref38 === void 0 ? void 0 : ref38.active
        }, type, "mobile");
        // tablet
        var tabletStyles4 = globalStylesResponsiveHandler.responsiveProperties(groupStyle, type, "tablet");
        var tabletHoverStyles4 = globalStylesResponsiveHandler.responsiveProperties({
            tablet: (ref39 = groupStyle.tablet) === null || ref39 === void 0 ? void 0 : (ref40 = ref39.behaviour) === null || ref40 === void 0 ? void 0 : ref40.hover
        }, type, "tablet");
        var tabletActiveStyles4 = globalStylesResponsiveHandler.responsiveProperties({
            tablet: (ref41 = groupStyle.tablet) === null || ref41 === void 0 ? void 0 : (ref42 = ref41.behaviour) === null || ref42 === void 0 ? void 0 : ref42.active
        }, type, "tablet");
        /**
     * write css
     */ var styles4 = "\n      ".concat(className, "{\n        filter: ").concat(desktopStyles4.filter.filter, ";\n        WebkitFilter: ").concat(desktopStyles4.filter.WebkitFilter, ";\n        background-color: ").concat(desktopStyles4.overlay.backgroundColor, ";\n      }\n      ").concat(hoverStyles4 ? "".concat(className, ":hover{\n            filter: ").concat(hoverStyles4.filter.filter, ";\n            WebkitFilter: ").concat(hoverStyles4.filter.WebkitFilter, ";\n            background-color: ").concat(hoverStyles4.overlay.backgroundColor, ";\n          }") : "", "\n      ").concat(activeStyles4 ? "".concat(className, ".active{\n            filter: ").concat(activeStyles4.filter.filter, ";\n            WebkitFilter: ").concat(activeStyles4.filter.WebkitFilter, ";\n            background-color: ").concat(activeStyles4.overlay.backgroundColor, ";\n          }") : "", "\n\n      ").concat(tabletStyles4 || tabletHoverStyles4 || tabletActiveStyles4 ? "@media all and (max-width: 992px) and (min-width: 767px){\n            ".concat(className, "{\n              filter: ").concat(tabletStyles4.filter, ";\n              background-color: ").concat(tabletStyles4["background-color"], ";\n            }\n            ").concat(tabletHoverStyles4 ? "".concat(className, ":hover{\n              filter: ").concat(tabletHoverStyles4.filter, ";\n              background-color: ").concat(tabletHoverStyles4["background-color"], ";\n                }") : "", "\n            ").concat(tabletActiveStyles4 ? "".concat(className, ".active{\n              filter: ").concat(tabletActiveStyles4.filter, ";\n              background-color: ").concat(tabletActiveStyles4["background-color"], ";\n                }") : "", "\n          }") : "", "\n\n      ").concat(mobileStyles4 || mobileHoverStyles4 || mobileActiveStyles4 ? "@media all and (max-width: 766px){\n            ".concat(className, "{\n              filter: ").concat(mobileStyles4.filter, ";\n              background-color: ").concat(mobileStyles4["background-color"], ";\n            }\n            ").concat(mobileHoverStyles4 ? "".concat(className, ":hover{\n              filter: ").concat(mobileHoverStyles4.filter, ";\n              background-color: ").concat(mobileHoverStyles4["background-color"], ";\n                }") : "", "\n            ").concat(mobileActiveStyles4 ? "".concat(className, ".active{\n              filter: ").concat(mobileActiveStyles4.filter, ";\n              background-color: ").concat(mobileActiveStyles4["background-color"], ";\n                }") : "", "\n          }") : "", "\n      ");
        return styles4;
    }
    if (type === GS_ALIGNMENT) {
        var ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51;
        /**
     * Every property from the json is computed at the head of the page
     * every component writes the specific flexDirection
     */ /**
     * handle api values to css values
     */ var desktopStyles5 = handleAlignment(groupStyle);
        var hoverStyles5 = handleAlignment(groupStyle.behaviour.hover);
        var activeStyles5 = handleAlignment((ref43 = groupStyle.behaviour) === null || ref43 === void 0 ? void 0 : ref43.active);
        // mobile
        var mobileStyles5 = globalStylesResponsiveHandler.responsiveProperties(groupStyle, type, "mobile", {
            alignment: {
                flexDirection: ""
            }
        });
        var mobileHoverStyles5 = globalStylesResponsiveHandler.responsiveProperties({
            mobile: (ref44 = groupStyle.mobile) === null || ref44 === void 0 ? void 0 : (ref45 = ref44.behaviour) === null || ref45 === void 0 ? void 0 : ref45.hover
        }, type, "mobile", {
            alignment: {
                flexDirection: ""
            }
        });
        var mobileActiveStyles5 = globalStylesResponsiveHandler.responsiveProperties({
            mobile: (ref46 = groupStyle.mobile) === null || ref46 === void 0 ? void 0 : (ref47 = ref46.behaviour) === null || ref47 === void 0 ? void 0 : ref47.active
        }, type, "mobile", {
            alignment: {
                flexDirection: ""
            }
        });
        // tablet
        var tabletStyles5 = globalStylesResponsiveHandler.responsiveProperties(groupStyle, type, "tablet", {
            alignment: {
                flexDirection: ""
            }
        });
        var tabletHoverStyles5 = globalStylesResponsiveHandler.responsiveProperties({
            tablet: (ref48 = groupStyle.tablet) === null || ref48 === void 0 ? void 0 : (ref49 = ref48.behaviour) === null || ref49 === void 0 ? void 0 : ref49.hover
        }, type, "tablet", {
            alignment: {
                flexDirection: ""
            }
        });
        var tabletActiveStyles5 = globalStylesResponsiveHandler.responsiveProperties({
            tablet: (ref50 = groupStyle.tablet) === null || ref50 === void 0 ? void 0 : (ref51 = ref50.behaviour) === null || ref51 === void 0 ? void 0 : ref51.active
        }, type, "tablet", {
            alignment: {
                flexDirection: ""
            }
        });
        /**
     * write css
     * Both alignSelf and flexDirection are written in each component
     */ var styles5 = "\n      ".concat(className, "{\n        justify-content: ").concat(desktopStyles5.justifyContent, ";\n        align-items: ").concat(desktopStyles5.alignItems, ";\n        display: ").concat(desktopStyles5.display, ";\n      }\n      ").concat(hoverStyles5 ? "".concat(className, ":hover{\n            justify-content: ").concat(hoverStyles5.justifyContent, ";\n            align-items: ").concat(hoverStyles5.alignItems, ";\n            display: ").concat(hoverStyles5.display, ";\n          }") : "", "\n      ").concat(activeStyles5 ? "".concat(className, ".active{\n            justify-content: ").concat(activeStyles5.justifyContent, ";\n            align-items: ").concat(activeStyles5.alignItems, ";\n            display: ").concat(activeStyles5.display, ";\n          }") : "", "\n\n      ").concat(tabletStyles5 || tabletHoverStyles5 || tabletActiveStyles5 ? "@media all and (max-width: 992px) and (min-width: 767px){\n            ".concat(className, "{\n              justify-content: ").concat(tabletStyles5["justify-content"], ";\n              align-items: ").concat(tabletStyles5["align-items"], ";\n              display: ").concat(tabletStyles5.display, ";\n            }\n            ").concat(tabletHoverStyles5 ? "".concat(className, ":hover{\n              justify-content: ").concat(tabletHoverStyles5["justify-content"], ";\n              align-items: ").concat(tabletHoverStyles5["align-items"], ";\n              display: ").concat(tabletHoverStyles5.display, ";\n                }") : "", "\n            ").concat(tabletActiveStyles5 ? "".concat(className, ".active{\n              justify-content: ").concat(tabletActiveStyles5["justify-content"], ";\n              align-items: ").concat(tabletActiveStyles5["align-items"], ";\n              display: ").concat(tabletActiveStyles5.display, ";\n                }") : "", "\n          }") : "", "\n\n      ").concat(mobileStyles5 || mobileHoverStyles5 || mobileActiveStyles5 ? "@media all and (max-width: 766px){\n            ".concat(className, "{\n              justify-content: ").concat(mobileStyles5["justify-content"], ";\n              align-items: ").concat(mobileStyles5["align-items"], ";\n              display: ").concat(mobileStyles5.display, ";\n            }\n            ").concat(mobileHoverStyles5 ? "".concat(className, ":hover{\n              justify-content: ").concat(mobileHoverStyles5["justify-content"], ";\n              align-items: ").concat(mobileHoverStyles5["align-items"], ";\n              display: ").concat(mobileHoverStyles5.display, ";\n                }") : "", "\n            ").concat(mobileActiveStyles5 ? "".concat(className, ".active{\n              justify-content: ").concat(mobileActiveStyles5["justify-content"], ";\n              align-items: ").concat(mobileActiveStyles5["align-items"], ";\n              display: ").concat(mobileActiveStyles5.display, ";\n                }") : "", "\n          }") : "", "\n      ");
        return styles5;
    }
}

// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(25934);
;// CONCATENATED MODULE: ./src/modules/shared-modules/globalStyles/globalStylesUtils.tsx











var GlobalStylesUtils = /*#__PURE__*/ function() {
    "use strict";
    function GlobalStylesUtils() {
        (0,src_class_call_check/* default */.Z)(this, GlobalStylesUtils);
    }
    GlobalStylesUtils.hasGlobalStyleAttached = function hasGlobalStyleAttached(selectedObject, bobKey, type) {
        var ref;
        var bob = selectedObject.styles.bobs[bobKey];
        return (ref = bob.nGlobalStyles) === null || ref === void 0 ? void 0 : ref[type];
    };
    /**
   * handle data structure for controller
   * @returns
   */ GlobalStylesUtils.handleGlobalStyleToEdit = function handleGlobalStyleToEdit(type, styles, responsiveBreakpoint) {
        if (!styles) return {};
        if (type === GS_SHADOW) {
            return {
                shadowOffsetH: getValue(responsiveBreakpoint, styles, "offsetH"),
                shadowOffsetV: getValue(responsiveBreakpoint, styles, "offsetV"),
                shadowBlur: getValue(responsiveBreakpoint, styles, "blur"),
                shadowSpread: getValue(responsiveBreakpoint, styles, "spread"),
                shadowColor: getValue(responsiveBreakpoint, styles, "color"),
                shadowInset: getValue(responsiveBreakpoint, styles, "inset")
            };
        }
        if (type === GS_BOUNDARY) {
            return {
                marginRight: getValue(responsiveBreakpoint, styles.margin, "right"),
                marginBottom: getValue(responsiveBreakpoint, styles.margin, "bottom"),
                marginLeft: getValue(responsiveBreakpoint, styles.margin, "left"),
                marginTop: getValue(responsiveBreakpoint, styles.margin, "top"),
                paddingTop: getValue(responsiveBreakpoint, styles.padding, "top"),
                paddingRight: getValue(responsiveBreakpoint, styles.padding, "right"),
                paddingBottom: getValue(responsiveBreakpoint, styles.padding, "bottom"),
                paddingLeft: getValue(responsiveBreakpoint, styles.padding, "left")
            };
        }
        if (type === GS_SCREEN_FLOW) {
            return {
                wrap: getValue(responsiveBreakpoint, styles, "wrap")
            };
        }
        if (type === GS_HEIGHT) {
            return {
                height: getValue(responsiveBreakpoint, styles, "height"),
                heightUnit: getValue(responsiveBreakpoint, styles, "heightUnit")
            };
        }
        if (type === GS_BORDER_RADIUS) {
            return {
                radiusBottomLeft: getValue(responsiveBreakpoint, styles, "bottomLeft"),
                radiusBottomRight: getValue(responsiveBreakpoint, styles, "bottomRight"),
                radiusTopLeft: getValue(responsiveBreakpoint, styles, "topLeft"),
                radiusTopRight: getValue(responsiveBreakpoint, styles, "topRight")
            };
        }
        if (type === GS_BORDER) {
            return {
                borderTopStyle: getValue(responsiveBreakpoint, styles, "topStyle"),
                borderTopWidth: getValue(responsiveBreakpoint, styles, "topWidth"),
                borderTopColor: getValue(responsiveBreakpoint, styles, "topColor"),
                borderTopEnable: getValue(responsiveBreakpoint, styles, "topEnable"),
                borderRightStyle: getValue(responsiveBreakpoint, styles, "rightStyle"),
                borderRightWidth: getValue(responsiveBreakpoint, styles, "rightWidth"),
                borderRightColor: getValue(responsiveBreakpoint, styles, "rightColor"),
                borderRightEnable: getValue(responsiveBreakpoint, styles, "rightEnable"),
                borderBottomStyle: getValue(responsiveBreakpoint, styles, "bottomStyle"),
                borderBottomWidth: getValue(responsiveBreakpoint, styles, "bottomWidth"),
                borderBottomColor: getValue(responsiveBreakpoint, styles, "bottomColor"),
                borderBottomEnable: getValue(responsiveBreakpoint, styles, "bottomEnable"),
                borderLeftStyle: getValue(responsiveBreakpoint, styles, "leftStyle"),
                borderLeftWidth: getValue(responsiveBreakpoint, styles, "leftWidth"),
                borderLeftColor: getValue(responsiveBreakpoint, styles, "leftColor"),
                borderLeftEnable: getValue(responsiveBreakpoint, styles, "leftEnable")
            };
        }
        if (type === GS_BG_COLORS) {
            return {
                isGradient: getValue(responsiveBreakpoint, styles, "colorsIsGradient"),
                colorFirst: getValue(responsiveBreakpoint, styles, "colorsColorFirst"),
                colorSecond: getValue(responsiveBreakpoint, styles, "colorsColorSecond"),
                gradientAngle: getValue(responsiveBreakpoint, styles, "colorsGradientAngle")
            };
        }
        if (type === GS_COLUMNS) {
            return {
                columns: getValue(responsiveBreakpoint, styles, "columns"),
                gutters: getValue(responsiveBreakpoint, styles, "gutters"),
                newBehaviour: getValue(responsiveBreakpoint, styles, "newBehaviour")
            };
        }
        if (type === GS_ALIGNMENT) {
            return {
                horizontal: getValue(responsiveBreakpoint, styles, "horizontal"),
                vertical: getValue(responsiveBreakpoint, styles, "vertical")
            };
        }
        if (type === GS_FILTER) {
            return {
                saturate: getValue(responsiveBreakpoint, styles, "saturate"),
                brightness: getValue(responsiveBreakpoint, styles, "brightness"),
                contrast: getValue(responsiveBreakpoint, styles, "contrast"),
                blur: getValue(responsiveBreakpoint, styles, "blur"),
                sepia: getValue(responsiveBreakpoint, styles, "sepia"),
                invert: getValue(responsiveBreakpoint, styles, "invert"),
                hueRotate: getValue(responsiveBreakpoint, styles, "hueRotate"),
                grayscale: getValue(responsiveBreakpoint, styles, "grayscale"),
                opacity: getValue(responsiveBreakpoint, styles, "opacity"),
                shadow: getValue(responsiveBreakpoint, styles, "shadow"),
                overlay: getValue(responsiveBreakpoint, styles, "overlay")
            };
        }
        if (type === GS_TEXT) {
            return {
                lineHeight: getValue(responsiveBreakpoint, styles, "lineHeight"),
                size: getValue(responsiveBreakpoint, styles, "size"),
                letterSpacing: getValue(responsiveBreakpoint, styles, "letterSpacing"),
                weight: getValue(responsiveBreakpoint, styles, "weight"),
                fontType: getValue(responsiveBreakpoint, styles, "fontType"),
                family: getValue(responsiveBreakpoint, styles, "family")
            };
        }
        if (type === GS_TEXT_COLOR) {
            return {
                color: getValue(responsiveBreakpoint, styles, "color")
            };
        }
        if (type === GS_ICON) {
            return {
                size: getValue(responsiveBreakpoint, styles, "size"),
                selectedIcon: getValue(responsiveBreakpoint, styles, "selectedIcon"),
                icon: getValue(responsiveBreakpoint, styles, "icon"),
                iconType: getValue(responsiveBreakpoint, styles, "iconType")
            };
        }
        return undefined;
    };
    /**
   * handle data structure for controller
   * @returns
   */ GlobalStylesUtils.getStylesByType = function getStylesByType(type, styles) {
        if (!styles) return {};
        if (type === GS_SHADOW) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35;
            return {
                offsetH: styles.shadowOffsetH,
                offsetV: styles.shadowOffsetV,
                blur: styles.shadowBlur,
                spread: styles.shadowSpread,
                color: styles.shadowColor,
                inset: styles.shadowInset,
                mobile: {
                    offsetH: this.null2undefined(styles.mobile.shadowOffsetH),
                    offsetV: this.null2undefined(styles.mobile.shadowOffsetV),
                    blur: this.null2undefined(styles.mobile.shadowBlur),
                    spread: this.null2undefined(styles.mobile.shadowSpread),
                    color: this.null2undefined(styles.mobile.shadowColor),
                    inset: this.null2undefined(styles.mobile.shadowInset),
                    behaviour: {
                        active: {
                            offsetH: this.null2undefined((ref = styles.mobile.active) === null || ref === void 0 ? void 0 : ref.shadowOffsetH),
                            offsetV: this.null2undefined((ref1 = styles.mobile.active) === null || ref1 === void 0 ? void 0 : ref1.shadowOffsetV),
                            blur: this.null2undefined((ref2 = styles.mobile.active) === null || ref2 === void 0 ? void 0 : ref2.shadowBlur),
                            spread: this.null2undefined((ref3 = styles.mobile.active) === null || ref3 === void 0 ? void 0 : ref3.shadowSpread),
                            color: this.null2undefined((ref4 = styles.mobile.active) === null || ref4 === void 0 ? void 0 : ref4.shadowColor),
                            inset: this.null2undefined((ref5 = styles.mobile.active) === null || ref5 === void 0 ? void 0 : ref5.shadowInset)
                        },
                        hover: {
                            offsetH: this.null2undefined((ref6 = styles.mobile.hover) === null || ref6 === void 0 ? void 0 : ref6.shadowOffsetH),
                            offsetV: this.null2undefined((ref7 = styles.mobile.hover) === null || ref7 === void 0 ? void 0 : ref7.shadowOffsetV),
                            blur: this.null2undefined((ref8 = styles.mobile.hover) === null || ref8 === void 0 ? void 0 : ref8.shadowBlur),
                            spread: this.null2undefined((ref9 = styles.mobile.hover) === null || ref9 === void 0 ? void 0 : ref9.shadowSpread),
                            color: this.null2undefined((ref10 = styles.mobile.hover) === null || ref10 === void 0 ? void 0 : ref10.shadowColor),
                            inset: this.null2undefined((ref11 = styles.mobile.hover) === null || ref11 === void 0 ? void 0 : ref11.shadowInset)
                        }
                    }
                },
                tablet: {
                    offsetH: this.null2undefined(styles.tablet.shadowOffsetH),
                    offsetV: this.null2undefined(styles.tablet.shadowOffsetV),
                    blur: this.null2undefined(styles.tablet.shadowBlur),
                    spread: this.null2undefined(styles.tablet.shadowSpread),
                    color: this.null2undefined(styles.tablet.shadowColor),
                    inset: this.null2undefined(styles.tablet.shadowInset),
                    behaviour: {
                        active: {
                            offsetH: this.null2undefined((ref12 = styles.tablet.active) === null || ref12 === void 0 ? void 0 : ref12.shadowOffsetH),
                            offsetV: this.null2undefined((ref13 = styles.tablet.active) === null || ref13 === void 0 ? void 0 : ref13.shadowOffsetV),
                            blur: this.null2undefined((ref14 = styles.tablet.active) === null || ref14 === void 0 ? void 0 : ref14.shadowBlur),
                            spread: this.null2undefined((ref15 = styles.tablet.active) === null || ref15 === void 0 ? void 0 : ref15.shadowSpread),
                            color: this.null2undefined((ref16 = styles.tablet.active) === null || ref16 === void 0 ? void 0 : ref16.shadowColor),
                            inset: this.null2undefined((ref17 = styles.tablet.active) === null || ref17 === void 0 ? void 0 : ref17.shadowInset)
                        },
                        hover: {
                            offsetH: this.null2undefined((ref18 = styles.tablet.hover) === null || ref18 === void 0 ? void 0 : ref18.shadowOffsetH),
                            offsetV: this.null2undefined((ref19 = styles.tablet.hover) === null || ref19 === void 0 ? void 0 : ref19.shadowOffsetV),
                            blur: this.null2undefined((ref20 = styles.tablet.hover) === null || ref20 === void 0 ? void 0 : ref20.shadowBlur),
                            spread: this.null2undefined((ref21 = styles.tablet.hover) === null || ref21 === void 0 ? void 0 : ref21.shadowSpread),
                            color: this.null2undefined((ref22 = styles.tablet.hover) === null || ref22 === void 0 ? void 0 : ref22.shadowColor),
                            inset: this.null2undefined((ref23 = styles.tablet.hover) === null || ref23 === void 0 ? void 0 : ref23.shadowInset)
                        }
                    }
                },
                behaviour: {
                    active: {
                        offsetH: this.null2undefined((ref24 = styles.active) === null || ref24 === void 0 ? void 0 : ref24.shadowOffsetH),
                        offsetV: this.null2undefined((ref25 = styles.active) === null || ref25 === void 0 ? void 0 : ref25.shadowOffsetV),
                        blur: this.null2undefined((ref26 = styles.active) === null || ref26 === void 0 ? void 0 : ref26.shadowBlur),
                        spread: this.null2undefined((ref27 = styles.active) === null || ref27 === void 0 ? void 0 : ref27.shadowSpread),
                        color: this.null2undefined((ref28 = styles.active) === null || ref28 === void 0 ? void 0 : ref28.shadowColor),
                        inset: this.null2undefined((ref29 = styles.active) === null || ref29 === void 0 ? void 0 : ref29.shadowInset)
                    },
                    hover: {
                        offsetH: this.null2undefined((ref30 = styles.hover) === null || ref30 === void 0 ? void 0 : ref30.shadowOffsetH),
                        offsetV: this.null2undefined((ref31 = styles.hover) === null || ref31 === void 0 ? void 0 : ref31.shadowOffsetV),
                        blur: this.null2undefined((ref32 = styles.hover) === null || ref32 === void 0 ? void 0 : ref32.shadowBlur),
                        spread: this.null2undefined((ref33 = styles.hover) === null || ref33 === void 0 ? void 0 : ref33.shadowSpread),
                        color: this.null2undefined((ref34 = styles.hover) === null || ref34 === void 0 ? void 0 : ref34.shadowColor),
                        inset: this.null2undefined((ref35 = styles.hover) === null || ref35 === void 0 ? void 0 : ref35.shadowInset)
                    }
                }
            };
        }
        if (type === GS_BOUNDARY) {
            var ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51, ref52, ref53, ref54, ref55, ref56, ref57, ref58, ref59, ref60, ref61, ref62, ref63, ref64, ref65, ref66, ref67, ref68, ref69, ref70, ref71, ref72, ref73, ref74, ref75, ref76, ref77, ref78, ref79, ref80, ref81, ref82, ref83;
            return {
                margin: {
                    top: styles.marginTop,
                    bottom: styles.marginBottom,
                    left: styles.marginLeft,
                    right: styles.marginRight
                },
                padding: {
                    top: styles.paddingTop,
                    bottom: styles.paddingBottom,
                    left: styles.paddingLeft,
                    right: styles.paddingRight
                },
                mobile: {
                    margin: {
                        top: this.null2undefined(styles.mobile.marginTop),
                        bottom: this.null2undefined(styles.mobile.marginBottom),
                        left: this.null2undefined(styles.mobile.marginLeft),
                        right: this.null2undefined(styles.mobile.marginRight)
                    },
                    padding: {
                        top: this.null2undefined(styles.mobile.paddingTop),
                        bottom: this.null2undefined(styles.mobile.paddingBottom),
                        left: this.null2undefined(styles.mobile.paddingLeft),
                        right: this.null2undefined(styles.mobile.paddingRight)
                    },
                    behaviour: {
                        active: {
                            margin: {
                                top: this.null2undefined((ref36 = styles.mobile.active) === null || ref36 === void 0 ? void 0 : ref36.marginTop),
                                bottom: this.null2undefined((ref37 = styles.mobile.active) === null || ref37 === void 0 ? void 0 : ref37.marginBottom),
                                left: this.null2undefined((ref38 = styles.mobile.active) === null || ref38 === void 0 ? void 0 : ref38.marginLeft),
                                right: this.null2undefined((ref39 = styles.mobile.active) === null || ref39 === void 0 ? void 0 : ref39.marginRight)
                            },
                            padding: {
                                top: this.null2undefined((ref40 = styles.mobile.active) === null || ref40 === void 0 ? void 0 : ref40.paddingTop),
                                bottom: this.null2undefined((ref41 = styles.mobile.active) === null || ref41 === void 0 ? void 0 : ref41.paddingBottom),
                                left: this.null2undefined((ref42 = styles.mobile.active) === null || ref42 === void 0 ? void 0 : ref42.paddingLeft),
                                right: this.null2undefined((ref43 = styles.mobile.active) === null || ref43 === void 0 ? void 0 : ref43.paddingRight)
                            }
                        },
                        hover: {
                            margin: {
                                top: this.null2undefined((ref44 = styles.mobile.hover) === null || ref44 === void 0 ? void 0 : ref44.marginTop),
                                bottom: this.null2undefined((ref45 = styles.mobile.hover) === null || ref45 === void 0 ? void 0 : ref45.marginBottom),
                                left: this.null2undefined((ref46 = styles.mobile.hover) === null || ref46 === void 0 ? void 0 : ref46.marginLeft),
                                right: this.null2undefined((ref47 = styles.mobile.hover) === null || ref47 === void 0 ? void 0 : ref47.marginRight)
                            },
                            padding: {
                                top: this.null2undefined((ref48 = styles.mobile.hover) === null || ref48 === void 0 ? void 0 : ref48.paddingTop),
                                bottom: this.null2undefined((ref49 = styles.mobile.hover) === null || ref49 === void 0 ? void 0 : ref49.paddingBottom),
                                left: this.null2undefined((ref50 = styles.mobile.hover) === null || ref50 === void 0 ? void 0 : ref50.paddingLeft),
                                right: this.null2undefined((ref51 = styles.mobile.hover) === null || ref51 === void 0 ? void 0 : ref51.paddingRight)
                            }
                        }
                    }
                },
                tablet: {
                    margin: {
                        top: this.null2undefined(styles.tablet.marginTop),
                        bottom: this.null2undefined(styles.tablet.marginBottom),
                        left: this.null2undefined(styles.tablet.marginLeft),
                        right: this.null2undefined(styles.tablet.marginRight)
                    },
                    padding: {
                        top: this.null2undefined(styles.tablet.paddingTop),
                        bottom: this.null2undefined(styles.tablet.paddingBottom),
                        left: this.null2undefined(styles.tablet.paddingLeft),
                        right: this.null2undefined(styles.tablet.paddingRight)
                    },
                    behaviour: {
                        active: {
                            margin: {
                                top: this.null2undefined((ref52 = styles.tablet.active) === null || ref52 === void 0 ? void 0 : ref52.marginTop),
                                bottom: this.null2undefined((ref53 = styles.tablet.active) === null || ref53 === void 0 ? void 0 : ref53.marginBottom),
                                left: this.null2undefined((ref54 = styles.tablet.active) === null || ref54 === void 0 ? void 0 : ref54.marginLeft),
                                right: this.null2undefined((ref55 = styles.tablet.active) === null || ref55 === void 0 ? void 0 : ref55.marginRight)
                            },
                            padding: {
                                top: this.null2undefined((ref56 = styles.tablet.active) === null || ref56 === void 0 ? void 0 : ref56.paddingTop),
                                bottom: this.null2undefined((ref57 = styles.tablet.active) === null || ref57 === void 0 ? void 0 : ref57.paddingBottom),
                                left: this.null2undefined((ref58 = styles.tablet.active) === null || ref58 === void 0 ? void 0 : ref58.paddingLeft),
                                right: this.null2undefined((ref59 = styles.tablet.active) === null || ref59 === void 0 ? void 0 : ref59.paddingRight)
                            }
                        },
                        hover: {
                            margin: {
                                top: this.null2undefined((ref60 = styles.tablet.hover) === null || ref60 === void 0 ? void 0 : ref60.marginTop),
                                bottom: this.null2undefined((ref61 = styles.tablet.hover) === null || ref61 === void 0 ? void 0 : ref61.marginBottom),
                                left: this.null2undefined((ref62 = styles.tablet.hover) === null || ref62 === void 0 ? void 0 : ref62.marginLeft),
                                right: this.null2undefined((ref63 = styles.tablet.hover) === null || ref63 === void 0 ? void 0 : ref63.marginRight)
                            },
                            padding: {
                                top: this.null2undefined((ref64 = styles.tablet.hover) === null || ref64 === void 0 ? void 0 : ref64.paddingTop),
                                bottom: this.null2undefined((ref65 = styles.tablet.hover) === null || ref65 === void 0 ? void 0 : ref65.paddingBottom),
                                left: this.null2undefined((ref66 = styles.tablet.hover) === null || ref66 === void 0 ? void 0 : ref66.paddingLeft),
                                right: this.null2undefined((ref67 = styles.tablet.hover) === null || ref67 === void 0 ? void 0 : ref67.paddingRight)
                            }
                        }
                    }
                },
                behaviour: {
                    active: {
                        margin: {
                            top: this.null2undefined((ref68 = styles.active) === null || ref68 === void 0 ? void 0 : ref68.marginTop),
                            bottom: this.null2undefined((ref69 = styles.active) === null || ref69 === void 0 ? void 0 : ref69.marginBottom),
                            left: this.null2undefined((ref70 = styles.active) === null || ref70 === void 0 ? void 0 : ref70.marginLeft),
                            right: this.null2undefined((ref71 = styles.active) === null || ref71 === void 0 ? void 0 : ref71.marginRight)
                        },
                        padding: {
                            top: this.null2undefined((ref72 = styles.active) === null || ref72 === void 0 ? void 0 : ref72.paddingTop),
                            bottom: this.null2undefined((ref73 = styles.active) === null || ref73 === void 0 ? void 0 : ref73.paddingBottom),
                            left: this.null2undefined((ref74 = styles.active) === null || ref74 === void 0 ? void 0 : ref74.paddingLeft),
                            right: this.null2undefined((ref75 = styles.active) === null || ref75 === void 0 ? void 0 : ref75.paddingRight)
                        }
                    },
                    hover: {
                        margin: {
                            top: this.null2undefined((ref76 = styles.hover) === null || ref76 === void 0 ? void 0 : ref76.marginTop),
                            bottom: this.null2undefined((ref77 = styles.hover) === null || ref77 === void 0 ? void 0 : ref77.marginBottom),
                            left: this.null2undefined((ref78 = styles.hover) === null || ref78 === void 0 ? void 0 : ref78.marginLeft),
                            right: this.null2undefined((ref79 = styles.hover) === null || ref79 === void 0 ? void 0 : ref79.marginRight)
                        },
                        padding: {
                            top: this.null2undefined((ref80 = styles.hover) === null || ref80 === void 0 ? void 0 : ref80.paddingTop),
                            bottom: this.null2undefined((ref81 = styles.hover) === null || ref81 === void 0 ? void 0 : ref81.paddingBottom),
                            left: this.null2undefined((ref82 = styles.hover) === null || ref82 === void 0 ? void 0 : ref82.paddingLeft),
                            right: this.null2undefined((ref83 = styles.hover) === null || ref83 === void 0 ? void 0 : ref83.paddingRight)
                        }
                    }
                }
            };
        }
        if (type === GS_TEXT) {
            var ref84, ref85, ref86, ref87, ref88, ref89, ref90, ref91, ref92, ref93, ref94, ref95, ref96, ref97, ref98, ref99, ref100, ref101, ref102, ref103, ref104, ref105, ref106, ref107, ref108, ref109, ref110, ref111, ref112, ref113, ref114, ref115, ref116, ref117, ref118, ref119;
            return {
                fontType: styles.fontType,
                fontFamily: styles.family,
                fontWeight: styles.weight,
                fontSize: styles.size,
                letterSpacing: styles.letterSpacing,
                lineHeight: styles.lineHeight,
                mobile: {
                    fontType: this.null2undefined(styles.mobile.fontType),
                    fontFamily: this.null2undefined(styles.mobile.family),
                    fontWeight: this.null2undefined(styles.mobile.weight),
                    fontSize: this.null2undefined(styles.mobile.size),
                    letterSpacing: this.null2undefined(styles.mobile.letterSpacing),
                    lineHeight: this.null2undefined(styles.mobile.lineHeight),
                    behaviour: {
                        active: {
                            fontType: this.null2undefined((ref84 = styles.mobile.active) === null || ref84 === void 0 ? void 0 : ref84.fontType),
                            fontFamily: this.null2undefined((ref85 = styles.mobile.active) === null || ref85 === void 0 ? void 0 : ref85.family),
                            fontWeight: this.null2undefined((ref86 = styles.mobile.active) === null || ref86 === void 0 ? void 0 : ref86.weight),
                            fontSize: this.null2undefined((ref87 = styles.mobile.active) === null || ref87 === void 0 ? void 0 : ref87.size),
                            letterSpacing: this.null2undefined((ref88 = styles.mobile.active) === null || ref88 === void 0 ? void 0 : ref88.letterSpacing),
                            lineHeight: this.null2undefined((ref89 = styles.mobile.active) === null || ref89 === void 0 ? void 0 : ref89.lineHeight)
                        },
                        hover: {
                            fontType: this.null2undefined((ref90 = styles.mobile.hover) === null || ref90 === void 0 ? void 0 : ref90.fontType),
                            fontFamily: this.null2undefined((ref91 = styles.mobile.hover) === null || ref91 === void 0 ? void 0 : ref91.family),
                            fontWeight: this.null2undefined((ref92 = styles.mobile.hover) === null || ref92 === void 0 ? void 0 : ref92.weight),
                            fontSize: this.null2undefined((ref93 = styles.mobile.hover) === null || ref93 === void 0 ? void 0 : ref93.size),
                            letterSpacing: this.null2undefined((ref94 = styles.mobile.hover) === null || ref94 === void 0 ? void 0 : ref94.letterSpacing),
                            lineHeight: this.null2undefined((ref95 = styles.mobile.hover) === null || ref95 === void 0 ? void 0 : ref95.lineHeight)
                        }
                    }
                },
                tablet: {
                    fontType: this.null2undefined(styles.tablet.fontType),
                    fontFamily: this.null2undefined(styles.tablet.family),
                    fontWeight: this.null2undefined(styles.tablet.weight),
                    fontSize: this.null2undefined(styles.tablet.size),
                    letterSpacing: this.null2undefined(styles.tablet.letterSpacing),
                    lineHeight: this.null2undefined(styles.tablet.lineHeight),
                    behaviour: {
                        active: {
                            fontType: this.null2undefined((ref96 = styles.tablet.active) === null || ref96 === void 0 ? void 0 : ref96.fontType),
                            fontFamily: this.null2undefined((ref97 = styles.tablet.active) === null || ref97 === void 0 ? void 0 : ref97.family),
                            fontWeight: this.null2undefined((ref98 = styles.tablet.active) === null || ref98 === void 0 ? void 0 : ref98.weight),
                            fontSize: this.null2undefined((ref99 = styles.tablet.active) === null || ref99 === void 0 ? void 0 : ref99.size),
                            letterSpacing: this.null2undefined((ref100 = styles.tablet.active) === null || ref100 === void 0 ? void 0 : ref100.letterSpacing),
                            lineHeight: this.null2undefined((ref101 = styles.tablet.active) === null || ref101 === void 0 ? void 0 : ref101.lineHeight)
                        },
                        hover: {
                            fontType: this.null2undefined((ref102 = styles.tablet.hover) === null || ref102 === void 0 ? void 0 : ref102.fontType),
                            fontFamily: this.null2undefined((ref103 = styles.tablet.hover) === null || ref103 === void 0 ? void 0 : ref103.family),
                            fontWeight: this.null2undefined((ref104 = styles.tablet.hover) === null || ref104 === void 0 ? void 0 : ref104.weight),
                            fontSize: this.null2undefined((ref105 = styles.tablet.hover) === null || ref105 === void 0 ? void 0 : ref105.size),
                            letterSpacing: this.null2undefined((ref106 = styles.tablet.hover) === null || ref106 === void 0 ? void 0 : ref106.letterSpacing),
                            lineHeight: this.null2undefined((ref107 = styles.tablet.hover) === null || ref107 === void 0 ? void 0 : ref107.lineHeight)
                        }
                    }
                },
                behaviour: {
                    active: {
                        fontType: this.null2undefined((ref108 = styles.active) === null || ref108 === void 0 ? void 0 : ref108.fontType),
                        fontFamily: this.null2undefined((ref109 = styles.active) === null || ref109 === void 0 ? void 0 : ref109.family),
                        fontWeight: this.null2undefined((ref110 = styles.active) === null || ref110 === void 0 ? void 0 : ref110.weight),
                        fontSize: this.null2undefined((ref111 = styles.active) === null || ref111 === void 0 ? void 0 : ref111.size),
                        letterSpacing: this.null2undefined((ref112 = styles.active) === null || ref112 === void 0 ? void 0 : ref112.letterSpacing),
                        lineHeight: this.null2undefined((ref113 = styles.active) === null || ref113 === void 0 ? void 0 : ref113.lineHeight)
                    },
                    hover: {
                        fontType: this.null2undefined((ref114 = styles.hover) === null || ref114 === void 0 ? void 0 : ref114.fontType),
                        fontFamily: this.null2undefined((ref115 = styles.hover) === null || ref115 === void 0 ? void 0 : ref115.family),
                        fontWeight: this.null2undefined((ref116 = styles.hover) === null || ref116 === void 0 ? void 0 : ref116.weight),
                        fontSize: this.null2undefined((ref117 = styles.hover) === null || ref117 === void 0 ? void 0 : ref117.size),
                        letterSpacing: this.null2undefined((ref118 = styles.hover) === null || ref118 === void 0 ? void 0 : ref118.letterSpacing),
                        lineHeight: this.null2undefined((ref119 = styles.hover) === null || ref119 === void 0 ? void 0 : ref119.lineHeight)
                    }
                }
            };
        }
        console.warn("No export data for type ".concat(type));
        return {};
    };
    /**
   *
   * @param value
   * @returns
   * Dirty fix for nulls
   */ GlobalStylesUtils.null2undefined = function null2undefined(value) {
        if (value === null) return undefined;
        return value;
    };
    /**
   * idEstilo-controllador-brk-behaviour
   *
   * @param pageGlobalStyles
   * @returns
   */ GlobalStylesUtils.handleStyles = function handleStyles(pageGlobalStyles, stylesheetLabels, expManager) {
        var styles = "";
        if (!pageGlobalStyles) return styles;
        for(var key in pageGlobalStyles){
            var globalStyle = pageGlobalStyles[key];
            styles += "".concat(handleStylesGroupCss(globalStyle, stylesheetLabels, expManager));
        }
        return styles;
    };
    /**
   * idEstilo-controllador-brk-behaviour
   *
   * @param pageGlobalStyles
   * @returns
   */ GlobalStylesUtils.handleClassName = function handleClassName(pageGlobalStyles, template, propsToInclude, extraClass, classNameSufix) {
        var attachedGlobalStyles = template.nGlobalStyles;
        var className = "";
        // no globalstyles or attached exist
        if (!pageGlobalStyles || !attachedGlobalStyles) return className;
        // handle attach global styles classnames
        for(var key in attachedGlobalStyles){
            var globalStyle = pageGlobalStyles[attachedGlobalStyles[key]];
            var styleProp = handleGroupKey(globalStyle.type);
            if (!propsToInclude) {
                className = this.writeClassName(className, template, globalStyle, styleProp, extraClass, classNameSufix);
            } else if (propsToInclude.includes(globalStyle.type)) {
                className = this.writeClassName(className, template, globalStyle, styleProp, extraClass, classNameSufix);
            }
        }
        return className;
    };
    /**
   * idEstilo-controllador-brk-behaviour
   *
   * @param pageGlobalStyles
   * @returns
   */ GlobalStylesUtils.handleClassNameV2 = function handleClassNameV2(pageGlobalStyles, template, extraClass, classNameSufix) {
        var attachedGlobalStyles = template.nGlobalStyles;
        var className = "";
        // no globalstyles or attached exist
        if (!pageGlobalStyles || !attachedGlobalStyles) return className;
        // handle attach global styles classnames
        for(var key in attachedGlobalStyles){
            var globalStyle = pageGlobalStyles[attachedGlobalStyles[key]];
            className = this.writeClassNameV2(className, globalStyle, extraClass, classNameSufix);
        }
        return className;
    };
    GlobalStylesUtils.writeClassName = function writeClassName(className, template, globalStyle, styleProp, extraClass, classNameSufix) {
        //TODO: better check for gs that doesnt use enable
        if (globalStyle.type === GS_TEXT) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
            className += " ".concat(globalStyle.type, "-").concat(globalStyle.uuid);
            // write classNameSufix
            if (classNameSufix && GS_TEXT in classNameSufix) {
                className += classNameSufix[GS_TEXT];
            }
            /**
       * write disable state class
       * hover state classes
       */ // desktop
            var enableHover = ((ref = template.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref.hover) === null || ref1 === void 0 ? void 0 : ref1.enable) || false;
            if (enableHover) {
                className += " ngsHoverState";
            }
            // tablet
            var enableTabletHover = typeof ((ref2 = template.tablet) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.behaviour) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.hover) === null || ref4 === void 0 ? void 0 : ref4.enable) === "boolean" ? template.tablet.behaviour.hover.enable : enableHover;
            if (enableTabletHover === true) {
                className += " ngsTabletHoverState";
            }
            // mobile
            var enableMobileHover = typeof ((ref5 = template.mobile) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.hover) === null || ref7 === void 0 ? void 0 : ref7.enable) === "boolean" ? template.mobile.behaviour.hover.enable : enableHover;
            if (enableMobileHover === true) {
                className += " ngsMobileHoverState";
            }
            /**
       * write disable state class
       * active state classes
       */ // desktop
            var enableActive = ((ref8 = template.behaviour) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.active) === null || ref9 === void 0 ? void 0 : ref9.enable) || false;
            if (enableActive) {
                className += " ngsActiveState";
            }
            // tablet
            var enableTabletActive = typeof ((ref10 = template.tablet) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.behaviour) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.active) === null || ref12 === void 0 ? void 0 : ref12.enable) === "boolean" ? template.tablet.behaviour.active.enable : enableActive;
            if (enableTabletActive === true) {
                className += " ngsTabletActiveState";
            }
            // mobile
            var enableMobileActive = typeof ((ref13 = template.mobile) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.behaviour) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.active) === null || ref15 === void 0 ? void 0 : ref15.enable) === "boolean" ? template.mobile.behaviour.active.enable : enableActive;
            if (enableMobileActive === true) {
                className += " ngsMobileActiveState";
            }
        } else if (utils_objValueExists(template[styleProp], "enable") && template[styleProp].enable) {
            var ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31;
            className += " ".concat(globalStyle.type, "-").concat(globalStyle.uuid);
            if (globalStyle.type === GS_SHADOW) {
                // write extra class
                if (extraClass) className += extraClass;
            }
            // write classNameSufix
            if (classNameSufix && globalStyle.type in classNameSufix) {
                className += classNameSufix[globalStyle.type] // TODO: globalStyle type must be written, currently is any
                ;
            }
            /**
       * write disable state class
       * hover state classes
       */ // desktop
            var enableHover1 = ((ref16 = template.behaviour) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.hover) === null || ref17 === void 0 ? void 0 : ref17.enable) || false;
            if (enableHover1) {
                className += " ngsHoverState";
            }
            // tablet
            var enableTabletHover1 = typeof ((ref18 = template.tablet) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.behaviour) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.hover) === null || ref20 === void 0 ? void 0 : ref20.enable) === "boolean" ? template.tablet.behaviour.hover.enable : enableHover1;
            if (enableTabletHover1 === true) {
                className += " ngsTabletHoverState";
            }
            // mobile
            var enableMobileHover1 = typeof ((ref21 = template.mobile) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.behaviour) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.hover) === null || ref23 === void 0 ? void 0 : ref23.enable) === "boolean" ? template.mobile.behaviour.hover.enable : enableHover1;
            if (enableMobileHover1 === true) {
                className += " ngsMobileHoverState";
            }
            /**
       * write disable state class
       * active state classes
       */ // desktop
            var enableActive1 = ((ref24 = template.behaviour) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.active) === null || ref25 === void 0 ? void 0 : ref25.enable) || false;
            if (enableActive1) {
                className += " ngsActiveState";
            }
            // tablet
            var enableTabletActive1 = typeof ((ref26 = template.tablet) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.behaviour) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.active) === null || ref28 === void 0 ? void 0 : ref28.enable) === "boolean" ? template.tablet.behaviour.active.enable : enableActive1;
            if (enableTabletActive1 === true) {
                className += " ngsTabletActiveState";
            }
            // mobile
            var enableMobileActive1 = typeof ((ref29 = template.mobile) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.behaviour) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.active) === null || ref31 === void 0 ? void 0 : ref31.enable) === "boolean" ? template.mobile.behaviour.active.enable : enableActive1;
            if (enableMobileActive1 === true) {
                className += " ngsMobileActiveState";
            }
        }
        return className;
    };
    GlobalStylesUtils.writeClassNameV2 = function writeClassNameV2(className, globalStyle, extraClass, classNameSufix) {
        className += " ".concat(globalStyle.type, "-").concat(globalStyle.uuid);
        // write extra class
        if (extraClass && globalStyle.type === GS_SHADOW) {
            className += extraClass;
        }
        // write classNameSufix
        if (classNameSufix && globalStyle.type in classNameSufix) {
            className += classNameSufix[globalStyle.type] // TODO: globalStyle type must be written, currently is any
            ;
        }
        return className;
    };
    GlobalStylesUtils.handleEditMode = function handleEditMode(editMode, controllerSetStateObject, stateHasChangesId, stateEnable, signalChanges) {
        var hasChangesId = signalChanges ? stateHasChangesId + (0,v4/* default */.Z)() : stateHasChangesId;
        var stateEnableObj = {};
        if (stateEnable) {
            for(var key in stateEnable){
                var enable = stateEnable[key];
                stateEnableObj = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, stateEnableObj), (0,src_define_property/* default */.Z)({}, enable.stateKey, enable.value));
            }
        }
        return (0,src_object_spread/* default */.Z)({
            isGlobalStyleEditMode: editMode,
            finderSelectedObjectUuid: hasChangesId
        }, controllerSetStateObject, stateEnableObj);
    };
    /**
   * handle activated state template values
   * @param globalStyleState
   * @param responsiveBreakpoint
   * @param globalStyleTemplate
   * @param type
   * @returns
   */ GlobalStylesUtils.handleGlobalStyleState = function handleGlobalStyleState(globalStyleState, responsiveBreakpoint, globalStyleTemplate, type) {
        var template;
        var handledTemplate;
        /**
     * when changed to active/hover state
     * use default when state template doenst exist
     */ if (globalStyleState !== "default") {
            // when in responsive state
            if (responsiveBreakpoint.breakpoint !== "desktop") {
                var ref;
                template = ((ref = globalStyleTemplate[responsiveBreakpoint.breakpoint].behaviour) === null || ref === void 0 ? void 0 : ref[globalStyleState]) || globalStyleTemplate;
                handledTemplate = GlobalStylesUtils.handleGlobalStyleToEdit(type, template, responsiveBreakpoint);
            } else {
                var ref1;
                template = ((ref1 = globalStyleTemplate.behaviour) === null || ref1 === void 0 ? void 0 : ref1[globalStyleState]) || globalStyleTemplate;
                handledTemplate = GlobalStylesUtils.handleGlobalStyleToEdit(type, template, responsiveBreakpoint);
            }
        } else {
            var ref2;
            /**
       * when changed to default state
       */ // when in default state
            template = ((ref2 = globalStyleTemplate.behaviour) === null || ref2 === void 0 ? void 0 : ref2[globalStyleState]) || globalStyleTemplate;
            handledTemplate = GlobalStylesUtils.handleGlobalStyleToEdit(type, template, responsiveBreakpoint);
        }
        return handledTemplate;
    };
    /**
   * controllerStyles can receive an object with the style props only
   * or an object divided by breakpoint on wich each has it's own style props.
   * The second option happens for breakpoint values.
   * @param globalStyleState
   * @param globalStyleTemplate
   * @param responsiveBreakpoint
   * @param controllerStyles
   * @param stylesProp
   * @returns
   */ GlobalStylesUtils.handleControllerValuesChange = function handleControllerValuesChange(globalStyleState, globalStyleTemplate, responsiveBreakpoint, controllerStyles, stylesProp) {
        var handledTemplate;
        /**
     * handle state values
     */ //TODO: create method
        if (globalStyleState !== "default") {
            // handle state responsive values
            // write values to responsive hover or active props
            if (responsiveBreakpoint.breakpoint !== "desktop") {
                var ref;
                handledTemplate = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, globalStyleTemplate), (0,src_define_property/* default */.Z)({}, responsiveBreakpoint.breakpoint, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, globalStyleTemplate[responsiveBreakpoint.breakpoint]), {
                    behaviour: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (ref = globalStyleTemplate[responsiveBreakpoint.breakpoint]) === null || ref === void 0 ? void 0 : ref.behaviour), (0,src_define_property/* default */.Z)({}, globalStyleState, controllerStyles[responsiveBreakpoint.breakpoint][stylesProp]))
                })));
            } else {
                handledTemplate = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, globalStyleTemplate), {
                    behaviour: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, globalStyleTemplate.behaviour), (0,src_define_property/* default */.Z)({}, globalStyleState, controllerStyles[stylesProp]))
                });
            }
        } else if (responsiveBreakpoint.breakpoint !== "desktop") {
            /**
       * handle responsive values
       * write values to mobile or tablet props
       */ handledTemplate = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, globalStyleTemplate), (0,src_define_property/* default */.Z)({}, responsiveBreakpoint.breakpoint, (0,src_object_spread/* default */.Z)({}, globalStyleTemplate[responsiveBreakpoint.breakpoint], controllerStyles[responsiveBreakpoint.breakpoint][stylesProp])));
        } else {
            /**
       * handle default values
       * write values to template root
       */ handledTemplate = (0,src_object_spread/* default */.Z)({}, globalStyleTemplate, controllerStyles[stylesProp]);
        }
        return handledTemplate;
    };
    GlobalStylesUtils.handleGlobalStyleDisabledState = function handleGlobalStyleDisabledState(globalStyleState, globalStyleType, type) {
        return (globalStyleState === "edit" || globalStyleState === "create") && globalStyleType !== type;
    };
    GlobalStylesUtils.getAttachedGlobalStyle = function getAttachedGlobalStyle(pageResponse, selectedObject, bobKey, type) {
        var ref;
        var globalStyleId = this.hasGlobalStyleAttached(selectedObject, bobKey, type);
        var globalStyleObject = (ref = pageResponse.nGlobalStyles) === null || ref === void 0 ? void 0 : ref[globalStyleId];
        return globalStyleObject;
    };
    GlobalStylesUtils.attachGlobalStyleToPage = function attachGlobalStyleToPage(hubContent, globalStyleObject, selectedObject, type, bobKey, emEditorType) {
        var clonedHubContent = cloneDeep_default()(hubContent);
        //trigger publish btn
        clonedHubContent.isOutdated = true;
        // keep compatibility when exists
        clonedHubContent.nGlobalStyles = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, clonedHubContent.nGlobalStyles), (0,src_define_property/* default */.Z)({}, globalStyleObject.uuid, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, globalStyleObject), {
            compatibility: {
                newBobs: true,
                oldBobs: true
            }
        })));
        var objects = components_handleObjectsListType(clonedHubContent, selectedObject, emEditorType);
        // attach gs to bob
        objects[selectedObject.uuid].styles.bobs[bobKey].nGlobalStyles = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, objects[selectedObject.uuid].styles.bobs[bobKey].nGlobalStyles), (0,src_define_property/* default */.Z)({}, type, globalStyleObject.uuid));
        return {
            hubContent: clonedHubContent,
            objects: objects
        };
    };
    GlobalStylesUtils.getGlobalStyleCompatibility = function getGlobalStyleCompatibility(globalStyleId, pageResponse) {
        var ref, ref1;
        return (ref = pageResponse.nGlobalStyles) === null || ref === void 0 ? void 0 : (ref1 = ref[globalStyleId]) === null || ref1 === void 0 ? void 0 : ref1.compatibility;
    };
    GlobalStylesUtils.updateGlobalStyleCompatibility = function updateGlobalStyleCompatibility(globalStyleId, compatibility, hubContent) {
        var clonedHubContent = cloneDeep_default()(hubContent);
        // update compatibility
        var updatedGlobalStyle = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, clonedHubContent.nGlobalStyles[globalStyleId]), {
            compatibility: compatibility
        });
        // update pageResponse globalStyle
        clonedHubContent.nGlobalStyles = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, clonedHubContent.nGlobalStyles), (0,src_define_property/* default */.Z)({}, globalStyleId, updatedGlobalStyle));
        return {
            hubContent: clonedHubContent,
            globalStyle: updatedGlobalStyle
        };
    };
    GlobalStylesUtils.writeGlobalStyleListCompatibility = function writeGlobalStyleListCompatibility(nGlobalStyles, newBobs, oldBobs) {
        if (nGlobalStyles) {
            var nGLobalStylesUpdated = cloneDeep_default()(nGlobalStyles);
            for(var key in nGLobalStylesUpdated){
                nGLobalStylesUpdated[key].compatibility = {
                    newBobs: newBobs,
                    oldBobs: oldBobs
                };
            }
            return nGLobalStylesUpdated;
        }
        return {};
    };
    return GlobalStylesUtils;
}();
/* harmony default export */ var globalStylesUtils = (GlobalStylesUtils);

;// CONCATENATED MODULE: ./src/modules/shared-modules/experienceManager/finder/inputs/controllerVersion.ts
var controllerVersion_ControllerVersion = {
    /**
   * all:
   * media:
   * icon:
   */ alignment: {
        media: 1,
        text: 1,
        background: 1,
        icon: 1
    },
    border: {
        media: 1,
        text: 1,
        background: 1,
        icon: 1
    },
    spacing: {
        media: 1,
        text: 1,
        background: 1,
        icon: 1
    },
    colors: {
        media: 1,
        text: 1,
        background: 1,
        icon: 1
    },
    shadow: {
        media: 1,
        text: 1,
        background: 1,
        icon: 1
    }
};
function isLastVersion(currentVersion, lastVersion) {
    if (currentVersion !== lastVersion) {
        return false;
    }
    return true;
}
/* harmony default export */ var controllerVersion = ((/* unused pure expression or super */ null && (controllerVersion_ControllerVersion)));

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/utils/componentAlignment.ts

function defaultAlign(style) {
    //These are the defaults, when the alignment doesn't need special handlement
    var AlignmentDefaultProperties = {
        flexDirection: "row",
        self: false
    };
    var alignmentStyles = AlignmentCssRenderUnsafe(style, "desktop", "default", AlignmentDefaultProperties);
    var tabletAlignment = AlignmentCssRenderUnsafe(style, "tablet", "default", AlignmentDefaultProperties);
    var mobileAlignment = AlignmentCssRenderUnsafe(style, "mobile", "default", AlignmentDefaultProperties);
    return {
        alignmentStyles: alignmentStyles,
        tabletAlignment: tabletAlignment,
        mobileAlignment: mobileAlignment
    };
}
function defaultClassAlign(style) {
    //These are the defaults, when the alignment doesn't need special handlement
    var AlignmentDefaultProperties = {
        flexDirection: "row",
        self: false
    };
    var alignmentStyles = AlignmentCssClassRenderUnsafe(style, "desktop", "default", AlignmentDefaultProperties);
    var tabletAlignment = AlignmentCssClassRenderUnsafe(style, "tablet", "default", AlignmentDefaultProperties);
    var mobileAlignment = AlignmentCssClassRenderUnsafe(style, "mobile", "default", AlignmentDefaultProperties);
    return "".concat(alignmentStyles, " ").concat(tabletAlignment, " ").concat(mobileAlignment);
}
function specificAlign(style, AlignmentDefaultProperties) {
    //These are the defaults, when the alignment doesn't need special handlement
    var alignmentStyles = AlignmentCssRenderUnsafe(style, "desktop", "default", AlignmentDefaultProperties);
    var tabletAlignment = AlignmentCssRenderUnsafe(style, "tablet", "default", AlignmentDefaultProperties);
    var mobileAlignment = AlignmentCssRenderUnsafe(style, "mobile", "default", AlignmentDefaultProperties);
    return {
        alignmentStyles: alignmentStyles,
        tabletAlignment: tabletAlignment,
        mobileAlignment: mobileAlignment
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/borderStyle_old.ts





var borderStyle_old_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
var borderStyle_old_borderStyleCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("none"),
    (0,es6/* literal */.i0)("solid"),
    (0,es6/* literal */.i0)("dashed"),
    (0,es6/* literal */.i0)("dotted")
]);
var borderStyle_old_BorderPropsCodec = (0,es6/* type */.dt)({
    bottomColor: es6/* string */.Z_,
    bottomEnable: es6/* boolean */.O7,
    bottomStyle: borderStyle_old_borderStyleCodec,
    bottomWidth: es6/* number */.pk,
    topColor: es6/* string */.Z_,
    topEnable: es6/* boolean */.O7,
    topStyle: borderStyle_old_borderStyleCodec,
    topWidth: es6/* number */.pk,
    leftColor: es6/* string */.Z_,
    leftEnable: es6/* boolean */.O7,
    leftStyle: borderStyle_old_borderStyleCodec,
    leftWidth: es6/* number */.pk,
    rightColor: es6/* string */.Z_,
    rightEnable: es6/* boolean */.O7,
    rightStyle: borderStyle_old_borderStyleCodec,
    rightWidth: es6/* number */.pk
});
var borderStyle_old_BorderCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    borderStyle_old_BorderPropsCodec
]);
var borderStyle_old_BorderPropsOptCodec = (0,es6/* partial */.r$)({
    bottomColor: borderStyle_old_nullable(es6/* string */.Z_),
    bottomEnable: borderStyle_old_nullable(es6/* boolean */.O7),
    bottomStyle: borderStyle_old_nullable(borderStyle_old_borderStyleCodec),
    bottomWidth: borderStyle_old_nullable(es6/* number */.pk),
    topColor: borderStyle_old_nullable(es6/* string */.Z_),
    topEnable: borderStyle_old_nullable(es6/* boolean */.O7),
    topStyle: borderStyle_old_nullable(borderStyle_old_borderStyleCodec),
    topWidth: borderStyle_old_nullable(es6/* number */.pk),
    leftColor: borderStyle_old_nullable(es6/* string */.Z_),
    leftEnable: borderStyle_old_nullable(es6/* boolean */.O7),
    leftStyle: borderStyle_old_nullable(borderStyle_old_borderStyleCodec),
    leftWidth: borderStyle_old_nullable(es6/* number */.pk),
    rightColor: borderStyle_old_nullable(es6/* string */.Z_),
    rightEnable: borderStyle_old_nullable(es6/* boolean */.O7),
    rightStyle: borderStyle_old_nullable(borderStyle_old_borderStyleCodec),
    rightWidth: borderStyle_old_nullable(es6/* number */.pk)
});
var borderStyle_old_BorderOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: borderStyle_old_nullable(es6/* boolean */.O7)
    }),
    borderStyle_old_BorderPropsOptCodec
]);
var borderStyle_old_StylesBorderCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        border: borderStyle_old_BorderCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                border: borderStyle_old_BorderOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                border: borderStyle_old_BorderOptCodec
            })
        }),
        mobile: (0,es6/* partial */.r$)({
            border: borderStyle_old_BorderOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    border: borderStyle_old_BorderOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    border: borderStyle_old_BorderOptCodec
                })
            })
        }),
        tablet: (0,es6/* partial */.r$)({
            border: borderStyle_old_BorderOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    border: borderStyle_old_BorderOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    border: borderStyle_old_BorderOptCodec
                })
            })
        })
    }), 
]);
var borderStyle_old_GSBorderCodec = (0,es6/* intersection */.jV)([
    borderStyle_old_BorderPropsCodec,
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: borderStyle_old_BorderPropsOptCodec,
            hover: borderStyle_old_BorderPropsOptCodec
        }),
        mobile: (0,es6/* intersection */.jV)([
            borderStyle_old_BorderPropsOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: borderStyle_old_BorderPropsOptCodec,
                    hover: borderStyle_old_BorderPropsOptCodec
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            borderStyle_old_BorderPropsOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: borderStyle_old_BorderPropsOptCodec,
                    hover: borderStyle_old_BorderPropsOptCodec
                })
            }), 
        ])
    }), 
]);
function borderStyle_old_responsiveStyle(borderObj) {
    if (borderObj.hasOwnProperty("enable") && !objValueExists(borderObj, "enable")) return "";
    if (borderObj.hasOwnProperty("enable") && !borderObj.enable) return {
        "border-top": "none !important",
        "border-right": "none !important",
        "border-bottom": "none !important",
        "border-left": "none !important"
    };
    var borderTop = borderObj.topEnable ? "".concat(borderObj.topWidth, "px ").concat(borderObj.topStyle, " ").concat(borderObj.topColor, " !important") : "none !important";
    var borderRight = borderObj.rightEnable ? "".concat(borderObj.rightWidth, "px ").concat(borderObj.rightStyle, " ").concat(borderObj.rightColor, " !important") : "none !important";
    var borderBottom = borderObj.bottomEnable ? "".concat(borderObj.bottomWidth, "px ").concat(borderObj.bottomStyle, " ").concat(borderObj.bottomColor, " !important") : "none !important";
    var borderLeft = borderObj.leftEnable ? "".concat(borderObj.leftWidth, "px ").concat(borderObj.leftStyle, " ").concat(borderObj.leftColor, " !important") : "none !important";
    return {
        "border-top": borderTop,
        "border-right": borderRight,
        "border-bottom": borderBottom,
        "border-left": borderLeft
    };
}
function borderStyle_old_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var styles = borderStyle_old_StylesBorderCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return borderStyle_old_cssRender(styles.right, breakpoint, behaviourState);
    console.warn(breakpoint, behaviourState, codecUtils_decoderErrors(styles));
    return {
        "border-bottom-style": "none !important",
        "border-bottom-width": "0 !important",
        "border-bottom-color": "#fff !important",
        "border-top-style": "none !important",
        "border-top-width": "0 !important",
        "border-top-color": "#fff !important",
        "border-left-style": "none !important",
        "border-left-width": "0 !important",
        "border-left-color": "#fff !important",
        "border-right-style": "none !important",
        "border-right-width": "0 !important",
        "border-right-color": "#fff !important"
    };
}
function borderStyle_old_globalStyleCssRenderUnsafe(gsObj, breakpoint, behaviourState) {
    var gs = borderStyle_old_GSBorderCodec.decode(gsObj);
    if (isRight(gs)) return borderStyle_old_globalStyleCssRender(gs.right, breakpoint, behaviourState);
    console.warn(decoderErrors(gs));
    return {
        "border-bottom-style": "none !important",
        "border-bottom-width": "0 !important",
        "border-bottom-color": "#fff !important",
        "border-top-style": "none !important",
        "border-top-width": "0 !important",
        "border-top-color": "#fff !important",
        "border-left-style": "none !important",
        "border-left-width": "0 !important",
        "border-left-color": "#fff !important",
        "border-right-style": "none !important",
        "border-right-width": "0 !important",
        "border-right-color": "#fff !important"
    };
}
function borderStyle_old_cssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return borderStyle_old_renderBob(stylesObj.border);
        } else {
            var ref, ref1;
            return borderStyle_old_renderBob(borderStyle_old_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.border, stylesObj.border));
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return borderStyle_old_renderBob(borderStyle_old_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.border, stylesObj.border));
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return borderStyle_old_renderBob(borderStyle_old_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.border, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.border, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.border, stylesObj.border));
        }
    }
}
function borderStyle_old_globalStyleCssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return borderStyle_old_render(stylesObj);
        } else {
            var ref;
            return borderStyle_old_render(borderStyle_old_merge2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : ref[behaviourState], stylesObj));
        }
    } else {
        if (behaviourState === "default") {
            return borderStyle_old_render(borderStyle_old_merge2(stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj));
        } else {
            var ref1, ref2, ref3;
            return borderStyle_old_render(borderStyle_old_merge3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref1 = stylesObj[breakpoint]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : ref2[behaviourState], (ref3 = stylesObj.behaviour) === null || ref3 === void 0 ? void 0 : ref3[behaviourState], stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj));
        }
    }
}
function borderStyle_old_renderBob(borderObj) {
    if (!borderObj.enable) return {
        "border-bottom-style": "none !important",
        "border-bottom-width": "0 !important",
        "border-bottom-color": "#fff !important",
        "border-top-style": "none !important",
        "border-top-width": "0 !important",
        "border-top-color": "#fff !important",
        "border-left-style": "none !important",
        "border-left-width": "0 !important",
        "border-left-color": "#fff !important",
        "border-right-style": "none !important",
        "border-right-width": "0 !important",
        "border-right-color": "#fff !important"
    };
    return borderStyle_old_render(borderObj);
}
function borderStyle_old_render(borderObj) {
    return {
        "border-bottom-style": "".concat(borderObj.bottomEnable ? borderObj.bottomStyle : "none", " !important"),
        "border-bottom-width": "".concat(borderObj.bottomEnable ? borderObj.bottomWidth : "0", "px !important"),
        "border-bottom-color": "".concat(borderObj.bottomEnable ? borderObj.bottomColor : "#fff", " !important"),
        "border-top-style": "".concat(borderObj.topEnable ? borderObj.topStyle : "none", " !important"),
        "border-top-width": "".concat(borderObj.topEnable ? borderObj.topWidth : "0", "px !important"),
        "border-top-color": "".concat(borderObj.topEnable ? borderObj.topColor : "#fff", " !important"),
        "border-left-style": "".concat(borderObj.leftEnable ? borderObj.leftStyle : "none", " !important"),
        "border-left-width": "".concat(borderObj.leftEnable ? borderObj.leftWidth : "0", "px !important"),
        "border-left-color": "".concat(borderObj.leftEnable ? borderObj.leftColor : "#fff", " !important"),
        "border-right-style": "".concat(borderObj.rightEnable ? borderObj.rightStyle : "none", " !important"),
        "border-right-width": "".concat(borderObj.rightEnable ? borderObj.rightWidth : "0", "px !important"),
        "border-right-color": "".concat(borderObj.rightEnable ? borderObj.rightColor : "#fff", " !important")
    };
}
function borderStyle_old_mergeBob2(borderObj, defaultBorderObj) {
    var enable = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.enable, defaultBorderObj.enable);
    var bottomColor = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomColor, defaultBorderObj.bottomColor);
    var bottomStyle = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomStyle, defaultBorderObj.bottomStyle);
    var bottomWidth = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomWidth, defaultBorderObj.bottomWidth);
    var bottomEnable = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomEnable, defaultBorderObj.bottomEnable);
    var topColor = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.topColor, defaultBorderObj.topColor);
    var topStyle = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.topStyle, defaultBorderObj.topStyle);
    var topWidth = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.topWidth, defaultBorderObj.topWidth);
    var topEnable = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.topEnable, defaultBorderObj.topEnable);
    var leftColor = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftColor, defaultBorderObj.leftColor);
    var leftStyle = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftStyle, defaultBorderObj.leftStyle);
    var leftWidth = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftWidth, defaultBorderObj.leftWidth);
    var leftEnable = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftEnable, defaultBorderObj.leftEnable);
    var rightColor = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightColor, defaultBorderObj.rightColor);
    var rightStyle = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightStyle, defaultBorderObj.rightStyle);
    var rightWidth = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightWidth, defaultBorderObj.rightWidth);
    var rightEnable = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightEnable, defaultBorderObj.rightEnable);
    return {
        enable: enable,
        bottomColor: bottomColor,
        bottomStyle: bottomStyle,
        bottomWidth: bottomWidth,
        bottomEnable: bottomEnable,
        topColor: topColor,
        topStyle: topStyle,
        topWidth: topWidth,
        topEnable: topEnable,
        leftColor: leftColor,
        leftStyle: leftStyle,
        leftWidth: leftWidth,
        leftEnable: leftEnable,
        rightColor: rightColor,
        rightStyle: rightStyle,
        rightWidth: rightWidth,
        rightEnable: rightEnable
    };
}
function borderStyle_old_merge2(borderObj, defaultBorderObj) {
    var bottomColor = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomColor, defaultBorderObj.bottomColor);
    var bottomStyle = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomStyle, defaultBorderObj.bottomStyle);
    var bottomWidth = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomWidth, defaultBorderObj.bottomWidth);
    var bottomEnable = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomEnable, defaultBorderObj.bottomEnable);
    var topColor = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.topColor, defaultBorderObj.topColor);
    var topStyle = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.topStyle, defaultBorderObj.topStyle);
    var topWidth = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.topWidth, defaultBorderObj.topWidth);
    var topEnable = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.topEnable, defaultBorderObj.topEnable);
    var leftColor = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftColor, defaultBorderObj.leftColor);
    var leftStyle = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftStyle, defaultBorderObj.leftStyle);
    var leftWidth = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftWidth, defaultBorderObj.leftWidth);
    var leftEnable = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftEnable, defaultBorderObj.leftEnable);
    var rightColor = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightColor, defaultBorderObj.rightColor);
    var rightStyle = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightStyle, defaultBorderObj.rightStyle);
    var rightWidth = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightWidth, defaultBorderObj.rightWidth);
    var rightEnable = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightEnable, defaultBorderObj.rightEnable);
    return {
        bottomColor: bottomColor,
        bottomStyle: bottomStyle,
        bottomWidth: bottomWidth,
        bottomEnable: bottomEnable,
        topColor: topColor,
        topStyle: topStyle,
        topWidth: topWidth,
        topEnable: topEnable,
        leftColor: leftColor,
        leftStyle: leftStyle,
        leftWidth: leftWidth,
        leftEnable: leftEnable,
        rightColor: rightColor,
        rightStyle: rightStyle,
        rightWidth: rightWidth,
        rightEnable: rightEnable
    };
}
function borderStyle_old_mergeBob3(borderObj, borderDesktopBehaviour, borderDefaultBreakpoint, defaultBorderObj) {
    var ref, ref1, ref2;
    var enable = (ref2 = (ref1 = (ref = borderObj === null || borderObj === void 0 ? void 0 : borderObj.enable) !== null && ref !== void 0 ? ref : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.enable) !== null && ref1 !== void 0 ? ref1 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.enable) !== null && ref2 !== void 0 ? ref2 : defaultBorderObj.enable;
    var ref3, ref4, ref5;
    var bottomColor = (ref5 = (ref4 = (ref3 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomColor) !== null && ref3 !== void 0 ? ref3 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.bottomColor) !== null && ref4 !== void 0 ? ref4 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.bottomColor) !== null && ref5 !== void 0 ? ref5 : defaultBorderObj.bottomColor;
    var ref6, ref7, ref8;
    var bottomStyle = (ref8 = (ref7 = (ref6 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomStyle) !== null && ref6 !== void 0 ? ref6 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.bottomStyle) !== null && ref7 !== void 0 ? ref7 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.bottomStyle) !== null && ref8 !== void 0 ? ref8 : defaultBorderObj.bottomStyle;
    var ref9, ref10, ref11;
    var bottomWidth = (ref11 = (ref10 = (ref9 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomWidth) !== null && ref9 !== void 0 ? ref9 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.bottomWidth) !== null && ref10 !== void 0 ? ref10 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.bottomWidth) !== null && ref11 !== void 0 ? ref11 : defaultBorderObj.bottomWidth;
    var ref12, ref13, ref14;
    var bottomEnable = (ref14 = (ref13 = (ref12 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomEnable) !== null && ref12 !== void 0 ? ref12 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.bottomEnable) !== null && ref13 !== void 0 ? ref13 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.bottomEnable) !== null && ref14 !== void 0 ? ref14 : defaultBorderObj.bottomEnable;
    var ref15, ref16, ref17;
    var topColor = (ref17 = (ref16 = (ref15 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.topColor) !== null && ref15 !== void 0 ? ref15 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.topColor) !== null && ref16 !== void 0 ? ref16 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.topColor) !== null && ref17 !== void 0 ? ref17 : defaultBorderObj.topColor;
    var ref18, ref19, ref20;
    var topStyle = (ref20 = (ref19 = (ref18 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.topStyle) !== null && ref18 !== void 0 ? ref18 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.topStyle) !== null && ref19 !== void 0 ? ref19 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.topStyle) !== null && ref20 !== void 0 ? ref20 : defaultBorderObj.topStyle;
    var ref21, ref22, ref23;
    var topWidth = (ref23 = (ref22 = (ref21 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.topWidth) !== null && ref21 !== void 0 ? ref21 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.topWidth) !== null && ref22 !== void 0 ? ref22 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.topWidth) !== null && ref23 !== void 0 ? ref23 : defaultBorderObj.topWidth;
    var ref24, ref25, ref26;
    var topEnable = (ref26 = (ref25 = (ref24 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.topEnable) !== null && ref24 !== void 0 ? ref24 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.topEnable) !== null && ref25 !== void 0 ? ref25 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.topEnable) !== null && ref26 !== void 0 ? ref26 : defaultBorderObj.topEnable;
    var ref27, ref28, ref29;
    var leftColor = (ref29 = (ref28 = (ref27 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftColor) !== null && ref27 !== void 0 ? ref27 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.leftColor) !== null && ref28 !== void 0 ? ref28 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.leftColor) !== null && ref29 !== void 0 ? ref29 : defaultBorderObj.leftColor;
    var ref30, ref31, ref32;
    var leftStyle = (ref32 = (ref31 = (ref30 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftStyle) !== null && ref30 !== void 0 ? ref30 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.leftStyle) !== null && ref31 !== void 0 ? ref31 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.leftStyle) !== null && ref32 !== void 0 ? ref32 : defaultBorderObj.leftStyle;
    var ref33, ref34, ref35;
    var leftWidth = (ref35 = (ref34 = (ref33 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftWidth) !== null && ref33 !== void 0 ? ref33 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.leftWidth) !== null && ref34 !== void 0 ? ref34 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.leftWidth) !== null && ref35 !== void 0 ? ref35 : defaultBorderObj.leftWidth;
    var ref36, ref37, ref38;
    var leftEnable = (ref38 = (ref37 = (ref36 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftEnable) !== null && ref36 !== void 0 ? ref36 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.leftEnable) !== null && ref37 !== void 0 ? ref37 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.leftEnable) !== null && ref38 !== void 0 ? ref38 : defaultBorderObj.leftEnable;
    var ref39, ref40, ref41;
    var rightColor = (ref41 = (ref40 = (ref39 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightColor) !== null && ref39 !== void 0 ? ref39 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.rightColor) !== null && ref40 !== void 0 ? ref40 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.rightColor) !== null && ref41 !== void 0 ? ref41 : defaultBorderObj.rightColor;
    var ref42, ref43, ref44;
    var rightStyle = (ref44 = (ref43 = (ref42 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightStyle) !== null && ref42 !== void 0 ? ref42 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.rightStyle) !== null && ref43 !== void 0 ? ref43 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.rightStyle) !== null && ref44 !== void 0 ? ref44 : defaultBorderObj.rightStyle;
    var ref45, ref46, ref47;
    var rightWidth = (ref47 = (ref46 = (ref45 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightWidth) !== null && ref45 !== void 0 ? ref45 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.rightWidth) !== null && ref46 !== void 0 ? ref46 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.rightWidth) !== null && ref47 !== void 0 ? ref47 : defaultBorderObj.rightWidth;
    var ref48, ref49, ref50;
    var rightEnable = (ref50 = (ref49 = (ref48 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightEnable) !== null && ref48 !== void 0 ? ref48 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.rightEnable) !== null && ref49 !== void 0 ? ref49 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.rightEnable) !== null && ref50 !== void 0 ? ref50 : defaultBorderObj.rightEnable;
    return {
        enable: enable,
        bottomColor: bottomColor,
        bottomStyle: bottomStyle,
        bottomWidth: bottomWidth,
        bottomEnable: bottomEnable,
        topColor: topColor,
        topStyle: topStyle,
        topWidth: topWidth,
        topEnable: topEnable,
        leftColor: leftColor,
        leftStyle: leftStyle,
        leftWidth: leftWidth,
        leftEnable: leftEnable,
        rightColor: rightColor,
        rightStyle: rightStyle,
        rightWidth: rightWidth,
        rightEnable: rightEnable
    };
}
function borderStyle_old_merge3(borderObj, borderDesktopBehaviour, borderDefaultBreakpoint, defaultBorderObj) {
    var ref, ref1, ref2;
    var bottomColor = (ref2 = (ref1 = (ref = borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomColor) !== null && ref !== void 0 ? ref : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.bottomColor) !== null && ref1 !== void 0 ? ref1 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.bottomColor) !== null && ref2 !== void 0 ? ref2 : defaultBorderObj.bottomColor;
    var ref3, ref4, ref5;
    var bottomStyle = (ref5 = (ref4 = (ref3 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomStyle) !== null && ref3 !== void 0 ? ref3 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.bottomStyle) !== null && ref4 !== void 0 ? ref4 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.bottomStyle) !== null && ref5 !== void 0 ? ref5 : defaultBorderObj.bottomStyle;
    var ref6, ref7, ref8;
    var bottomWidth = (ref8 = (ref7 = (ref6 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomWidth) !== null && ref6 !== void 0 ? ref6 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.bottomWidth) !== null && ref7 !== void 0 ? ref7 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.bottomWidth) !== null && ref8 !== void 0 ? ref8 : defaultBorderObj.bottomWidth;
    var ref9, ref10, ref11;
    var bottomEnable = (ref11 = (ref10 = (ref9 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomEnable) !== null && ref9 !== void 0 ? ref9 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.bottomEnable) !== null && ref10 !== void 0 ? ref10 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.bottomEnable) !== null && ref11 !== void 0 ? ref11 : defaultBorderObj.bottomEnable;
    var ref12, ref13, ref14;
    var topColor = (ref14 = (ref13 = (ref12 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.topColor) !== null && ref12 !== void 0 ? ref12 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.topColor) !== null && ref13 !== void 0 ? ref13 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.topColor) !== null && ref14 !== void 0 ? ref14 : defaultBorderObj.topColor;
    var ref15, ref16, ref17;
    var topStyle = (ref17 = (ref16 = (ref15 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.topStyle) !== null && ref15 !== void 0 ? ref15 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.topStyle) !== null && ref16 !== void 0 ? ref16 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.topStyle) !== null && ref17 !== void 0 ? ref17 : defaultBorderObj.topStyle;
    var ref18, ref19, ref20;
    var topWidth = (ref20 = (ref19 = (ref18 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.topWidth) !== null && ref18 !== void 0 ? ref18 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.topWidth) !== null && ref19 !== void 0 ? ref19 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.topWidth) !== null && ref20 !== void 0 ? ref20 : defaultBorderObj.topWidth;
    var ref21, ref22, ref23;
    var topEnable = (ref23 = (ref22 = (ref21 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.topEnable) !== null && ref21 !== void 0 ? ref21 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.topEnable) !== null && ref22 !== void 0 ? ref22 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.topEnable) !== null && ref23 !== void 0 ? ref23 : defaultBorderObj.topEnable;
    var ref24, ref25, ref26;
    var leftColor = (ref26 = (ref25 = (ref24 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftColor) !== null && ref24 !== void 0 ? ref24 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.leftColor) !== null && ref25 !== void 0 ? ref25 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.leftColor) !== null && ref26 !== void 0 ? ref26 : defaultBorderObj.leftColor;
    var ref27, ref28, ref29;
    var leftStyle = (ref29 = (ref28 = (ref27 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftStyle) !== null && ref27 !== void 0 ? ref27 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.leftStyle) !== null && ref28 !== void 0 ? ref28 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.leftStyle) !== null && ref29 !== void 0 ? ref29 : defaultBorderObj.leftStyle;
    var ref30, ref31, ref32;
    var leftWidth = (ref32 = (ref31 = (ref30 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftWidth) !== null && ref30 !== void 0 ? ref30 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.leftWidth) !== null && ref31 !== void 0 ? ref31 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.leftWidth) !== null && ref32 !== void 0 ? ref32 : defaultBorderObj.leftWidth;
    var ref33, ref34, ref35;
    var leftEnable = (ref35 = (ref34 = (ref33 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftEnable) !== null && ref33 !== void 0 ? ref33 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.leftEnable) !== null && ref34 !== void 0 ? ref34 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.leftEnable) !== null && ref35 !== void 0 ? ref35 : defaultBorderObj.leftEnable;
    var ref36, ref37, ref38;
    var rightColor = (ref38 = (ref37 = (ref36 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightColor) !== null && ref36 !== void 0 ? ref36 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.rightColor) !== null && ref37 !== void 0 ? ref37 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.rightColor) !== null && ref38 !== void 0 ? ref38 : defaultBorderObj.rightColor;
    var ref39, ref40, ref41;
    var rightStyle = (ref41 = (ref40 = (ref39 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightStyle) !== null && ref39 !== void 0 ? ref39 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.rightStyle) !== null && ref40 !== void 0 ? ref40 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.rightStyle) !== null && ref41 !== void 0 ? ref41 : defaultBorderObj.rightStyle;
    var ref42, ref43, ref44;
    var rightWidth = (ref44 = (ref43 = (ref42 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightWidth) !== null && ref42 !== void 0 ? ref42 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.rightWidth) !== null && ref43 !== void 0 ? ref43 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.rightWidth) !== null && ref44 !== void 0 ? ref44 : defaultBorderObj.rightWidth;
    var ref45, ref46, ref47;
    var rightEnable = (ref47 = (ref46 = (ref45 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightEnable) !== null && ref45 !== void 0 ? ref45 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.rightEnable) !== null && ref46 !== void 0 ? ref46 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.rightEnable) !== null && ref47 !== void 0 ? ref47 : defaultBorderObj.rightEnable;
    return {
        bottomColor: bottomColor,
        bottomStyle: bottomStyle,
        bottomWidth: bottomWidth,
        bottomEnable: bottomEnable,
        topColor: topColor,
        topStyle: topStyle,
        topWidth: topWidth,
        topEnable: topEnable,
        leftColor: leftColor,
        leftStyle: leftStyle,
        leftWidth: leftWidth,
        leftEnable: leftEnable,
        rightColor: rightColor,
        rightStyle: rightStyle,
        rightWidth: rightWidth,
        rightEnable: rightEnable
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/boundaryStyle_old.ts







//Temp to handle nulls
var boundaryStyle_old_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
var boundaryStyle_old_BMarginPropsCodec = (0,es6/* type */.dt)({
    top: es6/* number */.pk,
    bottom: es6/* number */.pk,
    left: es6/* number */.pk,
    right: es6/* number */.pk
});
var boundaryStyle_old_BPaddingPropsCodec = (0,es6/* type */.dt)({
    top: es6/* number */.pk,
    bottom: es6/* number */.pk,
    left: es6/* number */.pk,
    right: es6/* number */.pk
});
var boundaryStyle_old_BoundaryPropsCodec = (0,es6/* type */.dt)({
    margin: boundaryStyle_old_BMarginPropsCodec,
    padding: boundaryStyle_old_BPaddingPropsCodec
});
var boundaryStyle_old_BoundaryCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    boundaryStyle_old_BoundaryPropsCodec
]);
var boundaryStyle_old_BMarginPropsOptCodec = (0,es6/* partial */.r$)({
    top: boundaryStyle_old_nullable(es6/* number */.pk),
    bottom: boundaryStyle_old_nullable(es6/* number */.pk),
    left: boundaryStyle_old_nullable(es6/* number */.pk),
    right: boundaryStyle_old_nullable(es6/* number */.pk)
});
var boundaryStyle_old_BPaddingPropsOptCodec = (0,es6/* partial */.r$)({
    top: boundaryStyle_old_nullable(es6/* number */.pk),
    bottom: boundaryStyle_old_nullable(es6/* number */.pk),
    left: boundaryStyle_old_nullable(es6/* number */.pk),
    right: boundaryStyle_old_nullable(es6/* number */.pk)
});
var boundaryStyle_old_BoundaryPropsOptCodec = (0,es6/* partial */.r$)({
    margin: boundaryStyle_old_BMarginPropsOptCodec,
    padding: boundaryStyle_old_BPaddingPropsOptCodec
});
var boundaryStyle_old_BoundaryOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: boundaryStyle_old_nullable(es6/* boolean */.O7)
    }),
    boundaryStyle_old_BoundaryPropsOptCodec
]);
var boundaryStyle_old_StylesBoundaryCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        spacing: boundaryStyle_old_BoundaryCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                spacing: boundaryStyle_old_BoundaryOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                spacing: boundaryStyle_old_BoundaryOptCodec
            })
        }),
        mobile: (0,es6/* partial */.r$)({
            spacing: boundaryStyle_old_BoundaryOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    spacing: boundaryStyle_old_BoundaryOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    spacing: boundaryStyle_old_BoundaryOptCodec
                })
            })
        }),
        tablet: (0,es6/* partial */.r$)({
            spacing: boundaryStyle_old_BoundaryOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    spacing: boundaryStyle_old_BoundaryOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    spacing: boundaryStyle_old_BoundaryOptCodec
                })
            })
        })
    }), 
]);
var boundaryStyle_old_GSBoundaryCodec = (0,es6/* intersection */.jV)([
    boundaryStyle_old_BoundaryPropsCodec,
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: boundaryStyle_old_BoundaryPropsOptCodec,
            hover: boundaryStyle_old_BoundaryPropsOptCodec
        }),
        mobile: (0,es6/* intersection */.jV)([
            boundaryStyle_old_BoundaryPropsOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: boundaryStyle_old_BoundaryPropsOptCodec,
                    hover: boundaryStyle_old_BoundaryPropsOptCodec
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            boundaryStyle_old_BoundaryPropsOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: boundaryStyle_old_BoundaryPropsOptCodec,
                    hover: boundaryStyle_old_BoundaryPropsOptCodec
                })
            }), 
        ])
    }), 
]);
function boundaryStyle_old_responsiveStyle(boundaryObj) {
    if (boundaryObj.hasOwnProperty("enable") && !boundaryObj.enable) return {
        "margin-top": "0 !important",
        "margin-right": "0 !important",
        "margin-bottom": "0 !important",
        "margin-left": "0 !important",
        "padding-top": "0 !important",
        "padding-right": "0 !important",
        "padding-bottom": "0 !important",
        "padding-left": "0 !important"
    };
    var boundaryStyle = {};
    if (boundaryObj.margin) {
        for(var side in boundaryObj.margin){
            boundaryStyle = _object_spread_props(_object_spread({}, boundaryStyle), _define_property({}, "margin-".concat(side), boundaryObj.margin[side] + "px !important"));
        }
    }
    if (boundaryObj.padding) {
        for(var side1 in boundaryObj.padding){
            boundaryStyle = _object_spread_props(_object_spread({}, boundaryStyle), _define_property({}, "padding-".concat(side1), boundaryObj.padding[side1] + "px !important"));
        }
    }
    return boundaryStyle;
}
function boundaryStyle_old_renderCSSString(boundaryStyle) {
    if (!("margin-top" in boundaryStyle)) {
        return "";
    } else {
        return "margin-top: ".concat(boundaryStyle["margin-top"], ";\n    margin-bottom: ").concat(boundaryStyle["margin-bottom"], ";\n    margin-left: ").concat(boundaryStyle["margin-left"], ";\n    margin-right: ").concat(boundaryStyle["margin-right"], ";\n    padding-top: ").concat(boundaryStyle["padding-top"], ";\n    padding-bottom: ").concat(boundaryStyle["padding-bottom"], ";\n    padding-left: ").concat(boundaryStyle["padding-left"], ";\n    padding-right: ").concat(boundaryStyle["padding-right"], ";");
    }
}
function boundaryStyle_old_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var styles = boundaryStyle_old_StylesBoundaryCodec.decode(stylesObj);
    if ((0,lib_Either.isRight)(styles)) return boundaryStyle_old_cssRender(styles.right, breakpoint, behaviourState);
    console.warn("BoundaryStyle ".concat(breakpoint, " ").concat(behaviourState, " ").concat(codecUtils_decoderErrors(styles)));
    return {};
}
function boundaryStyle_old_globalStyleCssRenderUnsafe(gsObj, breakpoint, behaviourState) {
    var gs = boundaryStyle_old_GSBoundaryCodec.decode(gsObj);
    if (isRight(gs)) return boundaryStyle_old_globalStyleCssRender(gs.right, breakpoint, behaviourState);
    console.warn("BoundaryGSStyle ".concat(breakpoint, " ").concat(behaviourState, " ").concat(decoderErrors(gs)));
    return {};
}
function boundaryStyle_old_globalStyleCssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return boundaryStyle_old_render(stylesObj);
        } else {
            var ref;
            return boundaryStyle_old_render(boundaryStyle_old_merge2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : ref[behaviourState], stylesObj));
        }
    } else {
        if (behaviourState === "default") {
            return boundaryStyle_old_render(boundaryStyle_old_merge2(stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj));
        } else {
            var ref1, ref2, ref3;
            return boundaryStyle_old_render(boundaryStyle_old_merge3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref1 = stylesObj[breakpoint]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : ref2[behaviourState], stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj.behaviour) === null || ref3 === void 0 ? void 0 : ref3[behaviourState], stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj));
        }
    }
}
function boundaryStyle_old_cssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return boundaryStyle_old_renderBob(stylesObj.spacing);
        } else {
            var ref, ref1;
            return boundaryStyle_old_renderBob(boundaryStyle_old_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.spacing, stylesObj.spacing));
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return boundaryStyle_old_renderBob(boundaryStyle_old_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.spacing, stylesObj.spacing));
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return boundaryStyle_old_renderBob(boundaryStyle_old_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.spacing, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.spacing, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.spacing, stylesObj.spacing));
        }
    }
}
function boundaryStyle_old_mergeBob3(boundaryObj, boundaryDesktopBehaviour, boundaryDefaultBreakpoint, defaultBoundaryObj) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
    var ref24, ref25, ref26;
    var enable = (ref26 = (ref25 = (ref24 = boundaryObj === null || boundaryObj === void 0 ? void 0 : boundaryObj.enable) !== null && ref24 !== void 0 ? ref24 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : boundaryDesktopBehaviour.enable) !== null && ref25 !== void 0 ? ref25 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : boundaryDefaultBreakpoint.enable) !== null && ref26 !== void 0 ? ref26 : defaultBoundaryObj.enable;
    var ref27, ref28, ref29;
    var mTop = (ref29 = (ref28 = (ref27 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref = boundaryObj.margin) === null || ref === void 0 ? void 0 : ref.top) !== null && ref27 !== void 0 ? ref27 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref1 = boundaryDesktopBehaviour.margin) === null || ref1 === void 0 ? void 0 : ref1.top) !== null && ref28 !== void 0 ? ref28 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref2 = boundaryDefaultBreakpoint.margin) === null || ref2 === void 0 ? void 0 : ref2.top) !== null && ref29 !== void 0 ? ref29 : defaultBoundaryObj.margin.top;
    var ref30, ref31, ref32;
    var mBottom = (ref32 = (ref31 = (ref30 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref3 = boundaryObj.margin) === null || ref3 === void 0 ? void 0 : ref3.bottom) !== null && ref30 !== void 0 ? ref30 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref4 = boundaryDesktopBehaviour.margin) === null || ref4 === void 0 ? void 0 : ref4.bottom) !== null && ref31 !== void 0 ? ref31 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref5 = boundaryDefaultBreakpoint.margin) === null || ref5 === void 0 ? void 0 : ref5.bottom) !== null && ref32 !== void 0 ? ref32 : defaultBoundaryObj.margin.bottom;
    var ref33, ref34, ref35;
    var mLeft = (ref35 = (ref34 = (ref33 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref6 = boundaryObj.margin) === null || ref6 === void 0 ? void 0 : ref6.left) !== null && ref33 !== void 0 ? ref33 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref7 = boundaryDesktopBehaviour.margin) === null || ref7 === void 0 ? void 0 : ref7.left) !== null && ref34 !== void 0 ? ref34 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref8 = boundaryDefaultBreakpoint.margin) === null || ref8 === void 0 ? void 0 : ref8.left) !== null && ref35 !== void 0 ? ref35 : defaultBoundaryObj.margin.left;
    var ref36, ref37, ref38;
    var mRight = (ref38 = (ref37 = (ref36 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref9 = boundaryObj.margin) === null || ref9 === void 0 ? void 0 : ref9.right) !== null && ref36 !== void 0 ? ref36 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref10 = boundaryDesktopBehaviour.margin) === null || ref10 === void 0 ? void 0 : ref10.right) !== null && ref37 !== void 0 ? ref37 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref11 = boundaryDefaultBreakpoint.margin) === null || ref11 === void 0 ? void 0 : ref11.right) !== null && ref38 !== void 0 ? ref38 : defaultBoundaryObj.margin.right;
    var ref39, ref40, ref41;
    var pTop = (ref41 = (ref40 = (ref39 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref12 = boundaryObj.padding) === null || ref12 === void 0 ? void 0 : ref12.top) !== null && ref39 !== void 0 ? ref39 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref13 = boundaryDesktopBehaviour.padding) === null || ref13 === void 0 ? void 0 : ref13.top) !== null && ref40 !== void 0 ? ref40 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref14 = boundaryDefaultBreakpoint.padding) === null || ref14 === void 0 ? void 0 : ref14.top) !== null && ref41 !== void 0 ? ref41 : defaultBoundaryObj.padding.top;
    var ref42, ref43, ref44;
    var pBottom = (ref44 = (ref43 = (ref42 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref15 = boundaryObj.padding) === null || ref15 === void 0 ? void 0 : ref15.bottom) !== null && ref42 !== void 0 ? ref42 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref16 = boundaryDesktopBehaviour.padding) === null || ref16 === void 0 ? void 0 : ref16.bottom) !== null && ref43 !== void 0 ? ref43 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref17 = boundaryDefaultBreakpoint.padding) === null || ref17 === void 0 ? void 0 : ref17.bottom) !== null && ref44 !== void 0 ? ref44 : defaultBoundaryObj.padding.bottom;
    var ref45, ref46, ref47;
    var pLeft = (ref47 = (ref46 = (ref45 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref18 = boundaryObj.padding) === null || ref18 === void 0 ? void 0 : ref18.left) !== null && ref45 !== void 0 ? ref45 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref19 = boundaryDesktopBehaviour.padding) === null || ref19 === void 0 ? void 0 : ref19.left) !== null && ref46 !== void 0 ? ref46 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref20 = boundaryDefaultBreakpoint.padding) === null || ref20 === void 0 ? void 0 : ref20.left) !== null && ref47 !== void 0 ? ref47 : defaultBoundaryObj.padding.left;
    var ref48, ref49, ref50;
    var pRight = (ref50 = (ref49 = (ref48 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref21 = boundaryObj.padding) === null || ref21 === void 0 ? void 0 : ref21.right) !== null && ref48 !== void 0 ? ref48 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref22 = boundaryDesktopBehaviour.padding) === null || ref22 === void 0 ? void 0 : ref22.right) !== null && ref49 !== void 0 ? ref49 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref23 = boundaryDefaultBreakpoint.padding) === null || ref23 === void 0 ? void 0 : ref23.right) !== null && ref50 !== void 0 ? ref50 : defaultBoundaryObj.padding.right;
    return {
        enable: enable,
        margin: {
            top: mTop,
            bottom: mBottom,
            left: mLeft,
            right: mRight
        },
        padding: {
            top: pTop,
            bottom: pBottom,
            left: pLeft,
            right: pRight
        }
    };
}
function boundaryStyle_old_merge3(boundaryObj, boundaryDesktopBehaviour, boundaryDefaultBreakpoint, defaultBoundaryObj) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
    var ref24, ref25, ref26;
    var mTop = (ref26 = (ref25 = (ref24 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref = boundaryObj.margin) === null || ref === void 0 ? void 0 : ref.top) !== null && ref24 !== void 0 ? ref24 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref1 = boundaryDesktopBehaviour.margin) === null || ref1 === void 0 ? void 0 : ref1.top) !== null && ref25 !== void 0 ? ref25 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref2 = boundaryDefaultBreakpoint.margin) === null || ref2 === void 0 ? void 0 : ref2.top) !== null && ref26 !== void 0 ? ref26 : defaultBoundaryObj.margin.top;
    var ref27, ref28, ref29;
    var mBottom = (ref29 = (ref28 = (ref27 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref3 = boundaryObj.margin) === null || ref3 === void 0 ? void 0 : ref3.bottom) !== null && ref27 !== void 0 ? ref27 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref4 = boundaryDesktopBehaviour.margin) === null || ref4 === void 0 ? void 0 : ref4.bottom) !== null && ref28 !== void 0 ? ref28 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref5 = boundaryDefaultBreakpoint.margin) === null || ref5 === void 0 ? void 0 : ref5.bottom) !== null && ref29 !== void 0 ? ref29 : defaultBoundaryObj.margin.bottom;
    var ref30, ref31, ref32;
    var mLeft = (ref32 = (ref31 = (ref30 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref6 = boundaryObj.margin) === null || ref6 === void 0 ? void 0 : ref6.left) !== null && ref30 !== void 0 ? ref30 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref7 = boundaryDesktopBehaviour.margin) === null || ref7 === void 0 ? void 0 : ref7.left) !== null && ref31 !== void 0 ? ref31 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref8 = boundaryDefaultBreakpoint.margin) === null || ref8 === void 0 ? void 0 : ref8.left) !== null && ref32 !== void 0 ? ref32 : defaultBoundaryObj.margin.left;
    var ref33, ref34, ref35;
    var mRight = (ref35 = (ref34 = (ref33 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref9 = boundaryObj.margin) === null || ref9 === void 0 ? void 0 : ref9.right) !== null && ref33 !== void 0 ? ref33 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref10 = boundaryDesktopBehaviour.margin) === null || ref10 === void 0 ? void 0 : ref10.right) !== null && ref34 !== void 0 ? ref34 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref11 = boundaryDefaultBreakpoint.margin) === null || ref11 === void 0 ? void 0 : ref11.right) !== null && ref35 !== void 0 ? ref35 : defaultBoundaryObj.margin.right;
    var ref36, ref37, ref38;
    var pTop = (ref38 = (ref37 = (ref36 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref12 = boundaryObj.padding) === null || ref12 === void 0 ? void 0 : ref12.top) !== null && ref36 !== void 0 ? ref36 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref13 = boundaryDesktopBehaviour.padding) === null || ref13 === void 0 ? void 0 : ref13.top) !== null && ref37 !== void 0 ? ref37 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref14 = boundaryDefaultBreakpoint.padding) === null || ref14 === void 0 ? void 0 : ref14.top) !== null && ref38 !== void 0 ? ref38 : defaultBoundaryObj.padding.top;
    var ref39, ref40, ref41;
    var pBottom = (ref41 = (ref40 = (ref39 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref15 = boundaryObj.padding) === null || ref15 === void 0 ? void 0 : ref15.bottom) !== null && ref39 !== void 0 ? ref39 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref16 = boundaryDesktopBehaviour.padding) === null || ref16 === void 0 ? void 0 : ref16.bottom) !== null && ref40 !== void 0 ? ref40 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref17 = boundaryDefaultBreakpoint.padding) === null || ref17 === void 0 ? void 0 : ref17.bottom) !== null && ref41 !== void 0 ? ref41 : defaultBoundaryObj.padding.bottom;
    var ref42, ref43, ref44;
    var pLeft = (ref44 = (ref43 = (ref42 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref18 = boundaryObj.padding) === null || ref18 === void 0 ? void 0 : ref18.left) !== null && ref42 !== void 0 ? ref42 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref19 = boundaryDesktopBehaviour.padding) === null || ref19 === void 0 ? void 0 : ref19.left) !== null && ref43 !== void 0 ? ref43 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref20 = boundaryDefaultBreakpoint.padding) === null || ref20 === void 0 ? void 0 : ref20.left) !== null && ref44 !== void 0 ? ref44 : defaultBoundaryObj.padding.left;
    var ref45, ref46, ref47;
    var pRight = (ref47 = (ref46 = (ref45 = boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref21 = boundaryObj.padding) === null || ref21 === void 0 ? void 0 : ref21.right) !== null && ref45 !== void 0 ? ref45 : boundaryDesktopBehaviour === null || boundaryDesktopBehaviour === void 0 ? void 0 : (ref22 = boundaryDesktopBehaviour.padding) === null || ref22 === void 0 ? void 0 : ref22.right) !== null && ref46 !== void 0 ? ref46 : boundaryDefaultBreakpoint === null || boundaryDefaultBreakpoint === void 0 ? void 0 : (ref23 = boundaryDefaultBreakpoint.padding) === null || ref23 === void 0 ? void 0 : ref23.right) !== null && ref47 !== void 0 ? ref47 : defaultBoundaryObj.padding.right;
    return {
        margin: {
            top: mTop,
            bottom: mBottom,
            left: mLeft,
            right: mRight
        },
        padding: {
            top: pTop,
            bottom: pBottom,
            left: pLeft,
            right: pRight
        }
    };
}
function boundaryStyle_old_mergeBob2(boundaryObj, defaultBoundaryObj) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var enable = bobUtils_get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : boundaryObj.enable, defaultBoundaryObj.enable);
    var mTop = bobUtils_get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref = boundaryObj.margin) === null || ref === void 0 ? void 0 : ref.top, defaultBoundaryObj.margin.top);
    var mBottom = bobUtils_get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref1 = boundaryObj.margin) === null || ref1 === void 0 ? void 0 : ref1.bottom, defaultBoundaryObj.margin.bottom);
    var mRight = bobUtils_get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref2 = boundaryObj.margin) === null || ref2 === void 0 ? void 0 : ref2.right, defaultBoundaryObj.margin.right);
    var mLeft = bobUtils_get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref3 = boundaryObj.margin) === null || ref3 === void 0 ? void 0 : ref3.left, defaultBoundaryObj.margin.left);
    var pTop = bobUtils_get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref4 = boundaryObj.padding) === null || ref4 === void 0 ? void 0 : ref4.top, defaultBoundaryObj.padding.top);
    var pBottom = bobUtils_get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref5 = boundaryObj.padding) === null || ref5 === void 0 ? void 0 : ref5.bottom, defaultBoundaryObj.padding.bottom);
    var pRight = bobUtils_get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref6 = boundaryObj.padding) === null || ref6 === void 0 ? void 0 : ref6.right, defaultBoundaryObj.padding.right);
    var pLeft = bobUtils_get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref7 = boundaryObj.padding) === null || ref7 === void 0 ? void 0 : ref7.left, defaultBoundaryObj.padding.left);
    return {
        enable: enable,
        margin: {
            top: mTop,
            bottom: mBottom,
            left: mLeft,
            right: mRight
        },
        padding: {
            top: pTop,
            bottom: pBottom,
            left: pLeft,
            right: pRight
        }
    };
}
function boundaryStyle_old_merge2(boundaryObj, defaultBoundaryObj) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var mTop = get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref = boundaryObj.margin) === null || ref === void 0 ? void 0 : ref.top, defaultBoundaryObj.margin.top);
    var mBottom = get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref1 = boundaryObj.margin) === null || ref1 === void 0 ? void 0 : ref1.bottom, defaultBoundaryObj.margin.bottom);
    var mRight = get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref2 = boundaryObj.margin) === null || ref2 === void 0 ? void 0 : ref2.right, defaultBoundaryObj.margin.right);
    var mLeft = get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref3 = boundaryObj.margin) === null || ref3 === void 0 ? void 0 : ref3.left, defaultBoundaryObj.margin.left);
    var pTop = get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref4 = boundaryObj.padding) === null || ref4 === void 0 ? void 0 : ref4.top, defaultBoundaryObj.padding.top);
    var pBottom = get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref5 = boundaryObj.padding) === null || ref5 === void 0 ? void 0 : ref5.bottom, defaultBoundaryObj.padding.bottom);
    var pRight = get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref6 = boundaryObj.padding) === null || ref6 === void 0 ? void 0 : ref6.right, defaultBoundaryObj.padding.right);
    var pLeft = get2WithNull(boundaryObj === null || boundaryObj === void 0 ? void 0 : (ref7 = boundaryObj.padding) === null || ref7 === void 0 ? void 0 : ref7.left, defaultBoundaryObj.padding.left);
    return {
        margin: {
            top: mTop,
            bottom: mBottom,
            left: mLeft,
            right: mRight
        },
        padding: {
            top: pTop,
            bottom: pBottom,
            left: pLeft,
            right: pRight
        }
    };
}
function boundaryStyle_old_renderBob(boundaryObj) {
    if (!boundaryObj.enable) return {
        "margin-top": "0px !important",
        "margin-right": "0px !important",
        "margin-bottom": "0px !important",
        "margin-left": "0px !important",
        "padding-top": "0px !important",
        "padding-right": "0px !important",
        "padding-bottom": "0px !important",
        "padding-left": "0px !important"
    };
    return boundaryStyle_old_render(boundaryObj);
}
function boundaryStyle_old_render(boundaryObj) {
    return {
        "margin-top": "".concat(boundaryObj.margin.top, "px !important"),
        "margin-right": "".concat(boundaryObj.margin.right, "px !important"),
        "margin-bottom": "".concat(boundaryObj.margin.bottom, "px !important"),
        "margin-left": "".concat(boundaryObj.margin.left, "px !important"),
        "padding-top": "".concat(boundaryObj.padding.top, "px !important"),
        "padding-right": "".concat(boundaryObj.padding.right, "px !important"),
        "padding-bottom": "".concat(boundaryObj.padding.bottom, "px !important"),
        "padding-left": "".concat(boundaryObj.padding.left, "px !important")
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/colorsStyle_old.ts





//Temp to handle nulls
var colorsStyle_old_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
/**
 * We should only check for property and undefined
 * this solution is only until we fix the null being send around the page object
 */ // props only, no enable
var colorsStyle_old_ColorsPropsCodec = (0,es6/* type */.dt)({
    colorFirst: es6/* string */.Z_,
    colorSecond: es6/* string */.Z_,
    gradientAngle: es6/* number */.pk,
    gradientDirection: es6/* string */.Z_,
    isGradient: es6/* boolean */.O7
});
var colorsStyle_old_ColorsCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    colorsStyle_old_ColorsPropsCodec
]);
// props only, no enable
var colorsStyle_old_ColorsPropsOptCodec = (0,es6/* partial */.r$)({
    colorFirst: colorsStyle_old_nullable(es6/* string */.Z_),
    colorSecond: colorsStyle_old_nullable(es6/* string */.Z_),
    gradientAngle: colorsStyle_old_nullable(es6/* number */.pk),
    gradientDirection: colorsStyle_old_nullable(es6/* string */.Z_),
    isGradient: colorsStyle_old_nullable(es6/* boolean */.O7)
});
var colorsStyle_old_ColorsOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: colorsStyle_old_nullable(es6/* boolean */.O7)
    }),
    colorsStyle_old_ColorsPropsOptCodec
]);
var colorsStyle_old_StylesColorsCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        colors: colorsStyle_old_ColorsCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                colors: colorsStyle_old_ColorsOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                colors: colorsStyle_old_ColorsOptCodec
            })
        }),
        mobile: (0,es6/* partial */.r$)({
            colors: colorsStyle_old_ColorsOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    colors: colorsStyle_old_ColorsOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    colors: colorsStyle_old_ColorsOptCodec
                })
            })
        }),
        tablet: (0,es6/* partial */.r$)({
            colors: colorsStyle_old_ColorsOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    colors: colorsStyle_old_ColorsOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    colors: colorsStyle_old_ColorsOptCodec
                })
            })
        })
    }), 
]);
function colorsStyle_old_colorsCss(css) {
    if (css.hasOwnProperty("background-color")) return css["background-color"];
    return "";
}
function colorsStyle_old_responsiveStyle(colorsObj, desktopDefaultValues, breakpointDefaultValues) {
    var hasEnable = colorsObj.hasOwnProperty("enable");
    if (hasEnable && !objValueExists(colorsObj, "enable")) return "";
    /**
   * Check if property is available, and fallback to breakpointDefault or the desktopDefault
   */ var colorFirst = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.colorFirst) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.colorFirst);
    var colorSecond = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.colorSecond) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.colorSecond);
    var gradientAngle = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.gradientAngle) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.gradientAngle);
    // TODO: was not used in old method, why?
    // const gradientDirection =
    //   colorsObj?.gradientDirection ||
    //   breakpointDefaultValues?.gradientDirection ||
    //   desktopDefaultValues?.gradientDirection
    var isGradient = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.isGradient) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.isGradient);
    // colors prop
    // TODO: old method returned {} when isGradient was disabled, shouldn't it return background-image: none ?
    if (hasEnable && !colorsObj.enable) return !isGradient ? {
        "background-color": "transparent !important"
    } : {};
    if (!isGradient) return {
        "background-color": colorFirst + " !important"
    };
    else return {
        "background-image": "linear-gradient(".concat(gradientAngle, "deg, ").concat(colorFirst, ", ").concat(colorSecond, ") !important")
    };
}
function colorsStyle_old_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var foundationStyle = arguments.length > 3 && arguments[3] !== void 0 // TODO: fix when working on other bobs
     ? arguments[3] : undefined;
    /**
   * Colors in bobMEdia was optional in the BE, so some bobmedias didn't have colors written on the template.
   * A migration was runed to writte the colors object in all bobMedias,
   * this migration won't affect public pages until they are published again.
   * So, the codec will still break in this cases, which can haven bad effects on future logic, beware.
   */ var styles = colorsStyle_old_StylesColorsCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return colorsStyle_old_cssRender(styles.right, breakpoint, behaviourState, foundationStyle);
    console.warn(codecUtils_decoderErrors(styles));
    return {
        "background-color": "transparent"
    };
}
// export function globalStyleCssRenderUnsafe(
//   gsObj: any,
//   breakpoint: Breakpoint,
//   behaviourState: BehaviourState_,
//   foundationStyle: FColor | undefined = undefined // TODO: Work on when foundation is added to global styles
// ): ColorsCSS | "" {
//   const gs = GSColorsCodec.decode(gsObj)
//   if (isRight(gs)) return globalStyleCssRender(gs.right, breakpoint, behaviourState, foundationStyle)
//   console.warn(decoderErrors(gs))
//   return ""
// }
function colorsStyle_old_cssRender(stylesObj, breakpoint, behaviourState, foundationStyle) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return colorsStyle_old_renderBob(stylesObj.colors, foundationStyle);
        } else {
            var ref, ref1;
            return colorsStyle_old_renderBobOpt(colorsStyle_old_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.colors, stylesObj.colors), foundationStyle);
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return colorsStyle_old_renderBobOpt(colorsStyle_old_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.colors, stylesObj.colors), foundationStyle);
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return colorsStyle_old_renderBobOpt(colorsStyle_old_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.colors, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.colors, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.colors, stylesObj.colors), foundationStyle);
        }
    }
}
// export function globalStyleCssRender(
//   stylesObj: GSColors,
//   breakpoint: Breakpoint,
//   behaviourState: BehaviourState_,
//   foundationStyle: FColor | undefined
// ): ColorsCSS {
//   if (breakpoint === "desktop") {
//     if (behaviourState === "default") {
//       return render(stylesObj, foundationStyle)
//     }
//     //hover | active
//     else {
//       return render(merge2(stylesObj?.behaviour?.[behaviourState], stylesObj), foundationStyle)
//     }
//   }
//   //tablet | mobile
//   else {
//     if (behaviourState === "default") {
//       return render(merge2(stylesObj?.[breakpoint], stylesObj), foundationStyle)
//     }
//     //hover | active
//     else {
//       return render(
//         merge3(
//           stylesObj?.[breakpoint]?.behaviour?.[behaviourState],
//           stylesObj.behaviour?.[behaviourState],
//           stylesObj?.[breakpoint],
//           stylesObj
//         ),
//         foundationStyle
//       )
//     }
//   }
// }
/**
 * Renders Colors css for desktop template
 *
 * @param colorsObj
 * @param foundationStyle
 * @returns
 */ function colorsStyle_old_renderBob(colorsObj, foundationStyle) {
    if (!colorsObj.enable) return {
        "background-color": "transparent !important"
    };
    return colorsStyle_old_render(colorsObj, foundationStyle);
}
/**
 * Renders ColorsOpt css for breakpoints/state templates
 * or empty for non written style props
 *
 * @param colorsObj
 * @param foundationStyle
 * @returns
 */ function colorsStyle_old_renderBobOpt(colorsObj, foundationStyle) {
    if (colorsObj.enable === false) return {
        "background-color": "transparent !important"
    };
    else if (colorsObj.enable === true) {
        return colorsStyle_old_renderOpt(colorsObj, foundationStyle);
    }
    return {};
}
/**
 * Renders Colors css for desktop template
 * Returns background color for nonGradient style
 * or background-image for gradient style
 *
 * @param colorsObj
 * @param foundationStyle
 * @returns
 */ function colorsStyle_old_render(colorsObj, foundationStyle) {
    // single color css
    if (!colorsObj.isGradient) {
        return {
            "background-color": colorsObj.colorFirst + " !important"
        };
    // gradient color css
    } else {
        return {
            "background-image": "linear-gradient(".concat(colorsObj.gradientAngle, "deg, ").concat(colorsObj.colorFirst, ", ").concat(colorsObj.colorSecond, ") !important")
        };
    }
}
/**
 * Renders ColorsOpt css for breakpoints/state templates
 * Returns background color for nonGradient style
 * or background-image for gradient style
 * or empty for non written style props
 *
 * @param colorsObj
 * @param foundationStyle
 * @returns
 */ function colorsStyle_old_renderOpt(colorsObj, foundationStyle) {
    // single color css
    if (!colorsObj.isGradient) {
        if (colorsObj.colorFirst) return {
            "background-color": colorsObj.colorFirst + " !important"
        };
    // gradient color css
    } else if (utils_objValueExists(colorsObj, "gradientAngle") && colorsObj.colorFirst && colorsObj.colorSecond) {
        return {
            "background-image": "linear-gradient(".concat(colorsObj.gradientAngle, "deg, ").concat(colorsObj.colorFirst, ", ").concat(colorsObj.colorSecond, ") !important")
        };
    }
    // no written style props
    return {};
}
/**
 * Fallback templateObj values to defaultObj value when needed
 * used for breakpoints/states(default) templates
 *
 * For values that are not written on the templateObj and are interpreted as css,
 * the fallback value shouldn't be used as the browser deals with the fallback by itself
 *
 * For values that are not interpreted as css, like isGradient, the fallback must be allways used when needed,
 * as this value will not be dealt by the browser
 *
 * For values that are needed together for a single css property,
 * if one of those values is written on the templateObj the other values must use the fallback value when needed
 *
 * @param colorsObj
 * @param defaultColorsObj
 * @returns Colors
 *
 */ function colorsStyle_old_mergeBob2(colorsObj, defaultColorsObj) {
    var isGradientValueWritten = colorsStyle_old_handleGradientValueWritten(colorsObj);
    var enable = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.enable;
    var isGradient = bobUtils_get2WithNull(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient, defaultColorsObj.isGradient);
    var colorFirst = bobUtils_get2WithNullConditional(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst, defaultColorsObj.colorFirst, (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten);
    var colorSecond = bobUtils_get2WithNullConditional(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond, defaultColorsObj.colorSecond, (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten);
    var gradientAngle = bobUtils_get2WithNullConditional(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle, defaultColorsObj.gradientAngle, (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten);
    var gradientDirection = bobUtils_get2WithNullConditional(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientDirection, defaultColorsObj.gradientDirection, (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten);
    return {
        enable: enable,
        colorFirst: colorFirst,
        colorSecond: colorSecond,
        gradientAngle: gradientAngle,
        gradientDirection: gradientDirection,
        isGradient: isGradient
    };
}
/**
 * Fallback templateObj values to defaultObj value when needed
 * used for globalstyles breakpoints/states(default) templates
 *
 * For values that are not written on the templateObj and are interpreted as css,
 * the fallback value shouldn't be used as the browser deals with the fallback by itself
 *
 * For values that are not interpreted as css, like isGradient, the fallback must be allways used when needed,
 * as this value will not be dealt by the browser
 *
 * For values that are needed together for a single css property,
 * if one of those values is written on the templateObj the other values must use the fallback value when needed
 *
 * @param colorsObj
 * @param defaultColorsObj
 * @returns ColorsProps
 *
 */ function colorsStyle_old_merge2(colorsObj, defaultColorsObj) {
    var isGradientValueWritten = colorsStyle_old_handleGradientValueWritten(colorsObj);
    var isGradient = get2WithNull(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient, defaultColorsObj.isGradient);
    var colorFirst = get2WithNullConditional(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst, defaultColorsObj.colorFirst, (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten);
    var colorSecond = get2WithNullConditional(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond, defaultColorsObj.colorSecond, (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten);
    var gradientAngle = get2WithNullConditional(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle, defaultColorsObj.gradientAngle, (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten);
    var gradientDirection = get2WithNullConditional(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientDirection, defaultColorsObj.gradientDirection, (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten);
    return {
        colorFirst: colorFirst,
        colorSecond: colorSecond,
        gradientAngle: gradientAngle,
        gradientDirection: gradientDirection,
        isGradient: isGradient
    };
}
/**
 * Fallback templateObj values to defaultObj value when needed
 * used for states inside breakpoints templates
 *
 * For values that are not written on the templateObj and are interpreted as css,
 * the fallback value shouldn't be used as the browser deals with the fallback by itself
 *
 * For values that are not interpreted as css, like isGradient, the fallback must be allways used when needed,
 * as this value will not be dealt by the browser
 *
 * For values that are needed together for a single css property,
 * if one of those values is written on the templateObj the other values must use the fallback value when needed
 *
 * @param colorsObj
 * @param colorsDefaultBreakpoint
 * @param defaultColorsObj
 * @returns Colors
 */ function colorsStyle_old_mergeBob3(colorsObj, colorsDesktopBehaviour, colorsDefaultBreakpoint, defaultColorsObj) {
    var isGradientValueWritten = colorsStyle_old_handleGradientValueWritten(colorsObj);
    var enable = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.enable;
    var ref, ref1, ref2;
    var isGradient = (ref2 = (ref1 = (ref = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) !== null && ref !== void 0 ? ref : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.isGradient) !== null && ref1 !== void 0 ? ref1 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.isGradient) !== null && ref2 !== void 0 ? ref2 : defaultColorsObj.isGradient;
    var ref3, ref4, ref5;
    var colorFirst = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten ? (ref5 = (ref4 = (ref3 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst) !== null && ref3 !== void 0 ? ref3 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.colorFirst) !== null && ref4 !== void 0 ? ref4 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.colorFirst) !== null && ref5 !== void 0 ? ref5 : defaultColorsObj.colorFirst : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst;
    var ref6, ref7, ref8;
    var colorSecond = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten ? (ref8 = (ref7 = (ref6 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond) !== null && ref6 !== void 0 ? ref6 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.colorSecond) !== null && ref7 !== void 0 ? ref7 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.colorSecond) !== null && ref8 !== void 0 ? ref8 : defaultColorsObj.colorSecond : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond;
    var ref9, ref10, ref11;
    var gradientAngle = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten ? (ref11 = (ref10 = (ref9 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle) !== null && ref9 !== void 0 ? ref9 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.gradientAngle) !== null && ref10 !== void 0 ? ref10 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.gradientAngle) !== null && ref11 !== void 0 ? ref11 : defaultColorsObj.gradientAngle : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle;
    var ref12, ref13, ref14;
    var gradientDirection = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten ? (ref14 = (ref13 = (ref12 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientDirection) !== null && ref12 !== void 0 ? ref12 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.gradientDirection) !== null && ref13 !== void 0 ? ref13 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.gradientDirection) !== null && ref14 !== void 0 ? ref14 : defaultColorsObj.gradientDirection : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientDirection;
    return {
        enable: enable,
        colorFirst: colorFirst,
        colorSecond: colorSecond,
        gradientAngle: gradientAngle,
        gradientDirection: gradientDirection,
        isGradient: isGradient
    };
}
/**
 * Fallback templateObj values to defaultObj value when needed
 * used for globalstyles states inside breakpoints templates
 *
 * For values that are not written on the templateObj and are interpreted as css,
 * the fallback value shouldn't be used as the browser deals with the fallback by itself
 *
 * For values that are not interpreted as css, like isGradient, the fallback must be allways used when needed,
 * as this value will not be dealt by the browser
 *
 * @param colorsObj
 * @param colorsDefaultBreakpoint
 * @param defaultColorsObj
 * @returns Colors
 */ function colorsStyle_old_merge3(colorsObj, colorsDesktopBehaviour, colorsDefaultBreakpoint, defaultColorsObj) {
    var isGradientValueWritten = colorsStyle_old_handleGradientValueWritten(colorsObj);
    var ref, ref1, ref2;
    var isGradient = (ref2 = (ref1 = (ref = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) !== null && ref !== void 0 ? ref : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.isGradient) !== null && ref1 !== void 0 ? ref1 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.isGradient) !== null && ref2 !== void 0 ? ref2 : defaultColorsObj.isGradient;
    var ref3, ref4, ref5;
    var colorFirst = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten ? (ref5 = (ref4 = (ref3 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst) !== null && ref3 !== void 0 ? ref3 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.colorFirst) !== null && ref4 !== void 0 ? ref4 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.colorFirst) !== null && ref5 !== void 0 ? ref5 : defaultColorsObj.colorFirst : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst;
    var ref6, ref7, ref8;
    var colorSecond = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten ? (ref8 = (ref7 = (ref6 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond) !== null && ref6 !== void 0 ? ref6 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.colorSecond) !== null && ref7 !== void 0 ? ref7 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.colorSecond) !== null && ref8 !== void 0 ? ref8 : defaultColorsObj.colorSecond : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond;
    var ref9, ref10, ref11;
    var gradientAngle = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten ? (ref11 = (ref10 = (ref9 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle) !== null && ref9 !== void 0 ? ref9 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.gradientAngle) !== null && ref10 !== void 0 ? ref10 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.gradientAngle) !== null && ref11 !== void 0 ? ref11 : defaultColorsObj.gradientAngle : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle;
    var ref12, ref13, ref14;
    var gradientDirection = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten ? (ref14 = (ref13 = (ref12 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientDirection) !== null && ref12 !== void 0 ? ref12 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.gradientDirection) !== null && ref13 !== void 0 ? ref13 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.gradientDirection) !== null && ref14 !== void 0 ? ref14 : defaultColorsObj.gradientDirection : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientDirection;
    return {
        colorFirst: colorFirst,
        colorSecond: colorSecond,
        gradientAngle: gradientAngle,
        gradientDirection: gradientDirection,
        isGradient: isGradient
    };
}
/**
 * Checks if at least one gradient needed value is written
 *
 * @param colorsObj
 * @returns
 */ function colorsStyle_old_handleGradientValueWritten(colorsObj) {
    var ref, ref1, ref2;
    return ((ref2 = (ref1 = (ref = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst) !== null && ref !== void 0 ? ref : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond) !== null && ref1 !== void 0 ? ref1 : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle) !== null && ref2 !== void 0 ? ref2 : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientDirection) ? true : false;
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/shadowStyle_old.ts





//Temp to handle nulls
var shadowStyle_old_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
/**
 * We should only check for property and undefined
 * this solution is only until we fix the null being send around the page object
 */ // props only, no enable
var shadowStyle_old_ShadowPropsCodec = (0,es6/* type */.dt)({
    inset: es6/* boolean */.O7,
    offsetH: es6/* number */.pk,
    offsetV: es6/* number */.pk,
    spread: es6/* number */.pk,
    blur: es6/* number */.pk,
    color: es6/* string */.Z_
});
var shadowStyle_old_ShadowCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    shadowStyle_old_ShadowPropsCodec
]);
// props only, no enable
var shadowStyle_old_ShadowPropsOptCodec = (0,es6/* partial */.r$)({
    inset: shadowStyle_old_nullable(es6/* boolean */.O7),
    offsetH: shadowStyle_old_nullable(es6/* number */.pk),
    offsetV: shadowStyle_old_nullable(es6/* number */.pk),
    spread: shadowStyle_old_nullable(es6/* number */.pk),
    blur: shadowStyle_old_nullable(es6/* number */.pk),
    color: shadowStyle_old_nullable(es6/* string */.Z_)
});
var shadowStyle_old_ShadowOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: shadowStyle_old_nullable(es6/* boolean */.O7)
    }),
    shadowStyle_old_ShadowPropsOptCodec
]);
var shadowStyle_old_StylesShadowCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        shadow: shadowStyle_old_ShadowCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                shadow: shadowStyle_old_ShadowOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                shadow: shadowStyle_old_ShadowOptCodec
            })
        }),
        mobile: (0,es6/* partial */.r$)({
            shadow: shadowStyle_old_ShadowOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    shadow: shadowStyle_old_ShadowOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    shadow: shadowStyle_old_ShadowOptCodec
                })
            })
        }),
        tablet: (0,es6/* partial */.r$)({
            shadow: shadowStyle_old_ShadowOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    shadow: shadowStyle_old_ShadowOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    shadow: shadowStyle_old_ShadowOptCodec
                })
            })
        })
    }), 
]);
var shadowStyle_old_GSShadowCodec = (0,es6/* intersection */.jV)([
    shadowStyle_old_ShadowPropsCodec,
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: shadowStyle_old_ShadowPropsOptCodec,
            hover: shadowStyle_old_ShadowPropsOptCodec
        }),
        mobile: (0,es6/* intersection */.jV)([
            shadowStyle_old_ShadowPropsOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: shadowStyle_old_ShadowPropsOptCodec,
                    hover: shadowStyle_old_ShadowPropsOptCodec
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            shadowStyle_old_ShadowPropsOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: shadowStyle_old_ShadowPropsOptCodec,
                    hover: shadowStyle_old_ShadowPropsOptCodec
                })
            }), 
        ])
    }), 
]);
function shadowStyle_old_boxShadowCss(css) {
    if (css.hasOwnProperty("box-shadow")) return css["box-shadow"];
    return "";
}
function shadowStyle_old_textShadowCss(css) {
    if (css.hasOwnProperty("text-shadow")) return css["text-shadow"];
    return "";
}
function shadowStyle_old_responsiveStyle(shadowObj, optionalProperties, desktopDefaultValues, breakpointDefaultValues) {
    var hasEnable = shadowObj.hasOwnProperty("enable");
    if (hasEnable && !objValueExists(shadowObj, "enable")) return "";
    /**
   * Check if property is available, and fallback to breakpointDefault or the desktopDefault
   */ var inset = (shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.inset) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.inset) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.inset);
    var offsetH = (shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetH) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.offsetH) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.offsetH);
    var offsetV = (shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetV) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.offsetV) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.offsetV);
    var blur = (shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.blur) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.blur) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.blur);
    var color = (shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.color) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.color) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.color);
    var spread = (shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.spread) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.spread) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.spread);
    // other props like text-shadow
    if (optionalProperties && optionalProperties.shadowType) {
        if (hasEnable && !shadowObj.enable) return _define_property({}, "".concat(optionalProperties.shadowType, "-shadow"), "none !important");
        return _define_property({}, "".concat(optionalProperties.shadowType, "-shadow"), "".concat(inset ? "inset " : "").concat(offsetH, "px ").concat(offsetV, "px ").concat(blur, "px ").concat(color, " !important"));
    }
    // box shadow prop
    if (hasEnable && !shadowObj.enable) return {
        "box-shadow": "none !important"
    };
    return {
        "box-shadow": "".concat(inset ? "inset " : "").concat(offsetH, "px ").concat(offsetV, "px ").concat(blur, "px ").concat(spread, "px ").concat(color, " !important")
    };
}
function shadowStyle_old_cssRenderUnsafe(stylesObj, breakpoint, behaviourState, shadowType) {
    var foundationStyle = arguments.length > 4 && arguments[4] !== void 0 // TODO: fix when working on other bobs
     ? arguments[4] : undefined;
    var styles = shadowStyle_old_StylesShadowCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return shadowStyle_old_cssRender(styles.right, breakpoint, behaviourState, shadowType, foundationStyle);
    console.warn(codecUtils_decoderErrors(styles));
    return "";
}
function shadowStyle_old_globalStyleCssRenderUnsafe(gsObj, breakpoint, behaviourState, shadowType) {
    var foundationStyle = arguments.length > 4 && arguments[4] !== void 0 // TODO: Work on when foundation is added to global styles
     ? arguments[4] : undefined;
    var gs = shadowStyle_old_GSShadowCodec.decode(gsObj);
    if (isRight(gs)) return shadowStyle_old_globalStyleCssRender(gs.right, breakpoint, behaviourState, shadowType, foundationStyle);
    console.warn(decoderErrors(gs));
    return "";
}
function shadowStyle_old_zIndexFix(desktopDefaultShadowEnable, desktopDefaultScroll, objPosition) {
    if (desktopDefaultShadowEnable === false) {
        return "";
    }
    if (typeof objPosition === "number") {
        var defaultZIndex = 20;
        var computedZIndex = defaultZIndex - objPosition;
        var cssPosition = desktopDefaultScroll.enable && desktopDefaultScroll.value === "static" || !desktopDefaultScroll.enable ? "relative" : desktopDefaultScroll.value;
        if (computedZIndex <= 0) {
            return {
                "z-index": "1 !important",
                position: "".concat(cssPosition, " !important")
            };
        }
        return {
            "z-index": "".concat(computedZIndex, " !important"),
            position: "".concat(cssPosition, " !important")
        };
    }
    return "";
}
function shadowStyle_old_cssRender(stylesObj, breakpoint, behaviourState, shadowType, foundationStyle) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return shadowStyle_old_renderBob(stylesObj.shadow, shadowType, foundationStyle);
        } else {
            var ref, ref1;
            return shadowStyle_old_renderBob(shadowStyle_old_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.shadow, stylesObj.shadow), shadowType, foundationStyle);
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return shadowStyle_old_renderBob(shadowStyle_old_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.shadow, stylesObj.shadow), shadowType, foundationStyle);
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return shadowStyle_old_renderBob(shadowStyle_old_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.shadow, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.shadow, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.shadow, stylesObj.shadow), shadowType, foundationStyle);
        }
    }
}
function shadowStyle_old_globalStyleCssRender(stylesObj, breakpoint, behaviourState, shadowType, foundationStyle) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return shadowStyle_old_render(stylesObj, shadowType, foundationStyle);
        } else {
            var ref;
            return shadowStyle_old_render(shadowStyle_old_merge2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : ref[behaviourState], stylesObj), shadowType, foundationStyle);
        }
    } else {
        if (behaviourState === "default") {
            return shadowStyle_old_render(shadowStyle_old_merge2(stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj), shadowType, foundationStyle);
        } else {
            var ref1, ref2, ref3;
            return shadowStyle_old_render(shadowStyle_old_merge3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref1 = stylesObj[breakpoint]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : ref2[behaviourState], (ref3 = stylesObj.behaviour) === null || ref3 === void 0 ? void 0 : ref3[behaviourState], stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj), shadowType, foundationStyle);
        }
    }
}
function shadowStyle_old_renderBob(shadowObj, shadowType, foundationStyle) {
    if (!shadowObj.enable) return shadowStyle_old_cssProperty("none !important", shadowType);
    return shadowStyle_old_render(shadowObj, shadowType, foundationStyle);
}
function shadowStyle_old_render(shadowObj, shadowType, foundationStyle) {
    var isBox = shadowType === "box" ? " ".concat(shadowObj.spread, "px") : "";
    var cssValue = "".concat(shadowObj.inset ? "inset " : "").concat(shadowObj.offsetH, "px ").concat(shadowObj.offsetV, "px ").concat(shadowObj.blur, "px").concat(isBox, " ").concat(shadowObj.color, " !important");
    // TODO: foundation color reverted
    // }px${isBox} ${foundationStyle ? foundationStyle.color : shadowObj.color} !important`
    return shadowStyle_old_cssProperty(cssValue, shadowType);
}
function shadowStyle_old_cssProperty(cssValue, shadowType) {
    return shadowType === "box" ? {
        "box-shadow": cssValue
    } : {
        "text-shadow": cssValue
    };
}
/**
 *
 * @param shadowObj
 * @param defaultShadowObj
 * @returns Shadow
 *
 */ function shadowStyle_old_mergeBob2(shadowObj, defaultShadowObj) {
    var enable = shadowStyle_old_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.enable, defaultShadowObj.enable);
    var inset = shadowStyle_old_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.inset, defaultShadowObj.inset);
    var offsetH = shadowStyle_old_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetH, defaultShadowObj.offsetH);
    var offsetV = shadowStyle_old_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetV, defaultShadowObj.offsetV);
    var blur = shadowStyle_old_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.blur, defaultShadowObj.blur);
    var color = shadowStyle_old_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.color, defaultShadowObj.color);
    var spread = shadowStyle_old_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.spread, defaultShadowObj.spread);
    return {
        enable: enable,
        inset: inset,
        offsetH: offsetH,
        offsetV: offsetV,
        blur: blur,
        color: color,
        spread: spread
    };
}
/**
 *
 * @param shadowObj
 * @param defaultShadowObj
 * @returns ShadowProps
 *
 */ function shadowStyle_old_merge2(shadowObj, defaultShadowObj) {
    var inset = shadowStyle_old_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.inset, defaultShadowObj.inset);
    var offsetH = shadowStyle_old_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetH, defaultShadowObj.offsetH);
    var offsetV = shadowStyle_old_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetV, defaultShadowObj.offsetV);
    var blur = shadowStyle_old_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.blur, defaultShadowObj.blur);
    var color = shadowStyle_old_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.color, defaultShadowObj.color);
    var spread = shadowStyle_old_get2WithNull(shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.spread, defaultShadowObj.spread);
    return {
        inset: inset,
        offsetH: offsetH,
        offsetV: offsetV,
        blur: blur,
        color: color,
        spread: spread
    };
}
/**
 *
 * @param shadowObj
 * @param shadowDefaultBreakpoint
 * @param defaultShadowObj
 * @returns Shadow
 */ function shadowStyle_old_mergeBob3(shadowObj, shadowDesktopBehaviour, shadowDefaultBreakpoint, defaultShadowObj) {
    var ref, ref1, ref2;
    var enable = (ref2 = (ref1 = (ref = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.enable) !== null && ref !== void 0 ? ref : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.enable) !== null && ref1 !== void 0 ? ref1 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.enable) !== null && ref2 !== void 0 ? ref2 : defaultShadowObj.enable;
    var ref3, ref4, ref5;
    var inset = (ref5 = (ref4 = (ref3 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.inset) !== null && ref3 !== void 0 ? ref3 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.inset) !== null && ref4 !== void 0 ? ref4 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.inset) !== null && ref5 !== void 0 ? ref5 : defaultShadowObj.inset;
    var ref6, ref7, ref8;
    var offsetH = (ref8 = (ref7 = (ref6 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetH) !== null && ref6 !== void 0 ? ref6 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.offsetH) !== null && ref7 !== void 0 ? ref7 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.offsetH) !== null && ref8 !== void 0 ? ref8 : defaultShadowObj.offsetH;
    var ref9, ref10, ref11;
    var offsetV = (ref11 = (ref10 = (ref9 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetV) !== null && ref9 !== void 0 ? ref9 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.offsetV) !== null && ref10 !== void 0 ? ref10 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.offsetV) !== null && ref11 !== void 0 ? ref11 : defaultShadowObj.offsetV;
    var ref12, ref13, ref14;
    var blur = (ref14 = (ref13 = (ref12 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.blur) !== null && ref12 !== void 0 ? ref12 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.blur) !== null && ref13 !== void 0 ? ref13 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.blur) !== null && ref14 !== void 0 ? ref14 : defaultShadowObj.blur;
    var ref15, ref16, ref17;
    var color = (ref17 = (ref16 = (ref15 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.color) !== null && ref15 !== void 0 ? ref15 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.color) !== null && ref16 !== void 0 ? ref16 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.color) !== null && ref17 !== void 0 ? ref17 : defaultShadowObj.color;
    var ref18, ref19, ref20;
    var spread = (ref20 = (ref19 = (ref18 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.spread) !== null && ref18 !== void 0 ? ref18 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.spread) !== null && ref19 !== void 0 ? ref19 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.spread) !== null && ref20 !== void 0 ? ref20 : defaultShadowObj.spread;
    return {
        enable: enable,
        inset: inset,
        offsetH: offsetH,
        offsetV: offsetV,
        blur: blur,
        color: color,
        spread: spread
    };
}
/**
 *
 * @param shadowObj
 * @param shadowDefaultBreakpoint
 * @param defaultShadowObj
 * @returns Shadow
 */ function shadowStyle_old_merge3(shadowObj, shadowDesktopBehaviour, shadowDefaultBreakpoint, defaultShadowObj) {
    var ref, ref1, ref2;
    var inset = (ref2 = (ref1 = (ref = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.inset) !== null && ref !== void 0 ? ref : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.inset) !== null && ref1 !== void 0 ? ref1 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.inset) !== null && ref2 !== void 0 ? ref2 : defaultShadowObj.inset;
    var ref3, ref4, ref5;
    var offsetH = (ref5 = (ref4 = (ref3 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetH) !== null && ref3 !== void 0 ? ref3 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.offsetH) !== null && ref4 !== void 0 ? ref4 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.offsetH) !== null && ref5 !== void 0 ? ref5 : defaultShadowObj.offsetH;
    var ref6, ref7, ref8;
    var offsetV = (ref8 = (ref7 = (ref6 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.offsetV) !== null && ref6 !== void 0 ? ref6 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.offsetV) !== null && ref7 !== void 0 ? ref7 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.offsetV) !== null && ref8 !== void 0 ? ref8 : defaultShadowObj.offsetV;
    var ref9, ref10, ref11;
    var blur = (ref11 = (ref10 = (ref9 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.blur) !== null && ref9 !== void 0 ? ref9 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.blur) !== null && ref10 !== void 0 ? ref10 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.blur) !== null && ref11 !== void 0 ? ref11 : defaultShadowObj.blur;
    var ref12, ref13, ref14;
    var color = (ref14 = (ref13 = (ref12 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.color) !== null && ref12 !== void 0 ? ref12 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.color) !== null && ref13 !== void 0 ? ref13 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.color) !== null && ref14 !== void 0 ? ref14 : defaultShadowObj.color;
    var ref15, ref16, ref17;
    var spread = (ref17 = (ref16 = (ref15 = shadowObj === null || shadowObj === void 0 ? void 0 : shadowObj.spread) !== null && ref15 !== void 0 ? ref15 : shadowDesktopBehaviour === null || shadowDesktopBehaviour === void 0 ? void 0 : shadowDesktopBehaviour.spread) !== null && ref16 !== void 0 ? ref16 : shadowDefaultBreakpoint === null || shadowDefaultBreakpoint === void 0 ? void 0 : shadowDefaultBreakpoint.spread) !== null && ref17 !== void 0 ? ref17 : defaultShadowObj.spread;
    return {
        inset: inset,
        offsetH: offsetH,
        offsetV: offsetV,
        blur: blur,
        color: color,
        spread: spread
    };
}
//Fallback when not declared
function shadowStyle_old_get2(x, y) {
    return typeof x === "undefined" ? y : x;
}
//Temp with nulls
function shadowStyle_old_get2WithNull(x, y) {
    return typeof x === "undefined" || x === null ? y : x;
}

;// CONCATENATED MODULE: ./src/modules/shared-modules/utilities/conditionalController.ts













/**
 * Alignment version
 *
 */ function alignment(template) {
    var ref;
    var controllerVersion = (ref = template.controllerVersion) === null || ref === void 0 ? void 0 : ref.alignment;
    /**
   * return version 1 fix
   */ if (controllerVersion === 1) return defaultAlign(template);
    /**
   * return old logic
   */ var alignmentStyles = handleAlignment(template);
    var tabletAlignment = responsiveProperties(template, "tablet", {
        alignment: {}
    }, [], [
        "alignment"
    ]);
    var mobileAlignment = responsiveProperties(template, "mobile", {
        alignment: {}
    }, [], [
        "alignment"
    ]);
    return {
        alignmentStyles: alignmentStyles,
        tabletAlignment: tabletAlignment,
        mobileAlignment: mobileAlignment
    };
}
function alignmentWithAP(template, alignmentAdittionalProperties) {
    var ref;
    var controllerVersion = (ref = template.controllerVersion) === null || ref === void 0 ? void 0 : ref.alignment;
    /**
   * return version 1 fix
   */ if (controllerVersion === 1) {
        return specificAlign(template, alignmentAdittionalProperties);
    }
    /**
   * return old logic
   */ var alignmentStyles = handleAlignment(template, alignmentAdittionalProperties.flexDirection);
    var tabletAlignment = responsiveProperties(template, "tablet", {
        alignment: {
            flexDirection: alignmentAdittionalProperties.flexDirection
        }
    }, [], [
        "alignment"
    ]);
    var mobileAlignment = responsiveProperties(template, "mobile", {
        alignment: {
            flexDirection: alignmentAdittionalProperties.flexDirection
        }
    }, [], [
        "alignment"
    ]);
    return {
        alignmentStyles: alignmentStyles,
        tabletAlignment: tabletAlignment,
        mobileAlignment: mobileAlignment
    };
}
/**
 * Border version
 *
 */ function conditionalBorderRenderUnsafe(template, breakpoint, state, renderImportant) {
    var ref;
    var controllerVersion = (ref = template.controllerVersion) === null || ref === void 0 ? void 0 : ref.border;
    /**
   * return version 1 fix
   */ if (controllerVersion === 1) return borderStyle_cssRenderUnsafe(template, breakpoint, state);
    /**
   * return old logic
   */ return borderStyle_old_cssRenderUnsafe(template, breakpoint, state);
}
function conditionalBorderCss(borderStyle, controllerVersion) {
    /**
   * return version 1 fix
   */ if (controllerVersion === 1) return borderStyle_renderCSSString(borderStyle);
    /**
   * return old logic
   */ var borderStyle_old = borderStyle;
    return "\n    border-bottom-style: ".concat(borderStyle_old["border-bottom-style"], ";\n    border-bottom-width: ").concat(borderStyle_old["border-bottom-width"], ";\n    border-bottom-color: ").concat(borderStyle_old["border-bottom-color"], ";\n    border-top-style: ").concat(borderStyle_old["border-top-style"], ";\n    border-top-width: ").concat(borderStyle_old["border-top-width"], ";\n    border-top-color: ").concat(borderStyle_old["border-top-color"], ";\n    border-left-style: ").concat(borderStyle_old["border-left-style"], ";\n    border-left-width: ").concat(borderStyle_old["border-left-width"], ";\n    border-left-color: ").concat(borderStyle_old["border-left-color"], ";\n    border-right-style: ").concat(borderStyle_old["border-right-style"], ";\n    border-right-width: ").concat(borderStyle_old["border-right-width"], ";\n    border-right-color: ").concat(borderStyle_old["border-right-color"], ";\n  ");
}
/**
 * Boundary version
 *
 */ function conditionalBoundaryRenderUnsafe(template, breakpoint, state) {
    var ref;
    var controllerVersion = (ref = template.controllerVersion) === null || ref === void 0 ? void 0 : ref.spacing;
    /**
   * return version 1 fix
   */ if (controllerVersion === 1) return boundaryStyle_cssRenderUnsafe(template, breakpoint, state);
    /**
   * return old logic
   */ return boundaryStyle_old_cssRenderUnsafe(template, breakpoint, state);
}
/**
 * Shadow version
 *
 */ function conditionalShadowRenderUnsafe(template, breakpoint, state, shadowType, foundationStyle) {
    var ref;
    var controllerVersion = (ref = template.controllerVersion) === null || ref === void 0 ? void 0 : ref.shadow;
    /**
   * return version 1 fix
   */ if (controllerVersion === 1) return cssRenderUnsafe(template, breakpoint, state, shadowType, foundationStyle);
    /**
   * return old logic
   */ return shadowStyle_old_cssRenderUnsafe(template, breakpoint, state, shadowType, foundationStyle);
}
/**
 * Colors version
 *
 */ function conditionalColorsRenderUnsafe(template, breakpoint, state, shouldRenderImportant) {
    var ref;
    var controllerVersion = (ref = template.controllerVersion) === null || ref === void 0 ? void 0 : ref.colors;
    /**
   * return version 1 fix
   */ if (controllerVersion === 1) return colorsStyle_cssRenderUnsafe(template, breakpoint, state, undefined);
    /**
   * return old logic
   */ return colorsStyle_old_cssRenderUnsafe(template, breakpoint, state);
}
/**
 * writeVersion
 *
 */ function writeVersion(controller, bobKey) {
    var BobKey = bobKey.slice(0, -1);
    var capitalizedBobKey = BobKey.charAt(0).toUpperCase() + BobKey.slice(1);
    var version = ControllerVersion[controller];
    if (version === null || version === void 0 ? void 0 : version.all) {
        return _define_property({}, controller, version.all);
    } else if (version === null || version === void 0 ? void 0 : version[BobKey]) {
        return _define_property({}, "".concat(controller).concat(capitalizedBobKey), version[BobKey]);
    }
    return undefined;
}

// EXTERNAL MODULE: ./node_modules/react-content-loader/dist/react-content-loader.es.js
var react_content_loader_es = __webpack_require__(24561);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobLoading.tsx







var BobLoading = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(BobLoading, _Component);
    var _super = (0,_create_super/* default */.Z)(BobLoading);
    function BobLoading() {
        (0,src_class_call_check/* default */.Z)(this, BobLoading);
        return _super.apply(this, arguments);
    }
    var _proto = BobLoading.prototype;
    _proto.renderMoreLines = function renderMoreLines() {
        var _props = this.props, mappedValue = _props.mappedValue, fontSize = _props.fontSize;
        var fixedFontSize = fontSize || 20;
        if (mappedValue) {
            if (mappedValue.includes("description_preview")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "0",
                            y: "0",
                            rx: "3",
                            ry: "3",
                            width: "100%",
                            height: fixedFontSize
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "0",
                            y: fixedFontSize + fixedFontSize / 2,
                            rx: "3",
                            ry: "3",
                            width: "100%",
                            height: fixedFontSize
                        })
                    ]
                });
            }
            if (mappedValue.includes("description")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "0",
                            y: "0",
                            rx: "3",
                            ry: "3",
                            width: "100%",
                            height: fixedFontSize
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "0",
                            y: fixedFontSize + fixedFontSize / 2,
                            rx: "3",
                            ry: "3",
                            width: "100%",
                            height: fixedFontSize
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "0",
                            y: fixedFontSize * 3,
                            rx: "3",
                            ry: "3",
                            width: "100%",
                            height: fixedFontSize
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "0",
                            y: fixedFontSize * 4 + fixedFontSize / 2,
                            rx: "3",
                            ry: "3",
                            width: "100%",
                            height: fixedFontSize
                        })
                    ]
                });
            }
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
            x: "0",
            y: "0",
            rx: "3",
            ry: "3",
            width: "100%",
            height: fixedFontSize
        });
    };
    _proto.loadingHeight = function loadingHeight() {
        var _props = this.props, mappedValue = _props.mappedValue, fontSize = _props.fontSize;
        var fixedFontSize = fontSize || 20;
        if (mappedValue) {
            if (mappedValue.includes("description_preview")) {
                return fixedFontSize * 3;
            }
            if (mappedValue.includes("description")) {
                return fixedFontSize * 6;
            }
        }
        return fixedFontSize;
    };
    _proto.isLoading = function isLoading(contentSrc) {
        if (contentSrc === "content-page") return this.props.loadingPublicContentPagePost || this.props.loadingPreviewContentPagePost;
        if (contentSrc === "post") return this.props.contentFetch["content".concat(this.props.uuid, "loading")];
    };
    _proto.render = function render() {
        var _props = this.props, contentSrc = _props.contentSrc, type = _props.type;
        if ((contentSrc === "content-page" || contentSrc === "post") && this.isLoading(contentSrc)) {
            if (type === "text") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_content_loader_es/* default */.ZP, {
                    height: this.loadingHeight(),
                    width: "100%",
                    children: this.renderMoreLines()
                });
            }
            if (type === "media") {
                var _props1 = this.props, mediaHeight = _props1.mediaHeight, mediaWidth = _props1.mediaWidth;
                var fixedWidth = mediaWidth !== null && mediaWidth !== void 0 ? mediaWidth : "100%";
                var fixedHeight = mediaHeight !== null && mediaHeight !== void 0 ? mediaHeight : 500;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_content_loader_es/* default */.ZP, {
                    height: fixedHeight,
                    width: fixedWidth,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "0",
                        y: "0",
                        rx: "3",
                        ry: "3",
                        width: fixedWidth,
                        height: fixedHeight
                    })
                });
            }
        }
        return this.props.children;
    };
    return BobLoading;
}(react.Component);
function mapStateToProps(state) {
    return {
        loadingPublicContentPagePost: state.contentLibraryReducer.loadingPublicContentPagePost,
        loadingPreviewContentPagePost: state.contentLibraryReducer.loadingPreviewContentPagePost,
        contentFetch: state.contentHubReducer
    };
}
/* harmony default export */ var bobLoading = ((0,es/* connect */.$j)(mapStateToProps)(BobLoading));

// EXTERNAL MODULE: ./node_modules/he/he.js
var he = __webpack_require__(86492);
var he_default = /*#__PURE__*/__webpack_require__.n(he);
;// CONCATENATED MODULE: ./src/split/shared-public-page/bobTextSplit.tsx






function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n@media only screen and (max-width: 992px) and (min-width: 767px) {\n    ",
        "\n    ",
        "\n  }\n  @media all and (max-width: 766px) {\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var BobTextDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e10eab2b-0"
})(_templateObject(), function(props) {
    return props.desktop;
}, function(props) {
    return props.safeCustomTextTag ? innerTagsStyles : "";
}, function(props) {
    return props.tablet;
}, function(props) {
    return props.safeCustomTextTag ? innerTagsStyles : "";
}, function(props) {
    return props.mobile;
}, function(props) {
    return props.safeCustomTextTag ? innerTagsStyles : "";
});
/**
 * Must force bob styles on inner text tags
 * so that the text element default styles are overriden by bob styles
 *
 * Applies only to customText with safe flag
 */ var innerTagsStyles = "\n h1, h2, h3, h4, h5, h6, p, a {\n   font-family: inherit !important;\n   font-size: inherit !important;\n   font-weight: inherit !important;\n   line-height: inherit !important;\n   letter-spacing: inherit !important;\n   margin: 0 !important;\n }";
var BobTextSplit = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(BobTextSplit, _Component);
    var _super = (0,_create_super/* default */.Z)(BobTextSplit);
    function BobTextSplit(props) {
        (0,src_class_call_check/* default */.Z)(this, BobTextSplit);
        var _this;
        _this = _super.call(this, props);
        _this.renderHtml = function(styles, classPrefix, classes) {
            var desktopStyles = _this.props.handleCmsStyles(styles.templateStyles);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BobTextDiv, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, _this.props.datasetRender), {
                desktop: desktopStyles,
                mobile: styles.mobileStyles,
                tablet: styles.tabletStyles,
                id: handleDOMid(_this.props.field, _this.props.id, _this.props.instanceId),
                dangerouslySetInnerHTML: {
                    __html: _this.props.value
                },
                className: "".concat(_this.props.network === "grafly" ? "ql-editor" : "", " dangerousHTML ").concat(classPrefix, "-bob-text-container bob-text ").concat(classes),
                safeCustomTextTag: false
            }));
        };
        _this.renderCustomContent = function(styles, tag, classes, linkAttrs) {
            var desktopStyles = _this.props.handleCmsStyles(styles.templateStyles);
            var customText = components_getOverrideInlineContentValues("".concat(_this.props.field, ".customText"), _this.props);
            var safeCustomTextTag = _this.props.inlineContent["".concat(_this.props.field, ".safeCustomTextTag")];
            // legacy fix: for older bobText's use tag, for new ones use DIV so that the html is valid.
            // when link is enabled tag must be 'a'
            var TAG = safeCustomTextTag ? "div" : tag;
            TAG = components_getOverrideInlineContentValues("".concat(_this.props.field, ".behaviour-link-enable"), _this.props) ? "a" : TAG;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BobTextDiv, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, _this.props.datasetRender), {
                onClick: function(e) {
                    _this.props.clickEvent(e, tag);
                },
                as: TAG
            }), linkAttrs), {
                id: handleDOMid(_this.props.field, _this.props.id, _this.props.instanceId),
                dangerouslySetInnerHTML: {
                    __html: customText
                },
                className: " dangerousHTML ql-text ".concat(classes),
                desktop: desktopStyles,
                mobile: styles.mobileStyles,
                tablet: styles.tabletStyles,
                safeCustomTextTag: safeCustomTextTag
            }));
        };
        /**
   * Apply legacy fix to invalid html
   *
   * @param styles
   * @param tag
   * @param classes
   * @param linkAttrs
   * @returns
   */ _this.renderCustomContentLegacyFix = function(styles, tag, classes, linkAttrs) {
            var desktopStyles = _this.props.handleCmsStyles(styles.templateStyles);
            var customText = components_getOverrideInlineContentValues("".concat(_this.props.field, ".customText"), _this.props);
            var safeCustomTextTag = _this.props.inlineContent["".concat(_this.props.field, ".safeCustomTextTag")];
            // when link is enabled tag must be 'a'
            var TAG = components_getOverrideInlineContentValues("".concat(_this.props.field, ".behaviour-link-enable"), _this.props) ? "a" : tag;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BobTextDiv, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, _this.props.datasetRender), {
                onClick: function(e) {
                    _this.props.clickEvent(e, tag);
                },
                as: TAG
            }), linkAttrs), {
                id: handleDOMid(_this.props.field, _this.props.id, _this.props.instanceId),
                className: " dangerousHTML ql-text ".concat(classes),
                desktop: desktopStyles,
                mobile: styles.mobileStyles,
                tablet: styles.tabletStyles,
                dangerouslySetInnerHTML: {
                    __html: _this.state.customTextCanRender ? customText : ""
                },
                safeCustomTextTag: safeCustomTextTag
            }));
        };
        _this.renderCustomTag = function(styles, tag, linkAttrs, classes) {
            var desktopStyles = _this.props.handleCmsStyles(styles.templateStyles);
            // parse and render timestamp
            var value = _this.props.value;
            //if (value !== "" && moment.unix(value).isValid()) value = moment.unix(value).format("DD/MM/YYYY")
            // when link is enabled tag must be 'a'
            var TAG = components_getOverrideInlineContentValues("".concat(_this.props.field, ".behaviour-link-enable"), _this.props) ? "a" : tag;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BobTextDiv, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, _this.props.datasetRender), {
                as: TAG,
                id: handleDOMid(_this.props.field, _this.props.id, _this.props.instanceId)
            }), linkAttrs), {
                className: classes,
                desktop: desktopStyles,
                mobile: styles.mobileStyles,
                tablet: styles.tabletStyles,
                safeCustomTextTag: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobLoading, {
                    type: "text",
                    uuid: getComposedUuid(_this.props.pageResponse.objects[_this.props.id]),
                    contentSrc: components_getOverrideInlineContentValues("".concat(_this.props.field, ".contentSrc"), _this.props),
                    mappedValue: components_getOverrideInlineContentValues("".concat(_this.props.field, ".mappedValue"), _this.props),
                    fontSize: styles.templateStyles.fontSize,
                    children: value && value !== "" ? typeof value !== "number" ? he_default().decode(value) : value : ""
                })
            }));
        };
        _this.render = function() {
            /**
     * Render cms html
     */ if (_this.props.textType === "renderHtml") {
                return _this.renderHtml({
                    templateStyles: _this.props.templateStyles,
                    tabletStyles: _this.props.tabletStyles,
                    mobileStyles: _this.props.mobileStyles
                }, _this.props.classPrefix, _this.props.classes);
            }
            /**
     * Render inline custom content
     * When safeCustomTextTag flag is false/undefined a legacy fix should be applied
     *
     * Legacy fix
     */ if (_this.props.textType === "renderCustomContent") {
                var safeCustomTextTag = components_getOverrideInlineContentValues("".concat(_this.props.field, ".safeCustomTextTag"), _this.props);
                if (safeCustomTextTag) return _this.renderCustomContent({
                    templateStyles: _this.props.templateStyles,
                    tabletStyles: _this.props.tabletStyles,
                    mobileStyles: _this.props.mobileStyles
                }, _this.props.tag, _this.props.classes, _this.props.linkAttrs);
                else return _this.renderCustomContentLegacyFix({
                    templateStyles: _this.props.templateStyles,
                    tabletStyles: _this.props.tabletStyles,
                    mobileStyles: _this.props.mobileStyles
                }, _this.props.tag, _this.props.classes, _this.props.linkAttrs);
            }
            /**
     * Render cms html with no valid html
     */ if (_this.props.textType === "renderCustomTag") {
                return _this.renderCustomTag({
                    templateStyles: _this.props.templateStyles,
                    tabletStyles: _this.props.tabletStyles,
                    mobileStyles: _this.props.mobileStyles
                }, _this.props.tag, _this.props.linkAttrs, _this.props.classes);
            }
        };
        _this.state = {
            customTextCanRender: false
        };
        return _this;
    }
    var _proto = BobTextSplit.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this.state), {
            customTextCanRender: true
        }));
    };
    return BobTextSplit;
}(react.Component);
/* harmony default export */ var bobTextSplit = (BobTextSplit);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/colorStyle.ts





//Temp to handle nulls
var colorStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
/**
 * We should only check for property and undefined
 * this solution is only until we fix the null being send around the page object
 */ var ColorCodec = es6/* string */.Z_;
var ColorOptCodec = colorStyle_nullable(es6/* string */.Z_);
var StylesColorCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        color: ColorCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                color: ColorOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                color: ColorOptCodec
            })
        }),
        mobile: (0,es6/* partial */.r$)({
            color: ColorOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    color: ColorOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    color: ColorOptCodec
                })
            })
        }),
        tablet: (0,es6/* partial */.r$)({
            color: ColorOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    color: ColorOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    color: ColorOptCodec
                })
            })
        })
    }), 
]);
function colorCss(css) {
    if (css.hasOwnProperty("color")) return css["color"];
    return "";
}
function colorStyle_responsiveStyle(colorValue, desktopDefaultValues, breakpointDefaultValues) {
    /**
   * Check if property is available, and fallback to breakpointDefault or the desktopDefault
   */ var color = colorValue || breakpointDefaultValues || desktopDefaultValues;
    // color prop
    return {
        color: "".concat(color, " !important")
    };
}
function colorStyle_renderCSSString(stylesObj) {
    return "\n    ".concat(bobUtils_showIfWritten(stylesObj, "color"), " \n    ");
}
function colorStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var foundationStyle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : undefined, stylesheetLabel = arguments.length > 4 ? arguments[4] : void 0, shouldRenderImportant = arguments.length > 5 ? arguments[5] : void 0;
    var styles = StylesColorCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return colorStyle_cssRender(styles.right, breakpoint, behaviourState, foundationStyle, stylesheetLabel, shouldRenderImportant);
    console.warn(codecUtils_decoderErrors(styles));
    return {
        color: "#000"
    };
}
// export function globalStyleCssRenderUnsafe(
//   gsObj: any,
//   breakpoint: Breakpoint,
//   behaviourState: BehaviourState_,
//   foundationStyle: FColor | undefined = undefined // TODO: Work on when foundation is added to global styles
// ): ColorCSS | "" {
//   const gs = GSColorCodec.decode(gsObj)
//   if (isRight(gs)) return globalStyleCssRender(gs.right, breakpoint, behaviourState, foundationStyle)
//   console.warn(decoderErrors(gs))
//   return ""
// }
function colorStyle_cssRender(stylesObj, breakpoint, behaviourState, foundationStyle, stylesheetLabel, shouldRenderImportant) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return colorStyle_renderBob(stylesObj.color, foundationStyle, stylesheetLabel, shouldRenderImportant);
        } else {
            var ref, ref1;
            return colorStyle_renderBobOpt(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.color, foundationStyle, stylesheetLabel, shouldRenderImportant);
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return colorStyle_renderBobOpt(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.color, foundationStyle, stylesheetLabel, shouldRenderImportant);
        } else {
            var ref3, ref4, ref5;
            return colorStyle_renderBobOpt(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.color, foundationStyle, stylesheetLabel, shouldRenderImportant);
        }
    }
}
// export function globalStyleCssRender(
//   stylesObj: GSColor,
//   breakpoint: Breakpoint,
//   behaviourState: BehaviourState_,
//   foundationStyle: FColor | undefined
// ): ColorCSS {
//   if (breakpoint === "desktop") {
//     if (behaviourState === "default") {
//       return render(stylesObj, foundationStyle)
//     }
//     //hover | active
//     else {
//       return render(merge2(stylesObj?.behaviour?.[behaviourState], stylesObj), foundationStyle)
//     }
//   }
//   //tablet | mobile
//   else {
//     if (behaviourState === "default") {
//       return render(merge2(stylesObj?.[breakpoint], stylesObj), foundationStyle)
//     }
//     //hover | active
//     else {
//       return render(
//         merge3(
//           stylesObj?.[breakpoint]?.behaviour?.[behaviourState],
//           stylesObj.behaviour?.[behaviourState],
//           stylesObj?.[breakpoint],
//           stylesObj
//         ),
//         foundationStyle
//       )
//     }
//   }
// }
function colorStyle_renderBob(colorValue, foundationStyle, stylesheetLabel, shouldRenderImportant) {
    return colorStyle_render(colorValue, foundationStyle, stylesheetLabel, shouldRenderImportant);
}
/**
 * Renders ColorsOpt css for breakpoints/state templates
 * or empty for non written style props
 *
 * @param colorValue
 * @param foundationStyle
 * @returns
 */ function colorStyle_renderBobOpt(colorValue, foundationStyle, stylesheetLabel, shouldRenderImportant) {
    if (colorValue || stylesheetLabel) {
        return colorStyle_renderOpt(colorValue, foundationStyle, stylesheetLabel, shouldRenderImportant);
    }
    return {};
}
function colorStyle_render(colorValue, foundationStyle, stylesheetLabel, shouldRenderImportant) {
    var cssValue = "".concat(colorValue).concat(renderImportant(shouldRenderImportant));
    return colorStyle_cssProperty(cssValue, stylesheetLabel);
}
/**
 * Renders ColorOpt css for breakpoints/state templates
 * Returns color
 * or empty for non written style props
 *
 * @param colorValue
 * @param foundationStyle
 * @returns
 */ function colorStyle_renderOpt(colorValue, foundationStyle, stylesheetLabel, shouldRenderImportant) {
    if (colorValue || stylesheetLabel) {
        var cssValue = "".concat(colorValue).concat(renderImportant(shouldRenderImportant));
        return colorStyle_cssProperty(cssValue, stylesheetLabel);
    }
    // no written style props
    return {};
}
function colorStyle_cssProperty(cssValue, stylesheetLabel) {
    return {
        color: handleBobStylesheetLabel(stylesheetLabel, cssValue)
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobText/bobText.tsx








// @ts-ignore













var BobText = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(BobText, _Component);
    var _super = (0,_create_super/* default */.Z)(BobText);
    function BobText() {
        (0,src_class_call_check/* default */.Z)(this, BobText);
        return _super.apply(this, arguments);
    }
    var _proto = BobText.prototype;
    // apply a function to a value if defined, producing a list with a single element. empty list if undefined
    _proto.show = function show(x, f) {
        if (typeof x === "undefined") return [];
        else return [
            f(x)
        ];
    };
    _proto.clearFont = function clearFont(x) {
        if (typeof x === "undefined" || x === null) return undefined;
        else {
            var noPlus = x.replace("+", " ");
            return noPlus.split(":")[0] // why split?
            ;
        }
    };
    /**
   * Component Props
   * @param value to show on the text
   * @param template containing the componet rules and template
   */ _proto.handleStateStyles = function handleStateStyles(defaultTemplate, templateObj, templateObjMobile, templateObjTablet, className, behaviourState) {
        if (templateObj) {
            var templateMobile = responsiveProperties({
                mobile: templateObjMobile
            }, "mobile", {
                shadow: {
                    shadowType: "text"
                }
            }, [
                "color"
            ], [
                "behaviour"
            ]);
            templateMobile = (0,src_object_spread/* default */.Z)({}, templateMobile, conditionalShadowRenderUnsafe(defaultTemplate, "mobile", behaviourState, "text", undefined), conditionalBoundaryRenderUnsafe(defaultTemplate, "mobile", behaviourState), colorStyle_cssRenderUnsafe(defaultTemplate, "mobile", behaviourState, undefined, undefined, true), responsiveGroupStylesProperties({
                mobile: templateObjMobile
            }, "mobile", "text"));
            var templateTablet = responsiveProperties({
                tablet: templateObjTablet
            }, "tablet", {
                shadow: {
                    shadowType: "text"
                }
            }, [
                "color"
            ], [
                "behaviour"
            ]);
            templateTablet = (0,src_object_spread/* default */.Z)({}, templateTablet, conditionalShadowRenderUnsafe(defaultTemplate, "tablet", behaviourState, "text", undefined), conditionalBoundaryRenderUnsafe(defaultTemplate, "tablet", behaviourState), colorStyle_cssRenderUnsafe(defaultTemplate, "tablet", behaviourState, undefined, undefined, true), responsiveGroupStylesProperties({
                tablet: templateObjTablet
            }, "tablet", "text"));
            var mediaQueryRestrictions = this.handleMediaQueryRestrictions(templateObjMobile, templateObjTablet);
            var boundaries = conditionalBoundaryRenderUnsafe(defaultTemplate, "desktop", behaviourState);
            var shadows = conditionalShadowRenderUnsafe(defaultTemplate, "desktop", behaviourState, "text", undefined);
            var color = colorStyle_cssRenderUnsafe(defaultTemplate, "desktop", behaviourState, undefined, undefined, true);
            return "\n      ".concat(templateObj.enable ? "@media all ".concat(mediaQueryRestrictions, "{\n            ").concat(className, "{\n              ").concat(colorStyle_renderCSSString(color), "\n              ").concat(renderCSSString(boundaries), "\n              ").concat(textShadowCss(shadows), "\n              ").concat([
                this.show(this.clearFont(templateObj["fontFamily"]), function(x) {
                    return 'font-family: "'.concat(x, '" !important');
                }),
                this.show(templateObj["fontWeight"], function(x) {
                    return "font-weight: ".concat(x, " !important");
                }),
                this.show(templateObj["fontSize"], function(x) {
                    return "font-size: ".concat(x, "px !important");
                }),
                this.show(templateObj["letterSpacing"], function(x) {
                    return "letter-spacing: ".concat(x, "px !important");
                }),
                this.show(templateObj["textAlign"], function(x) {
                    return "text-align: ".concat(x, " !important");
                }),
                this.show(templateObj["verticalAlign"], function(x) {
                    return "vertical-align: ".concat(x, " !important");
                }),
                this.show(templateObj["lineHeight"], function(x) {
                    return "line-height: ".concat(x, " !important");
                }),
                this.show(templateObj["textTransform"], function(x) {
                    return "text-transform: ".concat(x, " !important");
                }), 
            ].flat().join(";"), "\n            }\n          }") : "", "\n      ").concat((templateObj.enable || (templateObjTablet === null || templateObjTablet === void 0 ? void 0 : templateObjTablet.enable)) && (templateObjTablet === null || templateObjTablet === void 0 ? void 0 : templateObjTablet.enable) !== false ? "@media all and (max-width: 992px) and (min-width: 767px){\n            ".concat(className, "{\n              ").concat(colorStyle_renderCSSString(templateTablet), "\n              ").concat(renderCSSString(templateTablet), "\n              ").concat(textShadowCss(templateTablet), "\n              ").concat([
                this.show(this.clearFont(templateTablet["font-family"]), function(x) {
                    return 'font-family: "'.concat(x, '"');
                }),
                this.show(templateTablet["font-weight"], function(x) {
                    return "font-weight: ".concat(x);
                }),
                this.show(templateTablet["font-size"], function(x) {
                    return "font-size: ".concat(x);
                }),
                this.show(templateTablet["letter-spacing"], function(x) {
                    return "letter-spacing: ".concat(x);
                }),
                this.show(templateTablet["text-align"], function(x) {
                    return "text-align: ".concat(x);
                }),
                this.show(templateTablet["vertical-align"], function(x) {
                    return "vertical-align: ".concat(x);
                }),
                this.show(templateTablet["line-height"], function(x) {
                    return "line-height: ".concat(x);
                }),
                this.show(templateTablet["text-transform"], function(x) {
                    return "text-transform: ".concat(x);
                }), 
            ].flat().join(";"), "\n            }\n          }") : "", "\n      ").concat((templateObj.enable || (templateObjMobile === null || templateObjMobile === void 0 ? void 0 : templateObjMobile.enable)) && (templateObjMobile === null || templateObjMobile === void 0 ? void 0 : templateObjMobile.enable) !== false ? "@media all and (max-width: 766px){\n            ".concat(className, "{\n              ").concat(colorStyle_renderCSSString(templateMobile), "\n              ").concat(renderCSSString(templateMobile), " \n              ").concat(textShadowCss(templateMobile), "\n              ").concat([
                this.show(this.clearFont(templateMobile["font-family"]), function(x) {
                    return 'font-family: "'.concat(x, '"');
                }),
                this.show(templateMobile["font-weight"], function(x) {
                    return "font-weight: ".concat(x);
                }),
                this.show(templateMobile["font-size"], function(x) {
                    return "font-size: ".concat(x);
                }),
                this.show(templateMobile["letter-spacing"], function(x) {
                    return "letter-spacing: ".concat(x);
                }),
                this.show(templateMobile["text-align"], function(x) {
                    return "text-align: ".concat(x);
                }),
                this.show(templateMobile["vertical-align"], function(x) {
                    return "vertical-align: ".concat(x);
                }),
                this.show(templateMobile["line-height"], function(x) {
                    return "line-height: ".concat(x);
                }),
                this.show(templateMobile["text-transform"], function(x) {
                    return "text-transform: ".concat(x);
                }), 
            ].flat().join(";"), "\n            }\n          }") : "", "\n      ");
        }
        return "";
    };
    /**
   * returns media queries to apply styles based on enable prop value on the diferent breakpoints
   */ _proto.handleMediaQueryRestrictions = function handleMediaQueryRestrictions(mobileStyles, tabletStyles) {
        if ((tabletStyles === null || tabletStyles === void 0 ? void 0 : tabletStyles.enable) === false && (mobileStyles === null || mobileStyles === void 0 ? void 0 : mobileStyles.enable)) return "and (max-width: 766px), (min-width: 993px)";
        if ((tabletStyles === null || tabletStyles === void 0 ? void 0 : tabletStyles.enable) === false) return "and (min-width: 993px)";
        if ((mobileStyles === null || mobileStyles === void 0 ? void 0 : mobileStyles.enable) === false) return "and (min-width: 767px)";
        return "";
    };
    /**
   * Build the component styles from it's template prop
   */ _proto.handleCmsStyles = function handleCmsStyles(templateStyles) {
        if (templateStyles) {
            var templateObj = templateStyles;
            var shadows = conditionalShadowRenderUnsafe(templateObj, "desktop", "default", "text", undefined);
            var boundaries = conditionalBoundaryRenderUnsafe(templateObj, "desktop", "default");
            var color = colorStyle_cssRenderUnsafe(templateObj, "desktop", "default", undefined, undefined, true);
            var verticalAlign = handleVerticalAlign(templateObj["verticalAlign"]);
            return (0,src_object_spread/* default */.Z)({
                fontFamily: '"'.concat(clearFont(templateObj["fontFamily"]), '" !important'),
                fontWeight: templateObj["fontWeight"] + " !important",
                fontSize: templateObj["fontSize"] + "px !important",
                letterSpacing: templateObj["letterSpacing"] + "px !important",
                lineHeight: templateObj["lineHeight"] + " !important",
                textAlign: templateObj["textAlign"] + " !important",
                textTransform: templateObj["textTransform"] + " !important"
            }, color, shadows, verticalAlign, boundaries);
        } else {
            return stylesOverride;
        }
    };
    _proto.handleFonts = function handleFonts(templateStyles) {
        var FONTLOADED = "";
        var FONTLOADEDTABLET = "";
        var FONTLOADEDMOBILE = "";
        var FONTLOADEDHOVER = "";
        var FONTLOADEDACTIVE = "";
        if (this.props.expManager.enable) {
            FONTLOADED = dynamicFontLoader(templateStyles ? templateStyles : bobDefaultNode_styles, [
                templateStyles.fontWeight
            ], undefined);
            FONTLOADEDTABLET = dynamicFontLoader(templateStyles.tablet ? templateStyles.tablet : bobDefaultNode_styles, [
                templateStyles.tablet && templateStyles.tablet.fontWeight
            ], undefined, undefined, true);
            FONTLOADEDMOBILE = dynamicFontLoader(templateStyles.mobile ? templateStyles.mobile : bobDefaultNode_styles, templateStyles.mobile && [
                templateStyles.mobile.fontWeight
            ], undefined, undefined, true);
            FONTLOADEDHOVER = templateStyles.behaviour && templateStyles.behaviour.hover && templateStyles.behaviour.hover.enable ? dynamicFontLoader(templateStyles.behaviour.hover, [
                templateStyles.behaviour.hover.fontWeight
            ], undefined, undefined, true) : "";
            FONTLOADEDACTIVE = templateStyles.behaviour && templateStyles.behaviour.active && templateStyles.behaviour.active.enable ? dynamicFontLoader(templateStyles.behaviour.active, [
                templateStyles.behaviour.active.fontWeight
            ], undefined, undefined, true) : "";
        }
        return "".concat(FONTLOADED, " ").concat(FONTLOADEDTABLET, " ").concat(FONTLOADEDMOBILE, " ").concat(FONTLOADEDHOVER, " ").concat(FONTLOADEDACTIVE);
    };
    _proto.clickEvent = function clickEvent(e, TAG) {
        if (TAG === "a") {
            var ref;
            var linkLabel = analyticsLinkLabel(this.props.field, {
                inlineContent: this.props.inlineContent,
                overrides: this.props.overrides
            }, this.props.pageResponse, this.props.post);
            //get parent id to properly know who has the link configured
            var parentId = (ref = e.target.parentElement) === null || ref === void 0 ? void 0 : ref.id;
            if (parentId) {
                GoogleEvent("link_click", linkLabel, "Link Clicked", 1);
            }
        }
    };
    _proto.render = function render() {
        var templateStyles = this.props.template;
        var mobileStyles = (0,src_object_spread/* default */.Z)({}, responsiveProperties(templateStyles, "mobile", {
            shadow: {
                shadowType: "text"
            }
        }, [
            "color"
        ], [
            "behaviour"
        ]), conditionalShadowRenderUnsafe(templateStyles, "mobile", "default", "text", undefined), conditionalBoundaryRenderUnsafe(templateStyles, "mobile", "default"), colorStyle_cssRenderUnsafe(templateStyles, "mobile", "default", undefined, undefined, true), responsiveGroupStylesProperties(templateStyles, "mobile", "text"));
        var tabletStyles = (0,src_object_spread/* default */.Z)({}, responsiveProperties(templateStyles, "tablet", {
            shadow: {
                shadowType: "text"
            }
        }, [
            "color"
        ], [
            "behaviour"
        ]), conditionalShadowRenderUnsafe(templateStyles, "tablet", "default", "text", undefined), conditionalBoundaryRenderUnsafe(templateStyles, "tablet", "default"), colorStyle_cssRenderUnsafe(templateStyles, "tablet", "default", undefined, undefined, true), responsiveGroupStylesProperties(templateStyles, "tablet", "text"));
        var TAG = components_getOverrideInlineContentValues("".concat(this.props.field, ".behaviour-link-enable"), this.props) ? "a" : components_getOverrideInlineContentValues("".concat(this.props.field, ".tag"), this.props);
        var FONTSLOADED = this.handleFonts(templateStyles);
        var isValidHtml = false;
        if (components_getOverrideInlineContentValues("".concat(this.props.field, ".contentSrc"), this.props) === textContentHelper_CMS || components_getOverrideInlineContentValues("".concat(this.props.field, ".contentSrc"), this.props) === textContentHelper_CONTENT_PAGE) {
            isValidHtml = validHtml(this.props.value);
        }
        var content;
        // give a prefix to each class so that the inline styles dont apply to all bob-text-container classes
        var classPrefix = "prefix".concat(templateStyles.uuid);
        var classes = "bob-text ".concat(classPrefix, "-bob-text ").concat(this.props.className || "", " spacing-preview-").concat(this.props.template.uuid, " ").concat(globalStylesUtils.handleClassName(this.props.pageResponse.nGlobalStyles, this.props.template, undefined, "-text"));
        // LEGACY check for (this.props.rules.behaviour && this.props.rules.behaviour.hover)
        var hoverStyles = "";
        var activeStyles = "";
        if (this.props.rule && this.props.rule.behaviour && this.props.rule.behaviour.hover) {
            var ref, ref1, ref2, ref3;
            hoverStyles = this.handleStateStyles(templateStyles, templateStyles.behaviour.hover, (ref = templateStyles.mobile) === null || ref === void 0 ? void 0 : (ref1 = ref.behaviour) === null || ref1 === void 0 ? void 0 : ref1.hover, (ref2 = templateStyles.tablet) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.behaviour) === null || ref3 === void 0 ? void 0 : ref3.hover, ".".concat(classPrefix, "-bob-text:hover, .").concat(classPrefix, "-bob-text.isHover"), "hover");
        }
        if (this.props.rule && this.props.rule.behaviour && this.props.rule.behaviour.active) {
            var ref4, ref5, ref6, ref7;
            activeStyles = this.handleStateStyles(templateStyles, templateStyles.behaviour.active, (ref4 = templateStyles.mobile) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.behaviour) === null || ref5 === void 0 ? void 0 : ref5.active, (ref6 = templateStyles.tablet) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.behaviour) === null || ref7 === void 0 ? void 0 : ref7.active, ".active .".concat(classPrefix, "-bob-text"), "active");
        }
        var linkAttrs = getLinkAttributes(this.props.field, {
            inlineContent: this.props.inlineContent,
            overrides: this.props.overrides
        }, this.props.pageResponse, this.props.post);
        var customAttributesEnable = components_getOverrideInlineContentValues("".concat(this.props.field, ".").concat(CUSTOM_ATTRIBUTES_ENABLE), {
            inlineContent: this.props.inlineContent,
            overrides: this.props.overrides
        });
        var customAttributesMappedField = components_getOverrideInlineContentValues("".concat(this.props.field, ".").concat(CUSTOM_ATTRIBUTES_MAPPED_FIELD), {
            inlineContent: this.props.inlineContent,
            overrides: this.props.overrides
        });
        var customAttributesValue = components_getOverrideInlineContentValues("".concat(this.props.field, ".").concat(CUSTOM_ATTRIBUTES_VALUE), {
            inlineContent: this.props.inlineContent,
            overrides: this.props.overrides
        });
        var customAttributesContentSrc = components_getOverrideInlineContentValues("".concat(this.props.field, ".").concat(CUSTOM_ATTRIBUTES_CONTENTSRC), {
            inlineContent: this.props.inlineContent,
            overrides: this.props.overrides
        });
        var datasetValue = datasetRender(this.props.post, customAttributesEnable, customAttributesMappedField, customAttributesValue, customAttributesContentSrc);
        // Render Html when coming from CMS/CONTENT_PAGE
        if (isValidHtml) {
            content = /*#__PURE__*/ (0,jsx_runtime.jsx)(bobTextSplit, {
                datasetRender: datasetValue,
                textType: "renderHtml",
                templateStyles: templateStyles,
                tabletStyles: tabletStyles,
                mobileStyles: mobileStyles,
                inlineContent: this.props.inlineContent,
                overrides: this.props.overrides,
                value: this.props.value,
                tag: TAG,
                classes: classes,
                linkAttrs: linkAttrs,
                id: this.props.id,
                instanceId: this.props.instanceId,
                field: this.props.field,
                network: this.props.network,
                pageResponse: this.props.pageResponse,
                classPrefix: classPrefix,
                handleCmsStyles: this.handleCmsStyles,
                clickEvent: this.clickEvent
            });
        } else if (components_getOverrideInlineContentValues("".concat(this.props.field, ".contentSrc"), this.props) === "custom") {
            content = /*#__PURE__*/ (0,jsx_runtime.jsx)(bobTextSplit, {
                datasetRender: datasetValue,
                textType: "renderCustomContent",
                templateStyles: templateStyles,
                tabletStyles: tabletStyles,
                mobileStyles: mobileStyles,
                inlineContent: this.props.inlineContent,
                overrides: this.props.overrides,
                value: this.props.value,
                tag: TAG,
                classes: classes,
                linkAttrs: linkAttrs,
                id: this.props.id,
                instanceId: this.props.instanceId,
                field: this.props.field,
                network: this.props.network,
                pageResponse: this.props.pageResponse,
                classPrefix: classPrefix,
                handleCmsStyles: this.handleCmsStyles,
                clickEvent: this.clickEvent
            });
        } else {
            content = /*#__PURE__*/ (0,jsx_runtime.jsx)(bobTextSplit, {
                datasetRender: datasetValue,
                textType: "renderCustomTag",
                templateStyles: templateStyles,
                tabletStyles: tabletStyles,
                mobileStyles: mobileStyles,
                inlineContent: this.props.inlineContent,
                overrides: this.props.overrides,
                value: this.props.value,
                tag: TAG,
                classes: classes,
                linkAttrs: linkAttrs,
                id: this.props.id,
                instanceId: this.props.instanceId,
                field: this.props.field,
                network: this.props.network,
                pageResponse: this.props.pageResponse,
                classPrefix: classPrefix,
                handleCmsStyles: this.handleCmsStyles,
                clickEvent: this.clickEvent
            });
        }
        var hasStateStylesOrFont = hoverStyles.trim() !== "" || activeStyles.trim() !== "" || FONTSLOADED.trim() !== "";
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                hasStateStylesOrFont && /*#__PURE__*/ (0,jsx_runtime.jsx)((style_it_default()), {
                    children: "\n              ".concat(FONTSLOADED, "\n              ").concat(hoverStyles, "\n              ").concat(activeStyles, "\n            ")
                }),
                content
            ]
        });
    };
    return BobText;
}(react.Component);
/* harmony default export */ var bobText = (BobText);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/inlineContentHandler.ts



function rewriteObjectOnRead(template, inlineContent, bobType) {
    /**
   * Check if it has inlineContent to Use
   */ if (inlineContent && inlineContent.safeInlineContent) return inlineContent;
    console.warn("Using old Content Logic, please publish to use the new InlineContent!");
    //else rewrite
    if (bobType.startsWith("text")) return bobTextReWriteOnRead(template, bobType);
    if (bobType.startsWith("background")) return bobBackgroundReWriteOnRead(template, bobType);
    if (bobType.startsWith("media")) return bobMediaReWriteOnRead(template, bobType);
}
function linkControllerReWriteOnRead(template, bobType) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var _obj;
    return _obj = {}, (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(LINK_ENABLE), (ref = template.behaviour.link) === null || ref === void 0 ? void 0 : ref.enable), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(LINK_LABEL), (ref1 = template.behaviour.link) === null || ref1 === void 0 ? void 0 : ref1.label), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(LINK_MAPPED_VALUE), (ref2 = template.behaviour.link) === null || ref2 === void 0 ? void 0 : ref2.mappedValue), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(LINK_CUSTOM_URL), (ref3 = template.behaviour.link) === null || ref3 === void 0 ? void 0 : ref3.customUrl), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(LINK_LINKED_OBJECT), (ref4 = template.behaviour.link) === null || ref4 === void 0 ? void 0 : ref4.linkedObject), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(LINK_TARGET), (ref5 = template.behaviour.link) === null || ref5 === void 0 ? void 0 : ref5.target), _obj;
}
function bobTextReWriteOnRead(template, bobType) {
    var _obj;
    return (0,src_object_spread/* default */.Z)((_obj = {}, (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(CUSTOM_TEXT), template.customText), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(CONTENT_SRC_TEXT), template.contentSrc), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(MAPPED_VALUE), template.mappedValue), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(EXTRA_WEIGHTS), template.extraWeights), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(TAG), template.tag), _obj), linkControllerReWriteOnRead(template, bobType));
}
function bobBackgroundReWriteOnRead(template, bobType) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var _obj;
    return (0,src_object_spread/* default */.Z)((_obj = {}, (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(IMAGE_SRC), template.image.src), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(IMAGE_SRC_ACTIVE), (ref = template.behaviour.active) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.src), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(IMAGE_SRC_HOVER), (ref2 = template.behaviour.hover) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.src), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(IMAGE_ALT), template.image.alt), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(IMAGE_ALT_ACTIVE), (ref4 = template.behaviour.active) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.image) === null || ref5 === void 0 ? void 0 : ref5.alt), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(IMAGE_ALT_HOVER), (ref6 = template.behaviour.hover) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.image) === null || ref7 === void 0 ? void 0 : ref7.alt), _obj), linkControllerReWriteOnRead(template, bobType));
}
function bobMediaReWriteOnRead(template, bobType) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    var _obj;
    return (0,src_object_spread/* default */.Z)((_obj = {}, (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(SRC), template.src), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(SRC_ACTIVE), (ref = template.behaviour.active) === null || ref === void 0 ? void 0 : ref.src), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(SRC_HOVER), (ref1 = template.behaviour.hover) === null || ref1 === void 0 ? void 0 : ref1.src), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(IMAGE_ENABLE), template.image.enable), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(IMAGE_ENABLE_ACTIVE), (ref2 = template.behaviour.active) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.enable), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(IMAGE_ENABLE_HOVER), (ref4 = template.behaviour.hover) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.image) === null || ref5 === void 0 ? void 0 : ref5.enable), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(VIDEO_ENABLE), template.video.enable), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(VIDEO_ENABLE_ACTIVE), (ref6 = template.behaviour.active) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.video) === null || ref7 === void 0 ? void 0 : ref7.enable), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(VIDEO_ENABLE_HOVER), (ref8 = template.behaviour.hover) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.video) === null || ref9 === void 0 ? void 0 : ref9.enable), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(CONTENT_SRC_MEDIA), template.contentSrc), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(CONTENT_SRC_ACTIVE), (ref10 = template.behaviour.active) === null || ref10 === void 0 ? void 0 : ref10.contentSrc), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(CONTENT_SRC_HOVER), (ref11 = template.behaviour.hover) === null || ref11 === void 0 ? void 0 : ref11.contentSrc), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(IMAGE_MAPPED_VALUE), template.image.mappedValue), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(IMAGE_MAPPED_VALUE_ACTIVE), (ref12 = template.behaviour.active) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.image) === null || ref13 === void 0 ? void 0 : ref13.mappedValue), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(IMAGE_MAPPED_VALUE_HOVER), (ref14 = template.behaviour.hover) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.image) === null || ref15 === void 0 ? void 0 : ref15.mappedValue), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(VIDEO_MAPPED_VALUE), template.video.mappedValue), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(VIDEO_MAPPED_VALUE_ACTIVE), (ref16 = template.behaviour.active) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.video) === null || ref17 === void 0 ? void 0 : ref17.mappedValue), (0,src_define_property/* default */.Z)(_obj, "".concat(bobType, ".").concat(VIDEO_MAPPED_VALUE_HOVER), (ref18 = template.behaviour.hover) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.video) === null || ref19 === void 0 ? void 0 : ref19.mappedValue), _obj), linkControllerReWriteOnRead(template, bobType));
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/modules/shared-modules/foundationStyles/foundationStylesUtils.tsx






function hasFoundationStyleAttached(bobTemplate, controller, property, state, breakpoint) {
    var ref, ref1, ref2, ref3;
    var isFoundationAttached = (ref = bobTemplate[controller].foundationColor) === null || ref === void 0 ? void 0 : ref[property];
    // handle breakpoint
    if (breakpoint !== "desktop") isFoundationAttached = (ref1 = bobTemplate[breakpoint]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[controller]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.foundationColor) === null || ref3 === void 0 ? void 0 : ref3[property];
    // handle state
    if (state && state !== "default") {
        var ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
        if (breakpoint !== "desktop") isFoundationAttached = (ref4 = bobTemplate[breakpoint]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.behaviour) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[state]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[controller]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.foundationColor) === null || ref8 === void 0 ? void 0 : ref8[property];
        else isFoundationAttached = (ref9 = bobTemplate.behaviour) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[state]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[controller]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.foundationColor) === null || ref12 === void 0 ? void 0 : ref12[property];
    }
    return isFoundationAttached ? true : false;
}
function getAttachedFoundationStyle(bobTemplate, foundationsList, controller, property, state, breakpoint) {
    var ref, ref1, ref2, ref3, ref4;
    var attachedFoundationId = bobTemplate === null || bobTemplate === void 0 ? void 0 : (ref = bobTemplate[controller]) === null || ref === void 0 ? void 0 : (ref1 = ref.foundationColor) === null || ref1 === void 0 ? void 0 : ref1[property];
    // handle breakpoint
    if (breakpoint !== "desktop") attachedFoundationId = bobTemplate === null || bobTemplate === void 0 ? void 0 : (ref2 = bobTemplate[breakpoint]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[controller]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.foundationColor) === null || ref4 === void 0 ? void 0 : ref4[property];
    // handle state
    if (state && state !== "default") {
        var ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
        if (breakpoint !== "desktop") attachedFoundationId = bobTemplate === null || bobTemplate === void 0 ? void 0 : (ref5 = bobTemplate[breakpoint]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[state]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[controller]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.foundationColor) === null || ref9 === void 0 ? void 0 : ref9[property];
        else attachedFoundationId = bobTemplate === null || bobTemplate === void 0 ? void 0 : (ref10 = bobTemplate.behaviour) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[state]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[controller]) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.foundationColor) === null || ref13 === void 0 ? void 0 : ref13[property];
    }
    var attachedFoundation = foundationsList === null || foundationsList === void 0 ? void 0 : foundationsList[attachedFoundationId];
    return attachedFoundation;
}
/**
 * Get foundation based on breakpoint and state
 * Default value is the default template foundation
 *
 * if the breakpoint/state has a foundation that one is used
 * if the breakpoint/state has value written remove default template foundation
 *
 * @param bobTemplate
 * @param foundationsList
 * @param controller
 * @param property
 * @param state
 * @param breakpoint
 * @returns
 */ function getResponsiveAttachedFoundationStyle(bobTemplate, foundationsList, controller, property, state, breakpoint) {
    var ref;
    var defaultController = bobTemplate[controller];
    /**
   * handle default template
   * this may be used as the default value for the breakpoint/state that doenst have a foundation or value written
   */ var attachedFoundationId = defaultController === null || defaultController === void 0 ? void 0 : (ref = defaultController.foundationColor) === null || ref === void 0 ? void 0 : ref[property];
    /**
   * handle breakpoint template
   */ if (breakpoint !== "desktop") {
        var ref1, ref2, ref3, ref4, ref5;
        var breakpointFoundation = (ref1 = bobTemplate[breakpoint]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[controller]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.foundationColor) === null || ref3 === void 0 ? void 0 : ref3[property];
        if (breakpointFoundation) {
            attachedFoundationId = breakpointFoundation;
        } else if (!shouldUseFallbackDefaultValue(defaultController, (ref4 = bobTemplate[breakpoint]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[controller]) === null || ref5 === void 0 ? void 0 : ref5[property])) {
            attachedFoundationId = undefined;
        }
    }
    /**
   * handle state template
   */ if (state && state !== "default") {
        var ref6, ref7, ref8, ref9, ref10, ref11, ref12;
        var stateFoundation = (ref6 = bobTemplate.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[state]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[controller]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.foundationColor) === null || ref9 === void 0 ? void 0 : ref9[property];
        if (stateFoundation) {
            attachedFoundationId = stateFoundation;
        } else if (!shouldUseFallbackDefaultValue(defaultController, (ref10 = bobTemplate.behaviour) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[state]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[controller]) === null || ref12 === void 0 ? void 0 : ref12[property])) {
            attachedFoundationId = undefined;
        }
        /**
     * handle state breakpoint
     */ if (breakpoint !== "desktop") {
            var ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21;
            var stateBreakpointFoundation = (ref13 = bobTemplate[breakpoint]) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.behaviour) === null || ref14 === void 0 ? void 0 : (ref15 = ref14[state]) === null || ref15 === void 0 ? void 0 : (ref16 = ref15[controller]) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.foundationColor) === null || ref17 === void 0 ? void 0 : ref17[property];
            if (stateBreakpointFoundation) {
                attachedFoundationId = stateBreakpointFoundation;
            } else if (!shouldUseFallbackDefaultValue(defaultController, (ref18 = bobTemplate[breakpoint]) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.behaviour) === null || ref19 === void 0 ? void 0 : (ref20 = ref19[state]) === null || ref20 === void 0 ? void 0 : (ref21 = ref20[controller]) === null || ref21 === void 0 ? void 0 : ref21[property])) {
                attachedFoundationId = undefined;
            }
        }
    }
    var attachedFoundation = foundationsList === null || foundationsList === void 0 ? void 0 : foundationsList[attachedFoundationId];
    return attachedFoundation;
}
/**
 * dont use fallback default value if:
 * - default template enable prop exists and is false
 * - breakpoint template value exists
 *
 *  TODO: types
 *
 * @param defaultController
 * @param breakpointControllerValue
 * @returns
 */ function shouldUseFallbackDefaultValue(defaultController, breakpointControllerValue) {
    if (utils_objValueExists(defaultController, "enable") && defaultController.enable === false || breakpointControllerValue) {
        return false;
    }
    return true;
}
function attachFoundationStyleToPage(foundation, objectSelected, hubContent, bobOpen, breakpoint, state, controller, property, emEditorType) {
    var clonedHubContent = cloneDeep(hubContent);
    var selectedObject = cloneDeep(objectSelected);
    //trigger publish btn
    clonedHubContent.isOutdated = true;
    // add foundation to foundations list
    if (clonedHubContent.foundations) clonedHubContent.foundations = _object_spread_props(_object_spread({}, clonedHubContent.foundations), _define_property({}, foundation.uuid, foundation));
    else clonedHubContent.foundations = _define_property({}, foundation.uuid, foundation);
    // add foundation to hubObject objects list
    var objects = handleObjectsListType(clonedHubContent, selectedObject, emEditorType);
    var bobTemplate = handleBobTemplate(objects[selectedObject.uuid].styles.bobs[bobOpen], breakpoint, state);
    if (!bobTemplate[controller]) {
        bobTemplate[controller] = {
            foundationColor: _define_property({}, property, foundation.uuid)
        };
    } else {
        bobTemplate[controller].foundationColor = _define_property({}, property, foundation.uuid);
    }
    // add foundation to selectedObject
    var selectedObjBobTemplate = handleBobTemplate(selectedObject.styles.bobs[bobOpen], breakpoint, state);
    if (!selectedObjBobTemplate[controller]) {
        selectedObjBobTemplate[controller] = {
            foundationColor: _define_property({}, property, foundation.uuid)
        };
    } else {
        selectedObjBobTemplate[controller].foundationColor = _define_property({}, property, foundation.uuid);
    }
    return {
        hubContent: clonedHubContent,
        selectedObject: selectedObject
    };
}
function dettachFoundationStyleFromPage(foundation, hubContent, objectSelected, bobOpen, breakpoint, state, controller, property, emEditorType) {
    var clonedHubContent = cloneDeep(hubContent);
    var selectedObject = cloneDeep(objectSelected);
    //trigger publish btn
    clonedHubContent.isOutdated = true;
    // remove foundation from hubObject objects list
    var objects = handleObjectsListType(clonedHubContent, selectedObject, emEditorType);
    var bobTemplate = handleBobTemplate(objects[selectedObject.uuid].styles.bobs[bobOpen], breakpoint, state);
    bobTemplate[controller][property] = foundation.color;
    delete bobTemplate[controller].foundationColor;
    // remove foundation from selectedObject
    var controllerTemplate = handleBobTemplate(selectedObject.styles.bobs[bobOpen], breakpoint, state);
    controllerTemplate[controller][property] = foundation.color;
    delete controllerTemplate[controller].foundationColor;
    return {
        hubContent: clonedHubContent,
        selectedObject: selectedObject
    };
}
/**
   * Writes object that represents the strcture where a foundation is attached to,
   * giving the path to the foundation from the bob->controller->property in a json object format.
   * This structure is expected by the API
   *
   * @param foundationValue
   * @param controller
   * @param property
   * @param responsiveData
   * @returns
   */ function handleFoundationPropertyRelation(foundationValue, controller, property, responsiveData) {
    var foundationStyle = {
        property: _define_property({}, controller, _define_property({}, property, foundationValue))
    };
    // handle breakpoint
    if (responsiveData.breakpoint !== "desktop") foundationStyle.property = _define_property({}, responsiveData.breakpoint, _object_spread({}, foundationStyle.property));
    // handle state
    if (responsiveData.state && responsiveData.state !== "default") {
        if (responsiveData.breakpoint !== "desktop") foundationStyle.property = _define_property({}, responsiveData.breakpoint, {
            behaviour: _define_property({}, responsiveData.state, _object_spread({}, foundationStyle.property[responsiveData.breakpoint]))
        });
        else foundationStyle.property = {
            behaviour: _define_property({}, responsiveData.state, _object_spread({}, foundationStyle.property))
        };
    }
    return foundationStyle;
}
/**
   * Get bob template based on breakpoint and behaviour state
   * @param bobTemplate
   * @param breakpoint
   * @param state
   * @returns default bob template, or breakpoint template, or behaviour state template
   */ function handleBobTemplate(bobTemplate, breakpoint, state) {
    var template = bobTemplate;
    /**
     * handle breakpoint
     */ if (breakpoint !== "desktop") {
        // if breakpoint template doens't exist, create it
        if (!bobTemplate[breakpoint]) bobTemplate[breakpoint] = {};
        template = bobTemplate[breakpoint];
    }
    /**
     * handle state
     */ if (state && state !== "default") {
        // handle state responsive
        if (breakpoint !== "desktop") {
            var ref, ref1;
            // if breakpoint template doens't exist, create it
            if (!bobTemplate[breakpoint]) bobTemplate[breakpoint] = {};
            if (!bobTemplate[breakpoint].behaviour) bobTemplate[breakpoint].behaviour = {};
            if (!bobTemplate[breakpoint].behaviour[state]) bobTemplate[breakpoint].behaviour[state] = {};
            template = (ref = bobTemplate[breakpoint]) === null || ref === void 0 ? void 0 : (ref1 = ref.behaviour) === null || ref1 === void 0 ? void 0 : ref1[state];
        } else {
            // if state template doens't exist, create it
            if (!bobTemplate.behaviour[state]) bobTemplate.behaviour[state] = {};
            template = bobTemplate.behaviour[state];
        }
    }
    return template;
}

;// CONCATENATED MODULE: ./src/areas/public-page/bob/bobBackgroundImage/bobBackgroundImage.tsx






function bobBackgroundImage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  @media only screen and (max-width: 992px) and (min-width: 767px) {\n    ",
        "\n  }\n  @media all and (max-width: 766px) {\n    ",
        "\n  }\n"
    ]);
    bobBackgroundImage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  @media only screen and (max-width: 992px) and (min-width: 767px) {\n    ",
        "\n  }\n  @media all and (max-width: 766px) {\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




// @ts-ignore




//@ts-ignore












var BoBackgroundDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a44fe624-0"
})(bobBackgroundImage_templateObject(), function(props) {
    return props.desktop;
}, function(props) {
    return props.tablet;
}, function(props) {
    return props.mobile;
});
var BobBackgroundContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a44fe624-1"
})(_templateObject1(), function(props) {
    return props.desktop;
}, function(props) {
    return props.tablet;
}, function(props) {
    return props.mobile;
});
var BobBackgroundImage = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(BobBackgroundImage, _Component);
    var _super = (0,_create_super/* default */.Z)(BobBackgroundImage);
    function BobBackgroundImage(props) {
        (0,src_class_call_check/* default */.Z)(this, BobBackgroundImage);
        var _this;
        _this = _super.call(this, props);
        _this.isFilterEnabled = function(templateStyles) {
            var ref, ref1, ref2, ref3;
            if (templateStyles.filter.enable || ((ref = templateStyles.tablet) === null || ref === void 0 ? void 0 : (ref1 = ref.filter) === null || ref1 === void 0 ? void 0 : ref1.enable) || ((ref2 = templateStyles.mobile) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.filter) === null || ref3 === void 0 ? void 0 : ref3.enable)) {
                return true;
            }
            return false;
        };
        return _this;
    }
    var _proto = BobBackgroundImage.prototype;
    _proto.handleStateStyles = function handleStateStyles(defaultTemplate, templateObj, templateObjMobile, templateObjTablet, className, imageSrc, behaviourState) {
        if (templateObj) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
            var foundationsList = this.props.pageResponse.foundations;
            var shadowFoundationStyle = getResponsiveAttachedFoundationStyle(defaultTemplate, foundationsList, "shadow", "color", behaviourState, "desktop");
            var mobileShadowFoundationStyle = getResponsiveAttachedFoundationStyle(defaultTemplate, foundationsList, "shadow", "color", behaviourState, "mobile");
            var tabletShadowFoundationStyle = getResponsiveAttachedFoundationStyle(defaultTemplate, foundationsList, "shadow", "color", behaviourState, "tablet");
            var templateMobile = (0,src_object_spread/* default */.Z)({}, responsiveProperties({
                mobile: templateObjMobile
            }, "mobile", {
                image: {
                    imageType: "backgroundImage"
                }
            }, [
                "grid",
                "alignment",
                "shadow",
                "spacing",
                "colors",
                "image",
                "border", 
            ]), conditionalShadowRenderUnsafe(defaultTemplate, "mobile", behaviourState, "box", mobileShadowFoundationStyle), conditionalBoundaryRenderUnsafe(defaultTemplate, "mobile", behaviourState), conditionalBorderRenderUnsafe(defaultTemplate, "mobile", behaviourState, true), conditionalColorsRenderUnsafe(defaultTemplate, "mobile", behaviourState, true), backgroundImageStyle_cssRenderUnsafe(defaultTemplate, "mobile", behaviourState, imageSrc));
            var templateTablet = (0,src_object_spread/* default */.Z)({}, responsiveProperties({
                tablet: templateObjTablet
            }, "tablet", {
                image: {
                    imageType: "backgroundImage"
                }
            }, [
                "grid",
                "alignment",
                "shadow",
                "spacing",
                "colors",
                "image",
                "border", 
            ]), conditionalShadowRenderUnsafe(defaultTemplate, "tablet", behaviourState, "box", tabletShadowFoundationStyle), conditionalBoundaryRenderUnsafe(defaultTemplate, "tablet", behaviourState), conditionalBorderRenderUnsafe(defaultTemplate, "tablet", behaviourState, true), conditionalColorsRenderUnsafe(defaultTemplate, "tablet", behaviourState, true), backgroundImageStyle_cssRenderUnsafe(defaultTemplate, "tablet", behaviourState, imageSrc));
            var mediaQueryRestrictions = this.handleMediaQueryRestrictions(templateObjMobile, templateObjTablet);
            var heightStyles = handleHeight(templateObj, defaultTemplate);
            var backgroundImageStyles = backgroundImageStyle_cssRenderUnsafe(defaultTemplate, "desktop", behaviourState, imageSrc);
            var backgroundColorStyles = conditionalColorsRenderUnsafe(defaultTemplate, "desktop", behaviourState, true);
            var bondariesObj = conditionalBoundaryRenderUnsafe(defaultTemplate, "desktop", behaviourState);
            var imageFilterStyles = handleImageFilter(templateObj);
            var flowStyles = handleFlow(templateObj);
            var borders = conditionalBorderRenderUnsafe(defaultTemplate, "desktop", behaviourState, true);
            var shadows = conditionalShadowRenderUnsafe(defaultTemplate, "desktop", behaviourState, "box", shadowFoundationStyle);
            var radiusStyles = handleRadius(templateObj, defaultTemplate);
            return "\n      ".concat(templateObj.enable ? "@media all ".concat(mediaQueryRestrictions, "{\n            ").concat(className, "{\n              height: ").concat(heightStyles.height, ";\n              ").concat(renderCSSString(bondariesObj), "               \n              ").concat(colorsStyle_renderCSSString(backgroundColorStyles), "             \n              background-size: ").concat(backgroundImageStyles["background-size"], ";\n              background-repeat: ").concat(backgroundImageStyles["background-repeat"], ";\n              background-position: ").concat(backgroundImageStyles["background-position"], ";\n              ").concat(conditionalBorderCss(borders, (ref = this.props.template.controllerVersion) === null || ref === void 0 ? void 0 : ref.border), "\n              background-image: ").concat(backgroundImageStyles["background-image"], ";              \n              background-attachment: ").concat(templateObj.attachment + " !important", ";\n              filter: ").concat((ref1 = imageFilterStyles.filter) === null || ref1 === void 0 ? void 0 : ref1.filter, ";\n              webkit-filter: ").concat((ref2 = imageFilterStyles.filter) === null || ref2 === void 0 ? void 0 : ref2.WebkitFilter, ";\n              position: ").concat(flowStyles.position, ";\n              z-index: ").concat(flowStyles.zIndex, ";\n              width: ").concat(flowStyles.width, ";\n              top: ").concat(flowStyles.top, ";\n              ").concat(boxShadowCss(shadows), "\n              border-bottom-left-radius: ").concat(radiusStyles.borderBottomLeftRadius, "; \n              border-bottom-right-radius: ").concat(radiusStyles.borderBottomRightRadius, "; \n              border-top-left-radius: ").concat(radiusStyles.borderTopLeftRadius, "; \n              border-top-right-radius: ").concat(radiusStyles.borderTopRightRadius, "; \n            }\n          }") : "", "\n      ").concat((templateObj.enable || (templateObjTablet === null || templateObjTablet === void 0 ? void 0 : templateObjTablet.enable)) && (templateObjTablet === null || templateObjTablet === void 0 ? void 0 : templateObjTablet.enable) !== false ? "@media all and (max-width: 992px) and (min-width: 767px){\n            ".concat(className, "{\n              height: ").concat(templateTablet.height, ";     \n              ").concat(renderCSSString(templateTablet), "\n              ").concat(colorsStyle_renderCSSString(templateTablet), "     \n              background-size: ").concat(templateTablet["background-size"], ";\n              background-repeat: ").concat(templateTablet["background-repeat"], ";\n              background-position: ").concat(templateTablet["background-position"], ";\n              ").concat(conditionalBorderCss(templateTablet, (ref3 = this.props.template.controllerVersion) === null || ref3 === void 0 ? void 0 : ref3.border), "\n              background-image: ").concat(templateTablet["background-image"], ";\n              filter: ").concat((ref4 = templateTablet.filter) === null || ref4 === void 0 ? void 0 : ref4.filter, ";\n              position: ").concat(templateTablet.position, ";\n              z-index: ").concat(templateTablet["z-index"], ";\n              width: ").concat(templateTablet.width, ";\n              top: ").concat(templateTablet.top, ";\n              ").concat(boxShadowCss(templateTablet), "\n              border-bottom-left-radius: ").concat(templateTablet["border-bottom-left-radius"], "; \n              border-bottom-right-radius: ").concat(templateTablet["border-bottom-left-radius"], "; \n              border-top-left-radius: ").concat(templateTablet["border-bottom-left-radius"], "; \n              border-top-right-radius: ").concat(templateTablet["border-bottom-left-radius"], ";  \n            }\n          }") : "", "\n      ").concat((templateObj.enable || (templateObjMobile === null || templateObjMobile === void 0 ? void 0 : templateObjMobile.enable)) && (templateObjMobile === null || templateObjMobile === void 0 ? void 0 : templateObjMobile.enable) !== false ? "@media all and (max-width: 766px){\n            ".concat(className, "{\n              height: ").concat(templateMobile.height, ";\n              ").concat(renderCSSString(templateMobile), "\n              ").concat(colorsStyle_renderCSSString(templateMobile), "   \n              background-size: ").concat(templateMobile["background-size"], ";\n              background-repeat: ").concat(templateMobile["background-repeat"], ";\n              background-position: ").concat(templateMobile["background-position"], ";\n              ").concat(conditionalBorderCss(templateMobile, (ref5 = this.props.template.controllerVersion) === null || ref5 === void 0 ? void 0 : ref5.border), " \n              background-image: ").concat(templateMobile["background-image"], ";\n              filter: ").concat((ref6 = templateMobile.filter) === null || ref6 === void 0 ? void 0 : ref6.filter, ";\n              position: ").concat(templateMobile.position, ";\n              z-index: ").concat(templateMobile["z-index"], ";\n              width: ").concat(templateMobile.width, ";\n              top: ").concat(templateMobile.top, ";\n              ").concat(boxShadowCss(templateMobile), "\n              border-bottom-left-radius: ").concat(templateMobile["border-bottom-left-radius"], "; \n              border-bottom-right-radius: ").concat(templateMobile["border-bottom-left-radius"], "; \n              border-top-left-radius: ").concat(templateMobile["border-bottom-left-radius"], "; \n              border-top-right-radius: ").concat(templateMobile["border-bottom-left-radius"], "; \n            }\n          }") : "", "\n      ");
        }
        return "";
    };
    /**
   * returns media queries to apply styles based on enable prop value on the diferent breakpoints
   */ _proto.handleMediaQueryRestrictions = function handleMediaQueryRestrictions(mobileStyles, tabletStyles) {
        if ((tabletStyles === null || tabletStyles === void 0 ? void 0 : tabletStyles.enable) === false && (mobileStyles === null || mobileStyles === void 0 ? void 0 : mobileStyles.enable)) return "and (max-width: 766px), (min-width: 993px)";
        if ((tabletStyles === null || tabletStyles === void 0 ? void 0 : tabletStyles.enable) === false) return "and (min-width: 993px)";
        if ((mobileStyles === null || mobileStyles === void 0 ? void 0 : mobileStyles.enable) === false) return "and (min-width: 767px)";
        return "";
    };
    _proto.handleOnClick = function handleOnClick(e, templateStyles) {
        // trigger parent onclick
        if (this.props.onClick) this.props.onClick(e);
        // check template onclick action
        // only run outside experience manager
        if (this.props.rule.actions && !this.props.expManager.enable) {
            if (templateStyles.actions && templateStyles.actions.enable && templateStyles.actions.onClick && templateStyles.actions.onClick !== "") {
                // https://stackoverflow.com/questions/939326/execute-javascript-code-stored-as-a-string
                // eslint-disable-next-line
                var F = new Function(templateStyles.actions.onClick);
                return F();
            }
        }
    };
    /**
   *
   * TODO: This logic only works for the first level of routes
   * needs to be redone
   */ _proto.handleActiveState = function handleActiveState(template) {
        var ref, ref1;
        var templateStylesBehaviour = template.behaviour;
        /**
     * Both Active state and link behaviour are enabled
     */ if (templateStylesBehaviour.active && templateStylesBehaviour.active.enable && ((ref = templateStylesBehaviour.link) === null || ref === void 0 ? void 0 : ref.enable) && ((ref1 = templateStylesBehaviour.link) === null || ref1 === void 0 ? void 0 : ref1.target) === "_self") {
            /**
       * Both customUrl for behaviour and the page link match
       */ if (templateStylesBehaviour.link.customUrl === this.props.router.query.localId) {
                return "active";
            }
        }
        return "";
    };
    _proto.clickEvent = function clickEvent(e, TAG) {
        if (TAG === "a") {
            var ref;
            var linkLabel = analyticsLinkLabel(this.props.field, {
                inlineContent: this.props.inlineContent,
                overrides: this.props.overrides
            }, this.props.pageResponse, this.props.post);
            //get parent id to properly know who has the link configured
            var parentId = (ref = e.target.parentElement) === null || ref === void 0 ? void 0 : ref.id;
            if (parentId) {
                GoogleEvent("link_click", linkLabel, "Link Clicked", 1);
            }
        }
    };
    _proto.handleLink = function handleLink() {
        var ref;
        var isPostPath = (ref = components_getOverrideInlineContentValues("".concat(this.props.field, ".behaviour-link-mappedValue"), this.props)) === null || ref === void 0 ? void 0 : ref.startsWith("$");
        var linkAttrs = {};
        //(templateStyles.behaviour && (templateStyles.behaviour.link.enable && ((templateStyles.behaviour.link.customUrl && templateStyles.behaviour.link.customUrl !== '') || isPostPath)))
        if (components_getOverrideInlineContentValues("".concat(this.props.field, ".behaviour-link-enable"), this.props) && (components_getOverrideInlineContentValues("".concat(this.props.field, ".behaviour-link-customUrl"), this.props) && components_getOverrideInlineContentValues("".concat(this.props.field, ".behaviour-link-customUrl"), this.props) !== "" || isPostPath)) {
            linkAttrs["href"] = handleComponentLinks(this.props.inlineContent, this.props.field, this.props.pageResponse, this.props.overrides, this.props.post);
            linkAttrs["target"] = components_getOverrideInlineContentValues("".concat(this.props.field, ".behaviour-link-target"), this.props);
        }
        return linkAttrs;
    };
    _proto.render = function render() {
        var _this = this;
        var templateStyles = this.props.template;
        var foundationsList = this.props.pageResponse.foundations;
        /**
     * Foundations
     */ var shadowFoundationStyle = getResponsiveAttachedFoundationStyle(templateStyles, foundationsList, "shadow", "color", "default", "desktop");
        var mobileShadowFoundationStyle = getResponsiveAttachedFoundationStyle(templateStyles, foundationsList, "shadow", "color", "default", "mobile");
        var tabletShadowFoundationStyle = getResponsiveAttachedFoundationStyle(templateStyles, foundationsList, "shadow", "color", "default", "tablet");
        // Colors
        // const colorsColorFirstFoundationStyle = getResponsiveAttachedFoundationStyle(
        //   templateStyles,
        //   foundationsList,
        //   "colors",
        //   "colorFirst",
        //   "default",
        //   "desktop"
        // ) as FColor
        var mobileColorsColorFirstFoundationStyle = getResponsiveAttachedFoundationStyle(templateStyles, foundationsList, "colors", "colorFirst", "default", "mobile");
        var tabletColorsColorFirstFoundationStyle = getResponsiveAttachedFoundationStyle(templateStyles, foundationsList, "colors", "colorFirst", "default", "tablet");
        // const colorsColorSecondFoundationStyle = getResponsiveAttachedFoundationStyle(
        //   templateStyles,
        //   foundationsList,
        //   "colors",
        //   "colorSecond",
        //   "default",
        //   "desktop"
        // ) as FColor
        var mobileColorsColorSecondFoundationStyle = getResponsiveAttachedFoundationStyle(templateStyles, foundationsList, "colors", "colorSecond", "default", "mobile");
        var tabletColorsColorSecondFoundationStyle = getResponsiveAttachedFoundationStyle(templateStyles, foundationsList, "colors", "colorSecond", "default", "tablet");
        /**
     * Background image src
     */ var mediaObject = this.props.inlineContent ? mediaLibraryUtils_handleSrcLink(this.props.pageResponse, components_getOverrideInlineContentValues("".concat(this.props.field, ".image-src"), this.props)) : undefined;
        var imageSrc = mediaObject ? mediaObject.mediaSrc : "";
        if (!this.props.pageResponse.webpSupport && (mediaObject === null || mediaObject === void 0 ? void 0 : mediaObject.fallbackExtension) && (mediaObject === null || mediaObject === void 0 ? void 0 : mediaObject.mediaInfo)) {
            imageSrc = "https://static-media.fluxio.cloud/".concat(mediaObject.mediaInfo.profileName, "/").concat(mediaObject.mediaInfo.id).concat(hasVersion(mediaObject.mediaInfo.version), ".").concat(mediaObject.fallbackExtension);
            console.warn("Fallback, webp not supported: ", imageSrc);
        }
        /**
     * Responsive Styles
     */ var alignmentAdittionalProperties = {
            flexDirection: this.props.flexDirection,
            self: true
        };
        var mobileStyles = (0,src_object_spread/* default */.Z)({}, responsiveProperties(templateStyles, "mobile", undefined, [
            "grid",
            "alignment",
            "shadow",
            "spacing",
            "colors",
            "image",
            "border"
        ], undefined, [
            mobileColorsColorFirstFoundationStyle,
            mobileColorsColorSecondFoundationStyle
        ]), conditionalShadowRenderUnsafe(templateStyles, "mobile", "default", "box", mobileShadowFoundationStyle), conditionalBoundaryRenderUnsafe(templateStyles, "mobile", "default"), conditionalBorderRenderUnsafe(templateStyles, "mobile", "default", true), conditionalColorsRenderUnsafe(templateStyles, "mobile", "default", true), backgroundImageStyle_cssRenderUnsafe(templateStyles, "mobile", "default", imageSrc));
        var tabletStyles = (0,src_object_spread/* default */.Z)({}, responsiveProperties(templateStyles, "tablet", undefined, [
            "grid",
            "alignment",
            "shadow",
            "spacing",
            "colors",
            "image",
            "border"
        ], undefined, [
            tabletColorsColorFirstFoundationStyle,
            tabletColorsColorSecondFoundationStyle
        ]), conditionalShadowRenderUnsafe(templateStyles, "tablet", "default", "box", tabletShadowFoundationStyle), conditionalBoundaryRenderUnsafe(templateStyles, "tablet", "default"), conditionalBorderRenderUnsafe(templateStyles, "tablet", "default", true), conditionalColorsRenderUnsafe(templateStyles, "tablet", "default", true), backgroundImageStyle_cssRenderUnsafe(templateStyles, "tablet", "default", imageSrc));
        var mobileStylesContainer = AlignmentCssRenderUnsafe(templateStyles, "mobile", "default", alignmentAdittionalProperties);
        var tabletStylesContainer = AlignmentCssRenderUnsafe(templateStyles, "tablet", "default", alignmentAdittionalProperties);
        var linkAttrs = getLinkAttributes(this.props.field, {
            inlineContent: this.props.inlineContent,
            overrides: this.props.overrides
        }, this.props.pageResponse, this.props.post);
        var TAG = components_getOverrideInlineContentValues("".concat(this.props.field, ".behaviour-link-enable"), this.props) ? "a" : "div";
        var containerClass = templateStyles.wrap && templateStyles.wrap === "container" ? "container" : templateStyles.wrap && templateStyles.wrap !== "container" ? "container-fluid" : "";
        var backgroundImageStyles = backgroundImageStyle_cssRenderUnsafe(templateStyles, "desktop", "default", imageSrc);
        var backgroundColorStyles = conditionalColorsRenderUnsafe(templateStyles, "desktop", "default", true);
        var heightStyles = handleHeight(templateStyles);
        var bondariesObj = conditionalBoundaryRenderUnsafe(templateStyles, "desktop", "default");
        var imageFilterStyles = handleImageFilter(templateStyles);
        var flowStyles = handleFlow(templateStyles);
        var borders = conditionalBorderRenderUnsafe(templateStyles, "desktop", "default", true);
        var shadows = conditionalShadowRenderUnsafe(templateStyles, "desktop", "default", "box", shadowFoundationStyle);
        var shadowZIndex = zIndexFix(templateStyles.shadow.enable, templateStyles.scroll, this.props.objPosition);
        var radiusStyles = handleRadius(templateStyles);
        var alignmentStyles = this.props.rule.alignment ? AlignmentCssRenderUnsafe(templateStyles, "desktop", "default", alignmentAdittionalProperties) : {};
        var backgroundProperties = (0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            height: heightStyles.height
        }, imageFilterStyles.filter, flowStyles, shadows, shadowZIndex, borders, radiusStyles, bondariesObj, backgroundColorStyles), {
            backgroundAttachment: templateStyles.attachment + " !important"
        }), backgroundImageStyles);
        var classPrefix = "prefix".concat(templateStyles.uuid);
        // LEGACY check for (this.props.rules.behaviour && this.props.rules.behaviour.hover)
        var hoverStyles = "";
        var activeStyles = "";
        if (this.props.rule && this.props.rule.behaviour && this.props.rule.behaviour.hover) {
            var ref, ref1, ref2, ref3;
            hoverStyles = this.handleStateStyles(templateStyles, templateStyles.behaviour.hover, (ref = templateStyles.mobile) === null || ref === void 0 ? void 0 : (ref1 = ref.behaviour) === null || ref1 === void 0 ? void 0 : ref1.hover, (ref2 = templateStyles.tablet) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.behaviour) === null || ref3 === void 0 ? void 0 : ref3.hover, ".".concat(classPrefix, "-image-filter:hover"), imageSrc, "hover");
        }
        if (this.props.rule && this.props.rule.behaviour && this.props.rule.behaviour.active) {
            var ref4, ref5, ref6, ref7;
            activeStyles = this.handleStateStyles(templateStyles, templateStyles.behaviour.active, (ref4 = templateStyles.mobile) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.behaviour) === null || ref5 === void 0 ? void 0 : ref5.active, (ref6 = templateStyles.tablet) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.behaviour) === null || ref7 === void 0 ? void 0 : ref7.active, ".".concat(classPrefix, "-image-filter.active"), imageSrc, "active");
        }
        var hasStateStyles = hoverStyles.trim() !== "" || activeStyles.trim() !== "";
        var customAttributesEnable = components_getOverrideInlineContentValues("".concat(this.props.field, ".").concat(CUSTOM_ATTRIBUTES_ENABLE), {
            inlineContent: this.props.inlineContent,
            overrides: this.props.overrides
        });
        var customAttributesMappedField = components_getOverrideInlineContentValues("".concat(this.props.field, ".").concat(CUSTOM_ATTRIBUTES_MAPPED_FIELD), {
            inlineContent: this.props.inlineContent,
            overrides: this.props.overrides
        });
        var customAttributesValue = components_getOverrideInlineContentValues("".concat(this.props.field, ".").concat(CUSTOM_ATTRIBUTES_VALUE), {
            inlineContent: this.props.inlineContent,
            overrides: this.props.overrides
        });
        var customAttributesContentSrc = components_getOverrideInlineContentValues("".concat(this.props.field, ".").concat(CUSTOM_ATTRIBUTES_CONTENTSRC), {
            inlineContent: this.props.inlineContent,
            overrides: this.props.overrides
        });
        var datasetValue = datasetRender(this.props.post, customAttributesEnable, customAttributesMappedField, customAttributesValue, customAttributesContentSrc);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                hasStateStyles && /*#__PURE__*/ (0,jsx_runtime.jsx)((style_it_default()), {
                    children: "          \n              ".concat(hoverStyles, "\n              ").concat(activeStyles, "\n            ")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoBackgroundDiv, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, datasetValue), {
                    tablet: tabletStyles,
                    mobile: mobileStyles,
                    desktop: backgroundProperties,
                    as: TAG,
                    id: handleDOMid(this.props.field, this.props.id, this.props.instanceId, this.props.post),
                    className: "bob-background spacing-preview-".concat(this.props.template.uuid, " ").concat(classPrefix, "-image-filter ").concat(this.props.className ? this.props.className : "", " ").concat(this.handleActiveState(templateStyles), " ").concat(globalStylesUtils.handleClassName(this.props.pageResponse.nGlobalStyles, this.props.template, undefined, "-box")),
                    onClick: function(e) {
                        _this.handleOnClick(e, templateStyles);
                        _this.clickEvent(e, TAG);
                    },
                    onMouseEnter: this.props.onMouseEnter,
                    onMouseLeave: this.props.onMouseLeave
                }), linkAttrs), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BobBackgroundContainer, {
                            desktop: alignmentStyles,
                            mobile: mobileStylesContainer,
                            tablet: tabletStylesContainer,
                            className: "".concat(containerClass, " ").concat(responsiveWrapClass(templateStyles)),
                            children: this.props.children
                        }),
                        this.isFilterEnabled(templateStyles) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "image-filter-overlay",
                            style: imageFilterStyles.overlay
                        })
                    ]
                }))
            ]
        });
    };
    return BobBackgroundImage;
}(react.Component);
/* harmony default export */ var bobBackgroundImage = ((0,router.withRouter)(BobBackgroundImage));

// EXTERNAL MODULE: ./node_modules/parse5/lib/index.js
var parse5_lib = __webpack_require__(42394);
// EXTERNAL MODULE: ./node_modules/lodash/flatten.js
var flatten = __webpack_require__(85564);
var flatten_default = /*#__PURE__*/__webpack_require__.n(flatten);
// EXTERNAL MODULE: ./node_modules/postscribe/dist/postscribe.js
var postscribe = __webpack_require__(53808);
var postscribe_default = /*#__PURE__*/__webpack_require__.n(postscribe);
// EXTERNAL MODULE: ./node_modules/react-tippy/dist/react-tippy.js
var react_tippy = __webpack_require__(47964);
;// CONCATENATED MODULE: ./src/modules/shared-modules/experienceManager/warningSystem.tsx







var WarningSystem = function(props) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var warningState = (0,es/* useSelector */.v9)(function(state) {
        return state.experienceManagerReducer;
    }).warningState;
    var actions = (0,redux/* bindActionCreators */.DE)((0,src_object_spread/* default */.Z)({}, publicPageActions_namespaceObject), dispatch);
    if (props.toggle) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_tippy.Tooltip, {
            title: warningState ? "Hide Information Notes on Preview" : "Show Information Notes on Preview",
            position: "bottom",
            trigger: "mouseenter",
            arrow: true,
            theme: "light",
            animation: "fade",
            style: {
                display: "flex"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: function() {
                    return actions.warningSystemEM(!warningState);
                },
                className: "btn btn-transparent".concat(warningState ? " selected" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "https://cdn.fluxio.cloud/fluxio/fluxio_icons_infomessages.svg",
                    alt: "warning"
                })
            })
        });
    }
    if (warningState) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "alert ".concat(props.alertType),
        role: "alert",
        children: props.messages
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var warningSystem = (/*#__PURE__*/react.memo(WarningSystem));

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/dangerousHtml/dangerousHtml.tsx







//@ts-ignore


//@ts-ignore


var DangerousHtml = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(DangerousHtml, _Component);
    var _super = (0,_create_super/* default */.Z)(DangerousHtml);
    function DangerousHtml(props) {
        (0,src_class_call_check/* default */.Z)(this, DangerousHtml);
        var _this;
        _this = _super.call(this, props);
        _this.state = (0,src_object_spread/* default */.Z)({
            id: (0,v4/* default */.Z)()
        }, _this.handleScripts(props.html));
        return _this;
    }
    var _proto = DangerousHtml.prototype;
    _proto.findScripts = function findScripts(node, keyPos) {
        var _this = this;
        if (node.tagName && node.tagName === "script") {
            return (node[keyPos] || []).map(function(n) {
                return n.value;
            });
        }
        return flatten_default()((node.childNodes || []).map(function(nodeChild) {
            return _this.findScripts(nodeChild, keyPos);
        }));
    };
    _proto.handleScripts = function handleScripts(html) {
        if (!html || typeof html !== "string") {
            return {
                scripts: undefined,
                srcs: undefined
            };
        }
        return {
            scripts: this.findScripts(parse5_lib.parseFragment(html), "childNodes"),
            srcs: this.findScripts(parse5_lib.parseFragment(html), "attrs")
        };
    };
    _proto.componentDidMount = function componentDidMount() {
        if (!this.props.expManager.enable) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = (this.state.srcs || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var script = _step.value;
                    script !== "" && postscribe_default()("#".concat(this.state.id), "<script src=".concat(script, "></script>"));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            // eslint-disable-next-line
            var fns = (this.state.scripts || []).map(function(src) {
                // eslint-disable-next-line
                return new Function("require", src);
            }).forEach(function(fn) {
                return fn();
            });
        }
    };
    _proto.render = function render() {
        if (typeof this.props.html !== "string") return /*#__PURE__*/ (0,jsx_runtime.jsx)(warningSystem, {
            alertType: "alert-warning",
            messages: "Missing valid props to DangerousHtml component"
        });
        var _className;
        return /*#__PURE__*/ react.createElement("div", {
            id: this.props.id ? this.props.id : this.state.id,
            style: this.props.style,
            dangerouslySetInnerHTML: {
                __html: this.props.html
            },
            className: "dangerousHtml ".concat((_className = this.props.className) !== null && _className !== void 0 ? _className : ""),
            onMouseEnter: this.props.onMouseEnter,
            onMouseLeave: this.props.onMouseLeave
        });
    };
    return DangerousHtml;
}(react.Component);
/* harmony default export */ var dangerousHtml = (DangerousHtml);

// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(72679);
;// CONCATENATED MODULE: ./src/modules/shared-modules/deprecatedHandlers.ts




/**
 * 
 * @param props 
 * This method will write the new keys, properly updating embed and embedEnable
 * when video-enable is true, key used in the old system, since there was no support
 * for video upload.
 */ //TODO: Props types to be imported from mediaContentController 
function handleMediaContentWrite(props) {
    var ref, ref1;
    var inlineContent = props.finderSelectedObject.content.inlineContent;
    var _obj;
    //HandleDeprecatedValues
    var resolvedDeprecatedValues = (_obj = {
        //If both image-enable and video-enable are false we make enable false, else we read from the original one 
        enable: !inlineContent["".concat(props.bobKey, ".").concat(inlineContentTypes.IMAGE_ENABLE)] && !inlineContent["".concat(props.bobKey, ".").concat(inlineContentTypes.VIDEO_ENABLE)] ? false : props.finderSelectedObject.styles.bobs[props.bobKey].enable,
        //same has the above, but for hover
        enableHover: !inlineContent["".concat(props.bobKey, ".").concat(inlineContentTypes.IMAGE_ENABLE_HOVER)] && !inlineContent["".concat(props.bobKey, ".").concat(inlineContentTypes.VIDEO_ENABLE_HOVER)] ? false : (ref = props.finderSelectedObject.styles.bobs[props.bobKey].behaviour.hover) === null || ref === void 0 ? void 0 : ref.enable,
        //same has the above, but for active
        enableActive: !inlineContent["".concat(props.bobKey, ".").concat(inlineContentTypes.IMAGE_ENABLE_ACTIVE)] && !inlineContent["".concat(props.bobKey, ".").concat(inlineContentTypes.VIDEO_ENABLE_ACTIVE)] ? false : (ref1 = props.finderSelectedObject.styles.bobs[props.bobKey].behaviour.active) === null || ref1 === void 0 ? void 0 : ref1.enable
    }, //If the embed-enable is false we see if we have the deprecated video-enable to fetch its value
    _define_property(_obj, inlineContentTypes.EMBED_ENABLE, inlineContent["".concat(props.bobKey, ".").concat(inlineContentTypes.EMBED_ENABLE)] || inlineContent["".concat(props.bobKey, ".").concat(inlineContentTypes.VIDEO_ENABLE)]), //We write this false if the user touchs the mediaTypeController
    _define_property(_obj, inlineContentTypes.VIDEO_ENABLE, inlineContent["".concat(props.bobKey, ".").concat(inlineContentTypes.VIDEO_ENABLE)]), //if we dont have an embed we get the one from the src if video-enable is true
    _define_property(_obj, inlineContentTypes.EMBED, inlineContent["".concat(props.bobKey, ".").concat(inlineContentTypes.EMBED)] || (inlineContent["".concat(props.bobKey, ".").concat(inlineContentTypes.VIDEO_ENABLE)] ? inlineContent["".concat(props.bobKey, ".").concat(inlineContentTypes.SRC)] : "")), _obj);
    return resolvedDeprecatedValues;
}
/**
 * When the page is rendering a bobMedia, that still uses the old fields
 * for the video-enable, this method rewrites it to properly populate
 * embed and embedEnable fields
 */ function bobMediaRenderReadFix(inlineContent, bobKey) {
    /**
       * if the video-enable is true, we have a deprecated style.
       * This style can be using the new structure already, so for that
       * we are now going to see if embedEnable is true, if not we change it.
       */ if (inlineContent["".concat(bobKey, ".video-enable")]) {
        //there is deprecated value, but its updated with the proper key
        if (inlineContent["".concat(bobKey, ".embedEnable")]) return inlineContent;
        var _obj;
        //We need to populate embed and embedEnable here
        var fixedInlineContent = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, inlineContent), (_obj = {}, (0,src_define_property/* default */.Z)(_obj, "".concat(bobKey, ".embedEnable"), true), (0,src_define_property/* default */.Z)(_obj, "".concat(bobKey, ".embed"), inlineContent["".concat(bobKey, ".src")]), _obj));
        return fixedInlineContent;
    }
    return inlineContent;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var react_player_lib = __webpack_require__(22004);
// EXTERNAL MODULE: ./node_modules/react-player/lazy/index.js
var lazy = __webpack_require__(56310);
;// CONCATENATED MODULE: ./src/split/shared-public-page/bobMediaVideoPlayer/lazyVideoPlayer.tsx






var LazyVideoPlayer = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(LazyVideoPlayer, _Component);
    var _super = (0,_create_super/* default */.Z)(LazyVideoPlayer);
    function LazyVideoPlayer() {
        (0,src_class_call_check/* default */.Z)(this, LazyVideoPlayer);
        return _super.apply(this, arguments);
    }
    var _proto = LazyVideoPlayer.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy/* default */.Z, {
            url: this.props.url,
            controls: this.props.controls,
            config: this.props.config,
            width: "100%",
            height: "100%",
            loop: this.props.loop ? this.props.loop : false
        });
    };
    return LazyVideoPlayer;
}(react.Component);
/* harmony default export */ var lazyVideoPlayer = (LazyVideoPlayer);

;// CONCATENATED MODULE: ./src/split/shared-public-page/bobMediaVideoPlayer/videoPlayerSplit.tsx









var VideoPlayerSplit = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(VideoPlayerSplit, _Component);
    var _super = (0,_create_super/* default */.Z)(VideoPlayerSplit);
    function VideoPlayerSplit(props) {
        (0,src_class_call_check/* default */.Z)(this, VideoPlayerSplit);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            hasLoaded: false
        };
        return _this;
    }
    var _proto = VideoPlayerSplit.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this.state), {
            hasLoaded: true
        }));
    };
    _proto.render = function render() {
        if (this.state.hasLoaded) {
            if (this.props.videoType === "lazy") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(lazyVideoPlayer, {
                    url: this.props.url,
                    controls: this.props.controls,
                    config: this.props.config
                });
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_player_lib/* default */.Z, {
                    url: this.props.url,
                    controls: this.props.controls,
                    playing: this.props.playing,
                    config: this.props.config,
                    width: "100%",
                    height: "100%",
                    loop: this.props.loop,
                    muted: this.props.muted,
                    className: this.props.className,
                    style: this.props.style
                });
            }
        }
        return [];
    };
    return VideoPlayerSplit;
}(react.Component);
/* harmony default export */ var videoPlayerSplit = (VideoPlayerSplit);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobMedia/customMediaPlayer.tsx









var CustomMediaPlayer = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(CustomMediaPlayer, _Component);
    var _super = (0,_create_super/* default */.Z)(CustomMediaPlayer);
    function CustomMediaPlayer(props) {
        (0,src_class_call_check/* default */.Z)(this, CustomMediaPlayer);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            isPlaying: false
        };
        _this.handlePlayClick = _this.handlePlayClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    var _proto = CustomMediaPlayer.prototype;
    _proto.handlePlayClick = function handlePlayClick() {
        this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this.state), {
            isPlaying: !this.state.isPlaying
        }));
    };
    _proto.render = function render() {
        var _props = this.props, url = _props.url, controls = _props.controls, config = _props.config, playPauseAsset = _props.playPauseAsset;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "custom-video-player",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "play-pause-wrap",
                    onClick: this.handlePlayClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "play-pause-asset ".concat(this.state.isPlaying ? "playing" : "paused"),
                        src: playPauseAsset,
                        alt: "play"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(videoPlayerSplit, {
                    videoType: "normal",
                    url: url,
                    controls: controls,
                    playing: this.state.isPlaying,
                    config: config
                })
            ]
        });
    };
    return CustomMediaPlayer;
}(react.Component);
/* harmony default export */ var customMediaPlayer = (CustomMediaPlayer);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobMedia/bobMedia.tsx






function bobMedia_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  @media only screen and (max-width: 992px) and (min-width: 767px) {\n    ",
        "\n  }\n  @media all and (max-width: 766px) {\n    ",
        "\n  }\n"
    ]);
    bobMedia_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function bobMedia_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  @media only screen and (max-width: 992px) and (min-width: 767px) {\n    ",
        "\n  }\n  @media all and (max-width: 766px) {\n    ",
        "\n  }\n"
    ]);
    bobMedia_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  @media only screen and (max-width: 992px) and (min-width: 767px) {\n    ",
        "\n  }\n  @media all and (max-width: 766px) {\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  @media only screen and (max-width: 992px) and (min-width: 767px) {\n    ",
        "\n  }\n  @media all and (max-width: 766px) {\n    ",
        "\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



// @ts-ignore



























var BobMediaOuterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ac667104-0"
})(bobMedia_templateObject(), function(props) {
    return props.desktop;
}, function(props) {
    return props.tablet;
}, function(props) {
    return props.mobile;
});
var BobMediaDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ac667104-1"
})(bobMedia_templateObject1(), function(props) {
    return props.desktop;
}, function(props) {
    return props.tablet;
}, function(props) {
    return props.mobile;
});
var BobMediaImg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ac667104-2"
})(_templateObject2(), function(props) {
    return props.desktop;
}, function(props) {
    return props.tablet;
}, function(props) {
    return props.mobile;
});
var BobMediaFilterOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ac667104-3"
})(_templateObject3(), function(props) {
    return props.desktop;
}, function(props) {
    return props.tablet;
}, function(props) {
    return props.mobile;
});
var EmbedContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ac667104-4"
})(_templateObject4(), function(props) {
    return props.styles;
});
var BobMedia = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(BobMedia, _Component);
    var _super = (0,_create_super/* default */.Z)(BobMedia);
    function BobMedia(props) {
        (0,src_class_call_check/* default */.Z)(this, BobMedia);
        var _this;
        _this = _super.call(this, props);
        _this.isHoverEnabled = function(templateObj) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
            if (((ref = templateObj.behaviour.hover) === null || ref === void 0 ? void 0 : ref.enable) || ((ref1 = templateObj.tablet) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.hover) === null || ref3 === void 0 ? void 0 : ref3.enable) || ((ref4 = templateObj.mobile) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.behaviour) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.hover) === null || ref6 === void 0 ? void 0 : ref6.enable)) {
                return true;
            }
            return false;
        };
        _this.isFilterEnabled = function(templateObj) {
            var ref, ref1, ref2, ref3;
            if (templateObj.filter.enable || ((ref = templateObj.tablet) === null || ref === void 0 ? void 0 : (ref1 = ref.filter) === null || ref1 === void 0 ? void 0 : ref1.enable) || ((ref2 = templateObj.mobile) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.filter) === null || ref3 === void 0 ? void 0 : ref3.enable)) {
                return true;
            }
            return false;
        };
        _this.state = {
            isHover: false
        };
        return _this;
    }
    var _proto = BobMedia.prototype;
    _proto.handleActiveStateStyles = function handleActiveStateStyles(defaultTemplate, templateObj, templateObjMobile, templateObjTablet, classPrefix) {
        if (templateObj) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
            var widthTabletActiveStyle = widthStyle_cssRenderUnsafe(defaultTemplate, "tablet", "active");
            var widthMobileActiveStyle = widthStyle_cssRenderUnsafe(defaultTemplate, "mobile", "active");
            var heightTabletActiveStyle = heightStyle_cssRenderUnsafe(defaultTemplate, "tablet", "active");
            var heightMobileActiveStyle = heightStyle_cssRenderUnsafe(defaultTemplate, "mobile", "active");
            // Properties for BobImage
            var bobMediaImgProperties = [
                "radius",
                "filter",
                "size",
                "position"
            ];
            var templateMobile = responsiveProperties({
                mobile: (ref = templateObj.mobile) === null || ref === void 0 ? void 0 : (ref1 = ref.behaviour) === null || ref1 === void 0 ? void 0 : ref1.active
            }, "mobile", {}, [
                ""
            ], bobMediaImgProperties);
            templateMobile = (0,src_object_spread/* default */.Z)({}, templateMobile, conditionalShadowRenderUnsafe(defaultTemplate, "mobile", "active", "box", undefined), conditionalColorsRenderUnsafe(defaultTemplate, "mobile", "active", true), widthMobileActiveStyle, heightMobileActiveStyle);
            var templateTablet = responsiveProperties({
                tablet: (ref2 = templateObj.tablet) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.behaviour) === null || ref3 === void 0 ? void 0 : ref3.active
            }, "tablet", {}, [
                ""
            ], bobMediaImgProperties);
            templateTablet = (0,src_object_spread/* default */.Z)({}, templateTablet, conditionalShadowRenderUnsafe(defaultTemplate, "tablet", "active", "box", undefined), conditionalColorsRenderUnsafe(defaultTemplate, "tablet", "active", true), widthTabletActiveStyle, heightTabletActiveStyle);
            var alignmentAdittionalProperties = {
                flexDirection: "row",
                self: false
            };
            // Properties for BobImage container
            var bobImageProperties = [
                "width",
                "height",
                "radius",
                "border"
            ];
            var containerTemplateMobile = responsiveProperties({
                mobile: (ref4 = templateObj.mobile) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.behaviour) === null || ref5 === void 0 ? void 0 : ref5.active
            }, "mobile", {}, [
                ""
            ], bobImageProperties);
            containerTemplateMobile = (0,src_object_spread/* default */.Z)({}, containerTemplateMobile, AlignmentCssRenderUnsafe(defaultTemplate, "mobile", "active", alignmentAdittionalProperties), conditionalBoundaryRenderUnsafe(defaultTemplate, "mobile", "active"), conditionalBorderRenderUnsafe(defaultTemplate, "mobile", "active", true));
            var containerTemplateTablet = responsiveProperties({
                tablet: (ref6 = templateObj.tablet) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.behaviour) === null || ref7 === void 0 ? void 0 : ref7.active
            }, "tablet", {}, [
                ""
            ], bobImageProperties);
            containerTemplateTablet = (0,src_object_spread/* default */.Z)({}, containerTemplateTablet, AlignmentCssRenderUnsafe(defaultTemplate, "tablet", "active", alignmentAdittionalProperties), conditionalBoundaryRenderUnsafe(defaultTemplate, "tablet", "active"), conditionalBorderRenderUnsafe(defaultTemplate, "tablet", "active", true));
            var mediaQueryRestrictions = this.handleMediaQueryRestrictions(templateObjMobile, templateObjTablet);
            var backgroundColorStyles = conditionalColorsRenderUnsafe(defaultTemplate, "desktop", "active", true);
            var heightStyles = heightStyle_cssRenderUnsafe(defaultTemplate, "desktop", "active");
            var widthStyles = widthStyle_cssRenderUnsafe(defaultTemplate, "desktop", "active");
            var alignmentStyles = AlignmentCssRenderUnsafe(defaultTemplate, "desktop", "active", alignmentAdittionalProperties);
            var boundaries = conditionalBoundaryRenderUnsafe(defaultTemplate, "desktop", "active");
            var borders = conditionalBorderRenderUnsafe(defaultTemplate, "desktop", "active", true);
            var shadow = conditionalShadowRenderUnsafe(defaultTemplate, "desktop", "active", "box", undefined);
            var imageFilterStyles = handleImageFilter(templateObj, defaultTemplate);
            var radiusStyles = handleRadius(templateObj, defaultTemplate);
            return "\n      ".concat(templateObj.enable ? "@media all ".concat(mediaQueryRestrictions, "{\n            .active .").concat(classPrefix, "-bob-media{                      \n              justify-content: ").concat(alignmentStyles["justify-content"], ";\n              align-items: ").concat(alignmentStyles["align-items"], ";\n              align-self: ").concat(alignmentStyles["align-self"], "; \n              display: ").concat(alignmentStyles["display"], ";\n              flex-direction: ").concat(alignmentStyles["flex-direction"], ";\n            }\n            .active .").concat(classPrefix, "-bob-image{                      \n              width: ").concat(widthStyles.width, ";\n              height: ").concat(heightStyles.height, ";\n              ").concat(renderCSSString(boundaries), "    \n              ").concat(conditionalBorderCss(borders, (ref8 = this.props.template.controllerVersion) === null || ref8 === void 0 ? void 0 : ref8.border), "\n              border-bottom-left-radius: ").concat(radiusStyles.borderBottomLeftRadius, "; \n              border-bottom-right-radius: ").concat(radiusStyles.borderBottomRightRadius, "; \n              border-top-left-radius: ").concat(radiusStyles.borderTopLeftRadius, "; \n              border-top-right-radius: ").concat(radiusStyles.borderTopRightRadius, "; \n            }\n            .active .").concat(classPrefix, "-bob-image img,\n            .active .").concat(classPrefix, "-bob-image picture{\n              ").concat(colorsStyle_renderCSSString(backgroundColorStyles), "  \n              object-fit: ").concat(templateObj.size ? templateObj.size + " !important" : "", ";\n              object-position: ").concat(templateObj.position ? templateObj.position + " !important" : "", ";\n              max-width: ").concat(this.handleImgSizePropInPercentage(widthStyles.width), ";\n              max-height: ").concat(this.handleImgSizePropInPercentage(heightStyles.height), ";\n              filter: ").concat(imageFilterStyles.filter.filter, ";\n              webkit-filter: ").concat(imageFilterStyles.filter.WebkitFilter, ";\n              ").concat(boxShadowCss(shadow), "\n              border-bottom-left-radius: ").concat(radiusStyles.borderBottomLeftRadius, "; \n              border-bottom-right-radius: ").concat(radiusStyles.borderBottomRightRadius, "; \n              border-top-left-radius: ").concat(radiusStyles.borderTopLeftRadius, "; \n              border-top-right-radius: ").concat(radiusStyles.borderTopRightRadius, "; \n            }\n            .active .").concat(classPrefix, "-bob-image .image-filter-overlay{\n              background-color: ").concat(imageFilterStyles.overlay.backgroundColor, ";\n            }\n          }") : "", "\n      ").concat((templateObj.enable || (templateObjTablet === null || templateObjTablet === void 0 ? void 0 : templateObjTablet.enable)) && (templateObjTablet === null || templateObjTablet === void 0 ? void 0 : templateObjTablet.enable) !== false ? "@media all and (max-width: 992px) and (min-width: 767px){\n            .active .".concat(classPrefix, "-bob-media{                      \n              justify-content: ").concat(templateTablet["justify-Content"], ";\n              align-items: ").concat(templateTablet["align-items"], ";\n              align-self: ").concat(templateTablet["align-self"], "; \n              display: ").concat(templateTablet["display"], ";\n              flex-direction: ").concat(templateTablet["flex-direction"], ";\n            }\n            .active .").concat(classPrefix, "-bob-image{  \n              width: ").concat(containerTemplateTablet.width, ";\n              height: ").concat(containerTemplateTablet.height, ";\n              ").concat(renderCSSString(containerTemplateTablet), "       \n              ").concat(conditionalBorderCss(containerTemplateTablet, (ref9 = this.props.template.controllerVersion) === null || ref9 === void 0 ? void 0 : ref9.border), "\n              border-bottom-left-radius: ").concat(containerTemplateTablet["border-bottom-left-radius"], "; \n              border-bottom-right-radius: ").concat(containerTemplateTablet["border-bottom-right-radius"], "; \n              border-top-left-radius: ").concat(containerTemplateTablet["border-top-left-radius"], "; \n              border-top-right-radius: ").concat(containerTemplateTablet["border-top-left-radius"], "; \n            }\n            .active .").concat(classPrefix, "-bob-image img,\n            .active .").concat(classPrefix, "-bob-image picture{\n              ").concat(colorsStyle_renderCSSString(templateTablet), "  \n              object-fit: ").concat(templateTablet["object-fit"], ";\n              object-position: ").concat(templateTablet["object-position"], ";\n              max-width: ").concat(this.handleImgSizePropInPercentage(templateTablet.width), ";\n              max-height: ").concat(this.handleImgSizePropInPercentage(templateTablet.height), ";\n              filter: ").concat((ref10 = templateTablet.filter) === null || ref10 === void 0 ? void 0 : ref10.filter, ";\n              ").concat(boxShadowCss(templateTablet), "\n              border-bottom-left-radius: ").concat(templateTablet["border-bottom-left-radius"], "; \n              border-bottom-right-radius: ").concat(templateTablet["border-bottom-right-radius"], "; \n              border-top-left-radius: ").concat(templateTablet["border-top-left-radius"], "; \n              border-top-right-radius: ").concat(templateTablet["border-top-left-radius"], "; \n            }\n            .active .").concat(classPrefix, "-bob-image .image-filter-overlay{\n              background-color: ").concat(templateTablet["background-color"], ";\n            }\n          }") : "", "\n      ").concat((templateObj.enable || (templateObjMobile === null || templateObjMobile === void 0 ? void 0 : templateObjMobile.enable)) && (templateObjMobile === null || templateObjMobile === void 0 ? void 0 : templateObjMobile.enable) !== false ? "@media all and (max-width: 766px){\n            .active .".concat(classPrefix, "-bob-media{                      \n              justify-content: ").concat(templateTablet["justify-Content"], ";\n              align-items: ").concat(templateTablet["align-items"], ";\n              align-self: ").concat(templateTablet["align-self"], "; \n              display: ").concat(templateTablet["display"], ";\n              flex-direction: ").concat(templateTablet["flex-direction"], ";\n            }\n            .active .").concat(classPrefix, "-bob-image{  \n              width: ").concat(containerTemplateMobile.width, ";\n              height: ").concat(containerTemplateMobile.height, ";\n              ").concat(renderCSSString(containerTemplateMobile), "\n              ").concat(conditionalBorderCss(containerTemplateMobile, (ref11 = this.props.template.controllerVersion) === null || ref11 === void 0 ? void 0 : ref11.border), "\n              border-bottom-left-radius: ").concat(containerTemplateMobile["border-bottom-left-radius"], "; \n              border-bottom-right-radius: ").concat(containerTemplateMobile["border-bottom-right-radius"], "; \n              border-top-left-radius: ").concat(containerTemplateMobile["border-top-left-radius"], "; \n              border-top-right-radius: ").concat(containerTemplateMobile["border-top-left-radius"], "; \n            }\n            .active .").concat(classPrefix, "-bob-image img,\n            .active .").concat(classPrefix, "-bob-image picture{\n              ").concat(colorsStyle_renderCSSString(templateMobile), "  \n              object-fit: ").concat(templateMobile["object-fit"], ";\n              object-position: ").concat(templateMobile["object-position"], ";\n              max-width: ").concat(this.handleImgSizePropInPercentage(templateMobile.width), ";\n              max-height: ").concat(this.handleImgSizePropInPercentage(templateMobile.height), ";\n              filter: ").concat((ref12 = templateMobile.filter) === null || ref12 === void 0 ? void 0 : ref12.filter, ";\n              ").concat(boxShadowCss(templateMobile), "\n              border-bottom-left-radius: ").concat(templateMobile["border-bottom-left-radius"], "; \n              border-bottom-right-radius: ").concat(templateMobile["border-bottom-right-radius"], "; \n              border-top-left-radius: ").concat(templateMobile["border-top-left-radius"], "; \n              border-top-right-radius: ").concat(templateMobile["border-top-left-radius"], "; \n            }\n            .active .").concat(classPrefix, "-bob-image .image-filter-overlay{\n              background-color: ").concat(templateMobile["background-color"], ";\n            }\n          }") : "", "\n      ");
        }
        return "";
    };
    _proto.handleSize = function handleSize(size) {
        if (size.enable) {
            return "".concat(size.value).concat(size.unit);
        }
        return undefined;
    };
    /**
   * TODO: check for behaviour status for each breakpoint before computing logic
   * @param templateObj
   * @param templateObjMobile
   * @param templateObjTablet
   * @param classPrefix
   */ _proto.handleHoverStateStyles = function handleHoverStateStyles(defaultTemplate, templateObj, templateObjMobile, templateObjTablet, classPrefix) {
        if (templateObj) {
            var ref, ref1, ref2, ref3, ref4;
            var widthTabletActiveStyle = widthStyle_cssRenderUnsafe(defaultTemplate, "tablet", "hover");
            var widthMobileActiveStyle = widthStyle_cssRenderUnsafe(defaultTemplate, "mobile", "hover");
            var heightTabletActiveStyle = heightStyle_cssRenderUnsafe(defaultTemplate, "tablet", "hover");
            var heightMobileActiveStyle = heightStyle_cssRenderUnsafe(defaultTemplate, "mobile", "hover");
            var alignmentAdittionalProperties = {
                flexDirection: "column",
                self: false
            };
            var templateMobile = responsiveProperties({
                mobile: templateObjMobile
            }, "mobile", {
                shadow: {
                    shadowType: "text"
                }
            }, [
                ""
            ], [
                "behaviour"
            ]);
            templateMobile = (0,src_object_spread/* default */.Z)({}, templateMobile, AlignmentCssRenderUnsafe(defaultTemplate, "mobile", "hover", alignmentAdittionalProperties), conditionalShadowRenderUnsafe(defaultTemplate, "mobile", "hover", "box", undefined), conditionalBoundaryRenderUnsafe(defaultTemplate, "mobile", "hover"), conditionalBorderRenderUnsafe(defaultTemplate, "mobile", "hover", true), conditionalColorsRenderUnsafe(defaultTemplate, "mobile", "hover", true), responsiveGroupStylesProperties({
                mobile: templateObjMobile
            }, "mobile", "text"), widthMobileActiveStyle, heightMobileActiveStyle);
            var templateTablet = responsiveProperties({
                tablet: templateObjTablet
            }, "tablet", {
                shadow: {
                    shadowType: "text"
                }
            }, [
                ""
            ], [
                "behaviour"
            ]);
            templateTablet = (0,src_object_spread/* default */.Z)({}, templateTablet, AlignmentCssRenderUnsafe(defaultTemplate, "tablet", "hover", alignmentAdittionalProperties), conditionalShadowRenderUnsafe(defaultTemplate, "tablet", "hover", "box", undefined), conditionalBoundaryRenderUnsafe(defaultTemplate, "tablet", "hover"), conditionalBorderRenderUnsafe(defaultTemplate, "tablet", "hover", true), conditionalColorsRenderUnsafe(defaultTemplate, "tablet", "hover", true), responsiveGroupStylesProperties({
                tablet: templateObjTablet
            }, "tablet", "text"), widthTabletActiveStyle, heightTabletActiveStyle);
            var mediaQueryRestrictions = this.handleMediaQueryRestrictions(templateObjMobile, templateObjTablet);
            var backgroundColorStyles = conditionalColorsRenderUnsafe(defaultTemplate, "desktop", "hover", true);
            var heightStyles = heightStyle_cssRenderUnsafe(defaultTemplate, "desktop", "hover");
            var widthStyles = widthStyle_cssRenderUnsafe(defaultTemplate, "desktop", "hover");
            var alignmentStyles = AlignmentCssRenderUnsafe(defaultTemplate, "desktop", "hover", alignmentAdittionalProperties);
            var boundaries = conditionalBoundaryRenderUnsafe(defaultTemplate, "desktop", "hover");
            var borders = conditionalBorderRenderUnsafe(defaultTemplate, "desktop", "hover", true);
            var shadow = conditionalShadowRenderUnsafe(defaultTemplate, "desktop", "hover", "box", undefined);
            var imageFilterStyles = handleImageFilter(templateObj, defaultTemplate);
            var radiusStyles = handleRadius(templateObj, defaultTemplate);
            return "\n      ".concat(templateObj.enable ? "@media all ".concat(mediaQueryRestrictions, "{ \n            ").concat(classPrefix, "-bob-media:hover{                      \n              justify-content: ").concat(alignmentStyles["justify-content"], ";\n              align-items: ").concat(alignmentStyles["align-items"], ";\n              align-self: ").concat(alignmentStyles["align-self"], "; \n              display: ").concat(alignmentStyles.display, ";\n              flex-direction: ").concat(alignmentStyles["flex-direction"], ";\n            }\n            ").concat(classPrefix, "-bob-image:hover, \n            ").concat(classPrefix, "-bob-image.isHover, \n            ").concat(classPrefix, "-bob-media.isHover{                      \n              width: ").concat(widthStyles.width, ";\n              height: ").concat(heightStyles.height, ";\n              ").concat(renderCSSString(boundaries), "\n              ").concat(conditionalBorderCss(borders, (ref = this.props.template.controllerVersion) === null || ref === void 0 ? void 0 : ref.border), "\n              border-bottom-left-radius: ").concat(radiusStyles.borderBottomLeftRadius, "; \n              border-bottom-right-radius: ").concat(radiusStyles.borderBottomRightRadius, "; \n              border-top-left-radius: ").concat(radiusStyles.borderTopLeftRadius, "; \n              border-top-right-radius: ").concat(radiusStyles.borderTopRightRadius, "; \n            }\n            ").concat(classPrefix, "-bob-image:hover img,\n            ").concat(classPrefix, "-bob-image:hover picture,\n            ").concat(classPrefix, "-bob-image.isHover img,\n            ").concat(classPrefix, "-bob-image.isHover picture,\n            ").concat(classPrefix, "-bob-media.isHover picture,\n            ").concat(classPrefix, "-bob-media.isHover img{\n              ").concat(colorsStyle_renderCSSString(backgroundColorStyles), "  \n              object-fit: ").concat(templateObj.size ? templateObj.size + " !important" : "", ";\n              object-position: ").concat(templateObj.position ? templateObj.position + " !important" : "", ";\n              max-width: ").concat(this.handleImgSizePropInPercentage(widthStyles.width), ";\n              max-height: ").concat(this.handleImgSizePropInPercentage(heightStyles.height), ";\n              filter: ").concat(imageFilterStyles.filter.filter, ";\n              webkit-filter: ").concat(imageFilterStyles.filter.WebkitFilter, ";\n              ").concat(boxShadowCss(shadow), "\n              border-bottom-left-radius: ").concat(radiusStyles.borderBottomLeftRadius, "; \n              border-bottom-right-radius: ").concat(radiusStyles.borderBottomRightRadius, "; \n              border-top-left-radius: ").concat(radiusStyles.borderTopLeftRadius, "; \n              border-top-right-radius: ").concat(radiusStyles.borderTopRightRadius, ";\n            }\n            ").concat(classPrefix, "-bob-image:hover .image-filter-overlay{\n              background-color: ").concat(imageFilterStyles.overlay.backgroundColor, ";\n            }\n          }") : "", "\n      ").concat((templateObj.enable || (templateTablet === null || templateTablet === void 0 ? void 0 : templateTablet.enable)) && (templateTablet === null || templateTablet === void 0 ? void 0 : templateTablet.enable) !== false ? "@media all and (max-width: 992px) and (min-width: 767px){\n            ".concat(classPrefix, "-bob-media:hover{                      \n              justify-content: ").concat(templateTablet["justify-Content"], ";\n              align-items: ").concat(templateTablet["align-items"], ";\n              align-self: ").concat(templateTablet["align-self"], "; \n              display: ").concat(templateTablet["display"], ";\n              flex-direction: ").concat(templateTablet["flex-direction"], ";\n            }\n            ").concat(classPrefix, "-bob-image:hover, \n            ").concat(classPrefix, "-bob-image.isHover, \n            ").concat(classPrefix, "-bob-media.isHover{                 \n              width: ").concat(templateTablet.width, ";\n              height: ").concat(templateTablet.height, ";              \n              ").concat(renderCSSString(templateTablet), "\n              ").concat(conditionalBorderCss(templateTablet, (ref1 = this.props.template.controllerVersion) === null || ref1 === void 0 ? void 0 : ref1.border), "\n              border-bottom-left-radius: ").concat(templateTablet["border-bottom-left-radius"], "; \n              border-bottom-right-radius: ").concat(templateTablet["border-bottom-right-radius"], "; \n              border-top-left-radius: ").concat(templateTablet["border-top-left-radius"], "; \n              border-top-right-radius: ").concat(templateTablet["border-top-left-radius"], "; \n            }\n            ").concat(classPrefix, "-bob-image:hover img,\n            ").concat(classPrefix, "-bob-image:hover picture,\n            ").concat(classPrefix, "-bob-image.isHover img,\n            ").concat(classPrefix, "-bob-image.isHover picture,\n            ").concat(classPrefix, "-bob-media.isHover picture,\n            ").concat(classPrefix, "-bob-media.isHover img{\n              ").concat(colorsStyle_renderCSSString(templateTablet), "  \n              object-fit: ").concat(templateTablet.size, " !important;\n              object-position: ").concat(templateTablet.position, " !important;              \n              border-bottom-left-radius: ").concat(templateTablet["border-bottom-left-radius"], "; \n              border-bottom-right-radius: ").concat(templateTablet["border-bottom-right-radius"], "; \n              border-top-left-radius: ").concat(templateTablet["border-top-left-radius"], "; \n              border-top-right-radius: ").concat(templateTablet["border-top-left-radius"], "; \n              filter: ").concat((ref2 = templateTablet.filter) === null || ref2 === void 0 ? void 0 : ref2.filter, ";\n              ").concat(boxShadowCss(templateTablet), "\n            }\n            ").concat(classPrefix, "-bob-image:hover .image-filter-overlay{\n              background-color: ").concat(templateTablet["background-color"], ";\n            }\n          }") : "", "\n      ").concat((templateObj.enable || (templateMobile === null || templateMobile === void 0 ? void 0 : templateMobile.enable)) && (templateMobile === null || templateMobile === void 0 ? void 0 : templateMobile.enable) !== false ? "@media all and (max-width: 766px){\n            ".concat(classPrefix, "-bob-media:hover{                      \n              justify-content: ").concat(templateMobile["justify-Content"], ";\n              align-items: ").concat(templateMobile["align-items"], ";\n              align-self: ").concat(templateMobile["align-self"], "; \n              display: ").concat(templateMobile["display"], ";\n              flex-direction: ").concat(templateMobile["flex-direction"], ";\n            }\n            ").concat(classPrefix, "-bob-image:hover, \n            ").concat(classPrefix, "-bob-image.isHover, \n            ").concat(classPrefix, "-bob-media.isHover{  \n              width: ").concat(templateMobile.width, ";\n              height: ").concat(templateMobile.height, ";\n              ").concat(renderCSSString(templateMobile), "\n              ").concat(conditionalBorderCss(templateMobile, (ref3 = this.props.template.controllerVersion) === null || ref3 === void 0 ? void 0 : ref3.border), "\n              border-bottom-left-radius: ").concat(templateMobile["border-bottom-left-radius"], "; \n              border-bottom-right-radius: ").concat(templateMobile["border-bottom-right-radius"], "; \n              border-top-left-radius: ").concat(templateMobile["border-top-left-radius"], "; \n              border-top-right-radius: ").concat(templateMobile["border-top-left-radius"], "; \n            }\n            ").concat(classPrefix, "-bob-image:hover img,\n            ").concat(classPrefix, "-bob-image:hover picture,\n            ").concat(classPrefix, "-bob-image.isHover img,\n            ").concat(classPrefix, "-bob-image.isHover picture,\n            ").concat(classPrefix, "-bob-media.isHover picture,\n            ").concat(classPrefix, "-bob-media.isHover img{\n              ").concat(colorsStyle_renderCSSString(templateMobile), "  \n              object-fit: ").concat(templateMobile.size, " !important;\n              object-position: ").concat(templateMobile.position, " !important;              \n              border-bottom-left-radius: ").concat(templateMobile["border-bottom-left-radius"], "; \n              border-bottom-right-radius: ").concat(templateMobile["border-bottom-right-radius"], "; \n              border-top-left-radius: ").concat(templateMobile["border-top-left-radius"], "; \n              border-top-right-radius: ").concat(templateMobile["border-top-left-radius"], "; \n              filter: ").concat((ref4 = templateMobile.filter) === null || ref4 === void 0 ? void 0 : ref4.filter, ";\n              ").concat(boxShadowCss(templateMobile), "\n            }\n            ").concat(classPrefix, "-bob-image:hover .image-filter-overlay{\n              background-color: ").concat(templateMobile["background-color"], ";\n            }\n          }") : "", "\n      ");
        }
        return "";
    };
    /**
   * returns media queries to apply styles based on enable prop value on the diferent breakpoints
   */ _proto.handleMediaQueryRestrictions = function handleMediaQueryRestrictions(mobileStyles, tabletStyles) {
        if ((tabletStyles === null || tabletStyles === void 0 ? void 0 : tabletStyles.enable) === false && (mobileStyles === null || mobileStyles === void 0 ? void 0 : mobileStyles.enable)) return "and (max-width: 766px), (min-width: 993px)";
        if ((tabletStyles === null || tabletStyles === void 0 ? void 0 : tabletStyles.enable) === false) return "and (min-width: 993px)";
        if ((mobileStyles === null || mobileStyles === void 0 ? void 0 : mobileStyles.enable) === false) return "and (min-width: 767px)";
        return "";
    };
    _proto.imageOnHover = function imageOnHover(template) {
        var ref;
        if (this.props.rule && this.props.rule.behaviour && this.props.rule.behaviour.hover) {
            if ((ref = template.behaviour.hover) === null || ref === void 0 ? void 0 : ref.enable) {
                // DEPRECATED CHECK
                this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this.state), {
                    isHover: true
                }));
            }
        }
    };
    _proto.imageUnHover = function imageUnHover(template) {
        var ref;
        if (this.props.rule && this.props.rule.behaviour && this.props.rule.behaviour.hover) {
            if ((ref = template.behaviour.hover) === null || ref === void 0 ? void 0 : ref.enable) {
                // DEPRECATED CHECK
                this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this.state), {
                    isHover: false
                }));
            }
        }
    };
    _proto.mergeMedias = function mergeMedias() {
        var ref, ref1;
        if (!((ref = this.props.object.content) === null || ref === void 0 ? void 0 : (ref1 = ref.formula) === null || ref1 === void 0 ? void 0 : ref1.media)) return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this.props.pageResponse), {
            media: (0,src_object_spread/* default */.Z)({}, this.props.pageResponse.media, this.props.replacedMediaList)
        });
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this.props.pageResponse), {
            media: (0,src_object_spread/* default */.Z)({}, this.props.pageResponse.media, this.props.object.content.formula.media, this.props.replacedMediaList)
        });
    };
    _proto.handleImageValue = function handleImageValue(postObj) {
        if (this.props.src) {
            return {
                mediaSrc: mkRawUrl(this.props.src),
                mediaAlt: ""
            };
        } else if (components_getOverrideInlineContentValues("".concat(this.props.field, ".contentSrc"), this.props) === textContentHelper_WRITE) {
            var mediaUrl = getOverrideInlineContentString("".concat(this.props.field, ".src"), this.props);
            return mediaLibraryUtils_handleSrcLink(this.props.pageResponse, mediaUrl);
        } else if (components_getOverrideInlineContentValues("".concat(this.props.field, ".contentSrc"), this.props) === textContentHelper_CMS && postObj && this.props.inlineContent) {
            var mediaUrl1 = components_getMediaStringField(postObj, this.props.inlineContent, this.props.field, this.props.overrides);
            return mediaLibraryUtils_handleSrcLink(this.mergeMedias(), mediaUrl1);
        } else if (components_getOverrideInlineContentValues("".concat(this.props.field, ".contentSrc"), this.props) === textContentHelper_CONTENT_PAGE) {
            var ref;
            var _$postObj = ((ref = this.props.pageResponse.contentPage) === null || ref === void 0 ? void 0 : ref.content) || contentPageHelper_DummyPost;
            var mediaUrl2 = components_getMediaStringField(_$postObj, this.props.inlineContent, this.props.field, this.props.overrides);
            return mediaLibraryUtils_handleSrcLink(this.mergeMedias(), mediaUrl2);
        } else {
            return {
                mediaSrc: undefined,
                mediaAlt: ""
            };
        }
    };
    _proto.handleWidthAndHeightReplace = function handleWidthAndHeightReplace(cssPropertiesObj) {
        if (cssPropertiesObj.width) {
            cssPropertiesObj.maxWidth = cssPropertiesObj.width !== "auto !important" ? cssPropertiesObj.width : "auto !important";
            cssPropertiesObj.width = cssPropertiesObj.width === "auto !important" && cssPropertiesObj.width;
        }
        if (cssPropertiesObj.height) {
            cssPropertiesObj.maxHeight = cssPropertiesObj.height !== "auto !important" ? cssPropertiesObj.height : "auto !important";
            cssPropertiesObj.height = cssPropertiesObj.height === "auto !important" && cssPropertiesObj.height;
        }
        return cssPropertiesObj;
    };
    /**
   * img must be 100% of it's bob-image if the style dimension is a % value
   *
   * @param style
   * @returns style
   */ _proto.handleImgSizeInPercentage = function handleImgSizeInPercentage(style) {
        var ref, ref1;
        if ((ref = style.width) === null || ref === void 0 ? void 0 : ref.includes("%")) style.width = "100% !important";
        if ((ref1 = style.height) === null || ref1 === void 0 ? void 0 : ref1.includes("%")) style.height = "100% !important";
        return style;
    };
    /**
   * img must be 100% of it's bob-image if the style dimension is a % value
   *
   * @param style
   * @returns style
   */ _proto.handleImgSizePropInPercentage = function handleImgSizePropInPercentage(size) {
        if (size === null || size === void 0 ? void 0 : size.includes("%")) size = "100% !important";
        return size;
    };
    _proto.handleImageHoverValue = function handleImageHoverValue(postObj) {
        if (this.props.src) return {
            mediaSrc: this.props.src,
            mediaAlt: ""
        };
        // fallback to default image when state doenst have it written
        if (!this.props.inlineContent.hasOwnProperty("".concat(this.props.field, ".src"))) return mediaLibraryUtils_handleSrcLink(this.props.pageResponse, components_getOverrideInlineContentValues("".concat(this.props.field, ".src"), this.props));
        // custom content
        if (components_getOverrideInlineContentValues("".concat(this.props.field, ".contentSrc"), this.props) === textContentHelper_WRITE) return components_getOverrideInlineContentValues("".concat(this.props.field, ".behaviour-hover-src"), this.props) && components_getOverrideInlineContentValues("".concat(this.props.field, ".behaviour-hover-src"), this.props) !== "" ? mediaLibraryUtils_handleSrcLink(this.props.pageResponse, components_getOverrideInlineContentValues("".concat(this.props.field, ".behaviour-hover-src"), this.props)) : mediaLibraryUtils_handleSrcLink(this.props.pageResponse, components_getOverrideInlineContentValues("".concat(this.props.field, ".src"), this.props));
        else if (components_getOverrideInlineContentValues("".concat(this.props.field, ".contentSrc"), this.props) === textContentHelper_CMS && postObj && this.props.inlineContent) {
            var mediaUrl = components_getMediaStringField(postObj, this.props.inlineContent, this.props.field, this.props.overrides);
            return mediaLibraryUtils_handleSrcLink(this.mergeMedias(), mediaUrl);
        }
        return {
            mediaSrc: "",
            mediaAlt: ""
        };
    };
    /**
   *
   * @param media
   * @param style
   * @param validMediaObject When its a validMediaObject we need to create the link
   * When its invalid, the link must be supported by the player, or else the video wont play
   */ _proto.renderVideo = function renderVideo(templateObj, media, style, inlineContent, classPrefix, datasetRender) {
        // Properties for BobImage container
        var bobVideoProperties = [
            "width",
            "height",
            "radius"
        ];
        var bobVideoMobileStyle = responsiveProperties(templateObj, "mobile", {}, [
            ""
        ], bobVideoProperties);
        bobVideoMobileStyle = (0,src_object_spread/* default */.Z)({}, bobVideoMobileStyle, conditionalBoundaryRenderUnsafe(templateObj, "mobile", "default"), conditionalBorderRenderUnsafe(templateObj, "mobile", "default", true), conditionalBorderRenderUnsafe(templateObj, "mobile", "default", true));
        var bobVideoTabletStyle = responsiveProperties(templateObj, "tablet", {}, [
            ""
        ], bobVideoProperties);
        bobVideoTabletStyle = (0,src_object_spread/* default */.Z)({}, bobVideoTabletStyle, conditionalBoundaryRenderUnsafe(templateObj, "tablet", "default"), conditionalBorderRenderUnsafe(templateObj, "tablet", "default", true), conditionalBorderRenderUnsafe(templateObj, "tablet", "default", true));
        var bobVideoStyle = {
            width: style.width,
            height: style.height,
            "margin-top": style["margin-top"],
            "margin-bottom": style["margin-bottom"],
            "margin-right": style["margin-right"],
            "margin-left": style["margin-left"],
            "padding-top": style["padding-top"],
            "padding-bottom": style["padding-bottom"],
            "padding-right": style["padding-right"],
            "padding-left": style["padding-left"],
            "border-bottom-style": style["border-bottom-style"],
            "border-bottom-width": style["border-bottom-width"],
            "border-bottom-color": style["border-bottom-color"],
            "border-top-style": style["border-top-style"],
            "border-top-width": style["border-top-width"],
            "border-top-color": style["border-top-color"],
            "border-left-style": style["border-left-style"],
            "border-left-width": style["border-left-width"],
            "border-left-color": style["border-left-color"],
            "border-right-style": style["border-right-style"],
            "border-right-width": style["border-right-width"],
            "border-right-color": style["border-right-color"],
            "border-bottom-left-radius": style.borderBottomLeftRadius,
            "border-bottom-right-radius": style.borderBottomRightRadius,
            "border-top-left-radius": style.borderTopLeftRadius,
            "border-top-right-radius": style.borderTopRightRadius
        };
        /**
     * Here we get the thumbnail to be used has a poster.
     * The poster attribute is sended to the ReactPlayer
     * when a valid string is present.
     */ var Poster = components_getOverrideInlineContentValues("".concat(this.props.field, ".thumbnail"), {
            inlineContent: inlineContent,
            overrides: this.props.overrides
        });
        var config = {
            file: {
                attributes: {
                    poster: Poster,
                    preload: Poster && Poster !== "" ? "none" : "auto"
                }
            }
        };
        /**
     * The controls must come with a false written, to disable them, else we show it
     * since the inlineContent can come empty
     */ var controls = components_getOverrideInlineContentValues("".concat(this.props.field, ".controls"), {
            inlineContent: inlineContent,
            overrides: this.props.overrides
        });
        /**
     * For the playPauseAsset to be used, the controls must be false,
     * since the user loses the ability to play/pause the video with the browser player,
     * this asset will control that.
     */ var playPauseAsset = components_getOverrideInlineContentValues("".concat(this.props.field, ".playPauseAsset"), {
            inlineContent: inlineContent,
            overrides: this.props.overrides
        });
        //We load a component, since this will use the state to control the player
        if (controls === false && playPauseAsset && playPauseAsset !== "") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BobMediaDiv, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, datasetRender), {
                desktop: bobVideoStyle,
                mobile: bobVideoMobileStyle,
                tablet: bobVideoTabletStyle,
                id: handleDOMid(this.props.field, this.props.id, this.props.instanceId),
                className: "bob-image ".concat(classPrefix, "-bob-image image-filter ").concat(globalStylesUtils.handleClassName(this.props.pageResponse.nGlobalStyles, this.props.template, [
                    GS_BOUNDARY
                ])),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(customMediaPlayer, {
                    url: handleMediaSrc(media),
                    controls: false,
                    config: config,
                    playPauseAsset: playPauseAsset
                })
            }));
        }
        //render the player with defaults
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BobMediaDiv, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, datasetRender), {
            desktop: bobVideoStyle,
            mobile: bobVideoMobileStyle,
            tablet: bobVideoTabletStyle,
            id: handleDOMid(this.props.field, this.props.id, this.props.instanceId),
            className: "bob-image ".concat(classPrefix, "-bob-image image-filter"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(videoPlayerSplit, {
                url: handleMediaSrc(media),
                controls: controls === false ? false : true,
                config: config,
                videoType: "lazy"
            })
        }));
    };
    _proto.renderEmbed = function renderEmbed(inlineContent, templateObj, style, datasetRender) {
        var _this = this;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbedContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            as: dangerousHtml
        }, datasetRender), {
            id: handleDOMid(this.props.field, this.props.id, this.props.instanceId) + "lalalalala",
            onMouseEnter: function() {
                return _this.imageOnHover(templateObj);
            },
            onMouseLeave: function() {
                return _this.imageUnHover(templateObj);
            },
            styles: (0,src_object_spread/* default */.Z)({
                textAlign: "center"
            }, style),
            html: components_getOverrideInlineContentValues("".concat(this.props.field, ".embed"), {
                inlineContent: inlineContent,
                overrides: this.props.overrides
            }),
            expManager: this.props.expManager
        }));
    };
    _proto.LazyMedia = function LazyMedia(param) {
        var src = param.src, alt = param.alt, tabletMedia = param.tabletMedia, mobileMedia = param.mobileMedia, mediaInfo = param.mediaInfo, className = param.className, style = param.style, onError = param.onError, visibleByDefault = param.visibleByDefault, fallbackExtension = param.fallbackExtension, onMouseEnter = param.onMouseEnter, onMouseLeave = param.onMouseLeave, datasetRender = param.datasetRender;
        var fallbackSrc = fallbackExtension && mediaInfo ? "https://static-media.fluxio.cloud/".concat(mediaInfo.profileName, "/").concat(mediaInfo.id).concat(mediaInfo.version ? "_".concat(mediaInfo.version) : "", ".").concat(fallbackExtension) : src;
        // RESPONSIVE_MEDIA const fallbackTabletSrc =
        //   tabletMedia?.fallbackExtension && tabletMedia?.mediaInfo
        //     ? `https://static-media.fluxio.cloud/${
        //         tabletMedia.mediaInfo.profileName
        //       }/${tabletMedia.mediaInfo.id}${
        //         tabletMedia.mediaInfo.version
        //           ? `_${tabletMedia.mediaInfo.version}`
        //           : ""
        //       }.${fallbackExtension}`
        //     : undefined
        // const fallbackMobileSrc =
        //   mobileMedia?.fallbackExtension && mobileMedia?.mediaInfo
        //     ? `https://static-media.fluxio.cloud/${
        //         mobileMedia.mediaInfo.profileName
        //       }/${mobileMedia.mediaInfo.id}${
        //         mobileMedia.mediaInfo.version
        //           ? `_${mobileMedia.mediaInfo.version}`
        //           : ""
        //       }.${fallbackExtension}`
        //     : undefined
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadComponent, {
            threshold: loadThreshold(mediaInfo === null || mediaInfo === void 0 ? void 0 : mediaInfo.size),
            visibleByDefault: visibleByDefault,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, datasetRender), {
                style: style,
                className: className,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onError: onError,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, datasetRender), {
                        srcSet: src,
                        type: mediaInfo === null || mediaInfo === void 0 ? void 0 : mediaInfo.contentType
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, datasetRender), {
                        style: style,
                        className: className,
                        src: fallbackSrc,
                        alt: alt
                    }))
                ]
            }))
        });
    };
    _proto.properMediaAlt = function properMediaAlt(mediaAlt, postObj) {
        if (mediaAlt && mediaAlt !== "") return mediaAlt;
        if (postObj) {
            if (postObj.picture_orig_alt && postObj.picture_orig_alt !== "") return postObj.picture_orig_alt;
            if (postObj.title && postObj.title !== "") return postObj.title;
        }
        return "";
    };
    _proto.responsiveMediaLink = function responsiveMediaLink(breakpoint) {
        var inlineContent = bobMediaRenderReadFix(this.props.inlineContent, this.props.field);
        var mediaSrc = components_getResponsiveOverrideInlineContentValues("".concat(this.props.field, ".").concat(breakpoint, "-src"), {
            inlineContent: inlineContent,
            overrides: this.props.overrides
        });
        if (mediaSrc) {
            return mediaLibraryUtils_handleSrcLink(this.props.pageResponse, mediaSrc);
        }
        return undefined;
    };
    _proto.renderImage = function renderImage(templateObj, postObj, imageFilterStyles, style, classPrefix, datasetRender) {
        var _this = this;
        var ref;
        var widthTabletStyle = widthStyle_cssRenderUnsafe(templateObj, "tablet", "default");
        var widthMobileStyle = widthStyle_cssRenderUnsafe(templateObj, "mobile", "default");
        var heightTabletStyle = heightStyle_cssRenderUnsafe(templateObj, "tablet", "default");
        var heightMobileStyle = heightStyle_cssRenderUnsafe(templateObj, "mobile", "default");
        // Properties for BobMediaImg
        var bobMediaImgProperties = [
            "radius",
            "filter",
            "size",
            "position"
        ];
        var bobMediaImgMobileStyle = (0,src_object_spread/* default */.Z)({}, responsiveProperties(templateObj, "mobile", {}, [
            ""
        ], bobMediaImgProperties), conditionalShadowRenderUnsafe(templateObj, "mobile", "default", "box", undefined), conditionalColorsRenderUnsafe(templateObj, "mobile", "default", true), heightMobileStyle, widthMobileStyle);
        var bobMediaImgTabletStyle = (0,src_object_spread/* default */.Z)({}, responsiveProperties(templateObj, "tablet", {}, [
            ""
        ], bobMediaImgProperties), conditionalShadowRenderUnsafe(templateObj, "tablet", "default", "box", undefined), conditionalColorsRenderUnsafe(templateObj, "tablet", "default", true), heightTabletStyle, widthTabletStyle);
        // Properties for BobImage container
        var bobImageProperties = [
            "radius"
        ];
        var bobImageMobileStyle = (0,src_object_spread/* default */.Z)({}, responsiveProperties(templateObj, "mobile", {}, [
            ""
        ], bobImageProperties), conditionalBoundaryRenderUnsafe(templateObj, "mobile", "default"), conditionalBorderRenderUnsafe(templateObj, "mobile", "default", true), heightMobileStyle, widthMobileStyle);
        var bobImageTabletStyle = (0,src_object_spread/* default */.Z)({}, responsiveProperties(templateObj, "tablet", {}, [
            ""
        ], bobImageProperties), conditionalBoundaryRenderUnsafe(templateObj, "tablet", "default"), conditionalBorderRenderUnsafe(templateObj, "tablet", "default", true), heightTabletStyle, widthTabletStyle);
        // Properties for BobImage filter
        var bobImageFilterOverlayProperties = [
            "filter"
        ];
        var bobImageFilterOverlayMobileStyle = responsiveProperties(templateObj, "mobile", {
            filter: {
                type: "overlay"
            }
        }, [
            ""
        ], bobImageFilterOverlayProperties);
        var bobImageFilterOverlayTabletStyle = responsiveProperties(templateObj, "tablet", {
            filter: {
                type: "overlay"
            }
        }, [
            ""
        ], bobImageFilterOverlayProperties);
        var containerWidth = style.width;
        var containerHeight = style.height;
        style = this.handleImgSizeInPercentage(style);
        bobMediaImgMobileStyle = this.handleImgSizeInPercentage(bobMediaImgMobileStyle);
        bobMediaImgTabletStyle = this.handleImgSizeInPercentage(bobMediaImgTabletStyle);
        // must have the hover img seperatly so that the browser caches the images and doenst download them multiple times
        var ref1 = this.handleImageValue(postObj), mediaSrc = ref1.mediaSrc, mediaAlt = ref1.mediaAlt, fallbackExtension = ref1.fallbackExtension, mediaInfo = ref1.mediaInfo;
        mediaAlt = this.properMediaAlt(mediaAlt, postObj);
        var mediaHoverObj = ((ref = templateObj.behaviour.hover) === null || ref === void 0 ? void 0 : ref.enable) ? this.handleImageHoverValue(postObj) : {
            mediaSrc: "",
            mediaAlt: ""
        };
        var mediaSrcHover = mediaHoverObj.mediaSrc, mediaAltHover = this.properMediaAlt(mediaHoverObj.mediaAlt, postObj);
        // fallback to placeholder when necesssary
        mediaSrc = mediaSrc ? mediaSrc : mkRawUrl("https://cdn.fluxio.cloud/fluxio/fluxio_placeholder.png");
        mediaSrcHover = mediaSrcHover === "" ? "https://cdn.fluxio.cloud/fluxio/fluxio_placeholder.png" : mediaSrcHover;
        var tabletMedia = this.responsiveMediaLink("tablet");
        var mobileMedia = this.responsiveMediaLink("mobile");
        var bobImageStyle = {
            width: containerWidth,
            height: containerHeight,
            "margin-top": style["margin-top"],
            "margin-bottom": style["margin-bottom"],
            "margin-right": style["margin-right"],
            "margin-left": style["margin-left"],
            "padding-top": style["padding-top"],
            "padding-bottom": style["padding-bottom"],
            "padding-right": style["padding-right"],
            "padding-left": style["padding-left"],
            "border-bottom-style": style["border-bottom-style"],
            "border-bottom-width": style["border-bottom-width"],
            "border-bottom-color": style["border-bottom-color"],
            "border-top-style": style["border-top-style"],
            "border-top-width": style["border-top-width"],
            "border-top-color": style["border-top-color"],
            "border-left-style": style["border-left-style"],
            "border-left-width": style["border-left-width"],
            "border-left-color": style["border-left-color"],
            "border-right-style": style["border-right-style"],
            "border-right-width": style["border-right-width"],
            "border-right-color": style["border-right-color"],
            "border-bottom-left-radius": style.borderBottomLeftRadius,
            "border-bottom-right-radius": style.borderBottomRightRadius,
            "border-top-left-radius": style.borderTopLeftRadius,
            "border-top-right-radius": style.borderTopRightRadius
        };
        var imgStyle = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, style), {
            maxHeight: style.height !== "auto !important" && style.height,
            maxWidth: style.width !== "auto !important" && style.width,
            height: style.height === "auto !important" && style.height,
            width: style.width === "auto !important" && style.width,
            margin: "0 !important",
            padding: "0 !important",
            "border-top": "0 !important",
            "border-bottom": "0 !important",
            "border-left": "0 !important",
            "border-right": "0 !important"
        });
        //Apply same workaround, seen above, to the responsive styles
        bobMediaImgMobileStyle = this.handleWidthAndHeightReplace(bobMediaImgMobileStyle);
        bobMediaImgTabletStyle = this.handleWidthAndHeightReplace(bobMediaImgTabletStyle);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BobMediaDiv, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, datasetRender), {
            desktop: bobImageStyle,
            mobile: bobImageMobileStyle,
            tablet: bobImageTabletStyle,
            id: handleDOMid(this.props.field, this.props.id, this.props.instanceId),
            className: "bob-image ".concat(classPrefix, "-bob-image spacing-preview-").concat(this.props.template.uuid, " image-filter ").concat(globalStylesUtils.handleClassName(this.props.pageResponse.nGlobalStyles, this.props.template, [
                GS_BOUNDARY, 
            ])),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BobMediaImg, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, datasetRender), {
                    datasetRender: datasetRender,
                    as: this.LazyMedia,
                    desktop: imgStyle,
                    mobile: bobMediaImgMobileStyle,
                    tablet: bobMediaImgTabletStyle,
                    visibleByDefault: this.props.expManager.enable,
                    className: "card-img-top image-filter-placeholder ".concat(globalStylesUtils.handleClassName(this.props.pageResponse.nGlobalStyles, this.props.template, [
                        GS_FILTER,
                        GS_SHADOW
                    ], "-box")),
                    src: mediaSrc,
                    tabletMedia: tabletMedia,
                    mobileMedia: mobileMedia,
                    fallbackExtension: fallbackExtension,
                    mediaInfo: mediaInfo,
                    alt: mediaAlt,
                    style: {
                        display: !this.state.isHover ? "block" : "none"
                    },
                    onError: function(node) {
                        return templateObj.behaviour && !templateObj.behaviour.hover.enable ? node.target.style.display = "none" : undefined;
                    },
                    onMouseEnter: function() {
                        return _this.imageOnHover(templateObj);
                    },
                    onMouseLeave: function() {
                        return _this.imageUnHover(templateObj);
                    }
                })),
                this.isHoverEnabled(templateObj) && /*#__PURE__*/ (0,jsx_runtime.jsx)(BobMediaImg, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, datasetRender), {
                    as: this.LazyMedia,
                    desktop: imgStyle,
                    mobile: bobMediaImgMobileStyle,
                    tablet: bobMediaImgTabletStyle,
                    className: "card-img-top image-filter-placeholder hovered ".concat(globalStylesUtils.handleClassName(this.props.pageResponse.nGlobalStyles, this.props.template, [
                        GS_FILTER,
                        GS_SHADOW
                    ], "-box")),
                    src: mediaSrcHover,
                    fallbackExtension: fallbackExtension,
                    mediaInfo: mediaInfo,
                    alt: mediaAltHover,
                    style: {
                        display: this.state.isHover ? "block" : "none"
                    },
                    onError: function(node) {
                        return templateObj.behaviour && !templateObj.behaviour.hover.enable ? node.target.style.display = "none" : undefined;
                    },
                    onMouseEnter: function() {
                        return _this.imageOnHover(templateObj);
                    },
                    onMouseLeave: function() {
                        return _this.imageUnHover(templateObj);
                    }
                })),
                this.isFilterEnabled(templateObj) && /*#__PURE__*/ (0,jsx_runtime.jsx)(BobMediaFilterOverlay, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, datasetRender), {
                    desktop: imageFilterStyles.overlay,
                    mobile: bobImageFilterOverlayMobileStyle,
                    tablet: bobImageFilterOverlayTabletStyle,
                    className: "image-filter-overlay ".concat(globalStylesUtils.handleClassName(this.props.pageResponse.nGlobalStyles, this.props.template, [
                        GS_FILTER
                    ]))
                }))
            ]
        }));
    };
    _proto.renderMedia = function renderMedia(templateObj, postObj, imageFilterStyles, style, classPrefix, inlineContent, media, datasetRender) {
        var isEmbedEnable = components_getOverrideInlineContentValues("".concat(this.props.field, ".embedEnable"), this.props);
        /**
     * This will check if the content is managed by us,
     * or its an embed with custom code, added by the user.
     */ if (!isEmbedEnable) {
            /**
       * Since we know for sure, that the cms option is only used for images,
       * when the media is undefined, the user is using the cms option.
       * TODO: check for cms when declaring media, and remove that logic from
       * the renderImage, so the logic is computed above this and renderImage and renderVideo
       * just receive what they are waiting for.
       */ if (media === undefined) return this.renderImage(templateObj, postObj, imageFilterStyles, style, classPrefix, datasetRender);
            //When its a string
            if (typeof media === "string") {
                var linkType = components_getOverrideInlineContentValues("".concat(this.props.field, ".linkType"), this.props);
                //The check is done at write time, if it doesnt exist, or it isnt video, we render image
                if (linkType && linkType === "video") return this.renderVideo(templateObj, media, style, inlineContent, classPrefix, datasetRender);
                //Its an image here
                return this.renderImage(templateObj, postObj, imageFilterStyles, style, classPrefix, datasetRender);
            }
            //When its an object
            if (media.itemType === "image") return this.renderImage(templateObj, postObj, imageFilterStyles, style, classPrefix, datasetRender);
            return this.renderVideo(templateObj, media, style, inlineContent, classPrefix, datasetRender);
        }
        return this.renderEmbed(inlineContent, templateObj, style, datasetRender);
    };
    _proto.clickEvent = function clickEvent(e, TAG) {
        if (TAG === "a") {
            var ref;
            var linkLabel = analyticsLinkLabel(this.props.field, {
                inlineContent: this.props.inlineContent,
                overrides: this.props.overrides
            }, this.props.pageResponse, this.props.post);
            //get parent id to properly know who has the link configured
            var parentId = (ref = e.target.parentElement) === null || ref === void 0 ? void 0 : ref.id;
            if (parentId) {
                GoogleEvent("link_click", linkLabel, "Link Clicked", 1);
            }
        }
    };
    _proto.render = function render() {
        var _this = this;
        var inlineContent = bobMediaRenderReadFix(this.props.inlineContent, this.props.field);
        /**
     * The media can be an object or a string.
     * When its a string, it means the user is using a direct link
     */ var media = handleMediaFields(this.props.pageResponse, components_getOverrideInlineContentValues("".concat(this.props.field, ".src"), {
            inlineContent: inlineContent,
            overrides: this.props.overrides
        }));
        //Handle GlobalStyles
        var templateObj = this.props.template;
        var _post;
        var postObj = (_post = this.props.post) !== null && _post !== void 0 ? _post : contentPageHelper_DummyPost;
        var classPrefix = "prefix".concat(templateObj.uuid);
        /**
     * Responsive Styles (mobile/tablet)
     */ // Properties for BobImage container
        var alignmentAdittionalProperties = {
            flexDirection: "row",
            self: true
        };
        var ref = alignmentWithAP(templateObj, alignmentAdittionalProperties), alignmentStyles = ref.alignmentStyles, bobImageOuterContainerTabletStyle = ref.tabletAlignment, bobImageOuterContainerMobileStyle = ref.mobileAlignment;
        /**
     * Desktop Styles
     */ var borders = conditionalBorderRenderUnsafe(templateObj, "desktop", "default", true);
        var backgroundColorStyles = conditionalColorsRenderUnsafe(templateObj, "desktop", "default", true);
        var heightStyles = heightStyle_cssRenderUnsafe(templateObj, "desktop", "default");
        var boundaries = conditionalBoundaryRenderUnsafe(templateObj, "desktop", "default");
        var widthStyles = widthStyle_cssRenderUnsafe(templateObj, "desktop", "default");
        var shadows = conditionalShadowRenderUnsafe(templateObj, "desktop", "default", "box", undefined);
        var imageFilterStyles = handleImageFilter(templateObj);
        var radiusStyles = handleRadius(templateObj);
        /**
     * Behaviour Styles
     */ var hoverStyles = "";
        var activeStyles = "";
        if (this.props.rule && this.props.rule.behaviour && this.props.rule.behaviour.hover) {
            var ref1, ref2, ref3, ref4;
            hoverStyles = this.handleHoverStateStyles(templateObj, templateObj.behaviour.hover, (ref1 = templateObj.mobile) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : ref2.hover, (ref3 = templateObj.tablet) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : ref4.hover, ".".concat(classPrefix));
        }
        if (this.props.rule && this.props.rule.behaviour && this.props.rule.behaviour.active) {
            var ref5, ref6, ref7, ref8;
            activeStyles = this.handleActiveStateStyles(templateObj, templateObj.behaviour.active, (ref5 = templateObj.mobile) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.behaviour) === null || ref6 === void 0 ? void 0 : ref6.active, (ref7 = templateObj.tablet) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.behaviour) === null || ref8 === void 0 ? void 0 : ref8.active, "".concat(classPrefix, "-bob-image"));
        }
        //Styles Tree
        var style = (0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, heightStyles, widthStyles, backgroundColorStyles, shadows, borders, radiusStyles, imageFilterStyles.filter), {
            objectFit: templateObj.size,
            objectPosition: templateObj.position
        }), boundaries);
        /**
     * The DOM tag changes with the selected behaviour properties.
     * Default is a <div> element, but with anchor properties turns into a<a> element
     */ var TAG = components_getOverrideInlineContentValues("".concat(this.props.field, ".behaviour-link-enable"), this.props) ? "a" : "div";
        //Link properties
        var linkAttrs = getLinkAttributes(this.props.field, {
            inlineContent: this.props.inlineContent,
            overrides: this.props.overrides
        }, this.props.pageResponse, this.props.post);
        var hasStateStyles = hoverStyles.trim() !== "" || activeStyles.trim() !== "";
        var customAttributesEnable = components_getOverrideInlineContentValues("".concat(this.props.field, ".").concat(CUSTOM_ATTRIBUTES_ENABLE), {
            inlineContent: this.props.inlineContent,
            overrides: this.props.overrides
        });
        var customAttributesMappedField = components_getOverrideInlineContentValues("".concat(this.props.field, ".").concat(CUSTOM_ATTRIBUTES_MAPPED_FIELD), {
            inlineContent: this.props.inlineContent,
            overrides: this.props.overrides
        });
        var customAttributesValue = components_getOverrideInlineContentValues("".concat(this.props.field, ".").concat(CUSTOM_ATTRIBUTES_VALUE), {
            inlineContent: this.props.inlineContent,
            overrides: this.props.overrides
        });
        var customAttributesContentSrc = components_getOverrideInlineContentValues("".concat(this.props.field, ".").concat(CUSTOM_ATTRIBUTES_CONTENTSRC), {
            inlineContent: this.props.inlineContent,
            overrides: this.props.overrides
        });
        var datasetValue = datasetRender(this.props.post, customAttributesEnable, customAttributesMappedField, customAttributesValue, customAttributesContentSrc);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                hasStateStyles && /*#__PURE__*/ (0,jsx_runtime.jsx)((style_it_default()), {
                    children: "          \n              ".concat(hoverStyles, "\n              ").concat(activeStyles, "          \n            ")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BobMediaOuterContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, datasetValue), {
                    as: TAG,
                    desktop: alignmentStyles,
                    mobile: bobImageOuterContainerMobileStyle,
                    tablet: bobImageOuterContainerTabletStyle,
                    className: "bob-media ".concat(classPrefix, "-bob-media ").concat(this.props.className ? this.props.className : ""),
                    onClick: function(e) {
                        _this.props.onClick && _this.props.onClick(e);
                        _this.clickEvent(e, TAG);
                    }
                }), linkAttrs), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobLoading, {
                        type: "media",
                        uuid: getComposedUuid(this.props.pageResponse.objects[this.props.id]),
                        contentSrc: components_getOverrideInlineContentValues("".concat(this.props.field, ".contentSrc"), this.props),
                        mediaWidth: this.handleSize(templateObj.width),
                        mediaHeight: this.handleSize(templateObj.height),
                        mappedValue: components_getOverrideInlineContentValues("".concat(this.props.field, ".image-mappedValue"), this.props),
                        children: this.renderMedia(templateObj, postObj, imageFilterStyles, style, classPrefix, inlineContent, media, datasetValue)
                    })
                }))
            ]
        });
    };
    return BobMedia;
}(react.Component);
/* harmony default export */ var bobMedia = (BobMedia);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobIcon/bobIcon.tsx





function bobIcon_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  @media only screen and (max-width: 992px) and (min-width: 767px) {\n    ",
        "\n  }\n  @media all and (max-width: 766px) {\n    ",
        "\n  }\n"
    ]);
    bobIcon_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


// @ts-ignore










var BobIconDOM = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cc733ad5-0"
})(bobIcon_templateObject(), function(props) {
    return props.desktop;
}, function(props) {
    return props.tablet;
}, function(props) {
    return props.mobile;
});
var BobIcon = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(BobIcon, _Component);
    var _super = (0,_create_super/* default */.Z)(BobIcon);
    function BobIcon() {
        (0,src_class_call_check/* default */.Z)(this, BobIcon);
        var _this;
        _this = _super.apply(this, arguments);
        //Handle breakpoints
        _this.handleIgnoredTemplateProp = function(prop, breakpoint, behaviour) {
            var ref;
            if ((ref = _this.props.templatePropsToIgnore) === null || ref === void 0 ? void 0 : ref.includes(prop)) return [];
            if (prop === "size") {
                return breakpoint === "desktop" ? {
                    fontSize: "".concat(_this.props.template.size, "px")
                } : responsiveGroupStylesProperties(_this.props.template, breakpoint, "icon");
            }
            if (prop === "spacing") {
                return conditionalBoundaryRenderUnsafe(_this.props.template, breakpoint, behaviour);
            }
        };
        //handle behaviours
        _this.handleIgnoredTemplatePropBehaviour = function(prop, template, breakpoint) {
            var ref;
            if ((ref = _this.props.templatePropsToIgnore) === null || ref === void 0 ? void 0 : ref.includes(prop)) return "";
            if (prop === "spacing") {
                return "\n      ".concat(renderCSSString(template), " ");
            }
        };
        return _this;
    }
    var _proto = BobIcon.prototype;
    _proto.handleStateStyles = function handleStateStyles(templateObj, stateTemplateObj, templateObjMobile, templateObjTablet, className, behaviourState, additionalAlignmentProperties) {
        if (stateTemplateObj) {
            var templateMobile = (0,src_object_spread/* default */.Z)({}, AlignmentCssRenderUnsafe(templateObj, "mobile", behaviourState, additionalAlignmentProperties), conditionalBoundaryRenderUnsafe(templateObj, "mobile", behaviourState), colorStyle_cssRenderUnsafe(templateObj, "mobile", behaviourState, undefined, undefined, true));
            var mobileShadow = conditionalShadowRenderUnsafe(templateObj, "mobile", behaviourState, "text", undefined);
            var templateTablet = (0,src_object_spread/* default */.Z)({}, AlignmentCssRenderUnsafe(templateObj, "tablet", behaviourState, additionalAlignmentProperties), conditionalBoundaryRenderUnsafe(templateObj, "tablet", behaviourState), colorStyle_cssRenderUnsafe(templateObj, "tablet", behaviourState, undefined, undefined, true));
            var tabletShadow = conditionalShadowRenderUnsafe(templateObj, "tablet", behaviourState, "text", undefined);
            var mediaQueryRestrictions = this.handleMediaQueryRestrictions(templateObjMobile, templateObjTablet);
            var shadows = conditionalShadowRenderUnsafe(templateObj, "desktop", behaviourState, "text", undefined);
            var boundaries = conditionalBoundaryRenderUnsafe(templateObj, "desktop", behaviourState);
            var color = colorStyle_cssRenderUnsafe(templateObj, "desktop", behaviourState, undefined, undefined, true);
            //TODO: Missing breakpoint/behaviour color for icons
            return "\n      ".concat(stateTemplateObj.enable ? "@media all ".concat(mediaQueryRestrictions, "{\n            ").concat(className, "{\n              ").concat(this.handleIgnoredTemplatePropBehaviour("spacing", boundaries, "desktop"), "\n              ").concat(textShadowCss(shadows), ";\n              ").concat(colorStyle_renderCSSString(color), "\n            }\n          }") : "", "\n      ").concat((stateTemplateObj.enable || (templateObjTablet === null || templateObjTablet === void 0 ? void 0 : templateObjTablet.enable)) && (templateObjTablet === null || templateObjTablet === void 0 ? void 0 : templateObjTablet.enable) !== false ? "@media all and (max-width: 992px) and (min-width: 767px){\n            ".concat(className, "{\n              ").concat(this.handleIgnoredTemplatePropBehaviour("spacing", templateTablet, "tablet"), "\n              ").concat(textShadowCss(tabletShadow), ";\n              ").concat(colorStyle_renderCSSString(templateTablet), "\n            }\n          }") : "", "\n      ").concat((stateTemplateObj.enable || (templateObjMobile === null || templateObjMobile === void 0 ? void 0 : templateObjMobile.enable)) && (templateObjMobile === null || templateObjMobile === void 0 ? void 0 : templateObjMobile.enable) !== false ? "@media all and (max-width: 766px){\n            ".concat(className, "{\n              ").concat(this.handleIgnoredTemplatePropBehaviour("spacing", templateMobile, "mobile"), "\n              ").concat(textShadowCss(mobileShadow), ";\n              ").concat(colorStyle_renderCSSString(templateMobile), "\n            }\n          }") : "", "\n      ");
        }
        return "";
    };
    /**
   * returns media queries to apply styles based on enable prop value on the diferent breakpoints
   */ _proto.handleMediaQueryRestrictions = function handleMediaQueryRestrictions(mobileStyles, tabletStyles) {
        if ((tabletStyles === null || tabletStyles === void 0 ? void 0 : tabletStyles.enable) === false && (mobileStyles === null || mobileStyles === void 0 ? void 0 : mobileStyles.enable)) return "and (max-width: 766px), (min-width: 993px)";
        if ((tabletStyles === null || tabletStyles === void 0 ? void 0 : tabletStyles.enable) === false) return "and (min-width: 993px)";
        if ((mobileStyles === null || mobileStyles === void 0 ? void 0 : mobileStyles.enable) === false) return "and (min-width: 767px)";
        return "";
    };
    _proto.render = function render() {
        var templateObj = this.props.template;
        var additionalAlignmentProperties = {
            flexDirection: "row",
            self: false
        };
        var ref = alignmentWithAP(templateObj, additionalAlignmentProperties), alignment = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
        var iconClass = templateObj.icon && templateObj.iconType && templateObj.icon !== "" && templateObj.iconType !== "" ? "".concat(templateObj.icon, " ").concat(templateObj.iconType) : this.props.iconClassName ? this.props.iconClassName : "";
        var classPrefix = "prefix".concat(templateObj.uuid);
        var hoverStyles = "";
        var activeStyles = "";
        if (this.props.rule && this.props.rule.behaviour && this.props.rule.behaviour.hover) {
            var ref1, ref2, ref3, ref4;
            var hoverTemplate = handleEnableValues(templateObj);
            hoverStyles = this.handleStateStyles(templateObj, hoverTemplate.behaviour.hover, (ref1 = hoverTemplate.mobile) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : ref2.hover, (ref3 = hoverTemplate.tablet) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : ref4.hover, ".".concat(classPrefix, "-bob-icon:hover i, .").concat(classPrefix, "-bob-icon.isHover i"), "hover", additionalAlignmentProperties);
        }
        if (this.props.rule && this.props.rule.behaviour && this.props.rule.behaviour.active) {
            var ref5, ref6, ref7, ref8;
            var activeTemplate = handleEnableValues(templateObj);
            activeStyles = this.handleStateStyles(templateObj, activeTemplate.behaviour.active, (ref5 = activeTemplate.mobile) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.behaviour) === null || ref6 === void 0 ? void 0 : ref6.active, (ref7 = activeTemplate.tablet) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.behaviour) === null || ref8 === void 0 ? void 0 : ref8.active, ".active.".concat(classPrefix, "-bob-icon i"), "active", additionalAlignmentProperties);
        }
        var style = (0,src_object_spread/* default */.Z)({}, this.handleIgnoredTemplateProp("size", "desktop", "default"), colorStyle_cssRenderUnsafe(templateObj, "desktop", "default", undefined, undefined, true), conditionalShadowRenderUnsafe(templateObj, "desktop", "default", "text", undefined), this.handleIgnoredTemplateProp("spacing", "desktop", "default"), alignment);
        var tabletStyles = (0,src_object_spread/* default */.Z)({}, this.handleIgnoredTemplateProp("spacing", "tablet", "default"), tabletAlignment, conditionalShadowRenderUnsafe(templateObj, "tablet", "default", "text", undefined), this.handleIgnoredTemplateProp("size", "tablet", "default"), colorStyle_cssRenderUnsafe(templateObj, "tablet", "default", undefined, undefined, true));
        var mobileStyles = (0,src_object_spread/* default */.Z)({}, this.handleIgnoredTemplateProp("spacing", "mobile", "default"), mobileAlignment, conditionalShadowRenderUnsafe(templateObj, "mobile", "default", "text", undefined), this.handleIgnoredTemplateProp("size", "mobile", "default"), colorStyle_cssRenderUnsafe(templateObj, "mobile", "default", undefined, undefined, true));
        var hasStateStyles = hoverStyles.trim() !== "" || activeStyles.trim() !== "";
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                hasStateStyles && /*#__PURE__*/ (0,jsx_runtime.jsx)((style_it_default()), {
                    children: "          \n              ".concat(hoverStyles, "\n              ").concat(activeStyles, "\n            ")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: handleDOMid(this.props.field, this.props.id, this.props.instanceId),
                    className: "bob-icon ".concat(classPrefix, "-bob-icon ").concat(this.props.className ? this.props.className : ""),
                    onClick: this.props.onClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BobIconDOM, {
                        as: "i",
                        className: "".concat(iconClass, " spacing-preview-").concat(this.props.template.uuid, " ").concat(globalStylesUtils.handleClassName(this.props.pageResponse.nGlobalStyles, this.props.template, undefined, "-text")),
                        desktop: style,
                        tablet: tabletStyles,
                        mobile: mobileStyles
                    })
                })
            ]
        });
    };
    return BobIcon;
}(react.Component);
/* harmony default export */ var bobIcon = (BobIcon);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobComponentHandler.tsx










var BobComponentHandler = function(props) {
    var handleBobType = function(rule, template, field) {
        var objectId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (0,v4/* default */.Z)();
        switch(rule.type){
            case "text":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobText, {
                        id: objectId,
                        globalStyles: props.pageResponse.globalStyles,
                        pageResponse: props.pageResponse,
                        instanceId: props.instanceId,
                        className: props.className,
                        inlineContent: rewriteObjectOnRead(template, props.inlineContent, field),
                        overrides: props.overrides,
                        value: props.value,
                        template: template,
                        rule: rule,
                        field: field,
                        network: props.network,
                        post: props.post,
                        expManager: props.expManager
                    })
                }, field);
            case "bobBackground":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobBackgroundImage, {
                        id: objectId,
                        expManager: props.expManager,
                        globalStyles: props.pageResponse.globalStyles,
                        pageResponse: props.pageResponse,
                        objPosition: props.position,
                        instanceId: props.instanceId,
                        post: props.post,
                        className: props.className,
                        inlineContent: rewriteObjectOnRead(template, props.inlineContent, field),
                        overrides: props.overrides,
                        template: template,
                        rule: rule,
                        field: field,
                        onClick: props.onClick,
                        onMouseEnter: props.onMouseEnter,
                        onMouseLeave: props.onMouseLeave,
                        flexDirection: props.flexDirection,
                        children: props.children
                    })
                }, field);
            case "bobMedia":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobMedia, {
                        id: objectId,
                        globalStyles: props.pageResponse.globalStyles,
                        pageResponse: props.pageResponse,
                        replacedMediaList: props.replacedMediaList,
                        instanceId: props.instanceId,
                        className: props.className,
                        inlineContent: rewriteObjectOnRead(template, props.inlineContent, field),
                        overrides: props.overrides,
                        template: template,
                        rule: rule,
                        object: props.object,
                        field: field,
                        post: props.post,
                        onClick: props.onClick,
                        expManager: props.expManager
                    })
                }, field);
            case "bobIcon":
                //TODO missing inlineCOntent handler and overrides???
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobIcon, {
                        id: objectId,
                        globalStyles: props.pageResponse.globalStyles,
                        pageResponse: props.pageResponse,
                        instanceId: props.instanceId,
                        className: props.className,
                        template: template,
                        rule: rule,
                        field: field,
                        onClick: props.onClick,
                        iconClassName: props.iconClassName,
                        templatePropsToIgnore: props.templatePropsToIgnore
                    })
                }, field);
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "alert alert-warning",
                    role: "alert",
                    children: [
                        "No bob to render! ",
                        rule.type
                    ]
                });
        }
    };
    var bobRules = props.rules.bob;
    var templateValues = props.template.bobs;
    //Workaround when bobRules is empty
    if (!bobRules) {
        if (props.expManager.enable) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "alert alert-warning",
                role: "alert",
                children: "No Bob Rules for ".concat(props.styles.component.name)
            });
        }
        return [];
    }
    /**
   * If the field if present we render only this particular field.
   * When this value is undefined we render all the fields inside it
   */ if (props.field) {
        var fieldRule = bobRules[props.field];
        var fieldTemplateValue = templateValues[props.field];
        if (!fieldTemplateValue || !fieldTemplateValue.enable || !fieldRule) {
            // console.warn(`No rules found for bob: ${props.field}`) // TODO: review rules for each prop in a bob
            return props.children ? props.children : [];
        }
        return handleBobType(fieldRule, fieldTemplateValue, props.field, props.objectId);
    }
    var arrFields = [];
    for(var fieldRule1 in bobRules){
        if (bobRules[fieldRule1].enable) arrFields = (0,src_to_consumable_array/* default */.Z)(arrFields).concat([
            handleBobType(bobRules[fieldRule1], templateValues[fieldRule1], fieldRule1, props.objectId), 
        ]);
    }
    return arrFields;
};
/* harmony default export */ var bobComponentHandler = (/*#__PURE__*/react.memo(BobComponentHandler));

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/alignmentHOC/alignmentHOC.tsx

function alignmentHOC_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  @media only screen and (max-width: 992px) and (min-width: 767px){\n    ",
        "\n  }\n  @media all and (max-width: 766px){\n    ",
        "\n  }\n"
    ]);
    alignmentHOC_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var AlignmentHOC = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-28336584-0"
})(alignmentHOC_templateObject(), function(props) {
    return props.desktop;
}, function(props) {
    return props.tablet;
}, function(props) {
    return props.mobile;
});
/* harmony default export */ var alignmentHOC = (AlignmentHOC);

// EXTERNAL MODULE: ./src/stylesheets/modules/components/card.module.sass
var card_module = __webpack_require__(18740);
var card_module_default = /*#__PURE__*/__webpack_require__.n(card_module);
// EXTERNAL MODULE: ./src/stylesheets/modules/templates/cards.module.sass
var cards_module = __webpack_require__(62825);
var cards_module_default = /*#__PURE__*/__webpack_require__.n(cards_module);
// EXTERNAL MODULE: ./src/stylesheets/modules/templates/socialCardShare.module.sass
var socialCardShare_module = __webpack_require__(45352);
var socialCardShare_module_default = /*#__PURE__*/__webpack_require__.n(socialCardShare_module);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Socials/SocialCardShare/SocialCardShare.tsx











var SocialCardShare = function(props) {
    var renderShareCard = function(post) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "card ".concat((card_module_default()).card, " ").concat((socialCardShare_module_default()).card),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                    position: props.position,
                    pageResponse: props.pageResponse,
                    replacedMediaList: props.replacedMediaList,
                    instanceId: props.obj.selectedInstanceId,
                    object: props.obj,
                    objectId: props.obj.uuid,
                    inlineContent: props.obj.content.inlineContent,
                    overrides: props.overrides,
                    field: "media2",
                    template: props.obj.styles,
                    rules: props.componentRule,
                    expManager: props.expManager,
                    network: post.network,
                    post: post
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "card-body",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: props.position,
                            pageResponse: props.pageResponse,
                            instanceId: props.obj.selectedInstanceId,
                            object: props.obj,
                            objectId: props.obj.uuid,
                            post: post,
                            inlineContent: props.obj.content.inlineContent,
                            overrides: props.overrides,
                            field: "text5",
                            tag: "p",
                            value: getStringField(post, props.obj, props.pageResponse, "text5", props.overrides),
                            template: props.obj.styles,
                            rules: props.componentRule,
                            expManager: props.expManager,
                            network: post.network,
                            className: "card-title"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: props.position,
                            pageResponse: props.pageResponse,
                            instanceId: props.obj.selectedInstanceId,
                            object: props.obj,
                            objectId: props.obj.uuid,
                            post: post,
                            inlineContent: props.obj.content.inlineContent,
                            overrides: props.overrides,
                            field: "text6",
                            tag: "p",
                            value: getStringField(post, props.obj, props.pageResponse, "text6", props.overrides),
                            template: props.obj.styles,
                            rules: props.componentRule,
                            expManager: props.expManager,
                            network: post.network,
                            className: "card-desc"
                        })
                    ]
                })
            ]
        });
    };
    var renderCards = function(background1Template) {
        var content = getContent(props.obj, "posts");
        if (content && content.length > 0) {
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            return content.map(function(post, idx) {
                var columns = bobHandler_handleColumns(idx, counter, background1Template, props.pageResponse.globalStyles[background1Template.globalStyleId]);
                counter = columns.counter;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(bobComponentHandler, {
                        position: props.position,
                        pageResponse: props.pageResponse,
                        instanceId: props.obj.selectedInstanceId,
                        object: props.obj,
                        objectId: props.obj.uuid,
                        post: post,
                        inlineContent: props.obj.content.inlineContent,
                        overrides: props.overrides,
                        field: "background2",
                        rules: props.componentRule,
                        template: props.obj.styles,
                        expManager: props.expManager,
                        className: "card ".concat((card_module_default()).card, " ").concat((socialCardShare_module_default()).card),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "card-header ".concat((socialCardShare_module_default())["card-header"]),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "d-flex w-100 justify-content-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                                    position: props.position,
                                                    pageResponse: props.pageResponse,
                                                    replacedMediaList: props.replacedMediaList,
                                                    instanceId: props.obj.selectedInstanceId,
                                                    object: props.obj,
                                                    objectId: props.obj.uuid,
                                                    inlineContent: props.obj.content.inlineContent,
                                                    overrides: props.overrides,
                                                    field: "media1",
                                                    template: props.obj.styles,
                                                    rules: props.componentRule,
                                                    expManager: props.expManager,
                                                    network: post.network,
                                                    post: post
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex-column d-flex justify-content-between ml-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                                        position: props.position,
                                                        pageResponse: props.pageResponse,
                                                        instanceId: props.obj.selectedInstanceId,
                                                        object: props.obj,
                                                        objectId: props.obj.uuid,
                                                        post: post,
                                                        inlineContent: props.obj.content.inlineContent,
                                                        overrides: props.overrides,
                                                        field: "text1",
                                                        tag: "p",
                                                        value: getStringField(post, props.obj, props.pageResponse, "text1", props.overrides),
                                                        template: props.obj.styles,
                                                        rules: props.componentRule,
                                                        expManager: props.expManager,
                                                        network: post.network,
                                                        className: "network"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                                        position: props.position,
                                                        pageResponse: props.pageResponse,
                                                        instanceId: props.obj.selectedInstanceId,
                                                        object: props.obj,
                                                        objectId: props.obj.uuid,
                                                        post: post,
                                                        inlineContent: props.obj.content.inlineContent,
                                                        overrides: props.overrides,
                                                        field: "text2",
                                                        tag: "p",
                                                        value: getStringField(post, props.obj, props.pageResponse, "text2", props.overrides),
                                                        template: props.obj.styles,
                                                        rules: props.componentRule,
                                                        expManager: props.expManager,
                                                        network: post.network,
                                                        className: "entity"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-flex align-items-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                            position: props.position,
                                            pageResponse: props.pageResponse,
                                            instanceId: props.obj.selectedInstanceId,
                                            object: props.obj,
                                            objectId: props.obj.uuid,
                                            post: post,
                                            inlineContent: props.obj.content.inlineContent,
                                            overrides: props.overrides,
                                            field: "text3",
                                            tag: "span",
                                            value: getStringField(post, props.obj, props.pageResponse, "text3", props.overrides),
                                            template: props.obj.styles,
                                            rules: props.componentRule,
                                            expManager: props.expManager,
                                            network: post.network,
                                            className: "date"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "card-body",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: props.position,
                                        pageResponse: props.pageResponse,
                                        instanceId: props.obj.selectedInstanceId,
                                        object: props.obj,
                                        objectId: props.obj.uuid,
                                        post: post,
                                        inlineContent: props.obj.content.inlineContent,
                                        overrides: props.overrides,
                                        field: "text4",
                                        tag: "p",
                                        value: getStringField(post, props.obj, props.pageResponse, "text4", props.overrides),
                                        template: props.obj.styles,
                                        rules: props.componentRule,
                                        expManager: props.expManager,
                                        network: post.network,
                                        className: "message"
                                    }),
                                    renderShareCard(post)
                                ]
                            })
                        ]
                    })
                }, idx);
            });
        } else {
            if (props.expManager.enable) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-sm-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warningSystem, {
                        alertType: "alert-secondary w-100 text-center",
                        messages: "Select a formula to show posts"
                    })
                });
            }
        }
    };
    var background1 = props.obj.styles.bobs.background1;
    var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "cards ".concat((cards_module_default()).cards, " social social-card-share ").concat((socialCardShare_module_default())["social-card-share"]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
            className: "card-deck ".concat((card_module_default())["card-deck"], " row ").concat(bobHandler_responsiveGuttersClass(background1, props.pageResponse.globalStyles[background1.globalStyleId])),
            desktop: alignmentStyles,
            tablet: tabletAlignment,
            mobile: mobileAlignment,
            children: renderCards(background1)
        })
    });
};
/* harmony default export */ var SocialCardShare_SocialCardShare = (SocialCardShare);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/modules/routeCreator/index.ts
function routeArrayByNumber() {
    var matchOrder = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, route = arguments.length > 1 ? arguments[1] : void 0, uri = arguments.length > 2 ? arguments[2] : void 0;
    if (!route) return "";
    if (typeof route === "string") return route;
    var stringPath = "";
    for(var i = 0; i < matchOrder; i++){
        stringPath += "".concat(route[i], "/");
    }
    return "".concat(stringPath).concat(uri ? uri : "");
}
function handler(router) {
    var matchOrder = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, uri = arguments.length > 2 ? arguments[2] : void 0;
    var route = router.query;
    var pageName = route.pageName;
    return routeArrayByNumber(matchOrder, pageName, uri);
}
function routeCreator_route() {
    var matchOrder = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, route = arguments.length > 1 ? arguments[1] : void 0;
    var pageName = route.query.pageName;
    if (!pageName) return "NO-ROUTE";
    if (typeof pageName === "string") return pageName;
    return pageName[matchOrder];
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/alignmentHOC/index.ts

/* harmony default export */ var fluxio_components_alignmentHOC = (alignmentHOC);

// EXTERNAL MODULE: ./src/stylesheets/modules/templates/tabsContainer.module.sass
var tabsContainer_module = __webpack_require__(51453);
var tabsContainer_module_default = /*#__PURE__*/__webpack_require__.n(tabsContainer_module);
;// CONCATENATED MODULE: ./src/areas/public-page/fluxio-components/Tabs/BobHorizontalTabs/BobHorizontalTabs.tsx

















var _Component;
//import ComponentHandler from '../../hub/../ComponentHandler'
/**
 * React Bootstrap Tabs component
 * usage:
 * <Tabs selected="Tab 1">
 *     <Tab label="Tab 1">
 *         <div>Tab 1 contents!</div>
 *     </Tab>
 *     <Tab label="Tab 2">
 *         <div>Tab 2 contents!</div>
 *     </Tab>
 * </Tabs>
 */ var BobHorizontalTabs = /*#__PURE__*/ function(_superClass) {
    "use strict";
    (0,_inherits/* default */.Z)(BobHorizontalTabs, _superClass);
    var _super = (0,_create_super/* default */.Z)(BobHorizontalTabs);
    function BobHorizontalTabs(props) {
        (0,src_class_call_check/* default */.Z)(this, BobHorizontalTabs);
        var _this;
        _this = _super.call(this, props);
        /**
   * Render an individual header
   * @param {any} tab - the actual tab (a <Tab>)
   * @param {number} index - the index of the tab in the set of tabs
   * @returns {any} - the header for the tab
   */ _this._renderHeader = function(tab, index) {
            var isActive = false;
            var tabComponent = tab.props.component;
            if (typeof _this.state.selected === "number") {
                // eslint-disable-next-line
                isActive = _this.state.selected === index;
            } else {
                isActive = _this.state.selected === tab.props.tabLabel;
            }
            var customHeaderClass = tab.props.headerClass ? tab.props.headerClass : _this.props.headerClass ? _this.props.headerClass : null;
            var customActiveHeaderClass = !isActive ? null : tab.props.activeHeaderClass || tab.props.activeHeaderClass || "active";
            var linkClasses = classnames_default()("nav-link ".concat((tabsContainer_module_default())["nav-link"]), customHeaderClass, customActiveHeaderClass, {
                disabled: tab.props.disabled
            });
            return tabComponent.type === "object" ? _this.renderTabSelector(tabComponent, tab.props.tabLabel, tab.props.tabName, tab.props.tabIcon, linkClasses, index, isActive) : [];
        };
        var intPageSelected = 0;
        _this.state = {
            selected: props.shouldWriteRoute ? intPageSelected : props.selected,
            selectOption: undefined
        };
        _this.handleSelectedTab = _this.handleSelectedTab.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    var _proto = BobHorizontalTabs.prototype;
    _proto.componentDidMount = function componentDidMount() {
        // handle select active option url on init
        if (this.props.shouldWriteRoute) {
            var _this = this;
            var activeTab = this.props.children.filter(function(item) {
                return item.props.component.objectUuid === _this.props.selected;
            });
            // only write url for first tabs
            // dont write for tabs inside tabs
            if (this.props.matchOrder === 1) {
                var ref, ref1;
                if (activeTab && activeTab.length > 0) (ref = this.props.router) === null || ref === void 0 ? void 0 : ref.replace(handler(this.props.router, this.props.matchOrder, activeTab[0].tabLabel), undefined, {
                    scroll: false
                });
                if (this.props.selected === 0) (ref1 = this.props.router) === null || ref1 === void 0 ? void 0 : ref1.replace(handler(this.props.router, this.props.matchOrder, this.props.children[0].props.tabLabel), undefined, {
                    scroll: false
                });
            }
        }
    };
    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
        /**
     * To prevent the loss of the selected tab
     * when the user changes this component,
     * we save the selected tab in the localStorage
     */ if (this.props.selected !== nextProps.selected) {
            this.setState({
                selected: nextProps.selected
            });
        }
    };
    _proto.handleSelectedTab = function handleSelectedTab(tab) {
        this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this.state), {
            selected: tab
        }));
    };
    /**
   * Render the tab headers
   * Show tabs on desktop and select on mobile
   * @returns {any} null if there are no children or a <ul> of tabs
   */ _proto._renderHeaders = function _renderHeaders() {
        var background1 = this.props.componentTemplate.bobs.background1;
        var ref = alignmentWithAP(background1, {
            flexDirection: this.props.isVertical ? "column" : "row"
        }), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(fluxio_components_alignmentHOC, {
            as: "ul",
            role: "tablist",
            className: "nav ".concat((tabsContainer_module_default()).nav, " nav-pills ").concat((tabsContainer_module_default())["nav-pills"], " nav-justified d-sm-flex"),
            desktop: alignmentStyles,
            tablet: tabletAlignment,
            mobile: mobileAlignment,
            children: Array.isArray(this.props.children) ? this.props.children.map(this._renderHeader.bind(this)) : this._renderHeader(this.props.children, 0)
        });
    };
    _proto.renderTabSelector = function renderTabSelector(tab, label, name, icon, linkClasses, index, isActive) {
        var activeStyles = {
            borderTop: "2px solid ".concat(this.props.bgColor),
            background: this.props.thirdColor,
            color: this.props.firstColor
        };
        var inactiveStyles = {
            background: this.props.bgColorAlt,
            color: this.props.secondColor
        };
        var linkStyles = isActive ? activeStyles : inactiveStyles;
        // render inner tabs
        // when tab has a tab child, and tabs is vertical
        var innerTabs;
        if (this.props.isVertical) {
            var _this = this;
            innerTabs = tab.children.filter(function(objectId) {
                return _this.props.pageResponse.components[_this.props.pageResponse.objects[objectId].styles.component].name === "tabs_content_vertical";
            });
        }
        // render link inside/outside experience manager
        if (!this.props.shouldWriteRoute) {
            var _this1 = this;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                position: this.props.position,
                pageResponse: this.props.pageResponse,
                instanceId: tab.selectedInstanceId,
                object: tab,
                objectId: tab.objectUuid,
                inlineContent: tab.content.inlineContent,
                overrides: this.props.overrides,
                field: "background2",
                rules: this.props.pageResponse.components[tab.styles.component],
                template: tab.styles,
                expManager: this.props.expManager,
                className: "nav-item ".concat((tabsContainer_module_default())["nav-item"], " ").concat(isActive ? "active" : ""),
                onClick: function() {
                    return _this1.handleSelectedTab(index);
                },
                onMouseEnter: this.props.onMouseEnter,
                onMouseLeave: this.props.onMouseLeave,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: linkClasses,
                    style: linkStyles,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: this.props.position,
                            pageResponse: this.props.pageResponse,
                            instanceId: tab.selectedInstanceId,
                            object: tab,
                            objectId: tab.objectUuid,
                            inlineContent: tab.content.inlineContent,
                            overrides: this.props.overrides,
                            field: "media1",
                            template: tab.styles,
                            rules: this.props.pageResponse.components[tab.styles.component],
                            expManager: this.props.expManager,
                            network: tab.network,
                            post: tab
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: this.props.position,
                            pageResponse: this.props.pageResponse,
                            instanceId: tab.selectedInstanceId,
                            object: tab,
                            objectId: tab.objectUuid,
                            inlineContent: tab.content.inlineContent,
                            overrides: this.props.overrides,
                            field: "text1",
                            tag: "p",
                            value: getStringField(tab, tab, this.props.pageResponse, "text1"),
                            template: tab.styles,
                            rules: this.props.pageResponse.components[tab.styles.component],
                            expManager: this.props.expManager,
                            network: tab.network,
                            className: "network"
                        }),
                        innerTabs && innerTabs.length > 0 ? innerTabs.map(function(innerTab, idx) {
                            if (innerTabs.type === "object") return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "nav-item-inner",
                                children: _this1.renderTabSelector(innerTab, innerTab.objectUuid, innerTab.objectLabel, innerTab.styles.iconPreview ? innerTab.styles.iconPreview : innerTab.styles.icon, linkClasses, 999, isActive)
                            }, idx);
                            else return [];
                        }) : []
                    ]
                })
            }, index);
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
            position: this.props.position,
            pageResponse: this.props.pageResponse,
            instanceId: tab.selectedInstanceId,
            object: tab,
            objectId: this.props.objectUuid,
            inlineContent: tab.content.inlineContent,
            overrides: this.props.overrides,
            field: "background2",
            rules: this.props.pageResponse.components[tab.styles.component],
            template: tab.styles,
            expManager: this.props.expManager,
            className: "nav-item ".concat((tabsContainer_module_default())["nav-item"], " ").concat(isActive ? "active" : ""),
            onMouseEnter: this.props.onMouseEnter,
            onMouseLeave: this.props.onMouseLeave,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: handler(this.props.router, this.props.matchOrder, label),
                passHref: true,
                scroll: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: "".concat(linkClasses),
                    style: linkStyles,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: this.props.position,
                            pageResponse: this.props.pageResponse,
                            instanceId: tab.selectedInstanceId,
                            object: tab,
                            objectId: this.props.objectUuid,
                            inlineContent: tab.content.inlineContent,
                            overrides: this.props.overrides,
                            field: "media1",
                            template: tab.styles,
                            rules: this.props.pageResponse.components[tab.styles.component],
                            expManager: this.props.expManager,
                            network: tab.network,
                            post: tab
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: this.props.position,
                            pageResponse: this.props.pageResponse,
                            instanceId: tab.selectedInstanceId,
                            object: tab,
                            objectId: this.props.objectUuid,
                            inlineContent: tab.content.inlineContent,
                            overrides: this.props.overrides,
                            field: "text1",
                            tag: "p",
                            value: getStringField(tab, tab.styles, this.props.pageResponse, "text1"),
                            template: tab.styles,
                            rules: this.props.pageResponse.components[tab.styles.component],
                            expManager: this.props.expManager,
                            network: tab.network,
                            className: "network"
                        })
                    ]
                })
            })
        }, index);
    };
    /**
   * Renders the content of the currently selected tab
   * @returns {any} The contents of the selected tab
   */ _proto._renderContent = function _renderContent(innerTabContent) {
        if (this.props.children === undefined) {
            return null;
        }
        var onlyOneChild = !Array.isArray(this.props.children);
        var selected = this.state.selected;
        // Find the tab index - selected could be the index or could be the tab label
        var selectedIndex;
        if (typeof selected === "number") {
            selectedIndex = selected;
            if (selectedIndex < 0) {
                console.warn("tab index '".concat(this.state.selected, "' < 0, defaulting to first tab"));
                selectedIndex = 0;
                selected = selectedIndex;
            } else {
                var tabCount = this.props.children.length || 1;
                if (selectedIndex > tabCount - 1) {
                    console.warn("tab index '".concat(this.state.selected, "' > number of tabs (").concat(tabCount, ", defaulting to last tab"));
                    selectedIndex = tabCount - 1;
                    selected = selectedIndex;
                }
            }
        } else {
            // selected is a string - should be the tab label so find the index of that tab
            var selectedLabel = this.state.selected;
            selectedIndex = onlyOneChild ? 0 : this.props.children.findIndex(function(child) {
                return selectedLabel === child.props.tabLabel;
            });
            if (selectedIndex < 0) {
                console.warn("tab '".concat(this.state.selected, "' not found, defaulting to first tab"));
                selectedIndex = 0;
                selected = onlyOneChild ? this.props.children.props.tabLabel : this.props.children[selectedIndex].props.tabLabel;
            }
        }
        // If the selected tab has changed then we need to update the state
        if (selected !== this.state.selected) {
            this.setState({
                selected: selected
            });
        }
        var contentTab = innerTabContent ? innerTabContent.content && innerTabContent.content[selectedIndex] : onlyOneChild ? this.props.children : this.props.children[selectedIndex];
        var contentClassNames = classnames_default()("tab-content ".concat((tabsContainer_module_default())["tab-content"]), contentTab.props.contentClass || this.props.contentClass);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(contentClassNames),
            children: contentTab
        });
    };
    _proto.render = function render() {
        var classNames = classnames_default()("horizontal-tabs ".concat((tabsContainer_module_default())["horizontal-tabs"], " tabs"), this.props.className);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat(classNames, " ").concat(this.props.isVertical ? "is-vertical ".concat((tabsContainer_module_default())["is-vertical"]) : "", " ").concat(this.props.isVerticalNotMobile ? "is-vertical_notMobile ".concat((tabsContainer_module_default())["is-vertical_notMobile"]) : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                    position: this.props.position,
                    pageResponse: this.props.pageResponse,
                    instanceId: this.props.obj.selectedInstanceId,
                    object: this.props.obj,
                    objectId: this.props.objectUuid,
                    inlineContent: this.props.obj.content.inlineContent,
                    overrides: this.props.obj.content.overrides,
                    field: "background1",
                    rules: this.props.componentRule,
                    template: this.props.componentTemplate,
                    expManager: this.props.expManager,
                    children: this._renderHeaders()
                }),
                this._renderContent()
            ]
        });
    };
    return BobHorizontalTabs;
}(_Component = react.Component);
BobHorizontalTabs.propTypes = {
    /**
     * The selected tab - either the index of it or the label string.  Defaults to tab 0 if not supplied
     */ selected: prop_types_default().oneOfType([
        (prop_types_default()).number,
        (prop_types_default()).string
    ]),
    /**
     * Optional CSS class to apply to the component overall
     */ className: (prop_types_default()).string,
    /**
     * Optional CSS class to apply to each tab header
     */ headerClass: (prop_types_default()).string,
    /**
     * Optional CSS class to apply to the active tab header
     */ activeHeaderClass: (prop_types_default()).string,
    /**
     * Optional CSS class to apply to the content container for the currently selected tab
     */ contentClass: (prop_types_default()).string,
    /**
     * Optional method to call when a tab is selected.  Receive the tab index and tab label of the selected tab
     */ onSelect: (prop_types_default()).func,
    /**
     * At least one tab is required - otherwise there's no point rendering this!
     */ children: prop_types_default().oneOfType([
        (prop_types_default()).array,
        (prop_types_default()).element
    ]).isRequired
};
BobHorizontalTabs.defaultProps = {
    selected: 0
};
var _Component1;
/**
 * React Bootstrap Tab component (to be contained by a <Tabs> component
 * usage:
 * <Tab label="Tab 1">
 *     <div>Tab 1 contents!</div>
 * </Tab>
 */ var TabComponent = /*#__PURE__*/ function(_superClass) {
    "use strict";
    (0,_inherits/* default */.Z)(TabComponent, _superClass);
    var _super = (0,_create_super/* default */.Z)(TabComponent);
    function TabComponent(props) {
        (0,src_class_call_check/* default */.Z)(this, TabComponent);
        return _super.call(this, props);
    }
    var _proto = TabComponent.prototype;
    _proto.componentDidMount = function componentDidMount() {
        //Deep link system without reloading page
        sessionStorage.urlPathTabs = this.props.label;
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: this.props.children
        });
    };
    return TabComponent;
}(_Component1 = react.Component);
TabComponent.propTypes = {
    /**
     * Label to display as the tab header
     */ label: (prop_types_default()).any.isRequired,
    /**
     * Is this tab disabled?  Default: false
     */ disabled: (prop_types_default()).bool,
    /**
     * Optional CSS class to apply to the tab header
     */ headerClass: (prop_types_default()).string,
    /**
     * Optional CSS class to apply to the tab header when active
     */ activeHeaderClass: (prop_types_default()).string,
    /**
     * Optional CSS class to apply to the content container when the tab is displayed
     */ contentClass: (prop_types_default()).string
};


;// CONCATENATED MODULE: ./src/modules/experienceManager/WarningDefaultSystem/warningDefaultSystem.tsx





var WarningDefaultSystem = function(param) {
    var children = param.children, toggle = param.toggle;
    var dispatch = (0,es/* useDispatch */.I0)();
    var warningState = (0,es/* useSelector */.v9)(function(state) {
        return state.experienceManagerReducer.server;
    }).warningState;
    if (toggle) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_tippy.Tooltip, {
            title: warningState ? "Hide Information Notes on Preview" : "Show Information Notes on Preview",
            position: "bottom",
            trigger: "mouseenter",
            arrow: true,
            theme: "light",
            animation: "fade",
            style: {
                display: "flex"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                onClick: function() {
                    return dispatch(warningSystemEM(!warningState));
                },
                className: "fas fa-exclamation-circle",
                style: {
                    color: warningState ? "rgb(33, 37, 41)" : "rgb(118, 122, 129)"
                }
            })
        });
    }
    if (warningState) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
    else return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var warningDefaultSystem = (WarningDefaultSystem);

;// CONCATENATED MODULE: ./src/areas/public-page/fluxio-components/Tabs/TabsContainer/TabsContainer.tsx
















var TabsContainer = function(props) {
    var renderTabsContent = function(childsId) {
        if (childsId.length > 0) {
            return childsId.map(function(childId, idx) {
                var handledItem = handleObjectType(props.obj, childId, props.pageResponse, props.expManager.emEditorType);
                var tabName = childId.objectLabel;
                var tabIcon = "";
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                    position: idx,
                    selectedInstanceId: props.obj.selectedInstanceId,
                    pageResponse: props.pageResponse,
                    matchOrder: props.matchOrder,
                    expManager: props.expManager,
                    component: handledItem,
                    tabName: tabName,
                    tabLabel: handleObjectUri((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, handledItem), {
                        selectedInstanceId: props.obj.selectedInstanceId
                    })),
                    tabIcon: tabIcon,
                    tabEventKey: 1
                }, idx);
            });
        } else {
            return "No content";
        }
    };
    var onMouseEnter = function(e) {
        if (!e || !e.target) return;
        var container = e.target;
        var childText = container.querySelector(".bob-text");
        if (!childText) return;
        childText.classList.add("isHover");
    };
    var onMouseLeave = function(e) {
        if (!e || !e.target) return;
        var container = e.target;
        var childText = container.querySelector(".bob-text");
        if (!childText) return;
        childText.classList.remove("isHover");
    };
    var renderNoChilds = function() {
        /**
     * render no content placeholder
     */ if (props.expManager.enable) {
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            var childs = isBobBackground(props.obj.styles.bobs.background1).grid.columns && isBobBackground(props.obj.styles.bobs.background1).grid.columns.length;
            var components = [];
            for(var i = 0; i < childs; i++){
                var columns = bobHandler_handleColumns(i, counter, props.obj.styles.bobs.background1);
                counter = columns.counter;
                components = (0,src_to_consumable_array/* default */.Z)(components).concat([
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                                verticalAlign: "middle",
                                height: "".concat(isBobBackground(props.obj.styles.bobs.background1).height.enable ? "100" : "100").concat(isBobBackground(props.obj.styles.bobs.background1).height.enable ? "%" : "px"),
                                border: "3px dashed #dbe0e7"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "alert warning m-0",
                                role: "alert",
                                children: [
                                    "Add ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Tabs Content"
                                    }),
                                    " components as a child to create tabs"
                                ]
                            })
                        })
                    }, i), 
                ]);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(warningDefaultSystem, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                    position: props.position,
                    pageResponse: props.pageResponse,
                    instanceId: props.obj.selectedInstanceId,
                    object: props.obj,
                    objectId: props.obj.uuid,
                    inlineContent: props.obj.content.inlineContent,
                    overrides: props.overrides,
                    field: "background1",
                    rules: props.componentRule,
                    template: props.obj.styles,
                    expManager: props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row no-gutters",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        width: "100%",
                                        verticalAlign: "middle",
                                        height: "".concat(isBobBackground(props.obj.styles.bobs.background1).height.enable ? "100" : "50").concat(isBobBackground(props.obj.styles.bobs.background1).height.enable ? "%" : "px"),
                                        border: "3px dashed #dbe0e7"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        width: "100%",
                                        verticalAlign: "middle",
                                        height: "".concat(isBobBackground(props.obj.styles.bobs.background1).height.enable ? "100" : "50").concat(isBobBackground(props.obj.styles.bobs.background1).height.enable ? "%" : "px"),
                                        border: "3px dashed #dbe0e7"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        width: "100%",
                                        verticalAlign: "middle",
                                        height: "".concat(isBobBackground(props.obj.styles.bobs.background1).height.enable ? "100" : "50").concat(isBobBackground(props.obj.styles.bobs.background1).height.enable ? "%" : "px"),
                                        border: "3px dashed #dbe0e7"
                                    }
                                })
                            }),
                            components
                        ]
                    })
                })
            });
        }
    };
    var childsId = props.obj.children;
    var tabsContent = childsId.filter(function(objectId) {
        var object = handleObjectType(props.obj, objectId, props.pageResponse, props.expManager.emEditorType);
        object = object.type === "instance" ? symbols_handleFilterSymbolObject(object, props.pageResponse.symbols, false) : object;
        return props.pageResponse.components[object.styles.component].name === "tabs_content" || props.pageResponse.components[object.styles.component].name === "tabs_content_vertical";
    });
    var tabsContentVerticalV2 = childsId.filter(function(objectId) {
        var object = handleObjectType(props.obj, objectId, props.pageResponse, props.expManager.emEditorType);
        object = object.type === "instance" ? symbols_handleFilterSymbolObject(object, props.pageResponse.symbols, false) : object;
        return props.pageResponse.components[object.styles.component].name === "tabs_content_vertical_v2";
    });
    var tabsContentVertical;
    if (!tabsContentVerticalV2 || tabsContentVerticalV2 && tabsContentVerticalV2.length <= 0) tabsContentVertical = childsId.filter(function(objectId) {
        var object = handleObjectType(props.obj, objectId, props.pageResponse, props.expManager.emEditorType);
        object = object.type === "instance" ? symbols_handleFilterSymbolObject(object, props.pageResponse.symbols, false) : object;
        return props.pageResponse.components[object.styles.component].name === "tabs_content_vertical";
    });
    var boundarieStyles = handleBondaries_DEPRECATED(props.obj.styles);
    var styles = (0,src_object_spread/* default */.Z)({}, boundarieStyles);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "containers tabs tabs-container ".concat((tabsContainer_module_default())["tabs-container"]),
        style: styles,
        children: tabsContent && tabsContent.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BobHorizontalTabs, {
            className: "",
            selected: routeCreator_route(props.matchOrder, props.router),
            expManager: props.expManager,
            shouldWriteRoute: props.shouldWriteRoute,
            router: props.router,
            position: props.position,
            matchOrder: props.matchOrder,
            componentRule: props.componentRule,
            componentTemplate: props.obj.styles,
            objectUuid: props.obj.uuid,
            onMouseEnter: function(e) {
                return onMouseEnter(e);
            },
            onMouseLeave: function(e) {
                return onMouseLeave(e);
            },
            isVertical: tabsContentVertical && tabsContentVertical.length > 0 ? true : false,
            isVerticalNotMobile: tabsContentVerticalV2 && tabsContentVerticalV2.length > 0 ? true : false,
            globalStyles: props.pageResponse.globalStyles,
            obj: props.obj,
            symbols: props.symbols,
            pageResponse: props.pageResponse,
            replacedMediaList: props.replacedMediaList,
            children: renderTabsContent(childsId)
        }) : props.expManager.enable && renderNoChilds()
    });
};
/* harmony default export */ var TabsContainer_TabsContainer = ((0,router.withRouter)(TabsContainer));

// EXTERNAL MODULE: ./src/stylesheets/modules/templates/tabsContainerDropdown.module.sass
var tabsContainerDropdown_module = __webpack_require__(49053);
var tabsContainerDropdown_module_default = /*#__PURE__*/__webpack_require__.n(tabsContainerDropdown_module);
;// CONCATENATED MODULE: ./src/areas/public-page/fluxio-components/Tabs/BobHorizontalTabsDropdown/BobHorizontalTabsDropdown.tsx

















var BobHorizontalTabsDropdown_Component;
//import ComponentHandler from '../../hub/../ComponentHandler'
/**
 * React Bootstrap Tabs component
 * usage:
 * <Tabs selected="Tab 1">
 *     <Tab label="Tab 1">
 *         <div>Tab 1 contents!</div>
 *     </Tab>
 *     <Tab label="Tab 2">
 *         <div>Tab 2 contents!</div>
 *     </Tab>
 * </Tabs>
 */ var BobHorizontalTabsDropdown_BobHorizontalTabs = /*#__PURE__*/ function(_superClass) {
    "use strict";
    (0,_inherits/* default */.Z)(BobHorizontalTabs, _superClass);
    var _super = (0,_create_super/* default */.Z)(BobHorizontalTabs);
    function BobHorizontalTabs(props) {
        (0,src_class_call_check/* default */.Z)(this, BobHorizontalTabs);
        var _this;
        _this = _super.call(this, props);
        _this.handleToggleDropdown = function() {
            _this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, _this.state), {
                dropdownClose: !_this.state.dropdownClose
            }));
        };
        /**
   * Render an individual header
   * @param {any} tab - the actual tab (a <Tab>)
   * @param {number} index - the index of the tab in the set of tabs
   * @returns {any} - the header for the tab
   */ _this._renderHeader = function(tab, index) {
            var isActive = false;
            var tabComponent = tab.props.component;
            if (typeof _this.state.selected === "number") {
                // eslint-disable-next-line
                isActive = _this.state.selected === index;
            } else {
                isActive = _this.state.selected === tab.props.tabLabel;
            }
            var customHeaderClass = tab.props.headerClass ? tab.props.headerClass : _this.props.headerClass ? _this.props.headerClass : null;
            var customActiveHeaderClass = !isActive ? null : tab.props.activeHeaderClass || tab.props.activeHeaderClass || "active ".concat((tabsContainerDropdown_module_default()).active);
            var linkClasses = classnames_default()("nav-link ".concat((tabsContainerDropdown_module_default())["nav-link"]), customHeaderClass, customActiveHeaderClass, {
                disabled: tab.props.disabled
            });
            return tabComponent.type === "object" ? _this.renderTabSelector(tabComponent, tab.props.tabLabel, linkClasses, index, isActive) : [];
        };
        _this.renderDropdown = function() {
            var activeTab = undefined;
            if (Array.isArray(_this.props.children)) {
                for(var key in _this.props.children){
                    var tab = _this.props.children[key];
                    if (typeof _this.state.selected === "number") {
                        if (_this.state.selected === parseInt(key)) activeTab = tab;
                    } else {
                        if (_this.state.selected === tab.props.tabLabel) activeTab = tab;
                    }
                }
            }
            if (activeTab) {
                var tabComponent = activeTab.props.component;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "dropdown-active-item ".concat((tabsContainerDropdown_module_default())["dropdown-active-item"]),
                    onClick: _this.handleToggleDropdown,
                    children: [
                        _this.renderDropdownSelector(tabComponent),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: _this.props.position,
                            pageResponse: _this.props.pageResponse,
                            instanceId: _this.props.obj.selectedInstanceId,
                            object: _this.props.obj,
                            objectId: _this.props.obj.uuid,
                            field: "icon1",
                            template: _this.props.obj.styles,
                            rules: _this.props.componentRule,
                            expManager: _this.props.expManager,
                            iconClassName: "fas fa-chevron-down"
                        })
                    ]
                });
            }
            return [];
        };
        var intPageSelected = 0;
        if (props.expManager.enable) {
            var tabSelected = localStorage.getItem("bob-tabs-tab".concat(props.objectUuid));
            if (tabSelected) {
                intPageSelected = parseInt(tabSelected, 10);
            }
        }
        _this.state = {
            selected: props.expManager.enable ? intPageSelected : props.selected,
            selectOption: undefined,
            dropdownClose: true
        };
        _this.handleSelectedTab = _this.handleSelectedTab.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this._renderHeader = _this._renderHeader.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    var _proto = BobHorizontalTabs.prototype;
    _proto.componentDidMount = function componentDidMount() {
        // handle select active option url on init
        if (!this.props.expManager.enable) {
            var _this = this;
            var activeTab = this.props.children.filter(function(item) {
                return item.props.component.objectUuid === _this.props.selected;
            });
            // only write url for first tabs
            // dont write for tabs inside tabs
            if (this.props.matchOrder === 1) {
                var ref, ref1;
                if (activeTab && activeTab.length > 0) (ref = this.props.router) === null || ref === void 0 ? void 0 : ref.replace(handler(this.props.router, this.props.matchOrder, activeTab[0].tabLabel), undefined, {
                    scroll: false
                });
                if (this.props.selected === 0) (ref1 = this.props.router) === null || ref1 === void 0 ? void 0 : ref1.replace(handler(this.props.router, this.props.matchOrder, this.props.children[0].props.tabLabel), undefined, {
                    scroll: false
                });
            }
        }
    };
    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
        /**
     * To prevent the loss of the selected tab
     * when the user changes this component,
     * we save the selected tab in the localStorage
     */ var tabSelectedOnEM = localStorage.getItem("bob-tabs-tab".concat(this.props.objectUuid));
        var IntTabSelected = 0;
        if (tabSelectedOnEM && this.props.expManager.enable) {
            IntTabSelected = parseInt(tabSelectedOnEM, 10);
            this.setState({
                selected: IntTabSelected
            });
        } else {
            this.setState({
                selected: nextProps.selected
            });
        }
    };
    _proto.handleSelectedTab = function handleSelectedTab(tab) {
        // handle select active option
        if (typeof tab === "string") {
            var ref;
            (ref = this.props.router) === null || ref === void 0 ? void 0 : ref.replace(handler(this.props.router, this.props.matchOrder, tab), undefined, {
                scroll: false
            });
        }
        // handle active tab
        localStorage.setItem("bob-tabs-tab".concat(this.props.objectUuid), tab);
        // localStorage.setItem(`bob-tabs-tab-label${this.props.objectUuid}`, tab)
        this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this.state), {
            selected: tab,
            dropdownClose: !this.state.dropdownClose
        }));
    };
    /**
   * Render the tab headers
   * Show tabs on desktop and select on mobile
   * @returns {any} null if there are no children or a <ul> of tabs
   */ _proto._renderHeaders = function _renderHeaders() {
        var background1 = this.props.componentTemplate.bobs.background1;
        var ref = alignmentWithAP(background1, {
            flexDirection: this.props.isVertical ? "column" : "row"
        }), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                this.renderDropdown(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(fluxio_components_alignmentHOC, {
                    as: "ul",
                    role: "tablist",
                    className: "nav nav-pills ".concat((tabsContainerDropdown_module_default())["nav-pills"], " nav-justified d-sm-flex ").concat(this.state.dropdownClose ? "dropdown-close ".concat((tabsContainerDropdown_module_default())["dropdown-close"]) : ""),
                    desktop: alignmentStyles,
                    tablet: tabletAlignment,
                    mobile: mobileAlignment,
                    children: Array.isArray(this.props.children) ? this.props.children.map(this._renderHeader.bind(this)) : this._renderHeader(this.props.children, 0)
                })
            ]
        });
    };
    _proto.renderTabSelector = function renderTabSelector(tab, label, linkClasses, index, isActive) {
        var _this = this;
        var activeStyles = {
            borderTop: "2px solid ".concat(this.props.bgColor),
            background: this.props.thirdColor,
            color: this.props.firstColor
        };
        var inactiveStyles = {
            background: this.props.bgColorAlt,
            color: this.props.secondColor
        };
        var linkStyles = isActive ? activeStyles : inactiveStyles;
        // render inner tabs
        // when tab has a tab child, and tabs is vertical
        var innerTabs;
        if (this.props.isVertical) {
            var _this1 = this;
            innerTabs = tab.children.filter(function(objectId) {
                return _this1.props.pageResponse.components[_this1.props.pageResponse.objects[objectId].styles.component].name === "tabs_content_vertical";
            });
        }
        // render link inside/outside experience manager
        if (this.props.expManager.enable) {
            var _this2 = this;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                position: this.props.position,
                pageResponse: this.props.pageResponse,
                instanceId: tab.selectedInstanceId,
                object: tab,
                objectId: tab.objectUuid,
                inlineContent: tab.content.inlineContent,
                overrides: tab.content.overrides,
                field: "background2",
                rules: this.props.pageResponse.components[tab.styles.component],
                template: tab.styles,
                expManager: this.props.expManager,
                className: "nav-item ".concat((tabsContainerDropdown_module_default())["nav-item"], " ").concat(isActive ? "active ".concat((tabsContainerDropdown_module_default()).active) : ""),
                onClick: function() {
                    return _this2.handleSelectedTab(index);
                },
                onMouseEnter: this.props.onMouseEnter,
                onMouseLeave: this.props.onMouseLeave,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: linkClasses,
                    style: linkStyles,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: this.props.position,
                            pageResponse: this.props.pageResponse,
                            instanceId: tab.selectedInstanceId,
                            object: tab,
                            objectId: tab.objectUuid,
                            inlineContent: tab.content.inlineContent,
                            overrides: tab.content.overrides,
                            field: "media1",
                            template: tab.styles,
                            rules: this.props.pageResponse.components[tab.styles.component],
                            expManager: this.props.expManager,
                            network: tab.network,
                            post: tab
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: this.props.position,
                            pageResponse: this.props.pageResponse,
                            instanceId: tab.selectedInstanceId,
                            object: tab,
                            objectId: tab.objectUuid,
                            inlineContent: tab.content.inlineContent,
                            overrides: tab.content.overrides,
                            field: "text1",
                            tag: "p",
                            value: getStringField(tab, tab, this.props.pageResponse, "text1"),
                            template: tab.styles,
                            rules: this.props.pageResponse.components[tab.styles.component],
                            expManager: this.props.expManager,
                            network: tab.network,
                            className: "network"
                        }),
                        innerTabs && innerTabs.length > 0 ? innerTabs.map(function(innerTab, idx) {
                            if (innerTabs.type === "object") return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "nav-item-inner",
                                children: _this2.renderTabSelector(innerTab, innerTab.objectUuid, linkClasses, 999, isActive)
                            }, idx);
                            else return [];
                        }) : []
                    ]
                })
            }, index);
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
            position: this.props.position,
            pageResponse: this.props.pageResponse,
            instanceId: tab.selectedInstanceId,
            object: tab,
            objectId: this.props.objectUuid,
            inlineContent: tab.content.inlineContent,
            overrides: tab.content.overrides,
            field: "background2",
            rules: this.props.pageResponse.components[tab.styles.component],
            template: tab.styles,
            expManager: this.props.expManager,
            className: "nav-item ".concat((tabsContainerDropdown_module_default())["nav-item"], " ").concat(isActive ? "active ".concat((tabsContainerDropdown_module_default()).active) : ""),
            onMouseEnter: this.props.onMouseEnter,
            onMouseLeave: this.props.onMouseLeave,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: handler(this.props.router, this.props.matchOrder, label),
                passHref: true,
                scroll: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: "".concat(linkClasses),
                    style: linkStyles,
                    onClick: function() {
                        return _this.handleToggleDropdown();
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: this.props.position,
                            pageResponse: this.props.pageResponse,
                            instanceId: tab.selectedInstanceId,
                            object: tab,
                            objectId: this.props.objectUuid,
                            inlineContent: tab.content.inlineContent,
                            overrides: tab.content.overrides,
                            field: "media1",
                            template: tab.styles,
                            rules: this.props.pageResponse.components[tab.styles.component],
                            expManager: this.props.expManager,
                            network: tab.network,
                            post: tab
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: this.props.position,
                            pageResponse: this.props.pageResponse,
                            instanceId: tab.selectedInstanceId,
                            object: tab,
                            objectId: this.props.objectUuid,
                            inlineContent: tab.content.inlineContent,
                            overrides: tab.content.overrides,
                            field: "text1",
                            tag: "p",
                            value: getStringField(tab, tab.styles, this.props.pageResponse, "text1", this.props.overrides),
                            template: tab.styles,
                            rules: this.props.pageResponse.components[tab.styles.component],
                            expManager: this.props.expManager,
                            network: tab.network,
                            className: "network"
                        })
                    ]
                })
            })
        }, index);
    };
    _proto.renderDropdownSelector = function renderDropdownSelector(tab) {
        // render link inside/outside experience manager
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(bobComponentHandler, {
            position: this.props.position,
            pageResponse: this.props.pageResponse,
            instanceId: this.props.selectedInstanceId,
            object: this.props.obj,
            objectId: this.props.obj.uuid,
            inlineContent: tab.content.inlineContent,
            overrides: tab.content.overrides,
            field: "background2",
            rules: this.props.pageResponse.components[this.props.obj.styles.component],
            template: this.props.obj.styles,
            expManager: this.props.expManager,
            onMouseEnter: this.props.onMouseEnter,
            onMouseLeave: this.props.onMouseLeave,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                    position: this.props.position,
                    pageResponse: this.props.pageResponse,
                    instanceId: this.props.selectedInstanceId,
                    object: this.props.obj,
                    objectId: this.props.obj.uuid,
                    inlineContent: tab.content.inlineContent,
                    overrides: tab.content.overrides,
                    field: "media1",
                    template: this.props.obj.styles,
                    rules: this.props.pageResponse.components[this.props.obj.styles.component],
                    expManager: this.props.expManager,
                    network: tab.network,
                    post: tab
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                    position: this.props.position,
                    pageResponse: this.props.pageResponse,
                    instanceId: this.props.selectedInstanceId,
                    object: this.props.obj,
                    objectId: this.props.obj.uuid,
                    inlineContent: tab.content.inlineContent,
                    overrides: tab.content.overrides,
                    field: "text1",
                    tag: "p",
                    value: getStringField(tab, tab, this.props.pageResponse, "text1"),
                    template: this.props.obj.styles,
                    rules: this.props.pageResponse.components[this.props.obj.styles.component],
                    expManager: this.props.expManager,
                    network: tab.network,
                    className: "network"
                })
            ]
        });
    };
    /**
   * Renders the content of the currently selected tab
   * @returns {any} The contents of the selected tab
   */ _proto._renderContent = function _renderContent(innerTabContent) {
        if (this.props.children === undefined) {
            return null;
        }
        var onlyOneChild = !Array.isArray(this.props.children);
        var selected = this.state.selected;
        // Find the tab index - selected could be the index or could be the tab label
        var selectedIndex;
        if (typeof selected === "number") {
            selectedIndex = selected;
            if (selectedIndex < 0) {
                console.warn("tab index '".concat(this.state.selected, "' < 0, defaulting to first tab"));
                selectedIndex = 0;
                selected = selectedIndex;
            } else {
                var tabCount = this.props.children.length || 1;
                if (selectedIndex > tabCount - 1) {
                    console.warn("tab index '".concat(this.state.selected, "' > number of tabs (").concat(tabCount, ", defaulting to last tab"));
                    selectedIndex = tabCount - 1;
                    selected = selectedIndex;
                }
            }
        } else {
            // selected is a string - should be the tab label so find the index of that tab
            var selectedLabel = this.state.selected;
            selectedIndex = onlyOneChild ? 0 : this.props.children.findIndex(function(child) {
                return selectedLabel === child.props.tabLabel;
            });
            if (selectedIndex < 0) {
                console.warn("tab '".concat(this.state.selected, "' not found, defaulting to first tab"));
                selectedIndex = 0;
                selected = onlyOneChild ? this.props.children.props.tabLabel : this.props.children[selectedIndex].props.tabLabel;
            }
        }
        var contentTab = innerTabContent ? innerTabContent.content && innerTabContent.content[selectedIndex] : onlyOneChild ? this.props.children : this.props.children[selectedIndex];
        var contentClassNames = classnames_default()("tab-content", contentTab.props.contentClass || this.props.contentClass);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(contentClassNames),
            children: contentTab
        });
    };
    _proto.render = function render() {
        var classNames = classnames_default()("horizontal-tabs tabs", this.props.className);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat(classNames, " ").concat(this.props.isVertical ? "is-vertical" : "", " ").concat(this.props.isVerticalNotMobile ? "is-vertical_notMobile" : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                    position: this.props.position,
                    pageResponse: this.props.pageResponse,
                    instanceId: this.props.obj.selectedInstanceId,
                    object: this.props.obj,
                    objectId: this.props.objectUuid,
                    inlineContent: this.props.obj.content.inlineContent,
                    overrides: this.props.obj.content.overrides,
                    field: "background1",
                    rules: this.props.componentRule,
                    template: this.props.componentTemplate,
                    expManager: this.props.expManager,
                    children: this._renderHeaders()
                }),
                this._renderContent()
            ]
        });
    };
    return BobHorizontalTabs;
}(BobHorizontalTabsDropdown_Component = react.Component);
BobHorizontalTabsDropdown_BobHorizontalTabs.propTypes = {
    /**
     * The selected tab - either the index of it or the label string.  Defaults to tab 0 if not supplied
     */ selected: prop_types_default().oneOfType([
        (prop_types_default()).number,
        (prop_types_default()).string
    ]),
    /**
     * Optional CSS class to apply to the component overall
     */ className: (prop_types_default()).string,
    /**
     * Optional CSS class to apply to each tab header
     */ headerClass: (prop_types_default()).string,
    /**
     * Optional CSS class to apply to the active tab header
     */ activeHeaderClass: (prop_types_default()).string,
    /**
     * Optional CSS class to apply to the content container for the currently selected tab
     */ contentClass: (prop_types_default()).string,
    /**
     * Optional method to call when a tab is selected.  Receive the tab index and tab label of the selected tab
     */ onSelect: (prop_types_default()).func,
    /**
     * At least one tab is required - otherwise there's no point rendering this!
     */ children: prop_types_default().oneOfType([
        (prop_types_default()).array,
        (prop_types_default()).element
    ]).isRequired
};
BobHorizontalTabsDropdown_BobHorizontalTabs.defaultProps = {
    selected: 0
};


;// CONCATENATED MODULE: ./src/areas/public-page/fluxio-components/Tabs/TabsContainerDropdown/TabsContainerDropdown.tsx

















var TabsContainerDropdown = function(props) {
    var renderTabsContent = function(childsId) {
        if (childsId.length > 0) {
            return childsId.map(function(childId, idx) {
                var handledItem = handleObjectType(props.obj, childId, props.pageResponse, props.expManager.emEditorType);
                var tabName = childId.objectLabel;
                var tabIcon = "";
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                    position: idx,
                    selectedInstanceId: props.obj.selectedInstanceId,
                    pageResponse: props.pageResponse,
                    matchOrder: props.matchOrder,
                    expManager: props.expManager,
                    component: handledItem,
                    tabName: tabName,
                    tabLabel: handleObjectUri((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, handledItem), {
                        selectedInstanceId: props.obj.selectedInstanceId
                    })),
                    tabIcon: tabIcon,
                    tabEventKey: 1
                }, idx);
            });
        } else {
            return "No content";
        }
    };
    var onMouseEnter = function(e) {
        if (!e || !e.target) return;
        var container = e.target;
        var childText = container.querySelector(".bob-text");
        if (!childText) return;
        childText.classList.add("isHover");
    };
    var onMouseLeave = function(e) {
        if (!e || !e.target) return;
        var container = e.target;
        var childText = container.querySelector(".bob-text");
        if (!childText) return;
        childText.classList.remove("isHover");
    };
    var renderNoChilds = function() {
        /**
     * render no content placeholder
     */ if (props.expManager.enable) {
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            var childs = isBobBackground(props.obj.styles.bobs.background1).grid.columns && isBobBackground(props.obj.styles.bobs.background1).grid.columns.length;
            var components = [];
            for(var i = 0; i < childs; i++){
                var columns = bobHandler_handleColumns(i, counter, props.obj.styles.bobs.background1);
                counter = columns.counter;
                components = (0,src_to_consumable_array/* default */.Z)(components).concat([
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                                verticalAlign: "middle",
                                height: "".concat(isBobBackground(props.obj.styles.bobs.background1).height.enable ? "100" : "100").concat(isBobBackground(props.obj.styles.bobs.background1).height.enable ? "%" : "px"),
                                border: "3px dashed #dbe0e7"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "alert warning m-0",
                                role: "alert",
                                children: [
                                    "Add ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Tabs Content"
                                    }),
                                    " components as a child to create tabs"
                                ]
                            })
                        })
                    }, i), 
                ]);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(warningDefaultSystem, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                    position: props.position,
                    pageResponse: props.pageResponse,
                    instanceId: props.obj.selectedInstanceId,
                    object: props.obj,
                    objectId: props.obj.uuid,
                    inlineContent: props.obj.content.inlineContent,
                    overrides: props.overrides,
                    field: "background1",
                    rules: props.componentRule,
                    template: props.obj.styles,
                    expManager: props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row no-gutters",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        width: "100%",
                                        verticalAlign: "middle",
                                        height: "".concat(isBobBackground(props.obj.styles.bobs.background1).height.enable ? "100" : "50").concat(isBobBackground(props.obj.styles.bobs.background1).height.enable ? "%" : "px"),
                                        border: "3px dashed #dbe0e7"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        width: "100%",
                                        verticalAlign: "middle",
                                        height: "".concat(isBobBackground(props.obj.styles.bobs.background1).height.enable ? "100" : "50").concat(isBobBackground(props.obj.styles.bobs.background1).height.enable ? "%" : "px"),
                                        border: "3px dashed #dbe0e7"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        width: "100%",
                                        verticalAlign: "middle",
                                        height: "".concat(isBobBackground(props.obj.styles.bobs.background1).height.enable ? "100" : "50").concat(isBobBackground(props.obj.styles.bobs.background1).height.enable ? "%" : "px"),
                                        border: "3px dashed #dbe0e7"
                                    }
                                })
                            }),
                            components
                        ]
                    })
                })
            });
        }
    };
    var childsId = props.obj.children;
    var tabsContent = childsId.filter(function(objectId) {
        var object = handleObjectType(props.obj, objectId, props.pageResponse, props.expManager.emEditorType);
        object = object.type === "instance" ? symbols_handleFilterSymbolObject(object, props.pageResponse.symbols, false) : object;
        return props.pageResponse.components[object.styles.component].name === "tabs_content" || props.pageResponse.components[object.styles.component].name === "tabs_content_vertical" || props.pageResponse.components[object.styles.component].name === "tabs_content_vertical_v2";
    });
    var tabsContentVerticalV2 = childsId.filter(function(objectId) {
        var object = handleObjectType(props.obj, objectId, props.pageResponse, props.expManager.emEditorType);
        object = object.type === "instance" ? symbols_handleFilterSymbolObject(object, props.pageResponse.symbols, false) : object;
        return props.pageResponse.components[object.styles.component].name === "tabs_content_vertical_v2";
    });
    var tabsContentVertical;
    if (!tabsContentVerticalV2 || tabsContentVerticalV2 && tabsContentVerticalV2.length <= 0) tabsContentVertical = childsId.filter(function(objectId) {
        var object = handleObjectType(props.obj, objectId, props.pageResponse, props.expManager.emEditorType);
        object = object.type === "instance" ? symbols_handleFilterSymbolObject(object, props.pageResponse.symbols, false) : object;
        return props.pageResponse.components[object.styles.component].name === "tabs_content_vertical";
    });
    var boundarieStyles = handleBondaries_DEPRECATED(props.obj.styles);
    var styles = (0,src_object_spread/* default */.Z)({}, boundarieStyles);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "containers tabs tabs-container ".concat((tabsContainer_module_default())["tabs-container"], " tabs-container_v2 ").concat((tabsContainerDropdown_module_default())["tabs-container_v2"]),
        style: styles,
        children: tabsContent && tabsContent.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BobHorizontalTabsDropdown_BobHorizontalTabs, {
            className: "",
            //@ts-ignore SSR TODO: fix selected type, is only bad on ssr side
            selected: routeCreator_route(props.matchOrder, props.router),
            expManager: props.expManager,
            router: props.router,
            position: props.position,
            matchOrder: props.matchOrder,
            componentRule: props.componentRule,
            componentTemplate: props.obj.styles,
            objectUuid: props.obj.uuid,
            onMouseEnter: function(e) {
                return onMouseEnter(e);
            },
            onMouseLeave: function(e) {
                return onMouseLeave(e);
            },
            isVertical: tabsContentVertical && tabsContentVertical.length > 0 ? true : false,
            isVerticalNotMobile: tabsContentVerticalV2 && tabsContentVerticalV2.length > 0 ? true : false,
            globalStyles: props.pageResponse.globalStyles,
            obj: props.obj,
            symbols: props.symbols,
            pageResponse: props.pageResponse,
            replacedMediaList: props.replacedMediaList,
            children: renderTabsContent(childsId)
        }) : props.expManager.enable && renderNoChilds()
    });
};
/* harmony default export */ var TabsContainerDropdown_TabsContainerDropdown = ((0,router.withRouter)(TabsContainerDropdown));

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Tabs/TabsContents/TabsContent/TabsContent.tsx







var TabsContent = function(props) {
    var renderTabContent = function() {
        var childsId = props.obj.children;
        if (childsId.length > 0) {
            return childsId.map(function(child, idx) {
                var handledItem = handleObjectType(props.obj, child, props.pageResponse, props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                    position: idx,
                    selectedInstanceId: props.obj.selectedInstanceId,
                    pageResponse: props.pageResponse,
                    instanceId: handledItem,
                    component: handledItem,
                    matchOrder: props.matchOrder + 1,
                    expManager: props.expManager
                }, idx);
            });
        } else {
            return renderNoChilds();
        }
    };
    var renderNoChilds = function() {
        /**
     * render no content placeholder
     */ if (props.expManager.enable) {
            var childs = 1;
            var components = [];
            for(var i = 0; i < childs; i++){
                var columns = 12;
                components = (0,src_to_consumable_array/* default */.Z)(components).concat([
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-".concat(columns),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                                verticalAlign: "middle",
                                height: "100px",
                                border: "3px dashed #dbe0e7"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "alert warning m-0",
                                role: "alert",
                                children: "Add a child component to show content."
                            })
                        })
                    }, i), 
                ]);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(warningDefaultSystem, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: components
                    })
                })
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "tabs tabs-content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabComponent, {
            className: "",
            name: props.tabName,
            label: props.tabLabel,
            icon: props.tabIcon,
            eventKey: props.tabEventKey,
            globalStyles: props.pageResponse.globalStyles,
            expManager: props.expManager,
            obj: props.obj,
            symbols: props.symbols,
            children: renderTabContent()
        })
    });
};
/* harmony default export */ var TabsContent_TabsContent = (TabsContent);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Tabs/TabsContents/TabsContentVertical/TabsContentVertical.tsx







var TabsContentVertical = function(props) {
    var renderTabContent = function() {
        var childsId = props.obj.children;
        if (childsId.length > 0) {
            return childsId.map(function(childId, idx) {
                var handledItem = handleObjectType(props.obj, childId, props.pageResponse, props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                    position: idx,
                    selectedInstanceId: props.obj.selectedInstanceId,
                    component: handledItem,
                    pageResponse: props.pageResponse,
                    matchOrder: props.matchOrder + 1,
                    expManager: props.expManager
                }, idx);
            });
        } else {
            return renderNoChilds();
        }
    };
    var renderNoChilds = function() {
        /**
     * render no content placeholder
     */ if (props.expManager.enable) {
            var childs = 1;
            var components = [];
            for(var i = 0; i < childs; i++){
                var columns = 12;
                components = (0,src_to_consumable_array/* default */.Z)(components).concat([
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-".concat(columns),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                                verticalAlign: "middle",
                                height: "100px",
                                border: "3px dashed #dbe0e7"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "alert warning m-0",
                                role: "alert",
                                children: "Add a child component to show content."
                            })
                        })
                    }, i), 
                ]);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(warningDefaultSystem, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: components
                    })
                })
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "tabs tabs-content tabs-content-vertical",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabComponent, {
            className: "",
            name: props.tabName,
            label: props.tabLabel,
            icon: props.tabIcon,
            eventKey: props.tabEventKey,
            obj: props.obj,
            pageResponse: props.pageResponse,
            expManager: props.expManager,
            children: renderTabContent()
        })
    });
};
/* harmony default export */ var TabsContentVertical_TabsContentVertical = (TabsContentVertical);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Tabs/TabsContents/TabsContentV2/TabsContentV2.tsx







var TabsContentV2 = function(props) {
    var renderTabContent = function() {
        var childsId = props.obj.children;
        if (childsId.length > 0) {
            return childsId.map(function(childId, idx) {
                var handledItem = handleObjectType(props.obj, childId, props.pageResponse, props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                    position: idx,
                    selectedInstanceId: props.obj.selectedInstanceId,
                    component: handledItem,
                    pageResponse: props.pageResponse,
                    matchOrder: props.matchOrder + 1,
                    expManager: props.expManager
                }, idx);
            });
        } else {
            return renderNoChilds();
        }
    };
    var renderNoChilds = function() {
        /**
     * render no content placeholder
     */ if (props.expManager.enable) {
            var childs = 1;
            var components = [];
            for(var i = 0; i < childs; i++){
                var columns = 12;
                components = (0,src_to_consumable_array/* default */.Z)(components).concat([
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-".concat(columns),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                                verticalAlign: "middle",
                                height: "100px",
                                border: "3px dashed #dbe0e7"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "alert warning m-0",
                                role: "alert",
                                children: "Add a child component to show content."
                            })
                        })
                    }, i), 
                ]);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(warningDefaultSystem, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: components
                    })
                })
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "tabs tabs-content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabComponent, {
            className: "",
            name: props.tabName,
            label: props.tabLabel,
            icon: props.tabIcon,
            eventKey: props.tabEventKey,
            obj: props.obj,
            pageResponse: props.pageResponse,
            expManager: props.expManager,
            children: renderTabContent()
        })
    });
};
/* harmony default export */ var TabsContentV2_TabsContentV2 = (TabsContentV2);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Tabs/TabsContents/TabsContentVerticalV2/TabsContentVerticalV2.tsx







var TabsContentVerticalV2 = function(props) {
    var renderTabContent = function() {
        var childsId = props.obj.children;
        if (childsId.length > 0) {
            return childsId.map(function(childId, idx) {
                var handledItem = handleObjectType(props.obj, childId, props.pageResponse, props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                    position: idx,
                    selectedInstanceId: props.obj.selectedInstanceId,
                    component: handledItem,
                    pageResponse: props.pageResponse,
                    matchOrder: props.matchOrder + 1,
                    expManager: props.expManager
                }, idx);
            });
        } else {
            return renderNoChilds();
        }
    };
    var renderNoChilds = function() {
        /**
     * render no content placeholder
     */ if (props.expManager.enable) {
            var childs = 1;
            var components = [];
            for(var i = 0; i < childs; i++){
                var columns = 12;
                components = (0,src_to_consumable_array/* default */.Z)(components).concat([
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-".concat(columns),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                                verticalAlign: "middle",
                                height: "100px",
                                border: "3px dashed #dbe0e7"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "alert warning m-0",
                                role: "alert",
                                children: "Add a child component to show content."
                            })
                        })
                    }, i), 
                ]);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(warningDefaultSystem, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: components
                    })
                })
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "tabs tabs-content tabs-content-vertical",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabComponent, {
            className: "",
            name: props.tabName,
            label: props.tabLabel,
            icon: props.tabIcon,
            eventKey: props.tabEventKey,
            globalStyles: props.pageResponse.globalStyles,
            obj: props.obj,
            symbols: props.symbols,
            expManager: props.expManager,
            children: renderTabContent()
        })
    });
};
/* harmony default export */ var TabsContentVerticalV2_TabsContentVerticalV2 = (TabsContentVerticalV2);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 54 modules
var esm_Modal = __webpack_require__(85079);
// EXTERNAL MODULE: ./src/stylesheets/modules/components/modal.module.sass
var modal_module = __webpack_require__(25322);
var modal_module_default = /*#__PURE__*/__webpack_require__.n(modal_module);
// EXTERNAL MODULE: ./src/stylesheets/modules/templates/cardModal.module.sass
var cardModal_module = __webpack_require__(12017);
var cardModal_module_default = /*#__PURE__*/__webpack_require__.n(cardModal_module);
;// CONCATENATED MODULE: ./src/areas/public-page/fluxio-components/Cards/CardModal/CardModal.tsx























var CardModal = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(CardModal, _Component);
    var _super = (0,_create_super/* default */.Z)(CardModal);
    function CardModal(props) {
        (0,src_class_call_check/* default */.Z)(this, CardModal);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            showModal: false,
            modalPost: undefined,
            hasChilds: _this.hasChilds(props)
        };
        _this.handleModal = _this.handleModal.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    var _proto = CardModal.prototype;
    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
        if (!this.props.obj.children && nextProps.obj.children && nextProps.obj.children.length || this.props.obj.children && nextProps.obj.children && this.props.obj.children.length !== nextProps.obj.children.length) {
            var _this = this;
            this.setState({
                hasChilds: this.hasChilds(nextProps),
                modalPost: this.handleModalFromUrl(nextProps)
            }, function() {
                if (_this.state.modalPost) _this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, _this.state), {
                    showModal: true
                }));
            });
        }
    };
    _proto.hasChilds = function hasChilds(props) {
        var childs = props.obj.children;
        return childs && childs.length;
    };
    _proto.handleModalFromUrl = function handleModalFromUrl(props) {
        if (!this.props.expManager.enable) {
            var _this = this;
            var activePost = props.obj.children.filter(function(objectId) {
                var Uri = _this.props.pageResponse.objects[objectId].uri;
                var starsWith = routeCreator_route(_this.props.matchOrder, _this.props.router);
                if (Uri && starsWith && typeof starsWith === "string") return Uri.startsWith(starsWith);
                return false;
            });
            return activePost[0];
        }
    };
    _proto.handleModal = function handleModal(post) {
        var _this = this;
        this.setState({
            showModal: !this.state.showModal,
            modalPost: post
        }, function() {
            if (!_this.props.expManager.enable) {
                if (_this.state.showModal && post) _this.props.router.push(handler(_this.props.router, _this.props.matchOrder, post.slug));
                else _this.props.router.push(handler(_this.props.router, _this.props.matchOrder, ""));
            }
        });
    };
    _proto.onMouseEnter = function onMouseEnter(e) {
        if (!e || !e.target) return;
        var container = e.target;
        var childImage = container.querySelector(".card-modal-image");
        var childTitle = container.querySelector(".title");
        var childPreview = container.querySelector(".preview");
        var childMessage = container.querySelector(".message");
        var Media1 = isBobMedia(this.props.obj.styles.bobs.media1);
        var Text1 = isBobText(this.props.obj.styles.bobs.text1);
        var Text2 = isBobText(this.props.obj.styles.bobs.text2);
        var Text3 = isBobText(this.props.obj.styles.bobs.text3);
        if (Media1.behaviour.hover.enable && childImage) childImage.classList.add("isHover");
        if (Text1.behaviour.hover.enable && childTitle) childTitle.classList.add("isHover");
        if (Text2.behaviour.hover.enable && childPreview) childPreview.classList.add("isHover");
        if (Text3.behaviour.hover.enable && childMessage) childMessage.classList.add("isHover");
    };
    _proto.onMouseLeave = function onMouseLeave(e) {
        if (!e || !e.target) return;
        var container = e.target;
        var childImage = container.querySelector(".card-modal-image");
        var childTitle = container.querySelector(".title");
        var childPreview = container.querySelector(".preview");
        var childMessage = container.querySelector(".message");
        var Media1 = isBobMedia(this.props.obj.styles.bobs.media1);
        var Text1 = isBobText(this.props.obj.styles.bobs.text1);
        var Text2 = isBobText(this.props.obj.styles.bobs.text2);
        var Text3 = isBobText(this.props.obj.styles.bobs.text3);
        if (Media1.behaviour.hover.enable && childImage) childImage.classList.remove("isHover");
        if (Text1.behaviour.hover.enable && childTitle) childTitle.classList.remove("isHover");
        if (Text2.behaviour.hover.enable && childPreview) childPreview.classList.remove("isHover");
        if (Text3.behaviour.hover.enable && childMessage) childMessage.classList.remove("isHover");
    };
    _proto.renderModalComponents = function renderModalComponents(post) {
        var _this = this;
        var componentsId = this.props.obj.children;
        if (componentsId && componentsId.length > 0) return componentsId.map(function(componentId, idx) {
            var handledItem = handleObjectType(_this.props.obj, componentId, _this.props.pageResponse, _this.props.expManager.emEditorType);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                position: idx,
                selectedInstanceId: _this.props.obj.selectedInstanceId,
                pageResponse: _this.props.pageResponse,
                matchOrder: _this.props.matchOrder,
                expManager: _this.props.expManager,
                component: handleContentBlock(handledItem, post, _this.props.obj, _this.props.pageResponse, _this.props.overrides)
            }, idx);
        });
    };
    _proto.renderModal = function renderModal() {
        var _this = this;
        var isOpen = this.state.showModal && this.state.modalPost ? true : false;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Modal/* default */.Z, {
            className: "modal-fluxio ".concat((modal_module_default())["modal-fluxio"], " ").concat((cardModal_module_default())["modal-fluxio"], " ").concat((cardModal_module_default()).card_modal_ssr, " ").concat(!this.state.hasChilds ? "isFeed ".concat((cardModal_module_default()).isFeed) : ""),
            show: isOpen,
            onHide: function() {
                return _this.handleModal;
            },
            backdropClassName: "modal-component-backdrop ".concat((cardModal_module_default()).modal_ssr_backdrop),
            size: "xl",
            enforceFocus: false,
            backdrop: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                position: this.props.position,
                pageResponse: this.props.pageResponse,
                instanceId: this.props.obj.selectedInstanceId,
                object: this.props.obj,
                objectId: this.props.obj.uuid,
                post: this.state.modalPost,
                inlineContent: this.props.obj.content.inlineContent,
                overrides: this.props.overrides,
                field: "background3",
                rules: this.props.componentRule,
                template: this.props.obj.styles,
                expManager: this.props.expManager,
                className: "modal-container",
                flexDirection: "column",
                children: this.state.modalPost ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Modal/* default.Header */.Z.Header, {
                            closeButton: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                position: this.props.position,
                                pageResponse: this.props.pageResponse,
                                instanceId: this.props.obj.selectedInstanceId,
                                object: this.props.obj,
                                objectId: this.props.obj.uuid,
                                field: "icon1",
                                template: this.props.obj.styles,
                                rules: this.props.componentRule,
                                expManager: this.props.expManager,
                                iconClassName: "fas fa-times aaa",
                                className: "modal-close",
                                onClick: this.handleModal
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Modal/* default.Body */.Z.Body, {
                            children: this.state.hasChilds ? this.renderModalComponents(this.state.modalPost) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: this.props.position,
                                        pageResponse: this.props.pageResponse,
                                        instanceId: this.props.obj.selectedInstanceId,
                                        object: this.props.obj,
                                        objectId: this.props.obj.uuid,
                                        field: "image3",
                                        template: this.props.obj.styles,
                                        rules: this.props.componentRule,
                                        expManager: this.props.expManager,
                                        network: this.state.modalPost.network,
                                        post: this.state.modalPost,
                                        className: "modal-close"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: this.props.position,
                                        pageResponse: this.props.pageResponse,
                                        instanceId: this.props.obj.selectedInstanceId,
                                        object: this.props.obj,
                                        objectId: this.props.obj.uuid,
                                        post: this.state.modalPost,
                                        inlineContent: this.props.obj.content.inlineContent,
                                        field: "text4",
                                        tag: "h1",
                                        value: getStringField(this.state.modalPost, this.props.obj, this.props.pageResponse, "text4", this.props.overrides),
                                        template: this.props.obj.styles,
                                        rules: this.props.componentRule,
                                        expManager: this.props.expManager,
                                        network: this.state.modalPost.network,
                                        className: "title"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: this.props.position,
                                        pageResponse: this.props.pageResponse,
                                        instanceId: this.props.obj.selectedInstanceId,
                                        object: this.props.obj,
                                        objectId: this.props.obj.uuid,
                                        post: this.state.modalPost,
                                        inlineContent: this.props.obj.content.inlineContent,
                                        overrides: this.props.overrides,
                                        field: "text5",
                                        tag: "p",
                                        value: getStringField(this.state.modalPost, this.props.obj, this.props.pageResponse, "text5", this.props.overrides),
                                        template: this.props.obj.styles,
                                        rules: this.props.componentRule,
                                        expManager: this.props.expManager,
                                        network: this.state.modalPost.network,
                                        className: "description"
                                    })
                                ]
                            })
                        })
                    ]
                }) : []
            })
        });
    };
    _proto.renderCards = function renderCards(content, background1TemplateMerged) {
        if (this.state.hasChilds) content = [
            content[0]
        ];
        var counter = {
            desktop: 0,
            tablet: 0,
            mobile: 0
        };
        if (content && content.length > 0) {
            var _this = this;
            return content.map(function(post, idx) {
                var _this1 = _this;
                var columns = bobHandler_handleColumns(idx, counter, background1TemplateMerged, _this.props.pageResponse.globalStyles[background1TemplateMerged.globalStyleId]);
                counter = columns.counter;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(bobComponentHandler, {
                        position: _this.props.position,
                        pageResponse: _this.props.pageResponse,
                        instanceId: _this.props.obj.selectedInstanceId,
                        object: _this.props.obj,
                        objectId: _this.props.obj.uuid,
                        post: post,
                        inlineContent: _this.props.obj.content.inlineContent,
                        overrides: _this.props.overrides,
                        field: "background2",
                        rules: _this.props.componentRule,
                        template: _this.props.obj.styles,
                        expManager: _this.props.expManager,
                        className: "card",
                        onClick: function() {
                            return _this1.handleModal(post);
                        },
                        onMouseEnter: function(e) {
                            return _this1.onMouseEnter(e);
                        },
                        onMouseLeave: function(e) {
                            return _this1.onMouseLeave(e);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                position: _this.props.position,
                                pageResponse: _this.props.pageResponse,
                                replacedMediaList: _this.props.replacedMediaList,
                                instanceId: _this.props.obj.selectedInstanceId,
                                object: _this.props.obj,
                                objectId: _this.props.obj.uuid,
                                inlineContent: _this.props.obj.content.inlineContent,
                                overrides: _this.props.overrides,
                                field: "media1",
                                template: _this.props.obj.styles,
                                rules: _this.props.componentRule,
                                expManager: _this.props.expManager,
                                network: post.network,
                                post: post,
                                className: "card-modal-image"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(bobComponentHandler, {
                                position: _this.props.position,
                                pageResponse: _this.props.pageResponse,
                                instanceId: _this.props.obj.selectedInstanceId,
                                object: _this.props.obj,
                                objectId: _this.props.obj.uuid,
                                post: post,
                                inlineContent: _this.props.obj.content.inlineContent,
                                overrides: _this.props.overrides,
                                field: "background4",
                                rules: _this.props.componentRule,
                                template: _this.props.obj.styles,
                                expManager: _this.props.expManager,
                                className: "card-body",
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: _this.props.position,
                                        pageResponse: _this.props.pageResponse,
                                        instanceId: _this.props.obj.selectedInstanceId,
                                        object: _this.props.obj,
                                        objectId: _this.props.obj.uuid,
                                        inlineContent: _this.props.obj.content.inlineContent,
                                        overrides: _this.props.overrides,
                                        field: "text1",
                                        tag: "p",
                                        value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text1", _this.props.overrides),
                                        template: _this.props.obj.styles,
                                        rules: _this.props.componentRule,
                                        expManager: _this.props.expManager,
                                        network: post.network,
                                        className: "title"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: _this.props.position,
                                        pageResponse: _this.props.pageResponse,
                                        instanceId: _this.props.obj.selectedInstanceId,
                                        object: _this.props.obj,
                                        objectId: _this.props.obj.uuid,
                                        inlineContent: _this.props.obj.content.inlineContent,
                                        overrides: _this.props.overrides,
                                        field: "text2",
                                        tag: "p",
                                        value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text2", _this.props.overrides),
                                        template: _this.props.obj.styles,
                                        rules: _this.props.componentRule,
                                        expManager: _this.props.expManager,
                                        network: post.network,
                                        className: "preview"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: _this.props.position,
                                        pageResponse: _this.props.pageResponse,
                                        instanceId: _this.props.obj.selectedInstanceId,
                                        object: _this.props.obj,
                                        objectId: _this.props.obj.uuid,
                                        inlineContent: _this.props.obj.content.inlineContent,
                                        overrides: _this.props.overrides,
                                        field: "text3",
                                        tag: "p",
                                        value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text3", _this.props.overrides),
                                        template: _this.props.obj.styles,
                                        rules: _this.props.componentRule,
                                        expManager: _this.props.expManager,
                                        network: post.network,
                                        className: "message"
                                    })
                                ]
                            })
                        ]
                    })
                }, idx);
            });
        } else {
            if (this.props.expManager.enable) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-sm-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warningSystem, {
                        alertType: "alert-secondary w-100 text-center",
                        messages: "Select a formula to show posts"
                    })
                });
            }
        }
    };
    _proto.render = function render() {
        var background1 = isBobBackground(this.props.obj.styles.bobs.background1);
        var background2 = isBobBackground(this.props.obj.styles.bobs.background2);
        /**
     * Responsive Alignment Styles
     */ var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
        var content = getContent(this.props.obj, "posts", this.props.overrides);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "cards ".concat((cards_module_default()).cards, " card-modal ").concat((cardModal_module_default())["card-modal"]),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
                    className: "row card-deck ".concat((card_module_default())["card-deck"], " ").concat((cardModal_module_default())["card-deck"], " ").concat(bobHandler_responsiveGuttersClass(background2, this.props.pageResponse.globalStyles[background2.globalStyleId])),
                    desktop: alignmentStyles,
                    tablet: tabletAlignment,
                    mobile: mobileAlignment,
                    children: this.renderCards(content, background1)
                }),
                this.renderModal()
            ]
        });
    };
    return CardModal;
}(react.Component);
/* harmony default export */ var CardModal_CardModal = ((0,router.withRouter)(CardModal));

// EXTERNAL MODULE: ./src/stylesheets/modules/templates/cardLeftRight.module.sass
var cardLeftRight_module = __webpack_require__(19417);
var cardLeftRight_module_default = /*#__PURE__*/__webpack_require__.n(cardLeftRight_module);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Cards/cardLeft/cardLeft.tsx















var CardLeft = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(CardLeft, _Component);
    var _super = (0,_create_super/* default */.Z)(CardLeft);
    function CardLeft(props) {
        (0,src_class_call_check/* default */.Z)(this, CardLeft);
        var _this;
        _this = _super.call(this, props);
        _this.child = [];
        _this.state = {
            childComponents: [],
            hasChildModal: false
        };
        return _this;
    }
    var _proto = CardLeft.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.handleWriteState(this.props);
    };
    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
        if (!this.props.obj.children && nextProps.obj.children && nextProps.obj.children.length || this.props.obj.children && nextProps.obj.children && this.props.obj.children.length !== nextProps.obj.children.length) {
            this.handleWriteState(nextProps);
        }
    };
    _proto.handleWriteState = function handleWriteState(props) {
        var componentsId = props.obj.children;
        if (componentsId && componentsId.length > 0) {
            this.setState({
                childComponents: componentsId,
                hasChildModal: hasChildOfType("modal", componentsId, props.obj, props.pageResponse, props.expManager.emEditorType)
            });
        }
    };
    /**
   *
   * @param {postIdx} idx
   * We need this idx from the post array
   * to properly call the inner function down the react tree.
   * if we dont use this we overwrite the same ref over and over
   * leaving only the reference to the last rendered object.
   */ _proto.handleCardClick = function handleCardClick(idx) {
        if (this.child && this.child[idx]) this.child[idx].handleInnerFunction();
    };
    _proto.renderComponents = function renderComponents(post, postIdx) {
        var componentsId = this.props.obj.children;
        if (componentsId && componentsId.length > 0) {
            var _this = this;
            return componentsId.map(function(componentId, idx) {
                var _this1 = _this;
                var handledItem = handleObjectType(_this.props.obj, componentId, _this.props.pageResponse, _this.props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                    position: idx,
                    selectedInstanceId: _this.props.obj.selectedInstanceId,
                    onRef: function(ref) {
                        return _this1.child[postIdx] = ref;
                    },
                    component: handleContentBlock(handledItem, post, _this.props.obj, _this.props.pageResponse, _this.props.overrides),
                    pageResponse: _this.props.pageResponse,
                    matchOrder: _this.props.matchOrder,
                    expManager: _this.props.expManager
                }, idx);
            });
        }
    };
    _proto.renderCards = function renderCards() {
        var content = getContent(this.props.obj, "posts", this.props.overrides);
        if (content && content.length > 0) {
            var _this = this;
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            var childs = this.props.obj.children;
            var hasChildModal = (childs === null || childs === void 0 ? void 0 : childs.length) > 0 && hasChildOfType("modal", childs, this.props.obj, this.props.pageResponse, this.props.expManager.emEditorType);
            return content.map(function(post, idx) {
                var _this1 = _this;
                var columns = bobHandler_handleColumns(idx, counter, _this.props.obj.styles.bobs.background1);
                var leftColumnsCard = bobHandler_handleColumns(0, {
                    desktop: 0,
                    tablet: 0,
                    mobile: 0
                }, _this.props.obj.styles.bobs.background2);
                var rightColumnsCard = bobHandler_handleColumns(1, {
                    desktop: 0,
                    tablet: 0,
                    mobile: 0
                }, _this.props.obj.styles.bobs.background2);
                var gutters = handleGutts(_this.props.obj.styles.bobs.background2, true);
                counter = columns.counter;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        position: _this.props.position,
                        pageResponse: _this.props.pageResponse,
                        instanceId: _this.props.obj.selectedInstanceId,
                        object: _this.props.obj,
                        objectId: _this.props.obj.uuid,
                        post: post,
                        inlineContent: _this.props.obj.content.inlineContent,
                        overrides: _this.props.overrides,
                        field: "background2",
                        rules: _this.props.componentRule,
                        template: _this.props.obj.styles,
                        expManager: _this.props.expManager,
                        className: "card ".concat(hasChildModal ? "is-clickable" : ""),
                        onClick: function() {
                            return _this1.handleCardClick(idx);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row ".concat(gutters, " ").concat(bobHandler_responsiveGuttersClass(_this.props.obj.styles.bobs.background2)),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-".concat(leftColumnsCard.columnsMobile, " col-md-").concat(leftColumnsCard.columnsTablet, " col-lg-").concat(leftColumnsCard.columns),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: _this.props.position,
                                        pageResponse: _this.props.pageResponse,
                                        replacedMediaList: _this.props.replacedMediaList,
                                        instanceId: _this.props.obj.selectedInstanceId,
                                        object: _this.props.obj,
                                        objectId: _this.props.obj.uuid,
                                        inlineContent: _this.props.obj.content.inlineContent,
                                        overrides: _this.props.overrides,
                                        field: "media1",
                                        template: _this.props.obj.styles,
                                        rules: _this.props.componentRule,
                                        expManager: _this.props.expManager,
                                        network: post.network,
                                        post: post
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-".concat(rightColumnsCard.columnsMobile, " col-md-").concat(rightColumnsCard.columnsTablet, " col-lg-").concat(rightColumnsCard.columns),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(bobComponentHandler, {
                                        position: _this.props.position,
                                        pageResponse: _this.props.pageResponse,
                                        instanceId: _this.props.obj.selectedInstanceId,
                                        object: _this.props.obj,
                                        objectId: _this.props.obj.uuid,
                                        post: post,
                                        inlineContent: _this.props.obj.content.inlineContent,
                                        overrides: _this.props.overrides,
                                        field: "background3",
                                        rules: _this.props.componentRule,
                                        template: _this.props.obj.styles,
                                        expManager: _this.props.expManager,
                                        className: "card-body",
                                        flexDirection: "column",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                                position: _this.props.position,
                                                pageResponse: _this.props.pageResponse,
                                                instanceId: _this.props.obj.selectedInstanceId,
                                                object: _this.props.obj,
                                                objectId: _this.props.obj.uuid,
                                                post: post,
                                                inlineContent: _this.props.obj.content.inlineContent,
                                                overrides: _this.props.overrides,
                                                field: "text1",
                                                tag: "p",
                                                value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text1", _this.props.overrides),
                                                template: _this.props.obj.styles,
                                                rules: _this.props.componentRule,
                                                expManager: _this.props.expManager,
                                                network: post.network,
                                                className: "title"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                                position: _this.props.position,
                                                pageResponse: _this.props.pageResponse,
                                                instanceId: _this.props.obj.selectedInstanceId,
                                                object: _this.props.obj,
                                                objectId: _this.props.obj.uuid,
                                                post: post,
                                                inlineContent: _this.props.obj.content.inlineContent,
                                                overrides: _this.props.overrides,
                                                field: "text2",
                                                tag: "p",
                                                value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text2", _this.props.overrides),
                                                template: _this.props.obj.styles,
                                                rules: _this.props.componentRule,
                                                expManager: _this.props.expManager,
                                                network: post.network,
                                                className: "preview"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                                position: _this.props.position,
                                                pageResponse: _this.props.pageResponse,
                                                instanceId: _this.props.obj.selectedInstanceId,
                                                object: _this.props.obj,
                                                objectId: _this.props.obj.uuid,
                                                post: post,
                                                inlineContent: _this.props.obj.content.inlineContent,
                                                overrides: _this.props.overrides,
                                                field: "text3",
                                                tag: "p",
                                                value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text3", _this.props.overrides),
                                                template: _this.props.obj.styles,
                                                rules: _this.props.componentRule,
                                                expManager: _this.props.expManager,
                                                network: post.network,
                                                className: "message"
                                            }),
                                            _this.renderComponents(post, idx)
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                }, idx);
            });
        } else {
            if (this.props.expManager.enable) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-sm-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warningSystem, {
                        alertType: "alert-secondary w-100 text-center",
                        messages: "Select a formula to show posts"
                    })
                });
            }
        }
    };
    _proto.render = function render() {
        var background1 = this.props.obj.styles.bobs.background1;
        var gutters = handleGutts(background1, false);
        /**
     * Responsive Alignment Styles
     */ var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "cards ".concat((cards_module_default()).cards, " card-left ").concat((cardLeftRight_module_default())["card-left"]),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
                className: "card-deck ".concat((card_module_default())["card-deck"], " row ").concat(gutters, " ").concat(bobHandler_responsiveGuttersClass(this.props.obj.styles.bobs.background1)),
                desktop: alignmentStyles,
                tablet: tabletAlignment,
                mobile: mobileAlignment,
                children: this.renderCards()
            })
        });
    };
    return CardLeft;
}(react.Component);
/* harmony default export */ var cardLeft = (CardLeft);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Cards/cardLeftV2/cardLeftV2.tsx
















var CardLeftV2 = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CardLeftV2, _PureComponent);
    var _super = (0,_create_super/* default */.Z)(CardLeftV2);
    function CardLeftV2() {
        (0,src_class_call_check/* default */.Z)(this, CardLeftV2);
        var _this;
        _this = _super.apply(this, arguments);
        _this.child = [];
        return _this;
    }
    var _proto = CardLeftV2.prototype;
    /**
   *
   * @param {postIdx} idx
   * We need this idx from the post array
   * to properly call the inner function down the react tree.
   * if we dont use this we overwrite the same ref over and over
   * leaving only the reference to the last rendered object.
   */ _proto.handleCardClick = function handleCardClick(idx) {
        if (this.child && this.child[idx]) {
            //@ts-ignore
            this.child[idx].handleInnerFunction();
        }
    };
    _proto.renderComponents = function renderComponents(post, postIdx) {
        var componentsId = this.props.obj.children;
        if (componentsId && componentsId.length > 0) {
            var _this = this;
            return componentsId.map(function(componentId, idx) {
                var _this1 = _this;
                var handledItem = handleObjectType(_this.props.obj, componentId, _this.props.pageResponse, _this.props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                    position: idx,
                    selectedInstanceId: _this.props.obj.selectedInstanceId,
                    onRef: function(ref) {
                        return _this1.child[postIdx] = ref;
                    },
                    component: handleContentBlock(handledItem, post, _this.props.obj, _this.props.pageResponse, _this.props.overrides),
                    pageResponse: _this.props.pageResponse,
                    matchOrder: _this.props.matchOrder,
                    expManager: _this.props.expManager
                }, idx);
            });
        }
    };
    _proto.renderCards = function renderCards(background1) {
        var content = getContent(this.props.obj, "posts", this.props.overrides);
        if (content && content.length > 0) {
            var _this = this;
            var background2 = this.props.obj.styles.bobs.background2;
            var ref = alignment(background2), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            var childs = this.props.obj.children;
            var hasChildModal = childs.length > 0 && hasChildOfType("modal", childs, this.props.obj, this.props.pageResponse, this.props.expManager.emEditorType);
            return content.map(function(post, idx) {
                var _this1 = _this;
                var columns = bobHandler_handleColumns(idx, counter, background1, _this.props.pageResponse.globalStyles[background1.globalStyleId]);
                var leftColumnsCard = bobHandler_handleColumns(0, {
                    desktop: 0,
                    tablet: 0,
                    mobile: 0
                }, background2, _this.props.pageResponse.globalStyles[background2.globalStyleId]);
                var rightColumnsCard = bobHandler_handleColumns(1, {
                    desktop: 0,
                    tablet: 0,
                    mobile: 0
                }, background2, _this.props.pageResponse.globalStyles[background2.globalStyleId]);
                counter = columns.counter;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        position: _this.props.position,
                        pageResponse: _this.props.pageResponse,
                        instanceId: _this.props.obj.selectedInstanceId,
                        object: _this.props.obj,
                        objectId: _this.props.obj.uuid,
                        post: post,
                        inlineContent: _this.props.obj.content.inlineContent,
                        overrides: _this.props.overrides,
                        field: "background2",
                        rules: _this.props.componentRule,
                        template: _this.props.obj.styles,
                        expManager: _this.props.expManager,
                        className: "card ".concat(hasChildModal ? "is-clickable" : ""),
                        onClick: function() {
                            return _this1.handleCardClick(idx);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(alignmentHOC, {
                            className: "row ".concat(bobHandler_responsiveGuttersClass(background2, _this.props.pageResponse.globalStyles[background2.globalStyleId], true)),
                            desktop: alignmentStyles,
                            tablet: tabletAlignment,
                            mobile: mobileAlignment,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-".concat(leftColumnsCard.columnsMobile, " col-md-").concat(leftColumnsCard.columnsTablet, " col-lg-").concat(leftColumnsCard.columns),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: _this.props.position,
                                        pageResponse: _this.props.pageResponse,
                                        replacedMediaList: _this.props.replacedMediaList,
                                        instanceId: _this.props.obj.selectedInstanceId,
                                        object: _this.props.obj,
                                        objectId: _this.props.obj.uuid,
                                        inlineContent: _this.props.obj.content.inlineContent,
                                        overrides: _this.props.overrides,
                                        field: "media1",
                                        template: _this.props.obj.styles,
                                        rules: _this.props.componentRule,
                                        expManager: _this.props.expManager,
                                        network: post.network,
                                        post: post
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-".concat(rightColumnsCard.columnsMobile, " col-md-").concat(rightColumnsCard.columnsTablet, " col-lg-").concat(rightColumnsCard.columns),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(bobComponentHandler, {
                                        position: _this.props.position,
                                        pageResponse: _this.props.pageResponse,
                                        instanceId: _this.props.obj.selectedInstanceId,
                                        object: _this.props.obj,
                                        objectId: _this.props.obj.uuid,
                                        post: post,
                                        inlineContent: _this.props.obj.content.inlineContent,
                                        overrides: _this.props.overrides,
                                        field: "background3",
                                        rules: _this.props.componentRule,
                                        template: _this.props.obj.styles,
                                        expManager: _this.props.expManager,
                                        className: "card-body",
                                        flexDirection: "column",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                                position: _this.props.position,
                                                pageResponse: _this.props.pageResponse,
                                                instanceId: _this.props.obj.selectedInstanceId,
                                                object: _this.props.obj,
                                                objectId: _this.props.obj.uuid,
                                                post: post,
                                                inlineContent: _this.props.obj.content.inlineContent,
                                                overrides: _this.props.overrides,
                                                field: "text1",
                                                tag: "p",
                                                value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text1", _this.props.overrides),
                                                template: _this.props.obj.styles,
                                                rules: _this.props.componentRule,
                                                expManager: _this.props.expManager,
                                                network: post.network,
                                                className: "title"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                                position: _this.props.position,
                                                pageResponse: _this.props.pageResponse,
                                                instanceId: _this.props.obj.selectedInstanceId,
                                                object: _this.props.obj,
                                                objectId: _this.props.obj.uuid,
                                                post: post,
                                                inlineContent: _this.props.obj.content.inlineContent,
                                                overrides: _this.props.overrides,
                                                field: "text2",
                                                tag: "p",
                                                value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text2", _this.props.overrides),
                                                template: _this.props.obj.styles,
                                                rules: _this.props.componentRule,
                                                expManager: _this.props.expManager,
                                                network: post.network,
                                                className: "preview"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                                position: _this.props.position,
                                                pageResponse: _this.props.pageResponse,
                                                instanceId: _this.props.obj.selectedInstanceId,
                                                object: _this.props.obj,
                                                objectId: _this.props.obj.uuid,
                                                post: post,
                                                inlineContent: _this.props.obj.content.inlineContent,
                                                overrides: _this.props.overrides,
                                                field: "text3",
                                                tag: "p",
                                                value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text3", _this.props.overrides),
                                                template: _this.props.obj.styles,
                                                rules: _this.props.componentRule,
                                                expManager: _this.props.expManager,
                                                network: post.network,
                                                className: "message"
                                            }),
                                            _this.renderComponents(post, idx)
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                }, idx);
            });
        } else {
            if (this.props.expManager.enable) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-sm-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warningSystem, {
                        alertType: "alert-secondary w-100 text-center",
                        messages: "Select a formula to show posts"
                    })
                });
            }
        }
    };
    _proto.render = function render() {
        var background1 = isBobBackground(this.props.obj.styles.bobs.background1);
        /**
     * Responsive Alignment Styles
     */ var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "cards ".concat((cards_module_default()).cards, " card-left ").concat((cardLeftRight_module_default())["card-left"]),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
                className: "card-deck ".concat((card_module_default())["card-deck"], " row ").concat(bobHandler_responsiveGuttersClass(background1, this.props.pageResponse.globalStyles[background1.globalStyleId])),
                desktop: alignmentStyles,
                tablet: tabletAlignment,
                mobile: mobileAlignment,
                children: this.renderCards(background1)
            })
        });
    };
    return CardLeftV2;
}(react.PureComponent);
/* harmony default export */ var cardLeftV2 = (CardLeftV2);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Cards/cardRight/cardRight.tsx















var CardRight = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(CardRight, _Component);
    var _super = (0,_create_super/* default */.Z)(CardRight);
    function CardRight(props) {
        (0,src_class_call_check/* default */.Z)(this, CardRight);
        var _this;
        _this = _super.call(this, props);
        _this.child = [];
        _this.state = {
            childComponents: [],
            hasChildModal: false
        };
        return _this;
    }
    var _proto = CardRight.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.handleWriteState(this.props);
    };
    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
        if (!this.props.obj.children && nextProps.obj.children && nextProps.obj.children.length || this.props.obj.children && nextProps.obj.children && this.props.obj.children.length !== nextProps.obj.children.length) {
            this.handleWriteState(nextProps);
        }
    };
    _proto.handleWriteState = function handleWriteState(props) {
        var componentsId = props.obj.children;
        if (componentsId && componentsId.length > 0) {
            this.setState({
                childComponents: componentsId,
                hasChildModal: hasChildOfType("modal", componentsId, props.obj, props.pageResponse, props.expManager.emEditorType)
            });
        }
    };
    /**
   *
   * @param {postIdx} idx
   * We need this idx from the post array
   * to properly call the inner function down the react tree.
   * if we dont use this we overwrite the same ref over and over
   * leaving only the reference to the last rendered object.
   */ _proto.handleCardClick = function handleCardClick(idx) {
        if (this.child && this.child[idx]) {
            //@ts-ignore
            this.child[idx].handleInnerFunction();
        }
    };
    _proto.renderComponents = function renderComponents(post, postIdx) {
        var componentsId = this.props.obj.children;
        if (componentsId && componentsId.length > 0) {
            var _this = this;
            return componentsId.map(function(componentId, idx) {
                var _this1 = _this;
                var handledItem = handleObjectType(_this.props.obj, componentId, _this.props.pageResponse, _this.props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                    position: idx,
                    selectedInstanceId: _this.props.obj.selectedInstanceId,
                    onRef: function(ref) {
                        return _this1.child[postIdx] = ref;
                    },
                    component: handleContentBlock(handledItem, post, _this.props.obj, _this.props.pageResponse, _this.props.overrides),
                    pageResponse: _this.props.pageResponse,
                    matchOrder: _this.props.matchOrder,
                    expManager: _this.props.expManager
                }, idx);
            });
        }
    };
    _proto.renderCards = function renderCards() {
        var content = getContent(this.props.obj, "posts", this.props.overrides);
        if (content && content.length > 0) {
            var _this = this;
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            var childs = this.props.obj.children;
            var hasChildModal = childs.length > 0 && hasChildOfType("modal", childs, this.props.obj, this.props.pageResponse, this.props.expManager.emEditorType);
            return content.map(function(post, idx) {
                var _this1 = _this;
                var columns = bobHandler_handleColumns(idx, counter, _this.props.obj.styles.bobs.background1);
                var leftColumnsCard = bobHandler_handleColumns(0, {
                    desktop: 0,
                    tablet: 0,
                    mobile: 0
                }, _this.props.obj.styles.bobs.background2);
                var rightColumnsCard = bobHandler_handleColumns(1, {
                    desktop: 0,
                    tablet: 0,
                    mobile: 0
                }, _this.props.obj.styles.bobs.background2);
                var gutters = handleGutts(_this.props.obj.styles.bobs.background2, true);
                counter = columns.counter;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        position: _this.props.position,
                        pageResponse: _this.props.pageResponse,
                        instanceId: _this.props.obj.selectedInstanceId,
                        object: _this.props.obj,
                        objectId: _this.props.obj.uuid,
                        post: post,
                        inlineContent: _this.props.obj.content.inlineContent,
                        overrides: _this.props.overrides,
                        field: "background2",
                        rules: _this.props.componentRule,
                        template: _this.props.obj.styles,
                        expManager: _this.props.expManager,
                        className: "card ".concat(hasChildModal ? "is-clickable" : ""),
                        onClick: function() {
                            return _this1.handleCardClick(idx);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row ".concat(gutters, " ").concat(bobHandler_responsiveGuttersClass(_this.props.obj.styles.bobs.background2)),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-".concat(rightColumnsCard.columnsMobile, " col-md-").concat(rightColumnsCard.columnsTablet, " col-lg-").concat(rightColumnsCard.columns),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(bobComponentHandler, {
                                        position: _this.props.position,
                                        pageResponse: _this.props.pageResponse,
                                        instanceId: _this.props.obj.selectedInstanceId,
                                        object: _this.props.obj,
                                        objectId: _this.props.obj.uuid,
                                        post: post,
                                        inlineContent: _this.props.obj.content.inlineContent,
                                        overrides: _this.props.overrides,
                                        field: "background3",
                                        rules: _this.props.componentRule,
                                        template: _this.props.obj.styles,
                                        expManager: _this.props.expManager,
                                        className: "card-body",
                                        flexDirection: "column",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                                position: _this.props.position,
                                                pageResponse: _this.props.pageResponse,
                                                instanceId: _this.props.obj.selectedInstanceId,
                                                object: _this.props.obj,
                                                objectId: _this.props.obj.uuid,
                                                post: post,
                                                inlineContent: _this.props.obj.content.inlineContent,
                                                overrides: _this.props.overrides,
                                                field: "text1",
                                                tag: "p",
                                                value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text1", _this.props.overrides),
                                                template: _this.props.obj.styles,
                                                rules: _this.props.componentRule,
                                                expManager: _this.props.expManager,
                                                network: post.network,
                                                className: "title"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                                position: _this.props.position,
                                                pageResponse: _this.props.pageResponse,
                                                instanceId: _this.props.obj.selectedInstanceId,
                                                object: _this.props.obj,
                                                objectId: _this.props.obj.uuid,
                                                post: post,
                                                inlineContent: _this.props.obj.content.inlineContent,
                                                overrides: _this.props.overrides,
                                                field: "text2",
                                                tag: "p",
                                                value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text2", _this.props.overrides),
                                                template: _this.props.obj.styles,
                                                rules: _this.props.componentRule,
                                                expManager: _this.props.expManager,
                                                network: post.network,
                                                className: "preview"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                                position: _this.props.position,
                                                pageResponse: _this.props.pageResponse,
                                                instanceId: _this.props.obj.selectedInstanceId,
                                                object: _this.props.obj,
                                                objectId: _this.props.obj.uuid,
                                                post: post,
                                                inlineContent: _this.props.obj.content.inlineContent,
                                                overrides: _this.props.overrides,
                                                field: "text3",
                                                tag: "p",
                                                value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text3", _this.props.overrides),
                                                template: _this.props.obj.styles,
                                                rules: _this.props.componentRule,
                                                expManager: _this.props.expManager,
                                                network: post.network,
                                                className: "message"
                                            }),
                                            _this.renderComponents(post, idx)
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-".concat(leftColumnsCard.columnsMobile, " col-md-").concat(leftColumnsCard.columnsTablet, " col-lg-").concat(leftColumnsCard.columns),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: _this.props.position,
                                        pageResponse: _this.props.pageResponse,
                                        replacedMediaList: _this.props.replacedMediaList,
                                        instanceId: _this.props.obj.selectedInstanceId,
                                        object: _this.props.obj,
                                        objectId: _this.props.obj.uuid,
                                        inlineContent: _this.props.obj.content.inlineContent,
                                        overrides: _this.props.overrides,
                                        field: "media1",
                                        template: _this.props.obj.styles,
                                        rules: _this.props.componentRule,
                                        expManager: _this.props.expManager,
                                        network: post.network,
                                        post: post
                                    })
                                })
                            ]
                        })
                    })
                }, idx);
            });
        } else {
            if (this.props.expManager.enable) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-sm-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warningSystem, {
                        alertType: "alert-secondary w-100 text-center",
                        messages: "Select a formula to show posts"
                    })
                });
            }
        }
    };
    _proto.render = function render() {
        var background1 = this.props.obj.styles.bobs.background1;
        /**
     * Responsive Alignment Styles
     */ var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
        var gutters = handleGutts(background1, false);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "cards ".concat((cards_module_default()).cards, " card-right ").concat((cardLeftRight_module_default())["card-right"]),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
                className: "card-deck ".concat((card_module_default())["card-deck"], " row ").concat(gutters, " ").concat(bobHandler_responsiveGuttersClass(background1)),
                desktop: alignmentStyles,
                tablet: tabletAlignment,
                mobile: mobileAlignment,
                children: this.renderCards()
            })
        });
    };
    return CardRight;
}(react.Component);
/* harmony default export */ var cardRight = (CardRight);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Cards/cardRightV2/cardRightV2.tsx
















var CardRightV2 = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(CardRightV2, _Component);
    var _super = (0,_create_super/* default */.Z)(CardRightV2);
    function CardRightV2(props) {
        (0,src_class_call_check/* default */.Z)(this, CardRightV2);
        var _this;
        _this = _super.call(this, props);
        _this.child = [];
        _this.state = {
            childComponents: [],
            hasChildModal: false
        };
        return _this;
    }
    var _proto = CardRightV2.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.handleWriteState(this.props);
    };
    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
        if (!this.props.obj.children && nextProps.obj.children && nextProps.obj.children.length || this.props.obj.children && nextProps.obj.children && this.props.obj.children.length !== nextProps.obj.children.length) {
            this.handleWriteState(nextProps);
        }
    };
    _proto.handleWriteState = function handleWriteState(props) {
        var componentsId = props.obj.children;
        if (componentsId && componentsId.length > 0) {
            this.setState({
                childComponents: componentsId,
                hasChildModal: hasChildOfType("modal", componentsId, props.obj, props.pageResponse, props.expManager.emEditorType)
            });
        }
    };
    /**
   *
   * @param {postIdx} idx
   * We need this idx from the post array
   * to properly call the inner function down the react tree.
   * if we dont use this we overwrite the same ref over and over
   * leaving only the reference to the last rendered object.
   */ _proto.handleCardClick = function handleCardClick(idx) {
        if (this.child && this.child[idx]) {
            //@ts-ignore
            this.child[idx].handleInnerFunction();
        }
    };
    _proto.renderComponents = function renderComponents(post, postIdx) {
        var componentsId = this.props.obj.children;
        if (componentsId && componentsId.length > 0) {
            var _this = this;
            return componentsId.map(function(componentId, idx) {
                var _this1 = _this;
                var handledItem = handleObjectType(_this.props.obj, componentId, _this.props.pageResponse, _this.props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                    position: idx,
                    selectedInstanceId: _this.props.obj.selectedInstanceId,
                    onRef: function(ref) {
                        return _this1.child[postIdx] = ref;
                    },
                    component: handleContentBlock(handledItem, post, _this.props.obj, _this.props.pageResponse, _this.props.overrides),
                    pageResponse: _this.props.pageResponse,
                    matchOrder: _this.props.matchOrder,
                    expManager: _this.props.expManager
                }, idx);
            });
        }
    };
    _proto.renderCards = function renderCards(background1) {
        var content = getContent(this.props.obj, "posts", this.props.overrides);
        if (content && content.length > 0) {
            var _this = this;
            var background2 = this.props.obj.styles.bobs.background2;
            var ref = alignment(background2), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            var childs = this.props.obj.children;
            var hasChildModal = childs.length > 0 && hasChildOfType("modal", childs, this.props.obj, this.props.pageResponse, this.props.expManager.emEditorType);
            return content.map(function(post, idx) {
                var _this1 = _this;
                var columns = bobHandler_handleColumns(idx, counter, background1, _this.props.pageResponse.globalStyles[background1.globalStyleId]);
                var leftColumnsCard = bobHandler_handleColumns(0, {
                    desktop: 0,
                    tablet: 0,
                    mobile: 0
                }, background2, _this.props.pageResponse.globalStyles[background2.globalStyleId]);
                var rightColumnsCard = bobHandler_handleColumns(1, {
                    desktop: 0,
                    tablet: 0,
                    mobile: 0
                }, background2, _this.props.pageResponse.globalStyles[background2.globalStyleId]);
                counter = columns.counter;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        position: _this.props.position,
                        pageResponse: _this.props.pageResponse,
                        instanceId: _this.props.obj.selectedInstanceId,
                        object: _this.props.obj,
                        objectId: _this.props.obj.uuid,
                        post: post,
                        inlineContent: _this.props.obj.content.inlineContent,
                        overrides: _this.props.overrides,
                        field: "background2",
                        rules: _this.props.componentRule,
                        template: _this.props.obj.styles,
                        expManager: _this.props.expManager,
                        className: "card ".concat(hasChildModal ? "is-clickable" : ""),
                        onClick: function() {
                            return _this1.handleCardClick(idx);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(alignmentHOC, {
                            className: "row ".concat(bobHandler_responsiveGuttersClass(background2, _this.props.pageResponse.globalStyles[background2.globalStyleId], true)),
                            desktop: alignmentStyles,
                            tablet: tabletAlignment,
                            mobile: mobileAlignment,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-".concat(leftColumnsCard.columnsMobile, " col-md-").concat(leftColumnsCard.columnsTablet, " col-lg-").concat(leftColumnsCard.columns),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(bobComponentHandler, {
                                        position: _this.props.position,
                                        pageResponse: _this.props.pageResponse,
                                        instanceId: _this.props.obj.selectedInstanceId,
                                        object: _this.props.obj,
                                        objectId: _this.props.obj.uuid,
                                        post: post,
                                        inlineContent: _this.props.obj.content.inlineContent,
                                        overrides: _this.props.overrides,
                                        field: "background3",
                                        rules: _this.props.componentRule,
                                        template: _this.props.obj.styles,
                                        expManager: _this.props.expManager,
                                        className: "card-body",
                                        flexDirection: "column",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                                position: _this.props.position,
                                                pageResponse: _this.props.pageResponse,
                                                instanceId: _this.props.obj.selectedInstanceId,
                                                object: _this.props.obj,
                                                objectId: _this.props.obj.uuid,
                                                post: post,
                                                inlineContent: _this.props.obj.content.inlineContent,
                                                overrides: _this.props.overrides,
                                                field: "text1",
                                                tag: "p",
                                                value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text1", _this.props.overrides),
                                                template: _this.props.obj.styles,
                                                rules: _this.props.componentRule,
                                                expManager: _this.props.expManager,
                                                network: post.network,
                                                className: "title"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                                position: _this.props.position,
                                                pageResponse: _this.props.pageResponse,
                                                instanceId: _this.props.obj.selectedInstanceId,
                                                object: _this.props.obj,
                                                objectId: _this.props.obj.uuid,
                                                post: post,
                                                inlineContent: _this.props.obj.content.inlineContent,
                                                overrides: _this.props.overrides,
                                                field: "text2",
                                                tag: "p",
                                                value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text2", _this.props.overrides),
                                                template: _this.props.obj.styles,
                                                rules: _this.props.componentRule,
                                                expManager: _this.props.expManager,
                                                network: post.network,
                                                className: "preview"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                                position: _this.props.position,
                                                pageResponse: _this.props.pageResponse,
                                                instanceId: _this.props.obj.selectedInstanceId,
                                                object: _this.props.obj,
                                                objectId: _this.props.obj.uuid,
                                                post: post,
                                                inlineContent: _this.props.obj.content.inlineContent,
                                                overrides: _this.props.overrides,
                                                field: "text3",
                                                tag: "p",
                                                value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text3", _this.props.overrides),
                                                template: _this.props.obj.styles,
                                                rules: _this.props.componentRule,
                                                expManager: _this.props.expManager,
                                                network: post.network,
                                                className: "message"
                                            }),
                                            _this.renderComponents(post, idx)
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-".concat(rightColumnsCard.columnsMobile, " col-md-").concat(rightColumnsCard.columnsTablet, " col-lg-").concat(rightColumnsCard.columns),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: _this.props.position,
                                        pageResponse: _this.props.pageResponse,
                                        replacedMediaList: _this.props.replacedMediaList,
                                        instanceId: _this.props.obj.selectedInstanceId,
                                        object: _this.props.obj,
                                        objectId: _this.props.obj.uuid,
                                        inlineContent: _this.props.obj.content.inlineContent,
                                        overrides: _this.props.overrides,
                                        field: "media1",
                                        template: _this.props.obj.styles,
                                        rules: _this.props.componentRule,
                                        expManager: _this.props.expManager,
                                        network: post.network,
                                        post: post
                                    })
                                })
                            ]
                        })
                    })
                }, idx);
            });
        } else {
            if (this.props.expManager.enable) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-sm-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warningSystem, {
                        alertType: "alert-secondary w-100 text-center",
                        messages: "Select a formula to show posts"
                    })
                });
            }
        }
    };
    _proto.render = function render() {
        var background1 = isBobBackground(this.props.obj.styles.bobs.background1);
        /**
     * Responsive Alignment Styles
     */ var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "cards ".concat((cards_module_default()).cards, " card-right ").concat((cardLeftRight_module_default())["card-right"]),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
                className: "card-deck ".concat((card_module_default())["card-deck"], " row ").concat(bobHandler_responsiveGuttersClass(background1)),
                desktop: alignmentStyles,
                tablet: tabletAlignment,
                mobile: mobileAlignment,
                children: this.renderCards(background1)
            })
        });
    };
    return CardRightV2;
}(react.Component);
/* harmony default export */ var cardRightV2 = (CardRightV2);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Cards/cardTop/cardTop.tsx















var CardTop = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(CardTop, _Component);
    var _super = (0,_create_super/* default */.Z)(CardTop);
    function CardTop(props) {
        (0,src_class_call_check/* default */.Z)(this, CardTop);
        var _this;
        _this = _super.call(this, props);
        _this.child = [];
        _this.state = {
            childComponents: [],
            hasChildModal: false
        };
        return _this;
    }
    var _proto = CardTop.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.handleWriteState(this.props);
    };
    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
        if (!this.props.obj.children && nextProps.obj.children && nextProps.obj.children.length || this.props.obj.children && nextProps.obj.children && this.props.obj.children.length !== nextProps.obj.children.length) {
            this.handleWriteState(nextProps);
        }
    };
    _proto.handleWriteState = function handleWriteState(props) {
        var componentsId = props.obj.children;
        if (componentsId && componentsId.length > 0) {
            this.setState({
                childComponents: componentsId,
                hasChildModal: hasChildOfType("modal", componentsId, props.obj, props.pageResponse, props.expManager.emEditorType)
            });
        }
    };
    /**
   *
   * @param {postIdx} idx
   * We need this idx from the post array
   * to properly call the inner function down the react tree.
   * if we dont use this we overwrite the same ref over and over
   * leaving only the reference to the last rendered object.
   */ _proto.handleCardClick = function handleCardClick(idx) {
        if (this.child && this.child[idx]) {
            //@ts-ignore
            this.child[idx].handleInnerFunction();
        }
    };
    _proto.renderComponents = function renderComponents(post, postIdx) {
        var componentsId = this.props.obj.children;
        if (componentsId && componentsId.length > 0) {
            var _this = this;
            return componentsId.map(function(componentId, idx) {
                var _this1 = _this;
                var handledItem = handleObjectType(_this.props.obj, componentId, _this.props.pageResponse, _this.props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                    position: idx,
                    selectedInstanceId: _this.props.obj.selectedInstanceId,
                    onRef: function(ref) {
                        return _this1.child[postIdx] = ref;
                    },
                    component: handleContentBlock(handledItem, post, _this.props.obj, _this.props.pageResponse, _this.props.overrides),
                    pageResponse: _this.props.pageResponse,
                    matchOrder: _this.props.matchOrder,
                    expManager: _this.props.expManager
                }, idx);
            });
        }
    };
    _proto.renderCards = function renderCards(background1) {
        var content = getContent(this.props.obj, "posts", this.props.overrides);
        if (content && content.length > 0) {
            var _this = this;
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            var childs = this.props.obj.children;
            var hasChildModal = childs.length > 0 && hasChildOfType("modal", childs, this.props.obj, this.props.pageResponse, this.props.expManager.emEditorType);
            return content.map(function(post, idx) {
                var _this1 = _this;
                var columns = bobHandler_handleColumns(idx, counter, background1, _this.props.pageResponse.globalStyles[background1.globalStyleId]);
                counter = columns.counter;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(bobComponentHandler, {
                        position: _this.props.position,
                        pageResponse: _this.props.pageResponse,
                        instanceId: _this.props.obj.selectedInstanceId,
                        object: _this.props.obj,
                        objectId: _this.props.obj.uuid,
                        post: post,
                        inlineContent: _this.props.obj.content.inlineContent,
                        overrides: _this.props.overrides,
                        field: "background2",
                        rules: _this.props.componentRule,
                        template: _this.props.obj.styles,
                        expManager: _this.props.expManager,
                        className: "card ".concat(hasChildModal ? "is-clickable" : ""),
                        onClick: function() {
                            return _this1.handleCardClick(idx);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                position: _this.props.position,
                                pageResponse: _this.props.pageResponse,
                                replacedMediaList: _this.props.replacedMediaList,
                                instanceId: _this.props.obj.selectedInstanceId,
                                object: _this.props.obj,
                                objectId: _this.props.obj.uuid,
                                inlineContent: _this.props.obj.content.inlineContent,
                                overrides: _this.props.overrides,
                                field: "media1",
                                template: _this.props.obj.styles,
                                rules: _this.props.componentRule,
                                expManager: _this.props.expManager,
                                network: post.network,
                                post: post
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(bobComponentHandler, {
                                position: _this.props.position,
                                pageResponse: _this.props.pageResponse,
                                instanceId: _this.props.obj.selectedInstanceId,
                                object: _this.props.obj,
                                objectId: _this.props.obj.uuid,
                                post: post,
                                inlineContent: _this.props.obj.content.inlineContent,
                                overrides: _this.props.overrides,
                                field: "background3",
                                rules: _this.props.componentRule,
                                template: _this.props.obj.styles,
                                expManager: _this.props.expManager,
                                className: "card-body",
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: _this.props.position,
                                        pageResponse: _this.props.pageResponse,
                                        instanceId: _this.props.obj.selectedInstanceId,
                                        object: _this.props.obj,
                                        objectId: _this.props.obj.uuid,
                                        post: post,
                                        inlineContent: _this.props.obj.content.inlineContent,
                                        overrides: _this.props.overrides,
                                        field: "text1",
                                        tag: "p",
                                        value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text1", _this.props.overrides),
                                        template: _this.props.obj.styles,
                                        rules: _this.props.componentRule,
                                        expManager: _this.props.expManager,
                                        network: post.network,
                                        className: "title"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: _this.props.position,
                                        pageResponse: _this.props.pageResponse,
                                        instanceId: _this.props.obj.selectedInstanceId,
                                        object: _this.props.obj,
                                        objectId: _this.props.obj.uuid,
                                        post: post,
                                        inlineContent: _this.props.obj.content.inlineContent,
                                        overrides: _this.props.overrides,
                                        field: "text2",
                                        tag: "p",
                                        value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text2", _this.props.overrides),
                                        template: _this.props.obj.styles,
                                        rules: _this.props.componentRule,
                                        expManager: _this.props.expManager,
                                        network: post.network,
                                        className: "preview"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: _this.props.position,
                                        pageResponse: _this.props.pageResponse,
                                        instanceId: _this.props.obj.selectedInstanceId,
                                        object: _this.props.obj,
                                        objectId: _this.props.obj.uuid,
                                        post: post,
                                        inlineContent: _this.props.obj.content.inlineContent,
                                        overrides: _this.props.overrides,
                                        field: "text3",
                                        tag: "p",
                                        value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text3", _this.props.overrides),
                                        template: _this.props.obj.styles,
                                        rules: _this.props.componentRule,
                                        expManager: _this.props.expManager,
                                        network: post.network,
                                        className: "message"
                                    }),
                                    _this.renderComponents(post, idx)
                                ]
                            })
                        ]
                    })
                }, idx);
            });
        } else {
            if (this.props.expManager.enable) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-sm-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warningSystem, {
                        alertType: "alert-secondary w-100 text-center",
                        messages: "Select a formula to show posts"
                    })
                });
            }
        }
    };
    _proto.render = function render() {
        var background1 = isBobBackground(this.props.obj.styles.bobs.background1);
        /**
     * Responsive Alignment Styles
     */ var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "cards ".concat((cards_module_default()).cards, " card-top"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
                className: "card-deck ".concat((card_module_default())["card-deck"], " row ").concat(bobHandler_responsiveGuttersClass(background1, this.props.pageResponse.globalStyles[background1.globalStyleId])),
                desktop: alignmentStyles,
                tablet: tabletAlignment,
                mobile: mobileAlignment,
                children: this.renderCards(background1)
            })
        });
    };
    return CardTop;
}(react.Component);
/* harmony default export */ var cardTop = (CardTop);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Structure/gridContainer/gridContainer.tsx










var GridContainer = function(props) {
    var renderChildComponents = function(childComponentsId) {
        var counter = {
            desktop: 0,
            tablet: 0,
            mobile: 0
        };
        return childComponentsId.map(function(item, idx) {
            var handledItem = handleObjectType(props.obj, item, props.pageResponse, props.expManager.emEditorType);
            var columns = bobHandler_handleColumns(idx, counter, props.obj.styles.bobs.background1);
            counter = columns.counter;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                    position: idx,
                    selectedInstanceId: props.obj.selectedInstanceId,
                    component: handledItem,
                    pageResponse: props.pageResponse,
                    matchOrder: props.matchOrder,
                    expManager: props.expManager
                })
            }, idx);
        });
    };
    var renderContent = function() {
        var background1 = props.obj.styles.bobs.background1;
        var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
        var childComponentsId = props.obj.children;
        var gutters = handleGutts(props.obj.styles.bobs.background1, false);
        if (childComponentsId && childComponentsId.length > 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
                className: "row ".concat(gutters, " ").concat(bobHandler_responsiveGuttersClass(props.obj.styles.bobs.background1)),
                desktop: alignmentStyles,
                tablet: tabletAlignment,
                mobile: mobileAlignment,
                children: renderChildComponents(childComponentsId)
            });
        } else {
            var ref1;
            /**
       * render no content placeholder
       */ if ((ref1 = props.expManager) === null || ref1 === void 0 ? void 0 : ref1.enable) {
                var counter = {
                    desktop: 0,
                    tablet: 0,
                    mobile: 0
                };
                var Background1 = isBobBackground(props.obj.styles.bobs.background1);
                var childs = Background1.grid.columns && Background1.grid.columns.length;
                var components = [];
                for(var i = 0; i < childs; i++){
                    var columns = bobHandler_handleColumns(i, counter, Background1);
                    counter = columns.counter;
                    components = (0,src_to_consumable_array/* default */.Z)(components).concat([
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    width: "100%",
                                    height: "".concat(Background1.height.enable ? Background1.height.value : "100").concat(Background1.height.enable ? Background1.height.unit : "px"),
                                    border: "3px dashed #dbe0e7"
                                }
                            })
                        }, i), 
                    ]);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(warningDefaultSystem, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row ".concat(gutters, " ").concat(bobHandler_responsiveGuttersClass(props.obj.styles.bobs.background1)),
                        style: alignmentStyles,
                        children: components
                    })
                });
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "containers grid-container-component",
        children: renderContent()
    });
};
/* harmony default export */ var gridContainer = (GridContainer);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Structure/gridContainerV2/gridContainerV2.tsx











var GridContainerV2 = function(props) {
    var renderChildComponents = function(childComponentsId, post) {
        var counter = {
            desktop: 0,
            tablet: 0,
            mobile: 0
        };
        return childComponentsId.map(function(item, idx) {
            var handledItem = handleObjectType(props.obj, item, props.pageResponse, props.expManager.emEditorType);
            var columns = bobHandler_handleColumns(idx, counter, props.obj.styles.bobs.background2, props.pageResponse.globalStyles[props.obj.styles.bobs.background2.globalStyleId]);
            counter = columns.counter;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                    position: idx,
                    component: handleContentBlock(handledItem, post, props.obj, props.pageResponse, props.overrides),
                    pageResponse: props.pageResponse,
                    selectedInstanceId: props.obj.selectedInstanceId,
                    matchOrder: props.matchOrder,
                    expManager: props.expManager
                }, idx)
            }, idx);
        });
    };
    var renderContent = function(post) {
        var background2 = isBobBackground(props.obj.styles.bobs.background2);
        var ref = alignment(background2), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
        var childComponentsId = props.obj.children;
        var gutters = handleGutts(background2, false);
        if (childComponentsId && childComponentsId.length > 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
                className: "row ".concat(bobHandler_responsiveGuttersClass(background2, props.pageResponse.globalStyles[props.obj.styles.bobs.background2.globalStyleId])),
                desktop: alignmentStyles,
                tablet: tabletAlignment,
                mobile: mobileAlignment,
                children: renderChildComponents(childComponentsId, post)
            });
        } else {
            /**
       * render no content placeholder
       */ if (props.expManager.enable) {
                var counter = {
                    desktop: 0,
                    tablet: 0,
                    mobile: 0
                };
                var Background2 = isBobBackground(props.obj.styles.bobs.background2);
                var childs = Background2.grid.columns && Background2.grid.columns.length;
                var components = [];
                for(var i = 0; i < childs; i++){
                    var columns = bobHandler_handleColumns(i, counter, Background2);
                    counter = columns.counter;
                    components = (0,src_to_consumable_array/* default */.Z)(components).concat([
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    width: "100%",
                                    height: "".concat(Background2.height.enable ? Background2.height.value : "100").concat(Background2.height.enable ? Background2.height.unit : "px"),
                                    border: "3px dashed #dbe0e7"
                                }
                            })
                        }, i), 
                    ]);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(warningDefaultSystem, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row ".concat(gutters),
                        style: alignmentStyles,
                        children: components
                    })
                });
            }
        }
    };
    var renderGrid = function(background1TemplateMerged) {
        var content = getContent(props.obj, "posts", props.overrides);
        if (content && content.length > 0) {
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            return content.map(function(post, idx) {
                var columns = bobHandler_handleColumns(idx, counter, background1TemplateMerged, props.pageResponse.globalStyles[background1TemplateMerged.globalStyleId]);
                counter = columns.counter;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        position: props.position,
                        pageResponse: props.pageResponse,
                        instanceId: props.obj.selectedInstanceId,
                        object: props.obj,
                        objectId: props.obj.uuid,
                        post: post,
                        inlineContent: props.obj.content.inlineContent,
                        overrides: props.overrides,
                        field: "background2",
                        rules: props.componentRule,
                        template: props.obj.styles,
                        expManager: props.expManager,
                        children: renderContent(post)
                    })
                }, idx);
            });
        }
    };
    var background1 = isBobBackground(props.obj.styles.bobs.background1);
    var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "containers",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
            className: "row ".concat(bobHandler_responsiveGuttersClass(background1, props.pageResponse.globalStyles[props.obj.styles.bobs.background1.globalStyleId])),
            desktop: alignmentStyles,
            tablet: tabletAlignment,
            mobile: mobileAlignment,
            children: renderGrid(background1)
        })
    });
};
/* harmony default export */ var gridContainerV2 = (/*#__PURE__*/react.memo(GridContainerV2));

// EXTERNAL MODULE: ./src/stylesheets/modules/templates/sliderContainer.module.sass
var sliderContainer_module = __webpack_require__(2031);
var sliderContainer_module_default = /*#__PURE__*/__webpack_require__.n(sliderContainer_module);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Structure/sliderContainer/sliderContainer.tsx









var SliderContainer = function(props) {
    var _sliderScroller;
    var ref = (0,react.useState)(0), sliderActive = ref[0], setSliderActive = ref[1];
    var slide = function(action) {
        var slides = _sliderScroller.getElementsByClassName((sliderContainer_module_default())["slider-item"]);
        var newIndex = action === "prev" ? sliderActive - 1 : sliderActive + 1;
        if (newIndex < 0 || newIndex + 1 > slides.length) {
            return;
        }
        setSliderActive(newIndex);
        var slide = slides[newIndex];
        slide.scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest"
        });
    };
    var renderSlides = function(childComponentsId) {
        return childComponentsId.map(function(objectId, idx) {
            var handledItem = handleObjectType(props.obj, objectId, props.pageResponse, props.expManager.emEditorType);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "slider-item ".concat((sliderContainer_module_default())["slider-item"]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                    position: idx,
                    selectedInstanceId: props.obj.selectedInstanceId,
                    component: handledItem,
                    pageResponse: props.pageResponse,
                    matchOrder: props.matchOrder,
                    expManager: props.expManager
                })
            }, idx);
        });
    };
    var renderSlider = function() {
        var childComponentsId = props.obj.children;
        if (childComponentsId && childComponentsId.length > 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "slider-body ".concat((sliderContainer_module_default())["slider-body"]),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "slider-nav ".concat((sliderContainer_module_default())["slider-nav"]),
                        onClick: function() {
                            return slide("prev");
                        },
                        style: sliderActive === 0 ? {
                            opacity: 0
                        } : {
                            opacity: 1
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: props.position,
                            pageResponse: props.pageResponse,
                            instanceId: props.obj.selectedInstanceId,
                            object: props.obj,
                            objectId: props.obj.uuid,
                            field: "icon1",
                            template: props.obj.styles,
                            rules: props.componentRule,
                            expManager: props.expManager,
                            iconClassName: "fas fa-chevron-left"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: function(node) {
                            return _sliderScroller = node;
                        },
                        className: "slider-scroller ".concat((sliderContainer_module_default())["slider-scroller"]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "slider-container ".concat((sliderContainer_module_default())["slider-container"]),
                            children: renderSlides(childComponentsId)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "slider-nav ".concat((sliderContainer_module_default())["slider-nav"]),
                        onClick: function() {
                            return slide("next");
                        },
                        style: sliderActive + 1 === childComponentsId.length ? {
                            opacity: 0
                        } : {
                            opacity: 1
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: props.position,
                            pageResponse: props.pageResponse,
                            instanceId: props.obj.selectedInstanceId,
                            object: props.obj,
                            objectId: props.obj.uuid,
                            field: "icon2",
                            template: props.obj.styles,
                            rules: props.componentRule,
                            expManager: props.expManager,
                            iconClassName: "fas fa-chevron-right"
                        })
                    })
                ]
            });
        } else {
            return renderNoChilds();
        }
    };
    var renderNoChilds = function() {
        /**
     * render no content placeholder
     */ if (props.expManager.enable) {
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            var Background1 = isBobBackground(props.obj.styles.bobs.background1);
            var childs = Background1.grid.columns && Background1.grid.columns.length;
            var components = [];
            for(var i = 0; i < childs; i++){
                var columns = handleColumns(i, counter, Background1);
                counter = columns.counter;
                components = (0,src_to_consumable_array/* default */.Z)(components).concat([
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                                verticalAlign: "middle",
                                height: "".concat(Background1.height.enable ? Background1.height.value : "100").concat(Background1.height.enable ? Background1.height.unit : "px"),
                                border: "3px dashed #dbe0e7"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "alert warning m-0",
                                role: "alert",
                                children: "Slider Container empty, please add childs"
                            })
                        })
                    }, i), 
                ]);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "slider-body ".concat((sliderContainer_module_default())["slider-body"]),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "slider-nav ".concat((sliderContainer_module_default())["slider-nav"]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: props.position,
                            pageResponse: props.pageResponse,
                            instanceId: props.obj.selectedInstanceId,
                            object: props.obj,
                            objectId: props.obj.uuid,
                            field: "icon1",
                            template: props.obj.styles,
                            rules: props.componentRule,
                            expManager: props.expManager,
                            iconClassName: "fas fa-chevron-left"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: function(node) {
                            return _sliderScroller = node;
                        },
                        className: "slider-scroller ".concat((sliderContainer_module_default())["slider-scroller"]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "slider-container ".concat((sliderContainer_module_default())["slider-container"]),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warningDefaultSystem, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row",
                                    children: components
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "slider-nav ".concat((sliderContainer_module_default())["slider-nav"]),
                        style: {
                            color: "#888",
                            opacity: 1
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: props.position,
                            pageResponse: props.pageResponse,
                            instanceId: props.obj.selectedInstanceId,
                            object: props.obj,
                            objectId: props.obj.uuid,
                            field: "icon2",
                            template: props.obj.styles,
                            rules: props.componentRule,
                            expManager: props.expManager,
                            iconClassName: "fas fa-chevron-right"
                        })
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "containers slider-container-component ".concat((sliderContainer_module_default())["slider-container-component"]),
        children: renderSlider()
    });
};
/* harmony default export */ var sliderContainer = (SliderContainer);

// EXTERNAL MODULE: ./src/stylesheets/modules/templates/carouselComponent.module.sass
var carouselComponent_module = __webpack_require__(42538);
var carouselComponent_module_default = /*#__PURE__*/__webpack_require__.n(carouselComponent_module);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Structure/sliderContainerV2/sliderContainerV2.tsx


















var SliderContainerV2 = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(SliderContainerV2, _Component);
    var _super = (0,_create_super/* default */.Z)(SliderContainerV2);
    function SliderContainerV2(props) {
        (0,src_class_call_check/* default */.Z)(this, SliderContainerV2);
        var _this;
        _this = _super.call(this, props);
        _this.sliderContainer = /*#__PURE__*/ react.createRef();
        _this.sliderItem = /*#__PURE__*/ react.createRef();
        _this.isDown = false;
        _this.startX = 0;
        _this.scrollLeft = 0;
        _this.state = {
            sliderActive: 0
        };
        _this.onMouseMove = _this.onMouseMove.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onMouseDown = _this.onMouseDown.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onMouseUp = _this.onMouseUp.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onMouseLeave = _this.onMouseLeave.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.goToSlide = _this.goToSlide.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    var _proto = SliderContainerV2.prototype;
    _proto.onMouseDown = function onMouseDown(e) {
        var slider = this.sliderContainer;
        this.isDown = true;
        if (slider.current) {
            this.startX = e.pageX - slider.current.offsetLeft;
            this.scrollLeft = slider.current.scrollLeft;
        }
    };
    _proto.onMouseMove = function onMouseMove(e) {
        if (!this.isDown) return;
        var slider = this.sliderContainer;
        if (slider.current) {
            e.preventDefault();
            var x = e.pageX - slider.current.offsetLeft, walk = x - this.startX;
            slider.current.scrollLeft = this.scrollLeft - walk;
        }
    };
    _proto.onMouseUp = function onMouseUp() {
        var slider = this.sliderContainer;
        if (slider.current) this.isDown = false;
    };
    _proto.onMouseLeave = function onMouseLeave() {
        var slider = this.sliderContainer;
        if (slider.current) this.isDown = false;
    };
    _proto.slide = function slide(action) {
        var slides = this.sliderContainer.current && this.sliderContainer.current.getElementsByClassName("slider-item");
        var newIndex = action === "next" ? this.state.sliderActive + 1 : this.state.sliderActive - 1;
        if (slides && (newIndex < 0 || newIndex + 1 > slides.length)) return;
        this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this.state), {
            sliderActive: newIndex
        }), function() {
            if (slides) {
                var slide = slides[newIndex];
                slide.scrollIntoView({
                    behavior: "smooth",
                    inline: "start",
                    block: "nearest"
                });
            }
        });
    };
    _proto.goToSlide = function goToSlide(newSlide, background1) {
        var slides = this.sliderContainer.current && this.sliderContainer.current.getElementsByClassName("slider-item");
        var amount = background1.grid.columns.length;
        newSlide = newSlide * amount;
        this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this.state), {
            sliderActive: newSlide
        }), function() {
            if (slides) {
                var slide = slides[newSlide];
                slide.scrollIntoView({
                    behavior: "smooth",
                    inline: "start",
                    block: "nearest"
                });
            }
        });
    };
    /**
   * handle navigation arrow visibility
   * if it can not move to that direction, the arrow should be hidden
   * @param action
   * @param childComponentsList
   */ _proto.handleNavState = function handleNavState(direction, background1, childComponentsList) {
        if (direction === "prev") return this.state.sliderActive !== 0;
        if (direction === "next") {
            var itemsPerSlide = background1.grid.columns.length;
            /**
       * last element in array is not sufiecient (length - 1)
       * because if we have more than one item per slide
       * the last element index doenst reflect the last slide position
       *
       * we need to subtract the number of items per slide
       * and minus one to count with the selected index when we'r on the last slide,
       * the selected index is the first in x items per slide(in the last slide), so we cannot subtract with it
       */ var lastItem = childComponentsList.length - 1 - (itemsPerSlide - 1);
            return this.state.sliderActive !== lastItem;
        }
        return {};
    };
    _proto.renderComponents = function renderComponents(childComponentsId, post) {
        var _this = this;
        return childComponentsId.map(function(item, idx) {
            var handledItem = handleObjectType(_this.props.obj, item, _this.props.pageResponse, _this.props.expManager.emEditorType);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                position: idx,
                selectedInstanceId: _this.props.obj.selectedInstanceId,
                // component={handledItem}
                component: handleContentBlock(handledItem, post, _this.props.obj, _this.props.pageResponse, _this.props.overrides),
                pageResponse: _this.props.pageResponse,
                matchOrder: _this.props.matchOrder,
                expManager: _this.props.expManager
            }, idx);
        });
    };
    _proto.renderSlides = function renderSlides(childComponentsId, background1TemplateMerged) {
        var content = getContent(this.props.obj, "posts", this.props.overrides, undefined, false);
        if (content && content.length > 0) {
            var _this = this;
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            return content.map(function(post, idx) {
                var columns = bobHandler_handleColumns(idx, counter, background1TemplateMerged, _this.props.pageResponse.globalStyles[background1TemplateMerged.globalStyleId]);
                counter = columns.counter;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: _this.sliderItem,
                    className: "slider-item ".concat((carouselComponent_module_default())["slider-item"], " col-").concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                    children: _this.renderComponents(childComponentsId, post)
                }, idx);
            });
        } else {
            var _this1 = this;
            var counter1 = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            return childComponentsId.map(function(item, idx) {
                var handledItem = handleObjectType(_this1.props.obj, item, _this1.props.pageResponse, _this1.props.expManager.emEditorType);
                var columns = bobHandler_handleColumns(idx, counter1, background1TemplateMerged, _this1.props.pageResponse.globalStyles[background1TemplateMerged.globalStyleId]);
                counter1 = columns.counter;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: _this1.sliderItem,
                    className: "slider-item ".concat((carouselComponent_module_default())["slider-item"], " col-").concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                        position: idx,
                        selectedInstanceId: _this1.props.obj.selectedInstanceId,
                        component: handledItem,
                        pageResponse: _this1.props.pageResponse,
                        matchOrder: _this1.props.matchOrder,
                        expManager: _this1.props.expManager
                    }, idx)
                }, idx);
            });
        }
    };
    _proto.renderNoChilds = function renderNoChilds(background1) {
        /**
     * render no content placeholder
     */ if (this.props.expManager.enable) {
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            var childs = background1.grid.columns && background1.grid.columns.length;
            var components = [];
            for(var i = 0; i < childs; i++){
                var columns = bobHandler_handleColumns(i, counter, background1, this.props.pageResponse.globalStyles[background1.globalStyleId]);
                counter = columns.counter;
                components = (0,src_to_consumable_array/* default */.Z)(components).concat([
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                                verticalAlign: "middle",
                                height: "".concat(background1.height.enable ? background1.height.value : "100").concat(background1.height.enable ? background1.height.unit : "px"),
                                border: "3px dashed #dbe0e7"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "alert warning m-0",
                                role: "alert",
                                children: "SliderContainerV2 empty, please add childs"
                            })
                        })
                    }, i), 
                ]);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "slider-body ".concat((carouselComponent_module_default())["slider-body"]),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "slider-nav ".concat((carouselComponent_module_default())["slider-nav"]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: this.props.position,
                            pageResponse: this.props.pageResponse,
                            instanceId: this.props.obj.selectedInstanceId,
                            object: this.props.obj,
                            objectId: this.props.obj.uuid,
                            field: "icon1",
                            template: this.props.obj.styles,
                            rules: this.props.componentRule,
                            expManager: this.props.expManager,
                            iconClassName: "fas fa-chevron-left"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "slider-container ".concat((carouselComponent_module_default())["slider-container"]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warningDefaultSystem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row",
                                children: components
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "slider-nav ".concat((carouselComponent_module_default())["slider-nav"]),
                        style: {
                            color: "#888",
                            opacity: 1
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: this.props.position,
                            pageResponse: this.props.pageResponse,
                            instanceId: this.props.obj.selectedInstanceId,
                            object: this.props.obj,
                            objectId: this.props.obj.uuid,
                            field: "icon2",
                            template: this.props.obj.styles,
                            rules: this.props.componentRule,
                            expManager: this.props.expManager,
                            iconClassName: "fas fa-chevron-right"
                        })
                    })
                ]
            });
        }
    };
    _proto.renderBottomNavigation = function renderBottomNavigation(background1) {
        var _this = this, _loop = function(i) {
            var _this1 = _this;
            slides = (0,src_to_consumable_array/* default */.Z)(slides).concat([
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                    onClick: function() {
                        return _this1.goToSlide(i, background1);
                    },
                    position: _this.props.position,
                    pageResponse: _this.props.pageResponse,
                    instanceId: _this.props.obj.selectedInstanceId,
                    object: _this.props.obj,
                    objectId: _this.props.obj.uuid,
                    field: "icon3",
                    template: _this.props.obj.styles,
                    rules: _this.props.componentRule,
                    expManager: _this.props.expManager,
                    iconClassName: "fas fa-chevron-left",
                    className: "".concat(i === _this.state.sliderActive ? "active" : "")
                }, i), 
            ]);
        };
        var slidesNumber = this.props.obj.children.length / background1.grid.columns.length;
        slidesNumber = Math.ceil(slidesNumber);
        var slides = [];
        for(var i = 0; i < slidesNumber; i++)_loop(i);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "slider-nav-bottom ".concat((carouselComponent_module_default())["slider-nav-bottom"]),
            children: slides
        });
    };
    _proto.render = function render() {
        var _this = this;
        var background1 = isBobBackground(this.props.obj.styles.bobs.background1);
        var childComponentsId = this.props.obj.children;
        var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
        var prevNavEnabled = this.handleNavState("prev", background1, childComponentsId);
        var nextNavEnabled = this.handleNavState("next", background1, childComponentsId);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "containers carousel-component ".concat((carouselComponent_module_default())["carousel-component"]),
            children: childComponentsId && childComponentsId.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "slider-body ".concat((carouselComponent_module_default())["slider-body"]),
                        children: [
                            this.props.obj.styles.bobs.icon1.enable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "slider-nav ".concat((carouselComponent_module_default())["slider-nav"], " left"),
                                onClick: function() {
                                    return prevNavEnabled && _this.slide("prev");
                                },
                                style: prevNavEnabled ? {
                                    opacity: 1
                                } : {
                                    opacity: 0
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                    position: this.props.position,
                                    pageResponse: this.props.pageResponse,
                                    instanceId: this.props.obj.selectedInstanceId,
                                    object: this.props.obj,
                                    objectId: this.props.obj.uuid,
                                    field: "icon1",
                                    template: this.props.obj.styles,
                                    rules: this.props.componentRule,
                                    expManager: this.props.expManager,
                                    iconClassName: "fas fa-chevron-left"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
                                ref: this.sliderContainer,
                                className: "slider-container ".concat((carouselComponent_module_default())["slider-container"], " ").concat(bobHandler_responsiveGuttersClass(background1, this.props.pageResponse.globalStyles[background1.globalStyleId])),
                                desktop: alignmentStyles,
                                tablet: tabletAlignment,
                                mobile: mobileAlignment,
                                onMouseMove: this.onMouseMove,
                                onMouseDown: this.onMouseDown,
                                onMouseUp: this.onMouseUp,
                                onMouseLeave: this.onMouseLeave,
                                children: this.renderSlides(childComponentsId, background1)
                            }),
                            this.props.obj.styles.bobs.icon2.enable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "slider-nav ".concat((carouselComponent_module_default())["slider-nav"], " right"),
                                onClick: function() {
                                    return nextNavEnabled && _this.slide("next");
                                },
                                style: nextNavEnabled ? {
                                    opacity: 1
                                } : {
                                    opacity: 0
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                    position: this.props.position,
                                    pageResponse: this.props.pageResponse,
                                    instanceId: this.props.obj.selectedInstanceId,
                                    object: this.props.obj,
                                    objectId: this.props.obj.uuid,
                                    field: "icon2",
                                    template: this.props.obj.styles,
                                    rules: this.props.componentRule,
                                    expManager: this.props.expManager,
                                    iconClassName: "fas fa-chevron-right"
                                })
                            })
                        ]
                    }),
                    this.renderBottomNavigation(background1)
                ]
            }) : this.renderNoChilds(background1)
        });
    };
    return SliderContainerV2;
}(react.Component);
/* harmony default export */ var sliderContainerV2 = (SliderContainerV2);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Structure/sliderContainerV3/dots/dots.css.ts

function dots_css_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: ",
        "px;\n    margin-top: ",
        "px;\n    margin-bottom: ",
        "px;\n    margin-left: ",
        "px;\n    margin-right: ",
        "px;\n    padding-top: ",
        "px;\n    padding-bottom: ",
        "px;\n    padding-left: ",
        "px;\n    padding-right: ",
        "px;\n  "
    ]);
    dots_css_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function dots_css_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    dots_css_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function dots_css_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  color: ",
        ";\n  transition: font-size 300ms ease-in-out, margin 300ms ease-in-out;\n\n  @media only screen and (max-width: 992px) and (min-width: 767px){\n    ",
        "\n    ",
        "\n    color: ",
        ";\n  }\n  @media all and (max-width: 766px){\n    ",
        "\n    ",
        "\n    color: ",
        ";\n  }\n"
    ]);
    dots_css_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var handleSize = function(breakpoint, props) {
    var ref;
    var ref1;
    var size = breakpoint === "desktop" ? props.template.size : (ref1 = (ref = props.template[breakpoint]) === null || ref === void 0 ? void 0 : ref.size) !== null && ref1 !== void 0 ? ref1 : props.template.size;
    return [
        size,
        size * 0.66,
        size * 0.33
    ];
};
var handleMargin = function(breakpoint, props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var ref12;
    var marginTop = breakpoint === "desktop" ? props.template.spacing.margin.top : (ref12 = (ref = props.template[breakpoint]) === null || ref === void 0 ? void 0 : (ref1 = ref.spacing) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.margin) === null || ref2 === void 0 ? void 0 : ref2.top) !== null && ref12 !== void 0 ? ref12 : props.template.spacing.margin.top;
    var ref13;
    var marginBottom = breakpoint === "desktop" ? props.template.spacing.margin.bottom : (ref13 = (ref3 = props.template[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.spacing) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.margin) === null || ref5 === void 0 ? void 0 : ref5.bottom) !== null && ref13 !== void 0 ? ref13 : props.template.spacing.margin.bottom;
    var ref14;
    var marginLeft = breakpoint === "desktop" ? props.template.spacing.margin.left : (ref14 = (ref6 = props.template[breakpoint]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.spacing) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.margin) === null || ref8 === void 0 ? void 0 : ref8.left) !== null && ref14 !== void 0 ? ref14 : props.template.spacing.margin.left;
    var ref15;
    var marginRight = breakpoint === "desktop" ? props.template.spacing.margin.right : (ref15 = (ref9 = props.template[breakpoint]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.spacing) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.margin) === null || ref11 === void 0 ? void 0 : ref11.right) !== null && ref15 !== void 0 ? ref15 : props.template.spacing.margin.right;
    return {
        marginTop: marginTop,
        marginBottom: marginBottom,
        marginLeft: [
            marginLeft,
            marginLeft + marginLeft * 0.66,
            marginLeft + marginLeft * 0.33
        ],
        marginRight: [
            marginRight,
            marginRight + marginRight * 0.66,
            marginRight + marginRight * 0.33
        ]
    };
};
var handlePadding = function(breakpoint, props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var ref12;
    var paddingTop = breakpoint === "desktop" ? props.template.spacing.padding.top : (ref12 = (ref = props.template[breakpoint]) === null || ref === void 0 ? void 0 : (ref1 = ref.spacing) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.padding) === null || ref2 === void 0 ? void 0 : ref2.top) !== null && ref12 !== void 0 ? ref12 : props.template.spacing.padding.top;
    var ref13;
    var paddingBottom = breakpoint === "desktop" ? props.template.spacing.padding.bottom : (ref13 = (ref3 = props.template[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.spacing) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.padding) === null || ref5 === void 0 ? void 0 : ref5.bottom) !== null && ref13 !== void 0 ? ref13 : props.template.spacing.padding.bottom;
    var ref14;
    var paddingLeft = breakpoint === "desktop" ? props.template.spacing.padding.left : (ref14 = (ref6 = props.template[breakpoint]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.spacing) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.padding) === null || ref8 === void 0 ? void 0 : ref8.left) !== null && ref14 !== void 0 ? ref14 : props.template.spacing.padding.left;
    var ref15;
    var paddingRight = breakpoint === "desktop" ? props.template.spacing.padding.right : (ref15 = (ref9 = props.template[breakpoint]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.spacing) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.padding) === null || ref11 === void 0 ? void 0 : ref11.right) !== null && ref15 !== void 0 ? ref15 : props.template.spacing.padding.right;
    return {
        paddingTop: paddingTop,
        paddingBottom: paddingBottom,
        paddingLeft: [
            paddingLeft,
            paddingLeft + paddingLeft * 0.66,
            paddingLeft + paddingLeft * 0.33
        ],
        paddingRight: [
            paddingRight,
            paddingRight + paddingRight * 0.66,
            paddingRight + paddingRight * 0.33
        ]
    };
};
var getSize = function(breakpoint) {
    return function(props) {
        var size = handleSize(breakpoint, props)[props.distance] || 0;
        var marginTop = size !== 0 ? handleMargin(breakpoint, props).marginTop : 0;
        var marginBottom = size !== 0 ? handleMargin(breakpoint, props).marginBottom : 0;
        var marginLeft = size !== 0 ? handleMargin(breakpoint, props).marginLeft[props.distance] : 0;
        var marginRight = size !== 0 ? handleMargin(breakpoint, props).marginRight[props.distance] : 0;
        var paddingTop = size !== 0 ? handlePadding(breakpoint, props).paddingTop : 0;
        var paddingBottom = size !== 0 ? handlePadding(breakpoint, props).paddingBottom : 0;
        var paddingLeft = size !== 0 ? handlePadding(breakpoint, props).paddingLeft[props.distance] : 0;
        var paddingRight = size !== 0 ? handlePadding(breakpoint, props).paddingRight[props.distance] : 0;
        return (0,styled_components_browser_esm/* css */.iv)(dots_css_templateObject(), size, marginTop, marginBottom, marginLeft, marginRight, paddingTop, paddingBottom, paddingLeft, paddingRight);
    };
};
var dimColor = function() {
    return function(props) {
        if (props.active) {
            return "";
        }
        return "filter: opacity(35%);";
    };
};
var Dots = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-88fcb046-0"
})(dots_css_templateObject1());
var ref, ref1;
var Dot = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-88fcb046-1"
})(dots_css_templateObject2(), getSize("desktop"), dimColor(), function(props) {
    return props.template.color;
}, getSize("tablet"), dimColor(), function(props) {
    var ref1;
    return (ref = (ref1 = props.template.tablet) === null || ref1 === void 0 ? void 0 : ref1.color) !== null && ref !== void 0 ? ref : props.template.color;
}, getSize("mobile"), dimColor(), function(props) {
    var ref;
    return (ref1 = (ref = props.template.mobile) === null || ref === void 0 ? void 0 : ref.color) !== null && ref1 !== void 0 ? ref1 : props.template.color;
});

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Structure/sliderContainerV3/dots/dots.tsx






function dots_Dots(param) {
    var centerDots = param.centerDots, currentSlide = param.currentSlide, totalSlides = param.totalSlides, goToSlide = param.goToSlide, position = param.position, pageResponse = param.pageResponse, instanceId = param.instanceId, object = param.object, objectId = param.objectId, field = param.field, template = param.template, rules = param.rules, expManager = param.expManager, iconClassName = param.iconClassName;
    var centerOffset = (0,react.useRef)(0);
    var slideOffset = (0,react.useRef)(0);
    var currentCenterOffset = currentSlide - slideOffset.current;
    if (currentCenterOffset >= 0 && currentCenterOffset < centerDots) {
        centerOffset.current = currentCenterOffset;
    } else {
        slideOffset.current = currentSlide - centerOffset.current;
    }
    var clamp = function(value, min, max) {
        return Math.min(Math.max(min, value), max);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dots, {
        className: "slider-nav-bottom",
        children: (0,src_to_consumable_array/* default */.Z)(Array(totalSlides)).map(function(_, idx) {
            var centerPage = centerDots / 2 + slideOffset.current;
            var distance = Math.abs(idx - centerPage);
            var scaledDistance = clamp(distance - centerDots / 2, 0, 3);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {
                active: idx === currentSlide,
                distance: scaledDistance,
                template: isBobIcon(template.bobs.icon3),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                    onClick: function() {
                        return goToSlide(idx);
                    },
                    position: position,
                    pageResponse: pageResponse,
                    instanceId: instanceId,
                    object: object,
                    objectId: objectId,
                    field: field,
                    template: template,
                    templatePropsToIgnore: [
                        "color",
                        "size",
                        "spacing"
                    ],
                    rules: rules,
                    expManager: expManager,
                    iconClassName: iconClassName
                })
            }, idx);
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-swipeable-views/lib/index.js
var react_swipeable_views_lib = __webpack_require__(77314);
// EXTERNAL MODULE: ./src/stylesheets/modules/templates/sliderComponentV3.module.sass
var sliderComponentV3_module = __webpack_require__(8708);
var sliderComponentV3_module_default = /*#__PURE__*/__webpack_require__.n(sliderComponentV3_module);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Structure/sliderContainerV3/sliderContainerV3.tsx



















var SliderContainerV3 = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(SliderContainerV3, _Component);
    var _super = (0,_create_super/* default */.Z)(SliderContainerV3);
    function SliderContainerV3(props) {
        (0,src_class_call_check/* default */.Z)(this, SliderContainerV3);
        var _this;
        _this = _super.call(this, props);
        _this.sliderContainer = /*#__PURE__*/ react.createRef();
        _this.totalSlides = 0;
        _this.screenX = 0;
        _this.windowResized = function(window1) {
            var breakpointValue = "desktop";
            if (window1.matchMedia("(max-width: 766px)").matches) {
                breakpointValue = "mobile";
            } else if (window1.matchMedia("(max-width: 992px) and (min-width: 767px)").matches) {
                breakpointValue = "tablet";
            }
            if (breakpointValue !== _this.state.activeBreakpoint) {
                _this.setState({
                    activeBreakpoint: breakpointValue
                });
            }
        };
        _this.getChilds = function() {
            if (_this.props.obj.isContentBlock) {
                var ref;
                var posts = (ref = _this.props.obj.content.formula) === null || ref === void 0 ? void 0 : ref.posts;
                return posts && posts.length > 0 ? posts : _this.props.obj.children;
            }
            return _this.props.obj.children;
        };
        _this.getObjectChildrens = function() {
            return _this.props.obj.children;
        };
        _this.isContentBlockPosts = function() {
            if (_this.props.obj.isContentBlock) {
                var ref;
                var posts = (ref = _this.props.obj.content.formula) === null || ref === void 0 ? void 0 : ref.posts;
                return posts && posts.length > 0 ? true : false;
            }
            return false;
        };
        _this.getColumnByBreakpoint = function() {
            var ref, ref1, ref2, ref3, ref4, ref5;
            var bobBackground1 = isBobBackground(_this.props.obj.styles.bobs.background1);
            var ref6;
            if (_this.state.activeBreakpoint === "mobile") return (ref6 = (ref = bobBackground1.mobile) === null || ref === void 0 ? void 0 : (ref1 = ref.grid) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.columns) === null || ref2 === void 0 ? void 0 : ref2.length) !== null && ref6 !== void 0 ? ref6 : bobBackground1.grid.columns.length;
            var ref7;
            if (_this.state.activeBreakpoint === "tablet") return (ref7 = (ref3 = bobBackground1.tablet) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.grid) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.columns) === null || ref5 === void 0 ? void 0 : ref5.length) !== null && ref7 !== void 0 ? ref7 : bobBackground1.grid.columns.length;
            return bobBackground1.grid.columns.length;
        };
        _this.slide = function(action) {
            var newSlide = action === "next" ? _this.state.activeSlide + 1 : _this.state.activeSlide - 1;
            // don't slide if on first or last slide
            if (newSlide < 0 || newSlide >= _this.totalSlides) return;
            _this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, _this.state), {
                activeSlide: newSlide
            }));
        };
        _this.goToSlide = function(newSlide) {
            _this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, _this.state), {
                activeSlide: newSlide
            }));
        };
        _this.onSwipeChangeIndex = function(index) {
            _this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, _this.state), {
                activeSlide: index
            }));
        };
        _this.isDrag = function(e) {
            var delta = Math.abs(e.screenX - _this.screenX);
            return delta > 10;
        };
        _this.handleMouseDown = function(e) {
            _this.screenX = e.screenX;
        };
        // prevent child click on mouse drag, touch events do this already
        _this.handleMouseUp = function(e) {
            var sliderChildren = e.currentTarget.children;
            if (sliderChildren) {
                for(var i = 0; i < sliderChildren.length; i++){
                    var child = sliderChildren[i];
                    child.onclick = function(event) {
                        if (_this.isDrag(e)) {
                            event.preventDefault();
                            event.stopPropagation();
                            return false;
                        }
                        return;
                    };
                }
            }
        };
        /**
   * handle navigation arrow visibility
   * if it can not move to that direction, the arrow should be hidden
   * @param action
   * @param childComponentsList
   */ _this.arrowCanSlide = function(direction) {
            if (direction === "prev") return _this.state.activeSlide !== 0;
            if (direction === "next") {
                return _this.state.activeSlide + 1 < _this.totalSlides;
            }
        };
        _this.renderComponents = function(childComponentsId, post) {
            return childComponentsId.map(function(item, idx) {
                var handledItem = handleObjectType(_this.props.obj, item, _this.props.pageResponse, _this.props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                    position: idx,
                    selectedInstanceId: _this.props.obj.selectedInstanceId,
                    // component={handledItem}
                    component: handleContentBlock(handledItem, post, _this.props.obj, _this.props.pageResponse, _this.props.overrides),
                    pageResponse: _this.props.pageResponse,
                    matchOrder: _this.props.matchOrder,
                    expManager: _this.props.expManager
                }, idx);
            });
        };
        _this.renderContentBlockSlideItems = function(slide, counter, objectChildren, background1TemplateMerged) {
            if (slide && slide.length > 0) {
                return slide.map(function(item, idxPost) {
                    var columns = bobHandler_handleColumns(idxPost, counter, background1TemplateMerged, _this.props.pageResponse.globalStyles[background1TemplateMerged.globalStyleId]);
                    counter = columns.counter;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "slider-item ".concat((sliderComponentV3_module_default())["slider-item"], " col-").concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                        children: _this.renderComponents(objectChildren, item)
                    }, idxPost);
                });
            }
        };
        _this.renderFormulaContentSlideItems = function(slide, counter, childIs, background1TemplateMerged) {
            if (slide && slide.length > 0) {
                return slide.map(function(post, idx) {
                    var columns = bobHandler_handleColumns(idx, counter, background1TemplateMerged, _this.props.pageResponse.globalStyles[background1TemplateMerged.globalStyleId]);
                    counter = columns.counter;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "slider-item ".concat((sliderComponentV3_module_default())["slider-item"], " col-").concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                        children: _this.renderComponents(childIs, post)
                    }, idx);
                });
            }
        };
        _this.renderChildrenSlideItems = function(slide, counter, background1TemplateMerged) {
            if (slide && slide.length > 0) {
                return slide.map(function(item, idx) {
                    var handledItem = handleObjectType(_this.props.obj, item, _this.props.pageResponse, _this.props.expManager.emEditorType);
                    var columns = bobHandler_handleColumns(idx, counter, background1TemplateMerged, _this.props.pageResponse.globalStyles[background1TemplateMerged.globalStyleId]);
                    counter = columns.counter;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "slider-item ".concat((sliderComponentV3_module_default())["slider-item"], " col-").concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                            position: idx,
                            selectedInstanceId: _this.props.obj.selectedInstanceId,
                            component: handledItem,
                            pageResponse: _this.props.pageResponse,
                            matchOrder: _this.props.matchOrder,
                            expManager: _this.props.expManager
                        }, idx)
                    }, idx);
                });
            }
        };
        _this.renderSlides = function(contentType, background1TemplateMerged, slides, childIds) {
            // using content block
            if (contentType === "contentBlock") {
                var objectChildren = _this.getObjectChildrens();
                return slides.map(function(slide, idx) {
                    var counter = {
                        desktop: 0,
                        tablet: 0,
                        mobile: 0
                    };
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "slide",
                        onMouseUp: _this.handleMouseUp,
                        onMouseLeave: _this.handleMouseUp,
                        onMouseDown: _this.handleMouseDown,
                        children: _this.renderContentBlockSlideItems(slide, counter, objectChildren, background1TemplateMerged)
                    }, idx);
                });
            } else {
                // using formula
                if (contentType === "formula") {
                    return slides.map(function(slide, idx) {
                        var counter = {
                            desktop: 0,
                            tablet: 0,
                            mobile: 0
                        };
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "slide",
                            onMouseUp: _this.handleMouseUp,
                            onMouseLeave: _this.handleMouseUp,
                            onMouseDown: _this.handleMouseDown,
                            children: _this.renderFormulaContentSlideItems(slide, counter, childIds, background1TemplateMerged)
                        }, idx);
                    });
                } else {
                    return slides.map(function(slide, idx) {
                        var counter = {
                            desktop: 0,
                            tablet: 0,
                            mobile: 0
                        };
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "slide",
                            onMouseUp: _this.handleMouseUp,
                            onMouseLeave: _this.handleMouseUp,
                            onMouseDown: _this.handleMouseDown,
                            children: _this.renderChildrenSlideItems(slide, counter, background1TemplateMerged)
                        }, idx);
                    });
                }
            }
        };
        _this.renderNoChilds = function() {
            /**
     * render no content placeholder
     */ var bobBackground1 = isBobBackground(_this.props.obj.styles.bobs.background1);
            if (_this.props.expManager.enable) {
                var counter = {
                    desktop: 0,
                    tablet: 0,
                    mobile: 0
                };
                var childs = bobBackground1.grid.columns && bobBackground1.grid.columns.length;
                var components = [];
                for(var i = 0; i < childs; i++){
                    var columns = bobHandler_handleColumns(i, counter, _this.props.obj.styles.bobs.background1, _this.props.pageResponse.globalStyles[_this.props.obj.styles.bobs.background1.globalStyleId]);
                    counter = columns.counter;
                    components = (0,src_to_consumable_array/* default */.Z)(components).concat([
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                    verticalAlign: "middle",
                                    height: "".concat(bobBackground1.height.enable ? bobBackground1.height.unit : "px"),
                                    border: "3px dashed #dbe0e7"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "alert warning m-0",
                                    role: "alert",
                                    children: "SliderContainer empty, please add childs"
                                })
                            })
                        }, i), 
                    ]);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "slider-body ".concat((sliderComponentV3_module_default())["slider-body"]),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "slider-nav ".concat((sliderComponentV3_module_default())["slider-nav"]),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                position: _this.props.position,
                                pageResponse: _this.props.pageResponse,
                                instanceId: _this.props.obj.selectedInstanceId,
                                object: _this.props.obj,
                                objectId: _this.props.obj.uuid,
                                field: "icon1",
                                template: _this.props.obj.styles,
                                rules: _this.props.componentRule,
                                expManager: _this.props.expManager,
                                iconClassName: "fas fa-chevron-left"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "slider-container ".concat((sliderComponentV3_module_default())["slider-container"]),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warningDefaultSystem, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row",
                                    children: components
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "slider-nav ".concat((sliderComponentV3_module_default())["slider-nav"]),
                            style: {
                                color: "#888",
                                opacity: 1
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                position: _this.props.position,
                                pageResponse: _this.props.pageResponse,
                                instanceId: _this.props.obj.selectedInstanceId,
                                object: _this.props.obj,
                                objectId: _this.props.obj.uuid,
                                field: "icon2",
                                template: _this.props.obj.styles,
                                rules: _this.props.componentRule,
                                expManager: _this.props.expManager,
                                iconClassName: "fas fa-chevron-right"
                            })
                        })
                    ]
                });
            }
        };
        _this.renderBottomNavigation = function() {
            if (_this.totalSlides > 1) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dots_Dots, {
                    totalSlides: _this.totalSlides,
                    currentSlide: _this.state.activeSlide,
                    centerDots: _this.totalSlides < 6 ? _this.totalSlides : 3,
                    goToSlide: _this.goToSlide,
                    position: _this.props.position,
                    pageResponse: _this.props.pageResponse,
                    instanceId: _this.props.obj.selectedInstanceId,
                    object: _this.props.obj,
                    objectId: _this.props.obj.uuid,
                    field: "icon3",
                    template: _this.props.obj.styles,
                    rules: _this.props.componentRule,
                    expManager: _this.props.expManager,
                    iconClassName: "fas fa-chevron-left"
                });
            }
        };
        _this.render = function() {
            var background1 = _this.props.obj.styles.bobs.background1;
            var childComponentsId = _this.getChilds();
            var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
            var contentType = "children";
            var posts;
            var slides;
            var content;
            var childIds;
            if (childComponentsId && childComponentsId.length > 0) {
                // using content block
                if (_this.isContentBlockPosts()) {
                    contentType = "contentBlock";
                    posts = childComponentsId;
                    slides = _this.groupItemsBySlides(posts, _this.getColumnByBreakpoint());
                    _this.totalSlides = slides.length;
                } else {
                    content = getContent(_this.props.obj, "posts", _this.props.overrides, undefined, false);
                    childIds = childComponentsId;
                    // using formula
                    if (content && content.length > 0) {
                        contentType = "formula";
                        slides = _this.groupItemsBySlides(content, _this.getColumnByBreakpoint());
                        _this.totalSlides = slides.length;
                    // using children
                    } else {
                        contentType = "children";
                        slides = _this.groupItemsBySlides(childIds, _this.getColumnByBreakpoint());
                        _this.totalSlides = slides.length;
                    }
                }
            }
            var prevNavEnabled = _this.arrowCanSlide("prev");
            var nextNavEnabled = _this.arrowCanSlide("next");
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "containers slider-component-v3 ".concat((sliderComponentV3_module_default())["slider-component-v3"]),
                children: childComponentsId && childComponentsId.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "slider-body ".concat((sliderComponentV3_module_default())["slider-body"]),
                            children: [
                                _this.props.obj.styles.bobs.icon1.enable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "slider-nav ".concat((sliderComponentV3_module_default())["slider-nav"], " left"),
                                    onClick: function() {
                                        return prevNavEnabled && _this.slide("prev");
                                    },
                                    style: prevNavEnabled ? {
                                        opacity: 1
                                    } : {
                                        opacity: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: _this.props.position,
                                        pageResponse: _this.props.pageResponse,
                                        instanceId: _this.props.obj.selectedInstanceId,
                                        object: _this.props.obj,
                                        objectId: _this.props.obj.uuid,
                                        field: "icon1",
                                        template: _this.props.obj.styles,
                                        rules: _this.props.componentRule,
                                        expManager: _this.props.expManager,
                                        iconClassName: "fas fa-chevron-left"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
                                    ref: _this.sliderContainer,
                                    className: "slider-container ".concat((sliderComponentV3_module_default())["slider-container"], " ").concat(bobHandler_responsiveGuttersClass(background1, _this.props.pageResponse.globalStyles[background1.globalStyleId])),
                                    desktop: alignmentStyles,
                                    tablet: tabletAlignment,
                                    mobile: mobileAlignment,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_swipeable_views_lib/* default */.ZP, {
                                        enableMouseEvents: true,
                                        ignoreNativeScroll: true,
                                        index: _this.state.activeSlide,
                                        onChangeIndex: function(index) {
                                            return _this.onSwipeChangeIndex(index);
                                        },
                                        children: _this.renderSlides(contentType, background1, slides, childIds)
                                    })
                                }),
                                _this.props.obj.styles.bobs.icon2.enable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "slider-nav ".concat((sliderComponentV3_module_default())["slider-nav"], " right"),
                                    onClick: function() {
                                        return nextNavEnabled && _this.slide("next");
                                    },
                                    style: nextNavEnabled ? {
                                        opacity: 1
                                    } : {
                                        opacity: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: _this.props.position,
                                        pageResponse: _this.props.pageResponse,
                                        instanceId: _this.props.obj.selectedInstanceId,
                                        object: _this.props.obj,
                                        objectId: _this.props.obj.uuid,
                                        field: "icon2",
                                        template: _this.props.obj.styles,
                                        rules: _this.props.componentRule,
                                        expManager: _this.props.expManager,
                                        iconClassName: "fas fa-chevron-right"
                                    })
                                })
                            ]
                        }),
                        _this.renderBottomNavigation()
                    ]
                }) : _this.renderNoChilds()
            });
        };
        _this.state = {
            activeSlide: 0
        };
        return _this;
    }
    var _proto = SliderContainerV3.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        // handle window for page builder iframe or public pages
        var iframe = document.getElementById("board-preview-frame");
        var handledWindow = (iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) || window;
        // Add resize eventListener, check window size on mount
        handledWindow.addEventListener("resize", function() {
            return _this.windowResized(handledWindow);
        });
        this.windowResized(handledWindow);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var _this = this;
        // handle document and window for page builder iframe or public pages
        var iframe = document.getElementById("board-preview-frame");
        var handledWindow = (iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) || window;
        // Clean resize eventListeners
        handledWindow.removeEventListener("resize", function() {
            return _this.windowResized(handledWindow);
        });
    };
    _proto.groupItemsBySlides = function groupItemsBySlides(items, slidesNumber) {
        var group = [];
        for(var i = 0, j = 0; i < items.length; i++){
            if (i >= slidesNumber && i % slidesNumber === 0) j++;
            group[j] = group[j] || [];
            group[j].push(items[i]);
        }
        return group;
    };
    return SliderContainerV3;
}(react.Component);
/* harmony default export */ var sliderContainerV3 = (SliderContainerV3);

// EXTERNAL MODULE: ./src/stylesheets/modules/templates/embedContainer.module.sass
var embedContainer_module = __webpack_require__(49336);
var embedContainer_module_default = /*#__PURE__*/__webpack_require__.n(embedContainer_module);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Structure/embedContainer/embedContainer.tsx








var embedContainer_EmbedContainer = function(props) {
    var ref = (0,react.useState)(false), isMouted = ref[0], setMounted = ref[1];
    (0,react.useEffect)(function() {
        setMounted(true);
    }, []);
    var renderNoChilds = function() {
        /**
     * render no content placeholder
     */ if (props.expManager.enable) {
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            var Background1 = isBobBackground(props.obj.styles.bobs.background1);
            var childs = Background1.grid.columns && Background1.grid.columns.length;
            var components = [];
            for(var i = 0; i < childs; i++){
                var columns = bobHandler_handleColumns(i, counter, Background1, props.pageResponse.globalStyles[Background1.globalStyleId]);
                counter = columns.counter;
                components = (0,src_to_consumable_array/* default */.Z)(components).concat([
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                                verticalAlign: "middle",
                                height: "".concat(Background1.height.enable ? Background1.height.value : "100").concat(Background1.height.enable ? Background1.height.unit : "px"),
                                border: "3px dashed #dbe0e7"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "alert warning m-0",
                                role: "alert",
                                children: "Go to the elements tab and add your embed code there."
                            })
                        })
                    }, i), 
                ]);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(warningDefaultSystem, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: components
                })
            });
        }
        return [];
    };
    var component = props.obj;
    var Embed1 = isBobCode(component.styles.bobs.embed1);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "containers embed-container-component ".concat((embedContainer_module_default())["embed-container-component"]),
        children: isMouted && Embed1.code && Embed1.code !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dangerousHtml, {
            style: {
                textAlign: "center"
            },
            html: Embed1.code,
            expManager: props.expManager
        }) : renderNoChilds()
    });
};
/* harmony default export */ var embedContainer = (embedContainer_EmbedContainer);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Structure/embedContainer/embedContainerV2.tsx




var EmbedContainerV2 = function(props) {
    var ref = (0,react.useState)(false), isMouted = ref[0], setMounted = ref[1];
    (0,react.useEffect)(function() {
        setMounted(true);
    }, []);
    var Embed1 = isBobCode(props.obj.styles.bobs.embed1);
    if (Embed1.code && Embed1.code !== "") {
        if (isMouted) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dangerousHtml, {
                style: {},
                html: Embed1.code,
                expManager: props.expManager
            });
        }
    }
    if (props.expManager.enable) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "alert warning m-0",
            role: "alert",
            children: "Go to the elements tab and add your embed code there."
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var embedContainerV2 = (EmbedContainerV2);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Elements/Media/Media.tsx








var Media = function(props) {
    var renderImages = function(background1Template) {
        var content = getContent(props.obj, "posts", props.overrides);
        if (content && content.length > 0) {
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            return content.map(function(post, idx) {
                var columns = bobHandler_handleColumns(idx, counter, background1Template, props.pageResponse.globalStyles[background1Template.globalStyleId]);
                counter = columns.counter;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        position: props.position,
                        pageResponse: props.pageResponse,
                        replacedMediaList: props.replacedMediaList,
                        instanceId: props.obj.selectedInstanceId,
                        object: props.obj,
                        objectId: props.obj.uuid,
                        inlineContent: props.obj.content.inlineContent,
                        overrides: props.overrides,
                        field: "media1",
                        template: props.obj.styles,
                        rules: props.componentRule,
                        expManager: props.expManager,
                        network: post.network,
                        post: post
                    })
                }, idx);
            });
        } else {
            if (props.expManager.enable) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-sm-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warningSystem, {
                        alertType: "alert-secondary w-100 text-center",
                        messages: "Add a single post or a feed"
                    })
                });
            }
        }
    };
    /**
   * Responsive Alignment Styles
   */ var background1 = props.obj.styles.bobs.background1;
    var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "elements image",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
            className: "row ".concat(bobHandler_responsiveGuttersClass(background1, props.pageResponse.globalStyles[background1.globalStyleId])),
            desktop: alignmentStyles,
            tablet: tabletAlignment,
            mobile: mobileAlignment,
            children: renderImages(background1)
        })
    });
};
/* harmony default export */ var Media_Media = (Media);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Elements/TextBlock/TextBlock.tsx








var TextBlock = function(props) {
    var renderText = function(background1Template) {
        var content = getContent(props.obj, "posts", props.overrides);
        if (content && content.length > 0) {
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            return content.map(function(post, idx) {
                var columns = bobHandler_handleColumns(idx, counter, background1Template, props.pageResponse.globalStyles[background1Template.globalStyleId]);
                counter = columns.counter;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        position: props.position,
                        pageResponse: props.pageResponse,
                        instanceId: props.obj.selectedInstanceId,
                        object: props.obj,
                        objectId: props.obj.uuid,
                        post: post,
                        inlineContent: props.obj.content.inlineContent,
                        overrides: props.overrides,
                        field: "text1",
                        tag: "p",
                        value: getStringField(post, props.obj, props.pageResponse, "text1", props.overrides),
                        template: props.obj.styles,
                        rules: props.componentRule,
                        expManager: props.expManager,
                        network: post.network,
                        className: "title"
                    })
                }, idx);
            });
        } else {
            if (props.expManager.enable) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-sm-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warningSystem, {
                        alertType: "alert-secondary w-100 text-center",
                        messages: "Add a single post or a feed"
                    })
                });
            }
        }
    };
    /**
   * Responsive Alignment Styles
   */ var background1 = props.obj.styles.bobs.background1;
    var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "elements text",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
            className: "row ".concat(bobHandler_responsiveGuttersClass(background1, props.pageResponse.globalStyles[background1.globalStyleId])),
            desktop: alignmentStyles,
            tablet: tabletAlignment,
            mobile: mobileAlignment,
            children: renderText(background1)
        })
    });
};
/* harmony default export */ var TextBlock_TextBlock = (TextBlock);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Elements/Buttons/Button/Button.tsx
















var Button = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Button, _Component);
    var _super = (0,_create_super/* default */.Z)(Button);
    function Button(props) {
        (0,src_class_call_check/* default */.Z)(this, Button);
        var _this;
        _this = _super.call(this, props);
        _this.child = [];
        _this.state = {
            isHover: false
        };
        _this.buttonOnHover = _this.buttonOnHover.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.buttonUnHover = _this.buttonUnHover.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    var _proto = Button.prototype;
    _proto.buttonOnHover = function buttonOnHover() {
        this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this.state), {
            isHover: true
        }));
    };
    _proto.buttonUnHover = function buttonUnHover() {
        this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this.state), {
            isHover: false
        }));
    };
    /**
   *
   * @param {postIdx} idx
   * We need this idx from the post array
   * to properly call the inner function down the react tree.
   * if we dont use this we overwrite the same ref over and over
   * leaving only the reference to the last rendered object.
   */ _proto.handleButtonClick = function handleButtonClick(buttonLabel, idx, slug) {
        clickEvent("button-".concat(buttonLabel), "CTA");
        if (this.child && this.child[idx]) this.child[idx].handleInnerFunction(slug);
    };
    _proto.renderComponents = function renderComponents(post, postIdx) {
        var componentsId = this.props.obj.children;
        if (componentsId && componentsId.length > 0) {
            var _this = this;
            return componentsId.map(function(componentId, idx) {
                var _this1 = _this;
                var handledItem = handleObjectType(_this.props.obj, componentId, _this.props.pageResponse, _this.props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                    position: idx,
                    selectedInstanceId: _this.props.obj.selectedInstanceId,
                    onRef: function(ref) {
                        return _this1.child[postIdx] = ref;
                    },
                    component: handleContentBlock(handledItem, post, _this.props.obj, _this.props.pageResponse, _this.props.overrides),
                    pageResponse: _this.props.pageResponse,
                    matchOrder: _this.props.matchOrder,
                    expManager: _this.props.expManager
                }, idx);
            });
        }
    };
    _proto.renderButton = function renderButton(background1Template) {
        var content = getContent(this.props.obj, "posts", this.props.overrides);
        if (content && content.length > 0) {
            var _this = this;
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            return content.map(function(post, idx) {
                var _this1 = _this;
                var columns = bobHandler_handleColumns(idx, counter, background1Template, _this.props.pageResponse.globalStyles[background1Template.globalStyleId]);
                counter = columns.counter;
                var buttonLabel = getStringField(post, _this.props.obj, _this.props.pageResponse, "text1", _this.props.overrides);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(bobComponentHandler, {
                            position: _this.props.position,
                            pageResponse: _this.props.pageResponse,
                            instanceId: _this.props.obj.selectedInstanceId,
                            object: _this.props.obj,
                            objectId: _this.props.obj.objectUuid,
                            post: post,
                            inlineContent: _this.props.obj.content.inlineContent,
                            overrides: _this.props.overrides,
                            field: "background2",
                            rules: _this.props.componentRule,
                            template: _this.props.obj.styles,
                            expManager: _this.props.expManager,
                            className: "btn btn-fluxio btn-lg",
                            tag: "a",
                            onClick: function() {
                                return _this1.handleButtonClick(buttonLabel, idx, post === null || post === void 0 ? void 0 : post.slug);
                            },
                            onMouseEnter: _this.buttonOnHover,
                            onMouseLeave: _this.buttonUnHover,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                    position: _this.props.position,
                                    pageResponse: _this.props.pageResponse,
                                    replacedMediaList: _this.props.replacedMediaList,
                                    instanceId: _this.props.obj.selectedInstanceId,
                                    object: _this.props.obj,
                                    objectId: _this.props.obj.objectUuid,
                                    inlineContent: _this.props.obj.content.inlineContent,
                                    overrides: _this.props.overrides,
                                    field: "media1",
                                    template: _this.props.obj.styles,
                                    rules: _this.props.componentRule,
                                    expManager: _this.props.expManager,
                                    network: post.network,
                                    post: post,
                                    className: _this.state.isHover ? "isHover" : ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                    position: _this.props.position,
                                    pageResponse: _this.props.pageResponse,
                                    instanceId: _this.props.obj.selectedInstanceId,
                                    object: _this.props.obj,
                                    objectId: _this.props.obj.objectUuid,
                                    post: post,
                                    inlineContent: _this.props.obj.content.inlineContent,
                                    overrides: _this.props.overrides,
                                    field: "text1",
                                    tag: "p",
                                    value: buttonLabel,
                                    template: _this.props.obj.styles,
                                    rules: _this.props.componentRule,
                                    expManager: _this.props.expManager,
                                    network: post.network,
                                    className: "label ".concat(_this.state.isHover ? "isHover" : "")
                                })
                            ]
                        }),
                        _this.renderComponents(post, idx)
                    ]
                }, idx);
            });
        } else {
            if (this.props.expManager.enable) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-sm-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warningSystem, {
                        alertType: "alert-secondary w-100 text-center",
                        messages: "Add a single post or a feed"
                    })
                });
            }
        }
    };
    _proto.render = function render() {
        /**
     * Responsive Alignment Styles
     */ var background1 = this.props.obj.styles.bobs.background1;
        var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "elements button",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
                className: "row ".concat(bobHandler_responsiveGuttersClass(background1, this.props.pageResponse.globalStyles[background1.globalStyleId])),
                desktop: alignmentStyles,
                tablet: tabletAlignment,
                mobile: mobileAlignment,
                children: this.renderButton(background1)
            })
        });
    };
    return Button;
}(react.Component);
/* harmony default export */ var Button_Button = (Button);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Elements/Buttons/ButtonRight/ButtonRight.tsx
















var ButtonRight = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ButtonRight, _Component);
    var _super = (0,_create_super/* default */.Z)(ButtonRight);
    function ButtonRight(props) {
        (0,src_class_call_check/* default */.Z)(this, ButtonRight);
        var _this;
        _this = _super.call(this, props);
        _this.child = [];
        _this.state = {
            isHover: false
        };
        _this.buttonOnHover = _this.buttonOnHover.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.buttonUnHover = _this.buttonUnHover.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    var _proto = ButtonRight.prototype;
    _proto.buttonOnHover = function buttonOnHover() {
        this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this.state), {
            isHover: true
        }));
    };
    _proto.buttonUnHover = function buttonUnHover() {
        this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this.state), {
            isHover: false
        }));
    };
    /**
   *
   * @param {postIdx} idx
   * We need this idx from the post array
   * to properly call the inner function down the react tree.
   * if we dont use this we overwrite the same ref over and over
   * leaving only the reference to the last rendered object.
   */ _proto.handleButtonClick = function handleButtonClick(buttonLabel, idx) {
        clickEvent("button-".concat(buttonLabel), "CTA");
        if (this.child && this.child[idx]) this.child[idx].handleInnerFunction();
    };
    _proto.renderComponents = function renderComponents(post, postIdx) {
        var componentsId = this.props.obj.children;
        if (componentsId && componentsId.length > 0) {
            var _this = this;
            return componentsId.map(function(componentId, idx) {
                var _this1 = _this;
                var handledItem = handleObjectType(_this.props.obj, componentId, _this.props.pageResponse, _this.props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                    position: idx,
                    selectedInstanceId: _this.props.obj.selectedInstanceId,
                    onRef: function(ref) {
                        return _this1.child[postIdx] = ref;
                    },
                    component: handleContentBlock(handledItem, post, _this.props.obj, _this.props.pageResponse, _this.props.overrides),
                    pageResponse: _this.props.pageResponse,
                    matchOrder: _this.props.matchOrder,
                    expManager: _this.props.expManager
                }, idx);
            });
        }
    };
    _proto.renderButton = function renderButton(background1Template) {
        var content = getContent(this.props.obj, "posts", this.props.overrides);
        if (content && content.length > 0) {
            var _this = this;
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            return content.map(function(post, idx) {
                var _this1 = _this;
                var columns = bobHandler_handleColumns(idx, counter, background1Template, _this.props.pageResponse.globalStyles[background1Template.globalStyleId]);
                counter = columns.counter;
                var buttonLabel = getStringField(post, _this.props.obj, _this.props.pageResponse, "text1", _this.props.overrides);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(bobComponentHandler, {
                            position: _this.props.position,
                            pageResponse: _this.props.pageResponse,
                            instanceId: _this.props.obj.selectedInstanceId,
                            object: _this.props.obj,
                            objectId: _this.props.obj.objectUuid,
                            post: post,
                            inlineContent: _this.props.obj.content.inlineContent,
                            overrides: _this.props.overrides,
                            field: "background2",
                            rules: _this.props.componentRule,
                            template: _this.props.obj.styles,
                            expManager: _this.props.expManager,
                            className: "btn btn-fluxio btn-lg",
                            tag: "a",
                            onClick: function() {
                                return _this1.handleButtonClick(buttonLabel, idx);
                            },
                            onMouseEnter: _this.buttonOnHover,
                            onMouseLeave: _this.buttonUnHover,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                    position: _this.props.position,
                                    pageResponse: _this.props.pageResponse,
                                    instanceId: _this.props.obj.selectedInstanceId,
                                    object: _this.props.obj,
                                    objectId: _this.props.obj.objectUuid,
                                    post: post,
                                    inlineContent: _this.props.obj.content.inlineContent,
                                    overrides: _this.props.overrides,
                                    field: "text1",
                                    tag: "p",
                                    value: buttonLabel,
                                    template: _this.props.obj.styles,
                                    rules: _this.props.componentRule,
                                    expManager: _this.props.expManager,
                                    network: post.network,
                                    className: "label ".concat(_this.state.isHover ? "isHover" : "")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                    position: _this.props.position,
                                    pageResponse: _this.props.pageResponse,
                                    replacedMediaList: _this.props.replacedMediaList,
                                    instanceId: _this.props.obj.selectedInstanceId,
                                    object: _this.props.obj,
                                    objectId: _this.props.obj.objectUuid,
                                    inlineContent: _this.props.obj.content.inlineContent,
                                    overrides: _this.props.overrides,
                                    field: "media1",
                                    template: _this.props.obj.styles,
                                    rules: _this.props.componentRule,
                                    expManager: _this.props.expManager,
                                    network: post.network,
                                    post: post,
                                    className: "".concat(_this.state.isHover ? "isHover" : "")
                                })
                            ]
                        }),
                        _this.renderComponents(post, idx)
                    ]
                }, idx);
            });
        } else {
            if (this.props.expManager.enable) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-sm-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warningSystem, {
                        alertType: "alert-secondary w-100 text-center",
                        messages: "Add a single post or a feed"
                    })
                });
            }
        }
    };
    _proto.render = function render() {
        /**
     * Responsive Alignment Styles
     */ var background1 = this.props.obj.styles.bobs.background1;
        var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "elements button button-right",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
                className: "row ".concat(bobHandler_responsiveGuttersClass(background1, this.props.pageResponse.globalStyles[background1.globalStyleId])),
                desktop: alignmentStyles,
                tablet: tabletAlignment,
                mobile: mobileAlignment,
                children: this.renderButton(background1)
            })
        });
    };
    return ButtonRight;
}(react.Component);
/* harmony default export */ var ButtonRight_ButtonRight = (ButtonRight);

// EXTERNAL MODULE: ./src/stylesheets/modules/templates/navbarComponent.module.sass
var navbarComponent_module = __webpack_require__(60769);
var navbarComponent_module_default = /*#__PURE__*/__webpack_require__.n(navbarComponent_module);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/navigation/navbar/navbar.tsx












var Navbar = function(props) {
    var ref = (0,react.useState)(false), showMenu = ref[0], setShowMenu = ref[1];
    var handleMenuToggle = function() {
        return setShowMenu(!showMenu);
    };
    var renderMenu = function(componentsId, background2Template) {
        if (componentsId && componentsId.length > 0) {
            return componentsId.map(function(componentId, idx) {
                var handledItem = handleObjectType(props.obj, componentId, props.pageResponse, props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                        position: idx,
                        selectedInstanceId: props.obj.selectedInstanceId,
                        component: handledItem,
                        pageResponse: props.pageResponse,
                        matchOrder: props.matchOrder,
                        expManager: props.expManager
                    })
                }, idx);
            });
        } else {
            if (props.expManager.enable) {
                var components = [];
                for(var i = 0; i < 3; i++){
                    var columns = "4";
                    components = (0,src_to_consumable_array/* default */.Z)(components).concat([
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "navbar-menu ".concat((navbarComponent_module_default())["navbar-menu"], " col-12 col-md-").concat(columns),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    height: "".concat(background2Template.height.value).concat(background2Template.height.unit),
                                    border: "3px dashed #dbe0e7"
                                }
                            })
                        }, i), 
                    ]);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(warningDefaultSystem, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row ".concat((navbarComponent_module_default()).row),
                        children: components
                    })
                });
            }
        }
    };
    var renderImage = function() {
        var content = getContent(props.obj, "posts");
        if (content && content.length > 0) {
            var post = content[0];
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "d-inline-flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        position: props.position,
                        pageResponse: props.pageResponse,
                        replacedMediaList: props.replacedMediaList,
                        instanceId: props.obj.selectedInstanceId,
                        object: props.obj,
                        objectId: props.obj.uuid,
                        inlineContent: props.obj.content.inlineContent,
                        overrides: props.overrides,
                        field: "media1",
                        template: props.obj.styles,
                        rules: props.componentRule,
                        expManager: props.expManager,
                        network: post.network,
                        post: post
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        position: props.position,
                        pageResponse: props.pageResponse,
                        instanceId: props.obj.selectedInstanceId,
                        object: props.obj,
                        objectId: props.obj.uuid,
                        inlineContent: props.obj.content.inlineContent,
                        overrides: props.overrides,
                        field: "text1",
                        post: post,
                        tag: "p",
                        value: getStringField(post, props.obj, props.pageResponse, "text1"),
                        template: props.obj.styles,
                        rules: props.componentRule,
                        expManager: props.expManager,
                        network: post.network,
                        className: "title text-nowrap"
                    })
                ]
            });
        }
    };
    var background1 = isBobBackground(props.obj.styles.bobs.background1);
    var background2 = isBobBackground(props.obj.styles.bobs.background2);
    var ref1 = alignment(background1), alignmentStyles = ref1.alignmentStyles, tabletAlignment = ref1.tabletAlignment, mobileAlignment = ref1.mobileAlignment;
    var ref2 = alignment(background2), alignmentStylesMenu = ref2.alignmentStyles, tabletAlignmentMenu = ref2.tabletAlignment, mobileAlignmentMenu = ref2.mobileAlignment;
    var childComponentsId = props.obj.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "navigation ".concat((navbarComponent_module_default()).navigation, " navbar-component ").concat((navbarComponent_module_default())["navbar-component"]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(alignmentHOC, {
            className: "row ".concat(bobHandler_responsiveGuttersClass(background1, props.pageResponse.globalStyles[background1.globalStyleId])),
            desktop: alignmentStyles,
            tablet: tabletAlignment,
            mobile: mobileAlignment,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12 col-md-4 navbar-identity",
                    children: [
                        renderImage(),
                        childComponentsId && childComponentsId.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "navbar-menu-toggle ".concat((navbarComponent_module_default())["navbar-menu-toggle"]),
                            onClick: handleMenuToggle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fas fa-bars"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-12 col-md-8 navbar-items ".concat((navbarComponent_module_default())["navbar-items"]),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        position: props.position,
                        pageResponse: props.pageResponse,
                        instanceId: props.obj.selectedInstanceId,
                        object: props.obj,
                        objectId: props.obj.uuid,
                        inlineContent: props.obj.content.inlineContent,
                        field: "background2",
                        rules: props.componentRule,
                        template: props.obj.styles,
                        expManager: props.expManager,
                        className: "navbar-menu ".concat((navbarComponent_module_default())["navbar-menu"]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
                            className: "navbar-menu-container ".concat((navbarComponent_module_default())["navbar-menu-container"], " ").concat(!showMenu ? "hide" : "show"),
                            desktop: alignmentStylesMenu,
                            tablet: tabletAlignmentMenu,
                            mobile: mobileAlignmentMenu,
                            children: renderMenu(childComponentsId, background2)
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var navbar = (Navbar);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/navigation/navbarTop/navbarTop.tsx










var NavbarTop = function(props) {
    var ref = (0,react.useState)(false), showMenu = ref[0], setShowMenu = ref[1];
    var handleMenuToggle = function() {
        return setShowMenu(!showMenu);
    };
    var renderMenu = function(childComponentsId, background2Template) {
        if (childComponentsId && childComponentsId.length > 0) {
            return childComponentsId.map(function(componentId, idx) {
                var handledItem = handleObjectType(props.obj, componentId, props.pageResponse, props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                        position: idx,
                        selectedInstanceId: props.obj.selectedInstanceId,
                        component: handledItem,
                        pageResponse: props.pageResponse,
                        matchOrder: props.matchOrder,
                        expManager: props.expManager
                    }, idx)
                }, idx);
            });
        } else {
            var ref;
            if ((ref = props.expManager) === null || ref === void 0 ? void 0 : ref.enable) {
                var components = [];
                for(var i = 0; i < 3; i++){
                    var columns = "4";
                    components = (0,src_to_consumable_array/* default */.Z)(components).concat([
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "navbar-menu ".concat((navbarComponent_module_default())["navbar-menu"], " col-12 col-md-").concat(columns),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    height: "".concat(background2Template.height.value).concat(background2Template.height.unit),
                                    border: "3px dashed #dbe0e7"
                                }
                            })
                        }, i), 
                    ]);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(warningDefaultSystem, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row ".concat((navbarComponent_module_default()).row),
                        children: components
                    })
                });
            }
        }
    };
    var renderImage = function() {
        var content = getContent(props.obj, "posts");
        if (content && content.length > 0) {
            var post = content[0];
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "d-inline-flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        position: props.position,
                        pageResponse: props.pageResponse,
                        replacedMediaList: props.replacedMediaList,
                        instanceId: props.obj.selectedInstanceId,
                        object: props.obj,
                        objectId: props.obj.uuid,
                        inlineContent: props.obj.content.inlineContent,
                        overrides: props.overrides,
                        field: "media1",
                        template: props.obj.styles,
                        rules: props.componentRule,
                        expManager: props.expManager,
                        network: post.network,
                        post: post
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        position: props.position,
                        pageResponse: props.pageResponse,
                        instanceId: props.obj.selectedInstanceId,
                        object: props.obj,
                        objectId: props.obj.uuid,
                        post: post,
                        inlineContent: props.obj.content.inlineContent,
                        overrides: props.overrides,
                        field: "text1",
                        tag: "p",
                        value: getStringField(post, props.obj, props.pageResponse, "text1"),
                        template: props.obj.styles,
                        rules: props.componentRule,
                        expManager: props.expManager,
                        network: post.network,
                        className: "title text-nowrap"
                    })
                ]
            });
        }
    };
    var background1 = props.obj.styles.bobs.background1;
    var background2 = props.obj.styles.bobs.background2;
    var alignmentAdittionalProperties = {
        flexDirection: "column",
        self: false
    };
    var ref1 = alignmentWithAP(background1, alignmentAdittionalProperties), alignmentStyles = ref1.alignmentStyles, tabletAlignment = ref1.tabletAlignment, mobileAlignment = ref1.mobileAlignment;
    var ref2 = alignment(background2), alignmentStylesMenu = ref2.alignmentStyles, tabletAlignmentMenu = ref2.tabletAlignment, mobileAlignmentMenu = ref2.mobileAlignment;
    var childComponentsId = props.obj.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "navigation ".concat((navbarComponent_module_default()).navigation, " navbar-component ").concat((navbarComponent_module_default())["navbar-component"], " navbar-top"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(alignmentHOC, {
            desktop: alignmentStyles,
            tablet: tabletAlignment,
            mobile: mobileAlignment,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "navbar-identity",
                    children: [
                        renderImage(),
                        childComponentsId && childComponentsId.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "navbar-menu-toggle ".concat((navbarComponent_module_default())["navbar-menu-toggle"]),
                            onClick: handleMenuToggle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fas fa-bars"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "navbar-items ".concat((navbarComponent_module_default())["navbar-items"]),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        position: props.position,
                        pageResponse: props.pageResponse,
                        instanceId: props.obj.selectedInstanceId,
                        object: props.obj,
                        objectId: props.obj.uuid,
                        inlineContent: props.obj.content.inlineContent,
                        field: "background2",
                        rules: props.componentRule,
                        template: props.obj.styles,
                        expManager: props.expManager,
                        className: "navbar-menu ".concat((navbarComponent_module_default())["navbar-menu"]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
                            className: "navbar-menu-container ".concat((navbarComponent_module_default())["navbar-menu-container"], " ").concat(!showMenu ? "hide" : "show"),
                            desktop: alignmentStylesMenu,
                            tablet: tabletAlignmentMenu,
                            mobile: mobileAlignmentMenu,
                            children: renderMenu(childComponentsId, background2)
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var navbarTop = (NavbarTop);

// EXTERNAL MODULE: ./src/stylesheets/modules/templates/navbarComponent_v2.module.sass
var navbarComponent_v2_module = __webpack_require__(60640);
var navbarComponent_v2_module_default = /*#__PURE__*/__webpack_require__.n(navbarComponent_v2_module);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/navigation/navbarV2/navbarV2.tsx











var NavbarComponentV2 = function(props) {
    var renderChildComponents = function(background2) {
        var componentsId = props.obj.children;
        if (componentsId && componentsId.length > 0) {
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            return componentsId.map(function(componentId, idx) {
                var handledItem = handleObjectType(props.obj, componentId, props.pageResponse, props.expManager.emEditorType);
                var columns = bobHandler_handleColumns(idx, counter, background2, props.pageResponse.globalStyles[background2.globalStyleId]);
                counter = columns.counter;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                        position: idx,
                        selectedInstanceId: props.obj.selectedInstanceId,
                        component: handledItem,
                        pageResponse: props.pageResponse,
                        matchOrder: props.matchOrder,
                        expManager: props.expManager
                    })
                }, idx);
            });
        } else {
            if (props.expManager.enable) {
                var counter1 = {
                    desktop: 0,
                    tablet: 0,
                    mobile: 0
                };
                var columns = bobHandler_handleColumns(1, counter1, background2, props.pageResponse.globalStyles[background2.globalStyleId]);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(warningDefaultSystem, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                height: "30px",
                                border: "3px dashed #dbe0e7"
                            }
                        })
                    }, 1)
                });
            }
        }
    };
    var renderMenu = function() {
        var background2 = isBobBackground(props.obj.styles.bobs.background2);
        var ref = alignment(background2), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
            className: "navbar-items-background ".concat((navbarComponent_v2_module_default())["navbar-items-background"]),
            position: props.position,
            pageResponse: props.pageResponse,
            instanceId: props.obj.selectedInstanceId,
            object: props.obj,
            objectId: props.obj.uuid,
            inlineContent: props.obj.content.inlineContent,
            field: "background2",
            rules: props.componentRule,
            template: props.obj.styles,
            expManager: props.expManager,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
                className: "row ".concat(bobHandler_responsiveGuttersClass(background2, props.pageResponse.globalStyles[background2.globalStyleId])),
                desktop: alignmentStyles,
                tablet: tabletAlignment,
                mobile: mobileAlignment,
                children: renderChildComponents(background2)
            })
        });
    };
    var renderIdentity = function() {
        var content = getContent(props.obj, "posts");
        if (content && content.length > 0) {
            var post = content[0];
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "d-inline-flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        position: props.position,
                        pageResponse: props.pageResponse,
                        replacedMediaList: props.replacedMediaList,
                        instanceId: props.obj.selectedInstanceId,
                        object: props.obj,
                        objectId: props.obj.uuid,
                        inlineContent: props.obj.content.inlineContent,
                        overrides: props.overrides,
                        field: "media1",
                        template: props.obj.styles,
                        rules: props.componentRule,
                        expManager: props.expManager,
                        network: post.network,
                        post: post
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        position: props.position,
                        pageResponse: props.pageResponse,
                        instanceId: props.obj.selectedInstanceId,
                        object: props.obj,
                        objectId: props.obj.uuid,
                        inlineContent: props.obj.content.inlineContent,
                        overrides: props.overrides,
                        field: "text1",
                        post: post,
                        tag: "p",
                        value: getStringField(post, props.obj, props.pageResponse, "text1"),
                        template: props.obj.styles,
                        rules: props.componentRule,
                        expManager: props.expManager,
                        network: post.network,
                        className: "title text-nowrap"
                    })
                ]
            });
        }
    };
    var background1 = props.obj.styles.bobs.background1;
    var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
    var columnsLeft = bobHandler_handleColumns(0, {
        desktop: 0,
        tablet: 0,
        mobile: 0
    }, background1, props.pageResponse.globalStyles[background1.globalStyleId]);
    var columnsRight = bobHandler_handleColumns(1, {
        desktop: 0,
        tablet: 0,
        mobile: 0
    }, background1, props.pageResponse.globalStyles[background1.globalStyleId]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "navigation ".concat((navbarComponent_v2_module_default()).navigation, " navbar-component_v2 ").concat((navbarComponent_v2_module_default())["navbar-component_v2"]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "row ".concat(bobHandler_responsiveGuttersClass(background1, props.pageResponse.globalStyles[background1.globalStyleId])),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "navbar-identity ".concat((navbarComponent_v2_module_default())["navbar-identity"], " col-").concat(columnsLeft.columnsMobile, " col-md-").concat(columnsLeft.columnsTablet, " col-lg-").concat(columnsLeft.columns),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
                        className: "navbar-identity-container ".concat((navbarComponent_v2_module_default())["navbar-identity-container"]),
                        desktop: alignmentStyles,
                        tablet: tabletAlignment,
                        mobile: mobileAlignment,
                        children: renderIdentity()
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "navbar-items ".concat((navbarComponent_v2_module_default())["navbar-items"], " col-").concat(columnsRight.columnsMobile, " col-md-").concat(columnsRight.columnsTablet, " col-lg-").concat(columnsRight.columns),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
                        className: "navbar-items-container ".concat((navbarComponent_v2_module_default())["navbar-items-container"]),
                        desktop: alignmentStyles,
                        tablet: tabletAlignment,
                        mobile: mobileAlignment,
                        children: renderMenu()
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var navbarV2 = (NavbarComponentV2);

// EXTERNAL MODULE: ./src/stylesheets/modules/templates/menuComponent.module.sass
var menuComponent_module = __webpack_require__(67934);
var menuComponent_module_default = /*#__PURE__*/__webpack_require__.n(menuComponent_module);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/navigation/menu/menu.tsx












var Menu = function(props) {
    var ref = (0,react.useState)(false), showMenu = ref[0], setShowMenu = ref[1];
    var handleMenuToggle = function() {
        return setShowMenu(!showMenu);
    };
    var renderMenu = function(componentsId) {
        if (componentsId && componentsId.length > 0) {
            return componentsId.map(function(componentId, idx) {
                var handledItem = handleObjectType(props.obj, componentId, props.pageResponse, props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                        position: idx,
                        selectedInstanceId: props.obj.selectedInstanceId,
                        component: handledItem,
                        pageResponse: props.pageResponse,
                        matchOrder: props.matchOrder,
                        expManager: props.expManager
                    }, idx)
                }, idx);
            });
        } else {
            if (props.expManager.enable) {
                var Background2 = isBobBackground(props.obj.styles.bobs.background2);
                var components = [];
                for(var i = 0; i < 3; i++){
                    var columns = "4";
                    components = (0,src_to_consumable_array/* default */.Z)(components).concat([
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "navbar-menu col-12 col-md-".concat(columns),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    height: "".concat(Background2.height.value).concat(Background2.height.unit),
                                    border: "3px dashed #dbe0e7"
                                }
                            })
                        }, i), 
                    ]);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(warningDefaultSystem, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: components
                    })
                });
            }
        }
    };
    var background1 = isBobBackground(props.obj.styles.bobs.background1);
    var ref1 = alignment(background1), alignmentStyles = ref1.alignmentStyles, tabletAlignment = ref1.tabletAlignment, mobileAlignment = ref1.mobileAlignment;
    var columns = background1.grid.columns[0];
    var childComponentsId = props.obj.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "navigation ".concat((menuComponent_module_default()).navigation, " menu-component ").concat((menuComponent_module_default())["menu-component"]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
            className: "main-menu ".concat((menuComponent_module_default())["main-menu"], " row ").concat(bobHandler_responsiveGuttersClass(background1, props.pageResponse.globalStyles[background1.globalStyleId])),
            desktop: alignmentStyles,
            tablet: tabletAlignment,
            mobile: mobileAlignment,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-12 col-md-".concat(columns),
                children: [
                    childComponentsId && childComponentsId.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "main-menu-toggle ".concat((menuComponent_module_default())["main-menu-toggle"]),
                        onClick: handleMenuToggle,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fas fa-bars"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        position: props.position,
                        pageResponse: props.pageResponse,
                        instanceId: props.obj.selectedInstanceId,
                        object: props.obj,
                        objectId: props.obj.uuid,
                        inlineContent: props.obj.content.inlineContent,
                        field: "background2",
                        rules: props.componentRule,
                        template: props.obj.styles,
                        expManager: props.expManager,
                        className: "main-menu-container ".concat((menuComponent_module_default())["main-menu-container"], " ").concat(!showMenu ? "hide" : "show"),
                        children: renderMenu(childComponentsId)
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var menu = (Menu);

// EXTERNAL MODULE: ./src/stylesheets/modules/templates/menuComponentV2.module.sass
var menuComponentV2_module = __webpack_require__(33944);
var menuComponentV2_module_default = /*#__PURE__*/__webpack_require__.n(menuComponentV2_module);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/navigation/menuV2/menuV2.tsx













var MenuV2 = function(props) {
    var ref = (0,react.useState)(false), showMenu = ref[0], _setShowMenu = ref[1];
    var ref1 = (0,react.useState)("row"), flexDirection = ref1[0], setFlexDirection = ref1[1];
    var showMenuRef = (0,react.useRef)(showMenu);
    var setShowMenu = function(data) {
        showMenuRef.current = data;
        _setShowMenu(data);
    };
    (0,react.useEffect)(function() {
        getFrame();
        return function() {
            return removeFrame();
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0,react.useEffect)(function() {
        disableBodyScroll(props.expManager, showMenu);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        showMenu
    ]);
    var getFrame = function() {
        /**
     * handle window for page builder iframe or public pages
     */ var iframe = document.getElementById("board-preview-frame");
        var handledWindow = (iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) || window;
        /**
     * Add resize eventListener
     * check window size on mount
     */ handledWindow.addEventListener("resize", function() {
            return windowResized(handledWindow);
        });
        windowResized(handledWindow);
        /**
     * Add click eventListener
     */ handledWindow.addEventListener("click", function(e) {
            return anchorClicked(e);
        });
    };
    var removeFrame = function() {
        /**
     * handle document and window for page builder iframe or public pages
     */ var iframe = document.getElementById("board-preview-frame");
        var handledWindow = (iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) || window;
        /**
     * Clean resize eventListeners
     */ handledWindow.removeEventListener("resize", function() {
            return windowResized(handledWindow);
        });
        /**
     * Clean click reventListeners
     */ handledWindow.removeEventListener("click", function(e) {
            return anchorClicked(e);
        });
    };
    /**
   * in mobile the menu container flex direction is forced to column
   * because of this the alignment logic must be switched to column too
   */ var windowResized = function(window1) {
        if (window1.matchMedia("(max-width: 768px)").matches) setFlexDirection("column");
        else setFlexDirection("row");
    };
    /**
   * close menu on anchor link click
   */ var anchorClicked = function(e) {
        var link = e.target.closest("a");
        if (link) {
            var linkHref = link.getAttribute("href");
            // anchor was clicked, close menu
            if (linkHref === null || linkHref === void 0 ? void 0 : linkHref.startsWith("#")) {
                if (showMenuRef.current) setShowMenu(false);
            }
        }
    };
    var handleMenuToggle = function() {
        return setShowMenu(!showMenu);
    };
    var renderMenu = function(componentsId) {
        if (componentsId && componentsId.length > 0) {
            return componentsId.map(function(componentId, idx) {
                var handledItem = handleObjectType(props.obj, componentId, props.pageResponse, props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "main-menu-item ".concat((menuComponentV2_module_default())["main-menu-item"]),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                        position: idx,
                        selectedInstanceId: props.obj.selectedInstanceId,
                        component: handledItem,
                        pageResponse: props.pageResponse,
                        matchOrder: props.matchOrder,
                        expManager: props.expManager
                    }, idx)
                }, idx);
            });
        } else {
            if (props.expManager.enable) {
                var components = [];
                for(var i = 0; i < 3; i++){
                    var columns = "4";
                    components = (0,src_to_consumable_array/* default */.Z)(components).concat([
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "navbar-menu col-12 col-md-".concat(columns),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    height: "".concat(isBobBackground(props.obj.styles.bobs.background2).height.value).concat(isBobBackground(props.obj.styles.bobs.background2).height.unit),
                                    border: "3px dashed #dbe0e7"
                                }
                            })
                        }, i), 
                    ]);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(warningDefaultSystem, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: components
                    })
                });
            }
        }
    };
    var background1 = isBobBackground(props.obj.styles.bobs.background1);
    var ref2 = alignment(background1), alignmentStyles = ref2.alignmentStyles, tabletAlignment = ref2.tabletAlignment, mobileAlignment = ref2.mobileAlignment;
    var columns = bobHandler_handleColumns(0, {
        desktop: 0,
        tablet: 0,
        mobile: 0
    }, background1, props.pageResponse.globalStyles[background1.globalStyleId]);
    var childComponentsId = props.obj.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "navigation ".concat((menuComponent_module_default()).navigation, " ").concat((menuComponentV2_module_default()).navigation, " menu-component_v2 ").concat((menuComponentV2_module_default())["menu-component_v2"]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
            className: "main-menu ".concat((menuComponentV2_module_default())["main-menu"], " row ").concat(bobHandler_responsiveGuttersClass(background1, props.pageResponse.globalStyles[background1.globalStyleId])),
            desktop: alignmentStyles,
            tablet: tabletAlignment,
            mobile: mobileAlignment,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                children: [
                    childComponentsId && childComponentsId.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        position: props.position,
                        pageResponse: props.pageResponse,
                        instanceId: props.obj.selectedInstanceId,
                        object: props.obj,
                        objectId: props.obj.uuid,
                        field: "icon1",
                        template: props.obj.styles,
                        rules: props.componentRule,
                        expManager: props.expManager,
                        iconClassName: "fas fa-bars",
                        className: "main-menu-toggle ".concat((menuComponentV2_module_default())["main-menu-toggle"]),
                        onClick: handleMenuToggle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(bobComponentHandler, {
                        position: props.position,
                        pageResponse: props.pageResponse,
                        instanceId: props.obj.selectedInstanceId,
                        object: props.obj,
                        objectId: props.obj.uuid,
                        inlineContent: props.obj.content.inlineContent,
                        flexDirection: flexDirection,
                        field: "background2",
                        rules: props.componentRule,
                        template: props.obj.styles,
                        expManager: props.expManager,
                        className: "main-menu-container ".concat((menuComponentV2_module_default())["main-menu-container"], " ").concat(!showMenu ? "hide" : "show"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                position: props.position,
                                pageResponse: props.pageResponse,
                                instanceId: props.obj.selectedInstanceId,
                                object: props.obj,
                                objectId: props.obj.uuid,
                                field: "icon2",
                                template: props.obj.styles,
                                rules: props.componentRule,
                                expManager: props.expManager,
                                iconClassName: "fas fa-times",
                                className: "main-menu-close ".concat((menuComponentV2_module_default())["main-menu-close"]),
                                onClick: handleMenuToggle
                            }),
                            renderMenu(childComponentsId)
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var menuV2 = (MenuV2);

// EXTERNAL MODULE: ./src/stylesheets/modules/templates/menuToggleComponent.module.sass
var menuToggleComponent_module = __webpack_require__(73927);
var menuToggleComponent_module_default = /*#__PURE__*/__webpack_require__.n(menuToggleComponent_module);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/navigation/menuToggle/menuToggle.tsx

















var MenuToggle = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(MenuToggle, _Component);
    var _super = (0,_create_super/* default */.Z)(MenuToggle);
    function MenuToggle(props) {
        (0,src_class_call_check/* default */.Z)(this, MenuToggle);
        var _this;
        _this = _super.call(this, props);
        /**
   * close menu on anchor link click
   */ _this.anchorClicked = function(e) {
            if (_this.state.showMenu) {
                var ref;
                var link = (ref = e.target) === null || ref === void 0 ? void 0 : ref.closest("a");
                if (link) {
                    var linkHref = link.getAttribute("href");
                    // anchor was clicked, close menu
                    if (linkHref === null || linkHref === void 0 ? void 0 : linkHref.startsWith("#")) {
                        _this.handleMenuToggle();
                    }
                }
            }
        };
        _this.handleMenuToggle = function() {
            _this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, _this.state), {
                showMenu: !_this.state.showMenu
            }), function() {
                return disableBodyScroll(_this.props.expManager, _this.state.showMenu);
            });
        };
        _this.state = {
            showMenu: false
        };
        return _this;
    }
    var _proto = MenuToggle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        /**
     * handle window for page builder iframe or public pages
     */ var iframe = document.getElementById("board-preview-frame");
        var handledWindow = (iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) || window;
        handledWindow.addEventListener("click", function(e) {
            return _this.anchorClicked(e);
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var _this = this;
        /**
     * handle document and window for page builder iframe or public pages
     */ var iframe = document.getElementById("board-preview-frame");
        var handledWindow = (iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) || window;
        handledWindow.removeEventListener("click", function(e) {
            return _this.anchorClicked(e);
        });
    };
    _proto.renderMenu = function renderMenu(componentsId) {
        if (componentsId && componentsId.length > 0) {
            var _this = this;
            return componentsId.map(function(componentId, idx) {
                var handledItem = handleObjectType(_this.props.obj, componentId, _this.props.pageResponse, _this.props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "main-menu-item ".concat((menuToggleComponent_module_default())["main-menu-item"]),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                        position: idx,
                        selectedInstanceId: _this.props.obj.selectedInstanceId,
                        component: handledItem,
                        pageResponse: _this.props.pageResponse,
                        matchOrder: _this.props.matchOrder,
                        expManager: _this.props.expManager
                    }, idx)
                }, idx);
            });
        } else {
            if (this.props.expManager.enable) {
                var components = [];
                for(var i = 0; i < 3; i++){
                    var columns = "4";
                    components = (0,src_to_consumable_array/* default */.Z)(components).concat([
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "navbar-menu col-12 col-md-".concat(columns),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    height: "".concat(isBobBackground(this.props.obj.styles.bobs.background2).height.value).concat(isBobBackground(this.props.obj.styles.bobs.background2).height.unit),
                                    border: "3px dashed #dbe0e7"
                                }
                            })
                        }, i), 
                    ]);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(warningDefaultSystem, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: components
                    })
                });
            }
        }
    };
    _proto.render = function render() {
        var background1 = isBobBackground(this.props.obj.styles.bobs.background1);
        var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
        var columns = bobHandler_handleColumns(0, {
            desktop: 0,
            tablet: 0,
            mobile: 0
        }, background1, this.props.pageResponse.globalStyles[background1.globalStyleId]);
        var childComponentsId = this.props.obj.children;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "navigation ".concat((menuToggleComponent_module_default()).navigation, " menu-toggle-component ").concat((menuToggleComponent_module_default())["menu-toggle-component"]),
            children: [
                this.state.showMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: this.handleMenuToggle,
                    className: "fade modal-backdrop modal-component-backdrop show"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
                    className: "main-menu ".concat((menuToggleComponent_module_default())["main-menu"], " row ").concat(bobHandler_responsiveGuttersClass(background1, this.props.pageResponse.globalStyles[background1.globalStyleId])),
                    desktop: alignmentStyles,
                    tablet: tabletAlignment,
                    mobile: mobileAlignment,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                        children: [
                            childComponentsId && childComponentsId.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                position: this.props.position,
                                pageResponse: this.props.pageResponse,
                                instanceId: this.props.obj.selectedInstanceId,
                                object: this.props.obj,
                                objectId: this.props.obj.uuid,
                                field: "icon1",
                                template: this.props.obj.styles,
                                rules: this.props.componentRule,
                                expManager: this.props.expManager,
                                iconClassName: "fas fa-bars",
                                className: "main-menu-toggle ".concat((menuToggleComponent_module_default())["main-menu-toggle"]),
                                onClick: this.handleMenuToggle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(bobComponentHandler, {
                                position: this.props.position,
                                pageResponse: this.props.pageResponse,
                                instanceId: this.props.obj.selectedInstanceId,
                                object: this.props.obj,
                                objectId: this.props.obj.uuid,
                                inlineContent: this.props.obj.content.inlineContent,
                                overrides: this.props.overrides,
                                field: "background2",
                                rules: this.props.componentRule,
                                template: this.props.obj.styles,
                                expManager: this.props.expManager,
                                flexDirection: "column",
                                className: "main-menu-container ".concat((menuToggleComponent_module_default())["main-menu-container"], " ").concat(!this.state.showMenu ? "hide ".concat((menuToggleComponent_module_default()).hide) : "show"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: this.props.position,
                                        pageResponse: this.props.pageResponse,
                                        instanceId: this.props.obj.selectedInstanceId,
                                        object: this.props.obj,
                                        objectId: this.props.obj.uuid,
                                        field: "icon2",
                                        template: this.props.obj.styles,
                                        rules: this.props.componentRule,
                                        expManager: this.props.expManager,
                                        iconClassName: "fas fa-times",
                                        className: "main-menu-close ".concat((menuToggleComponent_module_default())["main-menu-close"], " ").concat(!this.state.showMenu ? "hide ".concat((menuToggleComponent_module_default()).hide) : "show"),
                                        onClick: this.handleMenuToggle
                                    }),
                                    this.renderMenu(childComponentsId)
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    };
    return MenuToggle;
}(react.Component);
/* harmony default export */ var menuToggle = (MenuToggle);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/navigation/menuToggleV2/menuToggleV2.tsx















var MenuToggleV2 = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(MenuToggleV2, _Component);
    var _super = (0,_create_super/* default */.Z)(MenuToggleV2);
    function MenuToggleV2(props) {
        (0,src_class_call_check/* default */.Z)(this, MenuToggleV2);
        var _this;
        _this = _super.call(this, props);
        /**
   * close menu on anchor link click
   */ _this.anchorClicked = function(e) {
            if (_this.state.showMenu) {
                var ref;
                var link = (ref = e.target) === null || ref === void 0 ? void 0 : ref.closest("a");
                if (link) {
                    var linkHref = link.getAttribute("href");
                    // anchor was clicked, close menu
                    if (linkHref === null || linkHref === void 0 ? void 0 : linkHref.startsWith("#")) {
                        _this.handleMenuToggle();
                    }
                }
            }
        };
        _this.handleMenuToggle = function() {
            _this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, _this.state), {
                showMenu: !_this.state.showMenu
            }), function() {
                return disableBodyScroll(_this.props.expManager, _this.state.showMenu);
            });
        };
        _this.renderToggle = function() {
            var content = getContent(_this.props.obj, "posts");
            if (content && content.length > 0) {
                var post = content[0];
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "d-flex is-clickable",
                    onClick: _this.handleMenuToggle,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: _this.props.position,
                            pageResponse: _this.props.pageResponse,
                            instanceId: _this.props.obj.selectedInstanceId,
                            object: _this.props.obj,
                            objectId: _this.props.obj.uuid,
                            post: post,
                            inlineContent: _this.props.obj.content.inlineContent,
                            overrides: _this.props.overrides,
                            field: "text1",
                            tag: "p",
                            value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text1", _this.props.overrides),
                            template: _this.props.obj.styles,
                            rules: _this.props.componentRule,
                            expManager: _this.props.expManager,
                            className: "main-menu-toggle-text w-auto"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: _this.props.position,
                            pageResponse: _this.props.pageResponse,
                            instanceId: _this.props.obj.selectedInstanceId,
                            object: _this.props.obj,
                            objectId: _this.props.obj.uuid,
                            field: "icon1",
                            template: _this.props.obj.styles,
                            rules: _this.props.componentRule,
                            expManager: _this.props.expManager,
                            iconClassName: "fas fa-bars",
                            className: "main-menu-toggle ".concat((menuToggleComponent_module_default())["main-menu-toggle"])
                        })
                    ]
                });
            }
        };
        _this.state = {
            showMenu: false
        };
        return _this;
    }
    var _proto = MenuToggleV2.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        /**
     * handle window for page builder iframe or public pages
     */ var iframe = document.getElementById("board-preview-frame");
        var handledWindow = (iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) || window;
        handledWindow.addEventListener("click", function(e) {
            return _this.anchorClicked(e);
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var _this = this;
        /**
     * handle document and window for page builder iframe or public pages
     */ var iframe = document.getElementById("board-preview-frame");
        var handledWindow = (iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) || window;
        handledWindow.removeEventListener("click", function(e) {
            return _this.anchorClicked(e);
        });
    };
    _proto.renderMenu = function renderMenu(componentsId) {
        if (componentsId && componentsId.length > 0) {
            var _this = this;
            return componentsId.map(function(componentId, idx) {
                var handledItem = handleObjectType(_this.props.obj, componentId, _this.props.pageResponse, _this.props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "main-menu-item ".concat((menuToggleComponent_module_default())["main-menu-item"]),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                        position: idx,
                        selectedInstanceId: _this.props.obj.selectedInstanceId,
                        component: handledItem,
                        pageResponse: _this.props.pageResponse,
                        matchOrder: _this.props.matchOrder,
                        expManager: _this.props.expManager
                    }, idx)
                }, idx);
            });
        }
    };
    _proto.render = function render() {
        var background1 = isBobBackground(this.props.obj.styles.bobs.background1);
        var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
        var childComponentsId = this.props.obj.children;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "navigation ".concat((menuToggleComponent_module_default()).navigation, " menu-toggle-component ").concat((menuToggleComponent_module_default())["menu-toggle-component"]),
            children: [
                this.state.showMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: this.handleMenuToggle,
                    className: "fade modal-backdrop modal-component-backdrop show"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(alignmentHOC, {
                    className: "main-menu ".concat((menuToggleComponent_module_default())["main-menu"], " ").concat(bobHandler_responsiveGuttersClass(background1, this.props.pageResponse.globalStyles[background1.globalStyleId])),
                    desktop: alignmentStyles,
                    tablet: tabletAlignment,
                    mobile: mobileAlignment,
                    children: [
                        this.renderToggle(),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(bobComponentHandler, {
                            position: this.props.position,
                            pageResponse: this.props.pageResponse,
                            instanceId: this.props.obj.selectedInstanceId,
                            object: this.props.obj,
                            objectId: this.props.obj.uuid,
                            inlineContent: this.props.obj.content.inlineContent,
                            overrides: this.props.overrides,
                            field: "background2",
                            rules: this.props.componentRule,
                            template: this.props.obj.styles,
                            expManager: this.props.expManager,
                            flexDirection: "column",
                            className: "main-menu-container ".concat((menuToggleComponent_module_default())["main-menu-container"], " ").concat(!this.state.showMenu ? "hide ".concat((menuToggleComponent_module_default()).hide) : "show"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                    position: this.props.position,
                                    pageResponse: this.props.pageResponse,
                                    instanceId: this.props.obj.selectedInstanceId,
                                    object: this.props.obj,
                                    objectId: this.props.obj.uuid,
                                    field: "icon2",
                                    template: this.props.obj.styles,
                                    rules: this.props.componentRule,
                                    expManager: this.props.expManager,
                                    iconClassName: "fas fa-times",
                                    className: "main-menu-close ".concat((menuToggleComponent_module_default())["main-menu-close"], " ").concat(!this.state.showMenu ? "hide ".concat((menuToggleComponent_module_default()).hide) : "show"),
                                    onClick: this.handleMenuToggle
                                }),
                                this.renderMenu(childComponentsId)
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return MenuToggleV2;
}(react.Component);
/* harmony default export */ var menuToggleV2 = (MenuToggleV2);

// EXTERNAL MODULE: ./src/stylesheets/modules/templates/elementModal.module.sass
var elementModal_module = __webpack_require__(78338);
var elementModal_module_default = /*#__PURE__*/__webpack_require__.n(elementModal_module);
;// CONCATENATED MODULE: ./src/areas/public-page/fluxio-components/Elements/Modals/Modal/Modal.tsx














var Modal = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Modal, _Component);
    var _super = (0,_create_super/* default */.Z)(Modal);
    function Modal(props) {
        (0,src_class_call_check/* default */.Z)(this, Modal);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            showModal: false
        };
        _this.handleModal = _this.handleModal.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.handleModalContainerClick = _this.handleModalContainerClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.handleBackgroundClick = _this.handleBackgroundClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.handleInnerFunction = _this.handleInnerFunction.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    var _proto = Modal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        // access inner methods from parent
        if (this.props.onRef) this.props.onRef(this);
        else return;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        // access inner methods from parent
        if (this.props.onRef) this.props.onRef(undefined);
        else return;
    };
    _proto.handleInnerFunction = function handleInnerFunction() {
        this.handleModal();
    };
    _proto.handleModal = function handleModal(post) {
        var _this = this;
        this.setState({
            showModal: !this.state.showModal
        }, function() {
            if (!_this.props.expManager.enable && post) {
                if (_this.state.showModal) _this.props.router.push(handler(_this.props.router, _this.props.matchOrder, post.slug), undefined, {
                    scroll: false
                });
                else _this.props.router.push(handler(_this.props.router, _this.props.matchOrder, ""), undefined, {
                    scroll: false
                });
            }
        });
    };
    _proto.handleBackgroundClick = function handleBackgroundClick(e) {
        e.stopPropagation();
        /**
     * This trigger works when the user clicks outside of the modal body
     */ this.handleModal();
    };
    _proto.handleModalContainerClick = function handleModalContainerClick(e) {
        e.stopPropagation();
    };
    _proto.renderModalComponents = function renderModalComponents(post) {
        var _this = this;
        var componentsId = this.props.obj.children;
        if (componentsId && componentsId.length > 0) return componentsId.map(function(componentId, idx) {
            var handledItem = handleObjectType(_this.props.obj, componentId, _this.props.pageResponse, _this.props.expManager.emEditorType);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                position: idx,
                selectedInstanceId: _this.props.obj.selectedInstanceId,
                component: handleContentBlock(handledItem, post, _this.props.obj, _this.props.pageResponse, _this.props.overrides),
                pageResponse: _this.props.pageResponse,
                matchOrder: _this.props.matchOrder,
                expManager: _this.props.expManager
            }, idx);
        });
    };
    _proto.renderModalPosts = function renderModalPosts() {
        var postsArr = getContent(this.props.obj, "posts", this.props.overrides, undefined, false);
        if (postsArr.length > 0) {
            var _this = this;
            return postsArr.map(function(post, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: _this.props.position,
                            pageResponse: _this.props.pageResponse,
                            replacedMediaList: _this.props.replacedMediaList,
                            instanceId: _this.props.obj.selectedInstanceId,
                            object: _this.props.obj,
                            objectId: _this.props.obj.uuid,
                            inlineContent: _this.props.obj.content.inlineContent,
                            overrides: _this.props.overrides,
                            field: "media1",
                            template: _this.props.obj.styles,
                            rules: _this.props.componentRule,
                            expManager: _this.props.expManager,
                            network: post.network,
                            post: post
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: _this.props.position,
                            pageResponse: _this.props.pageResponse,
                            instanceId: _this.props.obj.selectedInstanceId,
                            object: _this.props.obj,
                            objectId: _this.props.obj.uuid,
                            post: post,
                            inlineContent: _this.props.obj.content.inlineContent,
                            overrides: _this.props.overrides,
                            field: "text1",
                            tag: "h1",
                            value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text1", _this.props.overrides),
                            template: _this.props.obj.styles,
                            rules: _this.props.componentRule,
                            expManager: _this.props.expManager,
                            network: post.network,
                            className: "title"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: _this.props.position,
                            pageResponse: _this.props.pageResponse,
                            instanceId: _this.props.obj.selectedInstanceId,
                            object: _this.props.obj,
                            objectId: _this.props.obj.uuid,
                            post: post,
                            inlineContent: _this.props.obj.content.inlineContent,
                            field: "text2",
                            tag: "p",
                            value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text2", _this.props.overrides),
                            template: _this.props.obj.styles,
                            rules: _this.props.componentRule,
                            expManager: _this.props.expManager,
                            network: post.network,
                            className: "description"
                        }),
                        _this.renderModalComponents(post)
                    ]
                }, idx);
            });
        }
        return this.renderModalComponents();
    };
    _proto.renderModal = function renderModal() {
        var _this = this;
        var isOpen = this.state.showModal;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Modal/* default */.Z, {
            className: "modal-fluxio ".concat((modal_module_default())["modal-fluxio"], " ").concat((elementModal_module_default())["modal-fluxio"], " ").concat((elementModal_module_default()).modal_v1_ssr),
            backdropClassName: "modal-component-backdrop ".concat((elementModal_module_default()).modal_ssr_backdrop),
            size: "xl",
            enforceFocus: false,
            show: isOpen,
            onHide: this.handleModal,
            backdrop: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(bobComponentHandler, {
                position: this.props.position,
                pageResponse: this.props.pageResponse,
                instanceId: this.props.obj.selectedInstanceId,
                object: this.props.obj,
                onClick: function(e) {
                    return _this.handleBackgroundClick(e);
                },
                objectId: this.props.obj.uuid,
                inlineContent: this.props.obj.content.inlineContent,
                overrides: this.props.overrides,
                field: "background1",
                rules: this.props.componentRule,
                template: this.props.obj.styles,
                expManager: this.props.expManager,
                className: "modal-container",
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Modal/* default.Header */.Z.Header, {
                        closeButton: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: this.props.position,
                            pageResponse: this.props.pageResponse,
                            instanceId: this.props.obj.selectedInstanceId,
                            object: this.props.obj,
                            objectId: this.props.obj.uuid,
                            field: "icon1",
                            template: this.props.obj.styles,
                            rules: this.props.componentRule,
                            expManager: this.props.expManager,
                            iconClassName: "fas fa-times aaa",
                            className: "modal-close",
                            onClick: this.handleModal
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Modal/* default.Body */.Z.Body, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "modal-boy-container",
                            onClick: function() {
                                return _this.handleModalContainerClick;
                            },
                            children: this.state.showModal && this.renderModalPosts()
                        })
                    })
                ]
            })
        });
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "elements ".concat((elementModal_module_default()).elements, " modal-component ").concat((elementModal_module_default())["modal-component"]),
            children: this.renderModal()
        });
    };
    return Modal;
}(react.Component);
/* harmony default export */ var Modal_Modal = ((0,router.withRouter)(Modal));

// EXTERNAL MODULE: ./src/stylesheets/modules/templates/elementModal_v2.module.sass
var elementModal_v2_module = __webpack_require__(16001);
var elementModal_v2_module_default = /*#__PURE__*/__webpack_require__.n(elementModal_v2_module);
;// CONCATENATED MODULE: ./src/areas/public-page/fluxio-components/Elements/Modals/ModalV2/ModalV2.tsx
















var ModalV2 = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ModalV2, _Component);
    var _super = (0,_create_super/* default */.Z)(ModalV2);
    function ModalV2(props) {
        (0,src_class_call_check/* default */.Z)(this, ModalV2);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            showModal: false
        };
        _this.handleModal = _this.handleModal.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.handleModalContainerClick = _this.handleModalContainerClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.handleBackgroundClick = _this.handleBackgroundClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.handleInnerFunction = _this.handleInnerFunction.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    var _proto = ModalV2.prototype;
    _proto.componentDidMount = function componentDidMount() {
        // access inner methods from parent
        if (this.props.onRef) this.props.onRef(this);
        else return;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        // access inner methods from parent
        if (this.props.onRef) this.props.onRef(undefined);
        else return;
    };
    _proto.handleInnerFunction = function handleInnerFunction() {
        this.handleModal();
    };
    /**
   * must replicate body class logic inside EM because modal-backdrop-open is inside the browser preview iframe
   * the logic to inject the body class is based on modal-backdrop-open class and it cant be accessed via the iframe
   */ _proto.handleBodyClass = function handleBodyClass() {
        if (this.props.expManager.enable) {
            var boardPreview = document.getElementById("board-preview-frame");
            if (boardPreview) {
                var ref;
                var iframeBody = (ref = boardPreview.contentWindow) === null || ref === void 0 ? void 0 : ref.document.body;
                if (!this.state.showModal) {
                    iframeBody === null || iframeBody === void 0 ? void 0 : iframeBody.classList.remove("modal-open");
                } else if (document.body.className.indexOf("modal-open") === -1) {
                    iframeBody === null || iframeBody === void 0 ? void 0 : iframeBody.classList.add("modal-open");
                }
            }
        }
    };
    _proto.handleModal = function handleModal(post) {
        var _this = this;
        this.setState({
            showModal: !this.state.showModal
        }, function() {
            if (!_this.props.expManager.enable && post) {
                if (_this.state.showModal) _this.props.router.push(handler(_this.props.router, _this.props.matchOrder, post.slug), undefined, {
                    scroll: false
                });
                else _this.props.router.push(handler(_this.props.router, _this.props.matchOrder, ""), undefined, {
                    scroll: false
                });
            }
            _this.handleBodyClass();
        });
    };
    _proto.handleBackgroundClick = function handleBackgroundClick(e) {
        e.stopPropagation();
        /**
     * This trigger works when the user clicks outside of the modal body
     */ this.handleModal();
    };
    _proto.handleModalContainerClick = function handleModalContainerClick(e) {
        e.stopPropagation();
    };
    _proto.renderModalComponents = function renderModalComponents(post) {
        var _this = this;
        var componentsId = this.props.obj.children;
        if (componentsId && componentsId.length > 0) return componentsId.map(function(componentId, idx) {
            var handledItem = handleObjectType(_this.props.obj, componentId, _this.props.pageResponse, _this.props.expManager.emEditorType);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                position: idx,
                selectedInstanceId: _this.props.obj.selectedInstanceId,
                component: handleContentBlock(handledItem, post, _this.props.obj, _this.props.pageResponse, _this.props.overrides),
                pageResponse: _this.props.pageResponse,
                matchOrder: _this.props.matchOrder,
                expManager: _this.props.expManager
            }, idx);
        });
    };
    _proto.renderModalPosts = function renderModalPosts() {
        var postsArr = this.props.obj.content.formula ? getContent(this.props.obj, "posts") : [];
        if (postsArr.length > 0) {
            var _this = this;
            return postsArr.map(function(post, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: _this.props.position,
                            pageResponse: _this.props.pageResponse,
                            replacedMediaList: _this.props.replacedMediaList,
                            instanceId: _this.props.obj.selectedInstanceId,
                            object: _this.props.obj,
                            objectId: _this.props.obj.uuid,
                            inlineContent: _this.props.obj.content.inlineContent,
                            overrides: _this.props.overrides,
                            field: "media1",
                            template: _this.props.obj.styles,
                            rules: _this.props.componentRule,
                            expManager: _this.props.expManager,
                            network: post.network,
                            post: post
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: _this.props.position,
                            pageResponse: _this.props.pageResponse,
                            instanceId: _this.props.obj.selectedInstanceId,
                            object: _this.props.obj,
                            objectId: _this.props.obj.uuid,
                            post: post,
                            inlineContent: _this.props.obj.content.inlineContent,
                            overrides: _this.props.overrides,
                            field: "text1",
                            tag: "h1",
                            value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text1", _this.props.overrides),
                            template: _this.props.obj.styles,
                            rules: _this.props.componentRule,
                            expManager: _this.props.expManager,
                            network: post.network,
                            className: "title"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: _this.props.position,
                            pageResponse: _this.props.pageResponse,
                            instanceId: _this.props.obj.selectedInstanceId,
                            object: _this.props.obj,
                            objectId: _this.props.obj.uuid,
                            post: post,
                            inlineContent: _this.props.obj.content.inlineContent,
                            field: "text2",
                            tag: "p",
                            value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text2", _this.props.overrides),
                            template: _this.props.obj.styles,
                            rules: _this.props.componentRule,
                            expManager: _this.props.expManager,
                            network: post.network,
                            className: "description"
                        }),
                        _this.renderModalComponents(post)
                    ]
                }, idx);
            });
        }
        return this.renderModalComponents();
    };
    _proto.renderModal = function renderModal() {
        var _this = this;
        var isOpen = this.state.showModal;
        var background1 = this.props.obj.styles.bobs.background1;
        /**
     * Responsive Alignment Styles
     */ var alignmentAdittionalProperties = {
            flexDirection: "column",
            self: false
        };
        var ref = alignmentWithAP(background1, alignmentAdittionalProperties), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Modal/* default */.Z, {
            className: "modal-fluxio ".concat((modal_module_default())["modal-fluxio"], " ").concat((elementModal_v2_module_default())["modal-fluxio"], " ").concat((elementModal_v2_module_default()).modal_v2_ssr),
            backdropClassName: "modal-component-backdrop ".concat((elementModal_v2_module_default()).modal_ssr_backdrop),
            show: isOpen,
            onHide: this.handleModal,
            size: "xl",
            enforceFocus: false,
            backdrop: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Modal/* default.Header */.Z.Header, {
                    closeButton: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        position: this.props.position,
                        pageResponse: this.props.pageResponse,
                        instanceId: this.props.obj.selectedInstanceId,
                        object: this.props.obj,
                        objectId: this.props.obj.uuid,
                        field: "icon1",
                        template: this.props.obj.styles,
                        rules: this.props.componentRule,
                        expManager: this.props.expManager,
                        iconClassName: "fas fa-times aaa",
                        className: "modal-close",
                        onClick: this.handleModal
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                    position: this.props.position,
                    pageResponse: this.props.pageResponse,
                    instanceId: this.props.obj.selectedInstanceId,
                    object: this.props.obj,
                    onClick: this.handleBackgroundClick,
                    objectId: this.props.obj.uuid,
                    inlineContent: this.props.obj.content.inlineContent,
                    overrides: this.props.overrides,
                    field: "background1",
                    rules: this.props.componentRule,
                    template: this.props.obj.styles,
                    expManager: this.props.expManager,
                    className: "modal-body",
                    flexDirection: "column",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fluxio_components_alignmentHOC, {
                        className: "modal-body-container",
                        desktop: alignmentStyles,
                        tablet: tabletAlignment,
                        mobile: mobileAlignment,
                        onClick: function() {
                            return _this.handleModalContainerClick;
                        },
                        children: this.state.showModal && this.renderModalPosts()
                    })
                })
            ]
        });
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "elements ".concat((elementModal_v2_module_default()).elements, " modal-component_V2 ").concat((elementModal_v2_module_default())["modal-component_v2"]),
            children: this.renderModal()
        });
    };
    return ModalV2;
}(react.Component);
/* harmony default export */ var ModalV2_ModalV2 = ((0,router.withRouter)(ModalV2));

;// CONCATENATED MODULE: ./src/areas/public-page/fluxio-components/Elements/Modals/ModalV3/ModalV3.tsx
















var ModalV3 = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ModalV3, _Component);
    var _super = (0,_create_super/* default */.Z)(ModalV3);
    function ModalV3(props) {
        (0,src_class_call_check/* default */.Z)(this, ModalV3);
        var _this;
        _this = _super.call(this, props);
        _this.handleInnerFunction = function(postSlug) {
            return _this.handleModal(postSlug);
        };
        _this.state = {
            showModal: false
        };
        _this.handleModal = _this.handleModal.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.handleModalContainerClick = _this.handleModalContainerClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.handleBackgroundClick = _this.handleBackgroundClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.handleInnerFunction = _this.handleInnerFunction.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    var _proto = ModalV3.prototype;
    _proto.componentDidMount = function componentDidMount() {
        // access inner methods from parent
        if (this.props.onRef) this.props.onRef(this);
        this.handleModalFromUrl();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        // access inner methods from parent
        if (this.props.onRef) this.props.onRef(undefined);
        else return;
    };
    /**
   * open modal if uri is already writen
   * Dont open modal from url when contentBlock is on. It would open a modal for each post.
   */ _proto.handleModalFromUrl = function handleModalFromUrl() {
        if (!this.props.obj.isContentBlockChild && handleObjectUri(this.props.obj) === routeCreator_route(this.props.matchOrder, this.props.router)) {
            this.setState({
                showModal: !this.state.showModal
            });
        } else if (this.props.obj.isContentBlockChild && routeCreator_route(this.props.matchOrder, this.props.router) === this.firstSlug()) {
            this.setState({
                showModal: !this.state.showModal
            });
        }
    };
    _proto.firstSlug = function firstSlug() {
        var ref, ref1, ref2;
        return (ref2 = (ref = this.props.obj.content) === null || ref === void 0 ? void 0 : (ref1 = ref.formula) === null || ref1 === void 0 ? void 0 : ref1.posts[0]) === null || ref2 === void 0 ? void 0 : ref2.slug;
    };
    /**
   * must replicate body class logic inside EM because modal-backdrop-open is inside the browser preview iframe
   * the logic to inject the body class is based on modal-backdrop-open class and it cant be accessed via the iframe
   */ _proto.handleBodyClass = function handleBodyClass() {
        if (this.props.expManager.enable) {
            var boardPreview = document.getElementById("board-preview-frame");
            if (boardPreview) {
                var ref;
                var iframeBody = (ref = boardPreview.contentWindow) === null || ref === void 0 ? void 0 : ref.document.body;
                if (!this.state.showModal) {
                    iframeBody === null || iframeBody === void 0 ? void 0 : iframeBody.classList.remove("modal-open");
                } else if (document.body.className.indexOf("modal-open") === -1) {
                    iframeBody === null || iframeBody === void 0 ? void 0 : iframeBody.classList.add("modal-open");
                }
            }
        }
    };
    _proto.handleModal = function handleModal(postSlug) {
        var _this = this;
        this.setState({
            showModal: !this.state.showModal
        }, function() {
            if (!_this.props.expManager.enable) {
                if (_this.state.showModal) _this.props.router.push(handler(_this.props.router, _this.props.matchOrder, postSlug ? postSlug : handleObjectUri(_this.props.obj)), undefined, {
                    scroll: false
                });
                else {
                    _this.props.router.push(handler(_this.props.router, _this.props.matchOrder, ""), undefined, {
                        scroll: false
                    });
                }
            }
        });
        this.handleBodyClass();
    };
    _proto.handleBackgroundClick = function handleBackgroundClick(e) {
        e.stopPropagation();
        /**
     * This trigger works when the user clicks outside of the modal body
     */ this.handleModal();
    };
    _proto.handleModalContainerClick = function handleModalContainerClick(e) {
        e.stopPropagation();
    };
    _proto.renderModalComponents = function renderModalComponents(post) {
        var _this = this;
        var componentsId = this.props.obj.children;
        if (componentsId && componentsId.length > 0) return componentsId.map(function(componentId, idx) {
            var handledItem = handleObjectType(_this.props.obj, componentId, _this.props.pageResponse, _this.props.expManager.emEditorType);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                position: idx,
                selectedInstanceId: _this.props.obj.selectedInstanceId,
                component: handleContentBlock(handledItem, post, _this.props.obj, _this.props.pageResponse, _this.props.overrides),
                pageResponse: _this.props.pageResponse,
                matchOrder: _this.props.matchOrder,
                expManager: _this.props.expManager
            }, idx);
        });
    };
    _proto.renderModalPosts = function renderModalPosts() {
        var postsArr = this.props.obj.content.formula ? getContent(this.props.obj, "posts") : [];
        if (postsArr.length > 0) {
            var _this = this;
            return postsArr.map(function(post, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: _this.props.position,
                            pageResponse: _this.props.pageResponse,
                            replacedMediaList: _this.props.replacedMediaList,
                            instanceId: _this.props.obj.selectedInstanceId,
                            object: _this.props.obj,
                            objectId: _this.props.obj.uuid,
                            inlineContent: _this.props.obj.content.inlineContent,
                            overrides: _this.props.overrides,
                            field: "media1",
                            template: _this.props.obj.styles,
                            rules: _this.props.componentRule,
                            expManager: _this.props.expManager,
                            network: post.network,
                            post: post
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: _this.props.position,
                            pageResponse: _this.props.pageResponse,
                            instanceId: _this.props.obj.selectedInstanceId,
                            object: _this.props.obj,
                            objectId: _this.props.obj.uuid,
                            post: post,
                            inlineContent: _this.props.obj.content.inlineContent,
                            overrides: _this.props.overrides,
                            field: "text1",
                            tag: "h1",
                            value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text1", _this.props.overrides),
                            template: _this.props.obj.styles,
                            rules: _this.props.componentRule,
                            expManager: _this.props.expManager,
                            network: post.network,
                            className: "title"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: _this.props.position,
                            pageResponse: _this.props.pageResponse,
                            instanceId: _this.props.obj.selectedInstanceId,
                            object: _this.props.obj,
                            objectId: _this.props.obj.uuid,
                            post: post,
                            inlineContent: _this.props.obj.content.inlineContent,
                            overrides: _this.props.overrides,
                            field: "text2",
                            tag: "p",
                            value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text2"),
                            template: _this.props.obj.styles,
                            rules: _this.props.componentRule,
                            expManager: _this.props.expManager,
                            network: post.network,
                            className: "description"
                        }),
                        _this.renderModalComponents(post)
                    ]
                }, idx);
            });
        }
        return this.renderModalComponents();
    };
    _proto.renderModal = function renderModal() {
        var _this = this;
        var isOpen = this.state.showModal;
        var background1 = this.props.obj.styles.bobs.background1;
        var alignmentAdittionalProperties = {
            flexDirection: "column",
            self: false
        };
        var ref = alignmentWithAP(background1, alignmentAdittionalProperties), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Modal/* default */.Z, {
            className: "modal-fluxio ".concat((modal_module_default())["modal-fluxio"], " ").concat((elementModal_v2_module_default())["modal-fluxio"], " ").concat((elementModal_v2_module_default()).modal_v2_ssr),
            backdropClassName: "modal-component-backdrop ".concat((elementModal_v2_module_default()).modal_ssr_backdrop),
            size: "lg",
            show: isOpen,
            onHide: this.handleModal,
            enforceFocus: false,
            backdrop: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Modal/* default.Header */.Z.Header, {
                    closeButton: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        position: this.props.position,
                        pageResponse: this.props.pageResponse,
                        instanceId: this.props.obj.selectedInstanceId,
                        object: this.props.obj,
                        objectId: this.props.obj.uuid,
                        field: "icon1",
                        template: this.props.obj.styles,
                        rules: this.props.componentRule,
                        expManager: this.props.expManager,
                        iconClassName: "fas fa-times",
                        className: "modal-close",
                        onClick: function(e) {
                            return _this.handleModal();
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                    position: this.props.position,
                    pageResponse: this.props.pageResponse,
                    instanceId: this.props.obj.selectedInstanceId,
                    object: this.props.obj,
                    onClick: this.handleBackgroundClick,
                    objectId: this.props.obj.uuid,
                    inlineContent: this.props.obj.content.inlineContent,
                    field: "background1",
                    rules: this.props.componentRule,
                    template: this.props.obj.styles,
                    expManager: this.props.expManager,
                    className: "modal-body",
                    flexDirection: "column",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fluxio_components_alignmentHOC, {
                        className: "modal-body-container",
                        desktop: alignmentStyles,
                        tablet: tabletAlignment,
                        mobile: mobileAlignment,
                        onClick: this.handleModalContainerClick,
                        children: this.state.showModal && this.renderModalPosts()
                    })
                })
            ]
        });
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "elements ".concat((elementModal_v2_module_default()).elements, " modal-component_v2 ").concat((elementModal_v2_module_default())["modal-component_v2"]),
            children: this.renderModal()
        });
    };
    return ModalV3;
}(react.Component);
/* harmony default export */ var ModalV3_ModalV3 = ((0,router.withRouter)(ModalV3));

// EXTERNAL MODULE: ./src/stylesheets/modules/templates/elementModal_v4.module.sass
var elementModal_v4_module = __webpack_require__(43670);
var elementModal_v4_module_default = /*#__PURE__*/__webpack_require__.n(elementModal_v4_module);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Elements/Modals/ModalV4/ModalV4.tsx














var ModalV4 = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ModalV4, _Component);
    var _super = (0,_create_super/* default */.Z)(ModalV4);
    function ModalV4(props) {
        (0,src_class_call_check/* default */.Z)(this, ModalV4);
        var _this;
        _this = _super.call(this, props);
        _this.componentDidMount = function() {
            // access inner methods from parent
            if (_this.props.onRef) _this.props.onRef((0,_assert_this_initialized/* default */.Z)(_this));
            // get iframe body node when inside page builder
            // use it to create the modal inside the iframe
            var modalMountContainer;
            if (_this.props.expManager.enable) {
                var ref;
                var previewIframe = document.querySelector("#board-preview-frame");
                modalMountContainer = (ref = previewIframe.contentWindow) === null || ref === void 0 ? void 0 : ref.document.querySelector(".page-container");
            } else {
                modalMountContainer = document.querySelector(".page-container");
            }
            _this.setState({
                modalMountContainer: modalMountContainer
            });
        };
        _this.componentWillUnmount = function() {
            // access inner methods from parent
            if (_this.props.onRef) _this.props.onRef(undefined);
            else return;
        };
        _this.handleInnerFunction = function() {
            return _this.toggleModal();
        };
        /**
   * must replicate body class logic inside EM because modal-backdrop-open is inside the browser preview iframe
   * the logic to inject the body class is based on modal-backdrop-open class and it cant be accessed via the iframe
   */ _this.handleBodyClass = function() {
            if (_this.props.expManager.enable) {
                var boardPreview = document.getElementById("board-preview-frame");
                if (boardPreview) {
                    var ref;
                    var iframeBody = (ref = boardPreview.contentWindow) === null || ref === void 0 ? void 0 : ref.document.body;
                    if (!_this.state.showModal) {
                        iframeBody === null || iframeBody === void 0 ? void 0 : iframeBody.classList.remove("modal-open");
                    } else if (document.body.className.indexOf("modal-open") === -1) {
                        iframeBody === null || iframeBody === void 0 ? void 0 : iframeBody.classList.add("modal-open");
                    }
                }
            } else {
                if (_this.state.showModal) document.body.style.overflow = "hidden";
                else document.body.style.overflow = "auto";
            }
        };
        _this.toggleModal = function() {
            _this.setState({
                showModal: !_this.state.showModal
            }, function() {
                return _this.handleBodyClass();
            });
        };
        _this.handleBackgroundClick = function(e) {
            e.stopPropagation();
            /**
     * This trigger works when the user clicks outside of the modal body
     */ _this.toggleModal();
        };
        _this.handleModalContainerClick = function(e) {
            e.stopPropagation();
        };
        _this.renderModalComponents = function(post) {
            var componentsId = _this.props.obj.children;
            if (componentsId && componentsId.length > 0) return componentsId.map(function(componentId, idx) {
                var handledItem = handleObjectType(_this.props.obj, componentId, _this.props.pageResponse, _this.props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                    position: idx,
                    selectedInstanceId: _this.props.obj.selectedInstanceId,
                    component: handleContentBlock(handledItem, post, _this.props.obj, _this.props.pageResponse, _this.props.overrides),
                    pageResponse: _this.props.pageResponse,
                    matchOrder: _this.props.matchOrder,
                    expManager: _this.props.expManager
                }, idx);
            });
        };
        _this.renderModalPosts = function() {
            var postsArr = _this.props.obj.content.formula ? getContent(_this.props.obj, "posts") : [];
            if (postsArr.length > 0) {
                return postsArr.map(function(post, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                position: _this.props.position,
                                pageResponse: _this.props.pageResponse,
                                replacedMediaList: _this.props.replacedMediaList,
                                instanceId: _this.props.obj.selectedInstanceId,
                                object: _this.props.obj,
                                objectId: _this.props.obj.uuid,
                                inlineContent: _this.props.obj.content.inlineContent,
                                overrides: _this.props.overrides,
                                field: "media1",
                                template: _this.props.obj.styles,
                                rules: _this.props.componentRule,
                                expManager: _this.props.expManager,
                                network: post.network,
                                post: post
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                position: _this.props.position,
                                pageResponse: _this.props.pageResponse,
                                instanceId: _this.props.obj.selectedInstanceId,
                                object: _this.props.obj,
                                objectId: _this.props.obj.uuid,
                                post: post,
                                inlineContent: _this.props.obj.content.inlineContent,
                                overrides: _this.props.overrides,
                                field: "text1",
                                tag: "h1",
                                value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text1", _this.props.overrides),
                                template: _this.props.obj.styles,
                                rules: _this.props.componentRule,
                                expManager: _this.props.expManager,
                                network: post.network,
                                className: "title"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                position: _this.props.position,
                                pageResponse: _this.props.pageResponse,
                                instanceId: _this.props.obj.selectedInstanceId,
                                object: _this.props.obj,
                                objectId: _this.props.obj.uuid,
                                post: post,
                                inlineContent: _this.props.obj.content.inlineContent,
                                overrides: _this.props.overrides,
                                field: "text2",
                                tag: "p",
                                value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text2", _this.props.overrides),
                                template: _this.props.obj.styles,
                                rules: _this.props.componentRule,
                                expManager: _this.props.expManager,
                                network: post.network,
                                className: "description"
                            }),
                            _this.renderModalComponents(post)
                        ]
                    }, idx);
                });
            }
            return _this.renderModalComponents();
        };
        _this.render = function() {
            var background1 = _this.props.obj.styles.bobs.background1;
            var alignmentAdittionalProperties = {
                flexDirection: "column",
                self: false
            };
            var ref = alignmentWithAP(background1, alignmentAdittionalProperties), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Modal/* default */.Z, {
                className: "modal-fluxio ".concat((modal_module_default())["modal-fluxio"], " ").concat((elementModal_v4_module_default())["modal-fluxio"], " elements ").concat((elementModal_v4_module_default()).elements, " modal-component_v4 ").concat((elementModal_v4_module_default())["modal-component_v4"]),
                backdropClassName: "modal-component-backdrop",
                container: _this.state.modalMountContainer,
                size: "lg",
                show: _this.state.showModal,
                onHide: _this.toggleModal,
                enforceFocus: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Modal/* default.Header */.Z.Header, {
                        closeButton: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: _this.props.position,
                            pageResponse: _this.props.pageResponse,
                            instanceId: _this.props.obj.selectedInstanceId,
                            object: _this.props.obj,
                            objectId: _this.props.obj.uuid,
                            field: "icon1",
                            template: _this.props.obj.styles,
                            rules: _this.props.componentRule,
                            expManager: _this.props.expManager,
                            iconClassName: "fas fa-times aaa",
                            className: "modal-close",
                            onClick: function() {
                                return _this.toggleModal();
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Modal/* default.Body */.Z.Body, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: _this.props.position,
                            pageResponse: _this.props.pageResponse,
                            instanceId: _this.props.obj.selectedInstanceId,
                            object: _this.props.obj,
                            onClick: _this.handleBackgroundClick,
                            objectId: _this.props.obj.uuid,
                            inlineContent: _this.props.obj.content.inlineContent,
                            overrides: _this.props.overrides,
                            field: "background1",
                            rules: _this.props.componentRule,
                            template: _this.props.obj.styles,
                            expManager: _this.props.expManager,
                            className: "modal-body",
                            flexDirection: "column",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fluxio_components_alignmentHOC, {
                                className: "modal-body-container",
                                desktop: alignmentStyles,
                                tablet: tabletAlignment,
                                mobile: mobileAlignment,
                                onClick: _this.handleModalContainerClick,
                                children: _this.state.showModal && _this.renderModalPosts()
                            })
                        })
                    })
                ]
            });
        };
        _this.state = {
            showModal: false,
            modalMountContainer: null
        };
        _this.parentRef = /*#__PURE__*/ react.createRef();
        return _this;
    }
    return ModalV4;
}(react.Component);
/* harmony default export */ var ModalV4_ModalV4 = (ModalV4);

// EXTERNAL MODULE: ./src/stylesheets/modules/templates/galleryShowcase.module.sass
var galleryShowcase_module = __webpack_require__(3594);
var galleryShowcase_module_default = /*#__PURE__*/__webpack_require__.n(galleryShowcase_module);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Gallery/showcase/showcase.tsx












var Showcase = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Showcase, _Component);
    var _super = (0,_create_super/* default */.Z)(Showcase);
    function Showcase(props) {
        (0,src_class_call_check/* default */.Z)(this, Showcase);
        var _this;
        _this = _super.call(this, props);
        _this.child = [];
        _this.state = {
            childComponents: [],
            hasChildModal: false
        };
        return _this;
    }
    var _proto = Showcase.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.handleWriteState(this.props);
    };
    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
        if (!this.props.obj.children && nextProps.obj.children && nextProps.obj.children.length || this.props.obj.children && nextProps.obj.children && this.props.obj.children.length !== nextProps.obj.children.length) {
            this.handleWriteState(nextProps);
        }
    };
    _proto.handleWriteState = function handleWriteState(props) {
        var components = props.obj.children;
        if (components && components.length > 0) {
            this.setState({
                childComponents: components,
                hasChildModal: hasChildOfType("modal", components, props.obj, props.pageResponse, props.expManager.emEditorType)
            });
        }
    };
    /**
   *
   * @param {postIdx} idx
   * We need this idx from the post array
   * to properly call the inner function down the react tree.
   * if we dont use this we overwrite the same ref over and over
   * leaving only the reference to the last rendered object.
   */ _proto.handleCardClick = function handleCardClick(idx) {
        if (this.child && this.child[idx]) this.child[idx].handleInnerFunction();
    };
    _proto.renderComponents = function renderComponents(post, postIdx) {
        var componentsId = this.props.obj.children;
        if (componentsId && componentsId.length > 0) {
            var _this = this;
            return componentsId.map(function(componentId, idx) {
                var _this1 = _this;
                var handledItem = handleObjectType(_this.props.obj, componentId, _this.props.pageResponse, _this.props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                    position: idx,
                    selectedInstanceId: _this.props.obj.selectedInstanceId,
                    onRef: function(ref) {
                        return _this1.child[postIdx] = ref;
                    },
                    component: handleContentBlock(handledItem, post, _this.props.obj, _this.props.pageResponse, _this.props.overrides),
                    pageResponse: _this.props.pageResponse,
                    matchOrder: _this.props.matchOrder,
                    expManager: _this.props.expManager
                }, idx);
            });
        }
    };
    _proto.renderItems = function renderItems() {
        var content = getContent(this.props.obj, "posts", this.props.overrides);
        if (content && content.length > 0) {
            var _this = this;
            var background2 = this.props.obj.styles.bobs.background2;
            var childs = this.props.obj.children;
            var hasChildModal = childs.length > 0 && hasChildOfType("modal", childs, this.props.obj, this.props.pageResponse, this.props.expManager.emEditorType);
            var ref = alignment(background2), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
            return content.map(function(post, idx) {
                var _this1 = _this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                    position: _this.props.position,
                    pageResponse: _this.props.pageResponse,
                    instanceId: _this.props.obj.selectedInstanceId,
                    object: _this.props.obj,
                    objectId: _this.props.obj.uuid,
                    post: post,
                    inlineContent: _this.props.obj.content.inlineContent,
                    overrides: _this.props.overrides,
                    field: "background2",
                    rules: _this.props.componentRule,
                    template: _this.props.obj.styles,
                    expManager: _this.props.expManager,
                    className: "showcase-item ".concat((galleryShowcase_module_default())["showcase-item"], " ").concat(idx === 0 ? "item-default ".concat((galleryShowcase_module_default())["item-default"]) : "", " ").concat(hasChildModal ? "is-clickable" : ""),
                    onClick: function() {
                        return _this1.handleCardClick(idx);
                    },
                    flexDirection: "column",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(alignmentHOC, {
                        className: "gallery-item-wrap",
                        desktop: alignmentStyles,
                        tablet: tabletAlignment,
                        mobile: mobileAlignment,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                position: _this.props.position,
                                pageResponse: _this.props.pageResponse,
                                replacedMediaList: _this.props.replacedMediaList,
                                instanceId: _this.props.obj.selectedInstanceId,
                                object: _this.props.obj,
                                objectId: _this.props.obj.uuid,
                                inlineContent: _this.props.obj.content.inlineContent,
                                overrides: _this.props.overrides,
                                field: "media1",
                                template: _this.props.obj.styles,
                                rules: _this.props.componentRule,
                                expManager: _this.props.expManager,
                                network: post.network,
                                post: post
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "gallery-item-content ".concat((galleryShowcase_module_default())["gallery-item-content"]),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: _this.props.position,
                                        pageResponse: _this.props.pageResponse,
                                        instanceId: _this.props.obj.selectedInstanceId,
                                        object: _this.props.obj,
                                        objectId: _this.props.obj.uuid,
                                        post: post,
                                        inlineContent: _this.props.obj.content.inlineContent,
                                        overrides: _this.props.overrides,
                                        field: "text1",
                                        tag: "p",
                                        value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text1", _this.props.overrides),
                                        template: _this.props.obj.styles,
                                        rules: _this.props.componentRule,
                                        expManager: _this.props.expManager,
                                        network: post.network
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: _this.props.position,
                                        pageResponse: _this.props.pageResponse,
                                        instanceId: _this.props.obj.selectedInstanceId,
                                        object: _this.props.obj,
                                        objectId: _this.props.obj.uuid,
                                        post: post,
                                        inlineContent: _this.props.obj.content.inlineContent,
                                        overrides: _this.props.overrides,
                                        field: "text2",
                                        tag: "p",
                                        value: getStringField(post, _this.props.obj, _this.props.pageResponse, "text2", _this.props.overrides),
                                        template: _this.props.obj.styles,
                                        rules: _this.props.componentRule,
                                        expManager: _this.props.expManager,
                                        network: post.network
                                    }),
                                    _this.renderComponents(post, idx)
                                ]
                            })
                        ]
                    })
                }, idx);
            });
        } else {
            if (this.props.expManager.enable) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-sm-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warningSystem, {
                        alertType: "alert-secondary w-100 text-center",
                        messages: "Select a formula to show posts"
                    })
                });
            }
        }
    };
    _proto.render = function render() {
        var background1 = this.props.obj.styles.bobs.background1;
        var alignmentStyles = alignment(background1).alignmentStyles;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "gallery ".concat((galleryShowcase_module_default()).gallery, " showcase ").concat((galleryShowcase_module_default()).showcase),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "d-flex flex-row",
                style: alignmentStyles,
                children: this.renderItems()
            })
        });
    };
    return Showcase;
}(react.Component);
/* harmony default export */ var showcase = (Showcase);

// EXTERNAL MODULE: ./node_modules/react-instagram-embed/es/index.js
var react_instagram_embed_es = __webpack_require__(45064);
;// CONCATENATED MODULE: ./src/areas/public-page/fluxio-components/Socials/SocialsEmbed/InstagramMediaEmbed/InstagramMediaEmbed.tsx







var InstagramMediaEmbed = function(props) {
    var ref = (0,react.useState)({}), post = ref[0], setPost = ref[1];
    (0,react.useEffect)(function() {
        handleApiRequests();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    var handleApiRequests = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return handleApiRequest("https://graph.facebook.com/v8.0/instagram_oembed?access_token=1669312576562272|0408296a55ded133d0135900018b2898&url=".concat(props.url));
                    case 2:
                        _ctx.next = 4;
                        return handleApiRequest("https://graph.facebook.com/v8.0/instagram_oembed?access_token=1669312576562272|0408296a55ded133d0135900018b2898&fields=thumbnail_url,author_name,provider_name,provider_url&url=".concat(props.url));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleApiRequests() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleApiRequest = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(url) {
            var response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return axios_default().get(url);
                    case 3:
                        response = _ctx.sent;
                        if (!response.data.html) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return", setPost((0,src_object_spread/* default */.Z)({}, post, response)));
                    case 6:
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        throw _ctx.t0;
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function handleApiRequest(url) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        className: "instagram-media-embed",
        href: props.url,
        target: "_blank",
        rel: "noopener noreferrer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                className: "instagram-media-embed-cover",
                src: post.thumbnail_url,
                alt: "instagram logo"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "instagram-media-embed-author",
                children: post.author_name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "instagram-media-embed-thumbnail",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "https://meshapp-user-generated.s3-eu-west-1.amazonaws.com/ricardo/Sx8ZLSeB2qYyeUB3pu0NdJIg9j0f6Q7XPe3oHTor.png",
                    alt: post.author_name
                })
            })
        ]
    });
};
/* harmony default export */ var InstagramMediaEmbed_InstagramMediaEmbed = (InstagramMediaEmbed);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Socials/SocialsEmbed/SocialEmbed/SocialEmbed.tsx




var SocialEmbed = function(props) {
    /**
   * Renders diferent type of layouts for diferent social media
   * Layout types: default, media 
   */ var postObj = props.postObj;
    // media layout
    if (props.type === "media") switch(postObj.network){
        case "instagram":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(InstagramMediaEmbed_InstagramMediaEmbed, {
                url: postObj.url
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: "no social post found"
            });
    }
    // default layout
    switch(postObj.network){
        case "instagram":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_instagram_embed_es/* default */.Z, {
                url: postObj.url,
                accessToken: "1669312576562272|0408296a55ded133d0135900018b2898",
                maxWidth: 100,
                hideCaption: false,
                containerTagName: "div",
                protocol: "",
                injectScript: true,
                onLoading: function() {},
                onSuccess: function() {},
                onAfterRender: function() {},
                onFailure: function() {}
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: "no social post found"
            });
    }
};
/* harmony default export */ var SocialEmbed_SocialEmbed = (SocialEmbed);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Socials/SocialCardEmbed/SocialCardEmbed.tsx











var SocialCardEmbed = function(props) {
    var renderItems = function(background1Template) {
        var content = getContent(props.obj, "posts", props.overrides);
        if (content && content.length > 0) {
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            return content.map(function(post, idx) {
                var columns = bobHandler_handleColumns(idx, counter, background1Template, props.pageResponse.globalStyles[background1Template.globalStyleId]);
                counter = columns.counter;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        object: props.obj,
                        position: props.position,
                        pageResponse: props.pageResponse,
                        objectId: props.obj.uuid,
                        post: post,
                        inlineContent: props.obj.content.inlineContent,
                        overrides: props.overrides,
                        field: "background2",
                        rules: props.componentRule,
                        template: props.obj.styles,
                        expManager: props.expManager,
                        className: "social-card-embed-item-".concat(idx),
                        flexDirection: "column",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialEmbed_SocialEmbed, {
                            postObj: post
                        })
                    })
                }, idx);
            });
        }
        if (props.expManager.enable) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-sm-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warningSystem, {
                    alertType: "alert-secondary w-100 text-center",
                    messages: "Select a formula to show posts"
                })
            });
        }
        return [];
    };
    var background1 = props.obj.styles.bobs.background1;
    var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "social social-card-embed",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
            className: "row ".concat(bobHandler_responsiveGuttersClass(background1, props.pageResponse.globalStyles[background1.globalStyleId])),
            desktop: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, alignmentStyles), {
                flexDirection: "row"
            }),
            tablet: tabletAlignment,
            mobile: mobileAlignment,
            children: renderItems(background1)
        })
    });
};
/* harmony default export */ var SocialCardEmbed_SocialCardEmbed = (SocialCardEmbed);

// EXTERNAL MODULE: ./src/stylesheets/modules/components/instagramMediaEmbed.module.sass
var instagramMediaEmbed_module = __webpack_require__(20136);
var instagramMediaEmbed_module_default = /*#__PURE__*/__webpack_require__.n(instagramMediaEmbed_module);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Socials/SocialMediaEmbed/SocialMediaEmbed.tsx









var SocialMediaEmbed = function(props) {
    var renderItems = function(background1Template) {
        var content = getContent(props.obj, "posts", props.overrides);
        if (content && content.length > 0) {
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            return content.map(function(post, idx) {
                var columns = bobHandler_handleColumns(idx, counter, background1Template, props.pageResponse.globalStyles[background1Template.globalStyleId]);
                counter = columns.counter;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialEmbed_SocialEmbed, {
                        type: "media",
                        postObj: post
                    })
                }, idx);
            });
        }
        if (props.expManager.enable) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-sm-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warningSystem, {
                    alertType: "alert-secondary w-100 text-center",
                    messages: "Select a formula to show posts"
                })
            });
        }
        return [];
    };
    var background1 = props.obj.styles.bobs.background1;
    var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "social social-media-embed ".concat((instagramMediaEmbed_module_default())["social-media-embed"]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
            className: "row ".concat(bobHandler_responsiveGuttersClass(background1, props.pageResponse.globalStyles[background1.globalStyleId])),
            desktop: alignmentStyles,
            tablet: tabletAlignment,
            mobile: mobileAlignment,
            children: renderItems(background1)
        })
    });
};
/* harmony default export */ var SocialMediaEmbed_SocialMediaEmbed = (SocialMediaEmbed);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/componentBoilerplate/componentBoilerplate.tsx




//@ts-ignore







/**
 * PROPS
 * obj
 * containerBackground
 * containerBoundaries
 * containerLean
 * containerRadius
 * containerBorder
 * containerShadow
 */ var ComponentBoilerplate = function(props) {
    var elRef = (0,react.useRef)(null);
    //On viewport logic for analytics
    (0,react.useEffect)(function() {
        if (props.pageResponse.profileName === "patricia" || props.pageResponse.profileName === "ricardo") {
            elementLoaded(elRef.current);
            window.addEventListener("scroll", function() {
                if (elRef && isElementInViewport(elRef.current)) {
                    elementInViewport(elRef.current);
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * Handle background color/image on the main container
   * @param {*} color can be a string or array
   * String for a solid background
   * Array for a gradient background. [gradientDirection, color1, color2]
   */ var handleContainerBackground = function(color) {
        if (typeof color === "string") {
            if ((color.startsWith("//") || color.startsWith("http") || color.startsWith("www")) && (!color.startsWith("#") || !color.startsWith("rgb"))) return {
                background: "url(".concat(color, ")")
            };
            return {
                background: color
            };
        } else if (color.constructor === Array) {
            var gradientOrientation = color[0] === "interleaved" ? "to bottom" : color[0] === "right" ? "to left" : "to right";
            return {
                background: "linear-gradient(".concat(gradientOrientation, ", ").concat(color[1], ", ").concat(color[2], ")")
            };
        }
    };
    /**
   * write css for all bobs customCss prop
   * bobCode has code prop while other bobs have customCss prop
   */ var handleCustomCss = function() {
        var bobs = cloneDeep_default()(props.obj.styles.bobs);
        var customCss = "";
        for(var key in bobs){
            //bobCode only has html/css/js code and not ready to use css
            if (!key.startsWith("embed") && (bobs[key].code || bobs[key].code === "")) customCss += bobs[key].code;
            else bobs[key].customCss = writeCustomCssSelectors(bobs[key], key, handleDOMid(key, props.obj.uuid, props.obj.selectedInstanceId), false) || bobs[key];
            customCss += handleCustomCssValues(bobs[key].customCss, key);
        }
        return customCss;
    };
    /**
   * write customCss values for each bob
   */ var handleCustomCssValues = function(customCss, bobType) {
        if (!customCss) return "";
        if (bobType.startsWith("background")) {
            var container = "".concat(customCss.default.container).concat(customCss.mobile.container).concat(customCss.tablet.container).concat(customCss.desktop.container);
            var innerContainer = "".concat(customCss.default.innerContainer).concat(customCss.mobile.innerContainer).concat(customCss.tablet.innerContainer).concat(customCss.desktop.innerContainer);
            return "".concat(container).concat(innerContainer);
        }
        if (bobType.startsWith("media")) {
            var container1 = "".concat(customCss.default.container).concat(customCss.mobile.container).concat(customCss.tablet.container).concat(customCss.desktop.container);
            var image = "".concat(customCss.default.image).concat(customCss.mobile.image).concat(customCss.tablet.image).concat(customCss.desktop.image);
            return "".concat(container1).concat(image);
        }
        if (bobType.startsWith("text")) {
            var text = "".concat(customCss.default.text).concat(customCss.mobile.text).concat(customCss.tablet.text).concat(customCss.desktop.text);
            return "".concat(text);
        }
        if (bobType.startsWith("icon")) {
            var container2 = "".concat(customCss.default.container).concat(customCss.mobile.container).concat(customCss.tablet.container).concat(customCss.desktop.container);
            var icon = "".concat(customCss.default.icon).concat(customCss.mobile.icon).concat(customCss.tablet.icon).concat(customCss.desktop.icon);
            return "".concat(container2).concat(icon);
        }
        return "";
    };
    /**
   * Render component title
   * Renders title if title prop exists in the text rule
   */ var renderTextComponents = function() {
        if (props.obj.styles.component.bob) {
            var field = "text1";
            var stringField = getStringField(props.obj, props.obj, props.pageResponse, field, props.overrides);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                position: props.position,
                pageResponse: props.pageResponse,
                instanceId: props.obj.selectedInstanceId,
                object: props.obj,
                objectId: props.obj.objectUuid,
                value: stringField,
                field: field,
                rules: props.componentRule,
                template: props.obj.styles,
                expManager: props.expManager
            });
        }
    };
    var css = function(componentTemplate) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var CustomCss = handleCustomCss();
        var tabletZIndexEnabled = (componentTemplate === null || componentTemplate === void 0 ? void 0 : (ref = componentTemplate.bobs) === null || ref === void 0 ? void 0 : (ref1 = ref.background1) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.tablet) === null || ref2 === void 0 ? void 0 : ref2.zIndex) && utils_objValueExists(componentTemplate.bobs.background1.tablet.zIndex, "enable");
        var tabletZIndexValueDefined = tabletZIndexEnabled && componentTemplate.bobs.background1.tablet && componentTemplate.bobs.background1.tablet.zIndex.enable;
        var tabletZIndexInner = tabletZIndexValueDefined ? ".component-boilerplate{\n          z-index: ".concat(componentTemplate.bobs.background1.tablet.zIndex.value, ";\n        }") : ".component-boilerplate{\n          z-index: auto;\n        }";
        var tabletZIndex = tabletZIndexEnabled ? "@media all and (max-width: 992px) and (min-width: 767px){\n            ".concat(tabletZIndexInner, "\n          }") : "";
        var mobileZIndexEnabled = (componentTemplate === null || componentTemplate === void 0 ? void 0 : (ref3 = componentTemplate.bobs) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.background1) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.mobile) === null || ref5 === void 0 ? void 0 : ref5.zIndex) && utils_objValueExists(componentTemplate.bobs.background1.mobile.zIndex, "enable");
        var mobileZIndexValueDefined = mobileZIndexEnabled && componentTemplate.bobs.background1.mobile && componentTemplate.bobs.background1.mobile.zIndex.enable;
        var mobileZIndexInner = mobileZIndexValueDefined ? ".component-boilerplate{\n          z-index: ".concat(componentTemplate.bobs.background1.mobile.zIndex.value, ";\n        }") : ".component-boilerplate{\n          z-index: auto;\n        }";
        var mobileZIndex = mobileZIndexEnabled ? "@media all and (max-width: 992px) and (min-width: 767px){\n            ".concat(mobileZIndexInner, "\n          }") : "";
        return "\n      ".concat(componentTemplate.bobs && componentTemplate.bobs.background1 && componentTemplate.bobs.background1.zIndex && componentTemplate.bobs.background1.zIndex.enable ? ".component-boilerplate{\n          z-index: ".concat(componentTemplate.bobs.background1.zIndex.value, ";\n        }") : "", "\n      ").concat(tabletZIndex, "\n      ").concat(mobileZIndex, "\n      ").concat(componentTemplate.bobs && componentTemplate.bobs.code1 && CustomCss, "\n    ");
    };
    /**
   * Main render
   * Defines the component main structure
   * Handles all the styles to be aplied to the component main containers
   * only apply styles that comes from the props
   */ var componentRules = props.pageResponse.components[props.obj.styles.component];
    var componentTemplate = props.obj.styles;
    var componentName = componentRules.name;
    var containerClass = props.container && componentTemplate.wrap === "container" ? "container" : props.container && componentTemplate.wrap !== "container" ? "container-fluid" : "";
    var boundaries = props.containerBoundaries && handleBondaries_DEPRECATED(componentTemplate);
    var leanStyles = props.containerLean && handleLeanSettings(componentTemplate);
    var radiusStyles = props.containerRadius && handleRadius(componentTemplate);
    var borderStyles = props.containerBorder && handleBorder(componentTemplate);
    var shadowStyles = props.containerShadow && handleShadow(componentTemplate);
    var flowStyles = props.containerFlow && handleFlow(componentTemplate, props.expManager);
    var containerBackground = props.containerBackground && handleContainerBackground(props.containerBackground);
    /**
   * For the css sticky to work, the sticky element must be the direct child of a parent with a height bigger than the child element itself.
   * Boilerplate must have position:stiky on himself because it's the first div of a component
   * and that's the one relative to the parent wich makes him sticky
   */ var boilerplateFlow = props.obj.styles.bobs.background1 && props.obj.styles.bobs.background1.scroll.value === "magnetic" ? {
        position: "sticky",
        top: 0
    } : undefined;
    var styles = (0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, boundaries), {
        clipPath: leanStyles,
        WebkitClipPath: leanStyles
    }), radiusStyles, borderStyles, shadowStyles, flowStyles, containerBackground);
    var container = containerClass ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: containerClass,
        children: [
            props.containerTitle && renderTextComponents(),
            props.children
        ]
    }) : props.children;
    var boilerplate = /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        ref: elRef,
        className: "component-boilerplate",
        //@ts-ignore
        name: componentName,
        style: (0,src_object_spread/* default */.Z)({}, styles, boilerplateFlow),
        id: handleDOMid("object", props.obj.objectUuid, props.obj.selectedInstanceId),
        children: componentRules.bob && componentRules.bob.background1 && !props.noContainer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
            position: props.position,
            pageResponse: props.pageResponse,
            instanceId: props.obj.selectedInstanceId,
            object: props.obj,
            objectId: props.obj.objectUuid,
            inlineContent: props.obj.content.inlineContent,
            overrides: props.overrides,
            field: "background1",
            rules: componentRules,
            template: componentTemplate,
            expManager: props.expManager,
            children: container
        }) : container
    });
    var cssRules = css(componentTemplate);
    if (cssRules.trim() !== "") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)((style_it_default()), {
            children: [
                "".concat(cssRules),
                boilerplate
            ]
        });
    } else {
        return boilerplate;
    }
};
/* harmony default export */ var componentBoilerplate = (/*#__PURE__*/react.memo(ComponentBoilerplate));

// EXTERNAL MODULE: ./src/stylesheets/modules/templates/elementDropdown.module.sass
var elementDropdown_module = __webpack_require__(93853);
var elementDropdown_module_default = /*#__PURE__*/__webpack_require__.n(elementDropdown_module);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Elements/Dropdowns/Dropdown/dropdown.tsx






//import CountryCode from '../../../../modules/routeCreator/countryCode';





var Dropdown = function(props) {
    var ref = (0,react.useState)(false), dropdownOpen = ref[0], setDropdownOpen = ref[1];
    var ref1 = (0,react.useState)(false), isHover = ref1[0], setIsHover = ref1[1];
    var buttonOnHover = function() {
        return setIsHover(true);
    };
    var buttonUnHover = function() {
        return setIsHover(false);
    };
    var handleButtonClick = function(buttonLabel) {
        clickEvent("button-".concat(buttonLabel), "Dropdown");
        setDropdownOpen(!dropdownOpen);
    };
    var renderDropdownItems = function() {
        var itemsId = props.obj.children;
        if (itemsId && itemsId.length > 0) {
            return itemsId.map(function(objId, idx) {
                var handledItem = handleObjectType(props.obj, objId, props.pageResponse, props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                    position: props.position,
                    pageResponse: props.pageResponse,
                    instanceId: props.obj.selectedInstanceId,
                    object: props.obj,
                    objectId: props.obj.uuid,
                    inlineContent: props.obj.content.inlineContent,
                    overrides: props.overrides,
                    field: "background3",
                    rules: props.componentRule,
                    template: props.obj.styles,
                    expManager: props.expManager,
                    className: "dropdown-item ".concat((elementDropdown_module_default())["dropdown-item"]),
                    tag: "button",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                        position: idx,
                        selectedInstanceId: props.obj.selectedInstanceId,
                        component: handledItem,
                        pageResponse: props.pageResponse,
                        matchOrder: props.matchOrder,
                        expManager: props.expManager
                    })
                }, idx);
            });
        }
    };
    var renderDropdown = function(background1Template) {
        var content = getContent(props.obj, "posts", props.overrides);
        if (content && content.length > 0) {
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            return content.map(function(post, idx) {
                var columns = bobHandler_handleColumns(idx, counter, background1Template, props.pageResponse.globalStyles[background1Template.globalStyleId]);
                counter = columns.counter;
                var buttonLabel = getStringField(post, props.obj, props.pageResponse, "text1", props.overrides);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "dropdown",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(bobComponentHandler, {
                                position: props.position,
                                pageResponse: props.pageResponse,
                                instanceId: props.obj.selectedInstanceId,
                                object: props.obj,
                                objectId: props.obj.uuid,
                                post: post,
                                inlineContent: props.obj.content.inlineContent,
                                overrides: props.overrides,
                                field: "background2",
                                rules: props.componentRule,
                                template: props.obj.styles,
                                expManager: props.expManager,
                                className: "btn btn-fluxio btn-lg dropdown-toggle ".concat((elementDropdown_module_default())["dropdown-toggle"], " ").concat(dropdownOpen ? "isOpen ".concat((elementDropdown_module_default()).isOpen) : ""),
                                tag: "button",
                                onClick: function() {
                                    return handleButtonClick(buttonLabel);
                                },
                                onMouseEnter: buttonOnHover,
                                onMouseLeave: buttonUnHover,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: props.position,
                                        pageResponse: props.pageResponse,
                                        replacedMediaList: props.replacedMediaList,
                                        instanceId: props.obj.selectedInstanceId,
                                        object: props.obj,
                                        objectId: props.obj.uuid,
                                        inlineContent: props.obj.content.inlineContent,
                                        overrides: props.overrides,
                                        field: "media1",
                                        template: props.obj.styles,
                                        rules: props.componentRule,
                                        expManager: props.expManager,
                                        network: post.network,
                                        post: post,
                                        className: "".concat(isHover ? "isHover" : "")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: props.position,
                                        pageResponse: props.pageResponse,
                                        instanceId: props.obj.selectedInstanceId,
                                        object: props.obj,
                                        objectId: props.obj.uuid,
                                        post: post,
                                        inlineContent: props.obj.content.inlineContent,
                                        overrides: props.overrides,
                                        field: "text1",
                                        tag: "p",
                                        value: buttonLabel,
                                        template: props.obj.styles,
                                        rules: props.componentRule,
                                        expManager: props.expManager,
                                        network: post.network,
                                        className: "label ".concat((elementDropdown_module_default()).label, " ").concat(isHover ? "isHover" : "")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: props.position,
                                        pageResponse: props.pageResponse,
                                        instanceId: props.obj.selectedInstanceId,
                                        object: props.obj,
                                        objectId: props.obj.uuid,
                                        field: "icon1",
                                        template: props.obj.styles,
                                        rules: props.componentRule,
                                        expManager: props.expManager,
                                        iconClassName: "fas fa-chevron-down"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "dropdown-menu ".concat((elementDropdown_module_default())["dropdown-menu"], " ").concat(dropdownOpen ? "isOpen ".concat((elementDropdown_module_default()).isOpen) : ""),
                                children: renderDropdownItems()
                            })
                        ]
                    })
                }, idx);
            });
        } else {
            if (props.expManager.enable) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-sm-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warningSystem, {
                        alertType: "alert-secondary w-100 text-center",
                        messages: "Add a single post or a feed"
                    })
                });
            }
        }
    };
    /**
   * Responsive Alignment Styles
   */ var background1 = props.obj.styles.bobs.background1;
    var ref2 = alignment(background1), alignmentStyles = ref2.alignmentStyles, tabletAlignment = ref2.tabletAlignment, mobileAlignment = ref2.mobileAlignment;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "elements ".concat((elementDropdown_module_default()).elements, " button dropdown ").concat((elementDropdown_module_default()).dropdown),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
            className: "row ".concat(bobHandler_responsiveGuttersClass(background1, props.pageResponse.globalStyles[background1.globalStyleId])),
            desktop: alignmentStyles,
            tablet: tabletAlignment,
            mobile: mobileAlignment,
            children: renderDropdown(background1)
        })
    });
};
/* harmony default export */ var dropdown = (Dropdown);

// EXTERNAL MODULE: ./src/stylesheets/modules/templates/elementDropdown_v2.module.sass
var elementDropdown_v2_module = __webpack_require__(93198);
var elementDropdown_v2_module_default = /*#__PURE__*/__webpack_require__.n(elementDropdown_v2_module);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Elements/Dropdowns/DropdownV2/dropdownV2.tsx






//import CountryCode from '../../../../modules/routeCreator/countryCode';






var DropdownV2 = function(props) {
    var dropdownNodeRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), dropdownOpen = ref[0], _setDropdownOpen = ref[1];
    var ref1 = (0,react.useState)(false), isHover = ref1[0], setIsHover = ref1[1];
    var dropdownOpenRef = (0,react.useRef)(dropdownOpen);
    var setDropdownOpen = function(data) {
        dropdownOpenRef.current = data;
        _setDropdownOpen(data);
    };
    var buttonOnHover = function() {
        return setIsHover(true);
    };
    var buttonUnHover = function() {
        return setIsHover(false);
    };
    (0,react.useEffect)(function() {
        if (!props.expManager.enable) document.addEventListener("mousedown", handleClick, false);
        //When inside Iframe at EM
        var IframeElement = document.getElementById("board-preview-frame");
        if (IframeElement) {
            var ref;
            (ref = IframeElement.contentDocument) === null || ref === void 0 ? void 0 : ref.addEventListener("mousedown", handleClick, false);
        }
        return function() {
            if (!props.expManager.enable) document.removeEventListener("mousedown", handleClick, false);
            //When inside Iframe at EM
            var IframeElement = document.getElementById("board-preview-frame");
            if (IframeElement) {
                var ref;
                (ref = IframeElement.contentDocument) === null || ref === void 0 ? void 0 : ref.removeEventListener("mousedown", handleClick, false);
            }
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    var handleClick = function(e) {
        if (dropdownNodeRef.current && dropdownNodeRef.current.contains(e.target)) {
        //inside element
        } else {
            if (dropdownOpenRef.current) setDropdownOpen(false);
        }
    };
    var handleButtonClick = function(buttonLabel) {
        clickEvent("button-".concat(buttonLabel), "Dropdown");
        setDropdownOpen(!dropdownOpen);
    };
    var renderDropdownItems = function() {
        var itemsId = props.obj.children;
        if (itemsId && itemsId.length > 0) {
            return itemsId.map(function(objId, idx) {
                var handledItem = handleObjectType(props.obj, objId, props.pageResponse, props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "dropdown-item ".concat((elementDropdown_v2_module_default())["dropdown-item"]),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                        position: idx,
                        selectedInstanceId: props.obj.selectedInstanceId,
                        component: handledItem,
                        pageResponse: props.pageResponse,
                        matchOrder: props.matchOrder,
                        expManager: props.expManager
                    })
                }, objId);
            });
        }
    };
    var renderDropdown = function(background1Template) {
        var content = getContent(props.obj, "posts");
        if (content && content.length > 0) {
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            return content.map(function(post, idx) {
                var columns = bobHandler_handleColumns(idx, counter, background1Template, props.pageResponse.globalStyles[background1Template.globalStyleId]);
                counter = columns.counter;
                var buttonLabel = getStringField(post, props.obj, props.pageResponse, "text1", props.overrides);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "dropdown",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(bobComponentHandler, {
                                position: props.position,
                                pageResponse: props.pageResponse,
                                instanceId: props.obj.selectedInstanceId,
                                object: props.obj,
                                objectId: props.obj.uuid,
                                post: post,
                                inlineContent: props.obj.content.inlineContent,
                                overrides: props.overrides,
                                field: "background2",
                                rules: props.componentRule,
                                template: props.obj.styles,
                                expManager: props.expManager,
                                className: "btn btn-fluxio btn-lg dropdown-toggle ".concat((elementDropdown_v2_module_default())["dropdown-toggle"], " ").concat(dropdownOpen ? "isOpen ".concat((elementDropdown_v2_module_default()).isOpen) : ""),
                                tag: "button",
                                onClick: function() {
                                    return handleButtonClick(buttonLabel);
                                },
                                onMouseEnter: buttonOnHover,
                                onMouseLeave: buttonUnHover,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: props.position,
                                        pageResponse: props.pageResponse,
                                        replacedMediaList: props.replacedMediaList,
                                        instanceId: props.obj.selectedInstanceId,
                                        object: props.obj,
                                        objectId: props.obj.uuid,
                                        inlineContent: props.obj.content.inlineContent,
                                        overrides: props.overrides,
                                        field: "media1",
                                        template: props.obj.styles,
                                        rules: props.componentRule,
                                        expManager: props.expManager,
                                        network: post.network,
                                        post: post,
                                        className: "".concat(isHover ? "isHover" : "")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: props.position,
                                        pageResponse: props.pageResponse,
                                        instanceId: props.obj.selectedInstanceId,
                                        object: props.obj,
                                        objectId: props.obj.uuid,
                                        post: post,
                                        inlineContent: props.obj.content.inlineContent,
                                        overrides: props.overrides,
                                        field: "text1",
                                        tag: "p",
                                        value: buttonLabel,
                                        template: props.obj.styles,
                                        rules: props.componentRule,
                                        expManager: props.expManager,
                                        network: post.network,
                                        className: "label ".concat((elementDropdown_v2_module_default()).label, " ").concat(isHover ? "isHover" : "")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                        position: props.position,
                                        pageResponse: props.pageResponse,
                                        instanceId: props.obj.selectedInstanceId,
                                        object: props.obj,
                                        objectId: props.obj.uuid,
                                        field: "icon1",
                                        template: props.obj.styles,
                                        rules: props.componentRule,
                                        expManager: props.expManager,
                                        iconClassName: "fas fa-chevron-down"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "dropdown-menu ".concat((elementDropdown_v2_module_default())["dropdown-menu"], " ").concat(dropdownOpen ? "isOpen ".concat((elementDropdown_v2_module_default()).isOpen) : ""),
                                children: dropdownOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                    position: props.position,
                                    pageResponse: props.pageResponse,
                                    instanceId: props.obj.selectedInstanceId,
                                    object: props.obj,
                                    objectId: props.obj.uuid,
                                    inlineContent: props.obj.content.inlineContent,
                                    overrides: props.overrides,
                                    field: "background3",
                                    flexDirection: "column",
                                    rules: props.componentRule,
                                    template: props.obj.styles,
                                    expManager: props.expManager,
                                    children: renderDropdownItems()
                                }, idx)
                            })
                        ]
                    })
                }, idx);
            });
        } else {
            if (props.expManager.enable) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-sm-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warningSystem, {
                        alertType: "alert-secondary w-100 text-center",
                        messages: "Add a single post or a feed"
                    })
                });
            }
        }
    };
    /**
   * Responsive Alignment Styles
   */ var background1 = props.obj.styles.bobs.background1;
    var ref2 = alignment(background1), alignmentStyles = ref2.alignmentStyles, tabletAlignment = ref2.tabletAlignment, mobileAlignment = ref2.mobileAlignment;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "elements ".concat((elementDropdown_v2_module_default()).elements, " button dropdown_v2 ").concat((elementDropdown_v2_module_default()).dropdown_v2),
        ref: dropdownNodeRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
            className: "row ".concat(bobHandler_responsiveGuttersClass(background1, props.pageResponse.globalStyles[background1.globalStyleId])),
            desktop: alignmentStyles,
            tablet: tabletAlignment,
            mobile: mobileAlignment,
            children: renderDropdown(isBobBackground(background1))
        })
    });
};
/* harmony default export */ var dropdownV2 = (DropdownV2);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
;// CONCATENATED MODULE: ./src/split/shared-modules/LinkManager/Link.tsx


var Link = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        passHref: true,
        href: props.to,
        scroll: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: props.className,
            style: props.style,
            children: props.children
        })
    }, props.key);
};


;// CONCATENATED MODULE: ./src/modules/shared-modules/routeCreator/LinkManager/LinkManager.tsx




var LinkManager = function(props) {
    var children = props.children;
    var key = props.innerKey ? props.innerKey : (0,v4/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
        className: props.className,
        style: props.style,
        to: props.to,
        passHref: true,
        href: props.to,
        onClick: props.onClick,
        expManager: props.expManager,
        children: children
    }, key);
};
/* harmony default export */ var LinkManager_LinkManager = (LinkManager);

;// CONCATENATED MODULE: ./src/modules/shared-modules/routeCreator/LinkManager/index.ts

/* harmony default export */ var routeCreator_LinkManager = (LinkManager_LinkManager);

;// CONCATENATED MODULE: ./src/areas/public-page/fluxio-components/Expand/cardExpandContainer/cardExpandContainer.tsx












//@ts-ignore


var CardExpandContainer = function(props) {
    var linkRef;
    var linkRefToChild = (0,react.useRef)(linkRef);
    var ref = (0,react.useState)(undefined), expSelectedItem = ref[0], setExpSelectedItem = ref[1];
    var ref1 = (0,react.useState)(undefined), selectedItem = ref1[0], setSelectedItem = ref1[1];
    var ref2 = (0,react.useState)(true), isNotMobileBreakpoint = ref2[0], setIsNotMobileBreakpoint = ref2[1];
    (0,react.useEffect)(function() {
        setIsNotMobileBreakpoint(window.matchMedia("(min-width: 768px)").matches);
        setExpSelectedItem(localStorage.getItem("cascaisPreviewCard-".concat(props.obj.uuid)));
    }, []);
    (0,react.useEffect)(function() {
        handleSelectedUri(props);
    }, [
        props.router.asPath
    ]);
    var handleSelectedUri = function(props) {
        var route = routeCreator_route(props.matchOrder, props.router);
        if (route && selectedItem !== route) {
            setSelectedItem(route);
        } else return;
    };
    var getSelectedUri = function() {
        if (props.expManager.enable) return expSelectedItem;
        else return selectedItem;
    };
    var handleSelectedItem = function(item) {
        /**
     * We save in the local storage the selected card
     * so when the user triggers a new event inside the EM
     * the selected card stays open
     */ localStorage.setItem("cascaisPreviewCard-".concat(props.obj.uuid), handleObjectUri(item));
        setExpSelectedItem(handleObjectUri(item));
    };
    var renderSelectedContent = function(menuItemsGroup) {
        if (selectedItem || expSelectedItem) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                var _loop = function(_iterator, _step) {
                    var menuContent = _step.value;
                    if (menuContent.children && menuContent.children.length > 0) {
                        if (handleObjectUri(menuContent) === getSelectedUri()) {
                            var menuContentChilds = menuContent.children;
                            return {
                                v: menuContentChilds.map(function(menuChildId, idx) {
                                    var handledItem = handleObjectType(menuContent, menuChildId, props.pageResponse, props.expManager.emEditorType);
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                                        position: idx,
                                        selectedInstanceId: handledItem.selectedInstanceId,
                                        component: handledItem,
                                        pageResponse: props.pageResponse,
                                        matchOrder: props.matchOrder + 1,
                                        expManager: props.expManager
                                    }, idx);
                                })
                            };
                        } else {
                            return "continue";
                        }
                    } else {
                        return "continue";
                    }
                };
                for(var _iterator = menuItemsGroup[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _ret = _loop(_iterator, _step);
                    if ((0,_type_of/* default */.Z)(_ret) === "object") return _ret.v;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    };
    var renderMenuItems = function(background1Template) {
        var menuItems = props.obj.children;
        if (menuItems && menuItems.length > 0) {
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            var menuItemsGroup = [];
            return menuItems.map(function(menuItemId, idx) {
                var ref;
                var menuItem = handleObjectType(props.obj, menuItemId, props.pageResponse, props.expManager.emEditorType);
                var handledMenuItem = handleInstanceObject(menuItem, props.pageResponse);
                linkRef = handleObjectUri(handledMenuItem);
                var columns = bobHandler_handleColumns(idx, counter, background1Template, props.pageResponse.globalStyles[background1Template.globalStyleId]);
                var itemIsActive = handleObjectUri(handledMenuItem) === getSelectedUri() ? "active" : "";
                var container = undefined;
                if (isNotMobileBreakpoint) {
                    // group menuItems contents in groups of {columns}
                    // and render a container for each group
                    if ((idx + 1) % (12 / parseInt(columns.columns)) === 0) {
                        menuItemsGroup = (0,src_to_consumable_array/* default */.Z)(menuItemsGroup).concat([
                            handledMenuItem
                        ]);
                        container = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "expand-content col-12",
                            children: renderSelectedContent(menuItemsGroup)
                        });
                        menuItemsGroup = [];
                    } else if (idx === menuItems.length - 1) {
                        menuItemsGroup = (0,src_to_consumable_array/* default */.Z)(menuItemsGroup).concat([
                            handledMenuItem
                        ]);
                        container = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "expand-content col-12",
                            children: renderSelectedContent(menuItemsGroup)
                        });
                        menuItemsGroup = [];
                    } else {
                        menuItemsGroup = (0,src_to_consumable_array/* default */.Z)(menuItemsGroup).concat([
                            handledMenuItem
                        ]);
                        container = undefined;
                    }
                } else {
                    menuItemsGroup = [
                        handledMenuItem
                    ];
                    container = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "expand-content col-12",
                        children: renderSelectedContent(menuItemsGroup)
                    });
                }
                var menuCard = /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                    position: idx,
                    selectedInstanceId: props.obj.selectedInstanceId,
                    component: handleContentBlock(handledMenuItem, (ref = props.obj.content.formula) === null || ref === void 0 ? void 0 : ref.posts[0], props.obj, props.pageResponse, props.overrides),
                    pageResponse: props.pageResponse,
                    matchOrder: props.matchOrder,
                    expManager: props.expManager
                }, idx);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                            children: props.expManager.enable ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: function() {
                                    return handleSelectedItem(handledMenuItem);
                                },
                                className: "".concat(itemIsActive),
                                children: menuCard
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(routeCreator_LinkManager, {
                                expManager: props.expManager,
                                to: handler(props.router, props.matchOrder, handleObjectUri(handledMenuItem)),
                                ref: linkRefToChild,
                                innerKey: idx,
                                onClick: function() {
                                    return handleSelectedItem(handledMenuItem);
                                },
                                className: "".concat(itemIsActive),
                                children: menuCard
                            })
                        }),
                        container ? container : []
                    ]
                }, idx);
            });
        } else if (props.expManager.enable) {
            return renderNoChilds();
        }
        return [];
    };
    var renderNoChilds = function() {
        /**
     * render no content placeholder
     */ if (props.expManager.enable) {
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            var Background1 = isBobBackground(props.obj.styles.bobs.background1);
            var childs = Background1.grid.columns && Background1.grid.columns.length;
            var components = [];
            for(var i = 0; i < childs; i++){
                var columns = bobHandler_handleColumns(i, counter, Background1, props.pageResponse.globalStyles[Background1.globalStyleId]);
                counter = columns.counter;
                components = (0,src_to_consumable_array/* default */.Z)(components).concat([
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                                verticalAlign: "middle",
                                height: "".concat(Background1.height.enable ? Background1.height.value : "100").concat(Background1.height.enable ? Background1.height.unit : "px"),
                                border: "3px dashed #dbe0e7"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "alert warning m-0",
                                role: "alert",
                                children: [
                                    "Add ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Card Expand"
                                    }),
                                    " component as childs to show menu items."
                                ]
                            })
                        })
                    }, i), 
                ]);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(warningDefaultSystem, {
                children: components
            });
        }
    };
    /**
   * Responsive Alignment Styles
   */ var background1 = isBobBackground(props.obj.styles.bobs.background1);
    var ref3 = alignment(background1), alignmentStyles = ref3.alignmentStyles, tabletAlignment = ref3.tabletAlignment, mobileAlignment = ref3.mobileAlignment;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "expands card-expand-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
            className: "row ".concat(bobHandler_responsiveGuttersClass(background1, props.pageResponse.globalStyles[background1.globalStyleId])),
            desktop: alignmentStyles,
            tablet: tabletAlignment,
            mobile: mobileAlignment,
            children: renderMenuItems(background1)
        })
    });
};
/* harmony default export */ var cardExpandContainer = ((0,router.withRouter)(CardExpandContainer));

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Expand/cardExpandContent/expandContent.tsx











var CardExpandContent = function(props) {
    var renderCards = function(background1Template) {
        var content = getContent(props.obj, "posts", props.overrides);
        if (content && content.length > 0) {
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            return content.map(function(post, idx) {
                var columns = bobHandler_handleColumns(idx, counter, background1Template);
                counter = columns.counter;
                var CARD = /*#__PURE__*/ (0,jsx_runtime.jsxs)(bobComponentHandler, {
                    position: props.position,
                    pageResponse: props.pageResponse,
                    instanceId: props.obj.selectedInstanceId,
                    object: props.obj,
                    objectId: props.obj.uuid,
                    post: post,
                    inlineContent: props.obj.content.inlineContent,
                    overrides: props.overrides,
                    field: "background2",
                    rules: props.componentRule,
                    template: props.obj.styles,
                    expManager: props.expManager,
                    className: "card ".concat(props.itemIsActive),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: props.position,
                            pageResponse: props.pageResponse,
                            replacedMediaList: props.replacedMediaList,
                            instanceId: props.obj.selectedInstanceId,
                            object: props.obj,
                            objectId: props.obj.uuid,
                            inlineContent: props.obj.content.inlineContent,
                            overrides: props.overrides,
                            field: "media1",
                            template: props.obj.styles,
                            rules: props.componentRule,
                            expManager: props.expManager,
                            network: post.network,
                            post: post
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "card-body",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                    position: props.position,
                                    pageResponse: props.pageResponse,
                                    instanceId: props.obj.selectedInstanceId,
                                    object: props.obj,
                                    objectId: props.obj.uuid,
                                    post: post,
                                    inlineContent: props.obj.content.inlineContent,
                                    overrides: props.overrides,
                                    field: "text1",
                                    tag: "p",
                                    value: getStringField(post, props.obj, props.pageResponse, "text1", props.overrides),
                                    template: props.obj.styles,
                                    rules: props.componentRule,
                                    expManager: props.expManager,
                                    network: post.network,
                                    className: "title"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                    position: props.position,
                                    pageResponse: props.pageResponse,
                                    instanceId: props.obj.selectedInstanceId,
                                    object: props.obj,
                                    objectId: props.obj.uuid,
                                    post: post,
                                    inlineContent: props.obj.content.inlineContent,
                                    overrides: props.overrides,
                                    field: "text2",
                                    tag: "p",
                                    value: getStringField(post, props.obj, props.pageResponse, "text2", props.overrides),
                                    template: props.obj.styles,
                                    rules: props.componentRule,
                                    expManager: props.expManager,
                                    network: post.network,
                                    className: "preview"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                    position: props.position,
                                    pageResponse: props.pageResponse,
                                    instanceId: props.obj.selectedInstanceId,
                                    object: props.obj,
                                    objectId: props.obj.uuid,
                                    post: post,
                                    inlineContent: props.obj.content.inlineContent,
                                    overrides: props.overrides,
                                    field: "text3",
                                    tag: "p",
                                    value: getStringField(post, props.obj, props.pageResponse, "text3", props.overrides),
                                    template: props.obj.styles,
                                    rules: props.componentRule,
                                    expManager: props.expManager,
                                    network: post.network,
                                    className: "message"
                                })
                            ]
                        })
                    ]
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                    children: CARD
                }, idx);
            });
        } else {
            if (props.expManager.enable) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-sm-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warningSystem, {
                        alertType: "alert-secondary w-100 text-center",
                        messages: "Select a formula to show posts"
                    })
                });
            }
        }
    };
    /**
   * Responsive Alignment Styles
   */ var background1 = isBobBackground(props.obj.styles.bobs.background1);
    var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
    var gutters = handleGutts(background1, false);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "expands cards ".concat((cards_module_default()).cards),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
            className: "card-deck ".concat((card_module_default())["card-deck"], " row ").concat(gutters, " ").concat(bobHandler_responsiveGuttersClass(background1)),
            desktop: alignmentStyles,
            tablet: tabletAlignment,
            mobile: mobileAlignment,
            children: renderCards(background1)
        })
    });
};
/* harmony default export */ var expandContent = (CardExpandContent);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Expand/cardExpandContentV2/expandContentV2.tsx











var CardExpandContentV2 = function(props) {
    var renderCards = function(background1Template) {
        var content = getContent(props.obj, "posts", props.overrides);
        if (content && content.length > 0) {
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            return content.map(function(post, idx) {
                var columns = bobHandler_handleColumns(idx, counter, background1Template, props.pageResponse.globalStyles[background1Template.globalStyleId]);
                counter = columns.counter;
                var CARD = /*#__PURE__*/ (0,jsx_runtime.jsxs)(bobComponentHandler, {
                    position: props.position,
                    pageResponse: props.pageResponse,
                    instanceId: props.obj.selectedInstanceId,
                    object: props.obj,
                    objectId: props.obj.uuid,
                    post: post,
                    inlineContent: props.obj.content.inlineContent,
                    overrides: props.overrides,
                    field: "background2",
                    rules: props.componentRule,
                    template: props.obj.styles,
                    expManager: props.expManager,
                    className: "card ".concat(props.itemIsActive),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                            position: props.position,
                            pageResponse: props.pageResponse,
                            replacedMediaList: props.replacedMediaList,
                            instanceId: props.obj.selectedInstanceId,
                            object: props.obj,
                            objectId: props.obj.uuid,
                            inlineContent: props.obj.content.inlineContent,
                            overrides: props.overrides,
                            field: "media1",
                            template: props.obj.styles,
                            rules: props.componentRule,
                            expManager: props.expManager,
                            network: post.network,
                            post: post
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "card-body",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                    position: props.position,
                                    pageResponse: props.pageResponse,
                                    instanceId: props.obj.selectedInstanceId,
                                    object: props.obj,
                                    objectId: props.obj.uuid,
                                    post: post,
                                    inlineContent: props.obj.content.inlineContent,
                                    overrides: props.overrides,
                                    field: "text1",
                                    tag: "p",
                                    value: getStringField(post, props.obj, props.pageResponse, "text1", props.overrides),
                                    template: props.obj.styles,
                                    rules: props.componentRule,
                                    expManager: props.expManager,
                                    network: post.network,
                                    className: "title"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                    position: props.position,
                                    pageResponse: props.pageResponse,
                                    instanceId: props.obj.selectedInstanceId,
                                    object: props.obj,
                                    objectId: props.obj.uuid,
                                    post: post,
                                    inlineContent: props.obj.content.inlineContent,
                                    overrides: props.overrides,
                                    field: "text2",
                                    tag: "p",
                                    value: getStringField(post, props.obj, props.pageResponse, "text2", props.overrides),
                                    template: props.obj.styles,
                                    rules: props.componentRule,
                                    expManager: props.expManager,
                                    network: post.network,
                                    className: "preview"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                    position: props.position,
                                    pageResponse: props.pageResponse,
                                    instanceId: props.obj.selectedInstanceId,
                                    object: props.obj,
                                    objectId: props.obj.uuid,
                                    post: post,
                                    inlineContent: props.obj.content.inlineContent,
                                    overrides: props.overrides,
                                    field: "text3",
                                    tag: "p",
                                    value: getStringField(post, props.obj, props.pageResponse, "text3", props.overrides),
                                    template: props.obj.styles,
                                    rules: props.componentRule,
                                    expManager: props.expManager,
                                    network: post.network,
                                    className: "message"
                                })
                            ]
                        })
                    ]
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                    children: CARD
                }, idx);
            });
        } else {
            if (props.expManager.enable) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-sm-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warningSystem, {
                        alertType: "alert-secondary w-100 text-center",
                        messages: "Select a formula to show posts"
                    })
                });
            }
        }
    };
    /**
   * Responsive Alignment Styles
   */ var background1 = isBobBackground(props.obj.styles.bobs.background1);
    var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "expands cards ".concat((cards_module_default()).cards),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
            className: "card-deck ".concat((card_module_default())["card-deck"], " row ").concat(bobHandler_responsiveGuttersClass(background1, props.pageResponse.globalStyles[background1.globalStyleId])),
            desktop: alignmentStyles,
            tablet: tabletAlignment,
            mobile: mobileAlignment,
            children: renderCards(background1)
        })
    });
};
/* harmony default export */ var expandContentV2 = (CardExpandContentV2);

// EXTERNAL MODULE: ./node_modules/react-compare-image/dist/bundle.js
var bundle = __webpack_require__(50864);
var bundle_default = /*#__PURE__*/__webpack_require__.n(bundle);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Gallery/comparationSlider/comparationSlider.tsx


// @ts-ignore



var ComparationSlider = function(props) {
    var handleRemoveHTMLTags = function(text) {
        var div = document.createElement("div");
        div.innerHTML = text;
        return div.textContent || div.innerText || undefined;
    };
    var handleGetAssets = function() {
        var content = getContent(props.obj, "posts", props.overrides);
        var styles = props.obj.styles;
        var media1 = isBobMedia(styles.bobs.media1);
        var media2 = isBobMedia(styles.bobs.media2);
        var text1 = isBobText(styles.bobs.text1);
        var text2 = isBobText(styles.bobs.text2);
        var icon1 = isBobIcon(styles.bobs.icon1);
        //Media handle for source type
        if (media1.contentSrc !== "custom") media1 = content[0].picture_orig;
        if (media2.contentSrc !== "custom") media2 = content[1].picture_orig;
        //Text handle for source type
        if (text1.contentSrc !== "custom") text1 = content[0].title;
        if (text2.contentSrc !== "custom") text2 = content[1].title;
        return {
            media1: media1.enable ? media1.src : "https://cdn.fluxio.cloud/fluxio/fluxio_placeholder.png",
            media2: media2.enable ? media2.src : "https://cdn.fluxio.cloud/fluxio/fluxio_placeholder.png",
            text1: text1.enable ? handleRemoveHTMLTags(text1.customText) : undefined,
            text2: text2.enable ? handleRemoveHTMLTags(text2.customText) : undefined,
            icon1: icon1.enable ? icon1.color : "#fff"
        };
    };
    var ref = handleGetAssets(), media1 = ref.media1, media2 = ref.media2, text1 = ref.text1, text2 = ref.text2, icon1 = ref.icon1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "comparation-slider",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((bundle_default()), {
            leftImageLabel: text1,
            leftImage: media1 !== "" ? media1 : "https://cdn.fluxio.cloud/fluxio/fluxio_placeholder.png",
            rightImage: media2 !== "" ? media2 : "https://cdn.fluxio.cloud/fluxio/fluxio_placeholder.png",
            rightImageLabel: text2,
            sliderLineColor: icon1
        })
    });
};
/* harmony default export */ var comparationSlider = (ComparationSlider);

// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobFormComponents.tsx






function bobFormComponents_handleBackgroundImage(templateStyles) {
    var url = "";
    if (templateStyles.colors.isGradient) url = "linear-gradient(".concat(templateStyles.colors.gradientAngle ? templateStyles.colors.gradientAngle : 0, "deg, ").concat(templateStyles.colors.colorFirst, ", ").concat(templateStyles.colors.colorSecond, "), url(").concat(templateStyles.image.src, ")");
    return url;
}
function handleBackgroundStyles(template, globalStyles) {
    var backgroundTemplateStyles = handleBakgroundGlobalStyles(template, globalStyles);
    var bondariesObj = handleBondaries(backgroundTemplateStyles);
    var borders = conditionalBorderRenderUnsafe(backgroundTemplateStyles, "desktop", "default", true);
    var shadows = handleShadow(backgroundTemplateStyles);
    var radiusStyles = handleRadius(backgroundTemplateStyles);
    var styles = (0,src_object_spread/* default */.Z)({}, bondariesObj, shadows, borders, radiusStyles);
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        height: backgroundTemplateStyles.height.enable ? "".concat(backgroundTemplateStyles.height.value).concat(backgroundTemplateStyles.height.unit, " !important") : "auto !important"
    }, styles), {
        backgroundColor: backgroundTemplateStyles.colors.enable && !backgroundTemplateStyles.colors.isGradient ? backgroundTemplateStyles.colors.colorFirst + " !important" : "transparent !important",
        backgroundImage: backgroundTemplateStyles.colors.enable && backgroundTemplateStyles.colors.isGradient ? "linear-gradient(".concat(backgroundTemplateStyles.colors.gradientAngle, "deg, ").concat(backgroundTemplateStyles.colors.colorFirst, ", ").concat(backgroundTemplateStyles.colors.colorSecond, ")  !important") : ""
    });
}
function handleBakgroundGlobalStyles(template, globalStyles) {
    if (!template.globalStyleId || !globalStyles || !globalStyles[template.globalStyleId]) return template;
    var clonedBobTemplate = cloneDeep_default()(template);
    clonedBobTemplate.colors = globalStyles[template.globalStyleId].colors;
    clonedBobTemplate.border = globalStyles[template.globalStyleId].border;
    clonedBobTemplate.shadow = globalStyles[template.globalStyleId].shadow;
    clonedBobTemplate.radius = globalStyles[template.globalStyleId].radius;
    clonedBobTemplate.image = globalStyles[template.globalStyleId].image;
    return clonedBobTemplate;
}
function handleTextStyles(template, globalStyles, expManager) {
    var fontTemplateStyles = handleTextGlobalStyles(template, globalStyles);
    var FONTLOADED = "";
    if (expManager.enable) {
        FONTLOADED = dynamicFontLoader(fontTemplateStyles ? fontTemplateStyles : bobDefaultNode_styles, [
            fontTemplateStyles.fontWeight
        ], undefined);
    }
    var templateObj = fontTemplateStyles;
    var textShadows = handleTextShadow(templateObj);
    var verticalAlign = handleVerticalAlign(templateObj["verticalAlign"]);
    var styles = (0,src_object_spread/* default */.Z)({}, textShadows, verticalAlign);
    return {
        styles: (0,src_object_spread/* default */.Z)({
            fontFamily: clearFont(templateObj["fontFamily"]) + " !important",
            fontWeight: templateObj["fontWeight"] + " !important",
            fontSize: templateObj["fontSize"] + "px !important",
            letterSpacing: templateObj["letterSpacing"] + "px !important",
            lineHeight: templateObj["lineHeight"] + " !important",
            textAlign: templateObj["textAlign"] + " !important",
            textTransform: templateObj["textTransform"] + " !important",
            color: templateObj["color"] + " !important"
        }, styles),
        fontLoaded: FONTLOADED
    };
}
function handleTextGlobalStyles(template, globalStyles) {
    if (!template.globalStyleId || !globalStyles || !globalStyles[template.globalStyleId]) return template;
    var clonedBobTemplate = cloneDeep_default()(template);
    clonedBobTemplate.fontFamily = globalStyles[template.globalStyleId].fontFamily;
    clonedBobTemplate.fontWeight = globalStyles[template.globalStyleId].fontWeight;
    clonedBobTemplate.fontSize = globalStyles[template.globalStyleId].fontSize;
    clonedBobTemplate.letterSpacing = globalStyles[template.globalStyleId].letterSpacing;
    clonedBobTemplate.lineHeight = globalStyles[template.globalStyleId].lineHeight;
    clonedBobTemplate.color = globalStyles[template.globalStyleId].color;
    clonedBobTemplate.tag = globalStyles[template.globalStyleId].tag;
    clonedBobTemplate.shadow = globalStyles[template.globalStyleId].shadow;
    return clonedBobTemplate;
}
function removeImportantFromStyle(stylesWithImportant) {
    for(var key in stylesWithImportant){
        var style = stylesWithImportant[key];
        stylesWithImportant[key] = style.replace("!important", "");
    }
    return stylesWithImportant;
}
function handlePlaceholderStyles(styles) {
    return "\n    ::placeholder{\n      color: ".concat(styles.color, ";\n      font-size: ").concat(styles.fontSize || styles["font-size"], ";\n    }\n    ");
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/forms/formContainer/textInput/textInput.tsx


function textInput_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  @media only screen and (max-width: 992px) and (min-width: 767px) {\n    ",
        "\n    ",
        "\n  }\n  @media all and (max-width: 766px) {\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    textInput_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


// @ts-ignore









var TextInputElement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b3f3bc2-0"
})(textInput_templateObject(), function(props) {
    return props.desktop;
}, function(props) {
    return handlePlaceholderStyles(props.desktop);
}, function(props) {
    return props.tablet;
}, function(props) {
    return handlePlaceholderStyles(props.tablet);
}, function(props) {
    return props.mobile;
}, function(props) {
    return handlePlaceholderStyles(props.mobile);
});
var TextInput = function(props) {
    var _value;
    var ref = (0,react.useState)((_value = props.inputObj.value) !== null && _value !== void 0 ? _value : ""), value = ref[0], setValue = ref[1];
    var isInitialMount = (0,react.useRef)(true);
    var timer = null;
    (0,react.useEffect)(function() {
        return function() {
            return clearTimer();
        };
    // eslint-disable-next-line
    }, []);
    (0,react.useEffect)(function() {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            if (props.delay) {
                // eslint-disable-next-line
                timer = setTimeout(function() {
                    return props.handleValueChange(value);
                }, props.delay);
            } else props.handleValueChange(value);
        }
    }, [
        value
    ]);
    var clearTimer = function() {
        if (timer) clearTimeout(timer);
    };
    var handleValueChange = function(value) {
        clearTimer();
        setValue(value);
    };
    var handleErrorBorder = function() {
        if (props.error) return {
            border: "2px solid red"
        };
        return {};
    };
    var renderErrorBorder = handleErrorBorder();
    var backgroundStyles = handleBackgroundStyles(props.bobStyle.bobInput, props.pageResponse.globalStyles);
    var textStyles = handleTextStyles(props.bobStyle.bobInput, props.pageResponse.globalStyles, props.expManager);
    var styles = (0,src_object_spread/* default */.Z)({}, backgroundStyles, textStyles.styles, renderErrorBorder);
    var mobileStyles = responsiveProperties((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "mobile", undefined, [
        "colors", 
    ]);
    mobileStyles = (0,src_object_spread/* default */.Z)({}, mobileStyles, responsiveGroupStylesProperties((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "mobile", "text"), conditionalColorsRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "mobile", "default", true), colorStyle_cssRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "mobile", "default", undefined, undefined, true), conditionalBorderRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "mobile", "default", true));
    var tabletStyles = responsiveProperties((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "tablet", undefined, [
        "colors", 
    ]);
    tabletStyles = (0,src_object_spread/* default */.Z)({}, tabletStyles, responsiveGroupStylesProperties((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "tablet", "text"), conditionalColorsRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "tablet", "default", true), colorStyle_cssRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "tablet", "default", undefined, undefined, true), conditionalBorderRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "tablet", "default", true));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((style_it_default()), {
        children: [
            "\n      ".concat(textStyles.fontLoaded, "          \n    "),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "form-group",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        position: props.position,
                        pageResponse: props.pageResponse,
                        instanceId: props.obj.selectedInstanceId,
                        inlineContent: props.obj.content.inlineContent,
                        overrides: props.overrides,
                        object: props.obj,
                        objectId: props.obj.uuid,
                        field: props.bobStyle.text.name,
                        tag: "label",
                        value: props.inputObj.label || props.inputObj.name,
                        template: (0,src_object_spread/* default */.Z)({}, props.obj.styles),
                        rules: props.componentRule,
                        expManager: props.expManager,
                        network: props.obj.network
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputElement, {
                        as: "input",
                        type: "text",
                        value: value,
                        desktop: styles,
                        mobile: mobileStyles,
                        tablet: tabletStyles,
                        placeholder: props.inputObj.label || props.inputObj.name,
                        onChange: function(e) {
                            return handleValueChange(e.target.value);
                        },
                        className: "form-control",
                        onFocus: function(e) {
                            var ref, ref1;
                            var formName = (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.form) === null || ref1 === void 0 ? void 0 : ref1.name;
                            if (formName) {
                                formInput(e, formName);
                            }
                        }
                    }),
                    props.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "simple-form-error",
                        children: props.lang === "en" ? "This field is required" : "Campo obrigat\xf3rio"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var textInput = (TextInput);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/forms/formContainer/selectInput/selectInput.tsx


function selectInput_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  @media only screen and (max-width: 992px) and (min-width: 767px) {\n    ",
        "\n  }\n  @media all and (max-width: 766px) {\n    ",
        "\n  }\n"
    ]);
    selectInput_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


// @ts-ignore







var SelectInputElement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-85302bab-0"
})(selectInput_templateObject(), function(props) {
    return props.desktop;
}, function(props) {
    return props.tablet;
}, function(props) {
    return props.mobile;
});
var SelectInput = function(props) {
    var ref = (0,react.useState)(""), value = ref[0], setValue = ref[1];
    var isInitialMount = (0,react.useRef)(true);
    (0,react.useEffect)(function() {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            props.handleValueChange(value);
        }
    // eslint-disable-next-line
    }, [
        value
    ]);
    var handleValueChange = function(inputValue) {
        setValue(inputValue);
    };
    var handleErrorBorder = function() {
        if (props.error) return {
            border: "2px solid red"
        };
        return {};
    };
    var renderErrorBorder = handleErrorBorder();
    var backgroundStyles = handleBackgroundStyles(props.bobStyle.bobInput, props.pageResponse.globalStyles);
    var textStyles = handleTextStyles(props.bobStyle.bobInput, props.pageResponse.globalStyles, props.expManager);
    var styles = (0,src_object_spread/* default */.Z)({}, backgroundStyles, textStyles.styles, renderErrorBorder);
    var mobileStyles = responsiveProperties((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "mobile", undefined, [
        "colors", 
    ]);
    mobileStyles = (0,src_object_spread/* default */.Z)({}, mobileStyles, responsiveGroupStylesProperties((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "mobile", "text"), conditionalColorsRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "mobile", "default", true), colorStyle_cssRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "mobile", "default", undefined, undefined, true));
    var tabletStyles = responsiveProperties((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "tablet", undefined, [
        "colors", 
    ]);
    tabletStyles = (0,src_object_spread/* default */.Z)({}, tabletStyles, responsiveGroupStylesProperties((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "tablet", "text"), conditionalColorsRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "tablet", "default", true), colorStyle_cssRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "tablet", "default", undefined, undefined, true));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((style_it_default()), {
        children: [
            "\n      ".concat(textStyles.fontLoaded, "          \n    "),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "form-group",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        position: props.position,
                        pageResponse: props.pageResponse,
                        instanceId: props.obj.selectedInstanceId,
                        inlineContent: props.obj.content.inlineContent,
                        overrides: props.overrides,
                        object: props.obj,
                        objectId: props.obj.uuid,
                        field: props.bobStyle.text.name,
                        tag: "label",
                        value: props.inputObj.label || props.inputObj.name,
                        template: props.obj.styles,
                        rules: props.componentRule,
                        expManager: props.expManager,
                        network: props.obj.network
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "select-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectInputElement, {
                            as: "select",
                            desktop: styles,
                            mobile: mobileStyles,
                            tablet: tabletStyles,
                            className: "form-control",
                            name: props.inputObj.name,
                            value: value,
                            onChange: function(e) {
                                return handleValueChange(e.target.value);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    style: {
                                        display: "none"
                                    },
                                    children: props.inputObj.label || props.inputObj.name
                                }),
                                props.inputObj.selectChoices.map(function(option, idx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: option,
                                        children: option
                                    }, idx);
                                })
                            ]
                        })
                    }),
                    props.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "simple-form-error",
                        children: props.lang === "en" ? "This field is required" : "Campo obrigat\xf3rio"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var selectInput = (SelectInput);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/forms/formContainer/fileInput/fileInput.tsx




function fileInput_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  @media only screen and (max-width: 992px) and (min-width: 767px) {\n    ",
        "\n  }\n  @media all and (max-width: 766px) {\n    ",
        "\n  }\n"
    ]);
    fileInput_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


// @ts-ignore









var FileInputButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b37734f2-0"
})(fileInput_templateObject(), function(props) {
    return props.desktop;
}, function(props) {
    return props.tablet;
}, function(props) {
    return props.mobile;
});
var FileInput = function(props) {
    var ref = (0,react.useState)(undefined), value = ref[0], setValue = ref[1];
    var ref1 = (0,react.useState)(""), fileName = ref1[0], setFileName = ref1[1];
    var ref2 = (0,react.useState)(false), errorUpload = ref2[0], setErrorUpload = ref2[1];
    var isInitialMount = (0,react.useRef)(true);
    (0,react.useEffect)(function() {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            handleUploadFile();
        }
    // eslint-disable-next-line
    }, [
        value
    ]);
    // ref for input html element
    var fileInput = (0,react.useRef)();
    var handleValueChange = function(e) {
        var target = e.target;
        if (target.files && target.files.length > 0) {
            var reader = new FileReader();
            var fileData = target.files;
            reader.addEventListener("load", function() {
                setValue(fileData[0]);
                setFileName(fileData[0].name);
                setErrorUpload(false);
            });
            reader.readAsDataURL(target.files[0]);
        }
    };
    var handleUploadFile = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var config, formData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        config = {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                Accept: "application/json",
                                "MeshApp-host": "meshapp"
                            }
                        };
                        formData = new FormData();
                        formData.append("file", value);
                        _ctx.next = 5;
                        return axios_default().post("".concat(shared_api_apiEnv(), "v1/forms/").concat(props.formId, "/files"), formData, config).then(function(response) {
                            return props.handleValueChange(response.data.url);
                        }).catch(function() {
                            return setErrorUpload(true);
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleUploadFile() {
            return _ref.apply(this, arguments);
        };
    }();
    var renderButton = function(backgroundStyles, textStyles) {
        var styles = (0,src_object_spread/* default */.Z)({}, backgroundStyles, textStyles.styles);
        var mobileStyles = responsiveProperties((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "mobile", undefined, [
            "colors"
        ]);
        mobileStyles = (0,src_object_spread/* default */.Z)({}, mobileStyles, responsiveGroupStylesProperties((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "mobile", "text"), conditionalColorsRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "mobile", "default", true), colorStyle_cssRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "mobile", "default", undefined, undefined, true));
        var tabletStyles = responsiveProperties((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "tablet", undefined, [
            "colors"
        ]);
        tabletStyles = (0,src_object_spread/* default */.Z)({}, tabletStyles, responsiveGroupStylesProperties((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "tablet", "text"), conditionalColorsRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "tablet", "default", true), colorStyle_cssRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "tablet", "default", undefined, undefined, true));
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FileInputButton, {
            as: "button",
            desktop: styles,
            mobile: mobileStyles,
            tablet: tabletStyles,
            type: "button",
            className: "btn btn-secondary",
            onClick: function() {
                return fileInput.current && fileInput.current.click();
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "fas fa-paperclip"
            })
        });
    };
    var backgroundStyles = handleBackgroundStyles(props.bobStyle.bobInput, props.pageResponse.globalStyles);
    var textStyles = handleTextStyles(props.bobStyle.bobInput, props.pageResponse.globalStyles, props.expManager);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((style_it_default()), {
        children: [
            "\n        ".concat(textStyles.fontLoaded, "          \n      "),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "form-group d-flex align-items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        ref: fileInput,
                        type: "file",
                        onChange: function(e) {
                            return handleValueChange(e);
                        },
                        style: {
                            display: "none",
                            height: "0",
                            width: "0"
                        }
                    }),
                    renderButton(backgroundStyles, textStyles),
                    fileName ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "simple-form-message",
                        children: fileName
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        position: props.position,
                        pageResponse: props.pageResponse,
                        instanceId: props.obj.selectedInstanceId,
                        inlineContent: props.obj.content.inlineContent,
                        overrides: props.overrides,
                        object: props.obj,
                        objectId: props.obj.uuid,
                        field: props.bobStyle.text.name,
                        tag: "label",
                        value: props.inputObj.label || props.inputObj.name,
                        template: props.obj.styles,
                        rules: props.componentRule,
                        expManager: props.expManager,
                        network: props.obj.network
                    }),
                    errorUpload && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "simple-form-error",
                        children: props.lang === "en" ? "There was an error uploading your file, please try again" : "Erro ao enviar o ficheiro, por favor tente novamente."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var fileInput = (FileInput);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/forms/formContainer/checkboxInput/checkboxInput.tsx


function checkboxInput_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  &:after {\n    ",
        "\n  }\n  @media only screen and (max-width: 992px) and (min-width: 767px) {\n    ",
        "\n    &:after {\n      ",
        "\n    }\n  }\n  @media all and (max-width: 766px) {\n    ",
        "\n    &:after {\n      ",
        "\n    }\n  }\n"
    ]);
    checkboxInput_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



// @ts-ignore








var CheckboxInputLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1e8de809-0"
})(checkboxInput_templateObject(), function(props) {
    return props.desktop;
}, function(props) {
    return props.desktop.background;
}, function(props) {
    return props.tablet;
}, function(props) {
    return props.tablet.background;
}, function(props) {
    return props.mobile;
}, function(props) {
    return props.mobile.background;
});
var CheckboxInput = function(props) {
    var ref = (0,react.useState)({
        value: false,
        apiValue: "false"
    }), value = ref[0], setValue = ref[1];
    var handleValueChange = function(value) {
        var newApiValue = value ? "true" : "false";
        setValue({
            value: value,
            apiValue: newApiValue
        });
        props.handleValueChange(newApiValue);
    };
    var renderLabel = function() {
        if (!props.bobText || !props.bobText.enable) return props.inputObj.label || props.inputObj.name;
        if (components_getOverrideInlineContentValues("text3.".concat(CONTENT_SRC_TEXT), {
            inlineContent: props.obj.content.inlineContent,
            overrides: props.overrides
        }) === "post") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                position: props.position,
                pageResponse: props.pageResponse,
                instanceId: props.obj.selectedInstanceId,
                object: props.obj,
                objectId: props.obj.uuid,
                inlineContent: props.obj.content.inlineContent,
                overrides: props.overrides,
                field: "text3",
                tag: "p",
                value: props.inputObj.label || props.inputObj.name,
                template: props.obj.styles,
                rules: props.componentRule,
                expManager: props.expManager,
                className: "title"
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
            position: props.position,
            pageResponse: props.pageResponse,
            instanceId: props.obj.selectedInstanceId,
            object: props.obj,
            objectId: props.obj.uuid,
            inlineContent: props.obj.content.inlineContent,
            overrides: props.overrides,
            field: "text3",
            tag: "p",
            value: getStringField(props.obj, props.obj, props.pageResponse, "text1", props.overrides),
            template: props.obj.styles,
            rules: props.componentRule,
            expManager: props.expManager,
            className: "title"
        });
    };
    var backgroundStyles = handleBackgroundStyles(props.bobStyle.bobInput, props.pageResponse.globalStyles);
    var textStyles = handleTextStyles(props.bobStyle.bobInput, props.pageResponse.globalStyles, props.expManager);
    // responsive styles for background
    var mobileStylesBackground = responsiveProperties(props.bobStyle.bobInput, "mobile");
    mobileStylesBackground = (0,src_object_spread/* default */.Z)({}, mobileStylesBackground, responsiveGroupStylesProperties(props.bobStyle.bobInput, "mobile", "text"));
    var tabletStylesBackground = responsiveProperties(props.bobStyle.bobInput, "tablet");
    tabletStylesBackground = (0,src_object_spread/* default */.Z)({}, tabletStylesBackground, responsiveGroupStylesProperties(props.bobStyle.bobInput, "tablet", "text"));
    // responsive styles for text
    var mobileStylesText = responsiveProperties(props.bobStyle.text, "mobile", undefined, [
        "colors"
    ]);
    mobileStylesText = (0,src_object_spread/* default */.Z)({}, mobileStylesText, responsiveGroupStylesProperties(props.bobStyle.text, "mobile", "text"), conditionalColorsRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "mobile", "default", true), colorStyle_cssRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "mobile", "default", undefined, undefined, true));
    var tabletStylesText = responsiveProperties(props.bobStyle.text, "tablet", undefined, [
        "colors"
    ]);
    tabletStylesText = (0,src_object_spread/* default */.Z)({}, tabletStylesText, responsiveGroupStylesProperties(props.bobStyle.text, "tablet", "text"), conditionalColorsRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "tablet", "default", true), colorStyle_cssRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "tablet", "default", undefined, undefined, true));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((style_it_default()), {
        children: [
            "\n        ".concat(textStyles.fontLoaded, ";\n      "),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "custom-control custom-checkbox",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "checkbox",
                        className: "custom-control-input",
                        id: "formCheckbox-".concat(props.inputObj.id),
                        checked: value.value,
                        onChange: function(e) {
                            return handleValueChange(e.target.checked);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxInputLabel, {
                        as: "label",
                        desktop: {
                            background: backgroundStyles,
                            text: textStyles.styles
                        },
                        mobile: {
                            background: mobileStylesBackground,
                            text: mobileStylesText
                        },
                        tablet: {
                            background: tabletStylesBackground,
                            text: tabletStylesText
                        },
                        className: "custom-control-label",
                        htmlFor: "formCheckbox-".concat(props.inputObj.id),
                        children: renderLabel()
                    }),
                    props.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "simple-form-error",
                        children: props.lang === "en" ? "This field is required" : "Campo obrigat\xf3rio"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var checkboxInput = (CheckboxInput);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/forms/inputTypes.ts
var inputTypes_TEXT = "text";
var TEXTAREA = "textarea";
var SELECT = "select";
var FILE = "file";
var CHECKBOX = "checkbox";

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/forms/formContainer/submitInput/submitInput.tsx


function submitInput_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  @media only screen and (max-width: 992px) and (min-width: 767px) {\n    ",
        "\n  }\n  @media all and (max-width: 766px) {\n    ",
        "\n  }\n"
    ]);
    submitInput_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


// @ts-ignore






var SubmitInputElement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-26a26349-0"
})(submitInput_templateObject(), function(props) {
    return props.desktop;
}, function(props) {
    return props.tablet;
}, function(props) {
    return props.mobile;
});
var SubmitInput = function(props) {
    var createMarkup = function(html) {
        return {
            __html: html
        };
    };
    var backgroundStyles = handleBackgroundStyles(props.bobStyle.bobInput, props.pageResponse.globalStyles);
    var textStyles = handleTextStyles(props.bobStyle.bobInput, props.pageResponse.globalStyles, props.expManager);
    var styles = (0,src_object_spread/* default */.Z)({}, backgroundStyles, textStyles.styles);
    var mobileStyles = responsiveProperties((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "mobile", undefined, [
        "colors", 
    ]);
    mobileStyles = (0,src_object_spread/* default */.Z)({}, mobileStyles, responsiveGroupStylesProperties((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "mobile", "text"), conditionalColorsRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "mobile", "default", true), colorStyle_cssRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "mobile", "default", undefined, undefined, true));
    var tabletStyles = responsiveProperties((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "tablet", undefined, [
        "colors", 
    ]);
    tabletStyles = (0,src_object_spread/* default */.Z)({}, tabletStyles, responsiveGroupStylesProperties((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "tablet", "text"), conditionalColorsRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "tablet", "default", true), colorStyle_cssRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "tablet", "default", undefined, undefined, true));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((style_it_default()), {
        children: [
            "\n      ".concat(textStyles.fontLoaded, "          \n    "),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitInputElement, {
                as: "button",
                desktop: styles,
                mobile: mobileStyles,
                tablet: tabletStyles,
                type: "submit",
                className: "btn btn-primary",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    ref: function() {
                        return "dangerousHTMLGenericPost";
                    },
                    className: "dangerousHTML",
                    dangerouslySetInnerHTML: createMarkup(props.bobStyle.bobInput.customText)
                })
            })
        ]
    });
};
/* harmony default export */ var submitInput = (SubmitInput);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/forms/formContainer/textAraeaInput/textAreaInput.tsx


function textAreaInput_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  @media only screen and (max-width: 992px) and (min-width: 767px) {\n    ",
        "\n    ",
        "\n  }\n  @media all and (max-width: 766px) {\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    textAreaInput_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


// @ts-ignore







var TextAreaInputElement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fa57b880-0"
})(textAreaInput_templateObject(), function(props) {
    return props.desktop;
}, function(props) {
    return handlePlaceholderStyles(props.desktop);
}, function(props) {
    return props.tablet;
}, function(props) {
    return handlePlaceholderStyles(props.tablet);
}, function(props) {
    return props.mobile;
}, function(props) {
    return handlePlaceholderStyles(props.mobile);
});
var TextAreaInput = function(props) {
    var _value;
    var ref = (0,react.useState)((_value = props.inputObj.value) !== null && _value !== void 0 ? _value : ""), value = ref[0], setValue = ref[1];
    var isInitialMount = (0,react.useRef)(true);
    (0,react.useEffect)(function() {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            props.handleValueChange(value);
        }
    // eslint-disable-next-line
    }, [
        value
    ]);
    var handleValueChange = function(value) {
        setValue(value);
    };
    var handleErrorBorder = function() {
        if (props.error) return {
            border: "2px solid red"
        };
        return;
    };
    var renderErrorBorder = handleErrorBorder();
    var backgroundStyles = handleBackgroundStyles(props.bobStyle.bobInput, props.pageResponse.globalStyles);
    var textStyles = handleTextStyles(props.bobStyle.bobInput, props.pageResponse.globalStyles, props.expManager);
    var styles = (0,src_object_spread/* default */.Z)({}, backgroundStyles, textStyles.styles, renderErrorBorder);
    var mobileStyles = responsiveProperties((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "mobile", undefined, [
        "colors", 
    ]);
    mobileStyles = (0,src_object_spread/* default */.Z)({}, mobileStyles, responsiveGroupStylesProperties((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "mobile", "text"), conditionalColorsRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "mobile", "default", true), colorStyle_cssRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "mobile", "default", undefined, undefined, true));
    var tabletStyles = responsiveProperties((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "tablet", undefined, [
        "colors", 
    ]);
    tabletStyles = (0,src_object_spread/* default */.Z)({}, tabletStyles, responsiveGroupStylesProperties((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "tablet", "text"), conditionalColorsRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "tablet", "default", true), colorStyle_cssRenderUnsafe((0,src_object_spread/* default */.Z)({}, props.bobStyle.text, props.bobStyle.bobInput), "tablet", "default", undefined, undefined, true));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((style_it_default()), {
        children: [
            "\n      ".concat(textStyles.fontLoaded, "          \n    "),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "form-group",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                        position: props.position,
                        pageResponse: props.pageResponse,
                        instanceId: props.obj.selectedInstanceId,
                        object: props.obj,
                        objectId: props.obj.uuid,
                        field: props.bobStyle.text.name,
                        inlineContent: props.obj.content.inlineContent,
                        overrides: props.overrides,
                        tag: "label",
                        value: props.inputObj.label || props.inputObj.name,
                        template: (0,src_object_spread/* default */.Z)({}, props.obj.styles),
                        rules: props.componentRule,
                        expManager: props.expManager,
                        network: props.obj.network
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextAreaInputElement, {
                        as: "textarea",
                        desktop: styles,
                        mobile: mobileStyles,
                        tablet: tabletStyles,
                        value: value,
                        placeholder: props.inputObj.label || props.inputObj.name,
                        onChange: function(e) {
                            return handleValueChange(e.target.value);
                        },
                        className: "form-control"
                    }),
                    props.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "simple-form-error",
                        children: props.lang === "en" ? "This field is required" : "Campo obrigat\xf3rio"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var textAreaInput = (TextAreaInput);

// EXTERNAL MODULE: ./src/stylesheets/modules/templates/simpleForm.module.sass
var simpleForm_module = __webpack_require__(46969);
var simpleForm_module_default = /*#__PURE__*/__webpack_require__.n(simpleForm_module);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/forms/formContainer/FormContainer/FormContainer.tsx





















var FormContainerChild = function(props) {
    var handleFieldsValues = function(props) {
        var bobFormId = isBobForm(props.obj.styles.bobs.form1).formId;
        var formObject = props.pageResponse.forms && props.pageResponse.forms[bobFormId];
        if (bobFormId && formObject) {
            var fields = formObject.fields;
            var formData = {};
            for(var inputObj in fields){
                if (fields[inputObj].value) {
                    formData = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, formData), (0,src_define_property/* default */.Z)({}, fields[inputObj].id, fields[inputObj].value));
                }
            }
            return formData;
        }
        return {};
    };
    var ref = (0,react.useState)(handleFieldsValues(props)), formData = ref[0], setFormData = ref[1];
    var ref1 = (0,react.useState)({}), formDataErrors = ref1[0], setFormDataErrors = ref1[1];
    var ref2 = (0,react.useState)({}), submitFeedback = ref2[0], setSubmitFeedback = ref2[1];
    var handleProperBobField = function(bobType) {
        var objStyles = props.obj.styles;
        var bobRule = props.pageResponse.components[objStyles.component].bob;
        var properBobField = {}, component;
        for(component in bobRule){
            if (bobRule[component].name === bobType) {
                properBobField = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, properBobField), (0,src_define_property/* default */.Z)({}, bobRule[component].type, objStyles.bobs[component]));
            }
        }
        return properBobField;
    };
    var handleInputTypes = function(inputObj, formObject) {
        var _obj;
        var inputs = (_obj = {}, (0,src_define_property/* default */.Z)(_obj, inputTypes_TEXT, function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(textInput, {
                position: props.position,
                obj: props.obj,
                inputObj: inputObj,
                componentRule: props.componentRule,
                error: formDataErrors[inputObj.id],
                handleValueChange: function(value) {
                    return handleInputValue(inputObj.id, value);
                },
                bobStyle: handleProperBobField("text_input"),
                overrides: props.overrides,
                lang: formObject.lang,
                pageResponse: props.pageResponse,
                expManager: props.expManager
            }, inputObj.idx);
        }), (0,src_define_property/* default */.Z)(_obj, TEXTAREA, function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(textAreaInput, {
                position: props.position,
                obj: props.obj,
                inputObj: inputObj,
                componentRule: props.componentRule,
                error: formDataErrors[inputObj.id],
                handleValueChange: function(value) {
                    return handleInputValue(inputObj.id, value);
                },
                bobStyle: handleProperBobField("text_input"),
                overrides: props.overrides,
                lang: formObject.lang,
                pageResponse: props.pageResponse,
                expManager: props.expManager
            }, inputObj.idx);
        }), (0,src_define_property/* default */.Z)(_obj, SELECT, function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(selectInput, {
                position: props.position,
                obj: props.obj,
                componentRule: props.componentRule,
                inputObj: inputObj,
                error: formDataErrors[inputObj.id],
                handleValueChange: function(value) {
                    return handleInputValue(inputObj.id, value);
                },
                bobStyle: handleProperBobField("text_input"),
                overrides: props.overrides,
                lang: formObject.lang,
                pageResponse: props.pageResponse,
                expManager: props.expManager
            }, inputObj.idx);
        }), (0,src_define_property/* default */.Z)(_obj, FILE, function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(fileInput, {
                position: props.position,
                obj: props.obj,
                componentRule: props.componentRule,
                inputObj: inputObj,
                error: formDataErrors[inputObj.id],
                handleValueChange: function(value) {
                    return handleInputValue(inputObj.id, value);
                },
                bobStyle: handleProperBobField("file_input"),
                overrides: props.overrides,
                lang: formObject.lang,
                pageResponse: props.pageResponse,
                expManager: props.expManager,
                formId: isBobForm(props.obj.styles.bobs.form1).formId
            }, inputObj.idx);
        }), (0,src_define_property/* default */.Z)(_obj, CHECKBOX, function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(checkboxInput, {
                position: props.position,
                obj: props.obj,
                componentRule: props.componentRule,
                inputObj: inputObj,
                error: formDataErrors[inputObj.id],
                bobText: props.obj.styles.bobs.text3,
                overrides: props.overrides,
                handleValueChange: function(value) {
                    return handleInputValue(inputObj.id, value);
                },
                bobStyle: handleProperBobField("checkbox_input"),
                lang: formObject.lang,
                pageResponse: props.pageResponse,
                expManager: props.expManager
            }, inputObj.idx);
        }), _obj);
        return inputs[inputObj.fieldType]();
    };
    var handleFields = function(fields, formObject) {
        return fields.map(function(inputObj, idx) {
            return handleInputTypes((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, inputObj), {
                idx: idx
            }), formObject);
        });
    };
    var handleInputValue = function(prop, value) {
        setFormData((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, formData), (0,src_define_property/* default */.Z)({}, prop, value)));
    };
    /**
   *
   * @param formObjectFieldsArr
   * Returns an array with the missing fields
   */ var checkRequiredValues = function(formObjectFieldsArr) {
        return formObjectFieldsArr.filter(function(input) {
            return input.required && (!formData[input.id] || formData[input.id] === "");
        });
    };
    var convertArrayToObject = function(array, key) {
        var initialValue = {};
        return array.reduce(function(obj, item) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, obj), (0,src_define_property/* default */.Z)({}, item[key], item));
        }, initialValue);
    };
    var handleSubmitErrors = function(res, formObject) {
        // validation refers only to form validation errors
        // message: "invalid-input-secret"
        // type: "recaptchaFailed"
        var errorsArray = res.data.validationErrors;
        if (errorsArray && errorsArray.length > 0) {
            for(var error in errorsArray){
                if (errorsArray[error].type === "recaptchaFailed") setSubmitFeedback({
                    type: "error",
                    text: formObject.lang === "en" ? "Something went wrong, please try again." : "Algo correu mal, por favor tente de novo."
                });
            }
        } else {
            setSubmitFeedback({
                type: "error",
                text: formObject.lang === "en" ? "Something went wrong." : "Algo correu mal."
            });
        }
    };
    var requestApi = function(reacaptchToken) {
        var bobFormId = isBobForm(props.obj.styles.bobs.form1).formId;
        var config = {
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "MeshApp-host": "meshapp"
            }
        };
        var body = {
            token: reacaptchToken,
            values: formData
        };
        axios_default().post("".concat(shared_api_apiEnv(), "v1/forms/").concat(bobFormId, "/submit"), JSON.stringify(body), config).then(function(res) {
            var ref;
            if ((ref = res.data) === null || ref === void 0 ? void 0 : ref.error) {
                handleSubmitErrors(res, formObject);
            } else {
                setSubmitFeedback({
                    type: "success",
                    text: formObject.lang === "en" ? "Form submitted successfully." : "Formul\xe1rio enviado com sucesso."
                });
            }
        }).catch(function(error) {
            console.warn("err", error);
            setSubmitFeedback({
                type: "error",
                text: formObject.lang === "pt" ? "Algo correu mal." : "Something went wrong."
            });
        });
    };
    var handleSubmitForm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e, formObject) {
            var reacaptchToken, missingFieldsArr, newFormDataErrors;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        _ctx.next = 3;
                        return props.googleReCaptchaProps.executeRecaptcha("form");
                    case 3:
                        reacaptchToken = _ctx.sent;
                        missingFieldsArr = checkRequiredValues(formObject.fields);
                        //Missing fields Form
                        if (missingFieldsArr.length > 0) {
                            newFormDataErrors = convertArrayToObject(missingFieldsArr, "id");
                            setFormDataErrors(newFormDataErrors);
                        } else {
                            //Clear errors
                            setFormDataErrors({});
                            requestApi(reacaptchToken);
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmitForm(e, formObject) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleGetSubmitBob = function() {
        for(var bob in props.obj.component.bob){
            if (props.obj.component.bob[bob].name === "submit_input") return props.obj.component.bob[bob];
        }
    };
    var bobFormId = isBobForm(props.obj.styles.bobs.form1).formId;
    var formObject = props.pageResponse.forms && props.pageResponse.forms[bobFormId];
    if (bobFormId && !formObject) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Form not Found!"
        });
    }
    if (bobFormId && formObject) {
        var background1 = props.obj.styles.bobs.background1;
        var alignmentStyles = alignment(background1).alignmentStyles;
        var columns = bobHandler_handleColumns(0, {
            desktop: 0,
            tablet: 0,
            mobile: 0
        }, background1, props.pageResponse.globalStyles[background1.globalStyleId]);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
            name: formObject.name,
            className: "simple-form-component ".concat((simpleForm_module_default())["simple-form-component"]),
            onSubmit: function(e) {
                return handleSubmitForm(e, formObject);
            },
            id: bobFormId,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row  ".concat(bobHandler_responsiveGuttersClass(background1, props.pageResponse.globalStyles[background1.globalStyleId])),
                style: (0,src_object_spread/* default */.Z)({}, alignmentStyles),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                    children: [
                        handleFields(formObject.fields, formObject),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex align-items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(submitInput, {
                                    inputObj: handleGetSubmitBob,
                                    bobStyle: handleProperBobField("submit_input"),
                                    pageResponse: props.pageResponse,
                                    expManager: props.expManager
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "submit-feedback",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: submitFeedback.type ? submitFeedback.type === "error" ? "submit-error" : "submit-success" : "",
                                        children: submitFeedback.text
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        children: "Please Select a Form"
    });
};
var RecaptchaFormContainerChild = (0,react_google_recaptcha_v3_esm/* withGoogleReCaptcha */.sT)(FormContainerChild);
var FormContainer = function(props) {
    var ref;
    var bobFormId = isBobForm(props.obj.styles.bobs.form1).formId;
    var formObject = props.pageResponse.forms && props.pageResponse.forms[bobFormId];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: bobFormId && (formObject === null || formObject === void 0 ? void 0 : (ref = formObject.captcha) === null || ref === void 0 ? void 0 : ref.captchaType) === "recaptcha" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_google_recaptcha_v3_esm/* GoogleReCaptchaProvider */.pm, {
            reCaptchaKey: formObject.captcha.key,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecaptchaFormContainerChild, (0,src_object_spread/* default */.Z)({}, props))
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Missing Repatcha Key"
        })
    });
};
/* harmony default export */ var FormContainer_FormContainer = (FormContainer);

;// CONCATENATED MODULE: ./src/modules/utilities/permission.ts

var Permissions = /*#__PURE__*/ function() {
    "use strict";
    function Permissions() {
        (0,src_class_call_check/* default */.Z)(this, Permissions);
    }
    Permissions.checkWorspacePermission = function checkWorspacePermission(user, workspace, featureToValidate) {
        if (!user || !workspace) return false;
        /**
     * check if user is admin
     * overlapps any other permission
     */ if (this.checkUserPermission(user)) return true;
        /**
     * check worskpace permissions
     */ if (workspace === null || workspace === void 0 ? void 0 : workspace.permissions) {
            /**
       * check betaFeatures permissions
       */ if (workspace.permissions.betaFeatures) {
                if (workspace.permissions.betaFeatures[featureToValidate] === false) return false;
                return true;
            }
        }
        /**
     * fallback
     */ return true;
    };
    Permissions.checkWorspacePermissionPageBuilder = function checkWorspacePermissionPageBuilder(user, workspace, featureToValidate) {
        if (!user || !workspace) return false;
        /**
     * check if user is admin
     * overlapps any other permission
     */ if (this.checkUserPermission(user)) return true;
        /**
     * check worskpace permissions
     */ if (workspace === null || workspace === void 0 ? void 0 : workspace.permissions) {
            /**
       * check betaFeatures permissions
       */ if (workspace.permissions.betaFeaturesPageBuilder) {
                if (workspace.permissions.betaFeaturesPageBuilder[featureToValidate] === false) return false;
                return true;
            }
        }
        /**
     * fallback
     */ return true;
    };
    Permissions.checkWorspacePermissionPlanLimit = function checkWorspacePermissionPlanLimit(user, workspace, featureToValidate, quantity) {
        if (!quantity) return false;
        /**
     * check if user is admin
     * overlapps any other permission
     */ if (this.checkUserPermission(user)) return true;
        /**
     * check worskpace permissions
     */ if (workspace === null || workspace === void 0 ? void 0 : workspace.permissions) {
            /**
       * check planLimits permissions
       */ if (workspace.permissions.planLimits) {
                // give permission if flag is not present
                if (!(featureToValidate in workspace.permissions.planLimits)) return true;
                // block permission
                if (quantity && workspace.permissions.planLimits[featureToValidate] <= quantity) return false;
                // fallback
                return true;
            }
        }
        /**
     * fallback
     */ return true;
    };
    /**
   * check user permissions
   */ Permissions.checkUserPermission = function checkUserPermission(user) {
        /**
     * check if user is admin
     */ if (user) return user.isAdmin;
        /**
     * fallback
     */ return true;
    };
    return Permissions;
}();
/* harmony default export */ var permission = (Permissions);

;// CONCATENATED MODULE: ./src/modules/shared-modules/experienceManager/singleObjectUtils.ts



var SingleObjectUtils = /*#__PURE__*/ function() {
    "use strict";
    function SingleObjectUtils() {
        (0,src_class_call_check/* default */.Z)(this, SingleObjectUtils);
    }
    SingleObjectUtils.getObjectByUuid = function getObjectByUuid(singleObject, form, pageResponse, emEditorType) {
        /**
     * when in symbolTree we must use symbols list to find the clicked object
     */ if (singleObject.fromSymbolTree && emEditorType !== "symbol") {
            var symbolObj = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, pageResponse.symbols[singleObject.fromSymbolTree].objects[singleObject.uuid]), {
                selectedInstanceId: singleObject.selectedInstanceId
            });
            // write form when needed
            if (form) symbolObj.content.form = form;
            return symbolObj;
        }
        var obj = pageResponse.objects[singleObject.uuid];
        // write form when needed
        if (form) obj.content.form = form;
        return obj;
    };
    return SingleObjectUtils;
}();
/* harmony default export */ var singleObjectUtils = (SingleObjectUtils);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/componentSelectorEM/CSEMv2ElementHover.tsx




function CSEMv2Element(param) {
    var id = param.id, displayBoundaries = param.displayBoundaries, MarginTop = param.MarginTop, MarginBottom = param.MarginBottom, MarginLeft = param.MarginLeft, MarginRight = param.MarginRight, PaddingBottom = param.PaddingBottom, PaddingLeft = param.PaddingLeft, PaddingTop = param.PaddingTop, marginLeft = param.marginLeft, marginRight = param.marginRight, Template = param.Template, label = param.label, realElementTop = param.realElementTop, objectSelectorHover = param.objectSelectorHover;
    /**
   * handle validate visiblity
   * based on objt uuid or instance uuid
   */ var isVisible = (0,react.useMemo)(function() {
        return objectSelectorHover === id;
    }, [
        id,
        objectSelectorHover
    ]);
    if (isVisible) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "element-hover",
            style: {
                display: displayBoundaries
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "property",
                children: [
                    MarginTop,
                    MarginBottom,
                    MarginLeft,
                    MarginRight,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "block",
                        style: {
                            top: "0",
                            right: "0",
                            bottom: "0",
                            left: "0",
                            width: "calc(100% - ".concat(marginLeft + marginRight, ")"),
                            height: "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "property",
                            children: [
                                PaddingTop,
                                PaddingBottom,
                                PaddingLeft,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "padding right",
                                    style: {
                                        width: "".concat(Template.padding.right, "px"),
                                        height: "100%"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "block",
                                    style: {
                                        top: "".concat(Template.padding.top, "px"),
                                        right: "".concat(Template.padding.right, "px"),
                                        bottom: "".concat(Template.padding.bottom, "px"),
                                        left: "".concat(Template.padding.left, "px"),
                                        width: "calc(100% - ".concat(Template.padding.right + Template.padding.left, "px)"),
                                        height: "calc(100% - ".concat(Template.padding.bottom + Template.padding.top, "px)")
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "property",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "content",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    top: "".concat(realElementTop + Template.padding.top < 22 ? "-".concat(realElementTop + Template.padding.top, "px") : "-22px")
                                                },
                                                className: "object-label",
                                                children: label
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}
var areEqual = function(prevProps, nextProps) {
    if (prevProps.id === prevProps.objectSelectorHover && nextProps.id !== nextProps.objectSelectorHover) {
        // Previous props had a match, but next props don't, so re-render to remove the class
        return false;
    }
    if (prevProps.id !== prevProps.objectSelectorHover && nextProps.id === nextProps.objectSelectorHover) {
        // Previous props didn't have a match, but next props do, so re-render to add the class
        return false;
    }
    if (prevProps.id !== nextProps.id) return false;
    if (prevProps.displayBoundaries !== nextProps.displayBoundaries) return false;
    if (prevProps.MarginTop !== nextProps.MarginTop) return false;
    if (prevProps.MarginBottom !== nextProps.MarginBottom) return false;
    if (prevProps.MarginLeft !== nextProps.MarginLeft) return false;
    if (prevProps.MarginRight !== nextProps.MarginRight) return false;
    if (prevProps.PaddingBottom !== nextProps.PaddingBottom) return false;
    if (prevProps.PaddingLeft !== nextProps.PaddingLeft) return false;
    if (prevProps.PaddingTop !== nextProps.PaddingTop) return false;
    if (prevProps.marginLeft !== nextProps.marginLeft) return false;
    if (prevProps.marginRight !== nextProps.marginRight) return false;
    if (prevProps.Template !== nextProps.Template) return false;
    if (prevProps.label !== nextProps.label) return false;
    if (prevProps.realElementTop !== nextProps.realElementTop) return false;
    return true;
};
var CSEMv2ElementHover_mapStateToProps = function(state) {
    return {
        objectSelectorHover: state.publicPageReducer.objectSelectorHover
    };
};
/* harmony default export */ var CSEMv2ElementHover = ((0,es/* connect */.$j)(CSEMv2ElementHover_mapStateToProps)(/*#__PURE__*/ react.memo(CSEMv2Element, areEqual)));

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/componentSelectorEM/ComponentSelectorEMv2.tsx

















var ComponentSelectorEMv2 = /*#__PURE__*/ react.memo(function(props) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var actions = (0,redux/* bindActionCreators */.DE)({
        hubHandlerSelected: hubHandlerSelected,
        selectFinder: selectFinder,
        objectSelectionHover: objectSelectionHover,
        selectSymbolInstance: selectSymbolInstance,
        setSymbolContentType: setSymbolContentType,
        editSymbolState: editSymbolState,
        viewPortSizeStateExperienceManager: viewPortSizeStateExperienceManager,
        changeResponsiveTab: changeResponsiveTab
    }, dispatch);
    var userInfo = (0,es/* useSelector */.v9)(function(state) {
        return state.session.userInfo;
    });
    var workspaceInfo = (0,es/* useSelector */.v9)(function(state) {
        return state.profileReducer.content;
    });
    var selectedSingleObject = (0,es/* useSelector */.v9)(function(state) {
        return state.publicPageReducer.hubHandlerObject;
    });
    var contentHub = (0,es/* useSelector */.v9)(function(state) {
        return state.contentHubReducer.hubContent;
    });
    var symbolObj = (0,es/* useSelector */.v9)(function(state) {
        return state.pageTreeReducer;
    }).symbolObj;
    var viewPortSizeState = (0,es/* useSelector */.v9)(function(state) {
        return state.publicPageReducer.viewPortSizeState;
    });
    var viewPortOriginalSizeState = (0,es/* useSelector */.v9)(function(state) {
        return state.experienceManagerReducer.viewPortOriginalSizeState;
    });
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return state.experienceManagerReducer;
    }), objectSelectorModeEM = ref.objectSelectorModeEM, objectSelectorStateEM = ref.objectSelectorStateEM, finderType = ref.finderType, emEditorType = ref.emEditorType;
    var id = handleUniqueid(props.obj, contentHub.symbols);
    var handleObjectClick = function(e) {
        /**
     * Only trigger if in object selection Mode
     * @param objectSelectorModeEM (boolean)
     */ if (objectSelectorModeEM) {
            e.stopPropagation();
            e.preventDefault();
            // symbol root object clicked
            if (props.obj.fromSymbolTree && props.obj.type === "root" && props.obj.selectedInstanceId) {
                var symbolInstanceObj = handleFilterInstanceObj(contentHub, props.obj.selectedInstanceId);
                var symbolToUse = symbols_handleFilterSymbolObject(symbolInstanceObj, contentHub.symbols, false);
                actions.hubHandlerSelected(symbolToUse.uuid, undefined, symbolToUse);
                actions.selectSymbolInstance(symbolInstanceObj.uuid, symbolInstanceObj);
                actions.selectFinder(handleOpenTab(), symbolToUse);
                //directly open styles for symbol
                actions.editSymbolState({
                    symbolObj: symbolToUse
                }, CONTENT_TAB);
                // if fromSymbolTree is different set instance edit mode
                if (props.obj.fromSymbolTree !== selectedSingleObject.fromSymbolTree) {
                    actions.setSymbolContentType(symbolTypes/* CONTENT_TYPE_INSTANCE */.h);
                }
            } else if (props.obj.fromSymbolTree && props.obj.type === "object" && props.obj.selectedInstanceId) {
                //Gets original object without the overrides
                var objToUse = getObjectFromSymbolObject(contentHub, props.obj);
                var symbolInstanceObj1 = handleFilterInstanceObj(contentHub, props.obj.selectedInstanceId);
                var symbolToUse1 = symbols_handleFilterSymbolObject(symbolInstanceObj1, contentHub.symbols, false);
                actions.hubHandlerSelected(props.obj.uuid, undefined, objToUse);
                actions.selectSymbolInstance(symbolInstanceObj1.uuid, symbolInstanceObj1);
                actions.selectFinder(handleOpenTab(), objToUse);
                //directly open styles for symbol
                actions.editSymbolState({
                    symbolObj: symbolToUse1
                }, CONTENT_TAB);
                // if fromSymbolTree is different set instance edit mode
                if (props.obj.fromSymbolTree !== selectedSingleObject.fromSymbolTree) {
                    actions.setSymbolContentType(symbolTypes/* CONTENT_TYPE_INSTANCE */.h);
                }
            } else {
                if (!props.obj.selectedInstanceId) {
                    actions.editSymbolState(false);
                    actions.setSymbolContentType(symbolTypes/* CONTENT_TYPE_INSTANCE */.h);
                }
                //clear selected instance
                if (!props.obj.fromSymbolTree) actions.selectSymbolInstance(undefined);
                var SingleObjectToUse = singleObjectUtils.getObjectByUuid(props.obj, props.form, contentHub, emEditorType);
                actions.hubHandlerSelected(SingleObjectToUse.uuid, SingleObjectToUse.parentId, SingleObjectToUse);
                actions.selectFinder(handleOpenTab(), SingleObjectToUse);
            }
            //Return to desktop mode when in Fullscreen
            if (viewPortSizeState === "100%_NO_BARS") {
                var viewport = devices.handleViewPortMaxSize(viewPortTypes/* DESKTOP */.q5, 100, viewPortOriginalSizeState);
                actions.viewPortSizeStateExperienceManager(viewport.size, viewport.scale);
                actions.changeResponsiveTab("responsive");
            }
        }
    };
    var handleOpenTab = function() {
        if (finderType === "template" || finderType === CONTENT_TAB) {
            return finderType;
        }
        return DEFAULT_FINDER_TAB;
    };
    var handleElementEnter = function(e) {
        e.stopPropagation();
        /**
     * element hover logic
     * when hover is on a symbol obj, use the selectedInstanceId
     */ if (objectSelectorModeEM) {
            var obj = props.obj;
            // when hovering a symbol object that inst the root object,
            // we must use the root object himself so that the instance on the tree matches the objectSelectorModeEM id
            if (props.obj.fromSymbolTree && props.obj.type !== "root" && !symbolObj) {
                var symbol = contentHub.symbols[props.obj.fromSymbolTree];
                obj = symbol.objects[symbol.rootId];
            }
            var id = handleUniqueid((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, obj), {
                selectedInstanceId: props.obj.selectedInstanceId
            }), contentHub.symbols);
            actions.objectSelectionHover(id);
        }
    };
    var handleElementLeave = function(e) {
        e.stopPropagation();
        /**
     * element hover logic
     */ if (objectSelectorModeEM) {
            actions.objectSelectionHover(false);
        }
    };
    var isNumber = function(e) {
        return typeof e === "number";
    };
    var isSelected = false;
    var classes = "componentSelector ";
    if (objectSelectorStateEM) {
        isSelected = true;
        classes += "editing ";
    }
    // don't render when objectSelectorModeEM and objectSelectorStateEM are turned off.
    // if only objectSelectorModeEM is off, pointer events should be disabled.
    // With this, components events like onmouseenter will begin working.
    if (objectSelectorModeEM || objectSelectorStateEM) {
        var ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
        var displayBoundaries = objectSelectorModeEM ? "block" : "none";
        var masterObject = (ref1 = props.obj.styles.bobs) === null || ref1 === void 0 ? void 0 : ref1[props.masterBob];
        var Template = masterObject && masterObject.spacing && masterObject.spacing.enable ? masterObject.spacing : {
            margin: {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
            },
            padding: {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
            }
        };
        /**
     *
     * Border/Padding/Content layout
     *
     * To emulate visually the borders, paddings and content with the charro feature
     * we need to create a frame around the content with the two options avaiable
     *
     * MARGIN TOP */ var MarginTop = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "margin top",
            style: {
                width: "100%",
                height: "".concat(Template.margin.top, "px"),
                left: "0",
                top: "-".concat(Template.margin.top, "px")
            }
        });
        /* Margin top will go from left to right using 100%
     * The height will equal the margin top selected in the interface
     * To visually apply it over the real margin he we need to give it a negative top equal to its height
     *
     * MARGIN BOTTOM */ var MarginBottom = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "margin bottom",
            style: {
                width: "100%",
                height: "".concat(Template.margin.bottom, "px"),
                right: "0",
                bottom: "-".concat(Template.margin.bottom, "px")
            }
        });
        /* Margin bottom applies the same principles from margin top but with inverted sides
    * In this case it uses the right and bottom side to align it and the negative value is applied at the bottom

    * MARGIN LEFT */ var MarginLeft = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "margin left",
            style: {
                width: "".concat(Template.margin.left, "px"),
                left: "-".concat(Template.margin.left, "px"),
                height: "100%"
            }
        });
        /* Margin left uses the full height avaiable
     * The width equals the margin left applied in the interface
     * The position is forced to the left side with top and left at 0
     *
     * MARGIN RIGHT */ var MarginRight = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "margin right",
            style: {
                width: "".concat(Template.margin.right, "px"),
                right: "-".concat(Template.margin.right, "px"),
                height: "100%"
            }
        });
        /* Margin right uses the same logic for the margin left
     * With the proper use of the margin right for the width
     * And starting at the right and bottom side (0)
     *
     *       ---------------------------------------------------------------------------------------------
     *       |       margin-top: width:100%; height:${margin.top}px; left:0; top: -${margin.top};        |
     *       ---------------------------------------------------------------------------------------------
     *       |        margin-left:     |                                      |        margin-right:     |
     *       | width: ${margin-left}px |                                      | width: ${margin-right}px |
     *       |        height: 100%     |                                      |        height: 100%      |
     *       |         left: 0         |                                      |         right: 0         |
     *       |         top: 0          |                                      |         bottom: 0        |
     *       ---------------------------------------------------------------------------------------------
     *       | margin-bottom: width:100%; height:${margin-bottom}px; right:0; bottom: -${margin.bottom}; |
     *       ---------------------------------------------------------------------------------------------
     *
     * PADDING TOP */ var PaddingTop = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "padding top",
            style: {
                width: "calc(100% - ".concat(Template.padding.left + Template.padding.right, "px)"),
                height: "".concat(Template.padding.top, "px"),
                left: "".concat(Template.padding.left, "px")
            }
        });
        /* Padding top will use the total width minus both padding side values for the left & right
     * The height will equal to the padding top and will start at where the left padding ends
     *
     * PADDING BOTTOM */ var PaddingBottom = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "padding bottom",
            style: {
                width: "calc(100% - ".concat(Template.padding.left + Template.padding.right, "px)"),
                height: "".concat(Template.padding.bottom, "px"),
                right: "".concat(Template.padding.right, "px")
            }
        });
        /* Padding bottom will have the same logic applied at the padding top, with the small change to start at the right side where the right padding ends
     * The height will equal the padding bottom
     *
     * PADDING LEFT */ var PaddingLeft = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "padding left",
            style: {
                width: "".concat(Template.padding.left, "px"),
                height: "100%"
            }
        });
        /* Padding left will just use the padding left for the width and 100% for the height
     * Since we leave the heavy logic for the top and bottom padding
     *
     *
     *
     *
     *       --------------------------------------------------------------------------------------------------------------------
     *       | padding-top: width:calc(100%-[${padding.left}+${padding.right}]px); height:${padding.top}; left:${padding.left}; |
     *       --------------------------------------------------------------------------------------------------------------------
     */ var IframeElement = document.getElementById("board-preview-frame");
        var ref12;
        //Get iframe Y size
        var scrollY = (ref12 = (ref2 = IframeElement.contentWindow) === null || ref2 === void 0 ? void 0 : ref2.scrollY) !== null && ref12 !== void 0 ? ref12 : 0;
        var ref13;
        var scrollX = (ref13 = (ref3 = IframeElement.contentWindow) === null || ref3 === void 0 ? void 0 : ref3.scrollX) !== null && ref13 !== void 0 ? ref13 : 0;
        var _top;
        //Element top & left
        var elementTop = (_top = (ref4 = props.elRef) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.current) === null || ref5 === void 0 ? void 0 : ref5.getBoundingClientRect().top) !== null && _top !== void 0 ? _top : 0;
        var _left;
        var elementLeft = (_left = (ref6 = props.elRef) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.current) === null || ref7 === void 0 ? void 0 : ref7.getBoundingClientRect().left) !== null && _left !== void 0 ? _left : 0;
        /**
     * Real top & left position
     * We first get the page scroll position, to know where the user is looking at,
     * so we can add to the getBoundingClientRect, since this value is calculated
     * with the current related position of the page, adding this 2 values we have
     * the precise distance from the top and left values
     */ var realElementTop = scrollY + elementTop;
        var realElementLeft = scrollX + elementLeft;
        var outerDivStyle = {
            position: "absolute",
            left: "".concat(realElementLeft, "px"),
            top: "".concat(realElementTop, "px"),
            width: (ref8 = props.elRef) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.current) === null || ref9 === void 0 ? void 0 : ref9.offsetWidth,
            height: (ref10 = props.elRef) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.current) === null || ref11 === void 0 ? void 0 : ref11.offsetHeight,
            pointerEvents: objectSelectorModeEM ? "auto" : "none",
            zIndex: 9999999
        };
        var marginLeft = isNumber(Template.margin.left) ? Template.margin.left : 0;
        var marginRight = isNumber(Template.margin.right) ? Template.margin.right : 0;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes,
            onClick: function(e) {
                return handleObjectClick(e);
            },
            style: outerDivStyle,
            onMouseOver: function(e) {
                return handleElementEnter(e);
            },
            onMouseLeave: function(e) {
                return handleElementLeave(e);
            },
            children: [
                permission.checkWorspacePermissionPageBuilder(userInfo, workspaceInfo, "addObject") && isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "object-selected",
                    style: {
                        left: 0,
                        top: 0,
                        width: "100%",
                        height: "100%"
                    },
                    className: "".concat(symbolObj ? "isSymbol" : "", " ").concat(props.obj.uuid === (selectedSingleObject === null || selectedSingleObject === void 0 ? void 0 : selectedSingleObject.uuid) ? "isSelected" : "")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CSEMv2ElementHover, {
                    label: props.obj.label,
                    MarginTop: MarginTop,
                    MarginBottom: MarginBottom,
                    MarginLeft: MarginLeft,
                    MarginRight: MarginRight,
                    PaddingBottom: PaddingBottom,
                    PaddingTop: PaddingTop,
                    PaddingLeft: PaddingLeft,
                    marginLeft: marginLeft,
                    marginRight: marginRight,
                    Template: Template,
                    realElementTop: realElementTop,
                    displayBoundaries: displayBoundaries,
                    id: id
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
});
ComponentSelectorEMv2.displayName = "ComponentSelectorEMv2";
/* harmony default export */ var componentSelectorEM_ComponentSelectorEMv2 = (ComponentSelectorEMv2);

// EXTERNAL MODULE: ./src/stylesheets/modules/utils/public-components.module.sass
var public_components_module = __webpack_require__(8147);
var public_components_module_default = /*#__PURE__*/__webpack_require__.n(public_components_module);
;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/flexStyle.ts







var flexStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
var flexStyle_UnitCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("px"),
    (0,es6/* literal */.i0)("%")
]);
var AlignContentCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("flex-start"),
    (0,es6/* literal */.i0)("flex-end"),
    (0,es6/* literal */.i0)("stretch"),
    (0,es6/* literal */.i0)("center"),
    (0,es6/* literal */.i0)("space-around"),
    (0,es6/* literal */.i0)("space-between"), 
]);
var AlignItemsCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("flex-start"),
    (0,es6/* literal */.i0)("flex-end"),
    (0,es6/* literal */.i0)("stretch"),
    (0,es6/* literal */.i0)("center"),
    (0,es6/* literal */.i0)("baseline"),
    (0,es6/* literal */.i0)("first-baseline"),
    (0,es6/* literal */.i0)("last-baseline"), 
]);
var DirectionCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("row"),
    (0,es6/* literal */.i0)("row-reverse"),
    (0,es6/* literal */.i0)("column"),
    (0,es6/* literal */.i0)("column-reverse")
]);
var JustifyContentCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("flex-start"),
    (0,es6/* literal */.i0)("flex-end"),
    (0,es6/* literal */.i0)("center"),
    (0,es6/* literal */.i0)("space-between"),
    (0,es6/* literal */.i0)("space-around"),
    (0,es6/* literal */.i0)("space-evenly"), 
]);
var WrapCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("nowrap"),
    (0,es6/* literal */.i0)("wrap"),
    (0,es6/* literal */.i0)("wrap-reverse")
]);
var ColumnGapCodec = (0,es6/* type */.dt)({
    enable: es6/* boolean */.O7,
    value: es6/* number */.pk,
    unit: flexStyle_UnitCodec
});
var RowGapCodec = (0,es6/* type */.dt)({
    enable: es6/* boolean */.O7,
    value: es6/* number */.pk,
    unit: flexStyle_UnitCodec
});
var FlexCodec = (0,es6/* type */.dt)({
    alignContent: AlignContentCodec,
    alignItems: AlignItemsCodec,
    direction: DirectionCodec,
    gap: (0,es6/* type */.dt)({
        column: ColumnGapCodec,
        row: RowGapCodec
    }),
    justifyContent: JustifyContentCodec,
    wrap: WrapCodec
});
var ColumnGapOptCodec = (0,es6/* partial */.r$)({
    enable: flexStyle_nullable(es6/* boolean */.O7),
    value: flexStyle_nullable(es6/* number */.pk),
    unit: flexStyle_nullable(flexStyle_UnitCodec)
});
var RowGapOptCodec = (0,es6/* partial */.r$)({
    enable: flexStyle_nullable(es6/* boolean */.O7),
    value: flexStyle_nullable(es6/* number */.pk),
    unit: flexStyle_nullable(flexStyle_UnitCodec)
});
var FlexOptCodec = (0,es6/* partial */.r$)({
    alignContent: flexStyle_nullable(AlignContentCodec),
    alignItems: flexStyle_nullable(AlignItemsCodec),
    direction: flexStyle_nullable(DirectionCodec),
    gap: (0,es6/* partial */.r$)({
        column: flexStyle_nullable(ColumnGapOptCodec),
        row: flexStyle_nullable(RowGapOptCodec)
    }),
    justifyContent: flexStyle_nullable(JustifyContentCodec),
    wrap: flexStyle_nullable(WrapCodec)
});
var StylesFlexCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        flex: FlexCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                flex: FlexOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                flex: FlexOptCodec
            })
        }),
        mobile: (0,es6/* partial */.r$)({
            flex: FlexOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    flex: FlexOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    flex: FlexOptCodec
                })
            })
        }),
        tablet: (0,es6/* partial */.r$)({
            flex: FlexOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    flex: FlexOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    flex: FlexOptCodec
                })
            })
        })
    }), 
]);
var DefaultFlexCSS = {
    "align-content": "flex-start",
    "align-items": "flex-start",
    "flex-direction": "row",
    "column-gap": "0px",
    "row-gap": "0px",
    "justify-content": "flex-start",
    "flex-wrap": "nowrap"
};
function flexStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var styles = StylesFlexCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return flexStyle_cssRender(styles.right, breakpoint, behaviourState);
    console.warn(codecUtils_decoderErrors(styles));
    return DefaultFlexCSS;
}
function flexStyle_cssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return flexStyle_render(stylesObj.flex);
        } else {
            var ref, ref1;
            return flexStyle_renderBobOpt(stylesObj.flex, flexStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.flex, stylesObj.flex));
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return flexStyle_renderBobOpt(stylesObj.flex, flexStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.flex, stylesObj.flex));
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return flexStyle_renderBobOpt(stylesObj.flex, flexStyle_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.flex, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.flex, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.flex, stylesObj.flex));
        }
    }
}
function flexStyle_render(flexObj) {
    return {
        "flex-direction": flexObj.direction,
        "flex-wrap": flexObj.wrap,
        "justify-content": flexObj.justifyContent,
        "align-items": flexObj.alignItems,
        "align-content": flexObj.alignContent,
        "column-gap": flexObj.gap.column.enable ? "".concat(flexObj.gap.column.value).concat(flexObj.gap.column.unit) : undefined,
        "row-gap": flexObj.gap.row.enable ? "".concat(flexObj.gap.row.value).concat(flexObj.gap.row.unit) : undefined
    };
}
/**
 * Renders ColorsOpt css for breakpoints/state templates
 * or empty for non written style props
 *
 * @param flexValue
 * @param foundationStyle
 * @returns
 */ function flexStyle_renderBobOpt(defaultSelfFlexObj, flexValue) {
    if (flexValue) {
        return flexStyle_renderOpt(defaultSelfFlexObj, flexValue);
    }
    return {};
}
/**
 * Renders FlexOpt css for breakpoints/state templates
 * Returns flex
 * or empty for non written style props
 *
 * @param flexValue
 * @param foundationStyle
 * @returns
 */ function flexStyle_renderOpt(defaultSelfFlexObj, flexValue) {
    var ref, ref1, ref2, ref3;
    var css = {};
    if (valueExists(flexValue === null || flexValue === void 0 ? void 0 : flexValue.direction)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "flex-direction": "".concat(flexValue === null || flexValue === void 0 ? void 0 : flexValue.direction)
    });
    if (valueExists(flexValue === null || flexValue === void 0 ? void 0 : flexValue.wrap)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "flex-wrap": "".concat(flexValue === null || flexValue === void 0 ? void 0 : flexValue.wrap)
    });
    if (valueExists(flexValue === null || flexValue === void 0 ? void 0 : flexValue.justifyContent)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "justify-content": "".concat(flexValue === null || flexValue === void 0 ? void 0 : flexValue.justifyContent)
    });
    if (valueExists(flexValue === null || flexValue === void 0 ? void 0 : flexValue.alignItems)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "align-items": "".concat(flexValue === null || flexValue === void 0 ? void 0 : flexValue.alignItems)
    });
    if (valueExists(flexValue === null || flexValue === void 0 ? void 0 : flexValue.alignContent)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "align-content": "".concat(flexValue === null || flexValue === void 0 ? void 0 : flexValue.alignContent)
    });
    if (valueExists(flexValue === null || flexValue === void 0 ? void 0 : (ref = flexValue.gap) === null || ref === void 0 ? void 0 : (ref1 = ref.column) === null || ref1 === void 0 ? void 0 : ref1.enable)) {
        var ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
        if ((flexValue === null || flexValue === void 0 ? void 0 : (ref4 = flexValue.gap) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.column) === null || ref5 === void 0 ? void 0 : ref5.enable) === false) {
            var ref16;
            if ((ref16 = defaultSelfFlexObj.gap.column) === null || ref16 === void 0 ? void 0 : ref16.enable) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
                "column-gap": "initial"
            });
        }
        if ((flexValue === null || flexValue === void 0 ? void 0 : (ref6 = flexValue.gap) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.column) === null || ref7 === void 0 ? void 0 : ref7.enable) === true && (valueExists(flexValue === null || flexValue === void 0 ? void 0 : (ref8 = flexValue.gap) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.column) === null || ref9 === void 0 ? void 0 : ref9.value) || valueExists(flexValue === null || flexValue === void 0 ? void 0 : (ref10 = flexValue.gap) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.column) === null || ref11 === void 0 ? void 0 : ref11.unit))) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
            "column-gap": "".concat(flexValue === null || flexValue === void 0 ? void 0 : (ref12 = flexValue.gap) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.column) === null || ref13 === void 0 ? void 0 : ref13.value).concat(flexValue === null || flexValue === void 0 ? void 0 : (ref14 = flexValue.gap) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.column) === null || ref15 === void 0 ? void 0 : ref15.unit)
        });
    }
    if (valueExists(flexValue === null || flexValue === void 0 ? void 0 : (ref2 = flexValue.gap) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.row) === null || ref3 === void 0 ? void 0 : ref3.enable)) {
        var ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28;
        if ((flexValue === null || flexValue === void 0 ? void 0 : (ref17 = flexValue.gap) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.row) === null || ref18 === void 0 ? void 0 : ref18.enable) === false) {
            var ref29;
            if ((ref29 = defaultSelfFlexObj.gap.row) === null || ref29 === void 0 ? void 0 : ref29.enable) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
                "row-gap": "initial"
            });
        }
        if ((flexValue === null || flexValue === void 0 ? void 0 : (ref19 = flexValue.gap) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.row) === null || ref20 === void 0 ? void 0 : ref20.enable) === true && (valueExists(flexValue === null || flexValue === void 0 ? void 0 : (ref21 = flexValue.gap) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.row) === null || ref22 === void 0 ? void 0 : ref22.value) || valueExists(flexValue === null || flexValue === void 0 ? void 0 : (ref23 = flexValue.gap) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.row) === null || ref24 === void 0 ? void 0 : ref24.unit))) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
            "row-gap": "".concat(flexValue === null || flexValue === void 0 ? void 0 : (ref25 = flexValue.gap) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.row) === null || ref26 === void 0 ? void 0 : ref26.value).concat(flexValue === null || flexValue === void 0 ? void 0 : (ref27 = flexValue.gap) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.row) === null || ref28 === void 0 ? void 0 : ref28.unit)
        });
    }
    return css;
}
function flexStyle_mergeBob2(flexObj, defaultFlexObj) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    if (!flexObj) {
        return {
            gap: undefined,
            alignContent: undefined,
            alignItems: undefined,
            direction: undefined,
            justifyContent: undefined,
            wrap: undefined
        };
    }
    var flex = {
        gap: {
            column: {
                enable: flexObj === null || flexObj === void 0 ? void 0 : (ref = flexObj.gap) === null || ref === void 0 ? void 0 : (ref1 = ref.column) === null || ref1 === void 0 ? void 0 : ref1.enable,
                value: undefined,
                unit: undefined
            },
            row: {
                enable: flexObj === null || flexObj === void 0 ? void 0 : (ref2 = flexObj.gap) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.row) === null || ref3 === void 0 ? void 0 : ref3.enable,
                value: undefined,
                unit: undefined
            }
        },
        alignContent: flexObj === null || flexObj === void 0 ? void 0 : flexObj.alignContent,
        alignItems: flexObj === null || flexObj === void 0 ? void 0 : flexObj.alignItems,
        direction: flexObj === null || flexObj === void 0 ? void 0 : flexObj.direction,
        justifyContent: flexObj === null || flexObj === void 0 ? void 0 : flexObj.justifyContent,
        wrap: flexObj === null || flexObj === void 0 ? void 0 : flexObj.wrap
    };
    var gapColumnEnable = get2WithNull4Enable(flexObj === null || flexObj === void 0 ? void 0 : (ref4 = flexObj.gap) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.column) === null || ref5 === void 0 ? void 0 : ref5.enable, defaultFlexObj.gap.column.enable);
    var gapRowEnable = get2WithNull4Enable(flexObj === null || flexObj === void 0 ? void 0 : (ref6 = flexObj.gap) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.row) === null || ref7 === void 0 ? void 0 : ref7.enable, defaultFlexObj.gap.row.enable);
    if (valueExists(flexObj === null || flexObj === void 0 ? void 0 : (ref8 = flexObj.gap) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.column) === null || ref9 === void 0 ? void 0 : ref9.value) || valueExists(flexObj === null || flexObj === void 0 ? void 0 : (ref10 = flexObj.gap) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.column) === null || ref11 === void 0 ? void 0 : ref11.unit)) {
        var ref16, ref17, ref18, ref19;
        var columnValue = bobUtils_get2WithNull(flexObj === null || flexObj === void 0 ? void 0 : (ref16 = flexObj.gap) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.column) === null || ref17 === void 0 ? void 0 : ref17.value, defaultFlexObj.gap.column.value);
        var columnUnit = bobUtils_get2WithNull(flexObj === null || flexObj === void 0 ? void 0 : (ref18 = flexObj.gap) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.column) === null || ref19 === void 0 ? void 0 : ref19.unit, defaultFlexObj.gap.column.unit);
        flex.gap = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, flex.gap), {
            column: {
                enable: gapColumnEnable,
                value: columnValue,
                unit: columnUnit
            }
        });
    }
    if (valueExists(flexObj === null || flexObj === void 0 ? void 0 : (ref12 = flexObj.gap) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.row) === null || ref13 === void 0 ? void 0 : ref13.value) || valueExists(flexObj === null || flexObj === void 0 ? void 0 : (ref14 = flexObj.gap) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.row) === null || ref15 === void 0 ? void 0 : ref15.unit)) {
        var ref20, ref21, ref22, ref23;
        var rowValue = bobUtils_get2WithNull(flexObj === null || flexObj === void 0 ? void 0 : (ref20 = flexObj.gap) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.row) === null || ref21 === void 0 ? void 0 : ref21.value, defaultFlexObj.gap.row.value);
        var rowUnit = bobUtils_get2WithNull(flexObj === null || flexObj === void 0 ? void 0 : (ref22 = flexObj.gap) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.row) === null || ref23 === void 0 ? void 0 : ref23.unit, defaultFlexObj.gap.row.unit);
        flex.gap = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, flex.gap), {
            row: {
                enable: gapRowEnable,
                value: rowValue,
                unit: rowUnit
            }
        });
    }
    return flex;
}
function flexStyle_mergeBob3(flexObj, flexDesktopBehaviour, flexDefaultBreakpoint, defaultFlexObj) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
    if (!flexObj) {
        return {
            gap: undefined,
            alignContent: undefined,
            alignItems: undefined,
            direction: undefined,
            justifyContent: undefined,
            wrap: undefined
        };
    }
    var ref24, ref25, ref26;
    var gapColumnEnable = (ref26 = (ref25 = (ref24 = flexObj === null || flexObj === void 0 ? void 0 : (ref = flexObj.gap) === null || ref === void 0 ? void 0 : (ref1 = ref.column) === null || ref1 === void 0 ? void 0 : ref1.enable) !== null && ref24 !== void 0 ? ref24 : flexDesktopBehaviour === null || flexDesktopBehaviour === void 0 ? void 0 : (ref2 = flexDesktopBehaviour.gap) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.column) === null || ref3 === void 0 ? void 0 : ref3.enable) !== null && ref25 !== void 0 ? ref25 : flexDefaultBreakpoint === null || flexDefaultBreakpoint === void 0 ? void 0 : (ref4 = flexDefaultBreakpoint.gap) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.column) === null || ref5 === void 0 ? void 0 : ref5.enable) !== null && ref26 !== void 0 ? ref26 : defaultFlexObj.gap.column.enable;
    var ref27, ref28, ref29;
    var gapRowEnable = (ref29 = (ref28 = (ref27 = flexObj === null || flexObj === void 0 ? void 0 : (ref6 = flexObj.gap) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.row) === null || ref7 === void 0 ? void 0 : ref7.enable) !== null && ref27 !== void 0 ? ref27 : flexDesktopBehaviour === null || flexDesktopBehaviour === void 0 ? void 0 : (ref8 = flexDesktopBehaviour.gap) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.row) === null || ref9 === void 0 ? void 0 : ref9.enable) !== null && ref28 !== void 0 ? ref28 : flexDefaultBreakpoint === null || flexDefaultBreakpoint === void 0 ? void 0 : (ref10 = flexDefaultBreakpoint.gap) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.row) === null || ref11 === void 0 ? void 0 : ref11.enable) !== null && ref29 !== void 0 ? ref29 : defaultFlexObj.gap.row.enable;
    if (valueExists(flexObj === null || flexObj === void 0 ? void 0 : (ref12 = flexObj.gap) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.column) === null || ref13 === void 0 ? void 0 : ref13.value) || valueExists(flexObj === null || flexObj === void 0 ? void 0 : (ref14 = flexObj.gap) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.column) === null || ref15 === void 0 ? void 0 : ref15.unit) || valueExists(flexObj === null || flexObj === void 0 ? void 0 : (ref16 = flexObj.gap) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.row) === null || ref17 === void 0 ? void 0 : ref17.value) || valueExists(flexObj === null || flexObj === void 0 ? void 0 : (ref18 = flexObj.gap) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.row) === null || ref19 === void 0 ? void 0 : ref19.unit)) {
        var ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51, ref52, ref53;
        var ref54, ref55, ref56;
        var columnValue = (ref56 = (ref55 = (ref54 = flexObj === null || flexObj === void 0 ? void 0 : (ref30 = flexObj.gap) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.column) === null || ref31 === void 0 ? void 0 : ref31.value) !== null && ref54 !== void 0 ? ref54 : flexDesktopBehaviour === null || flexDesktopBehaviour === void 0 ? void 0 : (ref32 = flexDesktopBehaviour.gap) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.column) === null || ref33 === void 0 ? void 0 : ref33.value) !== null && ref55 !== void 0 ? ref55 : flexDefaultBreakpoint === null || flexDefaultBreakpoint === void 0 ? void 0 : (ref34 = flexDefaultBreakpoint.gap) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.column) === null || ref35 === void 0 ? void 0 : ref35.value) !== null && ref56 !== void 0 ? ref56 : defaultFlexObj.gap.column.value;
        var ref57, ref58, ref59;
        var columnUnit = (ref59 = (ref58 = (ref57 = flexObj === null || flexObj === void 0 ? void 0 : (ref36 = flexObj.gap) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.column) === null || ref37 === void 0 ? void 0 : ref37.unit) !== null && ref57 !== void 0 ? ref57 : flexDesktopBehaviour === null || flexDesktopBehaviour === void 0 ? void 0 : (ref38 = flexDesktopBehaviour.gap) === null || ref38 === void 0 ? void 0 : (ref39 = ref38.column) === null || ref39 === void 0 ? void 0 : ref39.unit) !== null && ref58 !== void 0 ? ref58 : flexDefaultBreakpoint === null || flexDefaultBreakpoint === void 0 ? void 0 : (ref40 = flexDefaultBreakpoint.gap) === null || ref40 === void 0 ? void 0 : (ref41 = ref40.column) === null || ref41 === void 0 ? void 0 : ref41.unit) !== null && ref59 !== void 0 ? ref59 : defaultFlexObj.gap.column.unit;
        var ref60, ref61, ref62;
        var rowValue = (ref62 = (ref61 = (ref60 = flexObj === null || flexObj === void 0 ? void 0 : (ref42 = flexObj.gap) === null || ref42 === void 0 ? void 0 : (ref43 = ref42.row) === null || ref43 === void 0 ? void 0 : ref43.value) !== null && ref60 !== void 0 ? ref60 : flexDesktopBehaviour === null || flexDesktopBehaviour === void 0 ? void 0 : (ref44 = flexDesktopBehaviour.gap) === null || ref44 === void 0 ? void 0 : (ref45 = ref44.row) === null || ref45 === void 0 ? void 0 : ref45.value) !== null && ref61 !== void 0 ? ref61 : flexDefaultBreakpoint === null || flexDefaultBreakpoint === void 0 ? void 0 : (ref46 = flexDefaultBreakpoint.gap) === null || ref46 === void 0 ? void 0 : (ref47 = ref46.row) === null || ref47 === void 0 ? void 0 : ref47.value) !== null && ref62 !== void 0 ? ref62 : defaultFlexObj.gap.row.value;
        var ref63, ref64, ref65;
        var rowUnit = (ref65 = (ref64 = (ref63 = flexObj === null || flexObj === void 0 ? void 0 : (ref48 = flexObj.gap) === null || ref48 === void 0 ? void 0 : (ref49 = ref48.row) === null || ref49 === void 0 ? void 0 : ref49.unit) !== null && ref63 !== void 0 ? ref63 : flexDesktopBehaviour === null || flexDesktopBehaviour === void 0 ? void 0 : (ref50 = flexDesktopBehaviour.gap) === null || ref50 === void 0 ? void 0 : (ref51 = ref50.row) === null || ref51 === void 0 ? void 0 : ref51.unit) !== null && ref64 !== void 0 ? ref64 : flexDefaultBreakpoint === null || flexDefaultBreakpoint === void 0 ? void 0 : (ref52 = flexDefaultBreakpoint.gap) === null || ref52 === void 0 ? void 0 : (ref53 = ref52.row) === null || ref53 === void 0 ? void 0 : ref53.unit) !== null && ref65 !== void 0 ? ref65 : defaultFlexObj.gap.row.unit;
        return {
            gap: {
                column: {
                    enable: gapColumnEnable,
                    value: columnValue,
                    unit: columnUnit
                },
                row: {
                    enable: gapRowEnable,
                    value: rowValue,
                    unit: rowUnit
                }
            },
            alignContent: flexObj === null || flexObj === void 0 ? void 0 : flexObj.alignContent,
            alignItems: flexObj === null || flexObj === void 0 ? void 0 : flexObj.alignItems,
            direction: flexObj === null || flexObj === void 0 ? void 0 : flexObj.direction,
            justifyContent: flexObj === null || flexObj === void 0 ? void 0 : flexObj.justifyContent,
            wrap: flexObj === null || flexObj === void 0 ? void 0 : flexObj.wrap
        };
    }
    return {
        gap: {
            column: {
                enable: flexObj === null || flexObj === void 0 ? void 0 : (ref20 = flexObj.gap) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.column) === null || ref21 === void 0 ? void 0 : ref21.enable,
                value: undefined,
                unit: undefined
            },
            row: {
                enable: flexObj === null || flexObj === void 0 ? void 0 : (ref22 = flexObj.gap) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.row) === null || ref23 === void 0 ? void 0 : ref23.enable,
                value: undefined,
                unit: undefined
            }
        },
        alignContent: undefined,
        alignItems: undefined,
        direction: undefined,
        justifyContent: undefined,
        wrap: undefined
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/selfFlexStyle.ts







var selfFlexStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
var SelfAlignCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("auto"),
    (0,es6/* literal */.i0)("flex-start"),
    (0,es6/* literal */.i0)("center"),
    (0,es6/* literal */.i0)("flex-end"),
    (0,es6/* literal */.i0)("stretch"), 
]);
var SelfGrowCodec = (0,es6/* type */.dt)({
    enable: es6/* boolean */.O7,
    value: es6/* number */.pk
});
var SelfShrinkCodec = (0,es6/* type */.dt)({
    enable: es6/* boolean */.O7,
    value: es6/* number */.pk
});
var OrderCodec = (0,es6/* type */.dt)({
    enable: es6/* boolean */.O7,
    value: es6/* number */.pk
});
var SelfFlexCodec = (0,es6/* type */.dt)({
    selfAlign: SelfAlignCodec,
    selfGrow: SelfGrowCodec,
    selfShrink: SelfShrinkCodec,
    order: OrderCodec
});
var SelfGrowOptCodec = (0,es6/* partial */.r$)({
    enable: selfFlexStyle_nullable(es6/* boolean */.O7),
    value: selfFlexStyle_nullable(es6/* number */.pk)
});
var SelfShrinkOptCodec = (0,es6/* partial */.r$)({
    enable: selfFlexStyle_nullable(es6/* boolean */.O7),
    value: selfFlexStyle_nullable(es6/* number */.pk)
});
var OrderOptCodec = (0,es6/* partial */.r$)({
    enable: selfFlexStyle_nullable(es6/* boolean */.O7),
    value: selfFlexStyle_nullable(es6/* number */.pk)
});
var SelfFlexOptCodec = (0,es6/* partial */.r$)({
    selfAlign: selfFlexStyle_nullable(SelfAlignCodec),
    selfGrow: selfFlexStyle_nullable(SelfGrowOptCodec),
    selfShrink: selfFlexStyle_nullable(SelfShrinkOptCodec),
    order: selfFlexStyle_nullable(OrderOptCodec)
});
var StylesSelfFlexCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        selfFlex: SelfFlexCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                selfFlex: SelfFlexOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                selfFlex: SelfFlexOptCodec
            })
        }),
        mobile: (0,es6/* partial */.r$)({
            selfFlex: SelfFlexOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    selfFlex: SelfFlexOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    selfFlex: SelfFlexOptCodec
                })
            })
        }),
        tablet: (0,es6/* partial */.r$)({
            selfFlex: SelfFlexOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    selfFlex: SelfFlexOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    selfFlex: SelfFlexOptCodec
                })
            })
        })
    }), 
]);
var DefaultSelfFlexCSS = {
    "align-self": "auto",
    "flex-grow": "0",
    "flex-shrink": "0",
    order: "0"
};
function selfFlexStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var styles = StylesSelfFlexCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return selfFlexStyle_cssRender(styles.right, breakpoint, behaviourState);
    console.warn(codecUtils_decoderErrors(styles));
    return DefaultSelfFlexCSS;
}
function selfFlexStyle_cssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return selfFlexStyle_render(stylesObj.selfFlex);
        } else {
            var ref, ref1;
            return selfFlexStyle_renderBobOpt(stylesObj.selfFlex, selfFlexStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.selfFlex, stylesObj.selfFlex));
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return selfFlexStyle_renderBobOpt(stylesObj.selfFlex, selfFlexStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.selfFlex, stylesObj.selfFlex));
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return selfFlexStyle_renderBobOpt(stylesObj.selfFlex, selfFlexStyle_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.selfFlex, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.selfFlex, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.selfFlex, stylesObj.selfFlex));
        }
    }
}
function selfFlexStyle_render(selfFlexObj) {
    return {
        "align-self": selfFlexObj.selfAlign,
        "flex-grow": selfFlexObj.selfGrow.enable ? "".concat(selfFlexObj.selfGrow.value) : undefined,
        "flex-shrink": selfFlexObj.selfShrink.enable ? "".concat(selfFlexObj.selfShrink.value) : undefined,
        order: selfFlexObj.order.enable ? "".concat(selfFlexObj.order.value) : undefined
    };
}
/**
 * Renders ColorsOpt css for breakpoints/state templates
 * or empty for non written style props
 *
 * @param selfFlexValue
 * @param foundationStyle
 * @returns
 */ function selfFlexStyle_renderBobOpt(defaultSelfFlexObj, selfFlexValue) {
    if (selfFlexValue) {
        return selfFlexStyle_renderOpt(defaultSelfFlexObj, selfFlexValue);
    }
    return {};
}
/**
 * Renders SelfFlexOpt css for breakpoints/state templates
 * Returns selfFlex
 * or empty for non written style props
 *
 * @param selfFlexValue
 * @param foundationStyle
 * @returns
 */ function selfFlexStyle_renderOpt(defaultSelfFlexObj, selfFlexValue) {
    var ref, ref1, ref2;
    var css = {};
    if (valueExists(selfFlexValue === null || selfFlexValue === void 0 ? void 0 : selfFlexValue.selfAlign)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "align-self": "".concat(selfFlexValue === null || selfFlexValue === void 0 ? void 0 : selfFlexValue.selfAlign)
    });
    if (valueExists(selfFlexValue === null || selfFlexValue === void 0 ? void 0 : (ref = selfFlexValue.selfGrow) === null || ref === void 0 ? void 0 : ref.enable)) {
        var ref3, ref4, ref5, ref6;
        if ((selfFlexValue === null || selfFlexValue === void 0 ? void 0 : (ref3 = selfFlexValue.selfGrow) === null || ref3 === void 0 ? void 0 : ref3.enable) === false) {
            if (defaultSelfFlexObj.selfGrow.enable) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
                "flex-grow": "initial"
            });
        }
        if ((selfFlexValue === null || selfFlexValue === void 0 ? void 0 : (ref4 = selfFlexValue.selfGrow) === null || ref4 === void 0 ? void 0 : ref4.enable) === true && valueExists(selfFlexValue === null || selfFlexValue === void 0 ? void 0 : (ref5 = selfFlexValue.selfGrow) === null || ref5 === void 0 ? void 0 : ref5.value)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
            "flex-grow": "".concat(selfFlexValue === null || selfFlexValue === void 0 ? void 0 : (ref6 = selfFlexValue.selfGrow) === null || ref6 === void 0 ? void 0 : ref6.value)
        });
    }
    if (valueExists(selfFlexValue === null || selfFlexValue === void 0 ? void 0 : (ref1 = selfFlexValue.selfShrink) === null || ref1 === void 0 ? void 0 : ref1.enable)) {
        var ref7, ref8, ref9, ref10;
        if ((selfFlexValue === null || selfFlexValue === void 0 ? void 0 : (ref7 = selfFlexValue.selfShrink) === null || ref7 === void 0 ? void 0 : ref7.enable) === false) {
            if (defaultSelfFlexObj.selfShrink.enable) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
                "flex-shrink": "initial"
            });
        }
        if ((selfFlexValue === null || selfFlexValue === void 0 ? void 0 : (ref8 = selfFlexValue.selfShrink) === null || ref8 === void 0 ? void 0 : ref8.enable) === true && valueExists(selfFlexValue === null || selfFlexValue === void 0 ? void 0 : (ref9 = selfFlexValue.selfShrink) === null || ref9 === void 0 ? void 0 : ref9.value)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
            "flex-shrink": "".concat(selfFlexValue === null || selfFlexValue === void 0 ? void 0 : (ref10 = selfFlexValue.selfShrink) === null || ref10 === void 0 ? void 0 : ref10.value)
        });
    }
    if (valueExists(selfFlexValue === null || selfFlexValue === void 0 ? void 0 : (ref2 = selfFlexValue.order) === null || ref2 === void 0 ? void 0 : ref2.enable)) {
        var ref11, ref12, ref13, ref14;
        if ((selfFlexValue === null || selfFlexValue === void 0 ? void 0 : (ref11 = selfFlexValue.order) === null || ref11 === void 0 ? void 0 : ref11.enable) === false) {
            if (defaultSelfFlexObj.order.enable) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
                order: "initial"
            });
        }
        if ((selfFlexValue === null || selfFlexValue === void 0 ? void 0 : (ref12 = selfFlexValue.order) === null || ref12 === void 0 ? void 0 : ref12.enable) === true && valueExists(selfFlexValue === null || selfFlexValue === void 0 ? void 0 : (ref13 = selfFlexValue.order) === null || ref13 === void 0 ? void 0 : ref13.value)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
            order: "".concat(selfFlexValue === null || selfFlexValue === void 0 ? void 0 : (ref14 = selfFlexValue.order) === null || ref14 === void 0 ? void 0 : ref14.value)
        });
    }
    return css;
}
function selfFlexStyle_mergeBob2(selfFlexObj, defaultSelfFlexObj) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var selfGrowEnable = bobUtils_get2WithNull(selfFlexObj === null || selfFlexObj === void 0 ? void 0 : (ref = selfFlexObj.selfGrow) === null || ref === void 0 ? void 0 : ref.enable, defaultSelfFlexObj.selfGrow.enable);
    var seflShrinkEnable = bobUtils_get2WithNull(selfFlexObj === null || selfFlexObj === void 0 ? void 0 : (ref1 = selfFlexObj.selfShrink) === null || ref1 === void 0 ? void 0 : ref1.enable, defaultSelfFlexObj.selfShrink.enable);
    var orderEnable = bobUtils_get2WithNull(selfFlexObj === null || selfFlexObj === void 0 ? void 0 : (ref2 = selfFlexObj.order) === null || ref2 === void 0 ? void 0 : ref2.enable, defaultSelfFlexObj.order.enable);
    return {
        selfGrow: {
            enable: selfGrowEnable,
            value: selfFlexObj === null || selfFlexObj === void 0 ? void 0 : (ref3 = selfFlexObj.selfGrow) === null || ref3 === void 0 ? void 0 : ref3.value
        },
        selfShrink: {
            enable: seflShrinkEnable,
            value: selfFlexObj === null || selfFlexObj === void 0 ? void 0 : (ref4 = selfFlexObj.selfShrink) === null || ref4 === void 0 ? void 0 : ref4.value
        },
        order: {
            enable: orderEnable,
            value: selfFlexObj === null || selfFlexObj === void 0 ? void 0 : (ref5 = selfFlexObj.order) === null || ref5 === void 0 ? void 0 : ref5.value
        },
        selfAlign: selfFlexObj === null || selfFlexObj === void 0 ? void 0 : selfFlexObj.selfAlign
    };
}
function selfFlexStyle_mergeBob3(selfFlexObj, selfFlexDesktopBehaviour, selfFlexDefaultBreakpoint, defaultSelfFlexObj) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var ref12, ref13, ref14;
    var selfGrowEnable = (ref14 = (ref13 = (ref12 = selfFlexObj === null || selfFlexObj === void 0 ? void 0 : (ref = selfFlexObj.selfGrow) === null || ref === void 0 ? void 0 : ref.enable) !== null && ref12 !== void 0 ? ref12 : selfFlexDesktopBehaviour === null || selfFlexDesktopBehaviour === void 0 ? void 0 : (ref1 = selfFlexDesktopBehaviour.selfGrow) === null || ref1 === void 0 ? void 0 : ref1.enable) !== null && ref13 !== void 0 ? ref13 : selfFlexDefaultBreakpoint === null || selfFlexDefaultBreakpoint === void 0 ? void 0 : (ref2 = selfFlexDefaultBreakpoint.selfGrow) === null || ref2 === void 0 ? void 0 : ref2.enable) !== null && ref14 !== void 0 ? ref14 : defaultSelfFlexObj.selfGrow.enable;
    var ref15, ref16, ref17;
    var seflShrinkEnable = (ref17 = (ref16 = (ref15 = selfFlexObj === null || selfFlexObj === void 0 ? void 0 : (ref3 = selfFlexObj.selfShrink) === null || ref3 === void 0 ? void 0 : ref3.enable) !== null && ref15 !== void 0 ? ref15 : selfFlexDesktopBehaviour === null || selfFlexDesktopBehaviour === void 0 ? void 0 : (ref4 = selfFlexDesktopBehaviour.selfShrink) === null || ref4 === void 0 ? void 0 : ref4.enable) !== null && ref16 !== void 0 ? ref16 : selfFlexDefaultBreakpoint === null || selfFlexDefaultBreakpoint === void 0 ? void 0 : (ref5 = selfFlexDefaultBreakpoint.selfShrink) === null || ref5 === void 0 ? void 0 : ref5.enable) !== null && ref17 !== void 0 ? ref17 : defaultSelfFlexObj.selfShrink.enable;
    var ref18, ref19, ref20;
    var orderEnable = (ref20 = (ref19 = (ref18 = selfFlexObj === null || selfFlexObj === void 0 ? void 0 : (ref6 = selfFlexObj.order) === null || ref6 === void 0 ? void 0 : ref6.enable) !== null && ref18 !== void 0 ? ref18 : selfFlexDesktopBehaviour === null || selfFlexDesktopBehaviour === void 0 ? void 0 : (ref7 = selfFlexDesktopBehaviour.order) === null || ref7 === void 0 ? void 0 : ref7.enable) !== null && ref19 !== void 0 ? ref19 : selfFlexDefaultBreakpoint === null || selfFlexDefaultBreakpoint === void 0 ? void 0 : (ref8 = selfFlexDefaultBreakpoint.order) === null || ref8 === void 0 ? void 0 : ref8.enable) !== null && ref20 !== void 0 ? ref20 : defaultSelfFlexObj.order.enable;
    return {
        selfGrow: {
            enable: selfGrowEnable,
            value: selfFlexObj === null || selfFlexObj === void 0 ? void 0 : (ref9 = selfFlexObj.selfGrow) === null || ref9 === void 0 ? void 0 : ref9.value
        },
        selfShrink: {
            enable: seflShrinkEnable,
            value: selfFlexObj === null || selfFlexObj === void 0 ? void 0 : (ref10 = selfFlexObj.selfShrink) === null || ref10 === void 0 ? void 0 : ref10.value
        },
        order: {
            enable: orderEnable,
            value: selfFlexObj === null || selfFlexObj === void 0 ? void 0 : (ref11 = selfFlexObj.order) === null || ref11 === void 0 ? void 0 : ref11.value
        },
        selfAlign: selfFlexObj === null || selfFlexObj === void 0 ? void 0 : selfFlexObj.selfAlign
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/heightStyleV2.ts





//Temp to handle nulls
var heightStyleV2_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
var heightStyleV2_UnitCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("px"),
    (0,es6/* literal */.i0)("%"),
    (0,es6/* literal */.i0)("vw"),
    (0,es6/* literal */.i0)("vh"),
    (0,es6/* literal */.i0)("auto")
]);
var heightStyleV2_HeightPropsCodec = (0,es6/* type */.dt)({
    value: es6/* number */.pk,
    unit: heightStyleV2_UnitCodec
});
var heightStyleV2_HeightCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    heightStyleV2_HeightPropsCodec
]);
var heightStyleV2_HeightPropsOptCodec = (0,es6/* partial */.r$)({
    unit: heightStyleV2_nullable(heightStyleV2_UnitCodec),
    value: heightStyleV2_nullable(es6/* number */.pk)
});
var heightStyleV2_HeightOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: heightStyleV2_nullable(es6/* boolean */.O7)
    }),
    heightStyleV2_HeightPropsOptCodec
]);
var heightStyleV2_StylesHeightCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        height: heightStyleV2_HeightCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                height: heightStyleV2_HeightPropsOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                height: heightStyleV2_HeightPropsOptCodec
            })
        }),
        mobile: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                height: heightStyleV2_HeightPropsOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        height: heightStyleV2_HeightPropsOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        height: heightStyleV2_HeightPropsOptCodec
                    })
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                height: heightStyleV2_HeightPropsOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        height: heightStyleV2_HeightPropsOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        height: heightStyleV2_HeightPropsOptCodec
                    })
                })
            }), 
        ])
    }), 
]);
function heightStyleV2_responsiveStyle(heightObj) {
    if (!objValueExists(heightObj, "enable")) return "";
    if (!heightObj.enable) return {
        height: "auto"
    };
    return {
        height: heightObj.value + heightObj.unit
    };
}
function heightStyleV2_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var styles = heightStyleV2_StylesHeightCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return heightStyleV2_cssRender(styles.right, breakpoint, behaviourState);
    console.warn(codecUtils_decoderErrors(styles));
    return {
        height: "auto"
    };
}
function heightStyleV2_cssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return heightStyleV2_renderBob(stylesObj.height);
        } else {
            var ref, ref1;
            return heightStyleV2_renderBobOpt(stylesObj.height, heightStyleV2_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.height, stylesObj.height));
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return heightStyleV2_renderBobOpt(stylesObj.height, heightStyleV2_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.height, stylesObj.height));
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return heightStyleV2_renderBobOpt(stylesObj.height, heightStyleV2_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.height, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.height, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.height, stylesObj.height));
        }
    }
}
function heightStyleV2_renderBob(heightObj) {
    if (!heightObj.enable) return {};
    return heightStyleV2_render(heightObj);
}
function heightStyleV2_render(heightObj) {
    var heightValue = heightObj.value;
    var heightUnit = heightObj.unit;
    return {
        height: "".concat(heightValue).concat(heightUnit)
    };
}
/**
 * Renders ColorsOpt css for breakpoints/state templates
 * or empty for non written style props
 *
 * @param heightObj
 * @param foundationStyle
 * @returns
 */ function heightStyleV2_renderBobOpt(defaultHeightObj, heightObj) {
    if ((heightObj === null || heightObj === void 0 ? void 0 : heightObj.enable) === false) {
        if (defaultHeightObj.enable) return {
            height: "auto"
        };
        return {};
    }
    if (heightObj === null || heightObj === void 0 ? void 0 : heightObj.enable) return heightStyleV2_renderOpt(heightObj);
    return {};
}
/**
 * Renders HeightOpt css for breakpoints/state templates
 * Returns color
 * or empty for non written style props
 *
 * @param heightObj
 * @param foundationStyle
 * @returns
 */ function heightStyleV2_renderOpt(heightObj) {
    var css = {};
    if (utils_objValueExists(heightObj, "unit") || utils_objValueExists(heightObj, "value")) {
        css = {
            height: "".concat(heightObj.value).concat(heightObj.unit)
        };
    }
    return css;
}
function heightStyleV2_mergeBob2(heightObj, defaultHeightObj) {
    // no filter object
    if (!heightObj) {
        return {
            enable: undefined,
            value: undefined,
            unit: undefined
        };
    }
    var ref;
    var enable = (ref = heightObj === null || heightObj === void 0 ? void 0 : heightObj.enable) !== null && ref !== void 0 ? ref : defaultHeightObj.enable;
    //if one of the values is set in the breakpoint we render the entire shadow property
    if (utils_objValueExists(heightObj, "value") || utils_objValueExists(heightObj, "unit")) {
        var value = bobUtils_get2WithNull(heightObj === null || heightObj === void 0 ? void 0 : heightObj.value, defaultHeightObj.value);
        var unit = bobUtils_get2WithNull(heightObj === null || heightObj === void 0 ? void 0 : heightObj.unit, defaultHeightObj.unit);
        return {
            enable: enable,
            value: value,
            unit: unit
        };
    }
    //only enable is written
    return {
        enable: enable,
        value: undefined,
        unit: undefined
    };
}
function heightStyleV2_mergeBob3(heightObj, heightDesktopBehaviour, heightDefaultBreakpoint, defaultHeightObj) {
    // no filter object
    if (!heightObj) {
        return {
            enable: undefined,
            value: undefined,
            unit: undefined
        };
    }
    var ref, ref1, ref2;
    var enable = (ref2 = (ref1 = (ref = heightObj === null || heightObj === void 0 ? void 0 : heightObj.enable) !== null && ref !== void 0 ? ref : heightDesktopBehaviour === null || heightDesktopBehaviour === void 0 ? void 0 : heightDesktopBehaviour.enable) !== null && ref1 !== void 0 ? ref1 : heightDefaultBreakpoint === null || heightDefaultBreakpoint === void 0 ? void 0 : heightDefaultBreakpoint.enable) !== null && ref2 !== void 0 ? ref2 : defaultHeightObj.enable;
    //if one of the values is set in the breakpoint we render the entire shadow property
    if (utils_objValueExists(heightObj, "value") || utils_objValueExists(heightObj, "unit")) {
        var value = bobUtils_get2WithNull(heightObj === null || heightObj === void 0 ? void 0 : heightObj.value, defaultHeightObj.value);
        var unit = bobUtils_get2WithNull(heightObj === null || heightObj === void 0 ? void 0 : heightObj.unit, defaultHeightObj.unit);
        return {
            enable: enable,
            value: value,
            unit: unit
        };
    }
    //only enable is written
    return {
        enable: enable,
        value: undefined,
        unit: undefined
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/maxHeightStyle.ts





//Temp to handle nulls
var maxHeightStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
var maxHeightStyle_UnitCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("px"),
    (0,es6/* literal */.i0)("%"),
    (0,es6/* literal */.i0)("vw"),
    (0,es6/* literal */.i0)("vh"),
    (0,es6/* literal */.i0)("auto"), 
]);
var MaxHeightPropsCodec = (0,es6/* type */.dt)({
    value: es6/* number */.pk,
    unit: maxHeightStyle_UnitCodec
});
var MaxHeightCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    MaxHeightPropsCodec, 
]);
var MaxHeightPropsOptCodec = (0,es6/* partial */.r$)({
    unit: maxHeightStyle_nullable(maxHeightStyle_UnitCodec),
    value: maxHeightStyle_nullable(es6/* number */.pk)
});
var MaxHeightOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: maxHeightStyle_nullable(es6/* boolean */.O7)
    }),
    MaxHeightPropsOptCodec, 
]);
var StylesMaxHeightCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        maxHeight: MaxHeightCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                maxHeight: MaxHeightPropsOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                maxHeight: MaxHeightPropsOptCodec
            })
        }),
        mobile: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                maxHeight: MaxHeightPropsOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        maxHeight: MaxHeightPropsOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        maxHeight: MaxHeightPropsOptCodec
                    })
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                maxHeight: MaxHeightPropsOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        maxHeight: MaxHeightPropsOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        maxHeight: MaxHeightPropsOptCodec
                    })
                })
            }), 
        ])
    }), 
]);
function maxHeightStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var styles = StylesMaxHeightCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return maxHeightStyle_cssRender(styles.right, breakpoint, behaviourState);
    console.warn(codecUtils_decoderErrors(styles));
    return {};
}
function maxHeightStyle_cssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return maxHeightStyle_renderBob(stylesObj.maxHeight);
        } else {
            var ref, ref1;
            return maxHeightStyle_renderBobOpt(stylesObj.maxHeight, maxHeightStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.maxHeight, stylesObj.maxHeight));
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return maxHeightStyle_renderBobOpt(stylesObj.maxHeight, maxHeightStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.maxHeight, stylesObj.maxHeight));
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return maxHeightStyle_renderBobOpt(stylesObj.maxHeight, maxHeightStyle_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.maxHeight, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.maxHeight, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.maxHeight, stylesObj.maxHeight));
        }
    }
}
function maxHeightStyle_renderBob(maxHeightObj) {
    if (!maxHeightObj.enable) return {};
    return maxHeightStyle_render(maxHeightObj);
}
function maxHeightStyle_render(maxHeightObj) {
    var heightValue = maxHeightObj.value;
    var heightUnit = maxHeightObj.unit;
    return {
        "max-height": "".concat(heightValue).concat(heightUnit)
    };
}
/**
 * Renders ColorsOpt css for breakpoints/state templates
 * or empty for non written style props
 *
 * @param maxHeightObj
 * @param foundationStyle
 * @returns
 */ function maxHeightStyle_renderBobOpt(defaultMaxHeightObj, maxHeightObj) {
    if ((maxHeightObj === null || maxHeightObj === void 0 ? void 0 : maxHeightObj.enable) === false) {
        if (defaultMaxHeightObj.enable) return {
            "max-height": "auto"
        };
        return {};
    }
    if (maxHeightObj === null || maxHeightObj === void 0 ? void 0 : maxHeightObj.enable) return maxHeightStyle_renderOpt(maxHeightObj);
    return {};
}
/**
 * Renders MaxHeightOpt css for breakpoints/state templates
 * Returns color
 * or empty for non written style props
 *
 * @param maxHeightObj
 * @param foundationStyle
 * @returns
 */ function maxHeightStyle_renderOpt(maxHeightObj) {
    var css = {};
    if (utils_objValueExists(maxHeightObj, "unit") || utils_objValueExists(maxHeightObj, "value")) {
        css = {
            "max-height": "".concat(maxHeightObj.value).concat(maxHeightObj.unit)
        };
    }
    return css;
}
function maxHeightStyle_mergeBob2(maxHeightObj, defaultMaxHeightObj) {
    // no filter object
    if (!maxHeightObj) {
        return {
            enable: undefined,
            value: undefined,
            unit: undefined
        };
    }
    var ref;
    var enable = (ref = maxHeightObj === null || maxHeightObj === void 0 ? void 0 : maxHeightObj.enable) !== null && ref !== void 0 ? ref : defaultMaxHeightObj.enable;
    //if one of the values is set in the breakpoint we render the entire shadow property
    if (utils_objValueExists(maxHeightObj, "value") || utils_objValueExists(maxHeightObj, "unit")) {
        var value = bobUtils_get2WithNull(maxHeightObj === null || maxHeightObj === void 0 ? void 0 : maxHeightObj.value, defaultMaxHeightObj.value);
        var unit = bobUtils_get2WithNull(maxHeightObj === null || maxHeightObj === void 0 ? void 0 : maxHeightObj.unit, defaultMaxHeightObj.unit);
        return {
            enable: enable,
            value: value,
            unit: unit
        };
    }
    //only enable is written
    return {
        enable: enable,
        value: undefined,
        unit: undefined
    };
}
function maxHeightStyle_mergeBob3(maxHeightObj, maxHeightDesktopBehaviour, maxHeightDefaultBreakpoint, defaultMaxHeightObj) {
    // no filter object
    if (!maxHeightObj) {
        return {
            enable: undefined,
            value: undefined,
            unit: undefined
        };
    }
    var ref, ref1, ref2;
    var enable = (ref2 = (ref1 = (ref = maxHeightObj === null || maxHeightObj === void 0 ? void 0 : maxHeightObj.enable) !== null && ref !== void 0 ? ref : maxHeightDesktopBehaviour === null || maxHeightDesktopBehaviour === void 0 ? void 0 : maxHeightDesktopBehaviour.enable) !== null && ref1 !== void 0 ? ref1 : maxHeightDefaultBreakpoint === null || maxHeightDefaultBreakpoint === void 0 ? void 0 : maxHeightDefaultBreakpoint.enable) !== null && ref2 !== void 0 ? ref2 : defaultMaxHeightObj.enable;
    //if one of the values is set in the breakpoint we render the entire shadow property
    if (utils_objValueExists(maxHeightObj, "value") || utils_objValueExists(maxHeightObj, "unit")) {
        var value = bobUtils_get2WithNull(maxHeightObj === null || maxHeightObj === void 0 ? void 0 : maxHeightObj.value, defaultMaxHeightObj.value);
        var unit = bobUtils_get2WithNull(maxHeightObj === null || maxHeightObj === void 0 ? void 0 : maxHeightObj.unit, defaultMaxHeightObj.unit);
        return {
            enable: enable,
            value: value,
            unit: unit
        };
    }
    //only enable is written
    return {
        enable: enable,
        value: undefined,
        unit: undefined
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/minHeightStyle.ts





//Temp to handle nulls
var minHeightStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
var minHeightStyle_UnitCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("px"),
    (0,es6/* literal */.i0)("%"),
    (0,es6/* literal */.i0)("vw"),
    (0,es6/* literal */.i0)("vh"),
    (0,es6/* literal */.i0)("auto"), 
]);
var MinHeightPropsCodec = (0,es6/* type */.dt)({
    value: es6/* number */.pk,
    unit: minHeightStyle_UnitCodec
});
var MinHeightCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    MinHeightPropsCodec, 
]);
var MinHeightPropsOptCodec = (0,es6/* partial */.r$)({
    unit: minHeightStyle_nullable(minHeightStyle_UnitCodec),
    value: minHeightStyle_nullable(es6/* number */.pk)
});
var MinHeightOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: minHeightStyle_nullable(es6/* boolean */.O7)
    }),
    MinHeightPropsOptCodec, 
]);
var StylesMinHeightCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        minHeight: MinHeightCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                minHeight: MinHeightPropsOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                minHeight: MinHeightPropsOptCodec
            })
        }),
        mobile: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                minHeight: MinHeightPropsOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        minHeight: MinHeightPropsOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        minHeight: MinHeightPropsOptCodec
                    })
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                minHeight: MinHeightPropsOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        minHeight: MinHeightPropsOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        minHeight: MinHeightPropsOptCodec
                    })
                })
            }), 
        ])
    }), 
]);
function minHeightStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var styles = StylesMinHeightCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return minHeightStyle_cssRender(styles.right, breakpoint, behaviourState);
    console.warn(codecUtils_decoderErrors(styles));
    return {
        "min-height": "auto"
    };
}
function minHeightStyle_cssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return minHeightStyle_renderBob(stylesObj.minHeight);
        } else {
            var ref, ref1;
            return minHeightStyle_renderBobOpt(stylesObj.minHeight, minHeightStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.minHeight, stylesObj.minHeight));
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return minHeightStyle_renderBobOpt(stylesObj.minHeight, minHeightStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.minHeight, stylesObj.minHeight));
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return minHeightStyle_renderBobOpt(stylesObj.minHeight, minHeightStyle_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.minHeight, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.minHeight, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.minHeight, stylesObj.minHeight));
        }
    }
}
function minHeightStyle_renderBob(minHeightObj) {
    if (!minHeightObj.enable) return {};
    return minHeightStyle_render(minHeightObj);
}
function minHeightStyle_render(minHeightObj) {
    var heightValue = minHeightObj.value;
    var heightUnit = minHeightObj.unit;
    return {
        "min-height": "".concat(heightValue).concat(heightUnit)
    };
}
/**
 * Renders ColorsOpt css for breakpoints/state templates
 * or empty for non written style props
 *
 * @param minHeightObj
 * @param foundationStyle
 * @returns
 */ function minHeightStyle_renderBobOpt(defaultMinHeightObjObj, minHeightObj) {
    if ((minHeightObj === null || minHeightObj === void 0 ? void 0 : minHeightObj.enable) === false) {
        if (defaultMinHeightObjObj.enable) return {
            "min-height": "auto"
        };
        return {};
    }
    if (minHeightObj === null || minHeightObj === void 0 ? void 0 : minHeightObj.enable) return minHeightStyle_renderOpt(minHeightObj);
    return {};
}
/**
 * Renders MinHeightOpt css for breakpoints/state templates
 * Returns color
 * or empty for non written style props
 *
 * @param minHeightObj
 * @param foundationStyle
 * @returns
 */ function minHeightStyle_renderOpt(minHeightObj) {
    var css = {};
    if (utils_objValueExists(minHeightObj, "unit") || utils_objValueExists(minHeightObj, "value")) {
        css = {
            "min-height": "".concat(minHeightObj.value).concat(minHeightObj.unit)
        };
    }
    return css;
}
function minHeightStyle_mergeBob2(minHeightObj, defaultMinHeightObj) {
    // no filter object
    if (!minHeightObj) {
        return {
            enable: undefined,
            value: undefined,
            unit: undefined
        };
    }
    var ref;
    var enable = (ref = minHeightObj === null || minHeightObj === void 0 ? void 0 : minHeightObj.enable) !== null && ref !== void 0 ? ref : defaultMinHeightObj.enable;
    //if one of the values is set in the breakpoint we render the entire shadow property
    if (utils_objValueExists(minHeightObj, "value") || utils_objValueExists(minHeightObj, "unit")) {
        var value = bobUtils_get2WithNull(minHeightObj === null || minHeightObj === void 0 ? void 0 : minHeightObj.value, defaultMinHeightObj.value);
        var unit = bobUtils_get2WithNull(minHeightObj === null || minHeightObj === void 0 ? void 0 : minHeightObj.unit, defaultMinHeightObj.unit);
        return {
            enable: enable,
            value: value,
            unit: unit
        };
    }
    //only enable is written
    return {
        enable: enable,
        value: undefined,
        unit: undefined
    };
}
function minHeightStyle_mergeBob3(minHeightObj, minHeightDesktopBehaviour, minHeightDefaultBreakpoint, defaultMinHeightObj) {
    // no filter object
    if (!minHeightObj) {
        return {
            enable: undefined,
            value: undefined,
            unit: undefined
        };
    }
    var ref, ref1, ref2;
    var enable = (ref2 = (ref1 = (ref = minHeightObj === null || minHeightObj === void 0 ? void 0 : minHeightObj.enable) !== null && ref !== void 0 ? ref : minHeightDesktopBehaviour === null || minHeightDesktopBehaviour === void 0 ? void 0 : minHeightDesktopBehaviour.enable) !== null && ref1 !== void 0 ? ref1 : minHeightDefaultBreakpoint === null || minHeightDefaultBreakpoint === void 0 ? void 0 : minHeightDefaultBreakpoint.enable) !== null && ref2 !== void 0 ? ref2 : defaultMinHeightObj.enable;
    //if one of the values is set in the breakpoint we render the entire shadow property
    if (utils_objValueExists(minHeightObj, "value") || utils_objValueExists(minHeightObj, "unit")) {
        var value = bobUtils_get2WithNull(minHeightObj === null || minHeightObj === void 0 ? void 0 : minHeightObj.value, defaultMinHeightObj.value);
        var unit = bobUtils_get2WithNull(minHeightObj === null || minHeightObj === void 0 ? void 0 : minHeightObj.unit, defaultMinHeightObj.unit);
        return {
            enable: enable,
            value: value,
            unit: unit
        };
    }
    //only enable is written
    return {
        enable: enable,
        value: undefined,
        unit: undefined
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/widthStyleV2.ts





//Temp to handle nulls
var widthStyleV2_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
var widthStyleV2_UnitCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("px"),
    (0,es6/* literal */.i0)("%"),
    (0,es6/* literal */.i0)("vw"),
    (0,es6/* literal */.i0)("vh"),
    (0,es6/* literal */.i0)("auto")
]);
var widthStyleV2_WidthPropsCodec = (0,es6/* type */.dt)({
    value: es6/* number */.pk,
    unit: widthStyleV2_UnitCodec
});
var widthStyleV2_WidthCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    widthStyleV2_WidthPropsCodec
]);
var widthStyleV2_WidthPropsOptCodec = (0,es6/* partial */.r$)({
    unit: widthStyleV2_nullable(widthStyleV2_UnitCodec),
    value: widthStyleV2_nullable(es6/* number */.pk)
});
var widthStyleV2_WidthOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: widthStyleV2_nullable(es6/* boolean */.O7)
    }),
    widthStyleV2_WidthPropsOptCodec
]);
var widthStyleV2_StylesWidthCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        width: widthStyleV2_WidthCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                width: widthStyleV2_WidthPropsOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                width: widthStyleV2_WidthPropsOptCodec
            })
        }),
        mobile: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                width: widthStyleV2_WidthPropsOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        width: widthStyleV2_WidthPropsOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        width: widthStyleV2_WidthPropsOptCodec
                    })
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                width: widthStyleV2_WidthPropsOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        width: widthStyleV2_WidthPropsOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        width: widthStyleV2_WidthPropsOptCodec
                    })
                })
            }), 
        ])
    }), 
]);
function widthStyleV2_responsiveStyle(widthObj) {
    if (!objValueExists(widthObj, "enable")) return "";
    if (!widthObj.enable) return {
        width: "auto"
    };
    return {
        width: widthObj.value + widthObj.unit
    };
}
function widthStyleV2_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var styles = widthStyleV2_StylesWidthCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return widthStyleV2_cssRender(styles.right, breakpoint, behaviourState);
    console.warn(codecUtils_decoderErrors(styles));
    return {
        width: "auto"
    };
}
function widthStyleV2_cssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return widthStyleV2_renderBob(stylesObj.width);
        } else {
            var ref, ref1;
            return widthStyleV2_renderBobOpt(stylesObj.width, widthStyleV2_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.width, stylesObj.width));
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return widthStyleV2_renderBobOpt(stylesObj.width, widthStyleV2_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.width, stylesObj.width));
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return widthStyleV2_renderBobOpt(stylesObj.width, widthStyleV2_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.width, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.width, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.width, stylesObj.width));
        }
    }
}
function widthStyleV2_renderBob(widthObj) {
    if (!widthObj.enable) return {};
    return widthStyleV2_render(widthObj);
}
function widthStyleV2_render(widthObj) {
    var widthValue = widthObj.value;
    var widthUnit = widthObj.unit;
    return {
        width: "".concat(widthValue).concat(widthUnit)
    };
}
/**
 * Renders ColorsOpt css for breakpoints/state templates
 * or empty for non written style props
 *
 * @param widthObj
 * @param foundationStyle
 * @returns
 */ function widthStyleV2_renderBobOpt(defaultWidthObj, widthObj) {
    if ((widthObj === null || widthObj === void 0 ? void 0 : widthObj.enable) === false) {
        if (defaultWidthObj.enable) return {
            width: "auto"
        };
        return {};
    }
    if (widthObj === null || widthObj === void 0 ? void 0 : widthObj.enable) return widthStyleV2_renderOpt(widthObj);
    return {};
}
/**
 * Renders WidthOpt css for breakpoints/state templates
 * Returns color
 * or empty for non written style props
 *
 * @param widthObj
 * @param foundationStyle
 * @returns
 */ function widthStyleV2_renderOpt(widthObj) {
    var css = {};
    if (utils_objValueExists(widthObj, "unit") || utils_objValueExists(widthObj, "value")) {
        css = {
            width: "".concat(widthObj.value).concat(widthObj.unit)
        };
    }
    return css;
}
function widthStyleV2_mergeBob2(widthObj, defaultWidthObj) {
    // no filter object
    if (!widthObj) {
        return {
            enable: undefined,
            value: undefined,
            unit: undefined
        };
    }
    var ref;
    var enable = (ref = widthObj === null || widthObj === void 0 ? void 0 : widthObj.enable) !== null && ref !== void 0 ? ref : defaultWidthObj.enable;
    //if one of the values is set in the breakpoint we render the entire shadow property
    if (utils_objValueExists(widthObj, "value") || utils_objValueExists(widthObj, "unit")) {
        var value = bobUtils_get2WithNull(widthObj === null || widthObj === void 0 ? void 0 : widthObj.value, defaultWidthObj.value);
        var unit = bobUtils_get2WithNull(widthObj === null || widthObj === void 0 ? void 0 : widthObj.unit, defaultWidthObj.unit);
        return {
            enable: enable,
            value: value,
            unit: unit
        };
    }
    //only enable is written
    return {
        enable: enable,
        value: undefined,
        unit: undefined
    };
}
function widthStyleV2_mergeBob3(widthObj, widthDesktopBehaviour, widthDefaultBreakpoint, defaultWidthObj) {
    // no filter object
    if (!widthObj) {
        return {
            enable: undefined,
            value: undefined,
            unit: undefined
        };
    }
    var ref, ref1, ref2;
    var enable = (ref2 = (ref1 = (ref = widthObj === null || widthObj === void 0 ? void 0 : widthObj.enable) !== null && ref !== void 0 ? ref : widthDesktopBehaviour === null || widthDesktopBehaviour === void 0 ? void 0 : widthDesktopBehaviour.enable) !== null && ref1 !== void 0 ? ref1 : widthDefaultBreakpoint === null || widthDefaultBreakpoint === void 0 ? void 0 : widthDefaultBreakpoint.enable) !== null && ref2 !== void 0 ? ref2 : defaultWidthObj.enable;
    //if one of the values is set in the breakpoint we render the entire shadow property
    if (utils_objValueExists(widthObj, "value") || utils_objValueExists(widthObj, "unit")) {
        var value = bobUtils_get2WithNull(widthObj === null || widthObj === void 0 ? void 0 : widthObj.value, defaultWidthObj.value);
        var unit = bobUtils_get2WithNull(widthObj === null || widthObj === void 0 ? void 0 : widthObj.unit, defaultWidthObj.unit);
        return {
            enable: enable,
            value: value,
            unit: unit
        };
    }
    //only enable is written
    return {
        enable: enable,
        value: undefined,
        unit: undefined
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/maxWidthStyle.ts





//Temp to handle nulls
var maxWidthStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
var maxWidthStyle_UnitCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("px"),
    (0,es6/* literal */.i0)("%"),
    (0,es6/* literal */.i0)("vw"),
    (0,es6/* literal */.i0)("vh"),
    (0,es6/* literal */.i0)("auto"), 
]);
var MaxWidthPropsCodec = (0,es6/* type */.dt)({
    value: es6/* number */.pk,
    unit: maxWidthStyle_UnitCodec
});
var MaxWidthCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    MaxWidthPropsCodec, 
]);
var MaxWidthPropsOptCodec = (0,es6/* partial */.r$)({
    unit: maxWidthStyle_nullable(maxWidthStyle_UnitCodec),
    value: maxWidthStyle_nullable(es6/* number */.pk)
});
var MaxWidthOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: maxWidthStyle_nullable(es6/* boolean */.O7)
    }),
    MaxWidthPropsOptCodec, 
]);
var StylesMaxWidthCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        maxWidth: MaxWidthCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                maxWidth: MaxWidthPropsOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                maxWidth: MaxWidthPropsOptCodec
            })
        }),
        mobile: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                maxWidth: MaxWidthPropsOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        maxWidth: MaxWidthPropsOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        maxWidth: MaxWidthPropsOptCodec
                    })
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                maxWidth: MaxWidthPropsOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        maxWidth: MaxWidthPropsOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        maxWidth: MaxWidthPropsOptCodec
                    })
                })
            }), 
        ])
    }), 
]);
function maxWidthStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var styles = StylesMaxWidthCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return maxWidthStyle_cssRender(styles.right, breakpoint, behaviourState);
    console.warn(codecUtils_decoderErrors(styles));
    return {};
}
function maxWidthStyle_cssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return maxWidthStyle_renderBob(stylesObj.maxWidth);
        } else {
            var ref, ref1;
            return maxWidthStyle_renderBobOpt(stylesObj.maxWidth, maxWidthStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.maxWidth, stylesObj.maxWidth));
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return maxWidthStyle_renderBobOpt(stylesObj.maxWidth, maxWidthStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.maxWidth, stylesObj.maxWidth));
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return maxWidthStyle_renderBobOpt(stylesObj.maxWidth, maxWidthStyle_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.maxWidth, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.maxWidth, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.maxWidth, stylesObj.maxWidth));
        }
    }
}
function maxWidthStyle_renderBob(maxWidthObj) {
    if (!maxWidthObj.enable) return {};
    return maxWidthStyle_render(maxWidthObj);
}
function maxWidthStyle_render(maxWidthObj) {
    var widthValue = maxWidthObj.value;
    var widthUnit = maxWidthObj.unit;
    return {
        "max-width": "".concat(widthValue).concat(widthUnit)
    };
}
/**
 * Renders ColorsOpt css for breakpoints/state templates
 * or empty for non written style props
 *
 * @param maxWidthObj
 * @param foundationStyle
 * @returns
 */ function maxWidthStyle_renderBobOpt(defaultMaxWidthObjObj, maxWidthObj) {
    if ((maxWidthObj === null || maxWidthObj === void 0 ? void 0 : maxWidthObj.enable) === false) {
        if (defaultMaxWidthObjObj.enable) return {
            "max-width": "auto"
        };
        return {};
    }
    if (maxWidthObj === null || maxWidthObj === void 0 ? void 0 : maxWidthObj.enable) return maxWidthStyle_renderOpt(maxWidthObj);
    return {};
}
/**
 * Renders MaxWidthOpt css for breakpoints/state templates
 * Returns color
 * or empty for non written style props
 *
 * @param maxWidthObj
 * @param foundationStyle
 * @returns
 */ function maxWidthStyle_renderOpt(maxWidthObj) {
    var css = {};
    if (utils_objValueExists(maxWidthObj, "unit") || utils_objValueExists(maxWidthObj, "value")) {
        css = {
            "max-width": "".concat(maxWidthObj.value).concat(maxWidthObj.unit)
        };
    }
    return css;
}
function maxWidthStyle_mergeBob2(maxWidthObj, defaultMaxWidthObj) {
    // no filter object
    if (!maxWidthObj) {
        return {
            enable: undefined,
            value: undefined,
            unit: undefined
        };
    }
    var ref;
    var enable = (ref = maxWidthObj === null || maxWidthObj === void 0 ? void 0 : maxWidthObj.enable) !== null && ref !== void 0 ? ref : defaultMaxWidthObj.enable;
    //if one of the values is set in the breakpoint we render the entire shadow property
    if (utils_objValueExists(maxWidthObj, "value") || utils_objValueExists(maxWidthObj, "unit")) {
        var value = bobUtils_get2WithNull(maxWidthObj === null || maxWidthObj === void 0 ? void 0 : maxWidthObj.value, defaultMaxWidthObj.value);
        var unit = bobUtils_get2WithNull(maxWidthObj === null || maxWidthObj === void 0 ? void 0 : maxWidthObj.unit, defaultMaxWidthObj.unit);
        return {
            enable: enable,
            value: value,
            unit: unit
        };
    }
    //only enable is written
    return {
        enable: enable,
        value: undefined,
        unit: undefined
    };
}
function maxWidthStyle_mergeBob3(maxWidthObj, widthDesktopBehaviour, widthDefaultBreakpoint, defaultMaxWidthObj) {
    // no filter object
    if (!maxWidthObj) {
        return {
            enable: undefined,
            value: undefined,
            unit: undefined
        };
    }
    var ref, ref1, ref2;
    var enable = (ref2 = (ref1 = (ref = maxWidthObj === null || maxWidthObj === void 0 ? void 0 : maxWidthObj.enable) !== null && ref !== void 0 ? ref : widthDesktopBehaviour === null || widthDesktopBehaviour === void 0 ? void 0 : widthDesktopBehaviour.enable) !== null && ref1 !== void 0 ? ref1 : widthDefaultBreakpoint === null || widthDefaultBreakpoint === void 0 ? void 0 : widthDefaultBreakpoint.enable) !== null && ref2 !== void 0 ? ref2 : defaultMaxWidthObj.enable;
    //if one of the values is set in the breakpoint we render the entire shadow property
    if (utils_objValueExists(maxWidthObj, "value") || utils_objValueExists(maxWidthObj, "unit")) {
        var value = bobUtils_get2WithNull(maxWidthObj === null || maxWidthObj === void 0 ? void 0 : maxWidthObj.value, defaultMaxWidthObj.value);
        var unit = bobUtils_get2WithNull(maxWidthObj === null || maxWidthObj === void 0 ? void 0 : maxWidthObj.unit, defaultMaxWidthObj.unit);
        return {
            enable: enable,
            value: value,
            unit: unit
        };
    }
    //only enable is written
    return {
        enable: enable,
        value: undefined,
        unit: undefined
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/minWidthStyle.ts





//Temp to handle nulls
var minWidthStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
var minWidthStyle_UnitCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("px"),
    (0,es6/* literal */.i0)("%"),
    (0,es6/* literal */.i0)("vw"),
    (0,es6/* literal */.i0)("vh"),
    (0,es6/* literal */.i0)("auto"), 
]);
var MinWidthPropsCodec = (0,es6/* type */.dt)({
    value: es6/* number */.pk,
    unit: minWidthStyle_UnitCodec
});
var MinWidthCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    MinWidthPropsCodec, 
]);
var MinWidthPropsOptCodec = (0,es6/* partial */.r$)({
    unit: minWidthStyle_nullable(minWidthStyle_UnitCodec),
    value: minWidthStyle_nullable(es6/* number */.pk)
});
var MinWidthOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: minWidthStyle_nullable(es6/* boolean */.O7)
    }),
    MinWidthPropsOptCodec, 
]);
var StylesMinWidthCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        minWidth: MinWidthCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                minWidth: MinWidthPropsOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                minWidth: MinWidthPropsOptCodec
            })
        }),
        mobile: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                minWidth: MinWidthPropsOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        minWidth: MinWidthPropsOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        minWidth: MinWidthPropsOptCodec
                    })
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                minWidth: MinWidthPropsOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        minWidth: MinWidthPropsOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        minWidth: MinWidthPropsOptCodec
                    })
                })
            }), 
        ])
    }), 
]);
function minWidthStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var styles = StylesMinWidthCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return minWidthStyle_cssRender(styles.right, breakpoint, behaviourState);
    console.warn(codecUtils_decoderErrors(styles));
    return {
        "min-width": "auto"
    };
}
function minWidthStyle_cssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return minWidthStyle_renderBob(stylesObj.minWidth);
        } else {
            var ref, ref1;
            return minWidthStyle_renderBobOpt(stylesObj.minWidth, minWidthStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.minWidth, stylesObj.minWidth));
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return minWidthStyle_renderBobOpt(stylesObj.minWidth, minWidthStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.minWidth, stylesObj.minWidth));
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return minWidthStyle_renderBobOpt(stylesObj.minWidth, minWidthStyle_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.minWidth, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.minWidth, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.minWidth, stylesObj.minWidth));
        }
    }
}
function minWidthStyle_renderBob(minWidthObj) {
    if (!minWidthObj.enable) return {};
    return minWidthStyle_render(minWidthObj);
}
function minWidthStyle_render(minWidthObj) {
    var widthValue = minWidthObj.value;
    var widthUnit = minWidthObj.unit;
    return {
        "min-width": "".concat(widthValue).concat(widthUnit)
    };
}
/**
 * Renders ColorsOpt css for breakpoints/state templates
 * or empty for non written style props
 *
 * @param minWidthObj
 * @param foundationStyle
 * @returns
 */ function minWidthStyle_renderBobOpt(defaultMinWidthObjObj, minWidthObj) {
    if ((minWidthObj === null || minWidthObj === void 0 ? void 0 : minWidthObj.enable) === false) {
        if (defaultMinWidthObjObj.enable) return {
            "min-width": "auto"
        };
        return {};
    }
    if (minWidthObj === null || minWidthObj === void 0 ? void 0 : minWidthObj.enable) return minWidthStyle_renderOpt(minWidthObj);
    return {};
}
/**
 * Renders MinWidthOpt css for breakpoints/state templates
 * Returns color
 * or empty for non written style props
 *
 * @param minWidthObj
 * @param foundationStyle
 * @returns
 */ function minWidthStyle_renderOpt(minWidthObj) {
    var css = {};
    if (utils_objValueExists(minWidthObj, "unit") || utils_objValueExists(minWidthObj, "value")) {
        css = {
            "min-width": "".concat(minWidthObj.value).concat(minWidthObj.unit)
        };
    }
    return css;
}
function minWidthStyle_mergeBob2(minWidthObj, defaultMinWidthObj) {
    // no filter object
    if (!minWidthObj) {
        return {
            enable: undefined,
            value: undefined,
            unit: undefined
        };
    }
    var ref;
    var enable = (ref = minWidthObj === null || minWidthObj === void 0 ? void 0 : minWidthObj.enable) !== null && ref !== void 0 ? ref : defaultMinWidthObj.enable;
    //if one of the values is set in the breakpoint we render the entire shadow property
    if (utils_objValueExists(minWidthObj, "value") || utils_objValueExists(minWidthObj, "unit")) {
        var value = bobUtils_get2WithNull(minWidthObj === null || minWidthObj === void 0 ? void 0 : minWidthObj.value, defaultMinWidthObj.value);
        var unit = bobUtils_get2WithNull(minWidthObj === null || minWidthObj === void 0 ? void 0 : minWidthObj.unit, defaultMinWidthObj.unit);
        return {
            enable: enable,
            value: value,
            unit: unit
        };
    }
    //only enable is written
    return {
        enable: enable,
        value: undefined,
        unit: undefined
    };
}
function minWidthStyle_mergeBob3(minWidthObj, widthDesktopBehaviour, widthDefaultBreakpoint, defaultMinWidthObj) {
    // no filter object
    if (!minWidthObj) {
        return {
            enable: undefined,
            value: undefined,
            unit: undefined
        };
    }
    var ref, ref1, ref2;
    var enable = (ref2 = (ref1 = (ref = minWidthObj === null || minWidthObj === void 0 ? void 0 : minWidthObj.enable) !== null && ref !== void 0 ? ref : widthDesktopBehaviour === null || widthDesktopBehaviour === void 0 ? void 0 : widthDesktopBehaviour.enable) !== null && ref1 !== void 0 ? ref1 : widthDefaultBreakpoint === null || widthDefaultBreakpoint === void 0 ? void 0 : widthDefaultBreakpoint.enable) !== null && ref2 !== void 0 ? ref2 : defaultMinWidthObj.enable;
    //if one of the values is set in the breakpoint we render the entire shadow property
    if (utils_objValueExists(minWidthObj, "value") || utils_objValueExists(minWidthObj, "unit")) {
        var value = bobUtils_get2WithNull(minWidthObj === null || minWidthObj === void 0 ? void 0 : minWidthObj.value, defaultMinWidthObj.value);
        var unit = bobUtils_get2WithNull(minWidthObj === null || minWidthObj === void 0 ? void 0 : minWidthObj.unit, defaultMinWidthObj.unit);
        return {
            enable: enable,
            value: value,
            unit: unit
        };
    }
    //only enable is written
    return {
        enable: enable,
        value: undefined,
        unit: undefined
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/borderStyleV2.ts








var borderStyleV2_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
var borderStyleV2_borderStyleCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("none"),
    (0,es6/* literal */.i0)("solid"),
    (0,es6/* literal */.i0)("dashed"),
    (0,es6/* literal */.i0)("dotted")
]);
var borderStyleV2_BorderPropsCodec = (0,es6/* type */.dt)({
    bottomColor: es6/* string */.Z_,
    bottomEnable: es6/* boolean */.O7,
    bottomStyle: borderStyleV2_borderStyleCodec,
    bottomWidth: es6/* number */.pk,
    topColor: es6/* string */.Z_,
    topEnable: es6/* boolean */.O7,
    topStyle: borderStyleV2_borderStyleCodec,
    topWidth: es6/* number */.pk,
    leftColor: es6/* string */.Z_,
    leftEnable: es6/* boolean */.O7,
    leftStyle: borderStyleV2_borderStyleCodec,
    leftWidth: es6/* number */.pk,
    rightColor: es6/* string */.Z_,
    rightEnable: es6/* boolean */.O7,
    rightStyle: borderStyleV2_borderStyleCodec,
    rightWidth: es6/* number */.pk
});
var borderStyleV2_BorderCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    borderStyleV2_BorderPropsCodec
]);
var borderStyleV2_BorderPropsOptCodec = (0,es6/* partial */.r$)({
    bottomColor: borderStyleV2_nullable(es6/* string */.Z_),
    bottomEnable: borderStyleV2_nullable(es6/* boolean */.O7),
    bottomStyle: borderStyleV2_nullable(borderStyleV2_borderStyleCodec),
    bottomWidth: borderStyleV2_nullable(es6/* number */.pk),
    topColor: borderStyleV2_nullable(es6/* string */.Z_),
    topEnable: borderStyleV2_nullable(es6/* boolean */.O7),
    topStyle: borderStyleV2_nullable(borderStyleV2_borderStyleCodec),
    topWidth: borderStyleV2_nullable(es6/* number */.pk),
    leftColor: borderStyleV2_nullable(es6/* string */.Z_),
    leftEnable: borderStyleV2_nullable(es6/* boolean */.O7),
    leftStyle: borderStyleV2_nullable(borderStyleV2_borderStyleCodec),
    leftWidth: borderStyleV2_nullable(es6/* number */.pk),
    rightColor: borderStyleV2_nullable(es6/* string */.Z_),
    rightEnable: borderStyleV2_nullable(es6/* boolean */.O7),
    rightStyle: borderStyleV2_nullable(borderStyleV2_borderStyleCodec),
    rightWidth: borderStyleV2_nullable(es6/* number */.pk)
});
var borderStyleV2_BorderOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: borderStyleV2_nullable(es6/* boolean */.O7)
    }),
    borderStyleV2_BorderPropsOptCodec
]);
var borderStyleV2_StylesBorderCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        border: borderStyleV2_BorderCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                border: borderStyleV2_BorderOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                border: borderStyleV2_BorderOptCodec
            })
        }),
        mobile: (0,es6/* partial */.r$)({
            border: borderStyleV2_BorderOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    border: borderStyleV2_BorderOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    border: borderStyleV2_BorderOptCodec
                })
            })
        }),
        tablet: (0,es6/* partial */.r$)({
            border: borderStyleV2_BorderOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    border: borderStyleV2_BorderOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    border: borderStyleV2_BorderOptCodec
                })
            })
        })
    }), 
]);
var borderStyleV2_GSBorderCodec = (0,es6/* intersection */.jV)([
    borderStyleV2_BorderPropsCodec,
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: borderStyleV2_BorderPropsOptCodec,
            hover: borderStyleV2_BorderPropsOptCodec
        }),
        mobile: (0,es6/* intersection */.jV)([
            borderStyleV2_BorderPropsOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: borderStyleV2_BorderPropsOptCodec,
                    hover: borderStyleV2_BorderPropsOptCodec
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            borderStyleV2_BorderPropsOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: borderStyleV2_BorderPropsOptCodec,
                    hover: borderStyleV2_BorderPropsOptCodec
                })
            }), 
        ])
    }), 
]);
function borderStyleV2_renderCSSString(borderStyle) {
    return "\n    ".concat(showIfWritten(borderStyle, "border-bottom-style"), " \n    ").concat(showIfWritten(borderStyle, "border-bottom-width"), " \n    ").concat(showIfWritten(borderStyle, "border-bottom-color"), "  \n    ").concat(showIfWritten(borderStyle, "border-top-style"), " \n    ").concat(showIfWritten(borderStyle, "border-top-width"), " \n    ").concat(showIfWritten(borderStyle, "border-top-color"), "  \n    ").concat(showIfWritten(borderStyle, "border-left-style"), " \n    ").concat(showIfWritten(borderStyle, "border-left-width"), " \n    ").concat(showIfWritten(borderStyle, "border-left-color"), "  \n    ").concat(showIfWritten(borderStyle, "border-right-style"), " \n    ").concat(showIfWritten(borderStyle, "border-right-width"), " \n    ").concat(showIfWritten(borderStyle, "border-right-color"), "\n    ");
}
function borderStyleV2_cssRenderUnsafe(stylesObj, breakpoint, behaviourState, stylesheetLabel) {
    var styles = borderStyleV2_StylesBorderCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return borderStyleV2_cssRender(styles.right, breakpoint, behaviourState, stylesheetLabel);
    console.warn(breakpoint, behaviourState, codecUtils_decoderErrors(styles));
    return {};
}
function borderStyleV2_globalStyleCssRenderUnsafe(gsObj, breakpoint, behaviourState, stylesheetLabel) {
    var gs = borderStyleV2_GSBorderCodec.decode(gsObj);
    if (isRight(gs)) return borderStyleV2_globalStyleCssRender(gs.right, breakpoint, behaviourState, stylesheetLabel);
    console.warn(decoderErrors(gs));
    return {};
}
function borderStyleV2_cssRender(stylesObj, breakpoint, behaviourState, stylesheetLabel) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return borderStyleV2_renderBob(stylesObj.border, stylesheetLabel);
        } else {
            var ref, ref1;
            return borderStyleV2_renderBobOpt(stylesObj.border, borderStyleV2_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.border, stylesObj.border), stylesheetLabel);
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return borderStyleV2_renderBobOpt(stylesObj.border, borderStyleV2_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.border, stylesObj.border), stylesheetLabel);
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return borderStyleV2_renderBobOpt(stylesObj.border, borderStyleV2_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.border, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.border, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.border, stylesObj.border), stylesheetLabel);
        }
    }
}
function borderStyleV2_globalStyleCssRender(stylesObj, breakpoint, behaviourState, stylesheetLabel) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return borderStyleV2_render(stylesObj, stylesheetLabel);
        } else {
            var ref;
            return borderStyleV2_render(borderStyleV2_merge2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : ref[behaviourState], stylesObj), stylesheetLabel);
        }
    } else {
        if (behaviourState === "default") {
            return borderStyleV2_render(borderStyleV2_merge2(stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj), stylesheetLabel);
        } else {
            var ref1, ref2, ref3;
            return borderStyleV2_render(borderStyleV2_merge3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref1 = stylesObj[breakpoint]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : ref2[behaviourState], (ref3 = stylesObj.behaviour) === null || ref3 === void 0 ? void 0 : ref3[behaviourState], stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj), stylesheetLabel);
        }
    }
}
function borderStyleV2_renderBob(borderObj, stylesheetLabel) {
    if (borderObj.enable === false) {
        return {};
    }
    return borderStyleV2_render(borderObj, stylesheetLabel);
}
function borderStyleV2_renderBobOpt(defaultBorderObj, borderObj, stylesheetLabel) {
    if ((borderObj === null || borderObj === void 0 ? void 0 : borderObj.enable) === false) {
        if (defaultBorderObj.enable) {
            return {
                "border-bottom-style": "none",
                "border-bottom-width": "0",
                "border-bottom-color": "#fff",
                "border-top-style": "none",
                "border-top-width": "0",
                "border-top-color": "#fff",
                "border-left-style": "none",
                "border-left-width": "0",
                "border-left-color": "#fff",
                "border-right-style": "none",
                "border-right-width": "0",
                "border-right-color": "#fff"
            };
        }
        return {};
    }
    if ((borderObj === null || borderObj === void 0 ? void 0 : borderObj.enable) === true) return borderStyleV2_renderOpt(borderObj, stylesheetLabel);
    return {};
}
function borderStyleV2_render(borderObj, stylesheetLabel) {
    var cssProperties = {};
    if (borderObj.bottomEnable) {
        cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-bottom-style": borderObj.bottomStyle,
            "border-bottom-width": "".concat(borderObj.bottomWidth, "px"),
            "border-bottom-color": handleBobStylesheetLabel(stylesheetLabel === null || stylesheetLabel === void 0 ? void 0 : stylesheetLabel["bottom-color"], borderObj.bottomColor)
        });
    }
    if (borderObj.topEnable) {
        cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-top-style": borderObj.topStyle,
            "border-top-width": "".concat(borderObj.topWidth, "px"),
            "border-top-color": handleBobStylesheetLabel(stylesheetLabel === null || stylesheetLabel === void 0 ? void 0 : stylesheetLabel["top-color"], borderObj.topColor)
        });
    }
    if (borderObj.leftEnable) {
        cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-left-style": borderObj.leftStyle,
            "border-left-width": "".concat(borderObj.leftWidth, "px"),
            "border-left-color": handleBobStylesheetLabel(stylesheetLabel === null || stylesheetLabel === void 0 ? void 0 : stylesheetLabel["left-color"], borderObj.leftColor)
        });
    }
    if (borderObj.rightEnable) {
        cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-right-style": borderObj.rightStyle,
            "border-right-width": "".concat(borderObj.rightWidth, "px"),
            "border-right-color": handleBobStylesheetLabel(stylesheetLabel === null || stylesheetLabel === void 0 ? void 0 : stylesheetLabel["right-color"], borderObj.rightColor)
        });
    }
    return cssProperties;
}
function borderStyleV2_renderOpt(borderObj, stylesheetLabel) {
    var cssProperties = {};
    if (valueExists(borderObj.bottomEnable) && borderObj.bottomEnable) {
        if (valueExists(borderObj.bottomWidth)) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-bottom-width": "".concat(borderObj.bottomWidth, "px")
        });
        if (valueExists(borderObj.bottomStyle)) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-bottom-style": "".concat(borderObj.bottomStyle)
        });
        if (valueExists(borderObj.bottomColor) || (stylesheetLabel === null || stylesheetLabel === void 0 ? void 0 : stylesheetLabel["bottom-color"])) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-bottom-color": handleBobStylesheetLabel(stylesheetLabel === null || stylesheetLabel === void 0 ? void 0 : stylesheetLabel["bottom-color"], "".concat(borderObj.bottomColor))
        });
    }
    if (valueExists(borderObj.topEnable) && borderObj.topEnable) {
        if (valueExists(borderObj.topWidth)) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-top-width": "".concat(borderObj.topWidth, "px")
        });
        if (valueExists(borderObj.topStyle)) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-top-style": "".concat(borderObj.topStyle)
        });
        if (valueExists(borderObj.topColor || (stylesheetLabel === null || stylesheetLabel === void 0 ? void 0 : stylesheetLabel["top-color"]))) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-top-color": handleBobStylesheetLabel(stylesheetLabel === null || stylesheetLabel === void 0 ? void 0 : stylesheetLabel["top-color"], "".concat(borderObj.topColor))
        });
    }
    if (valueExists(borderObj.leftEnable) && borderObj.leftEnable) {
        if (valueExists(borderObj.leftWidth)) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-left-width": "".concat(borderObj.leftWidth, "px")
        });
        if (valueExists(borderObj.leftStyle)) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-left-style": "".concat(borderObj.leftStyle)
        });
        if (valueExists(borderObj.leftColor) || (stylesheetLabel === null || stylesheetLabel === void 0 ? void 0 : stylesheetLabel["left-color"])) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-left-color": handleBobStylesheetLabel(stylesheetLabel === null || stylesheetLabel === void 0 ? void 0 : stylesheetLabel["left-color"], "".concat(borderObj.leftColor))
        });
    }
    if (valueExists(borderObj.rightEnable) && borderObj.rightEnable) {
        if (valueExists(borderObj.rightWidth)) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-right-width": "".concat(borderObj.rightWidth, "px")
        });
        if (valueExists(borderObj.rightStyle)) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-right-style": "".concat(borderObj.rightStyle)
        });
        if (valueExists(borderObj.rightColor) || (stylesheetLabel === null || stylesheetLabel === void 0 ? void 0 : stylesheetLabel["right-color"])) cssProperties = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cssProperties), {
            "border-right-color": handleBobStylesheetLabel(stylesheetLabel === null || stylesheetLabel === void 0 ? void 0 : stylesheetLabel["right-color"], "".concat(borderObj.rightColor))
        });
    }
    return cssProperties;
}
function borderStyleV2_mergeBob2(borderObj, defaultBorderObj) {
    var enable = get2WithNull4Enable(borderObj === null || borderObj === void 0 ? void 0 : borderObj.enable, defaultBorderObj.enable);
    var bottomEnable = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomEnable, defaultBorderObj.bottomEnable);
    var topEnable = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.topEnable, defaultBorderObj.topEnable);
    var leftEnable = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftEnable, defaultBorderObj.leftEnable);
    var rightEnable = bobUtils_get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightEnable, defaultBorderObj.rightEnable);
    return {
        enable: enable,
        bottomColor: borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomColor,
        bottomStyle: borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomStyle,
        bottomWidth: borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomWidth,
        bottomEnable: bottomEnable,
        topColor: borderObj === null || borderObj === void 0 ? void 0 : borderObj.topColor,
        topStyle: borderObj === null || borderObj === void 0 ? void 0 : borderObj.topStyle,
        topWidth: borderObj === null || borderObj === void 0 ? void 0 : borderObj.topWidth,
        topEnable: topEnable,
        leftColor: borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftColor,
        leftStyle: borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftStyle,
        leftWidth: borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftWidth,
        leftEnable: leftEnable,
        rightColor: borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightColor,
        rightStyle: borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightStyle,
        rightWidth: borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightWidth,
        rightEnable: rightEnable
    };
}
function borderStyleV2_merge2(borderObj, defaultBorderObj) {
    var bottomColor = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomColor, defaultBorderObj.bottomColor);
    var bottomStyle = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomStyle, defaultBorderObj.bottomStyle);
    var bottomWidth = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomWidth, defaultBorderObj.bottomWidth);
    var bottomEnable = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomEnable, defaultBorderObj.bottomEnable);
    var topColor = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.topColor, defaultBorderObj.topColor);
    var topStyle = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.topStyle, defaultBorderObj.topStyle);
    var topWidth = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.topWidth, defaultBorderObj.topWidth);
    var topEnable = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.topEnable, defaultBorderObj.topEnable);
    var leftColor = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftColor, defaultBorderObj.leftColor);
    var leftStyle = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftStyle, defaultBorderObj.leftStyle);
    var leftWidth = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftWidth, defaultBorderObj.leftWidth);
    var leftEnable = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftEnable, defaultBorderObj.leftEnable);
    var rightColor = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightColor, defaultBorderObj.rightColor);
    var rightStyle = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightStyle, defaultBorderObj.rightStyle);
    var rightWidth = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightWidth, defaultBorderObj.rightWidth);
    var rightEnable = get2WithNull(borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightEnable, defaultBorderObj.rightEnable);
    return {
        bottomColor: bottomColor,
        bottomStyle: bottomStyle,
        bottomWidth: bottomWidth,
        bottomEnable: bottomEnable,
        topColor: topColor,
        topStyle: topStyle,
        topWidth: topWidth,
        topEnable: topEnable,
        leftColor: leftColor,
        leftStyle: leftStyle,
        leftWidth: leftWidth,
        leftEnable: leftEnable,
        rightColor: rightColor,
        rightStyle: rightStyle,
        rightWidth: rightWidth,
        rightEnable: rightEnable
    };
}
function borderStyleV2_mergeBob3(borderObj, borderDesktopBehaviour, borderDefaultBreakpoint, defaultBorderObj) {
    var enable = get3WithNull4Enable(borderObj === null || borderObj === void 0 ? void 0 : borderObj.enable, borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.enable, borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.enable, defaultBorderObj.enable);
    var ref, ref1, ref2;
    var bottomEnable = (ref2 = (ref1 = (ref = borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomEnable) !== null && ref !== void 0 ? ref : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.bottomEnable) !== null && ref1 !== void 0 ? ref1 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.bottomEnable) !== null && ref2 !== void 0 ? ref2 : defaultBorderObj.bottomEnable;
    var ref3, ref4, ref5;
    var topEnable = (ref5 = (ref4 = (ref3 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.topEnable) !== null && ref3 !== void 0 ? ref3 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.topEnable) !== null && ref4 !== void 0 ? ref4 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.topEnable) !== null && ref5 !== void 0 ? ref5 : defaultBorderObj.topEnable;
    var ref6, ref7, ref8;
    var leftEnable = (ref8 = (ref7 = (ref6 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftEnable) !== null && ref6 !== void 0 ? ref6 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.leftEnable) !== null && ref7 !== void 0 ? ref7 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.leftEnable) !== null && ref8 !== void 0 ? ref8 : defaultBorderObj.leftEnable;
    var ref9, ref10, ref11;
    var rightEnable = (ref11 = (ref10 = (ref9 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightEnable) !== null && ref9 !== void 0 ? ref9 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.rightEnable) !== null && ref10 !== void 0 ? ref10 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.rightEnable) !== null && ref11 !== void 0 ? ref11 : defaultBorderObj.rightEnable;
    return {
        enable: enable,
        bottomColor: borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomColor,
        bottomStyle: borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomStyle,
        bottomWidth: borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomWidth,
        bottomEnable: bottomEnable,
        topColor: borderObj === null || borderObj === void 0 ? void 0 : borderObj.topColor,
        topStyle: borderObj === null || borderObj === void 0 ? void 0 : borderObj.topStyle,
        topWidth: borderObj === null || borderObj === void 0 ? void 0 : borderObj.topWidth,
        topEnable: topEnable,
        leftColor: borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftColor,
        leftStyle: borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftStyle,
        leftWidth: borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftWidth,
        leftEnable: leftEnable,
        rightColor: borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightColor,
        rightStyle: borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightStyle,
        rightWidth: borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightWidth,
        rightEnable: rightEnable
    };
}
function borderStyleV2_merge3(borderObj, borderDesktopBehaviour, borderDefaultBreakpoint, defaultBorderObj) {
    var ref, ref1, ref2;
    var bottomColor = (ref2 = (ref1 = (ref = borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomColor) !== null && ref !== void 0 ? ref : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.bottomColor) !== null && ref1 !== void 0 ? ref1 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.bottomColor) !== null && ref2 !== void 0 ? ref2 : defaultBorderObj.bottomColor;
    var ref3, ref4, ref5;
    var bottomStyle = (ref5 = (ref4 = (ref3 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomStyle) !== null && ref3 !== void 0 ? ref3 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.bottomStyle) !== null && ref4 !== void 0 ? ref4 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.bottomStyle) !== null && ref5 !== void 0 ? ref5 : defaultBorderObj.bottomStyle;
    var ref6, ref7, ref8;
    var bottomWidth = (ref8 = (ref7 = (ref6 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomWidth) !== null && ref6 !== void 0 ? ref6 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.bottomWidth) !== null && ref7 !== void 0 ? ref7 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.bottomWidth) !== null && ref8 !== void 0 ? ref8 : defaultBorderObj.bottomWidth;
    var ref9, ref10, ref11;
    var bottomEnable = (ref11 = (ref10 = (ref9 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.bottomEnable) !== null && ref9 !== void 0 ? ref9 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.bottomEnable) !== null && ref10 !== void 0 ? ref10 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.bottomEnable) !== null && ref11 !== void 0 ? ref11 : defaultBorderObj.bottomEnable;
    var ref12, ref13, ref14;
    var topColor = (ref14 = (ref13 = (ref12 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.topColor) !== null && ref12 !== void 0 ? ref12 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.topColor) !== null && ref13 !== void 0 ? ref13 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.topColor) !== null && ref14 !== void 0 ? ref14 : defaultBorderObj.topColor;
    var ref15, ref16, ref17;
    var topStyle = (ref17 = (ref16 = (ref15 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.topStyle) !== null && ref15 !== void 0 ? ref15 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.topStyle) !== null && ref16 !== void 0 ? ref16 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.topStyle) !== null && ref17 !== void 0 ? ref17 : defaultBorderObj.topStyle;
    var ref18, ref19, ref20;
    var topWidth = (ref20 = (ref19 = (ref18 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.topWidth) !== null && ref18 !== void 0 ? ref18 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.topWidth) !== null && ref19 !== void 0 ? ref19 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.topWidth) !== null && ref20 !== void 0 ? ref20 : defaultBorderObj.topWidth;
    var ref21, ref22, ref23;
    var topEnable = (ref23 = (ref22 = (ref21 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.topEnable) !== null && ref21 !== void 0 ? ref21 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.topEnable) !== null && ref22 !== void 0 ? ref22 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.topEnable) !== null && ref23 !== void 0 ? ref23 : defaultBorderObj.topEnable;
    var ref24, ref25, ref26;
    var leftColor = (ref26 = (ref25 = (ref24 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftColor) !== null && ref24 !== void 0 ? ref24 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.leftColor) !== null && ref25 !== void 0 ? ref25 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.leftColor) !== null && ref26 !== void 0 ? ref26 : defaultBorderObj.leftColor;
    var ref27, ref28, ref29;
    var leftStyle = (ref29 = (ref28 = (ref27 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftStyle) !== null && ref27 !== void 0 ? ref27 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.leftStyle) !== null && ref28 !== void 0 ? ref28 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.leftStyle) !== null && ref29 !== void 0 ? ref29 : defaultBorderObj.leftStyle;
    var ref30, ref31, ref32;
    var leftWidth = (ref32 = (ref31 = (ref30 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftWidth) !== null && ref30 !== void 0 ? ref30 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.leftWidth) !== null && ref31 !== void 0 ? ref31 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.leftWidth) !== null && ref32 !== void 0 ? ref32 : defaultBorderObj.leftWidth;
    var ref33, ref34, ref35;
    var leftEnable = (ref35 = (ref34 = (ref33 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.leftEnable) !== null && ref33 !== void 0 ? ref33 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.leftEnable) !== null && ref34 !== void 0 ? ref34 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.leftEnable) !== null && ref35 !== void 0 ? ref35 : defaultBorderObj.leftEnable;
    var ref36, ref37, ref38;
    var rightColor = (ref38 = (ref37 = (ref36 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightColor) !== null && ref36 !== void 0 ? ref36 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.rightColor) !== null && ref37 !== void 0 ? ref37 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.rightColor) !== null && ref38 !== void 0 ? ref38 : defaultBorderObj.rightColor;
    var ref39, ref40, ref41;
    var rightStyle = (ref41 = (ref40 = (ref39 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightStyle) !== null && ref39 !== void 0 ? ref39 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.rightStyle) !== null && ref40 !== void 0 ? ref40 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.rightStyle) !== null && ref41 !== void 0 ? ref41 : defaultBorderObj.rightStyle;
    var ref42, ref43, ref44;
    var rightWidth = (ref44 = (ref43 = (ref42 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightWidth) !== null && ref42 !== void 0 ? ref42 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.rightWidth) !== null && ref43 !== void 0 ? ref43 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.rightWidth) !== null && ref44 !== void 0 ? ref44 : defaultBorderObj.rightWidth;
    var ref45, ref46, ref47;
    var rightEnable = (ref47 = (ref46 = (ref45 = borderObj === null || borderObj === void 0 ? void 0 : borderObj.rightEnable) !== null && ref45 !== void 0 ? ref45 : borderDesktopBehaviour === null || borderDesktopBehaviour === void 0 ? void 0 : borderDesktopBehaviour.rightEnable) !== null && ref46 !== void 0 ? ref46 : borderDefaultBreakpoint === null || borderDefaultBreakpoint === void 0 ? void 0 : borderDefaultBreakpoint.rightEnable) !== null && ref47 !== void 0 ? ref47 : defaultBorderObj.rightEnable;
    return {
        bottomColor: bottomColor,
        bottomStyle: bottomStyle,
        bottomWidth: bottomWidth,
        bottomEnable: bottomEnable,
        topColor: topColor,
        topStyle: topStyle,
        topWidth: topWidth,
        topEnable: topEnable,
        leftColor: leftColor,
        leftStyle: leftStyle,
        leftWidth: leftWidth,
        leftEnable: leftEnable,
        rightColor: rightColor,
        rightStyle: rightStyle,
        rightWidth: rightWidth,
        rightEnable: rightEnable
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/colorsStyleV2.ts






//Temp to handle nulls
var colorsStyleV2_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
/**
 * We should only check for property and undefined
 * this solution is only until we fix the null being send around the page object
 */ // props only, no enable
var colorsStyleV2_ColorsPropsCodec = (0,es6/* type */.dt)({
    colorFirst: es6/* string */.Z_,
    colorSecond: es6/* string */.Z_,
    gradientAngle: es6/* number */.pk,
    gradientDirection: es6/* string */.Z_,
    isGradient: es6/* boolean */.O7
});
var colorsStyleV2_ColorsCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    colorsStyleV2_ColorsPropsCodec
]);
// props only, no enable
var colorsStyleV2_ColorsPropsOptCodec = (0,es6/* partial */.r$)({
    colorFirst: colorsStyleV2_nullable(es6/* string */.Z_),
    colorSecond: colorsStyleV2_nullable(es6/* string */.Z_),
    gradientAngle: colorsStyleV2_nullable(es6/* number */.pk),
    gradientDirection: colorsStyleV2_nullable(es6/* string */.Z_),
    isGradient: colorsStyleV2_nullable(es6/* boolean */.O7)
});
var colorsStyleV2_ColorsOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: colorsStyleV2_nullable(es6/* boolean */.O7)
    }),
    colorsStyleV2_ColorsPropsOptCodec
]);
var colorsStyleV2_StylesColorsCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        colors: colorsStyleV2_ColorsCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                colors: colorsStyleV2_ColorsOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                colors: colorsStyleV2_ColorsOptCodec
            })
        }),
        mobile: (0,es6/* partial */.r$)({
            colors: colorsStyleV2_ColorsOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    colors: colorsStyleV2_ColorsOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    colors: colorsStyleV2_ColorsOptCodec
                })
            })
        }),
        tablet: (0,es6/* partial */.r$)({
            colors: colorsStyleV2_ColorsOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    colors: colorsStyleV2_ColorsOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    colors: colorsStyleV2_ColorsOptCodec
                })
            })
        })
    }), 
]);
function colorsStyleV2_colorsCss(css) {
    if (css.hasOwnProperty("background-color")) return css["background-color"];
    return "";
}
function colorsStyleV2_responsiveStyle(colorsObj, desktopDefaultValues, breakpointDefaultValues) {
    var hasEnable = colorsObj.hasOwnProperty("enable");
    if (hasEnable && !objValueExists(colorsObj, "enable")) return "";
    /**
   * Check if property is available, and fallback to breakpointDefault or the desktopDefault
   */ var colorFirst = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.colorFirst) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.colorFirst);
    var colorSecond = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.colorSecond) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.colorSecond);
    var gradientAngle = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.gradientAngle) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.gradientAngle);
    // TODO: was not used in old method, why?
    // const gradientDirection =
    //   colorsObj?.gradientDirection ||
    //   breakpointDefaultValues?.gradientDirection ||
    //   desktopDefaultValues?.gradientDirection
    var isGradient = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) || (breakpointDefaultValues === null || breakpointDefaultValues === void 0 ? void 0 : breakpointDefaultValues.isGradient) || (desktopDefaultValues === null || desktopDefaultValues === void 0 ? void 0 : desktopDefaultValues.isGradient);
    // colors prop
    // TODO: old method returned {} when isGradient was disabled, shouldn't it return background-image: none ?
    if (hasEnable && !colorsObj.enable) return !isGradient ? {
        "background-color": "transparent !important"
    } : {};
    if (!isGradient) return {
        "background-color": colorFirst + " !important"
    };
    else return {
        "background-image": "linear-gradient(".concat(gradientAngle, "deg, ").concat(colorFirst, ", ").concat(colorSecond, ") !important")
    };
}
function colorsStyleV2_renderCSSString(stylesObj) {
    return "\n    ".concat(showIfWritten(stylesObj, "background-color"), " \n    ");
}
function colorsStyleV2_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var foundationStyle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : undefined, stylesheetLabel = arguments.length > 4 ? arguments[4] : void 0;
    /**
   * Colors in bobMEdia was optional in the BE, so some bobmedias didn't have colors written on the template.
   * A migration was runed to writte the colors object in all bobMedias,
   * this migration won't affect public pages until they are published again.
   * So, the codec will still break in this cases, which can haven bad effects on future logic, beware.
   */ var styles = colorsStyleV2_StylesColorsCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return colorsStyleV2_cssRender(styles.right, breakpoint, behaviourState, foundationStyle, stylesheetLabel);
    console.warn(codecUtils_decoderErrors(styles));
    return {
        "background-color": "transparent"
    };
}
// export function globalStyleCssRenderUnsafe(
//   gsObj: any,
//   breakpoint: Breakpoint,
//   behaviourState: BehaviourState_,
//   foundationStyle: FColor | undefined = undefined // TODO: Work on when foundation is added to global styles
// ): ColorsCSS | "" {
//   const gs = GSColorsCodec.decode(gsObj)
//   if (isRight(gs)) return globalStyleCssRender(gs.right, breakpoint, behaviourState, foundationStyle)
//   console.warn(decoderErrors(gs))
//   return ""
// }
function colorsStyleV2_cssRender(stylesObj, breakpoint, behaviourState, foundationStyle, stylesheetLabel) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return colorsStyleV2_renderBob(stylesObj.colors, foundationStyle, stylesheetLabel);
        } else {
            var ref, ref1;
            return colorsStyleV2_renderBobOpt(stylesObj.colors, colorsStyleV2_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.colors, stylesObj.colors), foundationStyle, stylesheetLabel);
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return colorsStyleV2_renderBobOpt(stylesObj.colors, colorsStyleV2_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.colors, stylesObj.colors), foundationStyle, stylesheetLabel);
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return colorsStyleV2_renderBobOpt(stylesObj.colors, colorsStyleV2_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.colors, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.colors, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.colors, stylesObj.colors), foundationStyle, stylesheetLabel);
        }
    }
}
// export function globalStyleCssRender(
//   stylesObj: GSColors,
//   breakpoint: Breakpoint,
//   behaviourState: BehaviourState_,
//   foundationStyle: FColor | undefined
// ): ColorsCSS {
//   if (breakpoint === "desktop") {
//     if (behaviourState === "default") {
//       return render(stylesObj, foundationStyle)
//     }
//     //hover | active
//     else {
//       return render(merge2(stylesObj?.behaviour?.[behaviourState], stylesObj), foundationStyle)
//     }
//   }
//   //tablet | mobile
//   else {
//     if (behaviourState === "default") {
//       return render(merge2(stylesObj?.[breakpoint], stylesObj), foundationStyle)
//     }
//     //hover | active
//     else {
//       return render(
//         merge3(
//           stylesObj?.[breakpoint]?.behaviour?.[behaviourState],
//           stylesObj.behaviour?.[behaviourState],
//           stylesObj?.[breakpoint],
//           stylesObj
//         ),
//         foundationStyle
//       )
//     }
//   }
// }
/**
 * Renders Colors css for desktop template
 *
 * @param colorsObj
 * @param foundationStyle
 * @returns
 */ function colorsStyleV2_renderBob(colorsObj, foundationStyle, stylesheetLabel) {
    if (colorsObj.enable === false) {
        return {};
    }
    return colorsStyleV2_render(colorsObj, foundationStyle, stylesheetLabel);
}
/**
 * Renders ColorsOpt css for breakpoints/state templates
 * or empty for non written style props
 *
 * @param colorsObj
 * @param foundationStyle
 * @returns
 */ function colorsStyleV2_renderBobOpt(defaultColorsObj, colorsObj, foundationStyle, stylesheetLabel) {
    if ((colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.enable) === false) {
        if (defaultColorsObj.enable) return {
            "background-color": "transparent"
        };
        return {};
    }
    if ((colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.enable) === true) return colorsStyleV2_renderOpt(colorsObj, foundationStyle, stylesheetLabel);
    return {};
}
/**
 * Renders Colors css for desktop template
 * Returns background color for nonGradient style
 * or background-image for gradient style
 *
 * @param colorsObj
 * @param foundationStyle
 * @returns
 */ function colorsStyleV2_render(colorsObj, foundationStyle, stylesheetLabel) {
    // single color css
    if (!colorsObj.isGradient) {
        return {
            "background-color": handleBobStylesheetLabel(stylesheetLabel === null || stylesheetLabel === void 0 ? void 0 : stylesheetLabel["color-first"], colorsObj.colorFirst)
        };
    // gradient color css
    } else {
        return {
            "background-image": "linear-gradient(".concat(colorsObj.gradientAngle, "deg, ").concat(handleBobStylesheetLabel(stylesheetLabel === null || stylesheetLabel === void 0 ? void 0 : stylesheetLabel["color-first"], colorsObj.colorFirst), ", ").concat(handleBobStylesheetLabel(stylesheetLabel === null || stylesheetLabel === void 0 ? void 0 : stylesheetLabel["color-second"], colorsObj.colorSecond), ")")
        };
    }
}
/**
 * Renders ColorsOpt css for breakpoints/state templates
 * Returns background color for nonGradient style
 * or background-image for gradient style
 * or empty for non written style props
 *
 * @param colorsObj
 * @param foundationStyle
 * @returns
 */ function colorsStyleV2_renderOpt(colorsObj, foundationStyle, stylesheetLabel) {
    // single color css
    if (!colorsObj.isGradient) {
        if (colorsObj.colorFirst || (stylesheetLabel === null || stylesheetLabel === void 0 ? void 0 : stylesheetLabel["color-first"])) return {
            "background-color": handleBobStylesheetLabel(stylesheetLabel === null || stylesheetLabel === void 0 ? void 0 : stylesheetLabel["color-first"], colorsObj.colorFirst)
        };
    // gradient color css
    } else if (utils_objValueExists(colorsObj, "gradientAngle") && (colorsObj.colorFirst || (stylesheetLabel === null || stylesheetLabel === void 0 ? void 0 : stylesheetLabel["color-first"])) && (colorsObj.colorSecond || (stylesheetLabel === null || stylesheetLabel === void 0 ? void 0 : stylesheetLabel["color-first"]))) {
        return {
            "background-image": "linear-gradient(".concat(colorsObj.gradientAngle, "deg, ").concat(handleBobStylesheetLabel(stylesheetLabel === null || stylesheetLabel === void 0 ? void 0 : stylesheetLabel["color-first"], colorsObj.colorFirst), ", ").concat(handleBobStylesheetLabel(stylesheetLabel === null || stylesheetLabel === void 0 ? void 0 : stylesheetLabel["color-second"], colorsObj.colorSecond), ")")
        };
    }
    // no written style props
    return {};
}
/**
 * Fallback templateObj values to defaultObj value when needed
 * used for breakpoints/states(default) templates
 *
 * For values that are not written on the templateObj and are interpreted as css,
 * the fallback value shouldn't be used as the browser deals with the fallback by itself
 *
 * For values that are not interpreted as css, like isGradient, the fallback must be allways used when needed,
 * as this value will not be dealt by the browser
 *
 * For values that are needed together for a single css property,
 * if one of those values is written on the templateObj the other values must use the fallback value when needed
 *
 * @param colorsObj
 * @param defaultColorsObj
 * @returns Colors
 *
 */ function colorsStyleV2_mergeBob2(colorsObj, defaultColorsObj) {
    var fallbackTemplate = {
        enable: bobUtils_get2WithNull(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.enable, defaultColorsObj.enable),
        isGradient: bobUtils_get2WithNull(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient, defaultColorsObj.isGradient),
        colorFirst: bobUtils_get2WithNull(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst, defaultColorsObj.colorFirst),
        colorSecond: bobUtils_get2WithNull(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond, defaultColorsObj.colorSecond),
        gradientAngle: bobUtils_get2WithNull(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle, defaultColorsObj.gradientAngle),
        gradientDirection: bobUtils_get2WithNull(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientDirection, defaultColorsObj.gradientDirection)
    };
    var isGradientValueWritten = colorsStyleV2_handleGradientValueWritten(fallbackTemplate);
    // return fallback for gradient values when at least one exists
    if (isGradientValueWritten) return fallbackTemplate;
    return {
        enable: fallbackTemplate.enable,
        isGradient: fallbackTemplate.isGradient,
        colorFirst: colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst,
        colorSecond: colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond,
        gradientAngle: colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle,
        gradientDirection: colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientDirection
    };
}
/**
 * Fallback templateObj values to defaultObj value when needed
 * used for globalstyles breakpoints/states(default) templates
 *
 * For values that are not written on the templateObj and are interpreted as css,
 * the fallback value shouldn't be used as the browser deals with the fallback by itself
 *
 * For values that are not interpreted as css, like isGradient, the fallback must be allways used when needed,
 * as this value will not be dealt by the browser
 *
 * For values that are needed together for a single css property,
 * if one of those values is written on the templateObj the other values must use the fallback value when needed
 *
 * @param colorsObj
 * @param defaultColorsObj
 * @returns ColorsProps
 *
 */ function colorsStyleV2_merge2(colorsObj, defaultColorsObj) {
    var isGradientValueWritten = colorsStyleV2_handleGradientValueWritten(colorsObj);
    var isGradient = get2WithNull(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient, defaultColorsObj.isGradient);
    var colorFirst = get2WithNullConditional(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst, defaultColorsObj.colorFirst, (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten);
    var colorSecond = get2WithNullConditional(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond, defaultColorsObj.colorSecond, (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten);
    var gradientAngle = get2WithNullConditional(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle, defaultColorsObj.gradientAngle, (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten);
    var gradientDirection = get2WithNullConditional(colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientDirection, defaultColorsObj.gradientDirection, (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten);
    return {
        colorFirst: colorFirst,
        colorSecond: colorSecond,
        gradientAngle: gradientAngle,
        gradientDirection: gradientDirection,
        isGradient: isGradient
    };
}
/**
 * Fallback templateObj values to defaultObj value when needed
 * used for states inside breakpoints templates
 *
 * For values that are not written on the templateObj and are interpreted as css,
 * the fallback value shouldn't be used as the browser deals with the fallback by itself
 *
 * For values that are not interpreted as css, like isGradient, the fallback must be allways used when needed,
 * as this value will not be dealt by the browser
 *
 * For values that are needed together for a single css property,
 * if one of those values is written on the templateObj the other values must use the fallback value when needed
 *
 * @param colorsObj
 * @param colorsDefaultBreakpoint
 * @param defaultColorsObj
 * @returns Colors
 */ function colorsStyleV2_mergeBob3(colorsObj, colorsDesktopBehaviour, colorsDefaultBreakpoint, defaultColorsObj) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    var fallbackTemplate = {
        enable: (ref2 = (ref1 = (ref = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.enable) !== null && ref !== void 0 ? ref : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.enable) !== null && ref1 !== void 0 ? ref1 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.enable) !== null && ref2 !== void 0 ? ref2 : defaultColorsObj.enable,
        isGradient: (ref5 = (ref4 = (ref3 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) !== null && ref3 !== void 0 ? ref3 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.isGradient) !== null && ref4 !== void 0 ? ref4 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.isGradient) !== null && ref5 !== void 0 ? ref5 : defaultColorsObj.isGradient,
        colorFirst: (ref8 = (ref7 = (ref6 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst) !== null && ref6 !== void 0 ? ref6 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.colorFirst) !== null && ref7 !== void 0 ? ref7 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.colorFirst) !== null && ref8 !== void 0 ? ref8 : defaultColorsObj.colorFirst,
        colorSecond: (ref11 = (ref10 = (ref9 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond) !== null && ref9 !== void 0 ? ref9 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.colorSecond) !== null && ref10 !== void 0 ? ref10 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.colorSecond) !== null && ref11 !== void 0 ? ref11 : defaultColorsObj.colorSecond,
        gradientAngle: (ref14 = (ref13 = (ref12 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle) !== null && ref12 !== void 0 ? ref12 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.gradientAngle) !== null && ref13 !== void 0 ? ref13 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.gradientAngle) !== null && ref14 !== void 0 ? ref14 : defaultColorsObj.gradientAngle,
        gradientDirection: (ref17 = (ref16 = (ref15 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientDirection) !== null && ref15 !== void 0 ? ref15 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.gradientDirection) !== null && ref16 !== void 0 ? ref16 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.gradientDirection) !== null && ref17 !== void 0 ? ref17 : defaultColorsObj.gradientDirection
    };
    var isGradientValueWritten = colorsStyleV2_handleGradientValueWritten(fallbackTemplate);
    // return fallback for gradient values when at least one exists
    if (isGradientValueWritten) return fallbackTemplate;
    return {
        enable: fallbackTemplate.enable,
        isGradient: fallbackTemplate.isGradient,
        colorFirst: colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst,
        colorSecond: colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond,
        gradientAngle: colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle,
        gradientDirection: colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientDirection
    };
}
/**
 * Fallback templateObj values to defaultObj value when needed
 * used for globalstyles states inside breakpoints templates
 *
 * For values that are not written on the templateObj and are interpreted as css,
 * the fallback value shouldn't be used as the browser deals with the fallback by itself
 *
 * For values that are not interpreted as css, like isGradient, the fallback must be allways used when needed,
 * as this value will not be dealt by the browser
 *
 * @param colorsObj
 * @param colorsDefaultBreakpoint
 * @param defaultColorsObj
 * @returns Colors
 */ function colorsStyleV2_merge3(colorsObj, colorsDesktopBehaviour, colorsDefaultBreakpoint, defaultColorsObj) {
    var isGradientValueWritten = colorsStyleV2_handleGradientValueWritten(colorsObj);
    var ref, ref1, ref2;
    var isGradient = (ref2 = (ref1 = (ref = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) !== null && ref !== void 0 ? ref : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.isGradient) !== null && ref1 !== void 0 ? ref1 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.isGradient) !== null && ref2 !== void 0 ? ref2 : defaultColorsObj.isGradient;
    var ref3, ref4, ref5;
    var colorFirst = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten ? (ref5 = (ref4 = (ref3 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst) !== null && ref3 !== void 0 ? ref3 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.colorFirst) !== null && ref4 !== void 0 ? ref4 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.colorFirst) !== null && ref5 !== void 0 ? ref5 : defaultColorsObj.colorFirst : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst;
    var ref6, ref7, ref8;
    var colorSecond = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten ? (ref8 = (ref7 = (ref6 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond) !== null && ref6 !== void 0 ? ref6 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.colorSecond) !== null && ref7 !== void 0 ? ref7 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.colorSecond) !== null && ref8 !== void 0 ? ref8 : defaultColorsObj.colorSecond : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond;
    var ref9, ref10, ref11;
    var gradientAngle = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten ? (ref11 = (ref10 = (ref9 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle) !== null && ref9 !== void 0 ? ref9 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.gradientAngle) !== null && ref10 !== void 0 ? ref10 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.gradientAngle) !== null && ref11 !== void 0 ? ref11 : defaultColorsObj.gradientAngle : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle;
    var ref12, ref13, ref14;
    var gradientDirection = (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) === true && isGradientValueWritten ? (ref14 = (ref13 = (ref12 = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientDirection) !== null && ref12 !== void 0 ? ref12 : colorsDesktopBehaviour === null || colorsDesktopBehaviour === void 0 ? void 0 : colorsDesktopBehaviour.gradientDirection) !== null && ref13 !== void 0 ? ref13 : colorsDefaultBreakpoint === null || colorsDefaultBreakpoint === void 0 ? void 0 : colorsDefaultBreakpoint.gradientDirection) !== null && ref14 !== void 0 ? ref14 : defaultColorsObj.gradientDirection : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientDirection;
    return {
        colorFirst: colorFirst,
        colorSecond: colorSecond,
        gradientAngle: gradientAngle,
        gradientDirection: gradientDirection,
        isGradient: isGradient
    };
}
/**
 * Checks if at least one gradient needed value is written
 *
 * @param colorsObj
 * @returns
 */ function colorsStyleV2_handleGradientValueWritten(colorsObj) {
    var ref, ref1, ref2;
    return (colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.isGradient) && ((ref2 = (ref1 = (ref = colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorFirst) !== null && ref !== void 0 ? ref : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.colorSecond) !== null && ref1 !== void 0 ? ref1 : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientAngle) !== null && ref2 !== void 0 ? ref2 : colorsObj === null || colorsObj === void 0 ? void 0 : colorsObj.gradientDirection) ? true : false;
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/backgroundImageStyleV2.ts







//Temp to handle nulls
var backgroundImageStyleV2_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
/**
 * We should only check for property and undefined
 * this solution is only until we fix the null being send around the page object
 */ var AttachmentCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("fixed"),
    (0,es6/* literal */.i0)("scroll")
]);
// props only, no enable
var backgroundImageStyleV2_BackgroundImagePropsCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        position: es6/* string */.Z_,
        repeat: es6/* string */.Z_,
        size: es6/* string */.Z_
    }),
    (0,es6/* partial */.r$)({
        attachment: AttachmentCodec
    }), 
]);
var backgroundImageStyleV2_BackgroundImageCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    backgroundImageStyleV2_BackgroundImagePropsCodec
]);
// props only, no enable
var backgroundImageStyleV2_BackgroundImagePropsOptCodec = (0,es6/* partial */.r$)({
    position: backgroundImageStyleV2_nullable(es6/* string */.Z_),
    repeat: backgroundImageStyleV2_nullable(es6/* string */.Z_),
    size: backgroundImageStyleV2_nullable(es6/* string */.Z_),
    attachment: backgroundImageStyleV2_nullable(AttachmentCodec)
});
var backgroundImageStyleV2_BackgroundImageOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: backgroundImageStyleV2_nullable(es6/* boolean */.O7)
    }),
    backgroundImageStyleV2_BackgroundImagePropsOptCodec
]);
var backgroundImageStyleV2_StylesBackgroundImageCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        image: backgroundImageStyleV2_BackgroundImageCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                image: backgroundImageStyleV2_BackgroundImageOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                image: backgroundImageStyleV2_BackgroundImageOptCodec
            })
        }),
        mobile: (0,es6/* partial */.r$)({
            image: backgroundImageStyleV2_BackgroundImageOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    image: backgroundImageStyleV2_BackgroundImageOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    image: backgroundImageStyleV2_BackgroundImageOptCodec
                })
            })
        }),
        tablet: (0,es6/* partial */.r$)({
            image: backgroundImageStyleV2_BackgroundImageOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    image: backgroundImageStyleV2_BackgroundImageOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    image: backgroundImageStyleV2_BackgroundImageOptCodec
                })
            })
        })
    }), 
]);
function backgroundImageStyleV2_cssRenderUnsafe(stylesObj, breakpoint, behaviourState, imageSrc) {
    var foundationStyle = arguments.length > 4 && arguments[4] !== void 0 // TODO: fix when working on other bobs
     ? arguments[4] : undefined;
    var styles = backgroundImageStyleV2_StylesBackgroundImageCodec.decode(stylesObj);
    // TODO: should use codec from colors?
    if ((0,Either/* isRight */.tO)(styles)) return backgroundImageStyleV2_cssRender(styles.right, breakpoint, behaviourState, imageSrc, foundationStyle);
    console.warn(codecUtils_decoderErrors(styles));
    return {
        "background-position": "0% 0%",
        "background-repeat": "repeat",
        "background-size": "contain",
        "background-image": "transparent",
        "background-attachment": "scroll"
    };
}
function backgroundImageStyleV2_cssRender(stylesObj, breakpoint, behaviourState, imageSrc, foundationStyle) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return backgroundImageStyleV2_renderBob(stylesObj.image, imageSrc, foundationStyle);
        } else {
            var ref, ref1;
            return backgroundImageStyleV2_renderBobOpt(stylesObj.image, backgroundImageStyleV2_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.image, stylesObj.image), imageSrc, foundationStyle);
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return backgroundImageStyleV2_renderBobOpt(stylesObj.image, backgroundImageStyleV2_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.image, stylesObj.image), imageSrc, foundationStyle);
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return backgroundImageStyleV2_renderBobOpt(stylesObj.image, backgroundImageStyleV2_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.image, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.image, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.image, stylesObj.image), imageSrc, foundationStyle);
        }
    }
}
function backgroundImageStyleV2_renderBob(imageObj, imageSrc, foundationStyle) {
    if (!imageObj.enable) return {};
    return backgroundImageStyleV2_render(imageObj, imageSrc, foundationStyle);
}
function backgroundImageStyleV2_renderBobOpt(defaultImageObj, imageObj, imageSrc, foundationStyle) {
    if ((imageObj === null || imageObj === void 0 ? void 0 : imageObj.enable) === false) {
        if (defaultImageObj.enable) return {
            "background-image": "none"
        };
        return {};
    }
    if (imageObj === null || imageObj === void 0 ? void 0 : imageObj.enable) return backgroundImageStyleV2_renderOpt(imageObj, imageSrc, foundationStyle);
    return {};
}
function backgroundImageStyleV2_render(imageObj, imageSrc, foundationStyle) {
    var bgAttach = imageObj.attachment ? {
        "background-attachment": imageObj.attachment
    } : {};
    return (0,src_object_spread/* default */.Z)({
        "background-size": "".concat(imageObj.size),
        "background-repeat": "".concat(imageObj.repeat),
        "background-position": "".concat(imageObj.position),
        "background-image": "url(".concat(imageSrc, ")")
    }, bgAttach);
}
function backgroundImageStyleV2_renderOpt(imageObj, imageSrc, foundationStyle) {
    var css = {};
    if (valueExists(imageObj === null || imageObj === void 0 ? void 0 : imageObj.size)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "background-size": "".concat(imageObj === null || imageObj === void 0 ? void 0 : imageObj.size)
    });
    if (valueExists(imageObj === null || imageObj === void 0 ? void 0 : imageObj.repeat)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "background-repeat": "".concat(imageObj === null || imageObj === void 0 ? void 0 : imageObj.repeat)
    });
    if (valueExists(imageObj === null || imageObj === void 0 ? void 0 : imageObj.position)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "background-position": imageObj === null || imageObj === void 0 ? void 0 : imageObj.position
    });
    if (valueExists(imageSrc)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "background-image": "url(".concat(imageSrc, ")")
    });
    if (valueExists(imageObj === null || imageObj === void 0 ? void 0 : imageObj.attachment)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "background-attachment": "".concat(imageObj === null || imageObj === void 0 ? void 0 : imageObj.attachment)
    });
    return css;
}
/**
 *
 * @param imageObj
 * @param defaultBackgroundImageObj
 * @returns BackgroundImage
 *
 */ function backgroundImageStyleV2_mergeBob2(imageObj, defaultBackgroundImageObj) {
    var enable = bobUtils_get2WithNull(imageObj === null || imageObj === void 0 ? void 0 : imageObj.enable, defaultBackgroundImageObj.enable);
    return {
        enable: enable,
        position: imageObj === null || imageObj === void 0 ? void 0 : imageObj.position,
        repeat: imageObj === null || imageObj === void 0 ? void 0 : imageObj.repeat,
        size: imageObj === null || imageObj === void 0 ? void 0 : imageObj.size,
        attachment: imageObj === null || imageObj === void 0 ? void 0 : imageObj.attachment
    };
}
/**
 *
 * @param imageObj
 * @param imageDefaultBreakpoint
 * @param defaultBackgroundImageObj
 * @returns BackgroundImage
 */ function backgroundImageStyleV2_mergeBob3(imageObj, imageDesktopBehaviour, imageDefaultBreakpoint, defaultBackgroundImageObj) {
    var ref, ref1, ref2;
    var enable = (ref2 = (ref1 = (ref = imageObj === null || imageObj === void 0 ? void 0 : imageObj.enable) !== null && ref !== void 0 ? ref : imageDesktopBehaviour === null || imageDesktopBehaviour === void 0 ? void 0 : imageDesktopBehaviour.enable) !== null && ref1 !== void 0 ? ref1 : imageDefaultBreakpoint === null || imageDefaultBreakpoint === void 0 ? void 0 : imageDefaultBreakpoint.enable) !== null && ref2 !== void 0 ? ref2 : defaultBackgroundImageObj.enable;
    return {
        enable: enable,
        position: imageObj === null || imageObj === void 0 ? void 0 : imageObj.position,
        repeat: imageObj === null || imageObj === void 0 ? void 0 : imageObj.repeat,
        size: imageObj === null || imageObj === void 0 ? void 0 : imageObj.size,
        attachment: imageObj === null || imageObj === void 0 ? void 0 : imageObj.attachment
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/positionStyle.ts







var positionStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
var positionStyle_UnitCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("px"),
    (0,es6/* literal */.i0)("%"),
    (0,es6/* literal */.i0)("vh"),
    (0,es6/* literal */.i0)("auto")
]);
var ValueCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("relative"),
    (0,es6/* literal */.i0)("static"),
    (0,es6/* literal */.i0)("absolute"),
    (0,es6/* literal */.i0)("fixed"),
    (0,es6/* literal */.i0)("sticky"), 
]);
var SideCodec = (0,es6/* type */.dt)({
    value: es6/* number */.pk,
    unit: positionStyle_UnitCodec
});
var PositionCodec = (0,es6/* type */.dt)({
    value: ValueCodec,
    top: SideCodec,
    bottom: SideCodec,
    left: SideCodec,
    right: SideCodec
});
var SideOptCodec = (0,es6/* partial */.r$)({
    value: positionStyle_nullable(es6/* number */.pk),
    unit: positionStyle_nullable(positionStyle_UnitCodec)
});
var PositionOptCodec = (0,es6/* partial */.r$)({
    value: positionStyle_nullable(ValueCodec),
    top: positionStyle_nullable(SideOptCodec),
    bottom: positionStyle_nullable(SideOptCodec),
    left: positionStyle_nullable(SideOptCodec),
    right: positionStyle_nullable(SideOptCodec)
});
var StylesPositionCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        position: PositionCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                position: PositionOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                position: PositionOptCodec
            })
        }),
        mobile: (0,es6/* partial */.r$)({
            position: PositionOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    position: PositionOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    position: PositionOptCodec
                })
            })
        }),
        tablet: (0,es6/* partial */.r$)({
            position: PositionOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    position: PositionOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    position: PositionOptCodec
                })
            })
        })
    }), 
]);
var DefaultPositionCSS = {
    position: "initial",
    top: "initial",
    left: "initial",
    right: "initial",
    bottom: "initial"
};
function positionStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var styles = StylesPositionCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return positionStyle_cssRender(styles.right, breakpoint, behaviourState);
    console.warn(codecUtils_decoderErrors(styles));
    return DefaultPositionCSS;
}
function positionStyle_cssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return positionStyle_render(stylesObj.position);
        } else {
            var ref, ref1;
            return positionStyle_renderBobOpt(stylesObj.position, positionStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.position, stylesObj.position));
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return positionStyle_renderBobOpt(stylesObj.position, positionStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.position, stylesObj.position));
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return positionStyle_renderBobOpt(stylesObj.position, positionStyle_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.position, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.position, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.position, stylesObj.position));
        }
    }
}
function positionStyle_render(positionObj) {
    return {
        position: positionObj.value,
        top: "".concat(positionStyle_isNumberOrAuto(positionObj.top.value, positionObj.top.unit)),
        bottom: "".concat(positionStyle_isNumberOrAuto(positionObj.bottom.value, positionObj.bottom.unit)),
        left: "".concat(positionStyle_isNumberOrAuto(positionObj.left.value, positionObj.left.unit)),
        right: "".concat(positionStyle_isNumberOrAuto(positionObj.right.value, positionObj.right.unit))
    };
}
/**
 * Renders ColorsOpt css for breakpoints/state templates
 * or empty for non written style props
 *
 * @param positionValue
 * @param foundationStyle
 * @returns
 */ function positionStyle_renderBobOpt(defaultSelfPositionObj, positionValue) {
    if (positionValue) {
        return positionStyle_renderOpt(defaultSelfPositionObj, positionValue);
    }
    return {};
}
/**
 * Renders PositionOpt css for breakpoints/state templates
 * Returns position
 * or empty for non written style props
 *
 * @param positionValue
 * @param foundationStyle
 * @returns
 */ function positionStyle_renderOpt(defaultSelfPositionObj, positionValue) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var css = {};
    if (valueExists(positionValue === null || positionValue === void 0 ? void 0 : positionValue.value)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        position: "".concat(positionValue === null || positionValue === void 0 ? void 0 : positionValue.value)
    });
    if (valueExists(positionValue === null || positionValue === void 0 ? void 0 : (ref = positionValue.top) === null || ref === void 0 ? void 0 : ref.value) || valueExists(positionValue === null || positionValue === void 0 ? void 0 : (ref1 = positionValue.top) === null || ref1 === void 0 ? void 0 : ref1.unit)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        top: "".concat(positionStyle_isNumberOrAuto(positionValue === null || positionValue === void 0 ? void 0 : (ref2 = positionValue.top) === null || ref2 === void 0 ? void 0 : ref2.value, positionValue === null || positionValue === void 0 ? void 0 : (ref3 = positionValue.top) === null || ref3 === void 0 ? void 0 : ref3.unit))
    });
    if (valueExists(positionValue === null || positionValue === void 0 ? void 0 : (ref4 = positionValue.bottom) === null || ref4 === void 0 ? void 0 : ref4.value) || valueExists(positionValue === null || positionValue === void 0 ? void 0 : (ref5 = positionValue.bottom) === null || ref5 === void 0 ? void 0 : ref5.unit)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        bottom: "".concat(positionStyle_isNumberOrAuto(positionValue === null || positionValue === void 0 ? void 0 : (ref6 = positionValue.bottom) === null || ref6 === void 0 ? void 0 : ref6.value, positionValue === null || positionValue === void 0 ? void 0 : (ref7 = positionValue.bottom) === null || ref7 === void 0 ? void 0 : ref7.unit))
    });
    if (valueExists(positionValue === null || positionValue === void 0 ? void 0 : (ref8 = positionValue.left) === null || ref8 === void 0 ? void 0 : ref8.value) || valueExists(positionValue === null || positionValue === void 0 ? void 0 : (ref9 = positionValue.left) === null || ref9 === void 0 ? void 0 : ref9.unit)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        left: "".concat(positionStyle_isNumberOrAuto(positionValue === null || positionValue === void 0 ? void 0 : (ref10 = positionValue.left) === null || ref10 === void 0 ? void 0 : ref10.value, positionValue === null || positionValue === void 0 ? void 0 : (ref11 = positionValue.left) === null || ref11 === void 0 ? void 0 : ref11.unit))
    });
    if (valueExists(positionValue === null || positionValue === void 0 ? void 0 : (ref12 = positionValue.right) === null || ref12 === void 0 ? void 0 : ref12.value) || valueExists(positionValue === null || positionValue === void 0 ? void 0 : (ref13 = positionValue.right) === null || ref13 === void 0 ? void 0 : ref13.unit)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        right: "".concat(positionStyle_isNumberOrAuto(positionValue === null || positionValue === void 0 ? void 0 : (ref14 = positionValue.right) === null || ref14 === void 0 ? void 0 : ref14.value, positionValue === null || positionValue === void 0 ? void 0 : (ref15 = positionValue.right) === null || ref15 === void 0 ? void 0 : ref15.unit))
    });
    return css;
}
function positionStyle_mergeBob2(positionObj, defaultPositionObj) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    if (!positionObj) {
        return {
            value: undefined,
            top: undefined,
            bottom: undefined,
            left: undefined,
            right: undefined
        };
    }
    var position = {
        value: positionObj === null || positionObj === void 0 ? void 0 : positionObj.value,
        top: {
            value: positionObj === null || positionObj === void 0 ? void 0 : (ref = positionObj.top) === null || ref === void 0 ? void 0 : ref.value,
            unit: positionObj === null || positionObj === void 0 ? void 0 : (ref1 = positionObj.top) === null || ref1 === void 0 ? void 0 : ref1.unit
        },
        bottom: {
            value: positionObj === null || positionObj === void 0 ? void 0 : (ref2 = positionObj.bottom) === null || ref2 === void 0 ? void 0 : ref2.value,
            unit: positionObj === null || positionObj === void 0 ? void 0 : (ref3 = positionObj.bottom) === null || ref3 === void 0 ? void 0 : ref3.unit
        },
        left: {
            value: positionObj === null || positionObj === void 0 ? void 0 : (ref4 = positionObj.left) === null || ref4 === void 0 ? void 0 : ref4.value,
            unit: positionObj === null || positionObj === void 0 ? void 0 : (ref5 = positionObj.left) === null || ref5 === void 0 ? void 0 : ref5.unit
        },
        right: {
            value: positionObj === null || positionObj === void 0 ? void 0 : (ref6 = positionObj.right) === null || ref6 === void 0 ? void 0 : ref6.value,
            unit: positionObj === null || positionObj === void 0 ? void 0 : (ref7 = positionObj.right) === null || ref7 === void 0 ? void 0 : ref7.unit
        }
    };
    if (valueExists(positionObj === null || positionObj === void 0 ? void 0 : (ref8 = positionObj.top) === null || ref8 === void 0 ? void 0 : ref8.value) || valueExists(positionObj === null || positionObj === void 0 ? void 0 : (ref9 = positionObj.top) === null || ref9 === void 0 ? void 0 : ref9.unit)) {
        var ref16, ref17;
        var topValue = bobUtils_get2WithNull(positionObj === null || positionObj === void 0 ? void 0 : (ref16 = positionObj.top) === null || ref16 === void 0 ? void 0 : ref16.value, defaultPositionObj.top.value);
        var topUnit = bobUtils_get2WithNull(positionObj === null || positionObj === void 0 ? void 0 : (ref17 = positionObj.top) === null || ref17 === void 0 ? void 0 : ref17.unit, defaultPositionObj.top.unit);
        position.top = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, position.top), {
            value: topValue,
            unit: topUnit
        });
    }
    if (valueExists(positionObj === null || positionObj === void 0 ? void 0 : (ref10 = positionObj.bottom) === null || ref10 === void 0 ? void 0 : ref10.value) || valueExists(positionObj === null || positionObj === void 0 ? void 0 : (ref11 = positionObj.bottom) === null || ref11 === void 0 ? void 0 : ref11.unit)) {
        var ref18, ref19;
        var bottomValue = bobUtils_get2WithNull(positionObj === null || positionObj === void 0 ? void 0 : (ref18 = positionObj.bottom) === null || ref18 === void 0 ? void 0 : ref18.value, defaultPositionObj.bottom.value);
        var bottomUnit = bobUtils_get2WithNull(positionObj === null || positionObj === void 0 ? void 0 : (ref19 = positionObj.bottom) === null || ref19 === void 0 ? void 0 : ref19.unit, defaultPositionObj.bottom.unit);
        position.bottom = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, position.bottom), {
            value: bottomValue,
            unit: bottomUnit
        });
    }
    if (valueExists(positionObj === null || positionObj === void 0 ? void 0 : (ref12 = positionObj.left) === null || ref12 === void 0 ? void 0 : ref12.value) || valueExists(positionObj === null || positionObj === void 0 ? void 0 : (ref13 = positionObj.left) === null || ref13 === void 0 ? void 0 : ref13.unit)) {
        var ref20, ref21;
        var leftValue = bobUtils_get2WithNull(positionObj === null || positionObj === void 0 ? void 0 : (ref20 = positionObj.left) === null || ref20 === void 0 ? void 0 : ref20.value, defaultPositionObj.left.value);
        var leftUnit = bobUtils_get2WithNull(positionObj === null || positionObj === void 0 ? void 0 : (ref21 = positionObj.left) === null || ref21 === void 0 ? void 0 : ref21.unit, defaultPositionObj.left.unit);
        position.left = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, position.left), {
            value: leftValue,
            unit: leftUnit
        });
    }
    if (valueExists(positionObj === null || positionObj === void 0 ? void 0 : (ref14 = positionObj.right) === null || ref14 === void 0 ? void 0 : ref14.value) || valueExists(positionObj === null || positionObj === void 0 ? void 0 : (ref15 = positionObj.right) === null || ref15 === void 0 ? void 0 : ref15.unit)) {
        var ref22, ref23;
        var rightValue = bobUtils_get2WithNull(positionObj === null || positionObj === void 0 ? void 0 : (ref22 = positionObj.right) === null || ref22 === void 0 ? void 0 : ref22.value, defaultPositionObj.right.value);
        var rightUnit = bobUtils_get2WithNull(positionObj === null || positionObj === void 0 ? void 0 : (ref23 = positionObj.right) === null || ref23 === void 0 ? void 0 : ref23.unit, defaultPositionObj.right.unit);
        position.right = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, position.right), {
            value: rightValue,
            unit: rightUnit
        });
    }
    return position;
}
function positionStyle_mergeBob3(positionObj, positionDesktopBehaviour, positionDefaultBreakpoint, defaultPositionObj) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    if (!positionObj) {
        return {
            value: undefined,
            top: undefined,
            bottom: undefined,
            left: undefined,
            right: undefined
        };
    }
    var topValue = positionObj === null || positionObj === void 0 ? void 0 : (ref = positionObj.top) === null || ref === void 0 ? void 0 : ref.value;
    var topUnit = positionObj === null || positionObj === void 0 ? void 0 : (ref1 = positionObj.top) === null || ref1 === void 0 ? void 0 : ref1.unit;
    var bottomValue = positionObj === null || positionObj === void 0 ? void 0 : (ref2 = positionObj.bottom) === null || ref2 === void 0 ? void 0 : ref2.value;
    var bottomUnit = positionObj === null || positionObj === void 0 ? void 0 : (ref3 = positionObj.bottom) === null || ref3 === void 0 ? void 0 : ref3.unit;
    var leftValue = positionObj === null || positionObj === void 0 ? void 0 : (ref4 = positionObj.left) === null || ref4 === void 0 ? void 0 : ref4.value;
    var leftUnit = positionObj === null || positionObj === void 0 ? void 0 : (ref5 = positionObj.left) === null || ref5 === void 0 ? void 0 : ref5.unit;
    var rightValue = positionObj === null || positionObj === void 0 ? void 0 : (ref6 = positionObj.right) === null || ref6 === void 0 ? void 0 : ref6.value;
    var rightUnit = positionObj === null || positionObj === void 0 ? void 0 : (ref7 = positionObj.right) === null || ref7 === void 0 ? void 0 : ref7.unit;
    if (valueExists(positionObj === null || positionObj === void 0 ? void 0 : (ref8 = positionObj.top) === null || ref8 === void 0 ? void 0 : ref8.value) || valueExists(positionObj === null || positionObj === void 0 ? void 0 : (ref9 = positionObj.top) === null || ref9 === void 0 ? void 0 : ref9.unit)) {
        var ref16, ref17, ref18, ref19, ref20, ref21;
        var ref22, ref23, ref24;
        topValue = (ref24 = (ref23 = (ref22 = positionObj === null || positionObj === void 0 ? void 0 : (ref16 = positionObj.top) === null || ref16 === void 0 ? void 0 : ref16.value) !== null && ref22 !== void 0 ? ref22 : positionDesktopBehaviour === null || positionDesktopBehaviour === void 0 ? void 0 : (ref17 = positionDesktopBehaviour.top) === null || ref17 === void 0 ? void 0 : ref17.value) !== null && ref23 !== void 0 ? ref23 : positionDefaultBreakpoint === null || positionDefaultBreakpoint === void 0 ? void 0 : (ref18 = positionDefaultBreakpoint.top) === null || ref18 === void 0 ? void 0 : ref18.value) !== null && ref24 !== void 0 ? ref24 : defaultPositionObj.top.value;
        var ref25, ref26, ref27;
        topUnit = (ref27 = (ref26 = (ref25 = positionObj === null || positionObj === void 0 ? void 0 : (ref19 = positionObj.top) === null || ref19 === void 0 ? void 0 : ref19.unit) !== null && ref25 !== void 0 ? ref25 : positionDesktopBehaviour === null || positionDesktopBehaviour === void 0 ? void 0 : (ref20 = positionDesktopBehaviour.top) === null || ref20 === void 0 ? void 0 : ref20.unit) !== null && ref26 !== void 0 ? ref26 : positionDefaultBreakpoint === null || positionDefaultBreakpoint === void 0 ? void 0 : (ref21 = positionDefaultBreakpoint.top) === null || ref21 === void 0 ? void 0 : ref21.unit) !== null && ref27 !== void 0 ? ref27 : defaultPositionObj.top.unit;
    }
    if (valueExists(positionObj === null || positionObj === void 0 ? void 0 : (ref10 = positionObj.bottom) === null || ref10 === void 0 ? void 0 : ref10.value) || valueExists(positionObj === null || positionObj === void 0 ? void 0 : (ref11 = positionObj.bottom) === null || ref11 === void 0 ? void 0 : ref11.unit)) {
        var ref28, ref29, ref30, ref31, ref32, ref33;
        var ref34, ref35, ref36;
        bottomValue = (ref36 = (ref35 = (ref34 = positionObj === null || positionObj === void 0 ? void 0 : (ref28 = positionObj.bottom) === null || ref28 === void 0 ? void 0 : ref28.value) !== null && ref34 !== void 0 ? ref34 : positionDesktopBehaviour === null || positionDesktopBehaviour === void 0 ? void 0 : (ref29 = positionDesktopBehaviour.bottom) === null || ref29 === void 0 ? void 0 : ref29.value) !== null && ref35 !== void 0 ? ref35 : positionDefaultBreakpoint === null || positionDefaultBreakpoint === void 0 ? void 0 : (ref30 = positionDefaultBreakpoint.bottom) === null || ref30 === void 0 ? void 0 : ref30.value) !== null && ref36 !== void 0 ? ref36 : defaultPositionObj.bottom.value;
        var ref37, ref38, ref39;
        bottomUnit = (ref39 = (ref38 = (ref37 = positionObj === null || positionObj === void 0 ? void 0 : (ref31 = positionObj.bottom) === null || ref31 === void 0 ? void 0 : ref31.unit) !== null && ref37 !== void 0 ? ref37 : positionDesktopBehaviour === null || positionDesktopBehaviour === void 0 ? void 0 : (ref32 = positionDesktopBehaviour.bottom) === null || ref32 === void 0 ? void 0 : ref32.unit) !== null && ref38 !== void 0 ? ref38 : positionDefaultBreakpoint === null || positionDefaultBreakpoint === void 0 ? void 0 : (ref33 = positionDefaultBreakpoint.bottom) === null || ref33 === void 0 ? void 0 : ref33.unit) !== null && ref39 !== void 0 ? ref39 : defaultPositionObj.bottom.unit;
    }
    if (valueExists(positionObj === null || positionObj === void 0 ? void 0 : (ref12 = positionObj.right) === null || ref12 === void 0 ? void 0 : ref12.value) || valueExists(positionObj === null || positionObj === void 0 ? void 0 : (ref13 = positionObj.right) === null || ref13 === void 0 ? void 0 : ref13.unit)) {
        var ref40, ref41, ref42, ref43, ref44, ref45;
        var ref46, ref47, ref48;
        rightValue = (ref48 = (ref47 = (ref46 = positionObj === null || positionObj === void 0 ? void 0 : (ref40 = positionObj.right) === null || ref40 === void 0 ? void 0 : ref40.value) !== null && ref46 !== void 0 ? ref46 : positionDesktopBehaviour === null || positionDesktopBehaviour === void 0 ? void 0 : (ref41 = positionDesktopBehaviour.right) === null || ref41 === void 0 ? void 0 : ref41.value) !== null && ref47 !== void 0 ? ref47 : positionDefaultBreakpoint === null || positionDefaultBreakpoint === void 0 ? void 0 : (ref42 = positionDefaultBreakpoint.right) === null || ref42 === void 0 ? void 0 : ref42.value) !== null && ref48 !== void 0 ? ref48 : defaultPositionObj.right.value;
        var ref49, ref50, ref51;
        rightUnit = (ref51 = (ref50 = (ref49 = positionObj === null || positionObj === void 0 ? void 0 : (ref43 = positionObj.right) === null || ref43 === void 0 ? void 0 : ref43.unit) !== null && ref49 !== void 0 ? ref49 : positionDesktopBehaviour === null || positionDesktopBehaviour === void 0 ? void 0 : (ref44 = positionDesktopBehaviour.right) === null || ref44 === void 0 ? void 0 : ref44.unit) !== null && ref50 !== void 0 ? ref50 : positionDefaultBreakpoint === null || positionDefaultBreakpoint === void 0 ? void 0 : (ref45 = positionDefaultBreakpoint.right) === null || ref45 === void 0 ? void 0 : ref45.unit) !== null && ref51 !== void 0 ? ref51 : defaultPositionObj.right.unit;
    }
    if (valueExists(positionObj === null || positionObj === void 0 ? void 0 : (ref14 = positionObj.left) === null || ref14 === void 0 ? void 0 : ref14.value) || valueExists(positionObj === null || positionObj === void 0 ? void 0 : (ref15 = positionObj.left) === null || ref15 === void 0 ? void 0 : ref15.unit)) {
        var ref52, ref53, ref54, ref55, ref56, ref57;
        var ref58, ref59, ref60;
        leftValue = (ref60 = (ref59 = (ref58 = positionObj === null || positionObj === void 0 ? void 0 : (ref52 = positionObj.left) === null || ref52 === void 0 ? void 0 : ref52.value) !== null && ref58 !== void 0 ? ref58 : positionDesktopBehaviour === null || positionDesktopBehaviour === void 0 ? void 0 : (ref53 = positionDesktopBehaviour.left) === null || ref53 === void 0 ? void 0 : ref53.value) !== null && ref59 !== void 0 ? ref59 : positionDefaultBreakpoint === null || positionDefaultBreakpoint === void 0 ? void 0 : (ref54 = positionDefaultBreakpoint.left) === null || ref54 === void 0 ? void 0 : ref54.value) !== null && ref60 !== void 0 ? ref60 : defaultPositionObj.left.value;
        var ref61, ref62, ref63;
        leftUnit = (ref63 = (ref62 = (ref61 = positionObj === null || positionObj === void 0 ? void 0 : (ref55 = positionObj.left) === null || ref55 === void 0 ? void 0 : ref55.unit) !== null && ref61 !== void 0 ? ref61 : positionDesktopBehaviour === null || positionDesktopBehaviour === void 0 ? void 0 : (ref56 = positionDesktopBehaviour.left) === null || ref56 === void 0 ? void 0 : ref56.unit) !== null && ref62 !== void 0 ? ref62 : positionDefaultBreakpoint === null || positionDefaultBreakpoint === void 0 ? void 0 : (ref57 = positionDefaultBreakpoint.left) === null || ref57 === void 0 ? void 0 : ref57.unit) !== null && ref63 !== void 0 ? ref63 : defaultPositionObj.left.unit;
    }
    return {
        value: positionObj === null || positionObj === void 0 ? void 0 : positionObj.value,
        top: {
            value: topValue,
            unit: topUnit
        },
        bottom: {
            value: bottomValue,
            unit: bottomUnit
        },
        left: {
            value: rightValue,
            unit: rightUnit
        },
        right: {
            value: leftValue,
            unit: leftUnit
        }
    };
}
/**
 *
 * @param x
 * return only auto without the number
 */ function positionStyle_isNumberOrAuto(x, y) {
    if (y === "auto") {
        return "".concat(y);
    }
    return "".concat(x).concat(y);
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/cursorStyle.ts



//Temp to handle nulls
var cursorStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
/**
 * We should only check for property and undefined
 * this solution is only until we fix the null being send around the page object
 */ var CursorCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("auto"),
    (0,es6/* literal */.i0)("default"),
    (0,es6/* literal */.i0)("none"),
    (0,es6/* literal */.i0)("context-menu"),
    (0,es6/* literal */.i0)("help"),
    (0,es6/* literal */.i0)("pointer"),
    (0,es6/* literal */.i0)("progress"),
    (0,es6/* literal */.i0)("wait"),
    (0,es6/* literal */.i0)("cell"),
    (0,es6/* literal */.i0)("crosshair"),
    (0,es6/* literal */.i0)("text"),
    (0,es6/* literal */.i0)("vertical-text"),
    (0,es6/* literal */.i0)("alias"),
    (0,es6/* literal */.i0)("copy"),
    (0,es6/* literal */.i0)("move"),
    (0,es6/* literal */.i0)("no-drop"),
    (0,es6/* literal */.i0)("not-allowed"),
    (0,es6/* literal */.i0)("grab"),
    (0,es6/* literal */.i0)("grabbing"),
    (0,es6/* literal */.i0)("e-resize"),
    (0,es6/* literal */.i0)("n-resize"),
    (0,es6/* literal */.i0)("ne-resize"),
    (0,es6/* literal */.i0)("nw-resize"),
    (0,es6/* literal */.i0)("s-resize"),
    (0,es6/* literal */.i0)("se-resize"),
    (0,es6/* literal */.i0)("sw-resize"),
    (0,es6/* literal */.i0)("w-resize"),
    (0,es6/* literal */.i0)("ew-resize"),
    (0,es6/* literal */.i0)("ns-resize"),
    (0,es6/* literal */.i0)("nesw-resize"),
    (0,es6/* literal */.i0)("nwse-resize"),
    (0,es6/* literal */.i0)("col-resize"),
    (0,es6/* literal */.i0)("row-resize"),
    (0,es6/* literal */.i0)("all-scroll"),
    (0,es6/* literal */.i0)("zoom-in"),
    (0,es6/* literal */.i0)("zoom-out"), 
]);
var CursorOptCodec = cursorStyle_nullable(CursorCodec);
var StylesCursorCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        cursor: CursorOptCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                cursor: CursorOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                cursor: CursorOptCodec
            })
        }),
        mobile: (0,es6/* partial */.r$)({
            cursor: CursorOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    cursor: CursorOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    cursor: CursorOptCodec
                })
            })
        }),
        tablet: (0,es6/* partial */.r$)({
            cursor: CursorOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    cursor: CursorOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    cursor: CursorOptCodec
                })
            })
        })
    }), 
]);
function cursorCss(css) {
    if (css.hasOwnProperty("cursor")) return css["cursor"];
    return "";
}
function cursorStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var styles = StylesCursorCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return cursorStyle_cssRender(styles.right, breakpoint, behaviourState);
    console.warn(codecUtils_decoderErrors(styles));
    return {
        cursor: "default"
    };
}
function cursorStyle_cssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return cursorStyle_renderBobOpt(stylesObj.cursor);
        } else {
            var ref, ref1;
            return cursorStyle_renderBobOpt(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.cursor);
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return cursorStyle_renderBobOpt(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.cursor);
        } else {
            var ref3, ref4, ref5;
            return cursorStyle_renderBobOpt(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.cursor);
        }
    }
}
/**
 * Renders CursorsOpt css for breakpoints/state templates
 * or empty for non written style props
 *
 * @param cursorValue
 * @param foundationStyle
 * @returns
 */ function cursorStyle_renderBobOpt(cursorValue) {
    if (cursorValue) {
        return cursorStyle_renderOpt(cursorValue);
    }
    return {};
}
/**
 * Renders CursorOpt css for breakpoints/state templates
 * Returns cursor
 * or empty for non written style props
 *
 * @param cursorValue
 * @param foundationStyle
 * @returns
 */ function cursorStyle_renderOpt(cursorValue) {
    if (cursorValue) {
        var cssValue = cursorValue;
        return cursorStyle_cssProperty(cssValue);
    }
    // no written style props
    return {};
}
function cursorStyle_cssProperty(cssValue) {
    return {
        cursor: cssValue
    };
}

;// CONCATENATED MODULE: ./src/areas/skynet/experienceManager/finder/inputs/contentSrcController/contentSrcHelper.ts

var ContentSrcHelper = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function ContentSrcHelper() {
        _class_call_check(this, ContentSrcHelper);
    }
    ContentSrcHelper.stateWrite = function stateWrite(contentSrcControllerObject) {
        return {
            contentSrc: contentSrcControllerObject.contentSrc.value
        };
    };
    return ContentSrcHelper;
}()));
var contentSrcHelper_CMS = "post";
var contentSrcHelper_WRITE = "custom";
var contentSrcHelper_CONTENT_PAGE = "content-page";
var contentSrcHelper_mvPage = [
    {
        label: "Insert",
        value: contentSrcHelper_WRITE
    },
    {
        label: "CMS",
        value: contentSrcHelper_CMS
    }, 
];
var contentSrcHelper_mvContentPage = [
    {
        label: "Insert",
        value: contentSrcHelper_WRITE
    },
    {
        label: "CMS",
        value: contentSrcHelper_CMS
    },
    {
        label: "Content Page",
        value: contentSrcHelper_CONTENT_PAGE
    }, 
];
/* harmony default export */ var contentSrcHelper = ((/* unused pure expression or super */ null && (ContentSrcHelper)));

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobHandlerV2.ts



var handleStateStyles = function(bobTemplate, stylesDesktop, stylesTablet, stylesMobile) {
    var ref, ref1, ref2, ref3;
    var desktopHoverEnable = bobTemplate.behaviour.hover.enable;
    var tabletHoverEnable = fallbackBehaviourTemplateEnable((ref = bobTemplate.tablet) === null || ref === void 0 ? void 0 : (ref1 = ref.behaviour) === null || ref1 === void 0 ? void 0 : ref1.hover, bobTemplate.behaviour.hover);
    var mobilepHoverEnable = fallbackBehaviourTemplateEnable((ref2 = bobTemplate.mobile) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.behaviour) === null || ref3 === void 0 ? void 0 : ref3.hover, bobTemplate.behaviour.hover);
    return {
        isEnabled: {
            desktop: desktopHoverEnable,
            tablet: tabletHoverEnable.enable,
            mobile: mobilepHoverEnable.enable
        },
        desktop: desktopHoverEnable ? stylesDesktop : {},
        tablet: tabletHoverEnable ? stylesTablet : {},
        mobile: mobilepHoverEnable ? stylesMobile : {}
    };
};
var fallbackBehaviourTemplateEnable = function(behaviourObj, desktopBehaviour) {
    var enable = get2WithNull4Enable(behaviourObj === null || behaviourObj === void 0 ? void 0 : behaviourObj.enable, desktopBehaviour.enable);
    return {
        enable: enable
    };
};
/**
 * returns media queries to apply styles based on enable prop value on the diferent breakpoints
 */ var handleMediaQueryRestrictions = function(mobileStyles, tabletStyles) {
    if (tabletStyles === false && mobileStyles) return "and (max-width: 766px), (min-width: 993px)";
    if (tabletStyles === false) return "and (min-width: 993px)";
    if (mobileStyles === false) return "and (min-width: 767px)";
    return "";
};
var bobHandlerV2_mergeMedias = function(singleObject, pageResponse, replacedMediaList) {
    var ref, ref1;
    if (!((ref = singleObject.content) === null || ref === void 0 ? void 0 : (ref1 = ref.formula) === null || ref1 === void 0 ? void 0 : ref1.media)) return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, pageResponse), {
        media: (0,src_object_spread/* default */.Z)({}, pageResponse.media, replacedMediaList)
    });
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, pageResponse), {
        media: (0,src_object_spread/* default */.Z)({}, pageResponse.media, singleObject.content.formula.media, replacedMediaList)
    });
};


;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobContainer/bobContainerHandler.ts
























var responsiveStyles = function(styles, stylesheetLabels, breakpoint, behaviourState, imageUrl) {
    var stylesheetShadowColorLabel = handleBobShadowLabel(styles, stylesheetLabels, breakpoint, behaviourState);
    var stylesheetBorderColorLabel = handleBobBorderLabel(styles, stylesheetLabels, breakpoint, behaviourState);
    return (0,src_object_spread/* default */.Z)({}, heightStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState), maxHeightStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), minHeightStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), widthStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState), maxWidthStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), minWidthStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), flexStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), selfFlexStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), shadowStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState, undefined, stylesheetShadowColorLabel), boundaryStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState), borderStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState, stylesheetBorderColorLabel), radiusStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), bobContainerHandler_handleBackgroundImage(styles, stylesheetLabels, breakpoint, behaviourState, imageUrl), zindexStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), positionStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), cursorStyle_cssRenderUnsafe(styles, breakpoint, behaviourState));
};
var bobContainerHandler_handleBackgroundImage = function(styles, stylesheetLabels, breakpoint, behaviourState, imageUrl) {
    var stylesheetColorsLabel = handleBobColorsLabel(styles, stylesheetLabels, breakpoint, behaviourState);
    var colorsStyle = colorsStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState, undefined, stylesheetColorsLabel);
    var backgroundImageStyle = backgroundImageStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState, imageUrl);
    // when colors is using gradient and backgroundImage exists,
    // join them on the same background-image css
    if ("background-image" in colorsStyle && typeof backgroundImageStyle === "object" && "background-image" in backgroundImageStyle) {
        var mergedBackgroundImageStyle = {
            "background-image": "".concat(colorsStyle["background-image"], ", ").concat(backgroundImageStyle["background-image"])
        };
        return (0,src_object_spread/* default */.Z)({}, backgroundImageStyle, mergedBackgroundImageStyle);
    }
    // return color and background-image css
    return (0,src_object_spread/* default */.Z)({}, colorsStyle, backgroundImageStyle);
};
// TODO: i think this is not used
var GetMedia = function(field, inlineContent, pageResponse, singleObject, postObj, overrides, replacedMediaList) {
    // custom content
    if (getOverrideInlineContentValues("".concat(field, ".contentSrc"), {
        inlineContent: inlineContent,
        overrides: overrides
    }) === WRITE) {
        return handleSrcLink(pageResponse, getOverrideInlineContentValues("".concat(field, ".src"), {
            inlineContent: inlineContent,
            overrides: overrides
        }));
    } else if (getOverrideInlineContentValues("".concat(field, ".contentSrc"), {
        inlineContent: inlineContent,
        overrides: overrides
    }) === CMS && postObj && inlineContent) {
        var mediaUrl = getMediaStringField(postObj, inlineContent, field, overrides);
        return handleSrcLink(mergeMedias(singleObject, pageResponse, replacedMediaList), mediaUrl);
    } else if (getOverrideInlineContentValues("".concat(field, ".contentSrc"), {
        inlineContent: inlineContent,
        overrides: overrides
    }) === CONTENT_PAGE) {
        var ref;
        var _$postObj = ((ref = pageResponse.contentPage) === null || ref === void 0 ? void 0 : ref.content) || DummyPost;
        var mediaUrl1 = getMediaStringField(_$postObj, inlineContent, field, overrides);
        return handleSrcLink(mergeMedias(singleObject, pageResponse, replacedMediaList), mediaUrl1);
    } else {
        return {
            mediaSrc: "",
            mediaAlt: ""
        };
    }
};


;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobMediaV2/bobMediaV2Handler.ts























var bobMediaV2Handler_responsiveStyles = function(styles, stylesheetLabels, breakpoint, behaviourState) {
    var stylesheetShadowColorLabel = handleBobShadowLabel(styles, stylesheetLabels, breakpoint, behaviourState);
    var stylesheetBorderColorLabel = handleBobBorderLabel(styles, stylesheetLabels, breakpoint, behaviourState);
    var stylesheetColorsLabel = handleBobColorsLabel(styles, stylesheetLabels, breakpoint, behaviourState);
    return (0,src_object_spread/* default */.Z)({}, heightStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState), maxHeightStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), minHeightStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), widthStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState), maxWidthStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), minWidthStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), selfFlexStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), shadowStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState, undefined, stylesheetShadowColorLabel), borderStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState, stylesheetBorderColorLabel), boundaryStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState), radiusStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), colorsStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState, undefined, stylesheetColorsLabel), filterStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), positionStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), cursorStyle_cssRenderUnsafe(styles, breakpoint, behaviourState));
};
var handleImageSrcTemplate = function(isHover, defaultImageUrl, stateImageUrl) {
    return !isHover ? defaultImageUrl : isHover && stateImageUrl ? stateImageUrl : defaultImageUrl;
};
var isHoverEnabled = function(templateObj) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    if (((ref = templateObj.behaviour.hover) === null || ref === void 0 ? void 0 : ref.enable) || ((ref1 = templateObj.tablet) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.hover) === null || ref3 === void 0 ? void 0 : ref3.enable) || ((ref4 = templateObj.mobile) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.behaviour) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.hover) === null || ref6 === void 0 ? void 0 : ref6.enable)) {
        return true;
    }
    return false;
};
var isFilterEnabled = function(templateObj) {
    var ref, ref1, ref2, ref3;
    if (templateObj.filter.enable || ((ref = templateObj.tablet) === null || ref === void 0 ? void 0 : (ref1 = ref.filter) === null || ref1 === void 0 ? void 0 : ref1.enable) || ((ref2 = templateObj.mobile) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.filter) === null || ref3 === void 0 ? void 0 : ref3.enable)) {
        return true;
    }
    return false;
};
var bobMediaV2Handler_handleSize = function(size) {
    if (size.enable) {
        return "".concat(size.value).concat(size.unit);
    }
    return undefined;
};
var handleMedia = function(pageResponse, post, mediasId, linkType, singleObject, replacedMediaList) {
    var ref, ref1;
    var defaultMedia;
    var hoverMedia;
    /**
   * default media
   */ // placeholder
    if (!mediasId.defaultMediaId) {
        defaultMedia = {
            type: "image",
            url: "https://cdn.fluxio.cloud/fluxio/fluxio_placeholder.png",
            isDirectLink: false,
            alt: "Fluxio",
            size: undefined
        };
    } else if ((ref = mediasId.defaultMediaId) === null || ref === void 0 ? void 0 : ref.startsWith("media")) {
        var cutMediaId = mediasId.defaultMediaId.replace(/media-/g, "");
        var mediaObject = bobHandlerV2_mergeMedias(singleObject, pageResponse, replacedMediaList).media[cutMediaId];
        var mediaUrl = handleMediaUrl(mediaObject, pageResponse, post === null || post === void 0 ? void 0 : post.title);
        if (mediaObject) {
            defaultMedia = {
                type: mediaObject.itemType,
                url: mediaUrl.url,
                isDirectLink: false,
                alt: mediaUrl.alt,
                size: mediaObject.size
            };
        } else {
            console.warn("returning empty mediaObject");
            defaultMedia = {
                type: "image",
                url: "https://cdn.fluxio.cloud/fluxio/fluxio_placeholder.png",
                isDirectLink: true,
                alt: "placeholder",
                size: 0
            };
        }
    } else {
        var mediaType = linkType === "video" ? "video" : "image";
        defaultMedia = {
            type: mediaType,
            url: mediasId.defaultMediaId,
            isDirectLink: true,
            alt: "",
            size: undefined
        };
    }
    /**
   * hover media
   */ // placeholder
    if (!mediasId.hoverMediaId) {
        hoverMedia = undefined;
    } else if ((ref1 = mediasId.hoverMediaId) === null || ref1 === void 0 ? void 0 : ref1.startsWith("media")) {
        var cutMediaId1 = mediasId.hoverMediaId.replace(/media-/g, "");
        var mediaObject1 = bobHandlerV2_mergeMedias(singleObject, pageResponse, replacedMediaList).media[cutMediaId1];
        var mediaUrl1 = handleMediaUrl(mediaObject1, pageResponse, post === null || post === void 0 ? void 0 : post.title);
        hoverMedia = {
            type: mediaObject1.itemType,
            url: mediaUrl1.url,
            isDirectLink: false,
            alt: mediaUrl1.alt,
            size: mediaObject1.size
        };
    } else {
        var mediaType1 = linkType === "video" ? "video" : "image";
        hoverMedia = {
            type: mediaType1,
            url: mediasId.hoverMediaId,
            isDirectLink: true,
            alt: "",
            size: undefined
        };
    }
    return {
        defaultMedia: defaultMedia,
        hoverMedia: hoverMedia
    };
};
var handleMediaId = function(item, pageResponse, field, inlineContent, overrides, hoverEnable, mediaField) {
    var content = {
        inlineContent: inlineContent,
        overrides: overrides
    };
    var contentSrc = components_getOverrideInlineContentValues("".concat(field, ".contentSrc"), content);
    // custom content
    if (contentSrc === textContentHelper_WRITE) {
        var ref, ref1;
        var stylesheetLabels = (ref = pageResponse.stylesheet) === null || ref === void 0 ? void 0 : ref.labels;
        var mediaLabel = (ref1 = inlineContent.labels) === null || ref1 === void 0 ? void 0 : ref1["".concat(field, ".src")];
        var mediaLabelValue = stylesheetLabels === null || stylesheetLabels === void 0 ? void 0 : stylesheetLabels[mediaLabel || ""];
        return {
            defaultMediaId: handleMediaStylesheetLabel(mediaLabelValue, components_getOverrideInlineContentValues("".concat(field, ".src"), content)),
            hoverMediaId: hoverEnable && components_getOverrideInlineContentValues("".concat(field, ".behaviour-hover-src"), content)
        };
    } else if (contentSrc === textContentHelper_CMS && item) {
        return {
            defaultMediaId: bobMediaV2Handler_getMediaStringField(item, content, field, mediaField),
            hoverMediaId: undefined
        };
    } else if (contentSrc === textContentHelper_FORM && item) {
        return {
            defaultMediaId: bobMediaV2Handler_getMediaStringField(item, content, field, mediaField),
            hoverMediaId: undefined
        };
    } else {
        var ref2;
        var _$item = ((ref2 = pageResponse.contentPage) === null || ref2 === void 0 ? void 0 : ref2.content) || contentPageHelper_DummyPost;
        return {
            defaultMediaId: bobMediaV2Handler_getMediaStringField(_$item, content, field, mediaField),
            hoverMediaId: undefined
        };
    }
};
var handleMediaUrl = function(mediaObject, pageResponse, postTitle) {
    var ref, ref1;
    var placeholder = "https://cdn.fluxio.cloud/fluxio/fluxio_placeholder.png";
    var placeholderAlt = "Fluxio";
    // no media object, render placeholder
    if (!mediaObject) {
        console.warn("Missing media object");
        return {
            url: placeholder,
            alt: placeholderAlt
        };
    }
    //With no profile available we stop and return a placeholder
    var profileName = mediaObject.profileName || pageResponse.profileName;
    if (!profileName) {
        console.warn("Missing profileName");
        return {
            url: placeholder,
            alt: placeholderAlt
        };
    }
    var mediaAlt = mediaObject.alt || postTitle || ((ref = pageResponse.contentPage) === null || ref === void 0 ? void 0 : (ref1 = ref.content) === null || ref1 === void 0 ? void 0 : ref1.title) || "";
    // supported extension
    if (mediaObject.extension !== "webp" || pageResponse.webpSupport || window.Modernizr && window.Modernizr.webp) {
        return {
            url: "https://static-media.fluxio.cloud/".concat(profileName, "/").concat(mediaObject.id).concat(hasVersion(mediaObject.version), ".").concat(mediaObject.extension),
            alt: mediaAlt
        };
    }
    // Fallback for not supported .webp
    console.warn("No support for webp, using fallback for ".concat(mediaObject.id));
    return {
        url: "https://static-media.fluxio.cloud/".concat(profileName, "/").concat(mediaObject.id).concat(hasVersion(mediaObject.version), ".").concat(mediaObject.fallbackExtension),
        alt: mediaAlt
    };
};
var bobMediaV2Handler_getMediaStringField = function(item, content, bobField, mediaField) {
    var bobContent = components_getOverrideInlineContentValues("".concat(bobField).concat(mediaField), {
        inlineContent: content.inlineContent,
        overrides: content.overrides
    });
    if (bobContent) {
        if (bobContent.startsWith("$")) {
            var value = jsonpath_default().query(item, bobContent);
            return value && value.length > 0 ? value[0] : "";
        }
        return cleanPath(item, bobContent) || "";
    }
    return "";
};
var properMediaAlt = function(mediaAlt, postObj) {
    if (mediaAlt && mediaAlt !== "") return mediaAlt;
    if (postObj) {
        if (postObj.picture_orig_alt && postObj.picture_orig_alt !== "") return postObj.picture_orig_alt;
        if (postObj.title && postObj.title !== "") return postObj.title;
    }
    return "";
};
var responsiveMediaLink = function(breakpoint, pageResponse, inlineContent, overrides, field) {
    var mediaSrc = getResponsiveOverrideInlineContentValues("".concat(field, ".").concat(breakpoint, "-src"), {
        inlineContent: inlineContent,
        overrides: overrides
    });
    if (mediaSrc) {
        return handleSrcLink(pageResponse, mediaSrc);
    }
    return undefined;
};
var handleWidthAndHeightReplace = function(cssPropertiesObj) {
    if (cssPropertiesObj.width) {
        cssPropertiesObj.maxWidth = cssPropertiesObj.width !== "auto !important" ? cssPropertiesObj.width : "auto !important";
        cssPropertiesObj.width = cssPropertiesObj.width === "auto !important" && cssPropertiesObj.width;
    }
    if (cssPropertiesObj.height) {
        cssPropertiesObj.maxHeight = cssPropertiesObj.height !== "auto !important" ? cssPropertiesObj.height : "auto !important";
        cssPropertiesObj.height = cssPropertiesObj.height === "auto !important" && cssPropertiesObj.height;
    }
    return cssPropertiesObj;
};


;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobContainer/bobContainer.tsx







function bobContainer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all ",
        " {\n            &:hover {\n              ",
        "\n            }\n          }\n        "
    ]);
    bobContainer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function bobContainer_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    &:hover {\n                      ",
        "\n                    }\n                  "
    ]);
    bobContainer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function bobContainer_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all and (max-width: 992px) and (min-width: 767px) {\n            ",
        "\n            ",
        "\n          }\n        "
    ]);
    bobContainer_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function bobContainer_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    &:hover {\n                      ",
        "\n                    }\n                  "
    ]);
    bobContainer_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function bobContainer_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all and (max-width: 766px) {\n            ",
        "\n            ",
        "\n          }\n        "
    ]);
    bobContainer_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n",
        "\n\n",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}














var ContainerDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-24d37c6c-0"
})(_templateObject5(), function(props) {
    return props.desktop;
}, function(props) {
    return props.hover.isEnabled.desktop ? (0,styled_components_browser_esm/* css */.iv)(bobContainer_templateObject(), handleMediaQueryRestrictions(props.hover.isEnabled.mobile, props.hover.isEnabled.tablet), props.hover.desktop) : {};
}, function(props) {
    return Object.keys(props.tablet).length > 0 || Object.keys(props.hover.tablet).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(bobContainer_templateObject2(), function(props) {
        return props.tablet;
    }, function(props) {
        return props.hover.isEnabled.tablet && Object.keys(props.hover.tablet).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(bobContainer_templateObject1(), props.hover.tablet) : {};
    }) : {};
}, function(props) {
    return Object.keys(props.mobile).length > 0 || Object.keys(props.hover.mobile).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(bobContainer_templateObject4(), function(props) {
        return props.mobile;
    }, function(props) {
        return props.hover.isEnabled.mobile && Object.keys(props.hover.mobile).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(bobContainer_templateObject3(), props.hover.mobile) : {};
    }) : {};
});
var BobContainer = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(BobContainer, _Component);
    var _super = (0,_create_super/* default */.Z)(BobContainer);
    function BobContainer(props) {
        (0,src_class_call_check/* default */.Z)(this, BobContainer);
        var _this;
        _this = _super.call(this, props);
        _this.containerRef = /*#__PURE__*/ react.createRef();
        return _this;
    }
    var _proto = BobContainer.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.props.setRef && this.props.setRef(this.containerRef);
    };
    _proto.render = function render() {
        var _this = this;
        var ref, ref1, ref2, ref3, ref4, ref5;
        // const handleOnClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, templateStyles: any) => {
        //   // // trigger parent onclick
        //   // if (this.props.onClick)
        //   //   this.props.onClick(e)
        //   // // check template onclick action
        //   // // only run outside experience manager
        //   // if (this.props.rule.actions && !this.props.expManager.enable) {
        //   //   if ((templateStyles.actions && templateStyles.actions.enable) && (templateStyles.actions.onClick && templateStyles.actions.onClick !== '')) {
        //   //     // https://stackoverflow.com/questions/40661197/js-check-if-input-string-is-valid-code-and-run-input
        //   //     // eslint-disable-next-line
        //   //     if (eval("typeof " + templateStyles.actions.onClick) === "function") {
        //   //       // https://stackoverflow.com/questions/939326/execute-javascript-code-stored-as-a-string
        //   //       // eslint-disable-next-line
        //   //       let F = new Function(templateStyles.actions.onClick)
        //   //       return (F())
        //   //     }
        //   //   }
        //   // }
        // }
        //@ts-ignore
        var templateStyles = isBobFlex(this.props.object.styles.bobs.container1);
        var inlineContent = this.props.object.content.inlineContent;
        var settings = this.props.object.settings;
        var pageLabels = (ref = this.props.pageResponse.stylesheet) === null || ref === void 0 ? void 0 : ref.labels;
        var TAG = components_getOverrideInlineContentValues("".concat(this.props.field, ".behaviour-link-enable"), this.props) ? "a" : "div";
        var linkAttrs = function() {
            return getLinkAttributes(_this.props.field, {
                inlineContent: _this.props.inlineContent,
                overrides: _this.props.overrides
            }, _this.props.pageResponse, _this.props.post);
        };
        var media = handleMedia(this.props.pageResponse, this.props.post, handleMediaId(this.props.post, this.props.pageResponse, this.props.field, this.props.object.content.inlineContent, this.props.overrides, (ref1 = templateStyles.behaviour) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.hover) === null || ref2 === void 0 ? void 0 : ref2.enable, ".mappedValue"), components_getOverrideInlineContentValues("".concat(this.props.field, ".linkType"), {
            inlineContent: inlineContent,
            overrides: this.props.overrides
        }), this.props.object, this.props.replacedMediaList);
        var DesktopStyles = responsiveStyles(templateStyles, pageLabels, "desktop", "default", media.defaultMedia.url);
        var TabletStyles = responsiveStyles(templateStyles, pageLabels, "tablet", "default", media.defaultMedia.url);
        var MobileStyles = responsiveStyles(templateStyles, pageLabels, "mobile", "default", media.defaultMedia.url);
        var hoverStyles = handleStateStyles(templateStyles, responsiveStyles(templateStyles, pageLabels, "desktop", "hover", media.defaultMedia.url), responsiveStyles(templateStyles, pageLabels, "tablet", "hover", media.defaultMedia.url), responsiveStyles(templateStyles, pageLabels, "mobile", "hover", media.defaultMedia.url));
        var DOMid = this.props.expManager.enable ? {
            id: "".concat(handleDOMid(this.props.field, this.props.id, this.props.instanceId))
        } : {};
        var EMpreviewClass = emPreviewClass(this.props.expManager.enable, templateStyles.uuid);
        var EMScrollId = emScrollId(this.props.expManager.enable, this.props.object.uuid);
        var _obj;
        var GlobalStylesClass = globalStylesUtils.handleClassNameV2(this.props.pageResponse.nGlobalStyles, templateStyles, "-box", (_obj = {}, (0,src_define_property/* default */.Z)(_obj, GS_SHADOW, NGS_CLASS_SUFIX), (0,src_define_property/* default */.Z)(_obj, GS_BOUNDARY, NGS_CLASS_SUFIX), _obj));
        var customClasses = (settings === null || settings === void 0 ? void 0 : (ref3 = settings[this.props.field]) === null || ref3 === void 0 ? void 0 : ref3.class) ? " ".concat(settings === null || settings === void 0 ? void 0 : (ref4 = settings[this.props.field]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.class) === null || ref5 === void 0 ? void 0 : ref5.join(" ")) : "";
        var classes = "".concat((public_components_module_default()).flx_flex).concat(EMpreviewClass ? " ".concat(EMpreviewClass, " ") : "").concat(GlobalStylesClass ? " ".concat(GlobalStylesClass, " ") : "").concat(customClasses);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerDiv, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            as: TAG,
            ref: this.containerRef,
            desktop: DesktopStyles,
            mobile: MobileStyles,
            tablet: TabletStyles,
            hover: hoverStyles
        }, EMScrollId, DOMid), {
            className: classes,
            onClick: function(e) {
                //handleOnClick(e, templateStyles)
                bobUtils_clickEvent(e, TAG, _this.props.field, _this.props.inlineContent, _this.props.overrides, _this.props.pageResponse, _this.props.post);
            }
        }), linkAttrs()), {
            children: this.props.children
        }));
    };
    return BobContainer;
}(react.Component);
/* harmony default export */ var bobContainer = (BobContainer);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Structure/container/container.tsx






var Container = function(props) {
    var ref = (0,react.useState)(undefined), elRef = ref[0], setElRef = ref[1];
    var childComponentsId = props.obj.children;
    var renderChild = function(post) {
        if (childComponentsId) {
            return childComponentsId.map(function(childId, idx) {
                var handledItem = handleObjectType(props.obj, childId, props.pageResponse, props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                    position: idx,
                    component: handleContentBlock(handledItem, post, props.obj, props.pageResponse, props.overrides),
                    pageResponse: props.pageResponse,
                    selectedInstanceId: props.obj.selectedInstanceId,
                    matchOrder: props.matchOrder,
                    expManager: props.expManager,
                    form: props.form
                }, idx);
            });
        }
    };
    var items = getContent(props.obj, "posts", props.overrides);
    var childs = [];
    if (items && items.length > 0) {
        childs = items.map(function(post, idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(bobContainer, {
                id: props.obj.uuid,
                pageResponse: props.pageResponse,
                instanceId: props.obj.selectedInstanceId,
                inlineContent: props.obj.content.inlineContent,
                overrides: props.overrides,
                object: props.obj,
                post: post,
                template: props.obj.styles,
                field: "container1",
                setRef: function(containerRef) {
                    return setElRef(containerRef);
                },
                expManager: props.expManager,
                replacedMediaList: props.replacedMediaList,
                children: renderChild(post)
            }, idx);
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            props.expManager.enable && !props.expManager.content && /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM_ComponentSelectorEMv2, {
                uuid: props.obj.uuid,
                obj: props.obj,
                form: props.form,
                masterBob: "container1",
                editing: props.editing,
                elRef: elRef
            }),
            childs
        ]
    });
};
/* harmony default export */ var container = (/*#__PURE__*/react.memo(Container));

// EXTERNAL MODULE: ./node_modules/@react-google-maps/api/dist/reactgooglemapsapi.esm.js + 3 modules
var reactgooglemapsapi_esm = __webpack_require__(83854);
// EXTERNAL MODULE: ./src/stylesheets/modules/templates/resultsMap.module.sass
var resultsMap_module = __webpack_require__(39695);
var resultsMap_module_default = /*#__PURE__*/__webpack_require__.n(resultsMap_module);
;// CONCATENATED MODULE: ./src/areas/public-page/fluxio-components/dataSetFilters/resultsMap/resultsMap.tsx
















var containerStyle = {
    width: "100%",
    height: "100%"
};
var containerFullscreenStyle = {
    width: "100%",
    height: "100%",
    position: "fixed",
    left: "0",
    right: "0",
    zIndex: "999"
};
var center = {
    lat: 38.7334866,
    lng: -8.9292594
};
var ResultsMap = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ResultsMap, _Component);
    var _super = (0,_create_super/* default */.Z)(ResultsMap);
    function ResultsMap(props) {
        (0,src_class_call_check/* default */.Z)(this, ResultsMap);
        var _this;
        _this = _super.call(this, props);
        _this.child = [];
        _this.state = {
            infoOpen: false,
            place: false,
            fullScreenMode: false
        };
        return _this;
    }
    var _proto = ResultsMap.prototype;
    /**
   *
   * @param {postIdx} idx
   * We need this idx from the post array
   * to properly call the inner function down the react tree.
   * if we dont use this we overwrite the same ref over and over
   * leaving only the reference to the last rendered object.
   */ _proto.handleCardClick = function handleCardClick(idx) {
        if (this.child && this.child[idx]) this.child[idx].handleInnerFunction();
    };
    _proto.handleMarker = function handleMarker(marker, place) {
        this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this.state), {
            place: place,
            infoOpen: !this.state.infoOpen
        }));
    };
    _proto.handleFullscreen = function handleFullscreen() {
        this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this.state), {
            fullScreenMode: !this.state.fullScreenMode
        }));
    };
    /**
   * For now this render is best used with modal components
   *
   */ _proto.renderChildComponents = function renderChildComponents() {
        var childsId = this.props.obj.children;
        if (childsId && childsId.length > 0 && this.props.dataSet) {
            var _this = this;
            var childComponent = childsId[0];
            var handledItem = handleObjectType(this.props.obj, childComponent, this.props.pageResponse, this.props.expManager.emEditorType);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                onRef: function(ref) {
                    return _this.child[0] = ref;
                },
                position: 0,
                component: handleDataSetAsContentBlock(handledItem, this.props.dataSet.mapPosts.filter(function(post) {
                    return post.id === _this.state.place.id;
                }), this.props.obj),
                pageResponse: this.props.pageResponse,
                selectedInstanceId: this.props.obj.selectedInstanceId,
                matchOrder: this.props.matchOrder,
                expManager: this.props.expManager
            }, 0);
        } else return [];
    };
    _proto.renderInfoWindowContent = function renderInfoWindowContent(place) {
        var _this = this;
        //let background2Template = this.props.obj.styles.bobs.background2
        //let tabletStyles = responsiveProperties(background2Template, 'tablet', {}, [], [])
        //let mobileStyles = responsiveProperties(background2Template, 'mobile', {}, [], [])
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                    position: this.props.position,
                    pageResponse: this.props.pageResponse,
                    instanceId: this.props.obj.selectedInstanceId,
                    object: this.props.obj,
                    objectId: this.props.obj.uuid,
                    field: "icon1",
                    template: this.props.obj.styles,
                    rules: this.props.componentRule,
                    expManager: this.props.expManager,
                    iconClassName: "fas fa-times",
                    className: "infoWindow-close ".concat((resultsMap_module_default())["infoWindow-close"], " is-clickable"),
                    onClick: function() {
                        return _this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, _this.state), {
                            infoOpen: false
                        }));
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cards card-top ".concat((resultsMap_module_default())["card-top"]),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(bobComponentHandler, {
                        position: this.props.position,
                        pageResponse: this.props.pageResponse,
                        instanceId: this.props.obj.selectedInstanceId,
                        object: this.props.obj,
                        objectId: this.props.obj.uuid,
                        inlineContent: this.props.obj.content.inlineContent,
                        overrides: this.props.overrides,
                        field: "background2",
                        rules: this.props.componentRule,
                        template: this.props.obj.styles,
                        expManager: this.props.expManager,
                        className: "card",
                        onClick: function() {
                            return _this.handleCardClick(0);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                position: this.props.position,
                                pageResponse: this.props.pageResponse,
                                replacedMediaList: this.props.replacedMediaList,
                                instanceId: this.props.obj.selectedInstanceId,
                                object: this.props.obj,
                                objectId: this.props.obj.uuid,
                                inlineContent: this.props.obj.content.inlineContent,
                                overrides: this.props.overrides,
                                field: "media1",
                                template: this.props.obj.styles,
                                rules: this.props.componentRule,
                                expManager: this.props.expManager,
                                network: place.network,
                                post: place
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bobComponentHandler, {
                                position: this.props.position,
                                pageResponse: this.props.pageResponse,
                                instanceId: this.props.obj.selectedInstanceId,
                                object: this.props.obj,
                                objectId: this.props.obj.uuid,
                                inlineContent: this.props.obj.content.inlineContent,
                                overrides: this.props.overrides,
                                field: "text1",
                                tag: "p",
                                value: place.title,
                                template: this.props.obj.styles,
                                rules: this.props.componentRule,
                                expManager: this.props.expManager,
                                className: "title"
                            })
                        ]
                    })
                })
            ]
        });
    };
    _proto.renderMarks = function renderMarks() {
        if (this.props.dataSet && this.props.dataSet.mapPosts) {
            var _this = this;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(reactgooglemapsapi_esm/* MarkerClusterer */.XL, {
                maxZoom: 9,
                children: function(clusterer) {
                    return _this.props.dataSet.mapPosts.map(function(location, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(reactgooglemapsapi_esm/* Marker */.Jx, {
                            position: location.latLong,
                            clusterer: clusterer,
                            onClick: function(marker) {
                                return _this.handleMarker(marker, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, location), {
                                    pos: location.latLong
                                }));
                            }
                        }, idx);
                    });
                }
            });
        }
        return [];
    };
    _proto.renderMap = function renderMap(background1Template) {
        var _this = this;
        var counter = {
            desktop: 0,
            tablet: 0,
            mobile: 0
        };
        var columns = bobHandler_handleColumns(0, counter, background1Template, this.props.pageResponse.globalStyles[background1Template.globalStyleId]);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(reactgooglemapsapi_esm/* LoadScript */.KJ, {
                googleMapsApiKey: "AIzaSyA7FRMfMTaf1r2IF-IC_urfGQYl--CZyas",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(reactgooglemapsapi_esm/* GoogleMap */.b6, {
                    mapContainerStyle: this.state.fullScreenMode ? containerFullscreenStyle : containerStyle,
                    center: center,
                    zoom: 6,
                    options: {
                        gestureHandling: "cooperative",
                        fullscreenControl: false
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "map-fullscreen-trigger ".concat((resultsMap_module_default())["map-fullscreen-trigger"]),
                            onClick: function() {
                                return _this.handleFullscreen();
                            },
                            children: this.state.fullScreenMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fas fa-compress"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fas fa-expand"
                            })
                        }),
                        this.renderMarks(),
                        this.state.infoOpen && this.state.place && /*#__PURE__*/ (0,jsx_runtime.jsx)(reactgooglemapsapi_esm/* InfoWindow */.nx, {
                            onCloseClick: function() {
                                return _this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, _this.state), {
                                    infoOpen: false
                                }));
                            },
                            position: this.state.place.pos,
                            children: this.renderInfoWindowContent(this.state.place)
                        })
                    ]
                })
            })
        });
    };
    _proto.render = function render() {
        var background1 = this.props.obj.styles.bobs.background1;
        var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "results-map-component ".concat((resultsMap_module_default())["results-map-component"]),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
                    className: "row ".concat((resultsMap_module_default()).row, " ").concat(bobHandler_responsiveGuttersClass(background1, this.props.pageResponse.globalStyles[background1.globalStyleId])),
                    desktop: alignmentStyles,
                    tablet: tabletAlignment,
                    mobile: mobileAlignment,
                    children: this.renderMap(background1)
                }),
                this.renderChildComponents()
            ]
        });
    };
    return ResultsMap;
}(react.Component);
function resultsMap_mapStateToProps(state) {
    return {
        fetchingDataSet: state.publicPageReducer.server.fetchingDataSet,
        dataSet: state.publicPageReducer.server.dataSet,
        errorFetchingDataSet: state.publicPageReducer.server.errorFetchingDataSet,
        dataSetParams: state.publicPageReducer.server.dataSetParams
    };
}
/* harmony default export */ var resultsMap = ((0,es/* connect */.$j)(resultsMap_mapStateToProps)(ResultsMap));

;// CONCATENATED MODULE: ./src/areas/public-page/fluxio-components/dataSetFilters/dataSetContainer/dataSetContainer.tsx











var DataSetContainer = function(props) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var actions = (0,redux/* bindActionCreators */.DE)({
        getDataSet: getDataSet,
        writeDataSet: writeDataSet
    }, dispatch);
    // const {
    //   fetchingDataSet,
    //   dataSet,
    //   errorFetchingDataSet,
    //   dataSetParams
    // } = useSelector((state: any) => state.publicPageReducer.server);
    (0,react.useEffect)(function() {
        if (!props.expManager.enable || props.expManager.content) {
            if (props.obj.content.dataset && (!props.obj.content.dataset.posts || props.obj.content.dataset.posts.length === 0)) actions.getDataSet(props.obj.content.dataset.uuid, undefined);
        } else handlePopulateDataSet(props);
    }, []);
    var handlePopulateDataSet = function(props) {
        if (props.obj.content && props.obj.content.dataset) {
            actions.writeDataSet(props.obj.content.dataset);
        }
    };
    var renderComponents = function(childComponents, background1) {
        if (childComponents && childComponents.length > 0) {
            var counter = {
                desktop: 0,
                tablet: 0,
                mobile: 0
            };
            return childComponents.map(function(objId, idx) {
                var handledItem = handleObjectType(props.obj, objId, props.pageResponse, props.expManager.emEditorType);
                var columns = bobHandler_handleColumns(idx, counter, background1, props.pageResponse.globalStyles[background1.globalStyleId]);
                counter = columns.counter;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                        position: idx,
                        component: handledItem,
                        pageResponse: props.pageResponse,
                        selectedInstanceId: props.obj.selectedInstanceId,
                        matchOrder: props.matchOrder,
                        expManager: props.expManager
                    }, idx)
                }, idx);
            });
        }
    };
    var renderChilds = function(background1TemplateMerged) {
        // get only possible childs
        var childsId = props.obj.children;
        if (childsId && childsId.length > 0) return renderComponents(childsId, background1TemplateMerged);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                display: "flex",
                alignItems: "center",
                width: "100%",
                verticalAlign: "middle",
                height: "".concat(background1TemplateMerged.height.enable ? "100" : "100").concat(background1TemplateMerged.height.enable ? "%" : "px"),
                border: "3px dashed #dbe0e7"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "alert warning m-0",
                role: "alert",
                children: "Add results map, results list container, or filters component as a child to handle the chosen data set."
            })
        });
    };
    var background1 = isBobBackground(props.obj.styles.bobs.background1);
    var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "containers datase-container-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
            className: "row ".concat(bobHandler_responsiveGuttersClass(background1, props.pageResponse.globalStyles[background1.globalStyleId])),
            desktop: alignmentStyles,
            tablet: tabletAlignment,
            mobile: mobileAlignment,
            children: renderChilds(background1)
        })
    });
};
/* harmony default export */ var dataSetContainer = (DataSetContainer);

;// CONCATENATED MODULE: ./src/areas/public-page/fluxio-components/dataSetFilters/resultsList/resultsListContainer.tsx












var LoadMoreButtonStyle = {
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "16px",
    letterSpacing: "0px",
    lineHeight: "1",
    textAlign: "center",
    textTransform: "uppercase",
    color: "rgb(87, 109, 99)"
};
var ResultsListContainer = function(props) {
    var loadMoreResults = function() {
        props.actions.loadMoreDataSet(props.dataSet.uuid, props.dataSetFilterParams, props.dataSet.nextCursor);
    };
    var renderComponents = function(childComponent, background1Template) {
        var counter = {
            desktop: 0,
            tablet: 0,
            mobile: 0
        };
        var handledItem = handleObjectType(props.obj, childComponent, props.pageResponse, props.expManager.emEditorType);
        var columns = bobHandler_handleColumns(0, counter, background1Template, props.pageResponse.globalStyles[background1Template.globalStyleId]);
        counter = columns.counter;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                position: 0,
                component: handleDataSetAsContentBlock(handledItem, props.dataSet.posts, props.obj),
                pageResponse: props.pageResponse,
                selectedInstanceId: props.obj.selectedInstanceId,
                matchOrder: props.matchOrder,
                expManager: props.expManager
            }, 0)
        }, 0);
    };
    var renderPagination = function() {
        if (props.dataSet.nextCursor) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "d-flex align-items-center justify-content-center w-100 mt-4",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                //@ts-ignore
                style: LoadMoreButtonStyle,
                className: "btn btn-primeary btn-sm",
                disabled: props.fetchingLoadMoreDataSet,
                onClick: function() {
                    return loadMoreResults();
                },
                children: props.fetchingLoadMoreDataSet ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    style: {
                        color: "#6e6f75"
                    },
                    className: "fas fa-spinner fa-spin"
                }) : "Ver mais Resultados"
            })
        });
    };
    var renderChilds = function(background1Template) {
        var message = !props.dataSet ? "Select a DataSet to display its contents" : !props.dataSet.posts ? "No posts in this dataset" : "";
        if (!props.dataSet) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    verticalAlign: "middle",
                    height: "100px",
                    border: "3px dashed #dbe0e7"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "alert warning m-0",
                    role: "alert",
                    children: message
                })
            });
        } else if (!props.dataSet.posts || props.dataSet.posts && props.dataSet.posts.length === 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "d-flex align-items-center justify-content-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                    style: {
                        color: "#6e6f75"
                    },
                    children: "Sem resultados para a sua pesquisa."
                })
            });
        }
        // get only possible childs
        var childsId = props.obj.children;
        if (childsId && childsId.length > 0) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                renderComponents(childsId[0], background1Template),
                renderPagination()
            ]
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "d-flex align-items-center justify-content-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "alert warning m-0",
                role: "alert",
                children: "Add a child object to show results."
            })
        });
    };
    var background1 = mergeStyleWithGS(props.obj.styles.bobs.background1, props.pageResponse.globalStyles && props.pageResponse.globalStyles[props.obj.styles.bobs.background1.globalStyleId]);
    var ref = alignment(background1), alignmentStyles = ref.alignmentStyles, tabletAlignment = ref.tabletAlignment, mobileAlignment = ref.mobileAlignment;
    if (props.fetchingDataSet) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-flex align-items-center justify-content-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
            style: {
                color: "#6e6f75",
                fontSize: "35px"
            },
            className: "fa fa-spin fa-spinner"
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "datase-filter-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
            className: "row ".concat(bobHandler_responsiveGuttersClass(background1, props.pageResponse.globalStyles[background1.globalStyleId])),
            desktop: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, alignmentStyles), {
                flexDirection: "row"
            }),
            tablet: tabletAlignment,
            mobile: mobileAlignment,
            children: renderChilds(background1)
        })
    });
};
function mapDispatchToProps(dispatch) {
    return {
        actions: (0,redux/* bindActionCreators */.DE)({
            loadMoreDataSet: loadMoreDataSet
        }, dispatch)
    };
}
function resultsListContainer_mapStateToProps(state) {
    return {
        fetchingDataSet: state.publicPageReducer.server.fetchingDataSet,
        dataSet: state.publicPageReducer.server.dataSet,
        dataSetFilterParams: state.publicPageReducer.server.dataSetFilterParams,
        fetchingLoadMoreDataSet: state.publicPageReducer.server.fetchingLoadMoreDataSet
    };
}
/* harmony default export */ var resultsListContainer = ((0,es/* connect */.$j)(resultsListContainer_mapStateToProps, mapDispatchToProps)(ResultsListContainer));

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/forms/FormInputHandler/FormInputHandler.tsx











var FormInputHandler = function(props) {
    var handleProperBobField = function(bobType) {
        var objStyles = props.obj.styles;
        var bobRule = props.pageResponse.components[objStyles.component].bob;
        var properBobField = {}, component;
        for(component in bobRule){
            if (bobRule[component].name === bobType) {
                properBobField = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, properBobField), (0,src_define_property/* default */.Z)({}, bobRule[component].type, objStyles.bobs[component]));
            }
        }
        return properBobField;
    };
    var _obj;
    var inputs = (_obj = {}, (0,src_define_property/* default */.Z)(_obj, inputTypes_TEXT, function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(textInput, {
            position: props.position,
            obj: props.obj,
            inputObj: props.inputObj,
            componentRule: props.componentRule,
            delay: props.delay,
            error: props.formDataErrors[props.inputObj.id],
            handleValueChange: function(value) {
                return props.handleInputValue({
                    option: props.inputObj,
                    value: value
                });
            },
            bobStyle: handleProperBobField("text_input"),
            overrides: props.overrides,
            lang: props.lang,
            pageResponse: props.pageResponse,
            expManager: props.expManager
        }, props.inputObj.idx);
    }), (0,src_define_property/* default */.Z)(_obj, TEXTAREA, function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(textAreaInput, {
            position: props.position,
            obj: props.obj,
            inputObj: props.inputObj,
            componentRule: props.componentRule,
            error: props.formDataErrors[props.inputObj.id],
            handleValueChange: function(value) {
                return props.handleInputValue({
                    option: props.inputObj,
                    value: value
                });
            },
            bobStyle: handleProperBobField("text_input"),
            overrides: props.overrides,
            lang: props.lang,
            pageResponse: props.pageResponse,
            expManager: props.expManager
        }, props.inputObj.idx);
    }), (0,src_define_property/* default */.Z)(_obj, SELECT, function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(selectInput, {
            position: props.position,
            obj: props.obj,
            componentRule: props.componentRule,
            inputObj: props.inputObj,
            error: props.formDataErrors[props.inputObj.id],
            handleValueChange: function(value) {
                return props.handleInputValue({
                    option: props.inputObj,
                    value: value
                });
            },
            bobStyle: handleProperBobField("text_input"),
            overrides: props.overrides,
            lang: props.lang,
            pageResponse: props.pageResponse,
            expManager: props.expManager
        }, props.inputObj.idx);
    }), (0,src_define_property/* default */.Z)(_obj, FILE, function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(fileInput, {
            position: props.position,
            obj: props.obj,
            componentRule: props.componentRule,
            inputObj: props.inputObj,
            error: props.formDataErrors[props.inputObj.id],
            handleValueChange: function(value) {
                return props.handleInputValue({
                    option: props.inputObj,
                    value: value
                });
            },
            bobStyle: handleProperBobField("file_input"),
            overrides: props.overrides,
            lang: props.lang,
            pageResponse: props.pageResponse,
            expManager: props.expManager,
            formId: props.obj.styles.bobs.form1.formId
        }, props.inputObj.idx);
    }), (0,src_define_property/* default */.Z)(_obj, CHECKBOX, function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(checkboxInput, {
            position: props.position,
            obj: props.obj,
            componentRule: props.componentRule,
            inputObj: props.inputObj,
            error: props.formDataErrors[props.inputObj.id],
            bobText: props.obj.styles.bobs.text3,
            overrides: props.overrides,
            handleValueChange: function(value) {
                return props.handleInputValue({
                    option: props.inputObj,
                    value: value
                });
            },
            bobStyle: handleProperBobField("checkbox_input"),
            lang: props.lang,
            pageResponse: props.pageResponse,
            expManager: props.expManager
        }, props.inputObj.idx);
    }), _obj);
    return inputs[props.inputObj.fieldType || props.inputObj.field]();
};
/* harmony default export */ var FormInputHandler_FormInputHandler = (FormInputHandler);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/forms/FormInputHandler/index.ts

/* harmony default export */ var forms_FormInputHandler = (FormInputHandler_FormInputHandler);

;// CONCATENATED MODULE: ./src/areas/public-page/fluxio-components/dataSetFilters/dataSetFilter/dataSetFilter.tsx














var DataSetFilter = function(props) {
    var ref = (0,react.useState)({}), filterParams = ref[0], setFilterParams = ref[1];
    var isInitialMount = (0,react.useRef)(true);
    (0,react.useEffect)(function() {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            if (props.dataSet) props.actions.getDataSet(props.dataSet.uuid, filterParams);
        }
    }, [
        filterParams
    ]);
    var handleInputValue = function(selectedOption) {
        // handle clear filter
        if (selectedOption.value === "Sem filtro") {
            var newFilterParams = filterParams;
            delete newFilterParams[selectedOption.option.name];
            setFilterParams(newFilterParams);
        } else {
            // handle set filter
            setFilterParams((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, filterParams), (0,src_define_property/* default */.Z)({}, selectedOption.option.name, selectedOption.value)));
        }
    };
    var renderInputs = function(background1TemplateMerged) {
        var columns = bobHandler_handleColumns(0, {
            desktop: 0,
            tablet: 0,
            mobile: 0
        }, background1TemplateMerged, props.pageResponse.globalStyles[background1TemplateMerged.globalStyleId]);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "col-".concat(columns.columnsMobile, " col-md-").concat(columns.columnsTablet, " col-lg-").concat(columns.columns),
            children: props.dataSetFilters && props.dataSetFilters.map(function(filter, idx) {
                // add empty opton to clear filter
                filter.selectChoices = filter.selectChoices && filter.selectChoices[0] !== "Sem filtro" ? [
                    "Sem filtro"
                ].concat((0,src_to_consumable_array/* default */.Z)(filter.selectChoices)) : filter.selectChoices;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(forms_FormInputHandler, {
                    obj: props.obj,
                    componentRule: props.componentRule,
                    inputObj: (0,src_object_spread/* default */.Z)({}, filter),
                    lang: "pt",
                    delay: filter.fieldType === "text" ? 1000 : undefined,
                    position: props.position,
                    formDataErrors: [],
                    pageResponse: props.pageResponse,
                    expManager: props.expManager,
                    handleInputValue: function(value) {
                        return handleInputValue(value);
                    }
                }, idx);
            })
        });
    };
    var background1 = props.obj.styles.bobs.background1;
    var ref1 = alignment(background1), alignmentStyles = ref1.alignmentStyles, tabletAlignment = ref1.tabletAlignment, mobileAlignment = ref1.mobileAlignment;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        onSubmit: function(e) {
            e.preventDefault();
        },
        className: "datase-filter-component simple-form-component ".concat((simpleForm_module_default())["simple-form-component"]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alignmentHOC, {
            //TODO: typescript
            //@ts-ignore
            className: "row ".concat(responsiveGuttersClass(background1, props.pageResponse.globalStyles[background1.globalStyleId])),
            desktop: alignmentStyles,
            tablet: tabletAlignment,
            mobile: mobileAlignment,
            children: renderInputs(background1)
        })
    });
};
function dataSetFilter_mapDispatchToProps(dispatch) {
    return {
        actions: (0,redux/* bindActionCreators */.DE)({
            getDataSet: getDataSet
        }, dispatch)
    };
}
function dataSetFilter_mapStateToProps(state) {
    return {
        dataSet: state.publicPageReducer.server.dataSet,
        dataSetFilters: state.publicPageReducer.server.dataSetFilters
    };
}
/* harmony default export */ var dataSetFilter = ((0,es/* connect */.$j)(dataSetFilter_mapStateToProps, dataSetFilter_mapDispatchToProps)(DataSetFilter));

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/imageStyle.ts







//Temp to handle nulls
var imageStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
/**
 * We should only check for property and undefined
 * this solution is only until we fix the null being send around the page object
 */ // props only, no enable
var ImagePropsCodec = (0,es6/* type */.dt)({
    enable: es6/* boolean */.O7,
    size: (0,es6/* union */.G0)([
        (0,es6/* literal */.i0)("cover"),
        (0,es6/* literal */.i0)("contain"),
        (0,es6/* literal */.i0)("auto")
    ]),
    position: es6/* string */.Z_
});
var ImageCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    ImagePropsCodec
]);
// props only, no enable
var ImagePropsOptCodec = (0,es6/* partial */.r$)({
    size: imageStyle_nullable((0,es6/* union */.G0)([
        (0,es6/* literal */.i0)("cover"),
        (0,es6/* literal */.i0)("contain"),
        (0,es6/* literal */.i0)("auto")
    ])),
    position: imageStyle_nullable(es6/* string */.Z_)
});
var ImageOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: imageStyle_nullable(es6/* boolean */.O7)
    }),
    ImagePropsOptCodec
]);
var StylesImageCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        image: ImageCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                image: ImageOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                image: ImageOptCodec
            })
        }),
        mobile: (0,es6/* partial */.r$)({
            image: ImageOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    image: ImageOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    image: ImageOptCodec
                })
            })
        }),
        tablet: (0,es6/* partial */.r$)({
            image: ImageOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    image: ImageOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    image: ImageOptCodec
                })
            })
        })
    }), 
]);
var GSImageCodec = (0,es6/* intersection */.jV)([
    ImagePropsCodec,
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: ImagePropsOptCodec,
            hover: ImagePropsOptCodec
        }),
        mobile: (0,es6/* intersection */.jV)([
            ImagePropsOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: ImagePropsOptCodec,
                    hover: ImagePropsOptCodec
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            ImagePropsOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: ImagePropsOptCodec,
                    hover: ImagePropsOptCodec
                })
            }), 
        ])
    }), 
]);
function imageStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var foundationStyle = arguments.length > 3 && arguments[3] !== void 0 // TODO: fix when working on other bobs
     ? arguments[3] : undefined;
    var styles = StylesImageCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return imageStyle_cssRender(styles.right, breakpoint, behaviourState, foundationStyle);
    console.warn(codecUtils_decoderErrors(styles));
    return {};
}
function imageStyle_globalStyleCssRenderUnsafe(gsObj, breakpoint, behaviourState) {
    var foundationStyle = arguments.length > 3 && arguments[3] !== void 0 // TODO: Work on when foundation is added to global styles
     ? arguments[3] : undefined;
    var gs = GSImageCodec.decode(gsObj);
    if (isRight(gs)) return imageStyle_globalStyleCssRender(gs.right, breakpoint, behaviourState, foundationStyle);
    console.warn(decoderErrors(gs));
    return {};
}
function imageStyle_cssRender(stylesObj, breakpoint, behaviourState, foundationStyle) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return imageStyle_renderBob(stylesObj.image, foundationStyle);
        } else {
            var ref, ref1;
            return imageStyle_renderBobOpt(imageStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.image, stylesObj.image), foundationStyle);
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return imageStyle_renderBobOpt(imageStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.image, stylesObj.image), foundationStyle);
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return imageStyle_renderBobOpt(imageStyle_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.image, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.image, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.image, stylesObj.image), foundationStyle);
        }
    }
}
function imageStyle_globalStyleCssRender(stylesObj, breakpoint, behaviourState, foundationStyle) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return imageStyle_render(stylesObj, foundationStyle);
        } else {
            var ref;
            return imageStyle_renderOpt(imageStyle_merge2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : ref[behaviourState], stylesObj), foundationStyle);
        }
    } else {
        if (behaviourState === "default") {
            return imageStyle_renderOpt(imageStyle_merge2(stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj), foundationStyle);
        } else {
            var ref1, ref2, ref3;
            return imageStyle_renderOpt(imageStyle_merge3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref1 = stylesObj[breakpoint]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : ref2[behaviourState], (ref3 = stylesObj.behaviour) === null || ref3 === void 0 ? void 0 : ref3[behaviourState], stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj), foundationStyle);
        }
    }
}
function imageStyle_renderBob(imageObj, foundationStyle) {
    return imageStyle_render(imageObj, foundationStyle);
}
function imageStyle_renderBobOpt(imageObj, foundationStyle) {
    if (imageObj) return imageStyle_renderOpt(imageObj, foundationStyle);
    return {};
}
function imageStyle_render(imageObj, foundationStyle) {
    return {
        "object-position": imageObj.position,
        "object-fit": imageObj.size
    };
}
function imageStyle_renderOpt(imageObj, foundationStyle) {
    var css = {};
    if (valueExists(imageObj === null || imageObj === void 0 ? void 0 : imageObj.position)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "object-position": imageObj === null || imageObj === void 0 ? void 0 : imageObj.position
    });
    if (valueExists(imageObj === null || imageObj === void 0 ? void 0 : imageObj.size)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "object-fit": imageObj === null || imageObj === void 0 ? void 0 : imageObj.size
    });
    return css;
}
function imageStyle_cssProperty(cssValue) {
    return {
        "object-fit": cssValue,
        "object-position": cssValue
    };
}
/**
 *
 * @param imageObj
 * @param defaultImageObj
 * @returns Image
 *
 */ function imageStyle_mergeBob2(imageObj, defaultImageObj) {
    var enable = get2WithNull4Enable(imageObj === null || imageObj === void 0 ? void 0 : imageObj.enable, defaultImageObj.enable);
    return {
        enable: enable,
        position: imageObj === null || imageObj === void 0 ? void 0 : imageObj.position,
        size: imageObj === null || imageObj === void 0 ? void 0 : imageObj.size
    };
}
/**
 *
 * @param imageObj
 * @param defaultImageObj
 * @returns ImageProps
 *
 */ function imageStyle_merge2(imageObj, defaultImageObj) {
    var position = get2WithNull(imageObj === null || imageObj === void 0 ? void 0 : imageObj.position, defaultImageObj.position);
    var size = get2WithNull(imageObj === null || imageObj === void 0 ? void 0 : imageObj.size, defaultImageObj.size);
    return {
        position: position,
        size: size
    };
}
/**
 *
 * @param imageObj
 * @param imageDefaultBreakpoint
 * @param defaultImageObj
 * @returns Image
 */ function imageStyle_mergeBob3(imageObj, imageDesktopBehaviour, imageDefaultBreakpoint, defaultImageObj) {
    var enable = get3WithNull4Enable(imageObj === null || imageObj === void 0 ? void 0 : imageObj.enable, imageDesktopBehaviour === null || imageDesktopBehaviour === void 0 ? void 0 : imageDesktopBehaviour.enable, imageDefaultBreakpoint === null || imageDefaultBreakpoint === void 0 ? void 0 : imageDefaultBreakpoint.enable, defaultImageObj.enable);
    return {
        enable: enable,
        position: imageObj === null || imageObj === void 0 ? void 0 : imageObj.position,
        size: imageObj === null || imageObj === void 0 ? void 0 : imageObj.size
    };
}
/**
 *
 * @param imageObj
 * @param imageDefaultBreakpoint
 * @param defaultImageObj
 * @returns Image
 */ function imageStyle_merge3(imageObj, imageDesktopBehaviour, imageDefaultBreakpoint, defaultImageObj) {
    var ref, ref1, ref2;
    var position = (ref2 = (ref1 = (ref = imageObj === null || imageObj === void 0 ? void 0 : imageObj.position) !== null && ref !== void 0 ? ref : imageDesktopBehaviour === null || imageDesktopBehaviour === void 0 ? void 0 : imageDesktopBehaviour.position) !== null && ref1 !== void 0 ? ref1 : imageDefaultBreakpoint === null || imageDefaultBreakpoint === void 0 ? void 0 : imageDefaultBreakpoint.position) !== null && ref2 !== void 0 ? ref2 : defaultImageObj.position;
    var ref3, ref4, ref5;
    var size = (ref5 = (ref4 = (ref3 = imageObj === null || imageObj === void 0 ? void 0 : imageObj.size) !== null && ref3 !== void 0 ? ref3 : imageDesktopBehaviour === null || imageDesktopBehaviour === void 0 ? void 0 : imageDesktopBehaviour.size) !== null && ref4 !== void 0 ? ref4 : imageDefaultBreakpoint === null || imageDefaultBreakpoint === void 0 ? void 0 : imageDefaultBreakpoint.size) !== null && ref5 !== void 0 ? ref5 : defaultImageObj.size;
    return {
        position: position,
        size: size
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobMediaV2/mediaImage/mediaImage.tsx




function mediaImage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all ",
        " {\n            &:hover {\n              ",
        "\n            }\n          }\n        "
    ]);
    mediaImage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function mediaImage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    &:hover {\n                      ",
        "\n                    }\n                  "
    ]);
    mediaImage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function mediaImage_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all and (max-width: 992px) and (min-width: 767px) {\n            ",
        "\n            ",
        "\n          }\n        "
    ]);
    mediaImage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function mediaImage_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    &:hover {\n                      ",
        "\n                    }\n                  "
    ]);
    mediaImage_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function mediaImage_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all and (max-width: 766px) {\n            ",
        "\n            ",
        "\n          }\n        "
    ]);
    mediaImage_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function mediaImage_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n",
        "\n\n",
        "\n"
    ]);
    mediaImage_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


// @ts-ignore












var MediaImageImg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-95ed2ac5-0"
})(mediaImage_templateObject5(), function(props) {
    return props.desktop;
}, function(props) {
    return props.hover.isEnabled.desktop ? (0,styled_components_browser_esm/* css */.iv)(mediaImage_templateObject(), handleMediaQueryRestrictions(props.hover.isEnabled.mobile, props.hover.isEnabled.tablet), props.hover.desktop) : {};
}, function(props) {
    return Object.keys(props.tablet).length > 0 || Object.keys(props.hover.tablet).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(mediaImage_templateObject2(), function(props) {
        return props.tablet;
    }, function(props) {
        return props.hover.isEnabled.tablet && Object.keys(props.hover.tablet).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(mediaImage_templateObject1(), props.hover.tablet) : {};
    }) : {};
}, function(props) {
    return Object.keys(props.mobile).length > 0 || Object.keys(props.hover.mobile).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(mediaImage_templateObject4(), function(props) {
        return props.mobile;
    }, function(props) {
        return props.hover.isEnabled.mobile && Object.keys(props.hover.mobile).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(mediaImage_templateObject3(), props.hover.mobile) : {};
    }) : {};
});
var MediaImage = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,react.useState)(/*#__PURE__*/ react.createRef()), imgRef = ref6[0];
    var ref7 = (0,react.useState)(false), isHover = ref7[0], setIsHover = ref7[1];
    (0,react.useEffect)(function() {
        props.setRef && props.setRef(imgRef);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var mediaStyles = isNbobNmedia(props.object.styles.bobs.nmedia1);
    var settings = props.object.settings;
    var pageLabels = (ref = props.pageResponse.stylesheet) === null || ref === void 0 ? void 0 : ref.labels;
    /**
   * Styles
   */ var desktopStyles = (0,src_object_spread/* default */.Z)({}, imageStyle_cssRenderUnsafe(mediaStyles, "desktop", "default"), bobMediaV2Handler_responsiveStyles(mediaStyles, pageLabels, "desktop", "default"));
    var mobileStyles = (0,src_object_spread/* default */.Z)({}, imageStyle_cssRenderUnsafe(mediaStyles, "mobile", "default"), bobMediaV2Handler_responsiveStyles(mediaStyles, pageLabels, "mobile", "default"));
    var tabletStyles = (0,src_object_spread/* default */.Z)({}, imageStyle_cssRenderUnsafe(mediaStyles, "tablet", "default"), bobMediaV2Handler_responsiveStyles(mediaStyles, pageLabels, "tablet", "default"));
    var hoverStyles = handleStateStyles(mediaStyles, (0,src_object_spread/* default */.Z)({}, imageStyle_cssRenderUnsafe(mediaStyles, "desktop", "hover"), bobMediaV2Handler_responsiveStyles(mediaStyles, pageLabels, "desktop", "hover")), (0,src_object_spread/* default */.Z)({}, imageStyle_cssRenderUnsafe(mediaStyles, "tablet", "hover"), bobMediaV2Handler_responsiveStyles(mediaStyles, pageLabels, "tablet", "hover")), (0,src_object_spread/* default */.Z)({}, imageStyle_cssRenderUnsafe(mediaStyles, "mobile", "hover"), bobMediaV2Handler_responsiveStyles(mediaStyles, pageLabels, "mobile", "hover")));
    // hoverStyles.desktop?.fontSize TODO: typed styles cannot return {}
    var imageOnHover = function() {
        var ref;
        if ((ref = mediaStyles.behaviour.hover) === null || ref === void 0 ? void 0 : ref.enable) setIsHover(true);
    };
    var imageUnHover = function() {
        var ref;
        if ((ref = mediaStyles.behaviour.hover) === null || ref === void 0 ? void 0 : ref.enable) setIsHover(false);
    };
    // RESPONSIVE_MEDIA const fallbackTabletSrc =
    //   tabletMedia?.fallbackExtension && tabletMedia?.mediaInfo
    //     ? `https://static-media.fluxio.cloud/${
    //         tabletMedia.mediaInfo.profileName
    //       }/${tabletMedia.mediaInfo.id}${
    //         tabletMedia.mediaInfo.version
    //           ? `_${tabletMedia.mediaInfo.version}`
    //           : ""
    //       }.${fallbackExtension}`
    //     : undefined
    // const fallbackMobileSrc =
    //   mobileMedia?.fallbackExtension && mobileMedia?.mediaInfo
    //     ? `https://static-media.fluxio.cloud/${
    //         mobileMedia.mediaInfo.profileName
    //       }/${mobileMedia.mediaInfo.id}${
    //         mobileMedia.mediaInfo.version
    //           ? `_${mobileMedia.mediaInfo.version}`
    //           : ""
    //       }.${fallbackExtension}`
    //     : undefined
    var DOMid = props.expManager.enable ? {
        id: "".concat(handleDOMid(props.field, props.object.uuid, props.instanceId))
    } : {};
    var EMpreviewClass = emPreviewClass(props.expManager.enable, mediaStyles.uuid);
    var EMScrollId = emScrollId(props.expManager.enable, props.object.uuid);
    var _obj;
    var GlobalStylesClass = globalStylesUtils.handleClassNameV2(props.pageResponse.nGlobalStyles, mediaStyles, "-box", (_obj = {}, (0,src_define_property/* default */.Z)(_obj, GS_SHADOW, NGS_CLASS_SUFIX), (0,src_define_property/* default */.Z)(_obj, GS_BOUNDARY, NGS_CLASS_SUFIX), _obj));
    var customClasses = (settings === null || settings === void 0 ? void 0 : (ref1 = settings[props.field]) === null || ref1 === void 0 ? void 0 : ref1.class) ? " ".concat(settings === null || settings === void 0 ? void 0 : (ref2 = settings[props.field]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.class) === null || ref3 === void 0 ? void 0 : ref3.join(" ")) : "";
    var classes = "".concat(EMpreviewClass).concat(GlobalStylesClass ? " ".concat(GlobalStylesClass) : "").concat(customClasses);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(build.LazyLoadComponent, {
        threshold: loadThreshold(props.media.defaultMedia.size),
        visibleByDefault: props.expManager.enable,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaImageImg, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                as: "img",
                desktop: desktopStyles,
                mobile: mobileStyles,
                tablet: tabletStyles,
                hover: hoverStyles,
                ref: imgRef
            }, DOMid, EMScrollId), {
                className: classes,
                src: handleImageSrcTemplate(isHover, props.media.defaultMedia.url, (ref4 = props.media.hoverMedia) === null || ref4 === void 0 ? void 0 : ref4.url),
                alt: props.media.defaultMedia.alt,
                onMouseEnter: function() {
                    return imageOnHover();
                },
                onMouseLeave: function() {
                    return imageUnHover();
                },
                onError: function(node) {
                    return mediaStyles.behaviour && !mediaStyles.behaviour.hover.enable ? node.target.style.display = "none" : undefined;
                }
            })),
            isHoverEnabled(mediaStyles) && props.media.hoverMedia && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    backgroundImage: "url(".concat((ref5 = props.media.hoverMedia) === null || ref5 === void 0 ? void 0 : ref5.url, ")"),
                    display: "none"
                }
            })
        ]
    });
};
/* harmony default export */ var mediaImage = (MediaImage);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/videoStyle.ts







//Temp to handle nulls
var videoStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
/**
 * We should only check for property and undefined
 * this solution is only until we fix the null being send around the page object
 */ // props only, no enable
var VideoPropsCodec = (0,es6/* type */.dt)({
    enable: es6/* boolean */.O7,
    size: (0,es6/* union */.G0)([
        (0,es6/* literal */.i0)("cover"),
        (0,es6/* literal */.i0)("contain"),
        (0,es6/* literal */.i0)("auto")
    ]),
    position: es6/* string */.Z_
});
var VideoCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        enable: es6/* boolean */.O7
    }),
    VideoPropsCodec
]);
// props only, no enable
var VideoPropsOptCodec = (0,es6/* partial */.r$)({
    size: videoStyle_nullable((0,es6/* union */.G0)([
        (0,es6/* literal */.i0)("cover"),
        (0,es6/* literal */.i0)("contain"),
        (0,es6/* literal */.i0)("auto")
    ])),
    position: videoStyle_nullable(es6/* string */.Z_)
});
var VideoOptCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        enable: videoStyle_nullable(es6/* boolean */.O7)
    }),
    VideoPropsOptCodec
]);
var StylesVideoCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        video: VideoCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                video: VideoOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                video: VideoOptCodec
            })
        }),
        mobile: (0,es6/* partial */.r$)({
            video: VideoOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    video: VideoOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    video: VideoOptCodec
                })
            })
        }),
        tablet: (0,es6/* partial */.r$)({
            video: VideoOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    video: VideoOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    video: VideoOptCodec
                })
            })
        })
    }), 
]);
var GSVideoCodec = (0,es6/* intersection */.jV)([
    VideoPropsCodec,
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: VideoPropsOptCodec,
            hover: VideoPropsOptCodec
        }),
        mobile: (0,es6/* intersection */.jV)([
            VideoPropsOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: VideoPropsOptCodec,
                    hover: VideoPropsOptCodec
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            VideoPropsOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: VideoPropsOptCodec,
                    hover: VideoPropsOptCodec
                })
            }), 
        ])
    }), 
]);
function videoStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var foundationStyle = arguments.length > 3 && arguments[3] !== void 0 // TODO: fix when working on other bobs
     ? arguments[3] : undefined;
    var styles = StylesVideoCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return videoStyle_cssRender(styles.right, breakpoint, behaviourState, foundationStyle);
    console.warn(codecUtils_decoderErrors(styles));
    return {};
}
function videoStyle_globalStyleCssRenderUnsafe(gsObj, breakpoint, behaviourState) {
    var foundationStyle = arguments.length > 3 && arguments[3] !== void 0 // TODO: Work on when foundation is added to global styles
     ? arguments[3] : undefined;
    var gs = GSVideoCodec.decode(gsObj);
    if (isRight(gs)) return videoStyle_globalStyleCssRender(gs.right, breakpoint, behaviourState, foundationStyle);
    console.warn(decoderErrors(gs));
    return {};
}
function videoStyle_cssRender(stylesObj, breakpoint, behaviourState, foundationStyle) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return videoStyle_renderBob(stylesObj.video, foundationStyle);
        } else {
            var ref, ref1;
            return videoStyle_renderBobOpt(videoStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.video, stylesObj.video), foundationStyle);
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return videoStyle_renderBobOpt(videoStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.video, stylesObj.video), foundationStyle);
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return videoStyle_renderBobOpt(videoStyle_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.video, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.video, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.video, stylesObj.video), foundationStyle);
        }
    }
}
function videoStyle_globalStyleCssRender(stylesObj, breakpoint, behaviourState, foundationStyle) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return videoStyle_render(stylesObj, foundationStyle);
        } else {
            var ref;
            return videoStyle_renderOpt(videoStyle_merge2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : ref[behaviourState], stylesObj), foundationStyle);
        }
    } else {
        if (behaviourState === "default") {
            return videoStyle_renderOpt(videoStyle_merge2(stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj), foundationStyle);
        } else {
            var ref1, ref2, ref3;
            return videoStyle_renderOpt(videoStyle_merge3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref1 = stylesObj[breakpoint]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : ref2[behaviourState], (ref3 = stylesObj.behaviour) === null || ref3 === void 0 ? void 0 : ref3[behaviourState], stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint], stylesObj), foundationStyle);
        }
    }
}
function videoStyle_renderBob(videoObj, foundationStyle) {
    return videoStyle_render(videoObj, foundationStyle);
}
function videoStyle_renderBobOpt(videoObj, foundationStyle) {
    if (videoObj) return videoStyle_renderOpt(videoObj, foundationStyle);
    return {};
}
function videoStyle_render(videoObj, foundationStyle) {
    return {
        "object-position": videoObj.position,
        "object-fit": videoObj.size
    };
}
function videoStyle_renderOpt(videoObj, foundationStyle) {
    var css = {};
    if (valueExists(videoObj === null || videoObj === void 0 ? void 0 : videoObj.position)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "object-position": videoObj === null || videoObj === void 0 ? void 0 : videoObj.position
    });
    if (valueExists(videoObj === null || videoObj === void 0 ? void 0 : videoObj.size)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "object-fit": videoObj === null || videoObj === void 0 ? void 0 : videoObj.size
    });
    return css;
}
function videoStyle_cssProperty(cssValue) {
    return {
        "object-fit": cssValue,
        "object-position": cssValue
    };
}
/**
 *
 * @param videoObj
 * @param defaultVideoObj
 * @returns Video
 *
 */ function videoStyle_mergeBob2(videoObj, defaultVideoObj) {
    var enable = get2WithNull4Enable(videoObj === null || videoObj === void 0 ? void 0 : videoObj.enable, defaultVideoObj.enable);
    return {
        enable: enable,
        position: videoObj === null || videoObj === void 0 ? void 0 : videoObj.position,
        size: videoObj === null || videoObj === void 0 ? void 0 : videoObj.size
    };
}
/**
 *
 * @param videoObj
 * @param defaultVideoObj
 * @returns VideoProps
 *
 */ function videoStyle_merge2(videoObj, defaultVideoObj) {
    var position = get2WithNull(videoObj === null || videoObj === void 0 ? void 0 : videoObj.position, defaultVideoObj.position);
    var size = get2WithNull(videoObj === null || videoObj === void 0 ? void 0 : videoObj.size, defaultVideoObj.size);
    return {
        position: position,
        size: size
    };
}
/**
 *
 * @param videoObj
 * @param videoDefaultBreakpoint
 * @param defaultVideoObj
 * @returns Video
 */ function videoStyle_mergeBob3(videoObj, videoDesktopBehaviour, videoDefaultBreakpoint, defaultVideoObj) {
    var enable = get3WithNull4Enable(videoObj === null || videoObj === void 0 ? void 0 : videoObj.enable, videoDesktopBehaviour === null || videoDesktopBehaviour === void 0 ? void 0 : videoDesktopBehaviour.enable, videoDefaultBreakpoint === null || videoDefaultBreakpoint === void 0 ? void 0 : videoDefaultBreakpoint.enable, defaultVideoObj.enable);
    return {
        enable: enable,
        position: videoObj === null || videoObj === void 0 ? void 0 : videoObj.position,
        size: videoObj === null || videoObj === void 0 ? void 0 : videoObj.size
    };
}
/**
 *
 * @param videoObj
 * @param videoDefaultBreakpoint
 * @param defaultVideoObj
 * @returns Video
 */ function videoStyle_merge3(videoObj, videoDesktopBehaviour, videoDefaultBreakpoint, defaultVideoObj) {
    var ref, ref1, ref2;
    var position = (ref2 = (ref1 = (ref = videoObj === null || videoObj === void 0 ? void 0 : videoObj.position) !== null && ref !== void 0 ? ref : videoDesktopBehaviour === null || videoDesktopBehaviour === void 0 ? void 0 : videoDesktopBehaviour.position) !== null && ref1 !== void 0 ? ref1 : videoDefaultBreakpoint === null || videoDefaultBreakpoint === void 0 ? void 0 : videoDefaultBreakpoint.position) !== null && ref2 !== void 0 ? ref2 : defaultVideoObj.position;
    var ref3, ref4, ref5;
    var size = (ref5 = (ref4 = (ref3 = videoObj === null || videoObj === void 0 ? void 0 : videoObj.size) !== null && ref3 !== void 0 ? ref3 : videoDesktopBehaviour === null || videoDesktopBehaviour === void 0 ? void 0 : videoDesktopBehaviour.size) !== null && ref4 !== void 0 ? ref4 : videoDefaultBreakpoint === null || videoDefaultBreakpoint === void 0 ? void 0 : videoDefaultBreakpoint.size) !== null && ref5 !== void 0 ? ref5 : defaultVideoObj.size;
    return {
        position: position,
        size: size
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobMediaV2/mediaVideo/videoPlayer.tsx




var VideoPlayer = function(props) {
    var ref = (0,react.useState)(/*#__PURE__*/ react.createRef()), videoRef = ref[0];
    (0,react.useEffect)(function() {
        props.setRef && props.setRef(videoRef);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (props.playing === true) (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.play();
        if (props.playing === false) (ref1 = videoRef.current) === null || ref1 === void 0 ? void 0 : ref1.pause();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.playing
    ]);
    var DOMid = props.id ? {
        id: props.id
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("video", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, DOMid), {
        ref: videoRef,
        src: props.url,
        controls: props.controls,
        poster: props.poster,
        preload: props.preload,
        className: props.className,
        style: props.style
    }));
};
/* harmony default export */ var videoPlayer = (VideoPlayer);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobMediaV2/mediaVideo/videoPlayerLazy.tsx



var VideoPlayerLazy = function(props) {
    // <ReactPlayer> must render client side to work, hasLoaded enforces that
    var ref = (0,react.useState)(false), hasLoaded = ref[0], setHasLoaded = ref[1];
    (0,react.useEffect)(function() {
        setHasLoaded(true);
    }, []);
    if (hasLoaded) return /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy/* default */.Z, {
        url: props.url,
        controls: props.controls,
        config: props.config,
        width: "100%",
        height: "100%"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var videoPlayerLazy = (VideoPlayerLazy);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobMediaV2/mediaVideo/videoPlayerCustom.tsx



function videoPlayerCustom_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all ",
        " {\n            &:hover {\n              ",
        "\n            }\n          }\n        "
    ]);
    videoPlayerCustom_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function videoPlayerCustom_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    &:hover {\n                      ",
        "\n                    }\n                  "
    ]);
    videoPlayerCustom_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function videoPlayerCustom_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all and (max-width: 992px) and (min-width: 767px) {\n            ",
        "\n            ",
        "\n          }\n        "
    ]);
    videoPlayerCustom_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function videoPlayerCustom_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    &:hover {\n                      ",
        "\n                    }\n                  "
    ]);
    videoPlayerCustom_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function videoPlayerCustom_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all and (max-width: 766px) {\n            ",
        "\n            ",
        "\n          }\n        "
    ]);
    videoPlayerCustom_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function videoPlayerCustom_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n",
        "\n\n",
        "\n"
    ]);
    videoPlayerCustom_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all ",
        " {\n            &:hover {\n              ",
        "\n            }\n          }\n        "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    &:hover {\n                      ",
        "\n                    }\n                  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all and (max-width: 992px) and (min-width: 767px) {\n            ",
        "\n            ",
        "\n          }\n        "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    &:hover {\n                      ",
        "\n                    }\n                  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all and (max-width: 766px) {\n            ",
        "\n            ",
        "\n          }\n        "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n",
        "\n\n",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}







var CustomVideoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7ca8e40b-0"
})(videoPlayerCustom_templateObject5(), function(props) {
    return props.desktop;
}, function(props) {
    return props.hover.isEnabled.desktop ? (0,styled_components_browser_esm/* css */.iv)(videoPlayerCustom_templateObject(), handleMediaQueryRestrictions(props.hover.isEnabled.mobile, props.hover.isEnabled.tablet), props.hover.desktop) : {};
}, function(props) {
    return Object.keys(props.tablet).length > 0 || Object.keys(props.hover.tablet).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(videoPlayerCustom_templateObject2(), function(props) {
        return props.tablet;
    }, function(props) {
        return props.hover.isEnabled.tablet && Object.keys(props.hover.tablet).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(videoPlayerCustom_templateObject1(), props.hover.tablet) : {};
    }) : {};
}, function(props) {
    return Object.keys(props.mobile).length > 0 || Object.keys(props.hover.mobile).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(videoPlayerCustom_templateObject4(), function(props) {
        return props.mobile;
    }, function(props) {
        return props.hover.isEnabled.mobile && Object.keys(props.hover.mobile).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(videoPlayerCustom_templateObject3(), props.hover.mobile) : {};
    }) : {};
});
var CustomVideo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7ca8e40b-1"
})(_templateObject11(), function(props) {
    return props.desktop;
}, function(props) {
    return props.hover.isEnabled.desktop ? (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), handleMediaQueryRestrictions(props.hover.isEnabled.mobile, props.hover.isEnabled.tablet), props.hover.desktop) : {};
}, function(props) {
    return Object.keys(props.tablet).length > 0 || Object.keys(props.hover.tablet).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(_templateObject8(), function(props) {
        return props.tablet;
    }, function(props) {
        return props.hover.isEnabled.tablet && Object.keys(props.hover.tablet).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), props.hover.tablet) : {};
    }) : {};
}, function(props) {
    return Object.keys(props.mobile).length > 0 || Object.keys(props.hover.mobile).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(_templateObject10(), function(props) {
        return props.mobile;
    }, function(props) {
        return props.hover.isEnabled.mobile && Object.keys(props.hover.mobile).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(_templateObject9(), props.hover.mobile) : {};
    }) : {};
});
var VideoPlayerCustom = function(props) {
    var ref;
    var ref1 = (0,react.useState)(false), isPlaying = ref1[0], setIsPlaying = ref1[1];
    var pageLabels = (ref = props.stylesheet) === null || ref === void 0 ? void 0 : ref.labels;
    var desktopContainerStyles = bobMediaV2Handler_responsiveStyles(props.mediaStyles, pageLabels, "desktop", "default");
    var tabletContainerStyles = bobMediaV2Handler_responsiveStyles(props.mediaStyles, pageLabels, "tablet", "default");
    var mobileContainerStyles = bobMediaV2Handler_responsiveStyles(props.mediaStyles, pageLabels, "mobile", "default");
    var hoverContainerStyles = handleStateStyles(props.mediaStyles, bobMediaV2Handler_responsiveStyles(props.mediaStyles, pageLabels, "desktop", "hover"), bobMediaV2Handler_responsiveStyles(props.mediaStyles, pageLabels, "tablet", "hover"), bobMediaV2Handler_responsiveStyles(props.mediaStyles, pageLabels, "mobile", "hover"));
    var desktopVideoStyles = (0,src_object_spread/* default */.Z)({}, videoStyle_cssRenderUnsafe(props.mediaStyles, "desktop", "default"));
    var tabletVideoStyles = (0,src_object_spread/* default */.Z)({}, videoStyle_cssRenderUnsafe(props.mediaStyles, "tablet", "default"));
    var mobileVideoStyles = (0,src_object_spread/* default */.Z)({}, videoStyle_cssRenderUnsafe(props.mediaStyles, "mobile", "default"));
    var hoverStyles = handleStateStyles(props.mediaStyles, videoStyle_cssRenderUnsafe(props.mediaStyles, "desktop", "hover"), videoStyle_cssRenderUnsafe(props.mediaStyles, "tablet", "hover"), videoStyle_cssRenderUnsafe(props.mediaStyles, "mobile", "hover"));
    var DOMid = props.id ? {
        id: props.id
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomVideoContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, DOMid), {
        desktop: desktopContainerStyles,
        tablet: tabletContainerStyles,
        mobile: mobileContainerStyles,
        hover: hoverContainerStyles,
        className: "custom-video-player " + props.className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "play-pause-wrap",
                onClick: function() {
                    return setIsPlaying(!isPlaying);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "play-pause-asset-wrapp play-pause-asset ".concat(isPlaying ? "playing" : "paused"),
                    src: props.playPauseAsset,
                    alt: "play"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomVideo, {
                as: videoPlayer,
                setRef: function(mediaRef) {
                    return props.setRef(mediaRef);
                },
                desktop: desktopVideoStyles,
                tablet: tabletVideoStyles,
                mobile: mobileVideoStyles,
                hover: hoverStyles,
                className: "",
                style: {
                    width: "100%",
                    height: "100%"
                },
                playing: isPlaying,
                url: props.url,
                controls: props.controls,
                poster: props.poster,
                preload: props.preload
            })
        ]
    }));
};
/* harmony default export */ var videoPlayerCustom = (VideoPlayerCustom);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobMediaV2/mediaVideo/mediaVideo.tsx




function mediaVideo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all ",
        " {\n            &:hover {\n              ",
        "\n            }\n          }\n        "
    ]);
    mediaVideo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function mediaVideo_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    &:hover {\n                      ",
        "\n                    }\n                  "
    ]);
    mediaVideo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function mediaVideo_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all and (max-width: 992px) and (min-width: 767px) {\n            ",
        "\n            ",
        "\n          }\n        "
    ]);
    mediaVideo_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function mediaVideo_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    &:hover {\n                      ",
        "\n                    }\n                  "
    ]);
    mediaVideo_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function mediaVideo_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all and (max-width: 766px) {\n            ",
        "\n            ",
        "\n          }\n        "
    ]);
    mediaVideo_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function mediaVideo_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    mediaVideo_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


// @ts-ignore














var VideoComponent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64151ad4-0"
})(mediaVideo_templateObject5(), function(props) {
    return props.desktop;
}, function(props) {
    return props.hover.isEnabled.desktop ? (0,styled_components_browser_esm/* css */.iv)(mediaVideo_templateObject(), handleMediaQueryRestrictions(props.hover.isEnabled.mobile, props.hover.isEnabled.tablet), props.hover.desktop) : {};
}, function(props) {
    return Object.keys(props.tablet).length > 0 || Object.keys(props.hover.tablet).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(mediaVideo_templateObject2(), function(props) {
        return props.tablet;
    }, function(props) {
        return props.hover.isEnabled.tablet && Object.keys(props.hover.tablet).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(mediaVideo_templateObject1(), props.hover.tablet) : {};
    }) : {};
}, function(props) {
    return Object.keys(props.mobile).length > 0 || Object.keys(props.hover.mobile).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(mediaVideo_templateObject4(), function(props) {
        return props.mobile;
    }, function(props) {
        return props.hover.isEnabled.mobile && Object.keys(props.hover.mobile).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(mediaVideo_templateObject3(), props.hover.mobile) : {};
    }) : {};
});
// TODO: reduce props
var MediaVideo = function(props) {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)(/*#__PURE__*/ react.createRef()), videoRef = ref4[0];
    (0,react.useEffect)(function() {
        // only direct link render sets the ref here,
        // the other refs are create inside each video component.
        // this setRef conflicts with other video components setRef, so it must only run for direct link
        if (props.media.defaultMedia.isDirectLink) props.setRef && props.setRef(videoRef);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) // TODO: add deps
    ;
    var mediaStyles = isNbobNmedia(props.object.styles.bobs.nmedia1);
    var inlineContent = props.object.content.inlineContent;
    var settings = props.object.settings;
    var pageLabels = (ref = props.pageResponse.stylesheet) === null || ref === void 0 ? void 0 : ref.labels;
    /**
   * Styles
   */ var desktopStyles = (0,src_object_spread/* default */.Z)({}, videoStyle_cssRenderUnsafe(mediaStyles, "desktop", "default"), bobMediaV2Handler_responsiveStyles(mediaStyles, pageLabels, "desktop", "default"));
    var mobileStyles = (0,src_object_spread/* default */.Z)({}, videoStyle_cssRenderUnsafe(mediaStyles, "mobile", "default"), bobMediaV2Handler_responsiveStyles(mediaStyles, pageLabels, "mobile", "default"));
    var tabletStyles = (0,src_object_spread/* default */.Z)({}, videoStyle_cssRenderUnsafe(mediaStyles, "tablet", "default"), bobMediaV2Handler_responsiveStyles(mediaStyles, pageLabels, "tablet", "default"));
    var hoverStyles = handleStateStyles(mediaStyles, (0,src_object_spread/* default */.Z)({}, videoStyle_cssRenderUnsafe(mediaStyles, "desktop", "hover"), bobMediaV2Handler_responsiveStyles(mediaStyles, pageLabels, "desktop", "hover")), (0,src_object_spread/* default */.Z)({}, videoStyle_cssRenderUnsafe(mediaStyles, "tablet", "hover"), bobMediaV2Handler_responsiveStyles(mediaStyles, pageLabels, "tablet", "hover")), (0,src_object_spread/* default */.Z)({}, videoStyle_cssRenderUnsafe(mediaStyles, "mobile", "hover"), bobMediaV2Handler_responsiveStyles(mediaStyles, pageLabels, "mobile", "hover")));
    /**
   * Here we get the thumbnail to be used has a poster.
   * The poster attribute is sended to the ReactPlayer
   * when a valid string is present.
   */ var Poster = components_getOverrideInlineContentValues("".concat(props.field, ".thumbnail"), {
        inlineContent: inlineContent,
        overrides: props.overrides
    });
    var Preload = Poster && Poster !== "" ? "none" : "auto";
    var config = {
        file: {
            attributes: {
                poster: Poster,
                preload: Preload
            }
        }
    };
    /**
   * The controls must come with a false written, to disable them, else we show it
   * since the inlineContent can come empty
   */ var controls = components_getOverrideInlineContentValues("".concat(props.field, ".controls"), {
        inlineContent: inlineContent,
        overrides: props.overrides
    });
    /**
   * For the playPauseAsset to be used, the controls must be false,
   * since the user loses the ability to play/pause the video with the browser player,
   * this asset will control that.
   */ var playPauseAsset = components_getOverrideInlineContentValues("".concat(props.field, ".playPauseAsset"), {
        inlineContent: inlineContent,
        overrides: props.overrides
    });
    var DOMid = props.expManager.enable ? {
        id: "".concat(handleDOMid(props.field, props.object.uuid, props.instanceId))
    } : {};
    var EMpreviewClass = emPreviewClass(props.expManager.enable, mediaStyles.uuid);
    var EMScrollId = emScrollId(props.expManager.enable, props.object.uuid);
    var _obj;
    var GlobalStylesClass = globalStylesUtils.handleClassNameV2(props.pageResponse.nGlobalStyles, mediaStyles, "-box", (_obj = {}, (0,src_define_property/* default */.Z)(_obj, GS_SHADOW, NGS_CLASS_SUFIX), (0,src_define_property/* default */.Z)(_obj, GS_BOUNDARY, NGS_CLASS_SUFIX), _obj));
    var customClasses = (settings === null || settings === void 0 ? void 0 : (ref1 = settings[props.field]) === null || ref1 === void 0 ? void 0 : ref1.class) ? " ".concat(settings === null || settings === void 0 ? void 0 : (ref2 = settings[props.field]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.class) === null || ref3 === void 0 ? void 0 : ref3.join(" ")) : "";
    var classes = "".concat(EMpreviewClass).concat(GlobalStylesClass ? " ".concat(GlobalStylesClass) : "").concat(customClasses);
    // media library default video player
    var Video = /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoComponent, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        setRef: function(mediaRef) {
            return props.setRef(mediaRef);
        },
        as: videoPlayer,
        desktop: desktopStyles,
        mobile: mobileStyles,
        tablet: tabletStyles,
        hover: hoverStyles
    }, DOMid, EMScrollId), {
        className: classes,
        url: props.media.defaultMedia.url,
        controls: controls === false ? false : true,
        poster: Poster,
        preload: Preload
    }));
    // direct link
    if (props.media.defaultMedia.isDirectLink) Video = /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoComponent, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        ref: videoRef,
        desktop: desktopStyles,
        mobile: mobileStyles,
        tablet: tabletStyles,
        hover: hoverStyles
    }, DOMid, EMScrollId), {
        className: classes,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(videoPlayerLazy, {
            url: props.media.defaultMedia.url,
            controls: controls === false ? false : true,
            config: config
        })
    }));
    // custom video player
    if (controls === false && playPauseAsset && playPauseAsset !== "") Video = /*#__PURE__*/ (0,jsx_runtime.jsx)(videoPlayerCustom, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        setRef: function(mediaRef) {
            return props.setRef(mediaRef);
        },
        mediaStyles: mediaStyles
    }, DOMid, EMScrollId), {
        className: classes,
        url: props.media.defaultMedia.url,
        controls: false,
        playPauseAsset: playPauseAsset,
        poster: Poster,
        preload: Preload,
        stylesheet: props.pageResponse.stylesheet
    }));
    return Video;
};
/* harmony default export */ var mediaVideo = (MediaVideo);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobMediaV2/bobMediaV2.tsx









var bobMediaV2_BobMedia = function(props) {
    var ref;
    var mediaStyles = isNbobNmedia(props.object.styles.bobs.nmedia1);
    var hoverStyles = (ref = mediaStyles.behaviour) === null || ref === void 0 ? void 0 : ref.hover;
    var inlineContent = props.object.content.inlineContent;
    var media = handleMedia(props.pageResponse, props.post, handleMediaId(props.post, props.pageResponse, props.field, props.object.content.inlineContent, props.overrides, hoverStyles === null || hoverStyles === void 0 ? void 0 : hoverStyles.enable, ".image-mappedValue"), components_getOverrideInlineContentValues("".concat(props.field, ".linkType"), {
        inlineContent: inlineContent,
        overrides: props.overrides
    }), props.object, props.replacedMediaList);
    var renderMedia = function() {
        if (media.defaultMedia.type === "video") return /*#__PURE__*/ (0,jsx_runtime.jsx)(mediaVideo, {
            media: media,
            setRef: function(mediaRef) {
                return props.setRef(mediaRef);
            },
            replacedMediaList: props.replacedMediaList,
            pageResponse: props.pageResponse,
            instanceId: props.object.selectedInstanceId,
            object: props.object,
            overrides: props.overrides,
            field: props.field,
            post: props.post,
            expManager: props.expManager
        });
        else return /*#__PURE__*/ (0,jsx_runtime.jsx)(mediaImage, {
            media: media,
            setRef: function(mediaRef) {
                return props.setRef(mediaRef);
            },
            replacedMediaList: props.replacedMediaList,
            pageResponse: props.pageResponse,
            instanceId: props.object.selectedInstanceId,
            object: props.object,
            overrides: props.overrides,
            field: props.field,
            post: props.post,
            expManager: props.expManager
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobLoading, {
            type: "media",
            uuid: getComposedUuid(props.pageResponse.objects[props.object.uuid]),
            contentSrc: components_getOverrideInlineContentValues("".concat(props.field, ".contentSrc"), {
                inlineContent: inlineContent,
                overrides: props.overrides
            }),
            mediaWidth: bobMediaV2Handler_handleSize(mediaStyles.width),
            mediaHeight: bobMediaV2Handler_handleSize(mediaStyles.height),
            mappedValue: components_getOverrideInlineContentValues("".concat(props.field, ".image-mappedValue"), {
                inlineContent: inlineContent,
                overrides: props.overrides
            }),
            children: renderMedia()
        })
    });
};
/* harmony default export */ var bobMediaV2 = (bobMediaV2_BobMedia);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Elements/media_v2/media_v2.tsx








function getPosts(obj, bobName, ov, page) {
    var ref, ref1, ref2, ref3, ref4;
    if (ov === null || ov === void 0 ? void 0 : (ref = ov.formula) === null || ref === void 0 ? void 0 : ref.posts) {
        // old api
        return [
            ov.formula.posts,
            {}
        ];
    } else if ((ref1 = obj.content.formula) === null || ref1 === void 0 ? void 0 : ref1.posts) {
        // object with formula
        return [
            obj.content.formula.posts,
            {}
        ];
    } else if (((ref2 = page.contentPage) === null || ref2 === void 0 ? void 0 : ref2.content) && ((ref3 = obj.content) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.inlineContent) === null || ref4 === void 0 ? void 0 : ref4["".concat(bobName, ".contentSrc")]) === "content-page") {
        // content page
        return [
            [
                page.contentPage.content.post
            ],
            page.contentPage.content.media
        ];
    } else return [
        [
            main.staticPost
        ],
        {}
    ];
}
var MediaV2 = function(props) {
    var ref = (0,react.useState)(undefined), elRef = ref[0], setElRef = ref[1];
    var bobName = "nmedia1";
    var ref1 = (0,_sliced_to_array/* default */.Z)(getPosts(props.obj, bobName, props.overrides, props.pageResponse), 2), items = ref1[0], extraMedia = ref1[1];
    var replaceMedia = (0,src_object_spread/* default */.Z)({}, props.replacedMediaList, extraMedia);
    if (items && items.length > 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: items.map(function(item, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        props.expManager.enable && !props.expManager.content && /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM_ComponentSelectorEMv2, {
                            uuid: props.obj.uuid,
                            masterBob: bobName,
                            obj: props.obj,
                            editing: props.editing,
                            elRef: elRef
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bobMediaV2, {
                            setRef: function(containerRef) {
                                return setElRef(containerRef);
                            },
                            replacedMediaList: replaceMedia,
                            pageResponse: props.pageResponse,
                            instanceId: props.obj.selectedInstanceId,
                            object: props.obj,
                            overrides: props.overrides,
                            field: bobName,
                            post: item,
                            expManager: props.expManager
                        })
                    ]
                }, idx);
            })
        });
    } else {
        if (props.expManager.enable) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(warningSystem, {
                alertType: "alert-secondary w-100 text-center",
                messages: "Add a single post or a feed"
            });
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {});
};
/* harmony default export */ var media_v2 = (MediaV2);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Elements/media_v2/index.ts

/* harmony default export */ var Elements_media_v2 = (media_v2);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/textArrangeStyle.ts






//Temp to handle nulls
var textArrangeStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
var textArrangeStyle_TextCodec = (0,es6/* type */.dt)({
    textAlign: (0,es6/* union */.G0)([
        (0,es6/* literal */.i0)("right"),
        (0,es6/* literal */.i0)("left"),
        (0,es6/* literal */.i0)("center")
    ]),
    textTransform: (0,es6/* union */.G0)([
        (0,es6/* literal */.i0)("none"),
        (0,es6/* literal */.i0)("capitalize"),
        (0,es6/* literal */.i0)("uppercase"),
        (0,es6/* literal */.i0)("lowercase")
    ]),
    verticalAlign: (0,es6/* union */.G0)([
        (0,es6/* literal */.i0)("top"),
        (0,es6/* literal */.i0)("bottom"),
        (0,es6/* literal */.i0)("middle")
    ])
});
var textArrangeStyle_TextOptCodec = (0,es6/* partial */.r$)({
    textAlign: textArrangeStyle_nullable((0,es6/* union */.G0)([
        (0,es6/* literal */.i0)("right"),
        (0,es6/* literal */.i0)("left"),
        (0,es6/* literal */.i0)("center")
    ])),
    textTransform: textArrangeStyle_nullable((0,es6/* union */.G0)([
        (0,es6/* literal */.i0)("none"),
        (0,es6/* literal */.i0)("capitalize"),
        (0,es6/* literal */.i0)("uppercase"),
        (0,es6/* literal */.i0)("lowercase")
    ])),
    verticalAlign: textArrangeStyle_nullable((0,es6/* union */.G0)([
        (0,es6/* literal */.i0)("top"),
        (0,es6/* literal */.i0)("bottom"),
        (0,es6/* literal */.i0)("middle")
    ]))
});
var textArrangeStyle_StylesTextCodec = (0,es6/* intersection */.jV)([
    textArrangeStyle_TextCodec,
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: textArrangeStyle_TextOptCodec,
            hover: textArrangeStyle_TextOptCodec
        }),
        mobile: (0,es6/* intersection */.jV)([
            textArrangeStyle_TextOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: textArrangeStyle_TextOptCodec,
                    hover: textArrangeStyle_TextOptCodec
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            textArrangeStyle_TextOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: textArrangeStyle_TextOptCodec,
                    hover: textArrangeStyle_TextOptCodec
                })
            }), 
        ])
    }), 
]);
var textArrangeStyle_GSTextCodec = (0,es6/* intersection */.jV)([
    textArrangeStyle_TextCodec,
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: textArrangeStyle_TextOptCodec,
            hover: textArrangeStyle_TextOptCodec
        }),
        mobile: (0,es6/* intersection */.jV)([
            textArrangeStyle_TextOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: textArrangeStyle_TextOptCodec,
                    hover: textArrangeStyle_TextOptCodec
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            textArrangeStyle_TextOptCodec,
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: textArrangeStyle_TextOptCodec,
                    hover: textArrangeStyle_TextOptCodec
                })
            }), 
        ])
    }), 
]);
function textArrangeStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var styles = textArrangeStyle_StylesTextCodec.decode(stylesObj);
    if ((0,lib_Either.isRight)(styles)) return textArrangeStyle_cssRender(styles.right, breakpoint, behaviourState);
    console.warn("TextStyle ".concat(breakpoint, " ").concat(behaviourState, " ").concat(codecUtils_decoderErrors(styles)));
    return {};
}
function textArrangeStyle_globalStyleCssRenderUnsafe(gsObj, breakpoint, behaviourState) {
    var gs = textArrangeStyle_GSTextCodec.decode(gsObj);
    if (isRight(gs)) return textArrangeStyle_globalStyleCssRender(gs.right, breakpoint, behaviourState);
    console.warn("TextGSStyle ".concat(breakpoint, " ").concat(behaviourState, " ").concat(decoderErrors(gs)));
    return {};
}
function textArrangeStyle_cssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return textArrangeStyle_renderBob(stylesObj);
        } else {
            var ref;
            return textArrangeStyle_renderBobOpt(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : ref[behaviourState]);
        }
    } else {
        if (behaviourState === "default") {
            return textArrangeStyle_renderBobOpt(stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint]);
        } else {
            var ref1, ref2;
            return textArrangeStyle_renderBobOpt(stylesObj === null || stylesObj === void 0 ? void 0 : (ref1 = stylesObj[breakpoint]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : ref2[behaviourState]);
        }
    }
}
function textArrangeStyle_globalStyleCssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return textArrangeStyle_render(stylesObj);
        } else {
            var ref;
            return textArrangeStyle_renderOpt(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : ref[behaviourState]);
        }
    } else {
        if (behaviourState === "default") {
            return textArrangeStyle_renderOpt(stylesObj === null || stylesObj === void 0 ? void 0 : stylesObj[breakpoint]);
        } else {
            var ref1, ref2;
            return textArrangeStyle_renderOpt(stylesObj === null || stylesObj === void 0 ? void 0 : (ref1 = stylesObj[breakpoint]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.behaviour) === null || ref2 === void 0 ? void 0 : ref2[behaviourState]);
        }
    }
}
function textArrangeStyle_renderBob(textObj) {
    return textArrangeStyle_render(textObj);
}
/**
 * Renders ColorsOpt css for breakpoints/state templates
 * or empty for non written style props
 *
 * @param textObj
 * @param foundationStyle
 * @returns
 */ function textArrangeStyle_renderBobOpt(textObj) {
    if (textObj) {
        return textArrangeStyle_renderOpt(textObj);
    }
    return {};
}
/**
 * Renders TextOpt css for breakpoints/state templates
 * Returns color
 * or empty for non written style props
 *
 * @param textObj
 * @param foundationStyle
 * @returns
 */ function textArrangeStyle_renderOpt(textObj) {
    var css = {};
    if (valueExists(textObj === null || textObj === void 0 ? void 0 : textObj.textTransform)) {
        css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
            "text-transform": "".concat(textObj === null || textObj === void 0 ? void 0 : textObj.textTransform)
        });
    }
    if (valueExists(textObj === null || textObj === void 0 ? void 0 : textObj.textAlign)) {
        css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
            "text-align": "".concat(textObj === null || textObj === void 0 ? void 0 : textObj.textAlign),
            "justify-content": textObj === null || textObj === void 0 ? void 0 : textObj.textAlign
        });
    }
    return css;
}
function textArrangeStyle_render(textObj) {
    return {
        "text-align": textObj.textAlign,
        "text-transform": textObj.textTransform
    };
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/textDecorationStyle.ts







//Temp to handle nulls
var textDecorationStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
var ThicknessUnitCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("auto"),
    (0,es6/* literal */.i0)("from-font"),
    (0,es6/* literal */.i0)("px"),
    (0,es6/* literal */.i0)("%")
]);
var LineCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("none"),
    (0,es6/* literal */.i0)("underline"),
    (0,es6/* literal */.i0)("overline"),
    (0,es6/* literal */.i0)("line-through"),
    (0,es6/* literal */.i0)("blink"), 
]);
var StyleCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("solid"),
    (0,es6/* literal */.i0)("double"),
    (0,es6/* literal */.i0)("dotted"),
    (0,es6/* literal */.i0)("dashed"),
    (0,es6/* literal */.i0)("wavy")
]);
var SkipInkCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("auto"),
    (0,es6/* literal */.i0)("all"),
    (0,es6/* literal */.i0)("none")
]);
var ThicknessCodec = (0,es6/* partial */.r$)({
    value: textDecorationStyle_nullable(es6/* number */.pk),
    unit: textDecorationStyle_nullable(ThicknessUnitCodec)
});
var TextDecorationOptCodec = (0,es6/* partial */.r$)({
    color: textDecorationStyle_nullable(es6/* string */.Z_),
    line: textDecorationStyle_nullable(LineCodec),
    style: textDecorationStyle_nullable(StyleCodec),
    thickness: ThicknessCodec,
    skipInk: textDecorationStyle_nullable(SkipInkCodec)
});
var StylesTextDecorationCodec = (0,es6/* intersection */.jV)([
    (0,es6/* partial */.r$)({
        textDecorationV2: TextDecorationOptCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                textDecorationV2: TextDecorationOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                textDecorationV2: TextDecorationOptCodec
            })
        }),
        mobile: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                textDecorationV2: TextDecorationOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        textDecorationV2: TextDecorationOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        textDecorationV2: TextDecorationOptCodec
                    })
                })
            }), 
        ]),
        tablet: (0,es6/* intersection */.jV)([
            (0,es6/* partial */.r$)({
                textDecorationV2: TextDecorationOptCodec
            }),
            (0,es6/* partial */.r$)({
                behaviour: (0,es6/* partial */.r$)({
                    active: (0,es6/* partial */.r$)({
                        textDecorationV2: TextDecorationOptCodec
                    }),
                    hover: (0,es6/* partial */.r$)({
                        textDecorationV2: TextDecorationOptCodec
                    })
                })
            }), 
        ])
    }), 
]);
function textDecorationStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState, stylesheetLabel) {
    var styles = StylesTextDecorationCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return textDecorationStyle_cssRender(styles.right, breakpoint, behaviourState, stylesheetLabel);
    console.warn(breakpoint, behaviourState, codecUtils_decoderErrors(styles));
    return {};
}
function textDecorationStyle_cssRender(stylesObj, breakpoint, behaviourState, stylesheetLabel) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return textDecorationStyle_renderBob(stylesObj.textDecorationV2, stylesheetLabel);
        } else {
            var ref, ref1;
            return textDecorationStyle_renderBobOpt(stylesObj.textDecorationV2, stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.textDecorationV2, stylesheetLabel);
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return textDecorationStyle_renderBobOpt(stylesObj.textDecorationV2, stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.textDecorationV2, stylesheetLabel);
        } else {
            var ref3, ref4, ref5;
            return textDecorationStyle_renderBobOpt(stylesObj.textDecorationV2, stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.textDecorationV2, stylesheetLabel);
        }
    }
}
function mergedValue(desktopValue, value) {
    return value || desktopValue;
}
function checkForValidThicknessOptFallBack(desktopThickness, thickness) {
    if (!desktopThickness && !thickness) return false;
    if ((thickness === null || thickness === void 0 ? void 0 : thickness.unit) === "auto" || (thickness === null || thickness === void 0 ? void 0 : thickness.unit) === "from-font") return thickness.unit;
    var mergedThicknessValue = mergedValue(desktopThickness === null || desktopThickness === void 0 ? void 0 : desktopThickness.value, thickness === null || thickness === void 0 ? void 0 : thickness.value);
    if (((thickness === null || thickness === void 0 ? void 0 : thickness.unit) === "%" || (thickness === null || thickness === void 0 ? void 0 : thickness.unit) === "px") && mergedThicknessValue) return "".concat(mergedThicknessValue).concat(thickness.unit);
    return false;
}
function checkForValidThicknessOpt(thickness) {
    if (!thickness) return false;
    if (thickness.unit === "auto" || thickness.unit === "from-font") return thickness.unit;
    if ((thickness.unit === "%" || thickness.unit === "px") && thickness.value) return "".concat(thickness.value).concat(thickness.unit);
    return false;
}
function textDecorationStyle_renderBob(textDecorationObj, stylesheetLabel) {
    var thicknessExists = checkForValidThicknessOpt(textDecorationObj === null || textDecorationObj === void 0 ? void 0 : textDecorationObj.thickness);
    var css = {};
    if (valueExists((textDecorationObj === null || textDecorationObj === void 0 ? void 0 : textDecorationObj.color) || stylesheetLabel)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "text-decoration-color": handleBobStylesheetLabel(stylesheetLabel, textDecorationObj === null || textDecorationObj === void 0 ? void 0 : textDecorationObj.color)
    });
    if (valueExists(textDecorationObj === null || textDecorationObj === void 0 ? void 0 : textDecorationObj.line)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "text-decoration-line": textDecorationObj === null || textDecorationObj === void 0 ? void 0 : textDecorationObj.line
    });
    if (valueExists(textDecorationObj === null || textDecorationObj === void 0 ? void 0 : textDecorationObj.style)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "text-decoration-style": textDecorationObj === null || textDecorationObj === void 0 ? void 0 : textDecorationObj.style
    });
    if (thicknessExists) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "text-decoration-thickness": thicknessExists
    });
    if (valueExists(textDecorationObj === null || textDecorationObj === void 0 ? void 0 : textDecorationObj.skipInk)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "text-decoration-skip-ink": textDecorationObj === null || textDecorationObj === void 0 ? void 0 : textDecorationObj.skipInk
    });
    return css;
}
function textDecorationStyle_renderBobOpt(textDecorationDesktopObj, textDecorationObj, stylesheetLabel) {
    var thicknessExists = checkForValidThicknessOptFallBack(textDecorationDesktopObj === null || textDecorationDesktopObj === void 0 ? void 0 : textDecorationDesktopObj.thickness, textDecorationObj === null || textDecorationObj === void 0 ? void 0 : textDecorationObj.thickness);
    var css = {};
    if (valueExists((textDecorationObj === null || textDecorationObj === void 0 ? void 0 : textDecorationObj.color) || stylesheetLabel)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "text-decoration-color": handleBobStylesheetLabel(stylesheetLabel, textDecorationObj === null || textDecorationObj === void 0 ? void 0 : textDecorationObj.color)
    });
    if (valueExists(textDecorationObj === null || textDecorationObj === void 0 ? void 0 : textDecorationObj.line)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "text-decoration-line": textDecorationObj === null || textDecorationObj === void 0 ? void 0 : textDecorationObj.line
    });
    if (valueExists(textDecorationObj === null || textDecorationObj === void 0 ? void 0 : textDecorationObj.style)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "text-decoration-style": textDecorationObj === null || textDecorationObj === void 0 ? void 0 : textDecorationObj.style
    });
    if (thicknessExists) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "text-decoration-thickness": thicknessExists
    });
    if (valueExists(textDecorationObj === null || textDecorationObj === void 0 ? void 0 : textDecorationObj.skipInk)) css = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, css), {
        "text-decoration-skip-ink": textDecorationObj === null || textDecorationObj === void 0 ? void 0 : textDecorationObj.skipInk
    });
    return css;
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobTextV2/bobTextV2Handler.ts



















var bobTextV2Handler_responsiveStyles = function(styles, stylesheetLabels, breakpoint, behaviourState) {
    var colorLabel = handleBobLabel(styles, stylesheetLabels, breakpoint, behaviourState, "color");
    var shadowColorLabel = handleBobTextShadowLabel(styles, stylesheetLabels, breakpoint, behaviourState);
    var decorationColorLabel = handleBobTextDecorationLabel(styles, stylesheetLabels, breakpoint, behaviourState);
    var textLabel = handleBobLabel(styles, stylesheetLabels, breakpoint, behaviourState, "fontFamily");
    return (0,src_object_spread/* default */.Z)({}, textStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState, textLabel), textArrangeStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), heightStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState), maxHeightStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), minHeightStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), widthStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState), maxWidthStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), minWidthStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), selfFlexStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), boundaryStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState), colorStyle_cssRenderUnsafe(styles, breakpoint, behaviourState, undefined, colorLabel, false), cursorStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), textShadowStyle_cssRenderUnsafe(styles, breakpoint, behaviourState, undefined, shadowColorLabel), positionStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), textDecorationStyle_cssRenderUnsafe(styles, breakpoint, behaviourState, decorationColorLabel));
};
var handleFonts = function(templateStyles, pageLabels, isExpManager) {
    var FONTLOADED = "";
    var FONTLOADEDTABLET = "";
    var FONTLOADEDMOBILE = "";
    var FONTLOADEDHOVER = "";
    var FONTLOADEDACTIVE = "";
    var label = handleBobLabel(templateStyles, pageLabels, "desktop", "default", "fontFamily");
    if (isExpManager) {
        FONTLOADED = dynamicFontLoader(templateStyles ? templateStyles : bobDefaultNode_styles, [
            templateStyles.fontWeight
        ], label);
        FONTLOADEDTABLET = dynamicFontLoader(templateStyles.tablet ? templateStyles.tablet : bobDefaultNode_styles, [
            templateStyles.tablet && templateStyles.tablet.fontWeight
        ], label, undefined, true);
        FONTLOADEDMOBILE = dynamicFontLoader(templateStyles.mobile ? templateStyles.mobile : bobDefaultNode_styles, templateStyles.mobile && [
            templateStyles.mobile.fontWeight
        ], label, undefined, true);
        FONTLOADEDHOVER = templateStyles.behaviour && templateStyles.behaviour.hover && templateStyles.behaviour.hover.enable ? dynamicFontLoader(templateStyles.behaviour.hover, [
            templateStyles.behaviour.hover.fontWeight
        ], label, undefined, true) : "";
        FONTLOADEDACTIVE = templateStyles.behaviour && templateStyles.behaviour.active && templateStyles.behaviour.active.enable ? dynamicFontLoader(templateStyles.behaviour.active, [
            templateStyles.behaviour.active.fontWeight
        ], label, undefined, true) : "";
    }
    return "".concat(FONTLOADED, " ").concat(FONTLOADEDTABLET, " ").concat(FONTLOADEDMOBILE, " ").concat(FONTLOADEDHOVER, " ").concat(FONTLOADEDACTIVE);
};


;// CONCATENATED MODULE: ./src/modules/shared-modules/utilities/rebootCss.tsx
var writeRebootCssOVerride = function(css, htmlTag) {
    if (htmlTag === "a" && css && hasTextDecoration(css)) {
        var rebootCss = "";
        if ("color" in css) rebootCss += "color: ".concat(css.color, ";");
        if ("text-decoration-line" in css) rebootCss += "text-decoration-line: ".concat(css["text-decoration-line"], ";");
        if ("text-decoration-style" in css) rebootCss += "text-decoration-style: ".concat(css["text-decoration-style"], ";");
        if ("text-decoration-color" in css) rebootCss += "text-decoration-color: ".concat(css["text-decoration-color"], ";");
        if ("text-decoration-skip-ink" in css) rebootCss += "text-decoration-skip-ink: ".concat(css["text-decoration-skip-ink"], ";");
        if ("text-decoration-thickness" in css) rebootCss += "text-decoration-thickness: ".concat(css["text-decoration-thickness"], ";");
        return "a&:not([href]):not([tabindex]), a&:not([href]):not([tabindex]):hover, a&:not([href]):not([tabindex]):focus {".concat(rebootCss, "}");
    }
    return "";
};
var hasTextDecoration = function(css) {
    return "color" in css || "text-decoration-line" in css || "text-decoration-style" in css || "text-decoration-thickness" in css || "text-decoration-color" in css || "text-decoration-skip-ink" in css;
};

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobTextV2/bobTextV2.tsx




function bobTextV2_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        "\n      ",
        "\n    "
    ]);
    bobTextV2_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function bobTextV2_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all ",
        " {\n            &:hover {\n              ",
        "\n              ",
        "\n            }\n          }\n        "
    ]);
    bobTextV2_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function bobTextV2_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                ",
        "\n                ",
        "\n              "
    ]);
    bobTextV2_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function bobTextV2_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    &:hover {\n                      ",
        "\n                      ",
        "\n                    }\n                  "
    ]);
    bobTextV2_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function bobTextV2_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all and (max-width: 992px) and (min-width: 767px) {\n            ",
        "\n            ",
        "\n          }\n        "
    ]);
    bobTextV2_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function bobTextV2_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n              ",
        "\n              ",
        "\n            "
    ]);
    bobTextV2_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function bobTextV2_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    &:hover {\n                      ",
        "\n                      ",
        "\n                    }\n                  "
    ]);
    bobTextV2_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function bobTextV2_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all and (max-width: 766px) {\n            ",
        "\n            ",
        "\n          }\n        "
    ]);
    bobTextV2_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function bobTextV2_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    bobTextV2_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



// @ts-ignore







//import moment from "moment"









var TextComponent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e8148a97-0"
})(bobTextV2_templateObject8(), function(props) {
    return (0,styled_components_browser_esm/* css */.iv)(bobTextV2_templateObject(), props.desktop, writeRebootCssOVerride(props.desktop, props.as));
}, function(props) {
    return props.hover.isEnabled.desktop ? (0,styled_components_browser_esm/* css */.iv)(bobTextV2_templateObject1(), handleMediaQueryRestrictions(props.hover.isEnabled.mobile, props.hover.isEnabled.tablet), props.hover.desktop, writeRebootCssOVerride(props.hover.desktop, props.as)) : {};
}, function(props) {
    return Object.keys(props.tablet).length > 0 || Object.keys(props.hover.tablet).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(bobTextV2_templateObject4(), function(props) {
        return (0,styled_components_browser_esm/* css */.iv)(bobTextV2_templateObject2(), props.tablet, writeRebootCssOVerride(props.tablet, props.as));
    }, function(props) {
        return props.hover.isEnabled.tablet && Object.keys(props.hover.tablet).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(bobTextV2_templateObject3(), props.hover.tablet, writeRebootCssOVerride(props.hover.tablet, props.as)) : {};
    }) : {};
}, function(props) {
    return Object.keys(props.mobile).length > 0 || Object.keys(props.hover.mobile).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(bobTextV2_templateObject7(), function(props) {
        return (0,styled_components_browser_esm/* css */.iv)(bobTextV2_templateObject5(), props.mobile, writeRebootCssOVerride(props.mobile, props.as));
    }, function(props) {
        return props.hover.isEnabled.mobile && Object.keys(props.hover.mobile).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(bobTextV2_templateObject6(), props.hover.mobile, writeRebootCssOVerride(props.hover.mobile, props.as)) : {};
    }) : {};
});
var bobTextV2_BobText = function(props) {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)(/*#__PURE__*/ react.createRef()), textRef = ref4[0];
    (0,react.useEffect)(function() {
        props.setRef && props.setRef(textRef);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var textStyles = isNbobText(props.object.styles.bobs.ntext1);
    var inlineContent = props.object.content.inlineContent;
    var settings = props.object.settings;
    var pageLabels = (ref = props.pageResponse.stylesheet) === null || ref === void 0 ? void 0 : ref.labels;
    var desktopStyles = bobTextV2Handler_responsiveStyles(textStyles, pageLabels, "desktop", "default");
    var tabletStyles = bobTextV2Handler_responsiveStyles(textStyles, pageLabels, "tablet", "default");
    var mobileStyles = bobTextV2Handler_responsiveStyles(textStyles, pageLabels, "mobile", "default");
    var hoverStyles = handleStateStyles(textStyles, bobTextV2Handler_responsiveStyles(textStyles, pageLabels, "desktop", "hover"), bobTextV2Handler_responsiveStyles(textStyles, pageLabels, "tablet", "hover"), bobTextV2Handler_responsiveStyles(textStyles, pageLabels, "mobile", "hover"));
    // hoverStyles.desktop?.fontSize TODO: typed styles cannot return {}
    var DOMid = props.expManager.enable ? {
        id: "".concat(handleDOMid(props.field, props.object.uuid, props.instanceId))
    } : {};
    var EMpreviewClass = emPreviewClass(props.expManager.enable, textStyles.uuid);
    var EMScrollId = emScrollId(props.expManager.enable, props.object.uuid);
    var _obj;
    var GlobalStylesClass = globalStylesUtils.handleClassNameV2(props.pageResponse.nGlobalStyles, textStyles, "-text", (_obj = {}, (0,src_define_property/* default */.Z)(_obj, GS_TEXT, NGS_CLASS_SUFIX), (0,src_define_property/* default */.Z)(_obj, GS_SHADOW, NGS_CLASS_SUFIX), (0,src_define_property/* default */.Z)(_obj, GS_BOUNDARY, NGS_CLASS_SUFIX), _obj));
    var customClasses = (settings === null || settings === void 0 ? void 0 : (ref1 = settings[props.field]) === null || ref1 === void 0 ? void 0 : ref1.class) ? " ".concat(settings === null || settings === void 0 ? void 0 : (ref2 = settings[props.field]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.class) === null || ref3 === void 0 ? void 0 : ref3.join(" ")) : "";
    var classes = "".concat(EMpreviewClass).concat(GlobalStylesClass ? " ".concat(GlobalStylesClass) : "").concat(customClasses);
    var loadedFonts = handleFonts(textStyles, pageLabels, props.expManager.enable);
    var tag = components_getOverrideInlineContentValues("".concat(props.field, ".behaviour-link-enable"), {
        inlineContent: inlineContent,
        overrides: props.overrides
    }) ? "a" : components_getOverrideInlineContentValues("".concat(props.field, ".tag"), {
        inlineContent: inlineContent,
        overrides: props.overrides
    });
    var linkAttrs = getLinkAttributes(props.field, {
        inlineContent: inlineContent,
        overrides: props.overrides
    }, props.pageResponse, props.post);
    var isCmsValidHtml = false;
    if (components_getOverrideInlineContentValues("".concat(props.field, ".contentSrc"), {
        inlineContent: inlineContent,
        overrides: props.overrides
    }) === textContentHelper_CMS || components_getOverrideInlineContentValues("".concat(props.field, ".contentSrc"), {
        inlineContent: inlineContent,
        overrides: props.overrides
    }) === textContentHelper_CONTENT_PAGE) {
        isCmsValidHtml = validHtml(props.value);
    }
    var hasFont = loadedFonts.trim() !== "";
    var renderCmsContent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextComponent, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            ref: textRef,
            desktop: desktopStyles,
            mobile: mobileStyles,
            tablet: tabletStyles,
            hover: hoverStyles
        }, DOMid, EMScrollId), {
            dangerouslySetInnerHTML: {
                __html: props.value
            },
            className: classes
        }));
    };
    var renderCustomContent = function() {
        var customText = components_getOverrideInlineContentValues("".concat(props.field, ".customText"), {
            inlineContent: inlineContent,
            overrides: props.overrides
        });
        // when link is enabled tag must be 'a'
        var TAG = tag === "a" ? tag : "div";
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextComponent, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            ref: textRef,
            onClick: function(e) {
                bobUtils_clickEvent(e, tag, props.field, props.object.content.inlineContent, props.object.content.inlineContent.overrides, props.pageResponse, props.post);
            },
            as: TAG
        }, linkAttrs, DOMid, EMScrollId), {
            dangerouslySetInnerHTML: {
                __html: customText
            },
            className: classes,
            desktop: desktopStyles,
            mobile: mobileStyles,
            tablet: tabletStyles,
            hover: hoverStyles
        }));
    };
    var renderCmsCustomTag = function() {
        // parse and render timestamp
        var value = props.value;
        //if (value !== "" && moment.unix(value).isValid()) value = moment.unix(value).format("DD/MM/YYYY")
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextComponent, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            ref: textRef,
            as: tag
        }, DOMid, EMScrollId, linkAttrs), {
            className: classes,
            desktop: desktopStyles,
            mobile: mobileStyles,
            tablet: tabletStyles,
            hover: hoverStyles,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bobLoading, {
                type: "text",
                uuid: getComposedUuid(props.pageResponse.objects[props.object.uuid]),
                contentSrc: components_getOverrideInlineContentValues("".concat(props.field, ".contentSrc"), {
                    inlineContent: inlineContent,
                    overrides: props.overrides
                }),
                mappedValue: components_getOverrideInlineContentValues("".concat(props.field, ".mappedValue"), {
                    inlineContent: inlineContent,
                    overrides: props.overrides
                }),
                fontSize: desktopStyles["font-size"],
                children: value && value !== "" ? typeof value !== "number" ? he_default().decode(value) : value : ""
            })
        }));
    };
    var TEXT;
    // Render Html when coming from CMS/CONTENT_PAGE
    if (isCmsValidHtml) {
        TEXT = renderCmsContent();
    } else if (components_getOverrideInlineContentValues("".concat(props.field, ".contentSrc"), {
        inlineContent: inlineContent,
        overrides: props.overrides
    }) === "custom") {
        TEXT = renderCustomContent();
    } else {
        if (props.form) {
            var content = props.object.content;
            // when link is enabled tag must be 'a'
            var TAG = tag === "a" ? tag : "div";
            TEXT = /*#__PURE__*/ (0,jsx_runtime.jsx)(TextComponent, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                ref: textRef,
                onClick: function(e) {
                    bobUtils_clickEvent(e, tag, props.field, props.object.content.inlineContent, props.object.content.inlineContent.overrides, props.pageResponse, props.post);
                },
                as: TAG
            }, linkAttrs, DOMid, EMScrollId), {
                className: classes,
                desktop: desktopStyles,
                mobile: mobileStyles,
                tablet: tabletStyles,
                hover: hoverStyles,
                children: getFormField(props.form, content.inlineContent["".concat(props.field, ".mappedValue")], content, props.field)
            }));
        } else {
            TEXT = renderCmsCustomTag();
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            hasFont && /*#__PURE__*/ (0,jsx_runtime.jsx)((style_it_default()), {
                children: "\n            ".concat(loadedFonts, "\n          ")
            }),
            TEXT
        ]
    });
};
/* harmony default export */ var bobTextV2 = (bobTextV2_BobText);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Elements/text/text.tsx






var Text = function(props) {
    var ref = (0,react.useState)(undefined), elRef = ref[0], setElRef = ref[1];
    var items = getContent(props.obj, "posts", props.overrides);
    if (items && items.length > 0) {
        return items.map(function(item, idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    props.expManager.enable && !props.expManager.content && /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM_ComponentSelectorEMv2, {
                        uuid: props.obj.uuid,
                        masterBob: "ntext1",
                        obj: props.obj,
                        form: props.form,
                        editing: props.editing,
                        elRef: elRef
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bobTextV2, {
                        setRef: function(textRef) {
                            return setElRef(textRef);
                        },
                        pageResponse: props.pageResponse,
                        instanceId: props.obj.selectedInstanceId,
                        object: props.obj,
                        overrides: props.overrides,
                        field: "ntext1",
                        post: item,
                        value: getStringFieldV2(item, props.obj, props.pageResponse, "ntext1", props.overrides),
                        expManager: props.expManager,
                        form: props.form
                    })
                ]
            }, idx);
        });
    } else {
        if (props.expManager.enable) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(warningSystem, {
                alertType: "alert-secondary w-100 text-center",
                messages: "Add a single post or a feed"
            });
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {});
};
/* harmony default export */ var text_text = (/*#__PURE__*/react.memo(Text));

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobGrid/bobGridHandler.ts
function bobGridHandler_handleColumns(idx, counter, grid) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var nthCol = grid.grid.columns.length;
    var ref14;
    var nthColTablet = (ref14 = (ref = grid.tablet) === null || ref === void 0 ? void 0 : (ref1 = ref.grid) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.columns) === null || ref2 === void 0 ? void 0 : ref2.length) !== null && ref14 !== void 0 ? ref14 : nthCol;
    var ref15;
    var nthColMobile = (ref15 = (ref3 = grid.mobile) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.grid) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.columns) === null || ref5 === void 0 ? void 0 : ref5.length) !== null && ref15 !== void 0 ? ref15 : nthCol;
    counter.desktop = idx % nthCol !== 0 ? counter.desktop + 1 : 0;
    counter.tablet = idx % nthColTablet !== 0 ? counter.tablet + 1 : 0;
    counter.mobile = idx % nthColMobile !== 0 ? counter.mobile + 1 : 0;
    var columnsDesktop = grid.grid.columns[counter.desktop];
    var columnsTablet = ((ref6 = grid.tablet) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.grid) === null || ref7 === void 0 ? void 0 : ref7.columns) ? (ref8 = grid.tablet) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.grid) === null || ref9 === void 0 ? void 0 : ref9.columns[counter.tablet] : columnsDesktop;
    var columnsMobile = ((ref10 = grid.mobile) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.grid) === null || ref11 === void 0 ? void 0 : ref11.columns) ? (ref12 = grid.mobile) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.grid) === null || ref13 === void 0 ? void 0 : ref13.columns[counter.mobile] : columnsDesktop;
    return {
        desktop: columnsDesktop,
        tablet: columnsTablet,
        mobile: columnsMobile,
        counter: counter
    };
}
function getStartPos(childComponentsId, grid) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var totalChilds = childComponentsId.length;
    var initialPosDesktop = grid.grid.initialPos.enable ? grid.grid.initialPos.value : undefined;
    var columnsTotalDesktop = grid.grid.columnsTotal;
    var initialPosTablet = ((ref = grid.tablet) === null || ref === void 0 ? void 0 : (ref1 = ref.grid) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.initialPos) === null || ref2 === void 0 ? void 0 : ref2.enable) ? (ref3 = grid.tablet) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.grid) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.initialPos) === null || ref5 === void 0 ? void 0 : ref5.value : initialPosDesktop;
    var ref16;
    var columnsTotalTablet = (ref16 = (ref6 = grid.tablet) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.grid) === null || ref7 === void 0 ? void 0 : ref7.columnsTotal) !== null && ref16 !== void 0 ? ref16 : columnsTotalDesktop;
    var initialPosMobile = ((ref8 = grid.mobile) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.grid) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.initialPos) === null || ref10 === void 0 ? void 0 : ref10.enable) ? (ref11 = grid.mobile) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.grid) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.initialPos) === null || ref13 === void 0 ? void 0 : ref13.value : initialPosDesktop;
    var ref17;
    var columnsTotalMobile = (ref17 = (ref14 = grid.mobile) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.grid) === null || ref15 === void 0 ? void 0 : ref15.columnsTotal) !== null && ref17 !== void 0 ? ref17 : columnsTotalDesktop;
    var classes = {
        desktopClass: "",
        tabletClass: "",
        mobileClass: ""
    };
    if (initialPosDesktop) {
        classes.desktopClass = handleStartPosition(classes.desktopClass, "-lg", initialPosDesktop, columnsTotalDesktop, totalChilds);
    }
    if (initialPosTablet) {
        classes.tabletClass = handleStartPosition(classes.tabletClass, "-md", initialPosTablet, columnsTotalTablet, totalChilds);
    }
    if (initialPosMobile) {
        classes.mobileClass = handleStartPosition(classes.mobileClass, "", initialPosMobile, columnsTotalMobile, totalChilds);
    }
    return classes;
}
function handleStartPosition(classe, classBrk, initialPos, columnsTotal, totalChilds) {
    if (initialPos !== "false") {
        classe = " g-start".concat(classBrk, "-").concat(initialPos);
    }
    return classe;
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobStyles/gridPropertiesStyle.ts





var gridPropertiesStyle_nullable = function(t) {
    return (0,es6/* union */.G0)([
        t,
        es6/* null */.lB
    ]);
};
var ItemSizeCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("auto"),
    (0,es6/* literal */.i0)("columnSize")
]);
var InitialPosValueCodec = (0,es6/* union */.G0)([
    (0,es6/* literal */.i0)("start"),
    (0,es6/* literal */.i0)("middle"),
    (0,es6/* literal */.i0)("end"),
    es6/* string */.Z_
]);
var GuttersCodec = (0,es6/* type */.dt)({
    enable: es6/* boolean */.O7,
    value: es6/* number */.pk
});
var InitialPosCodec = (0,es6/* type */.dt)({
    enable: es6/* boolean */.O7,
    value: InitialPosValueCodec
});
var GridCodec = (0,es6/* type */.dt)({
    columns: (0,es6/* array */.IX)(es6/* string */.Z_),
    columnsTotal: es6/* number */.pk,
    gutters: GuttersCodec,
    initialPos: InitialPosCodec,
    itemSize: ItemSizeCodec
});
var ItemSizeOptCodec = gridPropertiesStyle_nullable(ItemSizeCodec);
var InitialPosValueOptCodec = gridPropertiesStyle_nullable(InitialPosValueCodec);
var InitialPosOptCodec = (0,es6/* partial */.r$)({
    enable: gridPropertiesStyle_nullable(es6/* boolean */.O7),
    value: InitialPosValueOptCodec
});
var GuttersOptCodec = (0,es6/* partial */.r$)({
    enable: gridPropertiesStyle_nullable(es6/* boolean */.O7),
    value: gridPropertiesStyle_nullable(es6/* number */.pk)
});
var GridOptCodec = (0,es6/* partial */.r$)({
    columns: gridPropertiesStyle_nullable((0,es6/* array */.IX)(es6/* string */.Z_)),
    columnsTotal: gridPropertiesStyle_nullable(es6/* number */.pk),
    gutters: gridPropertiesStyle_nullable(GuttersOptCodec),
    initialPos: InitialPosOptCodec,
    itemSize: ItemSizeOptCodec
});
var StylesGridCodec = (0,es6/* intersection */.jV)([
    (0,es6/* type */.dt)({
        grid: GridCodec
    }),
    (0,es6/* partial */.r$)({
        behaviour: (0,es6/* partial */.r$)({
            active: (0,es6/* partial */.r$)({
                grid: GridOptCodec
            }),
            hover: (0,es6/* partial */.r$)({
                grid: GridOptCodec
            })
        }),
        mobile: (0,es6/* partial */.r$)({
            grid: GridOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    grid: GridOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    grid: GridOptCodec
                })
            })
        }),
        tablet: (0,es6/* partial */.r$)({
            grid: GridOptCodec,
            behaviour: (0,es6/* partial */.r$)({
                active: (0,es6/* partial */.r$)({
                    grid: GridOptCodec
                }),
                hover: (0,es6/* partial */.r$)({
                    grid: GridOptCodec
                })
            })
        })
    }), 
]);
// const DefaultGridProperties = {
//   columns: ["12"],
//   columnsTotal: 1,
//   gutters: {
//     enable: false,
//     size: "0px",
//   },
//   initialPos: "",
//   itemSize: "",
// }
function gridPropertiesStyle_cssRenderUnsafe(stylesObj, breakpoint, behaviourState) {
    var styles = StylesGridCodec.decode(stylesObj);
    if ((0,Either/* isRight */.tO)(styles)) return gridPropertiesStyle_cssRender(styles.right, breakpoint, behaviourState);
    console.warn(codecUtils_decoderErrors(styles));
    return {};
}
function gridPropertiesStyle_cssRender(stylesObj, breakpoint, behaviourState) {
    if (breakpoint === "desktop") {
        if (behaviourState === "default") {
            return gridPropertiesStyle_render(stylesObj.grid);
        } else {
            var ref, ref1;
            return gridPropertiesStyle_renderOpt(gridPropertiesStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref = stylesObj.behaviour) === null || ref === void 0 ? void 0 : (ref1 = ref[behaviourState]) === null || ref1 === void 0 ? void 0 : ref1.grid, stylesObj.grid));
        }
    } else {
        if (behaviourState === "default") {
            var ref2;
            return gridPropertiesStyle_renderOpt(gridPropertiesStyle_mergeBob2(stylesObj === null || stylesObj === void 0 ? void 0 : (ref2 = stylesObj[breakpoint]) === null || ref2 === void 0 ? void 0 : ref2.grid, stylesObj.grid));
        } else {
            var ref3, ref4, ref5, ref6, ref7, ref8;
            return gridPropertiesStyle_renderOpt(gridPropertiesStyle_mergeBob3(stylesObj === null || stylesObj === void 0 ? void 0 : (ref3 = stylesObj[breakpoint]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.behaviour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[behaviourState]) === null || ref5 === void 0 ? void 0 : ref5.grid, stylesObj === null || stylesObj === void 0 ? void 0 : (ref6 = stylesObj.behaviour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[behaviourState]) === null || ref7 === void 0 ? void 0 : ref7.grid, stylesObj === null || stylesObj === void 0 ? void 0 : (ref8 = stylesObj[breakpoint]) === null || ref8 === void 0 ? void 0 : ref8.grid, stylesObj.grid));
        }
    }
}
function gridPropertiesStyle_render(gridObj) {
    var gridProps = {};
    if (gridObj.gutters.enable && gridObj.gutters.value) {
        gridProps = {
            "--bs-gap": gridObj.gutters.value
        };
    } else {
        gridProps = {
            "--bs-gap": 0
        };
    }
    if (gridObj.columnsTotal) {
        gridProps = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, gridProps), {
            "--bs-columns": "".concat(gridObj.columnsTotal)
        });
    }
    return gridProps;
}
function gridPropertiesStyle_mergeBob2(gridObj, defaultGridObj) {
    var ref, ref1;
    var ref2;
    var columnsTotal = (ref2 = gridObj === null || gridObj === void 0 ? void 0 : gridObj.columnsTotal) !== null && ref2 !== void 0 ? ref2 : defaultGridObj.columnsTotal;
    var ref3, ref4;
    var gutters = {
        enable: (ref3 = gridObj === null || gridObj === void 0 ? void 0 : (ref = gridObj.gutters) === null || ref === void 0 ? void 0 : ref.enable) !== null && ref3 !== void 0 ? ref3 : defaultGridObj.gutters.enable,
        value: (ref4 = gridObj === null || gridObj === void 0 ? void 0 : (ref1 = gridObj.gutters) === null || ref1 === void 0 ? void 0 : ref1.value) !== null && ref4 !== void 0 ? ref4 : defaultGridObj.gutters.value
    };
    return {
        columnsTotal: columnsTotal,
        gutters: gutters
    };
}
function gridPropertiesStyle_mergeBob3(gridObj, gridDesktopBehaviour, gridDefaultBreakpoint, defaultGridObj) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6, ref7, ref8;
    var columnsTotal = (ref8 = (ref7 = (ref6 = gridObj === null || gridObj === void 0 ? void 0 : gridObj.columnsTotal) !== null && ref6 !== void 0 ? ref6 : gridDesktopBehaviour === null || gridDesktopBehaviour === void 0 ? void 0 : gridDesktopBehaviour.columnsTotal) !== null && ref7 !== void 0 ? ref7 : gridDefaultBreakpoint === null || gridDefaultBreakpoint === void 0 ? void 0 : gridDefaultBreakpoint.columnsTotal) !== null && ref8 !== void 0 ? ref8 : defaultGridObj.columnsTotal;
    var ref9, ref10, ref11, ref12, ref13, ref14;
    var gutters = {
        enable: (ref11 = (ref10 = (ref9 = gridObj === null || gridObj === void 0 ? void 0 : (ref = gridObj.gutters) === null || ref === void 0 ? void 0 : ref.enable) !== null && ref9 !== void 0 ? ref9 : gridDesktopBehaviour === null || gridDesktopBehaviour === void 0 ? void 0 : (ref1 = gridDesktopBehaviour.gutters) === null || ref1 === void 0 ? void 0 : ref1.enable) !== null && ref10 !== void 0 ? ref10 : gridDefaultBreakpoint === null || gridDefaultBreakpoint === void 0 ? void 0 : (ref2 = gridDefaultBreakpoint.gutters) === null || ref2 === void 0 ? void 0 : ref2.enable) !== null && ref11 !== void 0 ? ref11 : defaultGridObj.gutters.enable,
        value: (ref14 = (ref13 = (ref12 = gridObj === null || gridObj === void 0 ? void 0 : (ref3 = gridObj.gutters) === null || ref3 === void 0 ? void 0 : ref3.value) !== null && ref12 !== void 0 ? ref12 : gridDesktopBehaviour === null || gridDesktopBehaviour === void 0 ? void 0 : (ref4 = gridDesktopBehaviour.gutters) === null || ref4 === void 0 ? void 0 : ref4.value) !== null && ref13 !== void 0 ? ref13 : gridDefaultBreakpoint === null || gridDefaultBreakpoint === void 0 ? void 0 : (ref5 = gridDefaultBreakpoint.gutters) === null || ref5 === void 0 ? void 0 : ref5.value) !== null && ref14 !== void 0 ? ref14 : defaultGridObj.gutters.value
    };
    return {
        columnsTotal: columnsTotal,
        gutters: gutters
    };
}
function gridPropertiesStyle_renderOpt(gridObj) {
    var ref;
    var gridProps = {};
    if ((gridObj === null || gridObj === void 0 ? void 0 : (ref = gridObj.gutters) === null || ref === void 0 ? void 0 : ref.enable) && gridObj.gutters.value) {
        gridProps = {
            "--bs-gap": gridObj.gutters.value
        };
    } else {
        gridProps = {
            "--bs-gap": 0
        };
    }
    if (gridObj === null || gridObj === void 0 ? void 0 : gridObj.columnsTotal) {
        gridProps = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, gridProps), {
            "--bs-columns": "".concat(gridObj.columnsTotal)
        });
    }
    return gridProps;
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobGrid/bobGrid.tsx



function bobGrid_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  @media only screen and (max-width: 992px) and (min-width: 767px) {\n    ",
        "\n  }\n  @media all and (max-width: 766px) {\n    ",
        "\n  }\n"
    ]);
    bobGrid_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



















var bobGrid_GridStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc266f45-0"
})(bobGrid_templateObject(), function(props) {
    return props.desktop;
}, function(props) {
    return props.tablet;
}, function(props) {
    return props.mobile;
});
var BobGrid = function(props) {
    var ref;
    var ref1 = (0,react.useState)(/*#__PURE__*/ react.createRef()), containerRef = ref1[0];
    (0,react.useEffect)(function() {
        props.setRef && props.setRef(containerRef);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var gridStyles = isBobGrid(props.object.styles.bobs.grid1);
    var inlineContent = props.object.content.inlineContent;
    var mediaObject = inlineContent ? mediaLibraryUtils_handleSrcLink(props.pageResponse, components_getOverrideInlineContentValues("".concat(props.field, ".image-src"), props)) : undefined;
    var isVideo = (mediaObject === null || mediaObject === void 0 ? void 0 : (ref = mediaObject.mediaInfo) === null || ref === void 0 ? void 0 : ref.itemType) === "video" ? true : false;
    var imageSrc = mediaObject && !isVideo ? mediaObject.mediaSrc : "";
    if (!isVideo && window.Modernizr && !window.Modernizr.webp && (mediaObject === null || mediaObject === void 0 ? void 0 : mediaObject.fallbackExtension) && mediaObject.mediaInfo) {
        imageSrc = "https://static-media.fluxio.cloud/".concat(mediaObject.mediaInfo.profileName, "/").concat(mediaObject.mediaInfo.id, ".").concat(mediaObject.fallbackExtension);
    }
    var desktopStyles = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, gridPropertiesStyle_cssRenderUnsafe(gridStyles, "desktop", "default"), heightStyleV2_cssRenderUnsafe(gridStyles, "desktop", "default"), maxHeightStyle_cssRenderUnsafe(gridStyles, "desktop", "default"), minHeightStyle_cssRenderUnsafe(gridStyles, "desktop", "default"), widthStyleV2_cssRenderUnsafe(gridStyles, "desktop", "default"), maxWidthStyle_cssRenderUnsafe(gridStyles, "desktop", "default"), minWidthStyle_cssRenderUnsafe(gridStyles, "desktop", "default"), shadowStyleV2_cssRenderUnsafe(gridStyles, "desktop", "default", undefined, undefined), boundaryStyleV2_cssRenderUnsafe(gridStyles, "desktop", "default"), borderStyleV2_cssRenderUnsafe(gridStyles, "desktop", "default", undefined), selfFlexStyle_cssRenderUnsafe(gridStyles, "desktop", "default"), handleBackgroundColor(gridStyles), handleBackgroundImage(gridStyles, undefined, imageSrc)), {
        backgroundSize: gridStyles.image.size + " !important",
        backgroundRepeat: gridStyles.image.repeat + " !important",
        backgroundPosition: gridStyles.image.position + " !important",
        backgroundAttachment: gridStyles.attachment + " !important"
    });
    var tabletStyles = (0,src_object_spread/* default */.Z)({}, gridPropertiesStyle_cssRenderUnsafe(gridStyles, "tablet", "default"), heightStyleV2_cssRenderUnsafe(gridStyles, "tablet", "default"), maxHeightStyle_cssRenderUnsafe(gridStyles, "tablet", "default"), minHeightStyle_cssRenderUnsafe(gridStyles, "tablet", "default"), widthStyleV2_cssRenderUnsafe(gridStyles, "tablet", "default"), maxWidthStyle_cssRenderUnsafe(gridStyles, "tablet", "default"), minWidthStyle_cssRenderUnsafe(gridStyles, "tablet", "default"), shadowStyleV2_cssRenderUnsafe(gridStyles, "tablet", "default", undefined, undefined), boundaryStyleV2_cssRenderUnsafe(gridStyles, "tablet", "default"), borderStyleV2_cssRenderUnsafe(gridStyles, "tablet", "default", undefined), selfFlexStyle_cssRenderUnsafe(gridStyles, "tablet", "default"), responsiveProperties(gridStyles, "tablet", {
        image: {
            imageType: "backgroundImage"
        }
    }, [
        "grid",
        "height",
        "minHeight",
        "maxHeight",
        "width",
        "maxWidth",
        "minWidth",
        "alignment",
        "shadow",
        "spacing",
        "border", 
    ]));
    var mobileStyles = (0,src_object_spread/* default */.Z)({}, gridPropertiesStyle_cssRenderUnsafe(gridStyles, "mobile", "default"), heightStyleV2_cssRenderUnsafe(gridStyles, "mobile", "default"), maxHeightStyle_cssRenderUnsafe(gridStyles, "mobile", "default"), minHeightStyle_cssRenderUnsafe(gridStyles, "mobile", "default"), widthStyleV2_cssRenderUnsafe(gridStyles, "mobile", "default"), maxWidthStyle_cssRenderUnsafe(gridStyles, "mobile", "default"), minWidthStyle_cssRenderUnsafe(gridStyles, "mobile", "default"), shadowStyleV2_cssRenderUnsafe(gridStyles, "mobile", "default", undefined, undefined), boundaryStyleV2_cssRenderUnsafe(gridStyles, "mobile", "default"), borderStyleV2_cssRenderUnsafe(gridStyles, "mobile", "default", undefined), selfFlexStyle_cssRenderUnsafe(gridStyles, "mobile", "default"), responsiveProperties(gridStyles, "mobile", {
        image: {
            imageType: "backgroundImage"
        }
    }, [
        "grid",
        "height",
        "minHeight",
        "maxHeight",
        "width",
        "maxWidth",
        "minWidth",
        "alignment",
        "shadow",
        "spacing",
        "border", 
    ]));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(bobGrid_GridStyle, {
        ref: containerRef,
        id: "".concat(handleDOMid("object", props.object.uuid, props.object.selectedInstanceId), " ").concat(handleDOMid(props.field, props.id, props.instanceId)),
        className: "grid",
        desktop: desktopStyles,
        tablet: tabletStyles,
        mobile: mobileStyles,
        children: props.children
    });
};
/* harmony default export */ var bobGrid = (BobGrid);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Structure/grid/grid.tsx







//Needs to be module for SSR
//import "../../../../../../stylesheets/bootstrap-grid.css"

var Grid = function(props) {
    var ref = (0,react.useState)(undefined), elRef = ref[0], setElRef = ref[1];
    var grid1 = isBobGrid(props.obj.styles.bobs.grid1);
    var renderChilds = function() {
        var content = getContent(props.obj, "posts", props.overrides);
        if (content && content.length > 0) {
            return content.map(function(post, idx) {
                var childComponentsId = props.obj.children;
                if (childComponentsId && childComponentsId.length > 0) {
                    return renderChildComponents(childComponentsId, post, idx);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: "No Content"
                }, idx);
            });
        }
    };
    var renderChildComponents = function(childComponentsId, post, idx) {
        var startPositionClasses = getStartPos(childComponentsId, grid1);
        var counter = {
            desktop: 0,
            tablet: 0,
            mobile: 0
        };
        return childComponentsId.map(function(item, idx2) {
            var handledItem = handleObjectType(props.obj, item, props.pageResponse, props.expManager.emEditorType);
            var finalIdx = idx + idx2;
            var columns = bobGridHandler_handleColumns(idx2, counter, grid1);
            counter = columns.counter;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "g-col-".concat(columns.mobile, " g-col-md-").concat(columns.tablet, " g-col-lg-").concat(columns.desktop).concat(idx2 === 0 ? "".concat(startPositionClasses.desktopClass).concat(startPositionClasses.tabletClass).concat(startPositionClasses.mobileClass) : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                    position: finalIdx,
                    component: handleContentBlock(handledItem, post, props.obj, props.pageResponse, props.overrides),
                    pageResponse: props.pageResponse,
                    selectedInstanceId: props.obj.selectedInstanceId,
                    matchOrder: props.matchOrder,
                    expManager: props.expManager
                })
            }, finalIdx);
        });
    };
    var renderMissingChildsPreviews = function() {
        if (props.expManager.enable && !props.expManager.content) {
            var columns = grid1.grid.columns.length;
            var childs = props.obj.children.length;
            var missingChilds = columns - childs;
            var startFrom = columns - missingChilds;
            var previews = [];
            for(var i = 0; i < missingChilds; i++){
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
                var columnsDesktop = grid1.grid.columns[startFrom + i];
                var columnsTablet = ((ref = grid1.tablet) === null || ref === void 0 ? void 0 : (ref1 = ref.grid) === null || ref1 === void 0 ? void 0 : ref1.columns) ? (ref2 = grid1.tablet) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.grid) === null || ref3 === void 0 ? void 0 : ref3.columns[startFrom + i] : columnsDesktop;
                var columnsMobile = ((ref4 = grid1.mobile) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.grid) === null || ref5 === void 0 ? void 0 : ref5.columns) ? (ref6 = grid1.mobile) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.grid) === null || ref7 === void 0 ? void 0 : ref7.columns[startFrom + i] : columnsDesktop;
                previews.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "g-col-".concat(columnsMobile, " g-col-md-").concat(columnsTablet, " g-col-lg-").concat(columnsDesktop),
                        style: {
                            minHeight: "100px",
                            border: "1px solid rgba(64, 80, 252, 0.3)"
                        }
                    }, i)
                }));
            }
            return previews;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            props.expManager.enable && !props.expManager.content && /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM_ComponentSelectorEMv2, {
                uuid: props.obj.uuid,
                masterBob: "grid1",
                obj: props.obj,
                editing: props.editing,
                elRef: elRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(bobGrid, {
                setRef: function(containerRef) {
                    return setElRef(containerRef);
                },
                pageResponse: props.pageResponse,
                instanceId: props.obj.selectedInstanceId,
                object: props.obj,
                id: props.obj.uuid,
                inlineContent: props.obj.content.inlineContent,
                overrides: props.overrides,
                field: "grid1",
                post: props.post,
                template: props.obj.styles,
                children: [
                    renderChilds(),
                    renderMissingChildsPreviews()
                ]
            })
        ]
    });
};
/* harmony default export */ var grid = (/*#__PURE__*/react.memo(Grid));

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/Structure/grid/index.ts

/* harmony default export */ var Structure_grid = (grid);

;// CONCATENATED MODULE: ./src/modules/shared-modules/utilities/customCss.tsx
/**
 * true if a component has css written in any bob->breakpoint->element
 *
 * @param bobs
 * @returns
 */ function hasComponentCss(bobs) {
    if (bobs) {
        //New bobs
        if ("ncode1" in bobs) {
            var ncode1Obj = bobs.ncode1;
            if (ncode1Obj.code.default !== "") return true;
            if (ncode1Obj.code.desktop && ncode1Obj.code.desktop !== "") return true;
            if (ncode1Obj.code.tablet && ncode1Obj.code.tablet !== "") return true;
            if (ncode1Obj.code.mobile && ncode1Obj.code.mobile !== "") return true;
        }
        //Old bobs
        for(var bobKey in bobs){
            var bob = bobs[bobKey];
            if ("customCss" in bob) {
                var customCss = bob.customCss;
                if (customCss) {
                    for(var cssKey in customCss){
                        var breakpointCss = customCss[cssKey];
                        for(var brKey in breakpointCss){
                            var elementCss = breakpointCss[brKey];
                            if (elementCss && elementCss !== "") return true;
                        }
                    }
                }
            }
        }
    }
    return false;
}
/**
 * True if a bob has Css writen
 *
 * @param customCss
 * @returns
 */ function hasBobCss(customCss) {
    if (customCss && customCss !== "") return true;
    return false;
}
/**
 * True if an element has css written
 *
 * @param customCss
 * @param element
 * @returns
 */ function hasElementCss(customCss, element) {
    if (customCss) {
        for(var cssKey in customCss){
            var breakpointCss = customCss[cssKey];
            var elementCss = breakpointCss[element];
            if (elementCss && elementCss !== "") return true;
        }
    }
    return false;
}
/**
 * True if any breakpoint has css written for any element
 *
 * @param customCss
 * @param br
 * @returns
 */ function hasBreakpointCss(customCss, br) {
    if (customCss) {
        var breakpointCss = customCss[br];
        for(var brKey in breakpointCss){
            var elementCss = breakpointCss[brKey];
            if (elementCss && elementCss !== "") return true;
        }
    }
    return false;
}
/**
 * forceWriteQuery is used to write the css rules even
 * if there are no css props to write inside the rule,
 * used in the controller for example
 * @param bobCode
 * @param breakpoint
 * @returns
 */ // TODO: Styles bob type should be completed
function customCss_writeCustomCssSelectors(bobCode, breakpoint, forceWriteQuery) {
    if (breakpoint !== "default") {
        var css = bobCode.code[breakpoint] || "";
        var mobileMediaQuery = "@media all and (max-width: 768px)";
        var tabletMediaQuery = "@media all and (max-width: 992px) and (min-width: 767px)";
        var desktopMediaQuery = "@media all and (min-width: 992px)";
        var mediaQuery = breakpoint === "mobile" ? mobileMediaQuery : breakpoint === "tablet" ? tabletMediaQuery : desktopMediaQuery;
        if (css.trim() !== "" || forceWriteQuery) return "".concat(mediaQuery, "{\n").concat(css, "\n}");
        return "";
    }
    var css1 = bobCode.code.default;
    return css1;
}

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/customCssHandler/customCssHandler.tsx


//@ts-ignore


var CustomCssHandler = function(props) {
    var handleCustomCss = function() {
        var customCssDesktop = customCss_writeCustomCssSelectors(props.obj.styles.bobs.ncode1, "desktop", false);
        var customCssTablet = customCss_writeCustomCssSelectors(props.obj.styles.bobs.ncode1, "tablet", false);
        var customCssMobile = customCss_writeCustomCssSelectors(props.obj.styles.bobs.ncode1, "mobile", false);
        var customCssDefault = customCss_writeCustomCssSelectors(props.obj.styles.bobs.ncode1, "default", false);
        return "".concat(customCssDefault).concat(customCssDesktop).concat(customCssTablet).concat(customCssMobile);
    };
    var css = function() {
        var componentTemplate = props.obj.styles;
        if (componentTemplate.bobs && componentTemplate.bobs.ncode1) {
            var CustomCss = handleCustomCss();
            return "".concat(CustomCss);
        }
        return "";
    };
    var cssRules = css();
    if (cssRules.trim() !== "") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((style_it_default()), {
                    children: "".concat(cssRules)
                }),
                props.children
            ]
        });
    }
    return props.children;
};
/* harmony default export */ var customCssHandler = (/*#__PURE__*/react.memo(CustomCssHandler));

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/customCssHandler/index.tsx

/* harmony default export */ var shared_public_page_customCssHandler = (customCssHandler);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobForm/bobFormHandler.ts


















var bobFormHandler_responsiveStyles = function(styles, stylesheetLabels, breakpoint, behaviourState) {
    var stylesheetShadowColorLabel = handleBobShadowLabel(styles, stylesheetLabels, breakpoint, behaviourState);
    var stylesheetBorderColorLabel = handleBobBorderLabel(styles, stylesheetLabels, breakpoint, behaviourState);
    var stylesheetColorsLabel = handleBobColorsLabel(styles, stylesheetLabels, breakpoint, behaviourState);
    return (0,src_object_spread/* default */.Z)({}, heightStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState), maxHeightStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), minHeightStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), widthStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState), maxWidthStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), minWidthStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), flexStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), selfFlexStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), shadowStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState, undefined, stylesheetShadowColorLabel), boundaryStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState), borderStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState, stylesheetBorderColorLabel), radiusStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), zindexStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), positionStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), cursorStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), colorsStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState, undefined, stylesheetColorsLabel));
};


;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobForm/bobForm.tsx











function bobForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all ",
        " {\n            &:hover {\n              ",
        "\n            }\n          }\n        "
    ]);
    bobForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function bobForm_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    &:hover {\n                      ",
        "\n                    }\n                  "
    ]);
    bobForm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function bobForm_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all and (max-width: 992px) and (min-width: 767px) {\n            ",
        "\n            ",
        "\n          }\n        "
    ]);
    bobForm_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function bobForm_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    &:hover {\n                      ",
        "\n                    }\n                  "
    ]);
    bobForm_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function bobForm_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all and (max-width: 766px) {\n            ",
        "\n            ",
        "\n          }\n        "
    ]);
    bobForm_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function bobForm_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    bobForm_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
















var FormDiv = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-d89508ba-0"
})(bobForm_templateObject5(), function(props) {
    return props.desktop;
}, function(props) {
    return props.hover.isEnabled.desktop ? (0,styled_components_browser_esm/* css */.iv)(bobForm_templateObject(), handleMediaQueryRestrictions(props.hover.isEnabled.mobile, props.hover.isEnabled.tablet), props.hover.desktop) : {};
}, function(props) {
    return Object.keys(props.tablet).length > 0 || Object.keys(props.hover.tablet).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(bobForm_templateObject2(), function(props) {
        return props.tablet;
    }, function(props) {
        return props.hover.isEnabled.tablet && Object.keys(props.hover.tablet).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(bobForm_templateObject1(), props.hover.tablet) : {};
    }) : {};
}, function(props) {
    return Object.keys(props.mobile).length > 0 || Object.keys(props.hover.mobile).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(bobForm_templateObject4(), function(props) {
        return props.mobile;
    }, function(props) {
        return props.hover.isEnabled.mobile && Object.keys(props.hover.mobile).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(bobForm_templateObject3(), props.hover.mobile) : {};
    }) : {};
});
var BobForm = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(BobForm, _Component);
    var _super = (0,_create_super/* default */.Z)(BobForm);
    function BobForm(props) {
        (0,src_class_call_check/* default */.Z)(this, BobForm);
        var _this;
        _this = _super.call(this, props);
        _this.setSubmitFeedback = function(submitFeedback) {
            return _this.setState({
                submitFeedback: submitFeedback
            });
        };
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.onSubmit = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(event) {
                var _Object, form, reacaptchToken, formData, formObject, config, body;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            event.preventDefault();
                            form = _this1.props.form;
                            if (!(form === null || form === void 0 ? void 0 : form.captcha)) {
                                _ctx.next = 9;
                                break;
                            }
                            _ctx.next = 6;
                            return _this1.props.googleReCaptchaProps.executeRecaptcha("form");
                        case 6:
                            _ctx.t0 = _ctx.sent;
                            _ctx.next = 10;
                            break;
                        case 9:
                            _ctx.t0 = undefined;
                        case 10:
                            reacaptchToken = _ctx.t0;
                            formData = new FormData(event.target);
                            formObject = Object.fromEntries(formData.entries());
                            // change formObject keys created with input name to input id
                            if (form) formObject = (_Object = Object).assign.apply(_Object, [
                                {}
                            ].concat((0,src_to_consumable_array/* default */.Z)(Object.keys(formObject).map(function(nameKey) {
                                var fieldId = Object.values(form === null || form === void 0 ? void 0 : form.fields).filter(function(field) {
                                    return field.name === nameKey;
                                })[0].id;
                                return (0,src_define_property/* default */.Z)({}, fieldId, formObject[nameKey]);
                            }))));
                            config = {
                                headers: {
                                    "Content-Type": "application/json",
                                    Accept: "application/json",
                                    "MeshApp-host": "meshapp"
                                }
                            };
                            body = {
                                token: reacaptchToken,
                                values: formObject
                            };
                            axios_default().post("".concat(shared_api_apiEnv(), "v1/forms/").concat(form === null || form === void 0 ? void 0 : form.uuid, "/submit"), JSON.stringify(body), config).then(function(res) {
                                var ref;
                                // error response
                                if ((ref = res.data) === null || ref === void 0 ? void 0 : ref.error) _this1.setSubmitFeedback({
                                    type: "error",
                                    text: (form === null || form === void 0 ? void 0 : form.lang) === "pt" ? "Algo correu mal." : "Something went wrong."
                                });
                                else _this1.setSubmitFeedback({
                                    type: "success",
                                    text: (form === null || form === void 0 ? void 0 : form.lang) === "pt" ? "Formul\xe1rio enviado com sucesso." : "Form submitted successfully."
                                });
                            }).catch(function(error) {
                                console.warn("err", error);
                                _this1.setSubmitFeedback({
                                    type: "error",
                                    text: (form === null || form === void 0 ? void 0 : form.lang) === "pt" ? "Algo correu mal." : "Something went wrong."
                                });
                            });
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(event) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.state = {
            submitFeedback: undefined
        };
        _this.formRef = /*#__PURE__*/ react.createRef();
        return _this;
    }
    var _proto = BobForm.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.props.setRef && this.props.setRef(this.formRef);
    };
    _proto.render = function render() {
        var _this = this;
        var ref, ref1, ref2, ref3;
        //@ts-ignore
        var templateStyles = isBobFormV2(this.props.object.styles.bobs.nform1);
        var settings = this.props.object.settings;
        var pageLabels = (ref = this.props.pageResponse.stylesheet) === null || ref === void 0 ? void 0 : ref.labels;
        var DesktopStyles = bobFormHandler_responsiveStyles(templateStyles, pageLabels, "desktop", "default");
        var TabletStyles = bobFormHandler_responsiveStyles(templateStyles, pageLabels, "tablet", "default");
        var MobileStyles = bobFormHandler_responsiveStyles(templateStyles, pageLabels, "mobile", "default");
        var hoverStyles = handleStateStyles(templateStyles, bobFormHandler_responsiveStyles(templateStyles, pageLabels, "desktop", "hover"), bobFormHandler_responsiveStyles(templateStyles, pageLabels, "tablet", "hover"), bobFormHandler_responsiveStyles(templateStyles, pageLabels, "mobile", "hover"));
        var DOMid = this.props.expManager.enable ? {
            id: "".concat(handleDOMid(this.props.field, this.props.id, this.props.instanceId))
        } : {};
        var EMpreviewClass = emPreviewClass(this.props.expManager.enable, templateStyles.uuid);
        var EMScrollId = emScrollId(this.props.expManager.enable, this.props.object.uuid);
        var _obj;
        var GlobalStylesClass = globalStylesUtils.handleClassNameV2(this.props.pageResponse.nGlobalStyles, templateStyles, "-box", (_obj = {}, (0,src_define_property/* default */.Z)(_obj, GS_SHADOW, NGS_CLASS_SUFIX), (0,src_define_property/* default */.Z)(_obj, GS_BOUNDARY, NGS_CLASS_SUFIX), _obj));
        var customClasses = (settings === null || settings === void 0 ? void 0 : (ref1 = settings[this.props.field]) === null || ref1 === void 0 ? void 0 : ref1.class) ? " ".concat(settings === null || settings === void 0 ? void 0 : (ref2 = settings[this.props.field]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.class) === null || ref3 === void 0 ? void 0 : ref3.join(" ")) : "";
        var classes = "".concat((public_components_module_default()).flx_flex).concat(EMpreviewClass ? " ".concat(EMpreviewClass, " ") : "").concat(GlobalStylesClass ? " ".concat(GlobalStylesClass, " ") : "").concat(customClasses);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormDiv, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            onSubmit: function(e) {
                return _this.onSubmit(e);
            },
            ref: this.formRef,
            desktop: DesktopStyles,
            mobile: MobileStyles,
            tablet: TabletStyles,
            hover: hoverStyles
        }, EMScrollId, DOMid), {
            className: classes,
            children: [
                this.props.children,
                this.state.submitFeedback && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "simple-form-component ".concat((simpleForm_module_default())["simple-form-component"]),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "submit-feedback ml-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: this.state.submitFeedback.type ? this.state.submitFeedback.type === "error" ? "submit-error" : "submit-success" : "",
                            children: this.state.submitFeedback.text
                        })
                    })
                })
            ]
        }));
    };
    return BobForm;
}(react.Component);
var BobFormRecaptchaWrapChild = (0,react_google_recaptcha_v3_esm/* withGoogleReCaptcha */.sT)(BobForm);
var BobFormRecaptchaWrap = function(props) {
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_google_recaptcha_v3_esm/* GoogleReCaptchaProvider */.pm, {
        reCaptchaKey: (ref = props.form) === null || ref === void 0 ? void 0 : (ref1 = ref.captcha) === null || ref1 === void 0 ? void 0 : ref1.key,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BobFormRecaptchaWrapChild, (0,src_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var bobForm = (BobFormRecaptchaWrap);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/forms/form/form.tsx






var Form = function(props) {
    var ref = (0,react.useState)(undefined), elRef = ref[0], setElRef = ref[1];
    var childComponentsId = props.obj.children;
    var renderChild = function(post) {
        if (childComponentsId) {
            return childComponentsId.map(function(childId, idx) {
                var handledItem = handleObjectType(props.obj, childId, props.pageResponse, props.expManager.emEditorType);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
                    position: idx,
                    component: handleContentBlock(handledItem, post, props.obj, props.pageResponse, props.overrides),
                    pageResponse: props.pageResponse,
                    selectedInstanceId: props.obj.selectedInstanceId,
                    matchOrder: props.matchOrder,
                    expManager: props.expManager,
                    form: props.obj.content.form
                }, idx);
            });
        }
    };
    var items = getContent(props.obj, "posts", props.overrides);
    var childs = [];
    if (items && items.length > 0) {
        childs = items.map(function(post, idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(bobForm, {
                id: props.obj.uuid,
                pageResponse: props.pageResponse,
                instanceId: props.obj.selectedInstanceId,
                inlineContent: props.obj.content.inlineContent,
                overrides: props.overrides,
                object: props.obj,
                post: post,
                template: props.obj.styles,
                field: "nform1",
                setRef: function(containerRef) {
                    return setElRef(containerRef);
                },
                expManager: props.expManager,
                replacedMediaList: props.replacedMediaList,
                form: props.obj.content.form,
                children: renderChild(post)
            }, idx);
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            props.expManager.enable && !props.expManager.content && /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM_ComponentSelectorEMv2, {
                uuid: props.obj.uuid,
                obj: props.obj,
                form: props.obj.content.form,
                masterBob: "nform1",
                editing: props.editing,
                elRef: elRef
            }),
            childs
        ]
    });
};
/* harmony default export */ var form_form = (/*#__PURE__*/react.memo(Form));

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobInput/bobInputHandler.ts
























var bobInputHandler_responsiveStyles = function(styles, stylesheetLabels, breakpoint, behaviourState) {
    var shadowColorLabel = handleBobShadowLabel(styles, stylesheetLabels, breakpoint, behaviourState);
    var borderColorLabel = handleBobBorderLabel(styles, stylesheetLabels, breakpoint, behaviourState);
    var colorLabel = handleBobLabel(styles, stylesheetLabels, breakpoint, behaviourState, "color");
    var decorationColorLabel = handleBobTextDecorationLabel(styles, stylesheetLabels, breakpoint, behaviourState);
    var colorsLabel = handleBobColorsLabel(styles, stylesheetLabels, breakpoint, behaviourState);
    var textLabel = handleBobLabel(styles, stylesheetLabels, breakpoint, behaviourState, "fontFamily");
    return (0,src_object_spread/* default */.Z)({}, heightStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState), maxHeightStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), minHeightStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), widthStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState), maxWidthStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), minWidthStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), flexStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), selfFlexStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), shadowStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState, undefined, shadowColorLabel), boundaryStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState), borderStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState, borderColorLabel), radiusStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), zindexStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), positionStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), cursorStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), textStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState, textLabel), textArrangeStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), heightStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState), maxHeightStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), minHeightStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), widthStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState), maxWidthStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), minWidthStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), selfFlexStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), boundaryStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState), colorStyle_cssRenderUnsafe(styles, breakpoint, behaviourState, undefined, colorLabel, false), cursorStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), textShadowStyle_cssRenderUnsafe(styles, breakpoint, behaviourState, undefined, shadowColorLabel), positionStyle_cssRenderUnsafe(styles, breakpoint, behaviourState), textDecorationStyle_cssRenderUnsafe(styles, breakpoint, behaviourState, decorationColorLabel), colorsStyleV2_cssRenderUnsafe(styles, breakpoint, behaviourState, undefined, colorsLabel));
};


;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobInput/bobInput.tsx







function bobInput_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    ::placeholder {\n      color: ",
        ";\n    }\n  "
    ]);
    bobInput_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function bobInput_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all ",
        " {\n            &:hover {\n              ",
        ";\n              ::placeholder {\n                color: ",
        ";\n              }\n            }\n          }\n        "
    ]);
    bobInput_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function bobInput_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    &:hover {\n                      ",
        "\n                      ::placeholder {\n                        color: ",
        ";\n                      }\n                    }\n                  "
    ]);
    bobInput_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function bobInput_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all and (max-width: 992px) and (min-width: 767px) {\n            ",
        "\n            ::placeholder {\n              color: ",
        ";\n            }\n            ",
        "\n          }\n        "
    ]);
    bobInput_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function bobInput_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    &:hover {\n                      ",
        "\n                      ::placeholder {\n                        color: ",
        ";\n                      }\n                    }\n                  "
    ]);
    bobInput_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function bobInput_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all and (max-width: 766px) {\n            ",
        "\n            ::placeholder {\n              color: ",
        ";\n            }\n            ",
        "\n          }\n        "
    ]);
    bobInput_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function bobInput_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    bobInput_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



// @ts-ignore












var InputDiv = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-6d5b227f-0"
})(bobInput_templateObject6(), function(props) {
    return (0,styled_components_browser_esm/* css */.iv)(bobInput_templateObject(), props.desktop, props.desktop.color);
}, function(props) {
    return props.hover.isEnabled.desktop ? (0,styled_components_browser_esm/* css */.iv)(bobInput_templateObject1(), handleMediaQueryRestrictions(props.hover.isEnabled.mobile, props.hover.isEnabled.tablet), props.hover.desktop, props.hover.desktop.color) : {};
}, function(props) {
    return Object.keys(props.tablet).length > 0 || Object.keys(props.hover.tablet).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(bobInput_templateObject3(), function(props) {
        return props.tablet;
    }, props.tablet.color, function(props) {
        return props.hover.isEnabled.tablet && Object.keys(props.hover.tablet).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(bobInput_templateObject2(), props.hover.tablet, props.hover.tablet.color) : {};
    }) : {};
}, function(props) {
    return Object.keys(props.mobile).length > 0 || Object.keys(props.hover.mobile).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(bobInput_templateObject5(), function(props) {
        return props.mobile;
    }, props.mobile.color, function(props) {
        return props.hover.isEnabled.mobile && Object.keys(props.hover.mobile).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(bobInput_templateObject4(), props.hover.mobile, props.hover.mobile.color) : {};
    }) : {};
});
var BobInput = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(BobInput, _Component);
    var _super = (0,_create_super/* default */.Z)(BobInput);
    function BobInput(props) {
        (0,src_class_call_check/* default */.Z)(this, BobInput);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            inputValue: getFormField(props.form, "value", props.object.content, props.field)
        };
        _this.inputRef = /*#__PURE__*/ react.createRef();
        return _this;
    }
    var _proto = BobInput.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.props.setRef && this.props.setRef(this.inputRef);
    };
    _proto.handleInputChange = function handleInputChange(e) {
        this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this.state), {
            inputValue: e.target.value
        }));
    };
    _proto.render = function render() {
        var _this = this;
        var ref, ref1, ref2, ref3;
        var bobField = this.props.field;
        var templateStyles = isBobInput(this.props.object.styles.bobs.ninput1);
        var content = this.props.object.content;
        var form = this.props.form;
        var settings = this.props.object.settings;
        var pageLabels = (ref = this.props.pageResponse.stylesheet) === null || ref === void 0 ? void 0 : ref.labels;
        var DesktopStyles = bobInputHandler_responsiveStyles(templateStyles, pageLabels, "desktop", "default");
        var TabletStyles = bobInputHandler_responsiveStyles(templateStyles, pageLabels, "tablet", "default");
        var MobileStyles = bobInputHandler_responsiveStyles(templateStyles, pageLabels, "mobile", "default");
        var hoverStyles = handleStateStyles(templateStyles, bobInputHandler_responsiveStyles(templateStyles, pageLabels, "desktop", "hover"), bobInputHandler_responsiveStyles(templateStyles, pageLabels, "tablet", "hover"), bobInputHandler_responsiveStyles(templateStyles, pageLabels, "mobile", "hover"));
        var DOMid = this.props.expManager.enable ? {
            id: "".concat(handleDOMid(bobField, this.props.id, this.props.instanceId))
        } : {};
        var EMpreviewClass = emPreviewClass(this.props.expManager.enable, templateStyles.uuid);
        var EMScrollId = emScrollId(this.props.expManager.enable, this.props.object.uuid);
        var _obj;
        var GlobalStylesClass = globalStylesUtils.handleClassNameV2(this.props.pageResponse.nGlobalStyles, templateStyles, "-box", (_obj = {}, (0,src_define_property/* default */.Z)(_obj, GS_SHADOW, NGS_CLASS_SUFIX), (0,src_define_property/* default */.Z)(_obj, GS_BOUNDARY, NGS_CLASS_SUFIX), _obj));
        var customClasses = (settings === null || settings === void 0 ? void 0 : (ref1 = settings[bobField]) === null || ref1 === void 0 ? void 0 : ref1.class) ? " ".concat(settings === null || settings === void 0 ? void 0 : (ref2 = settings[bobField]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.class) === null || ref3 === void 0 ? void 0 : ref3.join(" ")) : "";
        var classes = "".concat((public_components_module_default()).flx_flex).concat(EMpreviewClass ? " ".concat(EMpreviewClass, " ") : "").concat(GlobalStylesClass ? " ".concat(GlobalStylesClass, " ") : "").concat(customClasses);
        var loadedFonts = handleFonts(templateStyles, pageLabels, this.props.expManager.enable);
        var hasFont = loadedFonts.trim() !== "";
        var fieldType = getFormField(form, "fieldType", content, bobField);
        var name = getFormField(form, "name", content, bobField);
        var placeholder = getFormField(form, "placeholder", content, bobField);
        var required = getFormField(form, "required", content, bobField);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                hasFont && /*#__PURE__*/ (0,jsx_runtime.jsx)((style_it_default()), {
                    children: "\n            ".concat(loadedFonts, "\n          ")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputDiv, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    type: fieldType,
                    value: this.state.inputValue,
                    placeholder: placeholder,
                    required: required,
                    name: name,
                    onChange: function(e) {
                        return _this.handleInputChange(e);
                    },
                    ref: this.inputRef,
                    desktop: DesktopStyles,
                    mobile: MobileStyles,
                    tablet: TabletStyles,
                    hover: hoverStyles
                }, EMScrollId, DOMid), {
                    className: classes
                }))
            ]
        });
    };
    return BobInput;
}(react.Component);
/* harmony default export */ var bobInput = (BobInput);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/forms/formInput/formInput.tsx





var FormInput = function(props) {
    var ref = (0,react.useState)(undefined), elRef = ref[0], setElRef = ref[1];
    var items = getContent(props.obj, "posts", props.overrides);
    var childs = [];
    if (items && items.length > 0) {
        childs = items.map(function(post, idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(bobInput, {
                id: props.obj.uuid,
                pageResponse: props.pageResponse,
                instanceId: props.obj.selectedInstanceId,
                inlineContent: props.obj.content.inlineContent,
                overrides: props.overrides,
                object: props.obj,
                post: post,
                template: props.obj.styles,
                field: "ninput1",
                setRef: function(containerRef) {
                    return setElRef(containerRef);
                },
                expManager: props.expManager,
                replacedMediaList: props.replacedMediaList,
                form: props.form
            }, idx);
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            props.expManager.enable && !props.expManager.content && /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM_ComponentSelectorEMv2, {
                uuid: props.obj.uuid,
                obj: props.obj,
                form: props.form,
                masterBob: "ninput1",
                editing: props.editing,
                elRef: elRef
            }),
            childs
        ]
    });
};
/* harmony default export */ var formInput_formInput = (/*#__PURE__*/react.memo(FormInput));

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/bob/bobSubmit/bobSubmit.tsx







function bobSubmit_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    ::placeholder {\n      color: ",
        ";\n    }\n  "
    ]);
    bobSubmit_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function bobSubmit_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all ",
        " {\n            &:hover {\n              ",
        ";\n              ::placeholder {\n                color: ",
        ";\n              }\n            }\n          }\n        "
    ]);
    bobSubmit_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function bobSubmit_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    &:hover {\n                      ",
        "\n                      ::placeholder {\n                        color: ",
        ";\n                      }\n                    }\n                  "
    ]);
    bobSubmit_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function bobSubmit_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all and (max-width: 992px) and (min-width: 767px) {\n            ",
        "\n            ::placeholder {\n              color: ",
        ";\n            }\n            ",
        "\n          }\n        "
    ]);
    bobSubmit_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function bobSubmit_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    &:hover {\n                      ",
        "\n                      ::placeholder {\n                        color: ",
        ";\n                      }\n                    }\n                  "
    ]);
    bobSubmit_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function bobSubmit_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media all and (max-width: 766px) {\n            ",
        "\n            ::placeholder {\n              color: ",
        ";\n            }\n            ",
        "\n          }\n        "
    ]);
    bobSubmit_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function bobSubmit_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    bobSubmit_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



// @ts-ignore












var bobSubmit_InputDiv = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-ccd21678-0"
})(bobSubmit_templateObject6(), function(props) {
    return (0,styled_components_browser_esm/* css */.iv)(bobSubmit_templateObject(), props.desktop, props.desktop.color);
}, function(props) {
    return props.hover.isEnabled.desktop ? (0,styled_components_browser_esm/* css */.iv)(bobSubmit_templateObject1(), handleMediaQueryRestrictions(props.hover.isEnabled.mobile, props.hover.isEnabled.tablet), props.hover.desktop, props.hover.desktop.color) : {};
}, function(props) {
    return Object.keys(props.tablet).length > 0 || Object.keys(props.hover.tablet).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(bobSubmit_templateObject3(), function(props) {
        return props.tablet;
    }, props.tablet.color, function(props) {
        return props.hover.isEnabled.tablet && Object.keys(props.hover.tablet).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(bobSubmit_templateObject2(), props.hover.tablet, props.hover.tablet.color) : {};
    }) : {};
}, function(props) {
    return Object.keys(props.mobile).length > 0 || Object.keys(props.hover.mobile).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(bobSubmit_templateObject5(), function(props) {
        return props.mobile;
    }, props.mobile.color, function(props) {
        return props.hover.isEnabled.mobile && Object.keys(props.hover.mobile).length > 0 ? (0,styled_components_browser_esm/* css */.iv)(bobSubmit_templateObject4(), props.hover.mobile, props.hover.mobile.color) : {};
    }) : {};
});
var bobSubmit_BobInput = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(BobInput, _Component);
    var _super = (0,_create_super/* default */.Z)(BobInput);
    function BobInput(props) {
        (0,src_class_call_check/* default */.Z)(this, BobInput);
        var _this;
        _this = _super.call(this, props);
        _this.inputRef = /*#__PURE__*/ react.createRef();
        return _this;
    }
    var _proto = BobInput.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.props.setRef && this.props.setRef(this.inputRef);
    };
    _proto.render = function render() {
        var ref, ref1, ref2, ref3;
        //@ts-ignore
        var templateStyles = isBobInput(this.props.object.styles.bobs.submit1);
        var settings = this.props.object.settings;
        var pageLabels = (ref = this.props.pageResponse.stylesheet) === null || ref === void 0 ? void 0 : ref.labels;
        var DesktopStyles = bobInputHandler_responsiveStyles(templateStyles, pageLabels, "desktop", "default");
        var TabletStyles = bobInputHandler_responsiveStyles(templateStyles, pageLabels, "tablet", "default");
        var MobileStyles = bobInputHandler_responsiveStyles(templateStyles, pageLabels, "mobile", "default");
        var hoverStyles = handleStateStyles(templateStyles, bobInputHandler_responsiveStyles(templateStyles, pageLabels, "desktop", "hover"), bobInputHandler_responsiveStyles(templateStyles, pageLabels, "tablet", "hover"), bobInputHandler_responsiveStyles(templateStyles, pageLabels, "mobile", "hover"));
        var DOMid = this.props.expManager.enable ? {
            id: "".concat(handleDOMid(this.props.field, this.props.id, this.props.instanceId))
        } : {};
        var EMpreviewClass = emPreviewClass(this.props.expManager.enable, templateStyles.uuid);
        var EMScrollId = emScrollId(this.props.expManager.enable, this.props.object.uuid);
        var _obj;
        var GlobalStylesClass = globalStylesUtils.handleClassNameV2(this.props.pageResponse.nGlobalStyles, templateStyles, "-box", (_obj = {}, (0,src_define_property/* default */.Z)(_obj, GS_SHADOW, NGS_CLASS_SUFIX), (0,src_define_property/* default */.Z)(_obj, GS_BOUNDARY, NGS_CLASS_SUFIX), _obj));
        var customClasses = (settings === null || settings === void 0 ? void 0 : (ref1 = settings[this.props.field]) === null || ref1 === void 0 ? void 0 : ref1.class) ? " ".concat(settings === null || settings === void 0 ? void 0 : (ref2 = settings[this.props.field]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.class) === null || ref3 === void 0 ? void 0 : ref3.join(" ")) : "";
        var classes = "".concat((public_components_module_default()).flx_flex).concat(EMpreviewClass ? " ".concat(EMpreviewClass, " ") : "").concat(GlobalStylesClass ? " ".concat(GlobalStylesClass, " ") : "").concat(customClasses);
        var loadedFonts = handleFonts(templateStyles, pageLabels, this.props.expManager.enable);
        var hasFont = loadedFonts.trim() !== "";
        var label = getFormProp(this.props.form, "submitLabel", this.props.object.content, this.props.field);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                hasFont && /*#__PURE__*/ (0,jsx_runtime.jsx)((style_it_default()), {
                    children: "\n            ".concat(loadedFonts, "\n          ")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bobSubmit_InputDiv, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    type: "submit",
                    ref: this.inputRef,
                    desktop: DesktopStyles,
                    mobile: MobileStyles,
                    tablet: TabletStyles,
                    hover: hoverStyles
                }, EMScrollId, DOMid), {
                    className: classes,
                    value: label
                }))
            ]
        });
    };
    return BobInput;
}(react.Component);
/* harmony default export */ var bobSubmit = (bobSubmit_BobInput);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/fluxio-components/forms/formSubmit/formSubmit.tsx





var FormSubmit = function(props) {
    var ref = (0,react.useState)(undefined), elRef = ref[0], setElRef = ref[1];
    var items = getContent(props.obj, "posts", props.overrides);
    var childs = [];
    if (items && items.length > 0) {
        childs = items.map(function(post, idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(bobSubmit, {
                id: props.obj.uuid,
                pageResponse: props.pageResponse,
                instanceId: props.obj.selectedInstanceId,
                inlineContent: props.obj.content.inlineContent,
                overrides: props.overrides,
                object: props.obj,
                post: post,
                template: props.obj.styles,
                field: "submit1",
                setRef: function(elRef) {
                    return setElRef(elRef);
                },
                expManager: props.expManager,
                replacedMediaList: props.replacedMediaList,
                form: props.form
            }, idx);
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            props.expManager.enable && !props.expManager.content && /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM_ComponentSelectorEMv2, {
                uuid: props.obj.uuid,
                obj: props.obj,
                form: props.form,
                masterBob: "submit1",
                editing: props.editing,
                elRef: elRef
            }),
            childs
        ]
    });
};
/* harmony default export */ var formSubmit = (/*#__PURE__*/react.memo(FormSubmit));

;// CONCATENATED MODULE: ./src/areas/public-page/componentHandler/componentHandler.tsx







//import dynamic from 'next/dynamic'








// Templates2



























































var ComponentHandler = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ComponentHandler, _Component);
    var _super = (0,_create_super/* default */.Z)(ComponentHandler);
    function ComponentHandler() {
        (0,src_class_call_check/* default */.Z)(this, ComponentHandler);
        return _super.apply(this, arguments);
    }
    var _proto = ComponentHandler.prototype;
    _proto.componentDidMount = function componentDidMount() {
        // access inner methods from parent
        if (this.props.onRef) this.props.onRef(this);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        // access inner methods from parent
        if (this.props.onRef) this.props.onRef(undefined);
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        var areEqual = nextProps === this.props;
        if (areEqual) return false;
        else {
            var diff = false;
            for(var key in nextProps){
                /*
        We're using object spread to create the `component` prop, which forces rerenders even if there is no change
        A better solution would be to pass the symbol and instance down to the bobs and they could choose which value
        to read from.

        Currently we just optimize (prevent re-render) for the case where this component is an instance, we also
        avoid a deep equals when `component.styles` exists, because styles are too big to use deep equals.
        */ if (key === "component" && !nextProps.component.styles) diff = !isEqual_default()(nextProps.component, this.props.component);
                else {
                    //@ts-ignore
                    diff = nextProps[key] !== this.props[key];
                }
                if (diff) break;
            }
            return diff;
        }
    };
    _proto.handleInnerFunction = function handleInnerFunction(postSlug) {
        if (this.childRef) this.childRef.handleInnerFunction(postSlug);
    };
    _proto.handleLogicForEditState = function handleLogicForEditState(item) {
        //If its outside of EM we dont return the editing class
        if (!this.props.expManager.enable) return false;
        /**
     * If there is a selected instance in the page tree we cant let
     * the logic continute, so we force the return to be false
     * if the ids dont match
     */ if (typeof this.props.selectedSymbolInstanceId === "string") {
            if (this.props.selectedSymbolInstanceId === item.selectedInstanceId) {
                if (!this.props.symbolObj) return true;
                return this.props.hubHandlerId === item.uuid ? true : false;
            }
            return false;
        }
        /**
     * In this case everything works as usual
     */ return this.props.hubHandlerId === item.uuid ? true : false;
    };
    _proto.handleKey = function handleKey(item) {
        if (item === null || item === void 0 ? void 0 : item.selectedInstanceId) return "".concat(item.uuid, "-").concat(item.selectedInstanceId);
        return item === null || item === void 0 ? void 0 : item.uuid;
    };
    _proto.handleInstances = function handleInstances(item) {
        if (item.type === "instance") {
            // must keep parent id to send to pageTree when it needs to expand the instance parents
            var parentId = item.parentId // TODO: needed?
            ;
            var symbolObj = symbols_handleFilterSymbolObject(item, this.props.pageResponse.symbols, this.props.symbolObj);
            /**
       * On instance mode we send an object with the overrides
       * Each bob reads the override, and the EM can easly control it here
       */ if (this.props.symbolContentType === "instance") {
                var ref;
                // const clonedSymbolObj = cloneDeep(symbolObj)
                // const overridedSymbolObj = Symbols.handleInstanceOverrides(item, undefined, clonedSymbolObj)
                // return { ...overridedSymbolObj, parentId: parentId }
                return {
                    item: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, symbolObj), {
                        parentId: parentId
                    }),
                    overrides: (ref = item.content.overrides) === null || ref === void 0 ? void 0 : ref[symbolObj.uuid]
                };
            } else {
                return {
                    item: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, symbolObj), {
                        parentId: parentId
                    }),
                    overrides: undefined
                };
            }
        }
        return {
            item: item,
            overrides: undefined
        };
    };
    //Experimental, needs better solution
    _proto.isConditionalHidden = function isConditionalHidden(item, overrides) {
        if (item.isContentBlockChild && item.hiddenConditionField) {
            var ref, ref1;
            var ref2;
            var Posts = (ref2 = overrides === null || overrides === void 0 ? void 0 : (ref = overrides.formula) === null || ref === void 0 ? void 0 : ref.posts) !== null && ref2 !== void 0 ? ref2 : (ref1 = item.content.formula) === null || ref1 === void 0 ? void 0 : ref1.posts;
            //No posts we dont hide anything
            if (!Posts) return false;
            //we get the first post, since we only inject 1 post when dealing with contentblock
            var postField = jsonpath_default().query(Posts[0], item.hiddenConditionField);
            //we dont have the required field to show
            if (postField.length <= 0) return true;
        }
        return false;
    };
    _proto.render = function render() {
        var itemComponent = this.props.component;
        var pageResponse = this.props.pageResponse;
        var ref = this.handleInstances(itemComponent), item = ref.item, overrides = ref.overrides;
        /**
     * Hide component with eye icon, and hide by missing post field
     */ if (item.hidden || this.isConditionalHidden(item, overrides)) {
            return null;
        }
        /**
     * add selectedInstanceId to symbol root object childs
     *
     * selectedInstanceId is wirtten to the symbol root object in handleFilterSymbolObject
     * wich will be passed down it's childs
     */ if (this.props.selectedInstanceId) item.selectedInstanceId = this.props.selectedInstanceId;
        var componentRule = pageResponse.components[item.styles.component];
        switch(componentRule.name){
            case SOCIAL_CARD_SHARE:
                var _this = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialCardShare_SocialCardShare, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this.props.replacedMediaList,
                                        position: _this.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this.props.matchOrder,
                                        expManager: _this.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case TABS_CONTAINER:
                var _this1 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            noContainer: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsContainer_TabsContainer, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this1.props.replacedMediaList,
                                        position: _this1.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this1.props.matchOrder,
                                        expManager: _this1.props.expManager,
                                        shouldWriteRoute: true
                                    });
                                }
                            })
                        })
                    })
                });
            case TABS_CONTAINER_V2:
                var _this2 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            noContainer: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsContainer_TabsContainer, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this2.props.replacedMediaList,
                                        position: _this2.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this2.props.matchOrder,
                                        expManager: _this2.props.expManager,
                                        shouldWriteRoute: false
                                    });
                                }
                            })
                        })
                    })
                });
            case TABS_CONTAINER_DROPDOWN:
                var _this3 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            noContainer: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsContainerDropdown_TabsContainerDropdown, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this3.props.replacedMediaList,
                                        position: _this3.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this3.props.matchOrder,
                                        expManager: _this3.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case TABS_CONTENT_VERTICAL:
                var _this4 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsContentVertical_TabsContentVertical, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this4.props.replacedMediaList,
                                        position: _this4.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this4.props.matchOrder,
                                        expManager: _this4.props.expManager,
                                        tabName: _this4.props.tabName,
                                        tabLabel: _this4.props.tabLabel,
                                        tabIcon: _this4.props.tabIcon,
                                        tabEventKey: _this4.handleKey(_this4.props.tabEventKey)
                                    });
                                }
                            })
                        })
                    })
                });
            case TABS_CONTENT:
                var _this5 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsContent_TabsContent, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this5.props.replacedMediaList,
                                        position: _this5.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this5.props.matchOrder,
                                        expManager: _this5.props.expManager,
                                        tabName: _this5.props.tabName,
                                        tabLabel: _this5.props.tabLabel,
                                        tabIcon: _this5.props.tabIcon,
                                        tabEventKey: _this5.handleKey(_this5.props.tabEventKey)
                                    });
                                }
                            })
                        })
                    })
                });
            case TABS_CONTENT_VERTICAL_V2:
                var _this6 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsContentVerticalV2_TabsContentVerticalV2, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this6.props.replacedMediaList,
                                        position: _this6.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this6.props.matchOrder,
                                        expManager: _this6.props.expManager,
                                        tabName: _this6.props.tabName,
                                        tabLabel: _this6.props.tabLabel,
                                        tabIcon: _this6.props.tabIcon,
                                        tabEventKey: _this6.handleKey(_this6.props.tabEventKey)
                                    });
                                }
                            })
                        })
                    })
                });
            case TABS_CONTENT_V2:
                var _this7 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsContentV2_TabsContentV2, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this7.props.replacedMediaList,
                                        position: _this7.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this7.props.matchOrder,
                                        expManager: _this7.props.expManager,
                                        tabName: _this7.props.tabName,
                                        tabLabel: _this7.props.tabLabel,
                                        tabIcon: _this7.props.tabIcon,
                                        tabEventKey: _this7.handleKey(_this7.props.tabEventKey)
                                    });
                                }
                            })
                        })
                    })
                });
            case CARD_MODAL:
                var _this8 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardModal_CardModal, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this8.props.replacedMediaList,
                                        position: _this8.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this8.props.matchOrder,
                                        expManager: _this8.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case CARD_LEFT:
                var _this9 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(cardLeft, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this9.props.replacedMediaList,
                                        position: _this9.props.position,
                                        componentRule: componentRule,
                                        matchOrder: _this9.props.matchOrder,
                                        expManager: _this9.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case CARD_LEFT_V2:
                var _this10 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(cardLeftV2, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this10.props.replacedMediaList,
                                        position: _this10.props.position,
                                        componentRule: componentRule,
                                        matchOrder: _this10.props.matchOrder,
                                        expManager: _this10.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case CARD_TOP:
                var _this11 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(cardTop, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this11.props.replacedMediaList,
                                        position: _this11.props.position,
                                        componentRule: componentRule,
                                        matchOrder: _this11.props.matchOrder,
                                        expManager: _this11.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case CARD_RIGHT:
                var _this12 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(cardRight, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this12.props.replacedMediaList,
                                        position: _this12.props.position,
                                        componentRule: componentRule,
                                        matchOrder: _this12.props.matchOrder,
                                        expManager: _this12.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case CARD_RIGHT_V2:
                var _this13 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(cardRightV2, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this13.props.replacedMediaList,
                                        position: _this13.props.position,
                                        componentRule: componentRule,
                                        matchOrder: _this13.props.matchOrder,
                                        expManager: _this13.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case CARD_EXPAND_CONTAINER:
                var _this14 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(cardExpandContainer, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this14.props.replacedMediaList,
                                        position: _this14.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this14.props.matchOrder,
                                        expManager: _this14.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case EXPAND_CONTENT:
                var _this15 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(expandContent, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this15.props.replacedMediaList,
                                        position: _this15.props.position,
                                        componentRule: componentRule,
                                        itemIsActive: _this15.props.itemIsActive,
                                        matchOrder: _this15.props.matchOrder,
                                        expManager: _this15.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case EXPAND_CONTENT_V2:
                var _this16 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(expandContentV2, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this16.props.replacedMediaList,
                                        position: _this16.props.position,
                                        componentRule: componentRule,
                                        itemIsActive: _this16.props.itemIsActive,
                                        matchOrder: _this16.props.matchOrder,
                                        expManager: _this16.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case GRID_CONTAINER:
                var _this17 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(gridContainer, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this17.props.replacedMediaList,
                                        position: _this17.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this17.props.matchOrder,
                                        expManager: _this17.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case GRID_CONTAINER_V2:
                var _this18 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(gridContainerV2, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this18.props.replacedMediaList,
                                        position: _this18.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this18.props.matchOrder,
                                        expManager: _this18.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case CONTAINER:
                var _this19 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_public_page_customCssHandler, {
                        obj: item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                            obj: item,
                            overrides: overrides,
                            expManager: this.props.expManager,
                            children: function(contentItem) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(container, {
                                    pageResponse: pageResponse,
                                    obj: contentItem,
                                    overrides: overrides,
                                    replacedMediaList: _this19.props.replacedMediaList,
                                    editing: _this19.handleLogicForEditState(contentItem),
                                    matchOrder: _this19.props.matchOrder,
                                    expManager: _this19.props.expManager,
                                    selectedInstanceId: _this19.props.selectedInstanceId,
                                    form: _this19.props.form
                                });
                            }
                        })
                    })
                });
            case MEDIAV2:
                var _this20 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_public_page_customCssHandler, {
                        obj: item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                            obj: item,
                            overrides: overrides,
                            expManager: this.props.expManager,
                            children: function(contentItem) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements_media_v2, {
                                    pageResponse: pageResponse,
                                    obj: contentItem,
                                    overrides: overrides,
                                    replacedMediaList: _this20.props.replacedMediaList,
                                    editing: _this20.handleLogicForEditState(contentItem),
                                    matchOrder: _this20.props.matchOrder,
                                    expManager: _this20.props.expManager,
                                    selectedInstanceId: _this20.props.selectedInstanceId
                                });
                            }
                        })
                    })
                });
            case TEXT:
                var _this21 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_public_page_customCssHandler, {
                        obj: item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                            obj: item,
                            overrides: overrides,
                            expManager: this.props.expManager,
                            children: function(contentItem) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(text_text, {
                                    pageResponse: pageResponse,
                                    obj: contentItem,
                                    overrides: overrides,
                                    replacedMediaList: _this21.props.replacedMediaList,
                                    editing: _this21.handleLogicForEditState(contentItem),
                                    matchOrder: _this21.props.matchOrder,
                                    expManager: _this21.props.expManager,
                                    selectedInstanceId: _this21.props.selectedInstanceId,
                                    form: _this21.props.form
                                });
                            }
                        })
                    })
                });
            case GRID:
                var _this22 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_public_page_customCssHandler, {
                        obj: item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                            obj: item,
                            overrides: overrides,
                            expManager: this.props.expManager,
                            children: function(contentItem) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Structure_grid, {
                                    pageResponse: pageResponse,
                                    obj: contentItem,
                                    overrides: overrides,
                                    replacedMediaList: _this22.props.replacedMediaList,
                                    editing: _this22.handleLogicForEditState(contentItem),
                                    matchOrder: _this22.props.matchOrder,
                                    expManager: _this22.props.expManager,
                                    selectedInstanceId: _this22.props.selectedInstanceId
                                });
                            }
                        })
                    })
                });
            case FORM:
                var _this23 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_public_page_customCssHandler, {
                        obj: item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                            obj: item,
                            overrides: overrides,
                            expManager: this.props.expManager,
                            children: function(contentItem) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(form_form, {
                                    obj: contentItem,
                                    overrides: overrides,
                                    pageResponse: pageResponse,
                                    replacedMediaList: _this23.props.replacedMediaList,
                                    selectedInstanceId: item.selectedInstanceId,
                                    matchOrder: _this23.props.matchOrder,
                                    expManager: _this23.props.expManager,
                                    editing: _this23.handleLogicForEditState(contentItem)
                                });
                            }
                        })
                    })
                });
            case INPUT:
                var _this24 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_public_page_customCssHandler, {
                        obj: item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                            obj: item,
                            overrides: overrides,
                            expManager: this.props.expManager,
                            children: function(contentItem) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(formInput_formInput, {
                                    obj: contentItem,
                                    overrides: overrides,
                                    pageResponse: pageResponse,
                                    replacedMediaList: _this24.props.replacedMediaList,
                                    selectedInstanceId: item.selectedInstanceId,
                                    matchOrder: _this24.props.matchOrder,
                                    expManager: _this24.props.expManager,
                                    editing: _this24.handleLogicForEditState(contentItem),
                                    form: _this24.props.form
                                });
                            }
                        })
                    })
                });
            case SUBMIT:
                var _this25 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_public_page_customCssHandler, {
                        obj: item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                            obj: item,
                            overrides: overrides,
                            expManager: this.props.expManager,
                            children: function(contentItem) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(formSubmit, {
                                    obj: contentItem,
                                    overrides: overrides,
                                    pageResponse: pageResponse,
                                    replacedMediaList: _this25.props.replacedMediaList,
                                    selectedInstanceId: item.selectedInstanceId,
                                    matchOrder: _this25.props.matchOrder,
                                    expManager: _this25.props.expManager,
                                    editing: _this25.handleLogicForEditState(contentItem),
                                    form: _this25.props.form
                                });
                            }
                        })
                    })
                });
            case SLIDER_CONTAINER:
                var _this26 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(sliderContainer, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this26.props.replacedMediaList,
                                        position: _this26.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this26.props.matchOrder,
                                        expManager: _this26.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case SLIDER_CONTAINER_V2:
                var _this27 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(sliderContainerV2, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this27.props.replacedMediaList,
                                        position: _this27.props.position,
                                        componentRule: componentRule,
                                        matchOrder: _this27.props.matchOrder,
                                        expManager: _this27.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case SLIDER_CONTAINER_V3:
                var _this28 = this;
                if (item.hidden) {
                    return null;
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(sliderContainerV3, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this28.props.replacedMediaList,
                                        position: _this28.props.position,
                                        componentRule: componentRule,
                                        matchOrder: _this28.props.matchOrder,
                                        expManager: _this28.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case EMBED_CONTAINER:
                var _this29 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(embedContainer, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this29.props.replacedMediaList,
                                        position: _this29.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this29.props.matchOrder,
                                        expManager: _this29.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case EMBED_CONTAINER_V2:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(embedContainerV2, {
                        obj: item,
                        overrides: overrides,
                        pageResponse: pageResponse,
                        replacedMediaList: this.props.replacedMediaList,
                        position: this.props.position,
                        componentRule: componentRule,
                        selectedInstanceId: item.selectedInstanceId,
                        matchOrder: this.props.matchOrder,
                        expManager: this.props.expManager
                    })
                });
            case MEDIA:
                var _this30 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Media_Media, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this30.props.replacedMediaList,
                                        position: _this30.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this30.props.matchOrder,
                                        expManager: _this30.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case TEXT_BLOCK:
                var _this31 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBlock_TextBlock, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this31.props.replacedMediaList,
                                        position: _this31.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this31.props.matchOrder,
                                        expManager: _this31.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case BUTTON:
                var _this32 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this32.props.replacedMediaList,
                                        position: _this32.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this32.props.matchOrder,
                                        expManager: _this32.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case BUTTON_RIGHT:
                var _this33 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonRight_ButtonRight, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this33.props.replacedMediaList,
                                        position: _this33.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this33.props.matchOrder,
                                        expManager: _this33.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case NAVBARCOMPONENTV2:
                var _this34 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(navbarV2, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this34.props.replacedMediaList,
                                        position: _this34.props.position,
                                        componentRule: componentRule,
                                        matchOrder: _this34.props.matchOrder,
                                        expManager: _this34.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case NAVBARCOMPONENT:
                var _this35 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this35.props.replacedMediaList,
                                        position: _this35.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this35.props.matchOrder,
                                        expManager: _this35.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case NAVBARTOP:
                var _this36 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(navbarTop, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this36.props.replacedMediaList,
                                        position: _this36.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this36.props.matchOrder,
                                        expManager: _this36.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case MENUCOMPONENT:
                var _this37 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(menu, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this37.props.replacedMediaList,
                                        position: _this37.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this37.props.matchOrder,
                                        expManager: _this37.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case MENUCOMPONENT_V2:
                var _this38 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(menuV2, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this38.props.replacedMediaList,
                                        position: _this38.props.position,
                                        componentRule: componentRule,
                                        matchOrder: _this38.props.matchOrder,
                                        expManager: _this38.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case MENUTOGGLECOMPONENT:
                var _this39 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(menuToggle, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this39.props.replacedMediaList,
                                        position: _this39.props.position,
                                        componentRule: componentRule,
                                        matchOrder: _this39.props.matchOrder,
                                        expManager: _this39.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case MENUTOGGLECOMPONENTV2:
                var _this40 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(menuToggleV2, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this40.props.replacedMediaList,
                                        position: _this40.props.position,
                                        componentRule: componentRule,
                                        matchOrder: _this40.props.matchOrder,
                                        expManager: _this40.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case DROPDOWN:
                var _this41 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this41.props.replacedMediaList,
                                        position: _this41.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this41.props.matchOrder,
                                        expManager: _this41.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case DROPDOWN_V2:
                var _this42 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdownV2, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this42.props.replacedMediaList,
                                        position: _this42.props.position,
                                        componentRule: componentRule,
                                        matchOrder: _this42.props.matchOrder,
                                        expManager: _this42.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case MODAL:
                var _this43 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            noContainer: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_Modal, {
                                        onRef: function(ref) {
                                            return _this43.childRef = ref;
                                        },
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this43.props.replacedMediaList,
                                        position: _this43.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this43.props.matchOrder,
                                        expManager: _this43.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case MODAL_V2:
                var _this44 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            noContainer: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalV2_ModalV2, {
                                        onRef: function(ref) {
                                            return _this44.childRef = ref;
                                        },
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this44.props.replacedMediaList,
                                        position: _this44.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this44.props.matchOrder,
                                        expManager: _this44.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case MODAL_V3:
                var _this45 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            noContainer: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalV3_ModalV3, {
                                        onRef: function(ref) {
                                            return _this45.childRef = ref;
                                        },
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this45.props.replacedMediaList,
                                        position: _this45.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this45.props.matchOrder,
                                        expManager: _this45.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case MODAL_V4:
                var _this46 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            noContainer: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalV4_ModalV4, {
                                        onRef: function(ref) {
                                            return _this46.childRef = ref;
                                        },
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this46.props.replacedMediaList,
                                        position: _this46.props.position,
                                        componentRule: componentRule,
                                        matchOrder: _this46.props.matchOrder,
                                        expManager: _this46.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case SHOWCASE:
                var _this47 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(showcase, {
                                        onRef: function(ref) {
                                            return _this47.childRef = ref;
                                        },
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this47.props.replacedMediaList,
                                        position: _this47.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this47.props.matchOrder,
                                        expManager: _this47.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case SOCIAL_CARD_EMBED:
                var _this48 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialCardEmbed_SocialCardEmbed, {
                                        onRef: function(ref) {
                                            return _this48.childRef = ref;
                                        },
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this48.props.replacedMediaList,
                                        position: _this48.props.position,
                                        componentRule: componentRule,
                                        selectedInstanceId: item.selectedInstanceId,
                                        matchOrder: _this48.props.matchOrder,
                                        expManager: _this48.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case SOCIAL_MEDIA_EMBED:
                var _this49 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMediaEmbed_SocialMediaEmbed, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this49.props.replacedMediaList,
                                        position: _this49.props.position,
                                        componentRule: componentRule,
                                        matchOrder: _this49.props.matchOrder,
                                        expManager: _this49.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case IMAGE_COMPARATION_SLIDER:
                var _this50 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(comparationSlider, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        replacedMediaList: _this50.props.replacedMediaList,
                                        position: _this50.props.position,
                                        matchOrder: _this50.props.matchOrder,
                                        expManager: _this50.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case FORM_CONTAINER:
                var _this51 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                                obj: item,
                                overrides: overrides,
                                expManager: this.props.expManager,
                                children: function(contentItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormContainer_FormContainer, {
                                        obj: contentItem,
                                        overrides: overrides,
                                        pageResponse: pageResponse,
                                        position: _this51.props.position,
                                        componentRule: componentRule,
                                        expManager: _this51.props.expManager
                                    });
                                }
                            })
                        })
                    })
                });
            case RESULTS_MAP:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(resultsMap, {
                                obj: item,
                                overrides: overrides,
                                pageResponse: pageResponse,
                                replacedMediaList: this.props.replacedMediaList,
                                position: this.props.position,
                                componentRule: componentRule,
                                matchOrder: this.props.matchOrder,
                                expManager: this.props.expManager
                            })
                        })
                    })
                });
            case DATASET_CONTAINER:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dataSetContainer, {
                                obj: item,
                                pageResponse: pageResponse,
                                replacedMediaList: this.props.replacedMediaList,
                                position: this.props.position,
                                matchOrder: this.props.matchOrder,
                                expManager: this.props.expManager
                            })
                        })
                    })
                });
            case RESULTS_LIST_CONTAINER:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(resultsListContainer, {
                                obj: item,
                                pageResponse: pageResponse,
                                replacedMediaList: this.props.replacedMediaList,
                                position: this.props.position,
                                matchOrder: this.props.matchOrder,
                                expManager: this.props.expManager
                            })
                        })
                    })
                });
            case FILTERS:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentBoilerplate, {
                            obj: item,
                            pageResponse: pageResponse,
                            overrides: overrides,
                            position: this.props.position,
                            expManager: this.props.expManager,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dataSetFilter, {
                                obj: item,
                                overrides: overrides,
                                pageResponse: pageResponse,
                                replacedMediaList: this.props.replacedMediaList,
                                position: this.props.position,
                                componentRule: componentRule,
                                matchOrder: this.props.matchOrder,
                                expManager: this.props.expManager
                            })
                        })
                    })
                });
            // case component.GRID:
            //   return (
            //     <ErrorBoundary>
            //       <ContentFetch obj={item} overrides={overrides} expManager={this.props.expManager}>
            //         {(contentItem: SingleObject) => (
            //           <Grid
            //             pageResponse={pageResponse}
            //             obj={contentItem}
            //             overrides={overrides}
            //             replacedMediaList={this.props.replacedMediaList}
            //             editing={this.handleLogicForEditState(contentItem)}
            //             matchOrder={this.props.matchOrder}
            //             expManager={this.props.expManager}
            //             selectedInstanceId={item.selectedInstanceId}
            //           />
            //         )}
            //       </ContentFetch>
            //     </ErrorBoundary>
            //   )
            // case component.TEXT:
            //   return (
            //     <ErrorBoundary>
            //       <ContentFetch obj={item} overrides={overrides} expManager={this.props.expManager}>
            //         {(contentItem: SingleObject) => (
            //           <Text
            //             pageResponse={pageResponse}
            //             obj={item}
            //             overrides={overrides}
            //             replacedMediaList={this.props.replacedMediaList}
            //             editing={this.handleLogicForEditState(contentItem)}
            //             matchOrder={this.props.matchOrder}
            //             expManager={this.props.expManager}
            //             selectedInstanceId={item.selectedInstanceId}
            //           />
            //         )}
            //       </ContentFetch>
            //     </ErrorBoundary>
            //   )
            // case component.MEDIAV2:
            //   return (
            //     <ErrorBoundary expManager={this.props.expManager}>
            //       <ContentFetch obj={item} overrides={overrides} expManager={this.props.expManager}>
            //         {(contentItem: SingleObject) => (
            //           <MediaV2
            //             obj={contentItem}
            //             overrides={overrides}
            //             pageResponse={pageResponse}
            //             replacedMediaList={this.props.replacedMediaList}
            //             selectedInstanceId={item.selectedInstanceId}
            //             matchOrder={this.props.matchOrder}
            //             expManager={this.props.expManager}
            //             editing={this.handleLogicForEditState(contentItem)}
            //           />
            //         )}
            //       </ContentFetch>
            //     </ErrorBoundary>
            //   )
            default:
                var _this52 = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorBoundary, {
                    expManager: this.props.expManager,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(componentSelectorEM, {
                        uuid: item.uuid,
                        expManager: this.props.expManager,
                        obj: item,
                        editing: this.handleLogicForEditState(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_ContentFetch, {
                            obj: item,
                            overrides: overrides,
                            expManager: this.props.expManager,
                            children: function(contentItem) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(invalid_Invalid, {
                                    id: item.uuid,
                                    obj: item,
                                    componentRule: componentRule,
                                    expManager: _this52.props.expManager
                                });
                            }
                        })
                    })
                });
        }
    };
    return ComponentHandler;
}(react.Component);
function componentHandler_mapStateToProps(state) {
    return {
        hubHandlerId: state.experienceManagerReducer.server.hubHandlerId || null,
        selectedSymbolInstanceId: state.symbolsReducer.server.selectedSymbolInstanceId || null,
        symbolObj: state.pageTreeReducer.server.symbolObj || null,
        symbolContentType: state.symbolsReducer.server.symbolContentType || null,
        replacedMediaList: state.mediaLibraryReducer.replacedMediaList
    };
}
/* harmony default export */ var componentHandler = ((0,es/* connect */.$j)(componentHandler_mapStateToProps)(ComponentHandler));

;// CONCATENATED MODULE: ./src/areas/public-page/componentHandler/index.ts

/* harmony default export */ var public_page_componentHandler = (componentHandler);

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/objectHandler/objectHandler.tsx



var ObjectHandler = function(props) {
    var component = props.component;
    var pageResponse = props.pageResponse;
    /**
   * Render Every object children
   */ var childrenObjects = component.children.map(function(objectId, idx) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(public_page_componentHandler, {
            position: idx,
            component: pageResponse.objects[objectId],
            pageResponse: pageResponse,
            matchOrder: props.matchOrder,
            expManager: props.expManager
        }, objectId);
    });
    return childrenObjects;
};
/* harmony default export */ var objectHandler = (/*#__PURE__*/react.memo(ObjectHandler));

// EXTERNAL MODULE: ./node_modules/imagesloaded/imagesloaded.js
var imagesloaded = __webpack_require__(77564);
var imagesloaded_default = /*#__PURE__*/__webpack_require__.n(imagesloaded);
;// CONCATENATED MODULE: ./src/split/shared-public-page/pageLoaderImageSplit.tsx



var PageLoaderImageSplit = function(props) {
    return props.options.media ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        priority: true,
        loader: function() {
            return props.options.media;
        },
        src: props.options.media,
        alt: "loading",
        width: "100px",
        height: "100px"
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var pageLoaderImageSplit = (/*#__PURE__*/react.memo(PageLoaderImageSplit));

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/pageBootstrap/pageLoader.tsx

function pageLoader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    pageLoader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


// @ts-ignore



var PageLoaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1ab8be20-0"
})(pageLoader_templateObject(), function(props) {
    return "\n    visibility: visible;\n    opacity: 1;\n    transition: visibility 0.3s, opacity 0.3s linear;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #fff;\n    color: #000;\n    z-index: 999999999999;\n  ";
});
var PageLoader = function(props) {
    var handleImagesLoaded = function() {
        imagesloaded_default()(document.querySelector(".page-container"), function(a) {
            var loader = document.querySelector("#page-loader");
            if (loader && loader.style.display !== "none") {
                loader.style.opacity = "0";
                loader.style.visibility = "hidden";
            }
        });
    };
    if (props.options.delay) setTimeout(function() {
        handleImagesLoaded();
    }, props.options.delay);
    else handleImagesLoaded();
    // show when enabled and outside pagebuilder
    if (props.options.enable && !props.expManager.enable) {
        if (!props.options.code) return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoaderContainer, {
            id: "page-loader",
            children: props.options.media ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pageLoaderImageSplit, {
                options: props.options
            }) : "Loading"
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoaderContainer, {
            id: "page-loader",
            dangerouslySetInnerHTML: {
                __html: props.options.code
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var pageLoader = (/*#__PURE__*/react.memo(PageLoader));

;// CONCATENATED MODULE: ./src/areas/public-page/shared-public-page/pageBootstrap/pageBootstrap.tsx

function pageBootstrap_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    pageBootstrap_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





// @ts-ignore




var PageBootstrapContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cbe12c68-0"
})(pageBootstrap_templateObject(), function(props) {
    return handlePageBootstrapStyles(props);
});
var handlePageBootstrapStyles = function(props) {
    var ref, ref1;
    return "".concat(globalStylesUtils.handleStyles(props.nGlobalStyles, (ref = props.stylesheet) === null || ref === void 0 ? void 0 : ref.labels, props.expManager), "\n").concat(writeStylesheetCssVariables((ref1 = props.stylesheet) === null || ref1 === void 0 ? void 0 : ref1.labels));
};
var PageBootstrap = function(props) {
    var renderComponents = function() {
        var ref, ref1;
        var fontImports = getFontImports(props.pageResponse.nGlobalStyles, (ref = props.pageResponse.stylesheet) === null || ref === void 0 ? void 0 : ref["labels"], props.expManager);
        var pageResponse = props.pageResponse;
        var rootId = pageResponse.rootId;
        var pageRootObject = pageResponse.objects[rootId];
        /**
     * Workaround for possible problem with the uri rules, see issue:
     * https://github.com/MeshApp/web/issues/1169
     */ var matchOrderNumber = (((ref1 = pageRootObject.uri) === null || ref1 === void 0 ? void 0 : ref1.match(/\//g)) || []).length + 1;
        if (pageRootObject) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                fontImports !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)((style_it_default()), {
                    children: "\n            ".concat(fontImports, "\n          ")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(objectHandler, {
                    component: pageRootObject,
                    pageResponse: pageResponse,
                    matchOrder: matchOrderNumber,
                    expManager: props.expManager
                })
            ]
        });
        // handle error/no-content
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "empty-content",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "msg",
                children: "No Hub"
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageBootstrapContainer, {
        nGlobalStyles: props.pageResponse.nGlobalStyles,
        stylesheet: props.pageResponse.stylesheet,
        expManager: props.expManager,
        className: "page-container",
        children: [
            props.pageResponse.profileName === "davidrosas" && (props.pageResponse.objects[props.pageResponse.rootId].uri === "fine-jewellery" || props.pageResponse.objects[props.pageResponse.rootId].uri === "time-experts") && /*#__PURE__*/ (0,jsx_runtime.jsx)(pageLoader, {
                expManager: props.expManager,
                options: {
                    enable: true,
                    delay: 2000,
                    media: "https://static-media.fluxio.cloud/davidrosas/82BJxWAi_5.gif",
                    code: undefined
                }
            }),
            renderComponents()
        ]
    });
};
/* harmony default export */ var pageBootstrap = (/*#__PURE__*/react.memo(PageBootstrap));

// EXTERNAL MODULE: ./node_modules/next-useragent/dist/next-useragent.js
var next_useragent = __webpack_require__(28010);
;// CONCATENATED MODULE: ./src/api/shared-api/contentLibraryApi.ts

function contentLibraryApi_getLibrary(profile, token, order, orderBy, limit, search, cursor) {
    // when filters are not present, body must not exist
    var endpoint = "".concat(apiEnv(), "v1/profiles/").concat(profile, "/contentLibrary/content");
    var body = {
        limit: limit,
        order: order,
        orderBy: orderBy,
        search: search !== "" ? search : undefined,
        cursor: cursor !== "" ? cursor : undefined
    };
    var request = new Request(endpoint, {
        method: "POST",
        headers: new Headers({
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer ".concat(token.access_token)
        }),
        body: JSON.stringify(body)
    });
    return fetch(request).then(function(response) {
        if (response.status === 200) {
            return response.json();
        }
        throw response;
    }).catch(function(error) {
        throw error;
    });
}
function savePost(profileId, token, postObj, action) {
    var body = {
        title: postObj.title,
        picture: postObj.image,
        description: postObj.description,
        message: postObj.message,
        external_link: postObj.url,
        experience_order: postObj.experience_order !== "" ? postObj.experience_order : null,
        profileTags: postObj.profileTags
    };
    var endpoint = "".concat(apiEnv(), "v1/profiles/").concat(profileId, "/content/posts");
    var request = new Request(endpoint, {
        method: "POST",
        headers: new Headers({
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer ".concat(token.access_token)
        }),
        body: JSON.stringify(body)
    });
    return fetch(request).then(function(response) {
        if (response.status === 200) {
            return response.json();
        }
        throw response;
    }).catch(function(error) {
        throw error;
    });
}
function contentLibraryApi_validContentPagePostUrl(title, postId, contentPageId, profileId, token) {
    var body = {
        title: title,
        contentPageId: contentPageId,
        postId: postId
    };
    var endpoint = "".concat(apiEnv(), "v1/profiles/").concat(profileId, "/content/validatePageUrl");
    var request = new Request(endpoint, {
        method: "POST",
        headers: new Headers({
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer ".concat(token.access_token)
        }),
        body: JSON.stringify(body)
    });
    return fetch(request).then(function(response) {
        if (response.status === 200) {
            return response.json();
        }
        throw response;
    }).catch(function(error) {
        throw error;
    });
}
function contentLibraryApi_setDefaultPostToTest(objectRootId, post, profileId, token) {
    var endpoint = "".concat(apiEnv(), "v1/profiles/").concat(profileId, "/pages/root/").concat(objectRootId, "/defaultPost/").concat(post.sourceId);
    var request = new Request(endpoint, {
        method: "POST",
        headers: new Headers({
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer ".concat(token.access_token)
        })
    });
    return fetch(request).then(function(response) {
        if (response.status === 200) {
            return response.json();
        }
        throw response;
    }).catch(function(error) {
        throw error;
    });
}
function contentLibraryApi_getPostsToTest(objectRootId, profileId, token) {
    var endpoint = "".concat(apiEnv(), "v1/profiles/").concat(profileId, "/pages/root/").concat(objectRootId, "/posts");
    var request = new Request(endpoint, {
        method: "GET",
        headers: new Headers({
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer ".concat(token.access_token)
        })
    });
    return fetch(request).then(function(response) {
        if (response.status === 200) {
            return response.json();
        }
        throw response;
    }).catch(function(error) {
        throw error;
    });
}
function contentLibraryApi_getPreviewContentPagePost(hostId, pageUri, slug) {
    var endpoint = "".concat(apiEnv(), "v1/contentPageContent");
    var body = {
        hostId: hostId,
        pageUri: pageUri,
        slug: slug
    };
    var request = new Request(endpoint, {
        method: "POST",
        headers: new Headers({
            "Content-Type": "application/json",
            Accept: "application/json"
        }),
        body: JSON.stringify(body)
    });
    return fetch(request).then(function(response) {
        if (response.status === 200) {
            return response.json();
        }
        throw response;
    }).catch(function(error) {
        throw error;
    });
}
function getPublicContentPagePost(postId, url) {
    var endpoint = "".concat(shared_api_apiEnv(), "v1/contentPageContent");
    var body = {};
    if (postId) {
        body = {
            postId: postId
        };
    } else if (url) {
        body = {
            url: url
        };
    }
    var request = new Request(endpoint, {
        method: "POST",
        headers: new Headers({
            "Content-Type": "application/json",
            Accept: "application/json"
        }),
        body: JSON.stringify(body)
    });
    return fetch(request).then(function(response) {
        if (response.status === 200) {
            return response.json();
        }
        throw response;
    }).catch(function(error) {
        throw error;
    });
}
function detachContentPagePost(objectRootId, profile, token) {
    var endpoint = "".concat(apiEnv(), "v1/profiles/").concat(profile, "/pages/root/").concat(objectRootId, "/defaultPost/");
    var request = new Request(endpoint, {
        method: "DELETE",
        headers: new Headers({
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer ".concat(token.access_token)
        })
    });
    return fetch(request).then(function(response) {
        if (response.status === 200) {
            return response.json();
        }
        throw response;
    }).catch(function(error) {
        throw error;
    });
}
function contentLibraryApi_contentPageListByPost(sourceId, profile, token) {
    var endpoint = "".concat(apiEnv(), "v1/profiles/").concat(profile, "/content/posts/").concat(sourceId, "/contentPages");
    var request = new Request(endpoint, {
        method: "GET",
        headers: new Headers({
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer ".concat(token.access_token)
        })
    });
    return fetch(request).then(function(response) {
        if (response.status === 200) {
            return response.json();
        }
        throw response;
    }).catch(function(error) {
        throw error;
    });
}
function contentLibraryApi_fetchContentPageListByWorkspace(profile, token) {
    var endpoint = "".concat(apiEnv(), "v1/profiles/").concat(profile, "/contentPages");
    var request = new Request(endpoint, {
        method: "GET",
        headers: new Headers({
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer ".concat(token.access_token)
        })
    });
    return fetch(request).then(function(response) {
        if (response.status === 200) {
            return response.json();
        }
        throw response;
    }).catch(function(error) {
        throw error;
    });
}
function createPost(post, profileId, token) {
    var urlApi = "".concat(apiEnv(), "v1/profiles/").concat(profileId, "/content2/posts");
    var body = {
        title: post.title,
        picture: post.image,
        cover: post.cover,
        description: post.description,
        message: post.message,
        external_link: post.url,
        experience_order: post.experience_order !== "" ? post.experience_order : null,
        profileTags: post.profileTags,
        contentPage: post.contentPage
    };
    var request = new Request(urlApi, {
        method: "POST",
        headers: new Headers({
            "Content-Type": "application/json",
            Accept: "application/json",
            "MeshApp-host": "".concat(profileId),
            Authorization: "Bearer ".concat(token.access_token)
        }),
        body: JSON.stringify(body)
    });
    return fetch(request).then(function(response) {
        if (response.status === 200) {
            return response.json();
        }
        return response.json().then(function(response) {
            throw response;
        });
    }).catch(function(error) {
        throw error;
    });
}
function updatePost(post, profileId, token) {
    var urlApi = "".concat(apiEnv(), "v1/profiles/").concat(profileId, "/content2/posts/").concat(post.sourceId);
    var body = {
        title: post.title,
        picture: post.image,
        cover: post.cover,
        description: post.description,
        message: post.message,
        external_link: post.url,
        experience_order: post.experience_order !== "" ? post.experience_order : null,
        profileTags: post.profileTags,
        contentPage: post.contentPage
    };
    var request = new Request(urlApi, {
        method: "PATCH",
        headers: new Headers({
            "Content-Type": "application/json",
            Accept: "application/json",
            "MeshApp-host": "".concat(profileId),
            Authorization: "Bearer ".concat(token.access_token)
        }),
        body: JSON.stringify(body)
    });
    return fetch(request).then(function(response) {
        if (response.status === 200) {
            return response.json();
        }
        return response.json().then(function(response) {
            throw response;
        });
    }).catch(function(error) {
        throw error;
    });
}
function updatePostWithSchema(postBody, postId, profileId, token) {
    var urlApi = "".concat(apiEnv(), "v1/profiles/").concat(profileId, "/content3/posts/").concat(postId);
    var request = new Request(urlApi, {
        method: "PATCH",
        headers: new Headers({
            "Content-Type": "application/json",
            Accept: "application/json",
            "MeshApp-host": "".concat(profileId),
            Authorization: "Bearer ".concat(token.access_token)
        }),
        body: JSON.stringify(postBody)
    });
    return fetch(request).then(function(response) {
        if (response.status === 200) {
            return response.json();
        }
        return response.json().then(function(response) {
            throw response;
        });
    }).catch(function(error) {
        throw error;
    });
}

;// CONCATENATED MODULE: ./src/store/shared-store/actions/contentLibraryActions.ts



function toggleContentFormState(contentLibraryForm, formAction, postObj) {
    return {
        type: TOGGLE_CONTENT_FORM_STATE,
        contentLibraryForm: contentLibraryForm,
        formAction: formAction,
        postObj: postObj
    };
}
function setContentFormState(contentLibraryForm, formAction, postObj) {
    return function(dispatch) {
        dispatch(toggleContentFormState(contentLibraryForm, formAction, postObj));
    };
}
/************************** */ function toggleDynamicContentFormState(contentLibraryForm, formAction, postObjId) {
    return {
        type: TOGGLE_DYNAMIC_CONTENT_FORM_STATE,
        contentLibraryForm: contentLibraryForm,
        formAction: formAction,
        postObjId: postObjId
    };
}
function setDynamicContentFormState(contentLibraryForm, formAction, postObjId) {
    return function(dispatch) {
        dispatch(toggleDynamicContentFormState(contentLibraryForm, formAction, postObjId));
    };
}
/************************** */ function toggleContentLibraryPanel(contentLibraryPanel) {
    return {
        type: TOGGLE_CONTENT_LIBRARY_PANEL,
        contentLibraryPanel: contentLibraryPanel
    };
}
function setContentLibraryPanel(contentLibraryPanel) {
    return function(dispatch) {
        dispatch(toggleContentLibraryPanel(contentLibraryPanel));
    };
}
function cleanContentLibrary() {
    return {
        type: CLEAN_CONTENT_LIBRARY
    };
}
function clearContentLibrary() {
    return function(dispatch) {
        dispatch(cleanContentLibrary());
    };
}
function receiveContentLibrary(response, params) {
    return {
        type: RECEIVE_CONTENT_LIBRARY,
        response: response,
        params: params
    };
}
function errorFetchContentLibrary(error) {
    return {
        type: ERROR_FETCH_CONTENT_LIBRARY,
        error: error
    };
}
function fetchingContentLibrary() {
    return {
        type: FETCHING_CONTENT_LIBRARY
    };
}
function getContentLibrary(profileId, token, order, orderBy, limit, search, shouldRefresh, cursor) {
    return function(dispatch) {
        dispatch(fetchingContentLibrary());
        getLibrary(profileId, token, order, orderBy, limit, search, cursor).then(function(response) {
            dispatch(receiveContentLibrary(response, {
                search: search,
                order: order,
                orderBy: orderBy,
                limit: limit,
                cursor: cursor,
                shouldRefresh: shouldRefresh
            }));
        }).catch(function(error) {
            dispatch(errorFetchContentLibrary(error));
        });
    };
}
/************************** */ function validContentPagePostLink(response) {
    return {
        type: VALID_CONTENT_PAGE_POST_LINK,
        response: response
    };
}
function invalidContentPagePostLink(error) {
    return {
        type: INVALID_CONTENT_PAGE_POST_LINK,
        error: error
    };
}
function requestValidateContentPagePostLink() {
    return {
        type: REQUEST_VALIDATE_CONTENT_PAGE_POST_LINK
    };
}
function validateContentPagePostLink(postTitle, postId, contentPageId, profileId, token) {
    return function(dispatch) {
        dispatch(requestValidateContentPagePostLink());
        validContentPagePostUrl(postTitle, postId, contentPageId, profileId, token).then(function(response) {
            dispatch(validContentPagePostLink(response));
        }).catch(function(error) {
            dispatch(invalidContentPagePostLink(error));
        });
    };
}
function cleanValidateContentPagePostLink() {
    return {
        type: CLEAN_VALIDATE_CONTENT_PAGE_POST_LINK
    };
}
function clearValidateContentPagePostLink() {
    return function(dispatch) {
        dispatch(cleanValidateContentPagePostLink());
    };
}
/************************** */ function successFetchPostsToTestContentPage(response) {
    return {
        type: SUCCESS_FETCH_POSTS_TO_TEST_CONTENT_PAGE,
        response: response
    };
}
function errorFetchPostsToTestContentPage(error) {
    return {
        type: ERROR_FETCH_POSTS_TO_TEST_CONTENT_PAGE,
        error: error
    };
}
function requestPostsToTestContentPage() {
    return {
        type: REQUEST_POSTS_TO_TEST_CONTENT_PAGE
    };
}
function fetchPostsToTestContentPage(objectRootId, profileId, token) {
    return function(dispatch) {
        dispatch(requestPostsToTestContentPage());
        getPostsToTest(objectRootId, profileId, token).then(function(response) {
            dispatch(successFetchPostsToTestContentPage(response));
        }).catch(function(error) {
            dispatch(errorFetchPostsToTestContentPage(error));
        });
    };
}
/************************** */ function successSetDefaultPostToTestContentPage(response) {
    return {
        type: SUCCESS_SET_DEFAULT_POST_TO_TEST_CONTENT_PAGE,
        response: response
    };
}
function errorSetDefaultPostToTestContentPage(error) {
    return {
        type: ERROR_SET_DEFAULT_POST_TO_TEST_CONTENT_PAGE,
        error: error
    };
}
function requestSetDefaultPostToTestContentPage() {
    return {
        type: REQUEST_SET_DEFAULT_POST_TO_TEST_CONTENT_PAGE
    };
}
function setDefaultPostToTestContentPage(objectRootId, post, profileId, token) {
    return function(dispatch) {
        dispatch(requestSetDefaultPostToTestContentPage());
        setDefaultPostToTest(objectRootId, post, profileId, token).then(function(response) {
            dispatch(successSetDefaultPostToTestContentPage({
                response: response,
                post: post
            }));
        }).catch(function(error) {
            dispatch(errorSetDefaultPostToTestContentPage(error));
        });
    };
}
/* */ function cleanSetDefaultPostTestContentPage() {
    return {
        type: CLEAN_SET_DEFAULT_POST_TO_TEST_CONTENT_PAGE
    };
}
function clearSetDefaultPostTestContentPage() {
    return function(dispatch) {
        dispatch(cleanSetDefaultPostTestContentPage());
    };
}
/************************** */ function successFetchPreviewContentPagePost(response) {
    return {
        type: SUCCESS_FETCH_PREVIEW_CONTENT_PAGE_POST,
        response: response
    };
}
function errorFetchPreviewContentPagePost(error) {
    return {
        type: ERROR_FETCH_PREVIEW_CONTENT_PAGE_POST,
        error: error
    };
}
function requestPreviewContentPagePost() {
    return {
        type: REQUEST_PREVIEW_CONTENT_PAGE_POST
    };
}
function fetchPreviewContentPagePost(hostId, pageUri, slug) {
    return function(dispatch) {
        dispatch(requestPreviewContentPagePost());
        getPreviewContentPagePost(hostId, pageUri, slug).then(function(response) {
            dispatch(successFetchPreviewContentPagePost(response));
        }).catch(function(error) {
            dispatch(errorFetchPreviewContentPagePost(error));
        });
    };
}
function cleanFetchPreviewContentPagePost() {
    return {
        type: CLEAN_FETCH_PREVIEW_CONTENT_PAGE_POST
    };
}
function clearFetchPreviewContentPagePost() {
    return function(dispatch) {
        dispatch(cleanFetchPreviewContentPagePost());
    };
}
/************************** */ function successFetchPublicContentPagePost(response) {
    return {
        type: actionTypes/* SUCCESS_FETCH_PUBLIC_CONTENT_PAGE_POST */.wxE,
        response: response
    };
}
function errorFetchPublicContentPagePost(error) {
    return {
        type: actionTypes/* ERROR_FETCH_PUBLIC_CONTENT_PAGE_POST */.Wxf,
        error: error
    };
}
function requestPublicContentPagePost() {
    return {
        type: actionTypes/* REQUEST_PUBLIC_CONTENT_PAGE_POST */.egv
    };
}
function fetchPublicContentPagePost(postId, url) {
    return function(dispatch) {
        dispatch(requestPublicContentPagePost());
        getPublicContentPagePost(postId, url).then(function(response) {
            dispatch(successFetchPublicContentPagePost(response));
        }).catch(function(error) {
            dispatch(errorFetchPublicContentPagePost(error));
        });
    };
}
function cleanFetchPublicContentPagePost() {
    return {
        type: CLEAN_FETCH_PUBLIC_CONTENT_PAGE_POST
    };
}
function clearFetchPublicContentPagePost() {
    return function(dispatch) {
        dispatch(cleanFetchPublicContentPagePost());
    };
}
/************************** */ function successDetachContentPagePost(response) {
    return {
        type: SUCCESS_DETACH_CONTENT_PAGE_POST,
        response: response
    };
}
function errorDetachContentPagePost(error) {
    return {
        type: ERROR_DETACH_CONTENT_PAGE_POST,
        error: error
    };
}
function requestDetachContentPagePost() {
    return {
        type: REQUEST_DETACH_CONTENT_PAGE_POST
    };
}
function contentLibraryActions_detachContentPagePost(objectRootId, profileId, token) {
    return function(dispatch) {
        dispatch(requestDetachContentPagePost());
        contentLibraryDetachContentPagePost(objectRootId, profileId, token).then(function(response) {
            dispatch(successDetachContentPagePost(response));
        }).catch(function(error) {
            dispatch(errorDetachContentPagePost(error));
        });
    };
}
function cleanDetachContentPagePost() {
    return {
        type: CLEAN_DETACH_CONTENT_PAGE_POST
    };
}
function clearDetachContentPagePost() {
    return function(dispatch) {
        dispatch(cleanDetachContentPagePost());
    };
}
/************************** */ function successFetchContentPageListByPost(response) {
    return {
        type: SUCCESS_FETCH_CONTENT_PAGE_LIST_BY_POST,
        response: response
    };
}
function errorFetchContentPageListByPost(error) {
    return {
        type: ERROR_FETCH_CONTENT_PAGE_LIST_BY_POST,
        error: error
    };
}
function requestFetchContentPageListByPost() {
    return {
        type: REQUEST_FETCH_CONTENT_PAGE_LIST_BY_POST
    };
}
function FetchContentPageListByPost(sourceId, profileId, token) {
    return function(dispatch) {
        dispatch(requestFetchContentPageListByPost());
        contentPageListByPost(sourceId, profileId, token).then(function(response) {
            dispatch(successFetchContentPageListByPost(response));
        }).catch(function(error) {
            dispatch(errorFetchContentPageListByPost(error));
        });
    };
}
function cleanFetchContentPageListByPost() {
    return {
        type: CLEAN_FETCH_CONTENT_PAGE_LIST_BY_POST
    };
}
function clearFetchContentPageListByPost() {
    return function(dispatch) {
        dispatch(cleanFetchContentPageListByPost());
    };
}
/************************** */ function successFetchContentPageListByWorkspace(response) {
    return {
        type: SUCCESS_FETCH_CONTENT_PAGE_LIST_BY_WORKSPACE,
        response: response
    };
}
function errorFetchContentPageListByWorkspace(error) {
    return {
        type: ERROR_FETCH_CONTENT_PAGE_LIST_BY_WORKSPACE,
        error: error
    };
}
function requestFetchContentPageListByWorkspace() {
    return {
        type: REQUEST_FETCH_CONTENT_PAGE_LIST_BY_WORKSPACE
    };
}
function FetchContentPageListByWorkspace(profileId, token) {
    return function(dispatch) {
        dispatch(requestFetchContentPageListByWorkspace());
        fetchContentPageListByWorkspace(profileId, token).then(function(response) {
            dispatch(successFetchContentPageListByWorkspace(response));
        }).catch(function(error) {
            dispatch(errorFetchContentPageListByWorkspace(error));
        });
    };
}
function cleanFetchContentPageListByWorkspace() {
    return {
        type: CLEAN_FETCH_CONTENT_PAGE_LIST_BY_WORKSPACE
    };
}
function clearFetchContentPageListByWorkspace() {
    return function(dispatch) {
        dispatch(cleanFetchContentPageListByWorkspace());
    };
}
/* -- * -- * -- * -- * -- * -- * -- * -- */ function errorCreatePost(error) {
    return {
        type: ERROR_CREATE_POST,
        error: error
    };
}
function requestCreatePost() {
    return {
        type: REQUEST_CREATE_POST
    };
}
function successCreatePost(response) {
    return {
        type: SUCCESS_CREATE_POST,
        response: response
    };
}
function contentLibraryActions_createPost(postObj, profileId, token) {
    return function(dispatch) {
        dispatch(requestCreatePost());
        return contentLibraryCreatePost(postObj, profileId, token).then(function(response) {
            dispatch(successCreatePost(response));
        }).catch(function(error) {
            dispatch(errorCreatePost(error));
            throw error;
        });
    };
}
function cleanCreatePost() {
    return {
        type: CLEAN_CREATE_POST
    };
}
function clearCreatePost() {
    return function(dispatch) {
        dispatch(cleanCreatePost());
    };
}
/* -- * -- * -- * -- * -- * -- * -- * -- */ function errorUpdatePost(error) {
    return {
        type: ERROR_UPDATE_POST,
        error: error
    };
}
function requestUpdatePost() {
    return {
        type: REQUEST_UPDATE_POST
    };
}
function successUpdatePost(response) {
    return {
        type: SUCCESS_UPDATE_POST,
        response: response
    };
}
function contentLibraryActions_updatePost(postObj, profileId, token) {
    return function(dispatch) {
        dispatch(requestUpdatePost());
        return contentLibraryUpdatePost(postObj, profileId, token).then(function(response) {
            dispatch(successUpdatePost(response));
        }).catch(function(error) {
            dispatch(errorUpdatePost(error));
            throw error;
        });
    };
}
function cleanUpdatePost() {
    return {
        type: CLEAN_UPDATE_POST
    };
}
function clearUpdatePost() {
    return function(dispatch) {
        dispatch(cleanUpdatePost());
    };
}
/* -- * -- * -- * -- * -- * -- * -- * -- */ function errorUpdatePostWithSchema(error) {
    return {
        type: ERROR_UPDATE_POST_WITH_SCHEMA,
        error: error
    };
}
function requestUpdatePostWithSchema() {
    return {
        type: REQUEST_UPDATE_POST_WITH_SCHEMA
    };
}
function successUpdatePostWithSchema(response) {
    return {
        type: SUCCESS_UPDATE_POST_WITH_SCHEMA,
        response: response
    };
}
function contentLibraryActions_updatePostWithSchema(postObj, postId, profileId, token) {
    return function(dispatch) {
        dispatch(requestUpdatePostWithSchema());
        return contentLibraryUpdatePostWithSchema(postObj, postId, profileId, token).then(function(response) {
            dispatch(successUpdatePostWithSchema(response));
        }).catch(function(error) {
            dispatch(errorUpdatePostWithSchema(error));
            throw error;
        });
    };
}
function cleanUpdatePostWithSchema() {
    return {
        type: CLEAN_UPDATE_POST_WITH_SCHEMA
    };
}
function clearUpdatePostWithSchema() {
    return function(dispatch) {
        dispatch(cleanUpdatePostWithSchema());
    };
}
/* -- * -- * -- * -- * -- * -- * -- * -- */ function addMediaToContentLibraryResponse(mediaObj) {
    return {
        type: ADD_MEDIA_TO_CONTENT_LIBRARY_RESPONSE,
        mediaObj: mediaObj
    };
}
function updateContentLibraryMedia(mediaObj) {
    return function(dispatch) {
        dispatch(addMediaToContentLibraryResponse(mediaObj));
    };
}
/* -- * -- * -- * -- * -- * -- * -- * -- */ function draftPost(postObj) {
    return {
        type: DRAFT_POST,
        postObj: postObj
    };
}
function addDraftPost(postObj) {
    return function(dispatch) {
        dispatch(draftPost(postObj));
    };
}
function errorFetchSinglePost(error) {
    return {
        type: ERROR_FETCH_SINGLE_POST,
        error: error
    };
}
function requestSinglePost() {
    return {
        type: REQUEST_SINGLE_POST
    };
}
function successFetchSinglePost(response) {
    return {
        type: SUCCESS_FETCH_SINGLE_POST,
        response: response
    };
}
function fetchSinglePost(postId, profileId, token) {
    return function(dispatch) {
        dispatch(requestSinglePost());
        return singleContentLibraryPost(postId, profileId, token).then(function(response) {
            dispatch(successFetchSinglePost(response));
        }).catch(function(error) {
            dispatch(errorFetchSinglePost(error));
            throw error;
        });
    };
}
function cleanFetchSinglePost() {
    return {
        type: CLEAN_FETCH_SINGLE_POST
    };
}
function clearFetchSinglePost() {
    return function(dispatch) {
        dispatch(cleanFetchSinglePost());
    };
}

// EXTERNAL MODULE: ./node_modules/dangerously-set-html-content/dist/index.modern.js
var index_modern = __webpack_require__(90669);
;// CONCATENATED MODULE: ./src/areas/public-page/analytics/injectBody1Analytics.tsx




var InjectBody1Analytics = function(param) {
    var site = param.site;
    var ref, ref1;
    var isBody1Unlocked = ((ref = site.cookieBar) === null || ref === void 0 ? void 0 : (ref1 = ref.body1Consent) === null || ref1 === void 0 ? void 0 : ref1.enable) === true ? false : true;
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState({
        body1: isBody1Unlocked
    }), 2), cookieState = ref2[0], setCookieState = ref2[1];
    react.useEffect(function() {
        var handleCookieChange = function() {
            var body1Cookie = "".concat("cookie-body1-" + window.location.hostname);
            var cookieString = document.cookie;
            var isBody1Accepted = cookieString.includes(body1Cookie);
            if (isBody1Accepted) {
                setCookieState({
                    body1: isBody1Accepted
                });
            }
        };
        handleCookieChange() //initial load check
        ;
        //@ts-ignore
        if (typeof cookieStore !== "undefined") {
            //@ts-ignore
            cookieStore.addEventListener("change", function(param) {
                var changed = param.changed;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = changed[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _value = _step.value, name = _value.name, value = _value.value;
                        handleCookieChange();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
            return function() {
                //@ts-ignore
                cookieStore.removeEventListener("change", handleCookieChange);
            };
        }
    }, []);
    if (site.analyticsInjectBodyTop && cookieState.body1) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* default */.Z, {
            html: site.analyticsInjectBodyTop
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var injectBody1Analytics = (InjectBody1Analytics);

;// CONCATENATED MODULE: ./src/areas/public-page/analytics/injectBody2Analytics.tsx




var InjectBody2Analytics = function(param) {
    var site = param.site;
    var ref, ref1;
    var isBody2Unlocked = ((ref = site.cookieBar) === null || ref === void 0 ? void 0 : (ref1 = ref.body2Consent) === null || ref1 === void 0 ? void 0 : ref1.enable) === true ? false : true;
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState({
        body2: isBody2Unlocked
    }), 2), cookieState = ref2[0], setCookieState = ref2[1];
    react.useEffect(function() {
        var handleCookieChange = function() {
            var body2Cookie = "".concat("cookie-body2-" + window.location.hostname);
            var cookieString = document.cookie;
            var isBody2Accepted = cookieString.includes(body2Cookie);
            if (isBody2Accepted) {
                setCookieState({
                    body2: isBody2Accepted
                });
            }
        };
        handleCookieChange() //initial load check
        ;
        //@ts-ignore
        if (typeof cookieStore !== "undefined") {
            //@ts-ignore
            cookieStore.addEventListener("change", function(param) {
                var changed = param.changed;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = changed[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _value = _step.value, name = _value.name, value = _value.value;
                        handleCookieChange();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
            return function() {
                //@ts-ignore
                cookieStore.removeEventListener("change", handleCookieChange);
            };
        }
    }, []);
    if (site.analyticsInjectBodyBottom && cookieState.body2) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* default */.Z, {
            html: site.analyticsInjectBodyBottom
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var injectBody2Analytics = (InjectBody2Analytics);

;// CONCATENATED MODULE: ./src/pages/[...pageName].tsx

function _pageName_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _pageName_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var GlobalFontStyle = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(_pageName_templateObject(), function(props) {
    return props.customFontsCSS;
});
var Experience = function(props) {
    var ref, ref1;
    var dispatch = (0,es/* useDispatch */.I0)();
    var reduxState = (0,es/* useSelector */.v9)(successFetchPublicContentPagePost);
    (0,react.useEffect)(function() {
        if (props.experience.pageData.contentPage && !props.experience.pageData.contentPage.content) {
            var postId = props.experience.postId;
            var url = window.location.href;
            dispatch(fetchPublicContentPagePost(postId, url));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var ua;
    if (props.uaString) {
        ua = (0,next_useragent/* parse */.Qc)(props.uaString);
    } else {
        ua = (0,next_useragent/* parse */.Qc)(window.navigator.userAgent);
    }
    var isSafariOld = function(ua) {
        if (ua.isDesktop && ua.browser === "Safari") {
            return ua.browserVersion < 14 ? "true" : "false";
        }
        if (ua.isIos && ua.engineVersion < 604.1) {
            return "true";
        }
        //return ua.browserVersion < 11 ? "true" : "false"
        return "false";
    };
    /**
   * This handler controls the fetch action.
   */ var handleExperience = function() {
        if (props.loadingExperience) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pai-nosso",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hub-article-loading",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "loading",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: window.loader ? window.loader : "https://cdn.fluxio.cloud/meshapp/balls.svg",
                            alt: "Loading"
                        })
                    })
                })
            });
        }
        if (props.experience) {
            var ref;
            var hub = props.experience.pageData;
            var contentPagePost = reduxState.response.contentLibraryReducer.successFetchPublicContentPagePost;
            if (contentPagePost) {
                var ref1;
                var clonedHub = (0,lodash.cloneDeep)(hub);
                clonedHub.contentPage.content = contentPagePost;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "meshCenter meshConfig",
                    id: hub.uri,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalFontStyle, {
                            customFontsCSS: props.experience.pageData.customFontsCss
                        }),
                        hub.template && hub.template.cookieWarning && /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_public_page_cookieBanner, {
                            cookieRules: (ref1 = props.experience) === null || ref1 === void 0 ? void 0 : ref1.site
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(pageBootstrap, {
                            pageResponse: clonedHub,
                            expManager: {
                                enable: false,
                                emEditorType: undefined
                            }
                        })
                    ]
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "meshCenter meshConfig",
                id: hub.uri,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalFontStyle, {
                        customFontsCSS: props.experience.pageData.customFontsCss
                    }),
                    hub.template && hub.template.cookieWarning && /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_public_page_cookieBanner, {
                        cookieRules: (ref = props.experience) === null || ref === void 0 ? void 0 : ref.site
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(pageBootstrap, {
                        pageResponse: hub,
                        expManager: {
                            enable: false,
                            emEditorType: undefined
                        }
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Metadata_InjectMetaData, {
                site: (ref = props.experience) === null || ref === void 0 ? void 0 : ref.site,
                fonts: (ref1 = props.experience) === null || ref1 === void 0 ? void 0 : ref1.fonts.imports
            }),
            props.experience && /*#__PURE__*/ (0,jsx_runtime.jsx)(injectBody1Analytics, {
                site: props.experience.site
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pai-nosso ".concat(handleSafariOldVersion(isSafariOld(ua))),
                children: handleExperience()
            }),
            props.experience && /*#__PURE__*/ (0,jsx_runtime.jsx)(injectBody2Analytics, {
                site: props.experience.site
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _pageName_ = (Experience);


/***/ }),

/***/ 18740:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card-deck":"card_card-deck__tdoT_","card":"card_card__4cjsG"};

/***/ }),

/***/ 39295:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cookie-banner":"cookieBar_cookie-banner__ySx4h","cookie-actions":"cookieBar_cookie-actions__B0qNW","cookie-banner-modal-drop":"cookieBar_cookie-banner-modal-drop__NI8WY","cookie-banner-modal":"cookieBar_cookie-banner-modal__Rra__","cookie-options":"cookieBar_cookie-options___mUtV","cookie-option":"cookieBar_cookie-option__lAIgb","cookie-checkbox":"cookieBar_cookie-checkbox__HLvXB","cookie-title":"cookieBar_cookie-title__awLq0","cookie-description":"cookieBar_cookie-description__WqYj7","cookie-policy-wrap":"cookieBar_cookie-policy-wrap__7nE5v"};

/***/ }),

/***/ 20136:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"social-media-embed":"instagramMediaEmbed_social-media-embed__ecyE4"};

/***/ }),

/***/ 25322:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal-fluxio":"modal_modal-fluxio__1xUFf","modal-fluxio-lg":"modal_modal-fluxio-lg__jWxG_","modal-dialog":"modal_modal-dialog__eRSvr","modal-content":"modal_modal-content__YDkzD","modal-fluxio-no-height":"modal_modal-fluxio-no-height__rkk9D","modal-fluxio-full":"modal_modal-fluxio-full__ucsYR","modal-title":"modal_modal-title__zO417","btn":"modal_btn__UTPCZ","modal-fluxio-em":"modal_modal-fluxio-em__av86d","content-library-modal":"modal_content-library-modal__dVr9y","content-library-modal-two-sides":"modal_content-library-modal-two-sides__CJ9Tp","ace_editor":"modal_ace_editor__c27zc","safari-old-version":"modal_safari-old-version__y6w2J","modal-lg":"modal_modal-lg__WcJ2t","container":"modal_container__vmJ4W"};

/***/ }),

/***/ 19417:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card-left":"cardLeftRight_card-left__2tAda","card-right":"cardLeftRight_card-right__IU8oa"};

/***/ }),

/***/ 12017:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card-modal":"cardModal_card-modal__Pu_Ty","card-deck":"cardModal_card-deck__GOLwd","modal-fluxio":"cardModal_modal-fluxio__DuV5E","isFeed":"cardModal_isFeed__DQ7zZ","modal-content":"cardModal_modal-content__45M7a","container":"cardModal_container___HutU","container-md":"cardModal_container-md__GH8yK","container-sm":"cardModal_container-sm__Bu_i_","modal-body":"cardModal_modal-body___aAPW","modal-dialog":"cardModal_modal-dialog__38qPJ","modal-container":"cardModal_modal-container__ZuTK8","card_modal_ssr":"cardModal_card_modal_ssr__JHqHA","modal_ssr_backdrop":"cardModal_modal_ssr_backdrop__eh7rk"};

/***/ }),

/***/ 62825:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cards":"cards_cards__DJf1C"};

/***/ }),

/***/ 42538:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carousel-component":"carouselComponent_carousel-component__aESIv","slider-body":"carouselComponent_slider-body__sgx6p","slider-nav":"carouselComponent_slider-nav__QzqXP","slider-container":"carouselComponent_slider-container__Ucu08","slider-container:global(.no-gutters)":"carouselComponent_slider-container__global__no-gutters___NeeNv","slider-item":"carouselComponent_slider-item__HYn_x","slider-nav-bottom":"carouselComponent_slider-nav-bottom__8VNbl"};

/***/ }),

/***/ 93853:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"elements":"elementDropdown_elements__JVte8","dropdown":"elementDropdown_dropdown__xZspX","dropdown-toggle":"elementDropdown_dropdown-toggle__3fc9M","isOpen":"elementDropdown_isOpen__bg3B8","dropdown-menu":"elementDropdown_dropdown-menu__rSuPf","dropdown-item":"elementDropdown_dropdown-item__G6y3M"};

/***/ }),

/***/ 93198:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"elements":"elementDropdown_v2_elements__O0bfg","dropdown_v2":"elementDropdown_v2_dropdown_v2__mvg9Q","dropdown-toggle":"elementDropdown_v2_dropdown-toggle__OlUZE","isOpen":"elementDropdown_v2_isOpen__OyfsV","label":"elementDropdown_v2_label__hyf_l","dropdown-menu":"elementDropdown_v2_dropdown-menu__P3pjX","dropdown-item":"elementDropdown_v2_dropdown-item__lQhg2"};

/***/ }),

/***/ 78338:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"elements":"elementModal_elements__QPnL4","modal-component":"elementModal_modal-component__8WvIO","modal-fluxio":"elementModal_modal-fluxio__ufqc7","isFeed":"elementModal_isFeed__l3CbR","modal-content":"elementModal_modal-content__hZMpW","modal_v1_ssr":"elementModal_modal_v1_ssr__XU_Th","modal_ssr_backdrop":"elementModal_modal_ssr_backdrop__SeGZm"};

/***/ }),

/***/ 16001:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"elements":"elementModal_v2_elements__GcqXm","modal-component_v2":"elementModal_v2_modal-component_v2__RNptr","modal-fluxio":"elementModal_v2_modal-fluxio__VO9Ia","isFeed":"elementModal_v2_isFeed__m7CJ9","modal-content":"elementModal_v2_modal-content__cDy5C","modal_v2_ssr":"elementModal_v2_modal_v2_ssr__kRJys","modal_ssr_backdrop":"elementModal_v2_modal_ssr_backdrop__1VcXX"};

/***/ }),

/***/ 43670:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"elements":"elementModal_v4_elements__BKfXU","modal-component_v4":"elementModal_v4_modal-component_v4__8BYzb","modal-fluxio":"elementModal_v4_modal-fluxio__ceQhd","isFeed":"elementModal_v4_isFeed__X_5mx","modal-content":"elementModal_v4_modal-content__5AXbR"};

/***/ }),

/***/ 49336:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"embed-container-component":"embedContainer_embed-container-component__qX2Fi"};

/***/ }),

/***/ 3594:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gallery":"galleryShowcase_gallery___hjce","showcase":"galleryShowcase_showcase__D_r7j","item-default":"galleryShowcase_item-default__DEzSY","gallery-item-content":"galleryShowcase_gallery-item-content__pbiGd","showcase-item":"galleryShowcase_showcase-item__vayMW"};

/***/ }),

/***/ 67934:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navigation":"menuComponent_navigation__tUY3R","menu-component":"menuComponent_menu-component__i9tXu","main-menu-toggle":"menuComponent_main-menu-toggle__IIvz4","main-menu":"menuComponent_main-menu__6z8Ik","main-menu-container":"menuComponent_main-menu-container__4Ko6a","row":"menuComponent_row__GGc1U","menu-component_v2":"menuComponent_menu-component_v2__Oq_xu"};

/***/ }),

/***/ 33944:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navigation":"menuComponentV2_navigation__kBzca","menu-component_v2":"menuComponentV2_menu-component_v2__zqiTI","main-menu-toggle":"menuComponentV2_main-menu-toggle___gOlW","main-menu":"menuComponentV2_main-menu__CPr4t","main-menu-container":"menuComponentV2_main-menu-container__Httwf","row":"menuComponentV2_row__t2X_K","main-menu-close":"menuComponentV2_main-menu-close__NHs7A","main-menu-item":"menuComponentV2_main-menu-item__R_FVq"};

/***/ }),

/***/ 73927:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navigation":"menuToggleComponent_navigation__pQ3X5","menu-toggle-component":"menuToggleComponent_menu-toggle-component__SaSYz","main-menu":"menuToggleComponent_main-menu___7d1t","main-menu-container":"menuToggleComponent_main-menu-container__I6X14","hide":"menuToggleComponent_hide__IXhbm","main-menu-item":"menuToggleComponent_main-menu-item__21_p2","main-menu-toggle":"menuToggleComponent_main-menu-toggle__1fOnx","main-menu-close":"menuToggleComponent_main-menu-close__zrlpk"};

/***/ }),

/***/ 60769:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navbarComponent_navigation__VZFkn","navbar-component":"navbarComponent_navbar-component__S3ko4","navbar-menu-toggle":"navbarComponent_navbar-menu-toggle__mcKZ1","navbar-menu":"navbarComponent_navbar-menu__7hr30","navbar-menu-container":"navbarComponent_navbar-menu-container__FidOD","row":"navbarComponent_row__oPjA5","navbar-items":"navbarComponent_navbar-items__Ydhjm"};

/***/ }),

/***/ 60640:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navbarComponent_v2_navigation__B3GjK","navbar-component_v2":"navbarComponent_v2_navbar-component_v2__GR6bM","navbar-items":"navbarComponent_v2_navbar-items__FuEcj","navbar-items-container":"navbarComponent_v2_navbar-items-container__PVT6X","navbar-items-background":"navbarComponent_v2_navbar-items-background__vOnLn","navbar-identity":"navbarComponent_v2_navbar-identity__XuiLw","navbar-identity-container":"navbarComponent_v2_navbar-identity-container__BB7EX"};

/***/ }),

/***/ 39695:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"results-map-component":"resultsMap_results-map-component__UGPBQ","gm-style":"resultsMap_gm-style__zV5PQ","card-top":"resultsMap_card-top__TobWZ","gm-ui-hover-effect":"resultsMap_gm-ui-hover-effect__xGfpg","infoWindow-close":"resultsMap_infoWindow-close__xxHBx","map-fullscreen-trigger":"resultsMap_map-fullscreen-trigger__VwxIZ","row":"resultsMap_row__MdgNA"};

/***/ }),

/***/ 46969:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"simple-form-component":"simpleForm_simple-form-component__vC4w0"};

/***/ }),

/***/ 8708:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slider-component-v3":"sliderComponentV3_slider-component-v3__ylVw0","slider-body":"sliderComponentV3_slider-body__lWMhb","slider-nav":"sliderComponentV3_slider-nav__nq0nX","slider-container":"sliderComponentV3_slider-container___uq9W","slider-container:global(.no-gutters)":"sliderComponentV3_slider-container__global__no-gutters___CdhHK","slider-item":"sliderComponentV3_slider-item__vi0dc","slider-nav-bottom":"sliderComponentV3_slider-nav-bottom__deOWc"};

/***/ }),

/***/ 2031:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slider-container-component":"sliderContainer_slider-container-component__OjfGo","slider-body":"sliderContainer_slider-body__hdY4m","slider-nav":"sliderContainer_slider-nav__GW1pM","slider-scroller":"sliderContainer_slider-scroller__Wdnzc","slider-item":"sliderContainer_slider-item__pU3yH"};

/***/ }),

/***/ 45352:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"social-card-share":"socialCardShare_social-card-share__wtAcq","card-header":"socialCardShare_card-header__qZilp","card":"socialCardShare_card__Xtb2f"};

/***/ }),

/***/ 51453:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tabs-container":"tabsContainer_tabs-container__BiRv5","horizontal-tabs":"tabsContainer_horizontal-tabs__j7a5a","is-vertical":"tabsContainer_is-vertical__7F9tP","bob-background":"tabsContainer_bob-background___MLrT","nav":"tabsContainer_nav__knVk0","nav-link":"tabsContainer_nav-link__dTDBq","nav-item":"tabsContainer_nav-item__yA04s","tab-content":"tabsContainer_tab-content__Leygd","is-vertical_notMobile":"tabsContainer_is-vertical_notMobile__6tRvq","nav-pills":"tabsContainer_nav-pills__NDDGa"};

/***/ }),

/***/ 49053:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tabs-container_v2":"tabsContainerDropdown_tabs-container_v2__hRCAc","dropdown-active-item":"tabsContainerDropdown_dropdown-active-item__Yo_2v","nav-link":"tabsContainerDropdown_nav-link__Y6nw1","nav-pills":"tabsContainerDropdown_nav-pills__Z5Tn5","dropdown-close":"tabsContainerDropdown_dropdown-close__WX8cm","nav-item":"tabsContainerDropdown_nav-item__wPU2j","active":"tabsContainerDropdown_active__Hjzw_"};

/***/ }),

/***/ 8147:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"flx_flex":"public-components_flx_flex__wLWOH"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [662,954,63,787,774,888,179], function() { return __webpack_exec__(70829); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);